/**
 * @licstart The following is the entire license notice for the
 * JavaScript code in this page
 *
 * Copyright 2024 Mozilla Foundation
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * @licend The above is the entire license notice for the
 * JavaScript code in this page
 */
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
var __generator = (this && this.__generator) || function (thisArg, body) {
    var _ = { label: 0, sent: function() { if (t[0] & 1) throw t[1]; return t[1]; }, trys: [], ops: [] }, f, y, t, g = Object.create((typeof Iterator === "function" ? Iterator : Object).prototype);
    return g.next = verb(0), g["throw"] = verb(1), g["return"] = verb(2), typeof Symbol === "function" && (g[Symbol.iterator] = function() { return this; }), g;
    function verb(n) { return function (v) { return step([n, v]); }; }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while (g && (g = 0, op[0] && (_ = 0)), _) try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [op[0] & 2, t.value];
            switch (op[0]) {
                case 0: case 1: t = op; break;
                case 4: _.label++; return { value: op[1], done: false };
                case 5: _.label++; y = op[1]; op = [0]; continue;
                case 7: op = _.ops.pop(); _.trys.pop(); continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) { _ = 0; continue; }
                    if (op[0] === 3 && (!t || (op[1] > t[0] && op[1] < t[3]))) { _.label = op[1]; break; }
                    if (op[0] === 6 && _.label < t[1]) { _.label = t[1]; t = op; break; }
                    if (t && _.label < t[2]) { _.label = t[2]; _.ops.push(op); break; }
                    if (t[2]) _.ops.pop();
                    _.trys.pop(); continue;
            }
            op = body.call(thisArg, _);
        } catch (e) { op = [6, e]; y = 0; } finally { f = t = 0; }
        if (op[0] & 5) throw op[1]; return { value: op[0] ? op[1] : void 0, done: true };
    }
};
var __classPrivateFieldGet = (this && this.__classPrivateFieldGet) || function (receiver, state, kind, f) {
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a getter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot read private member from an object whose class did not declare it");
    return kind === "m" ? f : kind === "a" ? f.call(receiver) : f ? f.value : state.get(receiver);
};
var __classPrivateFieldSet = (this && this.__classPrivateFieldSet) || function (receiver, state, value, kind, f) {
    if (kind === "m") throw new TypeError("Private method is not writable");
    if (kind === "a" && !f) throw new TypeError("Private accessor was defined without a setter");
    if (typeof state === "function" ? receiver !== state || !f : !state.has(receiver)) throw new TypeError("Cannot write private member to an object whose class did not declare it");
    return (kind === "a" ? f.call(receiver, value) : f ? f.value = value : state.set(receiver, value)), value;
};
var __asyncValues = (this && this.__asyncValues) || function (o) {
    if (!Symbol.asyncIterator) throw new TypeError("Symbol.asyncIterator is not defined.");
    var m = o[Symbol.asyncIterator], i;
    return m ? m.call(o) : (o = typeof __values === "function" ? __values(o) : o[Symbol.iterator](), i = {}, verb("next"), verb("throw"), verb("return"), i[Symbol.asyncIterator] = function () { return this; }, i);
    function verb(n) { i[n] = o[n] && function (v) { return new Promise(function (resolve, reject) { v = o[n](v), settle(resolve, reject, v.done, v.value); }); }; }
    function settle(resolve, reject, d, v) { Promise.resolve(v).then(function(v) { resolve({ value: v, done: d }); }, reject); }
};
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __values = (this && this.__values) || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function () {
            if (o && i >= o.length) o = void 0;
            return { value: o && o[i++], done: !o };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
var __spreadArray = (this && this.__spreadArray) || function (to, from, pack) {
    if (pack || arguments.length === 2) for (var i = 0, l = from.length, ar; i < l; i++) {
        if (ar || !(i in from)) {
            if (!ar) ar = Array.prototype.slice.call(from, 0, i);
            ar[i] = from[i];
        }
    }
    return to.concat(ar || Array.prototype.slice.call(from));
};
var _a, _Util_getExtremumOnCurve, _Util_getExtremum, _b, _PDFDateString_regex, _HighlightToolbar_instances, _HighlightToolbar_buttons, _HighlightToolbar_toolbar, _HighlightToolbar_uiManager, _HighlightToolbar_render, _HighlightToolbar_getLastPoint, _HighlightToolbar_addHighlightButton, _IdManager_id, _ImageManager_instances, _c, _ImageManager_baseId, _ImageManager_id, _ImageManager_cache, _ImageManager_get, _CommandManager_commands, _CommandManager_locked, _CommandManager_maxSize, _CommandManager_position, _KeyboardManager_instances, _KeyboardManager_serialize, _TouchManager_instances, _d, _TouchManager_container, _TouchManager_isPinching, _TouchManager_isPinchingStopped, _TouchManager_isPinchingDisabled, _TouchManager_onPinchStart, _TouchManager_onPinching, _TouchManager_onPinchEnd, _TouchManager_pointerDownAC, _TouchManager_signal, _TouchManager_touchInfo, _TouchManager_touchManagerAC, _TouchManager_touchMoveAC, _TouchManager_onTouchStart, _TouchManager_onTouchMove, _TouchManager_onTouchEnd, _AnnotationStorage_instances, _AnnotationStorage_modified, _AnnotationStorage_modifiedIds, _AnnotationStorage_storage, _AnnotationStorage_setModified, _PrintAnnotationStorage_serializable, _FontLoader_systemFonts, _MessageHandler_instances, _MessageHandler_messageAC, _MessageHandler_onMessage, _MessageHandler_createStreamSink, _MessageHandler_processStreamMessage, _MessageHandler_deleteStreamController, _BaseCanvasFactory_enableHWA, _DOMFilterFactory_instances, _DOMFilterFactory_baseUrl, _DOMFilterFactory__cache, _DOMFilterFactory__defs, _DOMFilterFactory_docId, _DOMFilterFactory_document, _DOMFilterFactory__hcmCache, _DOMFilterFactory_id, _DOMFilterFactory_cache_get, _DOMFilterFactory_hcmCache_get, _DOMFilterFactory_defs_get, _DOMFilterFactory_createTables, _DOMFilterFactory_createUrl, _DOMFilterFactory_addLuminosityConversion, _DOMFilterFactory_addGrayConversion, _DOMFilterFactory_createFilter, _DOMFilterFactory_appendFeFunc, _DOMFilterFactory_addTransferMapConversion, _DOMFilterFactory_addTransferMapAlphaConversion, _DOMFilterFactory_getRGB, _CanvasGraphics_instances, _CanvasGraphics_restoreInitialState, _CanvasGraphics_drawFilter, _CanvasGraphics_getScaledPath, _Metadata_map, _Metadata_data, _OptionalContentGroup_isDisplay, _OptionalContentGroup_isPrint, _OptionalContentGroup_userSet, _OptionalContentGroup_visible, _OptionalContentConfig_instances, _OptionalContentConfig_cachedGetHash, _OptionalContentConfig_groups, _OptionalContentConfig_initialHash, _OptionalContentConfig_order, _OptionalContentConfig_evaluateVisibilityExpression, _PDFPageProxy_instances, _PDFPageProxy_pendingCleanup, _PDFPageProxy_tryCleanup, _LoopbackPort_listeners, _LoopbackPort_deferred, _WorkerTransport_instances, _WorkerTransport_methodPromises, _WorkerTransport_pageCache, _WorkerTransport_pagePromises, _WorkerTransport_pageRefCache, _WorkerTransport_passwordCapability, _WorkerTransport_cacheSimpleMethod, _PDFObjects_instances, _PDFObjects_objs, _PDFObjects_ensureObj, _RenderTask_internalRenderTask, _AnnotationElement_instances, _AnnotationElement_updates, _AnnotationElement_hasBorder, _AnnotationElement_popupElement, _AnnotationElement_setRectEdited, _LinkAnnotationElement_instances, _LinkAnnotationElement_setInternalLink, _LinkAnnotationElement_bindAttachment, _LinkAnnotationElement_bindSetOCGState, _PopupElement_instances, _PopupElement_boundKeyDown, _PopupElement_boundHide, _PopupElement_boundShow, _PopupElement_boundToggle, _PopupElement_color, _PopupElement_container, _PopupElement_contentsObj, _PopupElement_dateObj, _PopupElement_elements, _PopupElement_parent, _PopupElement_parentRect, _PopupElement_pinned, _PopupElement_popup, _PopupElement_position, _PopupElement_rect, _PopupElement_richText, _PopupElement_titleObj, _PopupElement_updates, _PopupElement_wasVisible, _PopupElement_html_get, _PopupElement_fontSize_get, _PopupElement_fontColor_get, _PopupElement_makePopupContent, _PopupElement_keyDown, _PopupElement_setPosition, _PopupElement_toggle, _PopupElement_show, _PopupElement_hide, _LineAnnotationElement_line, _SquareAnnotationElement_square, _CircleAnnotationElement_circle, _PolylineAnnotationElement_polyline, _InkAnnotationElement_instances, _InkAnnotationElement_polylinesGroupElement, _InkAnnotationElement_polylines, _InkAnnotationElement_getTransform, _FileAttachmentAnnotationElement_instances, _FileAttachmentAnnotationElement_trigger, _FileAttachmentAnnotationElement_download, _AnnotationLayer_instances, _AnnotationLayer_accessibilityManager, _AnnotationLayer_annotationCanvasMap, _AnnotationLayer_editableAnnotations, _AnnotationLayer_structTreeLayer, _AnnotationLayer_appendElement, _AnnotationLayer_setAnnotationCanvasMap, _FreeDrawOutline_instances, _FreeDrawOutline_box, _FreeDrawOutline_bbox, _FreeDrawOutline_innerMargin, _FreeDrawOutline_isLTR, _FreeDrawOutline_points, _FreeDrawOutline_scaleFactor, _FreeDrawOutline_outline, _FreeDrawOutline_computeMinMax, _HighlightOutliner_instances, _HighlightOutliner_box, _HighlightOutliner_lastPoint, _HighlightOutliner_verticalEdges, _HighlightOutliner_intervals, _HighlightOutliner_getOutlines, _HighlightOutliner_binarySearch, _HighlightOutliner_insert, _HighlightOutliner_remove, _HighlightOutliner_breakEdge, _HighlightOutline_box, _HighlightOutline_outlines, _DrawingOptions_svgProperties, _InkDrawOutliner_instances, _InkDrawOutliner_last, _InkDrawOutliner_line, _InkDrawOutliner_lines, _InkDrawOutliner_rotation, _InkDrawOutliner_thickness, _InkDrawOutliner_points, _InkDrawOutliner_lastSVGPath, _InkDrawOutliner_lastIndex, _InkDrawOutliner_outlines, _InkDrawOutliner_parentWidth, _InkDrawOutliner_parentHeight, _InkDrawOutliner_normalizePoint, _InkDrawOutline_instances, _InkDrawOutline_bbox, _InkDrawOutline_currentRotation, _InkDrawOutline_innerMargin, _InkDrawOutline_lines, _InkDrawOutline_parentWidth, _InkDrawOutline_parentHeight, _InkDrawOutline_parentScale, _InkDrawOutline_rotation, _InkDrawOutline_thickness, _InkDrawOutline_getMarginComponents, _InkDrawOutline_getBBoxWithNoMargin, _InkDrawOutline_computeBbox, _InkDrawOutline_updateThickness;
; // ./src/shared/util.js
var isNodeJS = typeof process === "object" && process + "" === "[object process]" && !process.versions.nw && !(process.versions.electron && process.type && process.type !== "browser");
var FONT_IDENTITY_MATRIX = [0.001, 0, 0, 0.001, 0, 0];
var LINE_FACTOR = 1.35;
var LINE_DESCENT_FACTOR = 0.35;
var BASELINE_FACTOR = LINE_DESCENT_FACTOR / LINE_FACTOR;
var RenderingIntentFlag = {
    ANY: 0x01,
    DISPLAY: 0x02,
    PRINT: 0x04,
    SAVE: 0x08,
    ANNOTATIONS_FORMS: 0x10,
    ANNOTATIONS_STORAGE: 0x20,
    ANNOTATIONS_DISABLE: 0x40,
    IS_EDITING: 0x80,
    OPLIST: 0x100
};
var AnnotationMode = {
    DISABLE: 0,
    ENABLE: 1,
    ENABLE_FORMS: 2,
    ENABLE_STORAGE: 3
};
var AnnotationEditorPrefix = "pdfjs_internal_editor_";
var AnnotationEditorType = {
    DISABLE: -1,
    NONE: 0,
    FREETEXT: 3,
    HIGHLIGHT: 9,
    STAMP: 13,
    INK: 15,
    SIGNATURE: 101
};
var AnnotationEditorParamsType = {
    RESIZE: 1,
    CREATE: 2,
    FREETEXT_SIZE: 11,
    FREETEXT_COLOR: 12,
    FREETEXT_OPACITY: 13,
    INK_COLOR: 21,
    INK_THICKNESS: 22,
    INK_OPACITY: 23,
    HIGHLIGHT_COLOR: 31,
    HIGHLIGHT_DEFAULT_COLOR: 32,
    HIGHLIGHT_THICKNESS: 33,
    HIGHLIGHT_FREE: 34,
    HIGHLIGHT_SHOW_ALL: 35,
    DRAW_STEP: 41
};
var PermissionFlag = {
    PRINT: 0x04,
    MODIFY_CONTENTS: 0x08,
    COPY: 0x10,
    MODIFY_ANNOTATIONS: 0x20,
    FILL_INTERACTIVE_FORMS: 0x100,
    COPY_FOR_ACCESSIBILITY: 0x200,
    ASSEMBLE: 0x400,
    PRINT_HIGH_QUALITY: 0x800
};
var TextRenderingMode = {
    FILL: 0,
    STROKE: 1,
    FILL_STROKE: 2,
    INVISIBLE: 3,
    FILL_ADD_TO_PATH: 4,
    STROKE_ADD_TO_PATH: 5,
    FILL_STROKE_ADD_TO_PATH: 6,
    ADD_TO_PATH: 7,
    FILL_STROKE_MASK: 3,
    ADD_TO_PATH_FLAG: 4
};
var util_ImageKind = {
    GRAYSCALE_1BPP: 1,
    RGB_24BPP: 2,
    RGBA_32BPP: 3
};
var AnnotationType = {
    TEXT: 1,
    LINK: 2,
    FREETEXT: 3,
    LINE: 4,
    SQUARE: 5,
    CIRCLE: 6,
    POLYGON: 7,
    POLYLINE: 8,
    HIGHLIGHT: 9,
    UNDERLINE: 10,
    SQUIGGLY: 11,
    STRIKEOUT: 12,
    STAMP: 13,
    CARET: 14,
    INK: 15,
    POPUP: 16,
    FILEATTACHMENT: 17,
    SOUND: 18,
    MOVIE: 19,
    WIDGET: 20,
    SCREEN: 21,
    PRINTERMARK: 22,
    TRAPNET: 23,
    WATERMARK: 24,
    THREED: 25,
    REDACT: 26
};
var AnnotationReplyType = {
    GROUP: "Group",
    REPLY: "R"
};
var AnnotationFlag = {
    INVISIBLE: 0x01,
    HIDDEN: 0x02,
    PRINT: 0x04,
    NOZOOM: 0x08,
    NOROTATE: 0x10,
    NOVIEW: 0x20,
    READONLY: 0x40,
    LOCKED: 0x80,
    TOGGLENOVIEW: 0x100,
    LOCKEDCONTENTS: 0x200
};
var AnnotationFieldFlag = {
    READONLY: 0x0000001,
    REQUIRED: 0x0000002,
    NOEXPORT: 0x0000004,
    MULTILINE: 0x0001000,
    PASSWORD: 0x0002000,
    NOTOGGLETOOFF: 0x0004000,
    RADIO: 0x0008000,
    PUSHBUTTON: 0x0010000,
    COMBO: 0x0020000,
    EDIT: 0x0040000,
    SORT: 0x0080000,
    FILESELECT: 0x0100000,
    MULTISELECT: 0x0200000,
    DONOTSPELLCHECK: 0x0400000,
    DONOTSCROLL: 0x0800000,
    COMB: 0x1000000,
    RICHTEXT: 0x2000000,
    RADIOSINUNISON: 0x2000000,
    COMMITONSELCHANGE: 0x4000000
};
var AnnotationBorderStyleType = {
    SOLID: 1,
    DASHED: 2,
    BEVELED: 3,
    INSET: 4,
    UNDERLINE: 5
};
var AnnotationActionEventType = {
    E: "Mouse Enter",
    X: "Mouse Exit",
    D: "Mouse Down",
    U: "Mouse Up",
    Fo: "Focus",
    Bl: "Blur",
    PO: "PageOpen",
    PC: "PageClose",
    PV: "PageVisible",
    PI: "PageInvisible",
    K: "Keystroke",
    F: "Format",
    V: "Validate",
    C: "Calculate"
};
var DocumentActionEventType = {
    WC: "WillClose",
    WS: "WillSave",
    DS: "DidSave",
    WP: "WillPrint",
    DP: "DidPrint"
};
var PageActionEventType = {
    O: "PageOpen",
    C: "PageClose"
};
var VerbosityLevel = {
    ERRORS: 0,
    WARNINGS: 1,
    INFOS: 5
};
var OPS = {
    dependency: 1,
    setLineWidth: 2,
    setLineCap: 3,
    setLineJoin: 4,
    setMiterLimit: 5,
    setDash: 6,
    setRenderingIntent: 7,
    setFlatness: 8,
    setGState: 9,
    save: 10,
    restore: 11,
    transform: 12,
    moveTo: 13,
    lineTo: 14,
    curveTo: 15,
    curveTo2: 16,
    curveTo3: 17,
    closePath: 18,
    rectangle: 19,
    stroke: 20,
    closeStroke: 21,
    fill: 22,
    eoFill: 23,
    fillStroke: 24,
    eoFillStroke: 25,
    closeFillStroke: 26,
    closeEOFillStroke: 27,
    endPath: 28,
    clip: 29,
    eoClip: 30,
    beginText: 31,
    endText: 32,
    setCharSpacing: 33,
    setWordSpacing: 34,
    setHScale: 35,
    setLeading: 36,
    setFont: 37,
    setTextRenderingMode: 38,
    setTextRise: 39,
    moveText: 40,
    setLeadingMoveText: 41,
    setTextMatrix: 42,
    nextLine: 43,
    showText: 44,
    showSpacedText: 45,
    nextLineShowText: 46,
    nextLineSetSpacingShowText: 47,
    setCharWidth: 48,
    setCharWidthAndBounds: 49,
    setStrokeColorSpace: 50,
    setFillColorSpace: 51,
    setStrokeColor: 52,
    setStrokeColorN: 53,
    setFillColor: 54,
    setFillColorN: 55,
    setStrokeGray: 56,
    setFillGray: 57,
    setStrokeRGBColor: 58,
    setFillRGBColor: 59,
    setStrokeCMYKColor: 60,
    setFillCMYKColor: 61,
    shadingFill: 62,
    beginInlineImage: 63,
    beginImageData: 64,
    endInlineImage: 65,
    paintXObject: 66,
    markPoint: 67,
    markPointProps: 68,
    beginMarkedContent: 69,
    beginMarkedContentProps: 70,
    endMarkedContent: 71,
    beginCompat: 72,
    endCompat: 73,
    paintFormXObjectBegin: 74,
    paintFormXObjectEnd: 75,
    beginGroup: 76,
    endGroup: 77,
    beginAnnotation: 80,
    endAnnotation: 81,
    paintImageMaskXObject: 83,
    paintImageMaskXObjectGroup: 84,
    paintImageXObject: 85,
    paintInlineImageXObject: 86,
    paintInlineImageXObjectGroup: 87,
    paintImageXObjectRepeat: 88,
    paintImageMaskXObjectRepeat: 89,
    paintSolidColorImageMask: 90,
    constructPath: 91,
    setStrokeTransparent: 92,
    setFillTransparent: 93,
    rawFillPath: 94
};
var DrawOPS = {
    moveTo: 0,
    lineTo: 1,
    curveTo: 2,
    closePath: 3
};
var PasswordResponses = {
    NEED_PASSWORD: 1,
    INCORRECT_PASSWORD: 2
};
var verbosity = VerbosityLevel.WARNINGS;
function setVerbosityLevel(level) {
    if (Number.isInteger(level)) {
        verbosity = level;
    }
}
function getVerbosityLevel() {
    return verbosity;
}
function info(msg) {
    if (verbosity >= VerbosityLevel.INFOS) {
        console.log("Info: ".concat(msg));
    }
}
function warn(msg) {
    if (verbosity >= VerbosityLevel.WARNINGS) {
        console.log("Warning: ".concat(msg));
    }
}
function unreachable(msg) {
    throw new Error(msg);
}
function assert(cond, msg) {
    if (!cond) {
        unreachable(msg);
    }
}
function _isValidProtocol(url) {
    switch (url === null || url === void 0 ? void 0 : url.protocol) {
        case "http:":
        case "https:":
        case "ftp:":
        case "mailto:":
        case "tel:":
            return true;
        default:
            return false;
    }
}
function createValidAbsoluteUrl(url, baseUrl, options) {
    if (baseUrl === void 0) { baseUrl = null; }
    if (options === void 0) { options = null; }
    if (!url) {
        return null;
    }
    if (options && typeof url === "string") {
        if (options.addDefaultProtocol && url.startsWith("www.")) {
            var dots = url.match(/\./g);
            if ((dots === null || dots === void 0 ? void 0 : dots.length) >= 2) {
                url = "http://".concat(url);
            }
        }
        if (options.tryConvertEncoding) {
            try {
                url = stringToUTF8String(url);
            }
            catch (_e) { }
        }
    }
    var absoluteUrl = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return _isValidProtocol(absoluteUrl) ? absoluteUrl : null;
}
function updateUrlHash(url, hash, allowRel) {
    if (allowRel === void 0) { allowRel = false; }
    var res = URL.parse(url);
    if (res) {
        res.hash = hash;
        return res.href;
    }
    if (allowRel && createValidAbsoluteUrl(url, "http://example.com")) {
        return url.split("#", 1)[0] + "".concat(hash ? "#".concat(hash) : "");
    }
    return "";
}
function shadow(obj, prop, value, nonSerializable) {
    if (nonSerializable === void 0) { nonSerializable = false; }
    Object.defineProperty(obj, prop, {
        value: value,
        enumerable: !nonSerializable,
        configurable: true,
        writable: false
    });
    return value;
}
var BaseException = function BaseExceptionClosure() {
    function BaseException(message, name) {
        this.message = message;
        this.name = name;
    }
    BaseException.prototype = new Error();
    BaseException.constructor = BaseException;
    return BaseException;
}();
var PasswordException = /** @class */ (function (_super) {
    __extends(PasswordException, _super);
    function PasswordException(msg, code) {
        var _this = _super.call(this, msg, "PasswordException") || this;
        _this.code = code;
        return _this;
    }
    return PasswordException;
}(BaseException));
var UnknownErrorException = /** @class */ (function (_super) {
    __extends(UnknownErrorException, _super);
    function UnknownErrorException(msg, details) {
        var _this = _super.call(this, msg, "UnknownErrorException") || this;
        _this.details = details;
        return _this;
    }
    return UnknownErrorException;
}(BaseException));
var InvalidPDFException = /** @class */ (function (_super) {
    __extends(InvalidPDFException, _super);
    function InvalidPDFException(msg) {
        return _super.call(this, msg, "InvalidPDFException") || this;
    }
    return InvalidPDFException;
}(BaseException));
var ResponseException = /** @class */ (function (_super) {
    __extends(ResponseException, _super);
    function ResponseException(msg, status, missing) {
        var _this = _super.call(this, msg, "ResponseException") || this;
        _this.status = status;
        _this.missing = missing;
        return _this;
    }
    return ResponseException;
}(BaseException));
var FormatError = /** @class */ (function (_super) {
    __extends(FormatError, _super);
    function FormatError(msg) {
        return _super.call(this, msg, "FormatError") || this;
    }
    return FormatError;
}(BaseException));
var AbortException = /** @class */ (function (_super) {
    __extends(AbortException, _super);
    function AbortException(msg) {
        return _super.call(this, msg, "AbortException") || this;
    }
    return AbortException;
}(BaseException));
function bytesToString(bytes) {
    if (typeof bytes !== "object" || (bytes === null || bytes === void 0 ? void 0 : bytes.length) === undefined) {
        unreachable("Invalid argument for bytesToString");
    }
    var length = bytes.length;
    var MAX_ARGUMENT_COUNT = 8192;
    if (length < MAX_ARGUMENT_COUNT) {
        return String.fromCharCode.apply(null, bytes);
    }
    var strBuf = [];
    for (var i = 0; i < length; i += MAX_ARGUMENT_COUNT) {
        var chunkEnd = Math.min(i + MAX_ARGUMENT_COUNT, length);
        var chunk = bytes.subarray(i, chunkEnd);
        strBuf.push(String.fromCharCode.apply(null, chunk));
    }
    return strBuf.join("");
}
function stringToBytes(str) {
    if (typeof str !== "string") {
        unreachable("Invalid argument for stringToBytes");
    }
    var length = str.length;
    var bytes = new Uint8Array(length);
    for (var i = 0; i < length; ++i) {
        bytes[i] = str.charCodeAt(i) & 0xff;
    }
    return bytes;
}
function string32(value) {
    return String.fromCharCode(value >> 24 & 0xff, value >> 16 & 0xff, value >> 8 & 0xff, value & 0xff);
}
function objectSize(obj) {
    return Object.keys(obj).length;
}
function isLittleEndian() {
    var buffer8 = new Uint8Array(4);
    buffer8[0] = 1;
    var view32 = new Uint32Array(buffer8.buffer, 0, 1);
    return view32[0] === 1;
}
function isEvalSupported() {
    try {
        new Function("");
        return true;
    }
    catch (_e) {
        return false;
    }
}
var util_FeatureTest = /** @class */ (function () {
    function util_FeatureTest() {
    }
    Object.defineProperty(util_FeatureTest, "isLittleEndian", {
        get: function () {
            return shadow(this, "isLittleEndian", isLittleEndian());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(util_FeatureTest, "isEvalSupported", {
        get: function () {
            return shadow(this, "isEvalSupported", isEvalSupported());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(util_FeatureTest, "isOffscreenCanvasSupported", {
        get: function () {
            return shadow(this, "isOffscreenCanvasSupported", typeof OffscreenCanvas !== "undefined");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(util_FeatureTest, "isImageDecoderSupported", {
        get: function () {
            return shadow(this, "isImageDecoderSupported", typeof ImageDecoder !== "undefined");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(util_FeatureTest, "platform", {
        get: function () {
            if (typeof navigator !== "undefined" && typeof (navigator === null || navigator === void 0 ? void 0 : navigator.platform) === "string" && typeof (navigator === null || navigator === void 0 ? void 0 : navigator.userAgent) === "string") {
                var platform = navigator.platform, userAgent = navigator.userAgent;
                return shadow(this, "platform", {
                    isAndroid: userAgent.includes("Android"),
                    isLinux: platform.includes("Linux"),
                    isMac: platform.includes("Mac"),
                    isWindows: platform.includes("Win"),
                    isFirefox: userAgent.includes("Firefox")
                });
            }
            return shadow(this, "platform", {
                isAndroid: false,
                isLinux: false,
                isMac: false,
                isWindows: false,
                isFirefox: false
            });
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(util_FeatureTest, "isCSSRoundSupported", {
        get: function () {
            var _e, _f;
            return shadow(this, "isCSSRoundSupported", (_f = (_e = globalThis.CSS) === null || _e === void 0 ? void 0 : _e.supports) === null || _f === void 0 ? void 0 : _f.call(_e, "width: round(1.5px, 1px)"));
        },
        enumerable: false,
        configurable: true
    });
    return util_FeatureTest;
}());
var hexNumbers = Array.from(Array(256).keys(), function (n) { return n.toString(16).padStart(2, "0"); });
var Util = /** @class */ (function () {
    function Util() {
    }
    Util.makeHexColor = function (r, g, b) {
        return "#".concat(hexNumbers[r]).concat(hexNumbers[g]).concat(hexNumbers[b]);
    };
    Util.scaleMinMax = function (transform, minMax) {
        var temp;
        if (transform[0]) {
            if (transform[0] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[0];
            minMax[2] *= transform[0];
            if (transform[3] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[3];
            minMax[3] *= transform[3];
        }
        else {
            temp = minMax[0];
            minMax[0] = minMax[1];
            minMax[1] = temp;
            temp = minMax[2];
            minMax[2] = minMax[3];
            minMax[3] = temp;
            if (transform[1] < 0) {
                temp = minMax[1];
                minMax[1] = minMax[3];
                minMax[3] = temp;
            }
            minMax[1] *= transform[1];
            minMax[3] *= transform[1];
            if (transform[2] < 0) {
                temp = minMax[0];
                minMax[0] = minMax[2];
                minMax[2] = temp;
            }
            minMax[0] *= transform[2];
            minMax[2] *= transform[2];
        }
        minMax[0] += transform[4];
        minMax[1] += transform[5];
        minMax[2] += transform[4];
        minMax[3] += transform[5];
    };
    Util.transform = function (m1, m2) {
        return [m1[0] * m2[0] + m1[2] * m2[1], m1[1] * m2[0] + m1[3] * m2[1], m1[0] * m2[2] + m1[2] * m2[3], m1[1] * m2[2] + m1[3] * m2[3], m1[0] * m2[4] + m1[2] * m2[5] + m1[4], m1[1] * m2[4] + m1[3] * m2[5] + m1[5]];
    };
    Util.applyTransform = function (p, m, pos) {
        if (pos === void 0) { pos = 0; }
        var p0 = p[pos];
        var p1 = p[pos + 1];
        p[pos] = p0 * m[0] + p1 * m[2] + m[4];
        p[pos + 1] = p0 * m[1] + p1 * m[3] + m[5];
    };
    Util.applyTransformToBezier = function (p, transform, pos) {
        if (pos === void 0) { pos = 0; }
        var m0 = transform[0];
        var m1 = transform[1];
        var m2 = transform[2];
        var m3 = transform[3];
        var m4 = transform[4];
        var m5 = transform[5];
        for (var i = 0; i < 6; i += 2) {
            var pI = p[pos + i];
            var pI1 = p[pos + i + 1];
            p[pos + i] = pI * m0 + pI1 * m2 + m4;
            p[pos + i + 1] = pI * m1 + pI1 * m3 + m5;
        }
    };
    Util.applyInverseTransform = function (p, m) {
        var p0 = p[0];
        var p1 = p[1];
        var d = m[0] * m[3] - m[1] * m[2];
        p[0] = (p0 * m[3] - p1 * m[2] + m[2] * m[5] - m[4] * m[3]) / d;
        p[1] = (-p0 * m[1] + p1 * m[0] + m[4] * m[1] - m[5] * m[0]) / d;
    };
    Util.axialAlignedBoundingBox = function (rect, transform, output) {
        var m0 = transform[0];
        var m1 = transform[1];
        var m2 = transform[2];
        var m3 = transform[3];
        var m4 = transform[4];
        var m5 = transform[5];
        var r0 = rect[0];
        var r1 = rect[1];
        var r2 = rect[2];
        var r3 = rect[3];
        var a0 = m0 * r0 + m4;
        var a2 = a0;
        var a1 = m0 * r2 + m4;
        var a3 = a1;
        var b0 = m3 * r1 + m5;
        var b2 = b0;
        var b1 = m3 * r3 + m5;
        var b3 = b1;
        if (m1 !== 0 || m2 !== 0) {
            var m1r0 = m1 * r0;
            var m1r2 = m1 * r2;
            var m2r1 = m2 * r1;
            var m2r3 = m2 * r3;
            a0 += m2r1;
            a3 += m2r1;
            a1 += m2r3;
            a2 += m2r3;
            b0 += m1r0;
            b3 += m1r0;
            b1 += m1r2;
            b2 += m1r2;
        }
        output[0] = Math.min(output[0], a0, a1, a2, a3);
        output[1] = Math.min(output[1], b0, b1, b2, b3);
        output[2] = Math.max(output[2], a0, a1, a2, a3);
        output[3] = Math.max(output[3], b0, b1, b2, b3);
    };
    Util.inverseTransform = function (m) {
        var d = m[0] * m[3] - m[1] * m[2];
        return [m[3] / d, -m[1] / d, -m[2] / d, m[0] / d, (m[2] * m[5] - m[4] * m[3]) / d, (m[4] * m[1] - m[5] * m[0]) / d];
    };
    Util.singularValueDecompose2dScale = function (matrix, output) {
        var m0 = matrix[0];
        var m1 = matrix[1];
        var m2 = matrix[2];
        var m3 = matrix[3];
        var a = Math.pow(m0, 2) + Math.pow(m1, 2);
        var b = m0 * m2 + m1 * m3;
        var c = Math.pow(m2, 2) + Math.pow(m3, 2);
        var first = (a + c) / 2;
        var second = Math.sqrt(Math.pow(first, 2) - (a * c - Math.pow(b, 2)));
        output[0] = Math.sqrt(first + second || 1);
        output[1] = Math.sqrt(first - second || 1);
    };
    Util.normalizeRect = function (rect) {
        var r = rect.slice(0);
        if (rect[0] > rect[2]) {
            r[0] = rect[2];
            r[2] = rect[0];
        }
        if (rect[1] > rect[3]) {
            r[1] = rect[3];
            r[3] = rect[1];
        }
        return r;
    };
    Util.intersect = function (rect1, rect2) {
        var xLow = Math.max(Math.min(rect1[0], rect1[2]), Math.min(rect2[0], rect2[2]));
        var xHigh = Math.min(Math.max(rect1[0], rect1[2]), Math.max(rect2[0], rect2[2]));
        if (xLow > xHigh) {
            return null;
        }
        var yLow = Math.max(Math.min(rect1[1], rect1[3]), Math.min(rect2[1], rect2[3]));
        var yHigh = Math.min(Math.max(rect1[1], rect1[3]), Math.max(rect2[1], rect2[3]));
        if (yLow > yHigh) {
            return null;
        }
        return [xLow, yLow, xHigh, yHigh];
    };
    Util.pointBoundingBox = function (x, y, minMax) {
        minMax[0] = Math.min(minMax[0], x);
        minMax[1] = Math.min(minMax[1], y);
        minMax[2] = Math.max(minMax[2], x);
        minMax[3] = Math.max(minMax[3], y);
    };
    Util.rectBoundingBox = function (x0, y0, x1, y1, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x1);
        minMax[1] = Math.min(minMax[1], y0, y1);
        minMax[2] = Math.max(minMax[2], x0, x1);
        minMax[3] = Math.max(minMax[3], y0, y1);
    };
    Util.bezierBoundingBox = function (x0, y0, x1, y1, x2, y2, x3, y3, minMax) {
        minMax[0] = Math.min(minMax[0], x0, x3);
        minMax[1] = Math.min(minMax[1], y0, y3);
        minMax[2] = Math.max(minMax[2], x0, x3);
        minMax[3] = Math.max(minMax[3], y0, y3);
        __classPrivateFieldGet(this, _a, "m", _Util_getExtremum).call(this, x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-x0 + 3 * (x1 - x2) + x3), 6 * (x0 - 2 * x1 + x2), 3 * (x1 - x0), minMax);
        __classPrivateFieldGet(this, _a, "m", _Util_getExtremum).call(this, x0, x1, x2, x3, y0, y1, y2, y3, 3 * (-y0 + 3 * (y1 - y2) + y3), 6 * (y0 - 2 * y1 + y2), 3 * (y1 - y0), minMax);
    };
    return Util;
}());
_a = Util, _Util_getExtremumOnCurve = function _Util_getExtremumOnCurve(x0, x1, x2, x3, y0, y1, y2, y3, t, minMax) {
    if (t <= 0 || t >= 1) {
        return;
    }
    var mt = 1 - t;
    var tt = t * t;
    var ttt = tt * t;
    var x = mt * (mt * (mt * x0 + 3 * t * x1) + 3 * tt * x2) + ttt * x3;
    var y = mt * (mt * (mt * y0 + 3 * t * y1) + 3 * tt * y2) + ttt * y3;
    minMax[0] = Math.min(minMax[0], x);
    minMax[1] = Math.min(minMax[1], y);
    minMax[2] = Math.max(minMax[2], x);
    minMax[3] = Math.max(minMax[3], y);
}, _Util_getExtremum = function _Util_getExtremum(x0, x1, x2, x3, y0, y1, y2, y3, a, b, c, minMax) {
    if (Math.abs(a) < 1e-12) {
        if (Math.abs(b) >= 1e-12) {
            __classPrivateFieldGet(this, _a, "m", _Util_getExtremumOnCurve).call(this, x0, x1, x2, x3, y0, y1, y2, y3, -c / b, minMax);
        }
        return;
    }
    var delta = Math.pow(b, 2) - 4 * c * a;
    if (delta < 0) {
        return;
    }
    var sqrtDelta = Math.sqrt(delta);
    var a2 = 2 * a;
    __classPrivateFieldGet(this, _a, "m", _Util_getExtremumOnCurve).call(this, x0, x1, x2, x3, y0, y1, y2, y3, (-b + sqrtDelta) / a2, minMax);
    __classPrivateFieldGet(this, _a, "m", _Util_getExtremumOnCurve).call(this, x0, x1, x2, x3, y0, y1, y2, y3, (-b - sqrtDelta) / a2, minMax);
};
var PDFStringTranslateTable = ( /* unused pure expression or super */null && ([0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2d8, 0x2c7, 0x2c6, 0x2d9, 0x2dd, 0x2db, 0x2da, 0x2dc, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0x2022, 0x2020, 0x2021, 0x2026, 0x2014, 0x2013, 0x192, 0x2044, 0x2039, 0x203a, 0x2212, 0x2030, 0x201e, 0x201c, 0x201d, 0x2018, 0x2019, 0x201a, 0x2122, 0xfb01, 0xfb02, 0x141, 0x152, 0x160, 0x178, 0x17d, 0x131, 0x142, 0x153, 0x161, 0x17e, 0, 0x20ac]));
function stringToPDFString(str) {
    if (str[0] >= "\xEF") {
        var encoding = void 0;
        if (str[0] === "\xFE" && str[1] === "\xFF") {
            encoding = "utf-16be";
            if (str.length % 2 === 1) {
                str = str.slice(0, -1);
            }
        }
        else if (str[0] === "\xFF" && str[1] === "\xFE") {
            encoding = "utf-16le";
            if (str.length % 2 === 1) {
                str = str.slice(0, -1);
            }
        }
        else if (str[0] === "\xEF" && str[1] === "\xBB" && str[2] === "\xBF") {
            encoding = "utf-8";
        }
        if (encoding) {
            try {
                var decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                var buffer = stringToBytes(str);
                var decoded = decoder.decode(buffer);
                if (!decoded.includes("\x1b")) {
                    return decoded;
                }
                return decoded.replaceAll(/\x1b[^\x1b]*(?:\x1b|$)/g, "");
            }
            catch (ex) {
                warn("stringToPDFString: \"".concat(ex, "\"."));
            }
        }
    }
    var strBuf = [];
    for (var i = 0, ii = str.length; i < ii; i++) {
        var charCode = str.charCodeAt(i);
        if (charCode === 0x1b) {
            while (++i < ii && str.charCodeAt(i) !== 0x1b) { }
            continue;
        }
        var code = PDFStringTranslateTable[charCode];
        strBuf.push(code ? String.fromCharCode(code) : str.charAt(i));
    }
    return strBuf.join("");
}
function stringToUTF8String(str) {
    return decodeURIComponent(escape(str));
}
function utf8StringToString(str) {
    return unescape(encodeURIComponent(str));
}
function isArrayEqual(arr1, arr2) {
    if (arr1.length !== arr2.length) {
        return false;
    }
    for (var i = 0, ii = arr1.length; i < ii; i++) {
        if (arr1[i] !== arr2[i]) {
            return false;
        }
    }
    return true;
}
function getModificationDate(date) {
    if (date === void 0) { date = new Date(); }
    var buffer = [date.getUTCFullYear().toString(), (date.getUTCMonth() + 1).toString().padStart(2, "0"), date.getUTCDate().toString().padStart(2, "0"), date.getUTCHours().toString().padStart(2, "0"), date.getUTCMinutes().toString().padStart(2, "0"), date.getUTCSeconds().toString().padStart(2, "0")];
    return buffer.join("");
}
var NormalizeRegex = null;
var NormalizationMap = null;
function normalizeUnicode(str) {
    if (!NormalizeRegex) {
        NormalizeRegex = /([\u00a0\u00b5\u037e\u0eb3\u2000-\u200a\u202f\u2126\ufb00-\ufb04\ufb06\ufb20-\ufb36\ufb38-\ufb3c\ufb3e\ufb40-\ufb41\ufb43-\ufb44\ufb46-\ufba1\ufba4-\ufba9\ufbae-\ufbb1\ufbd3-\ufbdc\ufbde-\ufbe7\ufbea-\ufbf8\ufbfc-\ufbfd\ufc00-\ufc5d\ufc64-\ufcf1\ufcf5-\ufd3d\ufd88\ufdf4\ufdfa-\ufdfb\ufe71\ufe77\ufe79\ufe7b\ufe7d]+)|(\ufb05+)/gu;
        NormalizationMap = new Map([["ﬅ", "ſt"]]);
    }
    return str.replaceAll(NormalizeRegex, function (_, p1, p2) { return p1 ? p1.normalize("NFKC") : NormalizationMap.get(p2); });
}
function getUuid() {
    if (typeof crypto.randomUUID === "function") {
        return crypto.randomUUID();
    }
    var buf = new Uint8Array(32);
    crypto.getRandomValues(buf);
    return bytesToString(buf);
}
var AnnotationPrefix = "pdfjs_internal_id_";
function _isValidExplicitDest(validRef, validName, dest) {
    var e_1, _e;
    if (!Array.isArray(dest) || dest.length < 2) {
        return false;
    }
    var _f = __read(dest), page = _f[0], zoom = _f[1], args = _f.slice(2);
    if (!validRef(page) && !Number.isInteger(page)) {
        return false;
    }
    if (!validName(zoom)) {
        return false;
    }
    var argsLen = args.length;
    var allowNull = true;
    switch (zoom.name) {
        case "XYZ":
            if (argsLen < 2 || argsLen > 3) {
                return false;
            }
            break;
        case "Fit":
        case "FitB":
            return argsLen === 0;
        case "FitH":
        case "FitBH":
        case "FitV":
        case "FitBV":
            if (argsLen > 1) {
                return false;
            }
            break;
        case "FitR":
            if (argsLen !== 4) {
                return false;
            }
            allowNull = false;
            break;
        default:
            return false;
    }
    try {
        for (var args_1 = __values(args), args_1_1 = args_1.next(); !args_1_1.done; args_1_1 = args_1.next()) {
            var arg = args_1_1.value;
            if (typeof arg === "number" || allowNull && arg === null) {
                continue;
            }
            return false;
        }
    }
    catch (e_1_1) { e_1 = { error: e_1_1 }; }
    finally {
        try {
            if (args_1_1 && !args_1_1.done && (_e = args_1.return)) _e.call(args_1);
        }
        finally { if (e_1) throw e_1.error; }
    }
    return true;
}
function MathClamp(v, min, max) {
    return Math.min(Math.max(v, min), max);
}
function toHexUtil(arr) {
    if (Uint8Array.prototype.toHex) {
        return arr.toHex();
    }
    return Array.from(arr, function (num) { return hexNumbers[num]; }).join("");
}
function toBase64Util(arr) {
    if (Uint8Array.prototype.toBase64) {
        return arr.toBase64();
    }
    return btoa(bytesToString(arr));
}
function fromBase64Util(str) {
    if (Uint8Array.fromBase64) {
        return Uint8Array.fromBase64(str);
    }
    return stringToBytes(atob(str));
}
if (typeof Promise.try !== "function") {
    Promise.try = function (fn) {
        var args = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            args[_i - 1] = arguments[_i];
        }
        return new Promise(function (resolve) {
            resolve(fn.apply(void 0, __spreadArray([], __read(args), false)));
        });
    };
}
if (typeof Math.sumPrecise !== "function") {
    Math.sumPrecise = function (numbers) {
        return numbers.reduce(function (a, b) { return a + b; }, 0);
    };
}
; // ./src/display/display_utils.js
var SVG_NS = "http://www.w3.org/2000/svg";
var PixelsPerInch = /** @class */ (function () {
    function PixelsPerInch() {
    }
    var _e;
    _e = PixelsPerInch;
    PixelsPerInch.CSS = 96.0;
    PixelsPerInch.PDF = 72.0;
    PixelsPerInch.PDF_TO_CSS_UNITS = _e.CSS / _e.PDF;
    return PixelsPerInch;
}());
function fetchData(url_1) {
    return __awaiter(this, arguments, void 0, function (url, type) {
        var response;
        if (type === void 0) { type = "text"; }
        return __generator(this, function (_f) {
            switch (_f.label) {
                case 0:
                    if (!isValidFetchUrl(url, document.baseURI)) return [3 /*break*/, 2];
                    return [4 /*yield*/, fetch(url)];
                case 1:
                    response = _f.sent();
                    if (!response.ok) {
                        throw new Error(response.statusText);
                    }
                    switch (type) {
                        case "arraybuffer":
                            return [2 /*return*/, response.arrayBuffer()];
                        case "blob":
                            return [2 /*return*/, response.blob()];
                        case "json":
                            return [2 /*return*/, response.json()];
                    }
                    return [2 /*return*/, response.text()];
                case 2: return [2 /*return*/, new Promise(function (resolve, reject) {
                        var request = new XMLHttpRequest();
                        request.open("GET", url, true);
                        request.responseType = type;
                        request.onreadystatechange = function () {
                            if (request.readyState !== XMLHttpRequest.DONE) {
                                return;
                            }
                            if (request.status === 200 || request.status === 0) {
                                switch (type) {
                                    case "arraybuffer":
                                    case "blob":
                                    case "json":
                                        resolve(request.response);
                                        return;
                                }
                                resolve(request.responseText);
                                return;
                            }
                            reject(new Error(request.statusText));
                        };
                        request.send(null);
                    })];
            }
        });
    });
}
var PageViewport = /** @class */ (function () {
    function PageViewport(_f) {
        var viewBox = _f.viewBox, userUnit = _f.userUnit, scale = _f.scale, rotation = _f.rotation, _g = _f.offsetX, offsetX = _g === void 0 ? 0 : _g, _h = _f.offsetY, offsetY = _h === void 0 ? 0 : _h, _j = _f.dontFlip, dontFlip = _j === void 0 ? false : _j;
        this.viewBox = viewBox;
        this.userUnit = userUnit;
        this.scale = scale;
        this.rotation = rotation;
        this.offsetX = offsetX;
        this.offsetY = offsetY;
        scale *= userUnit;
        var centerX = (viewBox[2] + viewBox[0]) / 2;
        var centerY = (viewBox[3] + viewBox[1]) / 2;
        var rotateA, rotateB, rotateC, rotateD;
        rotation %= 360;
        if (rotation < 0) {
            rotation += 360;
        }
        switch (rotation) {
            case 180:
                rotateA = -1;
                rotateB = 0;
                rotateC = 0;
                rotateD = 1;
                break;
            case 90:
                rotateA = 0;
                rotateB = 1;
                rotateC = 1;
                rotateD = 0;
                break;
            case 270:
                rotateA = 0;
                rotateB = -1;
                rotateC = -1;
                rotateD = 0;
                break;
            case 0:
                rotateA = 1;
                rotateB = 0;
                rotateC = 0;
                rotateD = -1;
                break;
            default:
                throw new Error("PageViewport: Invalid rotation, must be a multiple of 90 degrees.");
        }
        if (dontFlip) {
            rotateC = -rotateC;
            rotateD = -rotateD;
        }
        var offsetCanvasX, offsetCanvasY;
        var width, height;
        if (rotateA === 0) {
            offsetCanvasX = Math.abs(centerY - viewBox[1]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerX - viewBox[0]) * scale + offsetY;
            width = (viewBox[3] - viewBox[1]) * scale;
            height = (viewBox[2] - viewBox[0]) * scale;
        }
        else {
            offsetCanvasX = Math.abs(centerX - viewBox[0]) * scale + offsetX;
            offsetCanvasY = Math.abs(centerY - viewBox[1]) * scale + offsetY;
            width = (viewBox[2] - viewBox[0]) * scale;
            height = (viewBox[3] - viewBox[1]) * scale;
        }
        this.transform = [rotateA * scale, rotateB * scale, rotateC * scale, rotateD * scale, offsetCanvasX - rotateA * scale * centerX - rotateC * scale * centerY, offsetCanvasY - rotateB * scale * centerX - rotateD * scale * centerY];
        this.width = width;
        this.height = height;
    }
    Object.defineProperty(PageViewport.prototype, "rawDims", {
        get: function () {
            var dims = this.viewBox;
            return shadow(this, "rawDims", {
                pageWidth: dims[2] - dims[0],
                pageHeight: dims[3] - dims[1],
                pageX: dims[0],
                pageY: dims[1]
            });
        },
        enumerable: false,
        configurable: true
    });
    PageViewport.prototype.clone = function (_f) {
        var _g = _f === void 0 ? {} : _f, _h = _g.scale, scale = _h === void 0 ? this.scale : _h, _j = _g.rotation, rotation = _j === void 0 ? this.rotation : _j, _k = _g.offsetX, offsetX = _k === void 0 ? this.offsetX : _k, _l = _g.offsetY, offsetY = _l === void 0 ? this.offsetY : _l, _m = _g.dontFlip, dontFlip = _m === void 0 ? false : _m;
        return new PageViewport({
            viewBox: this.viewBox.slice(),
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    };
    PageViewport.prototype.convertToViewportPoint = function (x, y) {
        var p = [x, y];
        Util.applyTransform(p, this.transform);
        return p;
    };
    PageViewport.prototype.convertToViewportRectangle = function (rect) {
        var topLeft = [rect[0], rect[1]];
        Util.applyTransform(topLeft, this.transform);
        var bottomRight = [rect[2], rect[3]];
        Util.applyTransform(bottomRight, this.transform);
        return [topLeft[0], topLeft[1], bottomRight[0], bottomRight[1]];
    };
    PageViewport.prototype.convertToPdfPoint = function (x, y) {
        var p = [x, y];
        Util.applyInverseTransform(p, this.transform);
        return p;
    };
    return PageViewport;
}());
var RenderingCancelledException = /** @class */ (function (_super) {
    __extends(RenderingCancelledException, _super);
    function RenderingCancelledException(msg, extraDelay) {
        if (extraDelay === void 0) { extraDelay = 0; }
        var _this = _super.call(this, msg, "RenderingCancelledException") || this;
        _this.extraDelay = extraDelay;
        return _this;
    }
    return RenderingCancelledException;
}(BaseException));
function isDataScheme(url) {
    var ii = url.length;
    var i = 0;
    while (i < ii && url[i].trim() === "") {
        i++;
    }
    return url.substring(i, i + 5).toLowerCase() === "data:";
}
function isPdfFile(filename) {
    return typeof filename === "string" && /\.pdf$/i.test(filename);
}
function getFilenameFromUrl(url) {
    var _f;
    _f = __read(url.split(/[#?]/, 1), 1), url = _f[0];
    return url.substring(url.lastIndexOf("/") + 1);
}
function getPdfFilenameFromUrl(url, defaultFilename) {
    if (defaultFilename === void 0) { defaultFilename = "document.pdf"; }
    if (typeof url !== "string") {
        return defaultFilename;
    }
    if (isDataScheme(url)) {
        warn('getPdfFilenameFromUrl: ignore "data:"-URL for performance reasons.');
        return defaultFilename;
    }
    var reURI = /^(?:(?:[^:]+:)?\/\/[^/]+)?([^?#]*)(\?[^#]*)?(#.*)?$/;
    var reFilename = /[^/?#=]+\.pdf\b(?!.*\.pdf\b)/i;
    var splitURI = reURI.exec(url);
    var suggestedFilename = reFilename.exec(splitURI[1]) || reFilename.exec(splitURI[2]) || reFilename.exec(splitURI[3]);
    if (suggestedFilename) {
        suggestedFilename = suggestedFilename[0];
        if (suggestedFilename.includes("%")) {
            try {
                suggestedFilename = reFilename.exec(decodeURIComponent(suggestedFilename))[0];
            }
            catch (_f) { }
        }
    }
    return suggestedFilename || defaultFilename;
}
var StatTimer = /** @class */ (function () {
    function StatTimer() {
        this.started = Object.create(null);
        this.times = [];
    }
    StatTimer.prototype.time = function (name) {
        if (name in this.started) {
            warn("Timer is already running for ".concat(name));
        }
        this.started[name] = Date.now();
    };
    StatTimer.prototype.timeEnd = function (name) {
        if (!(name in this.started)) {
            warn("Timer has not been started for ".concat(name));
        }
        this.times.push({
            name: name,
            start: this.started[name],
            end: Date.now()
        });
        delete this.started[name];
    };
    StatTimer.prototype.toString = function () {
        var e_2, _f, e_3, _g;
        var outBuf = [];
        var longest = 0;
        try {
            for (var _h = __values(this.times), _j = _h.next(); !_j.done; _j = _h.next()) {
                var name = _j.value.name;
                longest = Math.max(name.length, longest);
            }
        }
        catch (e_2_1) { e_2 = { error: e_2_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_f = _h.return)) _f.call(_h);
            }
            finally { if (e_2) throw e_2.error; }
        }
        try {
            for (var _k = __values(this.times), _l = _k.next(); !_l.done; _l = _k.next()) {
                var _m = _l.value, name = _m.name, start = _m.start, end = _m.end;
                outBuf.push("".concat(name.padEnd(longest), " ").concat(end - start, "ms\n"));
            }
        }
        catch (e_3_1) { e_3 = { error: e_3_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_g = _k.return)) _g.call(_k);
            }
            finally { if (e_3) throw e_3.error; }
        }
        return outBuf.join("");
    };
    return StatTimer;
}());
function isValidFetchUrl(url, baseUrl) {
    var res = baseUrl ? URL.parse(url, baseUrl) : URL.parse(url);
    return (res === null || res === void 0 ? void 0 : res.protocol) === "http:" || (res === null || res === void 0 ? void 0 : res.protocol) === "https:";
}
function noContextMenu(e) {
    e.preventDefault();
}
function stopEvent(e) {
    e.preventDefault();
    e.stopPropagation();
}
function deprecated(details) {
    console.log("Deprecated API usage: " + details);
}
var PDFDateString = /** @class */ (function () {
    function PDFDateString() {
    }
    PDFDateString.toDateObject = function (input) {
        if (!input || typeof input !== "string") {
            return null;
        }
        __classPrivateFieldSet(this, _b, __classPrivateFieldGet(this, _b, "f", _PDFDateString_regex) || new RegExp("^D:" + "(\\d{4})" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "(\\d{2})?" + "([Z|+|-])?" + "(\\d{2})?" + "'?" + "(\\d{2})?" + "'?"), "f", _PDFDateString_regex);
        var matches = __classPrivateFieldGet(this, _b, "f", _PDFDateString_regex).exec(input);
        if (!matches) {
            return null;
        }
        var year = parseInt(matches[1], 10);
        var month = parseInt(matches[2], 10);
        month = month >= 1 && month <= 12 ? month - 1 : 0;
        var day = parseInt(matches[3], 10);
        day = day >= 1 && day <= 31 ? day : 1;
        var hour = parseInt(matches[4], 10);
        hour = hour >= 0 && hour <= 23 ? hour : 0;
        var minute = parseInt(matches[5], 10);
        minute = minute >= 0 && minute <= 59 ? minute : 0;
        var second = parseInt(matches[6], 10);
        second = second >= 0 && second <= 59 ? second : 0;
        var universalTimeRelation = matches[7] || "Z";
        var offsetHour = parseInt(matches[8], 10);
        offsetHour = offsetHour >= 0 && offsetHour <= 23 ? offsetHour : 0;
        var offsetMinute = parseInt(matches[9], 10) || 0;
        offsetMinute = offsetMinute >= 0 && offsetMinute <= 59 ? offsetMinute : 0;
        if (universalTimeRelation === "-") {
            hour += offsetHour;
            minute += offsetMinute;
        }
        else if (universalTimeRelation === "+") {
            hour -= offsetHour;
            minute -= offsetMinute;
        }
        return new Date(Date.UTC(year, month, day, hour, minute, second));
    };
    return PDFDateString;
}());
_b = PDFDateString;
_PDFDateString_regex = { value: void 0 };
function getXfaPageViewport(xfaPage, _f) {
    var _g = _f.scale, scale = _g === void 0 ? 1 : _g, _h = _f.rotation, rotation = _h === void 0 ? 0 : _h;
    var _j = xfaPage.attributes.style, width = _j.width, height = _j.height;
    var viewBox = [0, 0, parseInt(width), parseInt(height)];
    return new PageViewport({
        viewBox: viewBox,
        userUnit: 1,
        scale: scale,
        rotation: rotation
    });
}
function getRGB(color) {
    if (color.startsWith("#")) {
        var colorRGB = parseInt(color.slice(1), 16);
        return [(colorRGB & 0xff0000) >> 16, (colorRGB & 0x00ff00) >> 8, colorRGB & 0x0000ff];
    }
    if (color.startsWith("rgb(")) {
        return color.slice(4, -1).split(",").map(function (x) { return parseInt(x); });
    }
    if (color.startsWith("rgba(")) {
        return color.slice(5, -1).split(",").map(function (x) { return parseInt(x); }).slice(0, 3);
    }
    warn("Not a valid color format: \"".concat(color, "\""));
    return [0, 0, 0];
}
function getColorValues(colors) {
    var e_4, _f;
    var span = document.createElement("span");
    span.style.visibility = "hidden";
    span.style.colorScheme = "only light";
    document.body.append(span);
    try {
        for (var _g = __values(colors.keys()), _h = _g.next(); !_h.done; _h = _g.next()) {
            var name = _h.value;
            span.style.color = name;
            var computedColor = window.getComputedStyle(span).color;
            colors.set(name, getRGB(computedColor));
        }
    }
    catch (e_4_1) { e_4 = { error: e_4_1 }; }
    finally {
        try {
            if (_h && !_h.done && (_f = _g.return)) _f.call(_g);
        }
        finally { if (e_4) throw e_4.error; }
    }
    span.remove();
}
function getCurrentTransform(ctx) {
    var _f = ctx.getTransform(), a = _f.a, b = _f.b, c = _f.c, d = _f.d, e = _f.e, f = _f.f;
    return [a, b, c, d, e, f];
}
function getCurrentTransformInverse(ctx) {
    var _f = ctx.getTransform().invertSelf(), a = _f.a, b = _f.b, c = _f.c, d = _f.d, e = _f.e, f = _f.f;
    return [a, b, c, d, e, f];
}
function setLayerDimensions(div, viewport, mustFlip, mustRotate) {
    if (mustFlip === void 0) { mustFlip = false; }
    if (mustRotate === void 0) { mustRotate = true; }
    if (viewport instanceof PageViewport) {
        var _f = viewport.rawDims, pageWidth = _f.pageWidth, pageHeight = _f.pageHeight;
        var style = div.style;
        var useRound = util_FeatureTest.isCSSRoundSupported;
        var w = "var(--total-scale-factor) * ".concat(pageWidth, "px"), h = "var(--total-scale-factor) * ".concat(pageHeight, "px");
        var widthStr = useRound ? "round(down, ".concat(w, ", var(--scale-round-x))") : "calc(".concat(w, ")"), heightStr = useRound ? "round(down, ".concat(h, ", var(--scale-round-y))") : "calc(".concat(h, ")");
        if (!mustFlip || viewport.rotation % 180 === 0) {
            style.width = widthStr;
            style.height = heightStr;
        }
        else {
            style.width = heightStr;
            style.height = widthStr;
        }
    }
    if (mustRotate) {
        div.setAttribute("data-main-rotation", viewport.rotation);
    }
}
var OutputScale = /** @class */ (function () {
    function OutputScale() {
        var pixelRatio = OutputScale.pixelRatio;
        this.sx = pixelRatio;
        this.sy = pixelRatio;
    }
    Object.defineProperty(OutputScale.prototype, "scaled", {
        get: function () {
            return this.sx !== 1 || this.sy !== 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(OutputScale.prototype, "symmetric", {
        get: function () {
            return this.sx === this.sy;
        },
        enumerable: false,
        configurable: true
    });
    OutputScale.prototype.limitCanvas = function (width, height, maxPixels, maxDim) {
        var maxAreaScale = Infinity, maxWidthScale = Infinity, maxHeightScale = Infinity;
        if (maxPixels > 0) {
            maxAreaScale = Math.sqrt(maxPixels / (width * height));
        }
        if (maxDim !== -1) {
            maxWidthScale = maxDim / width;
            maxHeightScale = maxDim / height;
        }
        var maxScale = Math.min(maxAreaScale, maxWidthScale, maxHeightScale);
        if (this.sx > maxScale || this.sy > maxScale) {
            this.sx = maxScale;
            this.sy = maxScale;
            return true;
        }
        return false;
    };
    Object.defineProperty(OutputScale, "pixelRatio", {
        get: function () {
            return globalThis.devicePixelRatio || 1;
        },
        enumerable: false,
        configurable: true
    });
    return OutputScale;
}());
var SupportedImageMimeTypes = ["image/apng", "image/avif", "image/bmp", "image/gif", "image/jpeg", "image/png", "image/svg+xml", "image/webp", "image/x-icon"];
; // ./src/display/editor/toolbar.js
var EditorToolbar = /** @class */ (function () {
    function EditorToolbar(editor) {
        var _g;
        _EditorToolbar_instances.add(this);
        _EditorToolbar_toolbar.set(this, null);
        _EditorToolbar_colorPicker.set(this, null);
        _EditorToolbar_editor.set(this, void 0);
        _EditorToolbar_buttons.set(this, null);
        _EditorToolbar_altText.set(this, null);
        _EditorToolbar_signatureDescriptionButton.set(this, null);
        __classPrivateFieldSet(this, _EditorToolbar_editor, editor, "f");
        __classPrivateFieldSet(_g = _f, _f, __classPrivateFieldGet(_g, _f, "f", _EditorToolbar_l10nRemove) || Object.freeze({
            freetext: "pdfjs-editor-remove-freetext-button",
            highlight: "pdfjs-editor-remove-highlight-button",
            ink: "pdfjs-editor-remove-ink-button",
            stamp: "pdfjs-editor-remove-stamp-button",
            signature: "pdfjs-editor-remove-signature-button"
        }), "f", _EditorToolbar_l10nRemove);
    }
    EditorToolbar.prototype.render = function () {
        var editToolbar = __classPrivateFieldSet(this, _EditorToolbar_toolbar, document.createElement("div"), "f");
        editToolbar.classList.add("editToolbar", "hidden");
        editToolbar.setAttribute("role", "toolbar");
        var signal = __classPrivateFieldGet(this, _EditorToolbar_editor, "f")._uiManager._signal;
        editToolbar.addEventListener("contextmenu", noContextMenu, {
            signal: signal
        });
        editToolbar.addEventListener("pointerdown", __classPrivateFieldGet(_f, _f, "m", _EditorToolbar_pointerDown), {
            signal: signal
        });
        var buttons = __classPrivateFieldSet(this, _EditorToolbar_buttons, document.createElement("div"), "f");
        buttons.className = "buttons";
        editToolbar.append(buttons);
        var position = __classPrivateFieldGet(this, _EditorToolbar_editor, "f").toolbarPosition;
        if (position) {
            var style = editToolbar.style;
            var x = __classPrivateFieldGet(this, _EditorToolbar_editor, "f")._uiManager.direction === "ltr" ? 1 - position[0] : position[0];
            style.insetInlineEnd = "".concat(100 * x, "%");
            style.top = "calc(".concat(100 * position[1], "% + var(--editor-toolbar-vert-offset))");
        }
        __classPrivateFieldGet(this, _EditorToolbar_instances, "m", _EditorToolbar_addDeleteButton).call(this);
        return editToolbar;
    };
    Object.defineProperty(EditorToolbar.prototype, "div", {
        get: function () {
            return __classPrivateFieldGet(this, _EditorToolbar_toolbar, "f");
        },
        enumerable: false,
        configurable: true
    });
    EditorToolbar.prototype.hide = function () {
        var _g;
        __classPrivateFieldGet(this, _EditorToolbar_toolbar, "f").classList.add("hidden");
        (_g = __classPrivateFieldGet(this, _EditorToolbar_colorPicker, "f")) === null || _g === void 0 ? void 0 : _g.hideDropdown();
    };
    EditorToolbar.prototype.show = function () {
        var _g;
        __classPrivateFieldGet(this, _EditorToolbar_toolbar, "f").classList.remove("hidden");
        (_g = __classPrivateFieldGet(this, _EditorToolbar_altText, "f")) === null || _g === void 0 ? void 0 : _g.shown();
    };
    EditorToolbar.prototype.addAltText = function (altText) {
        return __awaiter(this, void 0, void 0, function () {
            var button;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, altText.render()];
                    case 1:
                        button = _g.sent();
                        __classPrivateFieldGet(this, _EditorToolbar_instances, "m", _EditorToolbar_addListenersToElement).call(this, button);
                        __classPrivateFieldGet(this, _EditorToolbar_buttons, "f").prepend(button, __classPrivateFieldGet(this, _EditorToolbar_instances, "a", _EditorToolbar_divider_get));
                        __classPrivateFieldSet(this, _EditorToolbar_altText, altText, "f");
                        return [2 /*return*/];
                }
            });
        });
    };
    EditorToolbar.prototype.addColorPicker = function (colorPicker) {
        __classPrivateFieldSet(this, _EditorToolbar_colorPicker, colorPicker, "f");
        var button = colorPicker.renderButton();
        __classPrivateFieldGet(this, _EditorToolbar_instances, "m", _EditorToolbar_addListenersToElement).call(this, button);
        __classPrivateFieldGet(this, _EditorToolbar_buttons, "f").prepend(button, __classPrivateFieldGet(this, _EditorToolbar_instances, "a", _EditorToolbar_divider_get));
    };
    EditorToolbar.prototype.addEditSignatureButton = function (signatureManager) {
        return __awaiter(this, void 0, void 0, function () {
            var button, _g;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        _g = [this, _EditorToolbar_signatureDescriptionButton];
                        return [4 /*yield*/, signatureManager.renderEditButton(__classPrivateFieldGet(this, _EditorToolbar_editor, "f"))];
                    case 1:
                        button = __classPrivateFieldSet.apply(void 0, _g.concat([_h.sent(), "f"]));
                        __classPrivateFieldGet(this, _EditorToolbar_instances, "m", _EditorToolbar_addListenersToElement).call(this, button);
                        __classPrivateFieldGet(this, _EditorToolbar_buttons, "f").prepend(button, __classPrivateFieldGet(this, _EditorToolbar_instances, "a", _EditorToolbar_divider_get));
                        return [2 /*return*/];
                }
            });
        });
    };
    EditorToolbar.prototype.updateEditSignatureButton = function (description) {
        if (__classPrivateFieldGet(this, _EditorToolbar_signatureDescriptionButton, "f")) {
            __classPrivateFieldGet(this, _EditorToolbar_signatureDescriptionButton, "f").title = description;
        }
    };
    EditorToolbar.prototype.remove = function () {
        var _g;
        __classPrivateFieldGet(this, _EditorToolbar_toolbar, "f").remove();
        (_g = __classPrivateFieldGet(this, _EditorToolbar_colorPicker, "f")) === null || _g === void 0 ? void 0 : _g.destroy();
        __classPrivateFieldSet(this, _EditorToolbar_colorPicker, null, "f");
    };
    var _EditorToolbar_instances, _f, _EditorToolbar_toolbar, _EditorToolbar_colorPicker, _EditorToolbar_editor, _EditorToolbar_buttons, _EditorToolbar_altText, _EditorToolbar_signatureDescriptionButton, _EditorToolbar_l10nRemove, _EditorToolbar_pointerDown, _EditorToolbar_focusIn, _EditorToolbar_focusOut, _EditorToolbar_addListenersToElement, _EditorToolbar_addDeleteButton, _EditorToolbar_divider_get;
    _f = EditorToolbar, _EditorToolbar_toolbar = new WeakMap(), _EditorToolbar_colorPicker = new WeakMap(), _EditorToolbar_editor = new WeakMap(), _EditorToolbar_buttons = new WeakMap(), _EditorToolbar_altText = new WeakMap(), _EditorToolbar_signatureDescriptionButton = new WeakMap(), _EditorToolbar_instances = new WeakSet(), _EditorToolbar_pointerDown = function _EditorToolbar_pointerDown(e) {
        e.stopPropagation();
    }, _EditorToolbar_focusIn = function _EditorToolbar_focusIn(e) {
        __classPrivateFieldGet(this, _EditorToolbar_editor, "f")._focusEventsAllowed = false;
        stopEvent(e);
    }, _EditorToolbar_focusOut = function _EditorToolbar_focusOut(e) {
        __classPrivateFieldGet(this, _EditorToolbar_editor, "f")._focusEventsAllowed = true;
        stopEvent(e);
    }, _EditorToolbar_addListenersToElement = function _EditorToolbar_addListenersToElement(element) {
        var signal = __classPrivateFieldGet(this, _EditorToolbar_editor, "f")._uiManager._signal;
        element.addEventListener("focusin", __classPrivateFieldGet(this, _EditorToolbar_instances, "m", _EditorToolbar_focusIn).bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("focusout", __classPrivateFieldGet(this, _EditorToolbar_instances, "m", _EditorToolbar_focusOut).bind(this), {
            capture: true,
            signal: signal
        });
        element.addEventListener("contextmenu", noContextMenu, {
            signal: signal
        });
    }, _EditorToolbar_addDeleteButton = function _EditorToolbar_addDeleteButton() {
        var _g = __classPrivateFieldGet(this, _EditorToolbar_editor, "f"), editorType = _g.editorType, _uiManager = _g._uiManager;
        var button = document.createElement("button");
        button.className = "delete";
        button.tabIndex = 0;
        button.setAttribute("data-l10n-id", __classPrivateFieldGet(_f, _f, "f", _EditorToolbar_l10nRemove)[editorType]);
        __classPrivateFieldGet(this, _EditorToolbar_instances, "m", _EditorToolbar_addListenersToElement).call(this, button);
        button.addEventListener("click", function (e) {
            _uiManager.delete();
        }, {
            signal: _uiManager._signal
        });
        __classPrivateFieldGet(this, _EditorToolbar_buttons, "f").append(button);
    }, _EditorToolbar_divider_get = function _EditorToolbar_divider_get() {
        var divider = document.createElement("div");
        divider.className = "divider";
        return divider;
    };
    _EditorToolbar_l10nRemove = { value: null };
    return EditorToolbar;
}());
var HighlightToolbar = /** @class */ (function () {
    function HighlightToolbar(uiManager) {
        _HighlightToolbar_instances.add(this);
        _HighlightToolbar_buttons.set(this, null);
        _HighlightToolbar_toolbar.set(this, null);
        _HighlightToolbar_uiManager.set(this, void 0);
        __classPrivateFieldSet(this, _HighlightToolbar_uiManager, uiManager, "f");
    }
    HighlightToolbar.prototype.show = function (parent, boxes, isLTR) {
        var _g = __read(__classPrivateFieldGet(this, _HighlightToolbar_instances, "m", _HighlightToolbar_getLastPoint).call(this, boxes, isLTR), 2), x = _g[0], y = _g[1];
        var style = __classPrivateFieldSet(this, _HighlightToolbar_toolbar, __classPrivateFieldGet(this, _HighlightToolbar_toolbar, "f") || __classPrivateFieldGet(this, _HighlightToolbar_instances, "m", _HighlightToolbar_render).call(this), "f").style;
        parent.append(__classPrivateFieldGet(this, _HighlightToolbar_toolbar, "f"));
        style.insetInlineEnd = "".concat(100 * x, "%");
        style.top = "calc(".concat(100 * y, "% + var(--editor-toolbar-vert-offset))");
    };
    HighlightToolbar.prototype.hide = function () {
        __classPrivateFieldGet(this, _HighlightToolbar_toolbar, "f").remove();
    };
    return HighlightToolbar;
}());
_HighlightToolbar_buttons = new WeakMap(), _HighlightToolbar_toolbar = new WeakMap(), _HighlightToolbar_uiManager = new WeakMap(), _HighlightToolbar_instances = new WeakSet(), _HighlightToolbar_render = function _HighlightToolbar_render() {
    var editToolbar = __classPrivateFieldSet(this, _HighlightToolbar_toolbar, document.createElement("div"), "f");
    editToolbar.className = "editToolbar";
    editToolbar.setAttribute("role", "toolbar");
    editToolbar.addEventListener("contextmenu", noContextMenu, {
        signal: __classPrivateFieldGet(this, _HighlightToolbar_uiManager, "f")._signal
    });
    var buttons = __classPrivateFieldSet(this, _HighlightToolbar_buttons, document.createElement("div"), "f");
    buttons.className = "buttons";
    editToolbar.append(buttons);
    __classPrivateFieldGet(this, _HighlightToolbar_instances, "m", _HighlightToolbar_addHighlightButton).call(this);
    return editToolbar;
}, _HighlightToolbar_getLastPoint = function _HighlightToolbar_getLastPoint(boxes, isLTR) {
    var e_5, _g;
    var lastY = 0;
    var lastX = 0;
    try {
        for (var boxes_1 = __values(boxes), boxes_1_1 = boxes_1.next(); !boxes_1_1.done; boxes_1_1 = boxes_1.next()) {
            var box = boxes_1_1.value;
            var y = box.y + box.height;
            if (y < lastY) {
                continue;
            }
            var x = box.x + (isLTR ? box.width : 0);
            if (y > lastY) {
                lastX = x;
                lastY = y;
                continue;
            }
            if (isLTR) {
                if (x > lastX) {
                    lastX = x;
                }
            }
            else if (x < lastX) {
                lastX = x;
            }
        }
    }
    catch (e_5_1) { e_5 = { error: e_5_1 }; }
    finally {
        try {
            if (boxes_1_1 && !boxes_1_1.done && (_g = boxes_1.return)) _g.call(boxes_1);
        }
        finally { if (e_5) throw e_5.error; }
    }
    return [isLTR ? 1 - lastX : lastX, lastY];
}, _HighlightToolbar_addHighlightButton = function _HighlightToolbar_addHighlightButton() {
    var _this = this;
    var button = document.createElement("button");
    button.className = "highlightButton";
    button.tabIndex = 0;
    button.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button1");
    var span = document.createElement("span");
    button.append(span);
    span.className = "visuallyHidden";
    span.setAttribute("data-l10n-id", "pdfjs-highlight-floating-button-label");
    var signal = __classPrivateFieldGet(this, _HighlightToolbar_uiManager, "f")._signal;
    button.addEventListener("contextmenu", noContextMenu, {
        signal: signal
    });
    button.addEventListener("click", function () {
        __classPrivateFieldGet(_this, _HighlightToolbar_uiManager, "f").highlightSelection("floating_button");
    }, {
        signal: signal
    });
    __classPrivateFieldGet(this, _HighlightToolbar_buttons, "f").append(button);
};
; // ./src/display/editor/tools.js
function bindEvents(obj, element, names) {
    var e_6, _g;
    try {
        for (var names_1 = __values(names), names_1_1 = names_1.next(); !names_1_1.done; names_1_1 = names_1.next()) {
            var name = names_1_1.value;
            element.addEventListener(name, obj[name].bind(obj));
        }
    }
    catch (e_6_1) { e_6 = { error: e_6_1 }; }
    finally {
        try {
            if (names_1_1 && !names_1_1.done && (_g = names_1.return)) _g.call(names_1);
        }
        finally { if (e_6) throw e_6.error; }
    }
}
var IdManager = /** @class */ (function () {
    function IdManager() {
        _IdManager_id.set(this, 0);
    }
    Object.defineProperty(IdManager.prototype, "id", {
        get: function () {
            var _g, _h;
            return "".concat(AnnotationEditorPrefix).concat((__classPrivateFieldSet(this, _IdManager_id, (_h = __classPrivateFieldGet(this, _IdManager_id, "f"), _g = _h++, _h), "f"), _g));
        },
        enumerable: false,
        configurable: true
    });
    return IdManager;
}());
_IdManager_id = new WeakMap();
var ImageManager = /** @class */ (function () {
    function ImageManager() {
        _ImageManager_instances.add(this);
        _ImageManager_baseId.set(this, getUuid());
        _ImageManager_id.set(this, 0);
        _ImageManager_cache.set(this, null);
    }
    Object.defineProperty(ImageManager, "_isSVGFittingCanvas", {
        get: function () {
            var svg = "data:image/svg+xml;charset=UTF-8,<svg viewBox=\"0 0 1 1\" width=\"1\" height=\"1\" xmlns=\"http://www.w3.org/2000/svg\"><rect width=\"1\" height=\"1\" style=\"fill:red;\"/></svg>";
            var canvas = new OffscreenCanvas(1, 3);
            var ctx = canvas.getContext("2d", {
                willReadFrequently: true
            });
            var image = new Image();
            image.src = svg;
            var promise = image.decode().then(function () {
                ctx.drawImage(image, 0, 0, 1, 1, 0, 0, 1, 3);
                return new Uint32Array(ctx.getImageData(0, 0, 1, 1).data.buffer)[0] === 0;
            });
            return shadow(this, "_isSVGFittingCanvas", promise);
        },
        enumerable: false,
        configurable: true
    });
    ImageManager.prototype.getFromFile = function (file) {
        return __awaiter(this, void 0, void 0, function () {
            var lastModified, name, size, type;
            return __generator(this, function (_g) {
                lastModified = file.lastModified, name = file.name, size = file.size, type = file.type;
                return [2 /*return*/, __classPrivateFieldGet(this, _ImageManager_instances, "m", _ImageManager_get).call(this, "".concat(lastModified, "_").concat(name, "_").concat(size, "_").concat(type), file)];
            });
        });
    };
    ImageManager.prototype.getFromUrl = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_g) {
                return [2 /*return*/, __classPrivateFieldGet(this, _ImageManager_instances, "m", _ImageManager_get).call(this, url, url)];
            });
        });
    };
    ImageManager.prototype.getFromBlob = function (id, blobPromise) {
        return __awaiter(this, void 0, void 0, function () {
            var blob;
            return __generator(this, function (_g) {
                switch (_g.label) {
                    case 0: return [4 /*yield*/, blobPromise];
                    case 1:
                        blob = _g.sent();
                        return [2 /*return*/, __classPrivateFieldGet(this, _ImageManager_instances, "m", _ImageManager_get).call(this, id, blob)];
                }
            });
        });
    };
    ImageManager.prototype.getFromId = function (id) {
        return __awaiter(this, void 0, void 0, function () {
            var data, blobPromise;
            return __generator(this, function (_g) {
                __classPrivateFieldSet(this, _ImageManager_cache, __classPrivateFieldGet(this, _ImageManager_cache, "f") || new Map(), "f");
                data = __classPrivateFieldGet(this, _ImageManager_cache, "f").get(id);
                if (!data) {
                    return [2 /*return*/, null];
                }
                if (data.bitmap) {
                    data.refCounter += 1;
                    return [2 /*return*/, data];
                }
                if (data.file) {
                    return [2 /*return*/, this.getFromFile(data.file)];
                }
                if (data.blobPromise) {
                    blobPromise = data.blobPromise;
                    delete data.blobPromise;
                    return [2 /*return*/, this.getFromBlob(data.id, blobPromise)];
                }
                return [2 /*return*/, this.getFromUrl(data.url)];
            });
        });
    };
    ImageManager.prototype.getFromCanvas = function (id, canvas) {
        var _g, _h;
        __classPrivateFieldSet(this, _ImageManager_cache, __classPrivateFieldGet(this, _ImageManager_cache, "f") || new Map(), "f");
        var data = __classPrivateFieldGet(this, _ImageManager_cache, "f").get(id);
        if (data === null || data === void 0 ? void 0 : data.bitmap) {
            data.refCounter += 1;
            return data;
        }
        var offscreen = new OffscreenCanvas(canvas.width, canvas.height);
        var ctx = offscreen.getContext("2d");
        ctx.drawImage(canvas, 0, 0);
        data = {
            bitmap: offscreen.transferToImageBitmap(),
            id: "image_".concat(__classPrivateFieldGet(this, _ImageManager_baseId, "f"), "_").concat((__classPrivateFieldSet(this, _ImageManager_id, (_h = __classPrivateFieldGet(this, _ImageManager_id, "f"), _g = _h++, _h), "f"), _g)),
            refCounter: 1,
            isSvg: false
        };
        __classPrivateFieldGet(this, _ImageManager_cache, "f").set(id, data);
        __classPrivateFieldGet(this, _ImageManager_cache, "f").set(data.id, data);
        return data;
    };
    ImageManager.prototype.getSvgUrl = function (id) {
        var data = __classPrivateFieldGet(this, _ImageManager_cache, "f").get(id);
        if (!(data === null || data === void 0 ? void 0 : data.isSvg)) {
            return null;
        }
        return data.svgUrl;
    };
    ImageManager.prototype.deleteId = function (id) {
        var _g;
        __classPrivateFieldSet(this, _ImageManager_cache, __classPrivateFieldGet(this, _ImageManager_cache, "f") || new Map(), "f");
        var data = __classPrivateFieldGet(this, _ImageManager_cache, "f").get(id);
        if (!data) {
            return;
        }
        data.refCounter -= 1;
        if (data.refCounter !== 0) {
            return;
        }
        var bitmap = data.bitmap;
        if (!data.url && !data.file) {
            var canvas = new OffscreenCanvas(bitmap.width, bitmap.height);
            var ctx = canvas.getContext("bitmaprenderer");
            ctx.transferFromImageBitmap(bitmap);
            data.blobPromise = canvas.convertToBlob();
        }
        (_g = bitmap.close) === null || _g === void 0 ? void 0 : _g.call(bitmap);
        data.bitmap = null;
    };
    ImageManager.prototype.isValidId = function (id) {
        return id.startsWith("image_".concat(__classPrivateFieldGet(this, _ImageManager_baseId, "f"), "_"));
    };
    return ImageManager;
}());
_c = ImageManager, _ImageManager_baseId = new WeakMap(), _ImageManager_id = new WeakMap(), _ImageManager_cache = new WeakMap(), _ImageManager_instances = new WeakSet(), _ImageManager_get = function _ImageManager_get(key, rawData) {
    return __awaiter(this, void 0, void 0, function () {
        var data, image, mustRemoveAspectRatioPromise_1, fileReader_1, imageElement_1, imagePromise, _g, e_7;
        var _this = this;
        var _h, _j;
        return __generator(this, function (_k) {
            switch (_k.label) {
                case 0:
                    __classPrivateFieldSet(this, _ImageManager_cache, __classPrivateFieldGet(this, _ImageManager_cache, "f") || new Map(), "f");
                    data = __classPrivateFieldGet(this, _ImageManager_cache, "f").get(key);
                    if (data === null) {
                        return [2 /*return*/, null];
                    }
                    if (data === null || data === void 0 ? void 0 : data.bitmap) {
                        data.refCounter += 1;
                        return [2 /*return*/, data];
                    }
                    _k.label = 1;
                case 1:
                    _k.trys.push([1, 9, , 10]);
                    data || (data = {
                        bitmap: null,
                        id: "image_".concat(__classPrivateFieldGet(this, _ImageManager_baseId, "f"), "_").concat((__classPrivateFieldSet(this, _ImageManager_id, (_j = __classPrivateFieldGet(this, _ImageManager_id, "f"), _h = _j++, _j), "f"), _h)),
                        refCounter: 0,
                        isSvg: false
                    });
                    image = void 0;
                    if (!(typeof rawData === "string")) return [3 /*break*/, 3];
                    data.url = rawData;
                    return [4 /*yield*/, fetchData(rawData, "blob")];
                case 2:
                    image = _k.sent();
                    return [3 /*break*/, 4];
                case 3:
                    if (rawData instanceof File) {
                        image = data.file = rawData;
                    }
                    else if (rawData instanceof Blob) {
                        image = rawData;
                    }
                    _k.label = 4;
                case 4:
                    if (!(image.type === "image/svg+xml")) return [3 /*break*/, 6];
                    mustRemoveAspectRatioPromise_1 = _c._isSVGFittingCanvas;
                    fileReader_1 = new FileReader();
                    imageElement_1 = new Image();
                    imagePromise = new Promise(function (resolve, reject) {
                        imageElement_1.onload = function () {
                            data.bitmap = imageElement_1;
                            data.isSvg = true;
                            resolve();
                        };
                        fileReader_1.onload = function () { return __awaiter(_this, void 0, void 0, function () {
                            var url, _g;
                            return __generator(this, function (_h) {
                                switch (_h.label) {
                                    case 0:
                                        url = data.svgUrl = fileReader_1.result;
                                        _g = imageElement_1;
                                        return [4 /*yield*/, mustRemoveAspectRatioPromise_1];
                                    case 1:
                                        _g.src = (_h.sent()) ? "".concat(url, "#svgView(preserveAspectRatio(none))") : url;
                                        return [2 /*return*/];
                                }
                            });
                        }); };
                        imageElement_1.onerror = fileReader_1.onerror = reject;
                    });
                    fileReader_1.readAsDataURL(image);
                    return [4 /*yield*/, imagePromise];
                case 5:
                    _k.sent();
                    return [3 /*break*/, 8];
                case 6:
                    _g = data;
                    return [4 /*yield*/, createImageBitmap(image)];
                case 7:
                    _g.bitmap = _k.sent();
                    _k.label = 8;
                case 8:
                    data.refCounter = 1;
                    return [3 /*break*/, 10];
                case 9:
                    e_7 = _k.sent();
                    warn(e_7);
                    data = null;
                    return [3 /*break*/, 10];
                case 10:
                    __classPrivateFieldGet(this, _ImageManager_cache, "f").set(key, data);
                    if (data) {
                        __classPrivateFieldGet(this, _ImageManager_cache, "f").set(data.id, data);
                    }
                    return [2 /*return*/, data];
            }
        });
    });
};
var CommandManager = /** @class */ (function () {
    function CommandManager(maxSize) {
        if (maxSize === void 0) { maxSize = 128; }
        _CommandManager_commands.set(this, []);
        _CommandManager_locked.set(this, false);
        _CommandManager_maxSize.set(this, void 0);
        _CommandManager_position.set(this, -1);
        __classPrivateFieldSet(this, _CommandManager_maxSize, maxSize, "f");
    }
    CommandManager.prototype.add = function (_g) {
        var cmd = _g.cmd, undo = _g.undo, post = _g.post, mustExec = _g.mustExec, _h = _g.type, type = _h === void 0 ? NaN : _h, _j = _g.overwriteIfSameType, overwriteIfSameType = _j === void 0 ? false : _j, _k = _g.keepUndo, keepUndo = _k === void 0 ? false : _k;
        if (mustExec) {
            cmd();
        }
        if (__classPrivateFieldGet(this, _CommandManager_locked, "f")) {
            return;
        }
        var save = {
            cmd: cmd,
            undo: undo,
            post: post,
            type: type
        };
        if (__classPrivateFieldGet(this, _CommandManager_position, "f") === -1) {
            if (__classPrivateFieldGet(this, _CommandManager_commands, "f").length > 0) {
                __classPrivateFieldGet(this, _CommandManager_commands, "f").length = 0;
            }
            __classPrivateFieldSet(this, _CommandManager_position, 0, "f");
            __classPrivateFieldGet(this, _CommandManager_commands, "f").push(save);
            return;
        }
        if (overwriteIfSameType && __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")].type === type) {
            if (keepUndo) {
                save.undo = __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")].undo;
            }
            __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")] = save;
            return;
        }
        var next = __classPrivateFieldGet(this, _CommandManager_position, "f") + 1;
        if (next === __classPrivateFieldGet(this, _CommandManager_maxSize, "f")) {
            __classPrivateFieldGet(this, _CommandManager_commands, "f").splice(0, 1);
        }
        else {
            __classPrivateFieldSet(this, _CommandManager_position, next, "f");
            if (next < __classPrivateFieldGet(this, _CommandManager_commands, "f").length) {
                __classPrivateFieldGet(this, _CommandManager_commands, "f").splice(next);
            }
        }
        __classPrivateFieldGet(this, _CommandManager_commands, "f").push(save);
    };
    CommandManager.prototype.undo = function () {
        if (__classPrivateFieldGet(this, _CommandManager_position, "f") === -1) {
            return;
        }
        __classPrivateFieldSet(this, _CommandManager_locked, true, "f");
        var _g = __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")], undo = _g.undo, post = _g.post;
        undo();
        post === null || post === void 0 ? void 0 : post();
        __classPrivateFieldSet(this, _CommandManager_locked, false, "f");
        __classPrivateFieldSet(this, _CommandManager_position, __classPrivateFieldGet(this, _CommandManager_position, "f") - 1, "f");
    };
    CommandManager.prototype.redo = function () {
        if (__classPrivateFieldGet(this, _CommandManager_position, "f") < __classPrivateFieldGet(this, _CommandManager_commands, "f").length - 1) {
            __classPrivateFieldSet(this, _CommandManager_position, __classPrivateFieldGet(this, _CommandManager_position, "f") + 1, "f");
            __classPrivateFieldSet(this, _CommandManager_locked, true, "f");
            var _g = __classPrivateFieldGet(this, _CommandManager_commands, "f")[__classPrivateFieldGet(this, _CommandManager_position, "f")], cmd = _g.cmd, post = _g.post;
            cmd();
            post === null || post === void 0 ? void 0 : post();
            __classPrivateFieldSet(this, _CommandManager_locked, false, "f");
        }
    };
    CommandManager.prototype.hasSomethingToUndo = function () {
        return __classPrivateFieldGet(this, _CommandManager_position, "f") !== -1;
    };
    CommandManager.prototype.hasSomethingToRedo = function () {
        return __classPrivateFieldGet(this, _CommandManager_position, "f") < __classPrivateFieldGet(this, _CommandManager_commands, "f").length - 1;
    };
    CommandManager.prototype.cleanType = function (type) {
        if (__classPrivateFieldGet(this, _CommandManager_position, "f") === -1) {
            return;
        }
        for (var i = __classPrivateFieldGet(this, _CommandManager_position, "f"); i >= 0; i--) {
            if (__classPrivateFieldGet(this, _CommandManager_commands, "f")[i].type !== type) {
                __classPrivateFieldGet(this, _CommandManager_commands, "f").splice(i + 1, __classPrivateFieldGet(this, _CommandManager_position, "f") - i);
                __classPrivateFieldSet(this, _CommandManager_position, i, "f");
                return;
            }
        }
        __classPrivateFieldGet(this, _CommandManager_commands, "f").length = 0;
        __classPrivateFieldSet(this, _CommandManager_position, -1, "f");
    };
    CommandManager.prototype.destroy = function () {
        __classPrivateFieldSet(this, _CommandManager_commands, null, "f");
    };
    return CommandManager;
}());
_CommandManager_commands = new WeakMap(), _CommandManager_locked = new WeakMap(), _CommandManager_maxSize = new WeakMap(), _CommandManager_position = new WeakMap();
var KeyboardManager = /** @class */ (function () {
    function KeyboardManager(callbacks) {
        var e_8, _g, e_9, _h;
        _KeyboardManager_instances.add(this);
        this.buffer = [];
        this.callbacks = new Map();
        this.allKeys = new Set();
        var isMac = util_FeatureTest.platform.isMac;
        try {
            for (var callbacks_1 = __values(callbacks), callbacks_1_1 = callbacks_1.next(); !callbacks_1_1.done; callbacks_1_1 = callbacks_1.next()) {
                var _j = __read(callbacks_1_1.value, 3), keys = _j[0], callback = _j[1], _k = _j[2], options = _k === void 0 ? {} : _k;
                try {
                    for (var keys_1 = (e_9 = void 0, __values(keys)), keys_1_1 = keys_1.next(); !keys_1_1.done; keys_1_1 = keys_1.next()) {
                        var key = keys_1_1.value;
                        var isMacKey = key.startsWith("mac+");
                        if (isMac && isMacKey) {
                            this.callbacks.set(key.slice(4), {
                                callback: callback,
                                options: options
                            });
                            this.allKeys.add(key.split("+").at(-1));
                        }
                        else if (!isMac && !isMacKey) {
                            this.callbacks.set(key, {
                                callback: callback,
                                options: options
                            });
                            this.allKeys.add(key.split("+").at(-1));
                        }
                    }
                }
                catch (e_9_1) { e_9 = { error: e_9_1 }; }
                finally {
                    try {
                        if (keys_1_1 && !keys_1_1.done && (_h = keys_1.return)) _h.call(keys_1);
                    }
                    finally { if (e_9) throw e_9.error; }
                }
            }
        }
        catch (e_8_1) { e_8 = { error: e_8_1 }; }
        finally {
            try {
                if (callbacks_1_1 && !callbacks_1_1.done && (_g = callbacks_1.return)) _g.call(callbacks_1);
            }
            finally { if (e_8) throw e_8.error; }
        }
    }
    KeyboardManager.prototype.exec = function (self, event) {
        if (!this.allKeys.has(event.key)) {
            return;
        }
        var info = this.callbacks.get(__classPrivateFieldGet(this, _KeyboardManager_instances, "m", _KeyboardManager_serialize).call(this, event));
        if (!info) {
            return;
        }
        var callback = info.callback, _g = info.options, _h = _g.bubbles, bubbles = _h === void 0 ? false : _h, _j = _g.args, args = _j === void 0 ? [] : _j, _k = _g.checker, checker = _k === void 0 ? null : _k;
        if (checker && !checker(self, event)) {
            return;
        }
        callback.bind.apply(callback, __spreadArray(__spreadArray([self], __read(args), false), [event], false))();
        if (!bubbles) {
            stopEvent(event);
        }
    };
    return KeyboardManager;
}());
_KeyboardManager_instances = new WeakSet(), _KeyboardManager_serialize = function _KeyboardManager_serialize(event) {
    if (event.altKey) {
        this.buffer.push("alt");
    }
    if (event.ctrlKey) {
        this.buffer.push("ctrl");
    }
    if (event.metaKey) {
        this.buffer.push("meta");
    }
    if (event.shiftKey) {
        this.buffer.push("shift");
    }
    this.buffer.push(event.key);
    var str = this.buffer.join("+");
    this.buffer.length = 0;
    return str;
};
var ColorManager = /** @class */ (function () {
    function ColorManager() {
    }
    Object.defineProperty(ColorManager.prototype, "_colors", {
        get: function () {
            var colors = new Map([["CanvasText", null], ["Canvas", null]]);
            getColorValues(colors);
            return shadow(this, "_colors", colors);
        },
        enumerable: false,
        configurable: true
    });
    ColorManager.prototype.convert = function (color) {
        var e_10, _g;
        var rgb = getRGB(color);
        if (!window.matchMedia("(forced-colors: active)").matches) {
            return rgb;
        }
        try {
            for (var _h = __values(this._colors), _j = _h.next(); !_j.done; _j = _h.next()) {
                var _k = __read(_j.value, 2), name = _k[0], RGB = _k[1];
                if (RGB.every(function (x, i) { return x === rgb[i]; })) {
                    return ColorManager._colorsMapping.get(name);
                }
            }
        }
        catch (e_10_1) { e_10 = { error: e_10_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_10) throw e_10.error; }
        }
        return rgb;
    };
    ColorManager.prototype.getHexCode = function (name) {
        var rgb = this._colors.get(name);
        if (!rgb) {
            return name;
        }
        return Util.makeHexColor.apply(Util, __spreadArray([], __read(rgb), false));
    };
    ColorManager._colorsMapping = new Map([["CanvasText", [0, 0, 0]], ["Canvas", [255, 255, 255]]]);
    return ColorManager;
}());
var AnnotationEditorUIManager = /** @class */ (function () {
    function AnnotationEditorUIManager(container, viewer, altTextManager, signatureManager, eventBus, pdfDocument, pageColors, highlightColors, enableHighlightFloatingButton, enableUpdatedAddImage, enableNewAltTextWhenAddingImage, mlManager, editorUndoBar, supportsPinchToZoom) {
        var _this = this;
        _AnnotationEditorUIManager_instances.add(this);
        _AnnotationEditorUIManager_abortController.set(this, new AbortController());
        _AnnotationEditorUIManager_activeEditor.set(this, null);
        _AnnotationEditorUIManager_allEditors.set(this, new Map());
        _AnnotationEditorUIManager_allLayers.set(this, new Map());
        _AnnotationEditorUIManager_altTextManager.set(this, null);
        _AnnotationEditorUIManager_annotationStorage.set(this, null);
        _AnnotationEditorUIManager_changedExistingAnnotations.set(this, null);
        _AnnotationEditorUIManager_commandManager.set(this, new CommandManager());
        _AnnotationEditorUIManager_copyPasteAC.set(this, null);
        _AnnotationEditorUIManager_currentDrawingSession.set(this, null);
        _AnnotationEditorUIManager_currentPageIndex.set(this, 0);
        _AnnotationEditorUIManager_deletedAnnotationsElementIds.set(this, new Set());
        _AnnotationEditorUIManager_draggingEditors.set(this, null);
        _AnnotationEditorUIManager_editorTypes.set(this, null);
        _AnnotationEditorUIManager_editorsToRescale.set(this, new Set());
        this._editorUndoBar = null;
        _AnnotationEditorUIManager_enableHighlightFloatingButton.set(this, false);
        _AnnotationEditorUIManager_enableUpdatedAddImage.set(this, false);
        _AnnotationEditorUIManager_enableNewAltTextWhenAddingImage.set(this, false);
        _AnnotationEditorUIManager_filterFactory.set(this, null);
        _AnnotationEditorUIManager_focusMainContainerTimeoutId.set(this, null);
        _AnnotationEditorUIManager_focusManagerAC.set(this, null);
        _AnnotationEditorUIManager_highlightColors.set(this, null);
        _AnnotationEditorUIManager_highlightWhenShiftUp.set(this, false);
        _AnnotationEditorUIManager_highlightToolbar.set(this, null);
        _AnnotationEditorUIManager_idManager.set(this, new IdManager());
        _AnnotationEditorUIManager_isEnabled.set(this, false);
        _AnnotationEditorUIManager_isWaiting.set(this, false);
        _AnnotationEditorUIManager_keyboardManagerAC.set(this, null);
        _AnnotationEditorUIManager_lastActiveElement.set(this, null);
        _AnnotationEditorUIManager_mainHighlightColorPicker.set(this, null);
        _AnnotationEditorUIManager_missingCanvases.set(this, null);
        _AnnotationEditorUIManager_mlManager.set(this, null);
        _AnnotationEditorUIManager_mode.set(this, AnnotationEditorType.NONE);
        _AnnotationEditorUIManager_selectedEditors.set(this, new Set());
        _AnnotationEditorUIManager_selectedTextNode.set(this, null);
        _AnnotationEditorUIManager_signatureManager.set(this, null);
        _AnnotationEditorUIManager_pageColors.set(this, null);
        _AnnotationEditorUIManager_showAllStates.set(this, null);
        _AnnotationEditorUIManager_previousStates.set(this, {
            isEditing: false,
            isEmpty: true,
            hasSomethingToUndo: false,
            hasSomethingToRedo: false,
            hasSelectedEditor: false,
            hasSelectedText: false
        });
        _AnnotationEditorUIManager_translation.set(this, [0, 0]);
        _AnnotationEditorUIManager_translationTimeoutId.set(this, null);
        _AnnotationEditorUIManager_container.set(this, null);
        _AnnotationEditorUIManager_viewer.set(this, null);
        _AnnotationEditorUIManager_updateModeCapability.set(this, null);
        var signal = this._signal = __classPrivateFieldGet(this, _AnnotationEditorUIManager_abortController, "f").signal;
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_container, container, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_viewer, viewer, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_altTextManager, altTextManager, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_signatureManager, signatureManager, "f");
        this._eventBus = eventBus;
        eventBus._on("editingaction", this.onEditingAction.bind(this), {
            signal: signal
        });
        eventBus._on("pagechanging", this.onPageChanging.bind(this), {
            signal: signal
        });
        eventBus._on("scalechanging", this.onScaleChanging.bind(this), {
            signal: signal
        });
        eventBus._on("rotationchanging", this.onRotationChanging.bind(this), {
            signal: signal
        });
        eventBus._on("setpreference", this.onSetPreference.bind(this), {
            signal: signal
        });
        eventBus._on("switchannotationeditorparams", function (evt) { return _this.updateParams(evt.type, evt.value); }, {
            signal: signal
        });
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addSelectionListener).call(this);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addDragAndDropListeners).call(this);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addKeyboardManager).call(this);
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_annotationStorage, pdfDocument.annotationStorage, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_filterFactory, pdfDocument.filterFactory, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_pageColors, pageColors, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightColors, highlightColors || null, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_enableHighlightFloatingButton, enableHighlightFloatingButton, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_enableUpdatedAddImage, enableUpdatedAddImage, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_enableNewAltTextWhenAddingImage, enableNewAltTextWhenAddingImage, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_mlManager, mlManager || null, "f");
        this.viewParameters = {
            realScale: PixelsPerInch.PDF_TO_CSS_UNITS,
            rotation: 0
        };
        this.isShiftKeyDown = false;
        this._editorUndoBar = editorUndoBar || null;
        this._supportsPinchToZoom = supportsPinchToZoom !== false;
    }
    Object.defineProperty(AnnotationEditorUIManager, "_keyboardManager", {
        get: function () {
            var proto = AnnotationEditorUIManager.prototype;
            var arrowChecker = function (self) { return __classPrivateFieldGet(self, _AnnotationEditorUIManager_container, "f").contains(document.activeElement) && document.activeElement.tagName !== "BUTTON" && self.hasSomethingToControl(); };
            var textInputChecker = function (_self, _g) {
                var el = _g.target;
                if (el instanceof HTMLInputElement) {
                    var type = el.type;
                    return type !== "text" && type !== "number";
                }
                return true;
            };
            var small = this.TRANSLATE_SMALL;
            var big = this.TRANSLATE_BIG;
            return shadow(this, "_keyboardManager", new KeyboardManager([[["ctrl+a", "mac+meta+a"], proto.selectAll, {
                        checker: textInputChecker
                    }], [["ctrl+z", "mac+meta+z"], proto.undo, {
                        checker: textInputChecker
                    }], [["ctrl+y", "ctrl+shift+z", "mac+meta+shift+z", "ctrl+shift+Z", "mac+meta+shift+Z"], proto.redo, {
                        checker: textInputChecker
                    }], [["Backspace", "alt+Backspace", "ctrl+Backspace", "shift+Backspace", "mac+Backspace", "mac+alt+Backspace", "mac+ctrl+Backspace", "Delete", "ctrl+Delete", "shift+Delete", "mac+Delete"], proto.delete, {
                        checker: textInputChecker
                    }], [["Enter", "mac+Enter"], proto.addNewEditorFromKeyboard, {
                        checker: function (self, _g) {
                            var el = _g.target;
                            return !(el instanceof HTMLButtonElement) && __classPrivateFieldGet(self, _AnnotationEditorUIManager_container, "f").contains(el) && !self.isEnterHandled;
                        }
                    }], [[" ", "mac+ "], proto.addNewEditorFromKeyboard, {
                        checker: function (self, _g) {
                            var el = _g.target;
                            return !(el instanceof HTMLButtonElement) && __classPrivateFieldGet(self, _AnnotationEditorUIManager_container, "f").contains(document.activeElement);
                        }
                    }], [["Escape", "mac+Escape"], proto.unselectAll], [["ArrowLeft", "mac+ArrowLeft"], proto.translateSelectedEditors, {
                        args: [-small, 0],
                        checker: arrowChecker
                    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto.translateSelectedEditors, {
                        args: [-big, 0],
                        checker: arrowChecker
                    }], [["ArrowRight", "mac+ArrowRight"], proto.translateSelectedEditors, {
                        args: [small, 0],
                        checker: arrowChecker
                    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto.translateSelectedEditors, {
                        args: [big, 0],
                        checker: arrowChecker
                    }], [["ArrowUp", "mac+ArrowUp"], proto.translateSelectedEditors, {
                        args: [0, -small],
                        checker: arrowChecker
                    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto.translateSelectedEditors, {
                        args: [0, -big],
                        checker: arrowChecker
                    }], [["ArrowDown", "mac+ArrowDown"], proto.translateSelectedEditors, {
                        args: [0, small],
                        checker: arrowChecker
                    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto.translateSelectedEditors, {
                        args: [0, big],
                        checker: arrowChecker
                    }]]));
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.destroy = function () {
        var e_11, _g;
        var _h, _j, _k, _l, _m, _o, _p, _q;
        (_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_updateModeCapability, "f")) === null || _h === void 0 ? void 0 : _h.resolve();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_updateModeCapability, null, "f");
        (_j = __classPrivateFieldGet(this, _AnnotationEditorUIManager_abortController, "f")) === null || _j === void 0 ? void 0 : _j.abort();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_abortController, null, "f");
        this._signal = null;
        try {
            for (var _r = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()), _s = _r.next(); !_s.done; _s = _r.next()) {
                var layer = _s.value;
                layer.destroy();
            }
        }
        catch (e_11_1) { e_11 = { error: e_11_1 }; }
        finally {
            try {
                if (_s && !_s.done && (_g = _r.return)) _g.call(_r);
            }
            finally { if (e_11) throw e_11.error; }
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").clear();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").clear();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f").clear();
        (_k = __classPrivateFieldGet(this, _AnnotationEditorUIManager_missingCanvases, "f")) === null || _k === void 0 ? void 0 : _k.clear();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_activeEditor, null, "f");
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").destroy();
        (_l = __classPrivateFieldGet(this, _AnnotationEditorUIManager_altTextManager, "f")) === null || _l === void 0 ? void 0 : _l.destroy();
        (_m = __classPrivateFieldGet(this, _AnnotationEditorUIManager_signatureManager, "f")) === null || _m === void 0 ? void 0 : _m.destroy();
        (_o = __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f")) === null || _o === void 0 ? void 0 : _o.hide();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightToolbar, null, "f");
        (_p = __classPrivateFieldGet(this, _AnnotationEditorUIManager_mainHighlightColorPicker, "f")) === null || _p === void 0 ? void 0 : _p.destroy();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_mainHighlightColorPicker, null, "f");
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f"));
            __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, null, "f");
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f"));
            __classPrivateFieldSet(this, _AnnotationEditorUIManager_translationTimeoutId, null, "f");
        }
        (_q = this._editorUndoBar) === null || _q === void 0 ? void 0 : _q.destroy();
    };
    AnnotationEditorUIManager.prototype.combinedSignal = function (ac) {
        return AbortSignal.any([this._signal, ac.signal]);
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "mlManager", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_mlManager, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorUIManager.prototype, "useNewAltTextFlow", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_enableUpdatedAddImage, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorUIManager.prototype, "useNewAltTextWhenAddingImage", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_enableNewAltTextWhenAddingImage, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorUIManager.prototype, "hcmFilter", {
        get: function () {
            return shadow(this, "hcmFilter", __classPrivateFieldGet(this, _AnnotationEditorUIManager_pageColors, "f") ? __classPrivateFieldGet(this, _AnnotationEditorUIManager_filterFactory, "f").addHCMFilter(__classPrivateFieldGet(this, _AnnotationEditorUIManager_pageColors, "f").foreground, __classPrivateFieldGet(this, _AnnotationEditorUIManager_pageColors, "f").background) : "none");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorUIManager.prototype, "direction", {
        get: function () {
            return shadow(this, "direction", getComputedStyle(__classPrivateFieldGet(this, _AnnotationEditorUIManager_container, "f")).direction);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorUIManager.prototype, "highlightColors", {
        get: function () {
            return shadow(this, "highlightColors", __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightColors, "f") ? new Map(__classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightColors, "f").split(",").map(function (pair) { return pair.split("=").map(function (x) { return x.trim(); }); })) : null);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorUIManager.prototype, "highlightColorNames", {
        get: function () {
            return shadow(this, "highlightColorNames", this.highlightColors ? new Map(Array.from(this.highlightColors, function (e) { return e.reverse(); })) : null);
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.setCurrentDrawingSession = function (layer) {
        if (layer) {
            this.unselectAll();
            this.disableUserSelect(true);
        }
        else {
            this.disableUserSelect(false);
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_currentDrawingSession, layer, "f");
    };
    AnnotationEditorUIManager.prototype.setMainHighlightColorPicker = function (colorPicker) {
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_mainHighlightColorPicker, colorPicker, "f");
    };
    AnnotationEditorUIManager.prototype.editAltText = function (editor, firstTime) {
        var _g;
        if (firstTime === void 0) { firstTime = false; }
        (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_altTextManager, "f")) === null || _g === void 0 ? void 0 : _g.editAltText(this, editor, firstTime);
    };
    AnnotationEditorUIManager.prototype.getSignature = function (editor) {
        var _g;
        (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_signatureManager, "f")) === null || _g === void 0 ? void 0 : _g.getSignature({
            uiManager: this,
            editor: editor
        });
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "signatureManager", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_signatureManager, "f");
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.switchToMode = function (mode, callback) {
        this._eventBus.on("annotationeditormodechanged", callback, {
            once: true,
            signal: this._signal
        });
        this._eventBus.dispatch("showannotationeditorui", {
            source: this,
            mode: mode
        });
    };
    AnnotationEditorUIManager.prototype.setPreference = function (name, value) {
        this._eventBus.dispatch("setpreference", {
            source: this,
            name: name,
            value: value
        });
    };
    AnnotationEditorUIManager.prototype.onSetPreference = function (_g) {
        var name = _g.name, value = _g.value;
        switch (name) {
            case "enableNewAltTextWhenAddingImage":
                __classPrivateFieldSet(this, _AnnotationEditorUIManager_enableNewAltTextWhenAddingImage, value, "f");
                break;
        }
    };
    AnnotationEditorUIManager.prototype.onPageChanging = function (_g) {
        var pageNumber = _g.pageNumber;
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_currentPageIndex, pageNumber - 1, "f");
    };
    AnnotationEditorUIManager.prototype.focusMainContainer = function () {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_container, "f").focus();
    };
    AnnotationEditorUIManager.prototype.findParent = function (x, y) {
        var e_12, _g;
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()), _j = _h.next(); !_j.done; _j = _h.next()) {
                var layer = _j.value;
                var _k = layer.div.getBoundingClientRect(), layerX = _k.x, layerY = _k.y, width = _k.width, height = _k.height;
                if (x >= layerX && x <= layerX + width && y >= layerY && y <= layerY + height) {
                    return layer;
                }
            }
        }
        catch (e_12_1) { e_12 = { error: e_12_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_12) throw e_12.error; }
        }
        return null;
    };
    AnnotationEditorUIManager.prototype.disableUserSelect = function (value) {
        if (value === void 0) { value = false; }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_viewer, "f").classList.toggle("noUserSelect", value);
    };
    AnnotationEditorUIManager.prototype.addShouldRescale = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f").add(editor);
    };
    AnnotationEditorUIManager.prototype.removeShouldRescale = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f").delete(editor);
    };
    AnnotationEditorUIManager.prototype.onScaleChanging = function (_g) {
        var e_13, _h;
        var _j;
        var scale = _g.scale;
        this.commitOrRemove();
        this.viewParameters.realScale = scale * PixelsPerInch.PDF_TO_CSS_UNITS;
        try {
            for (var _k = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorsToRescale, "f")), _l = _k.next(); !_l.done; _l = _k.next()) {
                var editor = _l.value;
                editor.onScaleChanging();
            }
        }
        catch (e_13_1) { e_13 = { error: e_13_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_h = _k.return)) _h.call(_k);
            }
            finally { if (e_13) throw e_13.error; }
        }
        (_j = __classPrivateFieldGet(this, _AnnotationEditorUIManager_currentDrawingSession, "f")) === null || _j === void 0 ? void 0 : _j.onScaleChanging();
    };
    AnnotationEditorUIManager.prototype.onRotationChanging = function (_g) {
        var pagesRotation = _g.pagesRotation;
        this.commitOrRemove();
        this.viewParameters.rotation = pagesRotation;
    };
    AnnotationEditorUIManager.prototype.highlightSelection = function (methodOfCreation) {
        var _this = this;
        if (methodOfCreation === void 0) { methodOfCreation = ""; }
        var selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            return;
        }
        var anchorNode = selection.anchorNode, anchorOffset = selection.anchorOffset, focusNode = selection.focusNode, focusOffset = selection.focusOffset;
        var text = selection.toString();
        var anchorElement = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getAnchorElementForSelection).call(this, selection);
        var textLayer = anchorElement.closest(".textLayer");
        var boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) {
            return;
        }
        selection.empty();
        var layer = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getLayerForTextLayer).call(this, textLayer);
        var isNoneMode = __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === AnnotationEditorType.NONE;
        var callback = function () {
            layer === null || layer === void 0 ? void 0 : layer.createAndAddNewEditor({
                x: 0,
                y: 0
            }, false, {
                methodOfCreation: methodOfCreation,
                boxes: boxes,
                anchorNode: anchorNode,
                anchorOffset: anchorOffset,
                focusNode: focusNode,
                focusOffset: focusOffset,
                text: text
            });
            if (isNoneMode) {
                _this.showAllEditors("highlight", true, true);
            }
        };
        if (isNoneMode) {
            this.switchToMode(AnnotationEditorType.HIGHLIGHT, callback);
            return;
        }
        callback();
    };
    AnnotationEditorUIManager.prototype.addToAnnotationStorage = function (editor) {
        if (!editor.isEmpty() && __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f") && !__classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f").has(editor.id)) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f").setValue(editor.id, editor);
        }
    };
    AnnotationEditorUIManager.prototype.blur = function () {
        var e_14, _g;
        this.isShiftKeyDown = false;
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightWhenShiftUp, "f")) {
            __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightWhenShiftUp, false, "f");
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_onSelectEnd).call(this, "main_toolbar");
        }
        if (!this.hasSelection) {
            return;
        }
        var activeElement = document.activeElement;
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _j = _h.next(); !_j.done; _j = _h.next()) {
                var editor = _j.value;
                if (editor.div.contains(activeElement)) {
                    __classPrivateFieldSet(this, _AnnotationEditorUIManager_lastActiveElement, [editor, activeElement], "f");
                    editor._focusEventsAllowed = false;
                    break;
                }
            }
        }
        catch (e_14_1) { e_14 = { error: e_14_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_14) throw e_14.error; }
        }
    };
    AnnotationEditorUIManager.prototype.focus = function () {
        if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_lastActiveElement, "f")) {
            return;
        }
        var _g = __read(__classPrivateFieldGet(this, _AnnotationEditorUIManager_lastActiveElement, "f"), 2), lastEditor = _g[0], lastActiveElement = _g[1];
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_lastActiveElement, null, "f");
        lastActiveElement.addEventListener("focusin", function () {
            lastEditor._focusEventsAllowed = true;
        }, {
            once: true,
            signal: this._signal
        });
        lastActiveElement.focus();
    };
    AnnotationEditorUIManager.prototype.addEditListeners = function () {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addKeyboardManager).call(this);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addCopyPasteListeners).call(this);
    };
    AnnotationEditorUIManager.prototype.removeEditListeners = function () {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeKeyboardManager).call(this);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeCopyPasteListeners).call(this);
    };
    AnnotationEditorUIManager.prototype.dragOver = function (event) {
        var e_15, _g, e_16, _h;
        try {
            for (var _j = __values(event.dataTransfer.items), _k = _j.next(); !_k.done; _k = _j.next()) {
                var type = _k.value.type;
                try {
                    for (var _l = (e_16 = void 0, __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f"))), _m = _l.next(); !_m.done; _m = _l.next()) {
                        var editorType = _m.value;
                        if (editorType.isHandlingMimeForPasting(type)) {
                            event.dataTransfer.dropEffect = "copy";
                            event.preventDefault();
                            return;
                        }
                    }
                }
                catch (e_16_1) { e_16 = { error: e_16_1 }; }
                finally {
                    try {
                        if (_m && !_m.done && (_h = _l.return)) _h.call(_l);
                    }
                    finally { if (e_16) throw e_16.error; }
                }
            }
        }
        catch (e_15_1) { e_15 = { error: e_15_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
            }
            finally { if (e_15) throw e_15.error; }
        }
    };
    AnnotationEditorUIManager.prototype.drop = function (event) {
        var e_17, _g, e_18, _h;
        try {
            for (var _j = __values(event.dataTransfer.items), _k = _j.next(); !_k.done; _k = _j.next()) {
                var item = _k.value;
                try {
                    for (var _l = (e_18 = void 0, __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f"))), _m = _l.next(); !_m.done; _m = _l.next()) {
                        var editorType = _m.value;
                        if (editorType.isHandlingMimeForPasting(item.type)) {
                            editorType.paste(item, this.currentLayer);
                            event.preventDefault();
                            return;
                        }
                    }
                }
                catch (e_18_1) { e_18 = { error: e_18_1 }; }
                finally {
                    try {
                        if (_m && !_m.done && (_h = _l.return)) _h.call(_l);
                    }
                    finally { if (e_18) throw e_18.error; }
                }
            }
        }
        catch (e_17_1) { e_17 = { error: e_17_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
            }
            finally { if (e_17) throw e_17.error; }
        }
    };
    AnnotationEditorUIManager.prototype.copy = function (event) {
        var e_19, _g;
        var _h;
        event.preventDefault();
        (_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f")) === null || _h === void 0 ? void 0 : _h.commitOrRemove();
        if (!this.hasSelection) {
            return;
        }
        var editors = [];
        try {
            for (var _j = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _k = _j.next(); !_k.done; _k = _j.next()) {
                var editor = _k.value;
                var serialized = editor.serialize(true);
                if (serialized) {
                    editors.push(serialized);
                }
            }
        }
        catch (e_19_1) { e_19 = { error: e_19_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
            }
            finally { if (e_19) throw e_19.error; }
        }
        if (editors.length === 0) {
            return;
        }
        event.clipboardData.setData("application/pdfjs", JSON.stringify(editors));
    };
    AnnotationEditorUIManager.prototype.cut = function (event) {
        this.copy(event);
        this.delete();
    };
    AnnotationEditorUIManager.prototype.paste = function (event) {
        return __awaiter(this, void 0, void 0, function () {
            var clipboardData, _g, _h, item, _j, _k, editorType, data, layer, newEditors_1, data_1, data_1_1, editor, deserializedEditor, e_20_1, cmd, undo, ex_1;
            var e_21, _l, e_22, _m, e_20, _o;
            var _this = this;
            return __generator(this, function (_p) {
                switch (_p.label) {
                    case 0:
                        event.preventDefault();
                        clipboardData = event.clipboardData;
                        try {
                            for (_g = __values(clipboardData.items), _h = _g.next(); !_h.done; _h = _g.next()) {
                                item = _h.value;
                                try {
                                    for (_j = (e_22 = void 0, __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f"))), _k = _j.next(); !_k.done; _k = _j.next()) {
                                        editorType = _k.value;
                                        if (editorType.isHandlingMimeForPasting(item.type)) {
                                            editorType.paste(item, this.currentLayer);
                                            return [2 /*return*/];
                                        }
                                    }
                                }
                                catch (e_22_1) { e_22 = { error: e_22_1 }; }
                                finally {
                                    try {
                                        if (_k && !_k.done && (_m = _j.return)) _m.call(_j);
                                    }
                                    finally { if (e_22) throw e_22.error; }
                                }
                            }
                        }
                        catch (e_21_1) { e_21 = { error: e_21_1 }; }
                        finally {
                            try {
                                if (_h && !_h.done && (_l = _g.return)) _l.call(_g);
                            }
                            finally { if (e_21) throw e_21.error; }
                        }
                        data = clipboardData.getData("application/pdfjs");
                        if (!data) {
                            return [2 /*return*/];
                        }
                        try {
                            data = JSON.parse(data);
                        }
                        catch (ex) {
                            warn("paste: \"".concat(ex.message, "\"."));
                            return [2 /*return*/];
                        }
                        if (!Array.isArray(data)) {
                            return [2 /*return*/];
                        }
                        this.unselectAll();
                        layer = this.currentLayer;
                        _p.label = 1;
                    case 1:
                        _p.trys.push([1, 10, , 11]);
                        newEditors_1 = [];
                        _p.label = 2;
                    case 2:
                        _p.trys.push([2, 7, 8, 9]);
                        data_1 = __values(data), data_1_1 = data_1.next();
                        _p.label = 3;
                    case 3:
                        if (!!data_1_1.done) return [3 /*break*/, 6];
                        editor = data_1_1.value;
                        return [4 /*yield*/, layer.deserialize(editor)];
                    case 4:
                        deserializedEditor = _p.sent();
                        if (!deserializedEditor) {
                            return [2 /*return*/];
                        }
                        newEditors_1.push(deserializedEditor);
                        _p.label = 5;
                    case 5:
                        data_1_1 = data_1.next();
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 9];
                    case 7:
                        e_20_1 = _p.sent();
                        e_20 = { error: e_20_1 };
                        return [3 /*break*/, 9];
                    case 8:
                        try {
                            if (data_1_1 && !data_1_1.done && (_o = data_1.return)) _o.call(data_1);
                        }
                        finally { if (e_20) throw e_20.error; }
                        return [7 /*endfinally*/];
                    case 9:
                        cmd = function () {
                            var e_23, _g;
                            try {
                                for (var newEditors_2 = __values(newEditors_1), newEditors_2_1 = newEditors_2.next(); !newEditors_2_1.done; newEditors_2_1 = newEditors_2.next()) {
                                    var editor = newEditors_2_1.value;
                                    __classPrivateFieldGet(_this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addEditorToLayer).call(_this, editor);
                                }
                            }
                            catch (e_23_1) { e_23 = { error: e_23_1 }; }
                            finally {
                                try {
                                    if (newEditors_2_1 && !newEditors_2_1.done && (_g = newEditors_2.return)) _g.call(newEditors_2);
                                }
                                finally { if (e_23) throw e_23.error; }
                            }
                            __classPrivateFieldGet(_this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_selectEditors).call(_this, newEditors_1);
                        };
                        undo = function () {
                            var e_24, _g;
                            try {
                                for (var newEditors_3 = __values(newEditors_1), newEditors_3_1 = newEditors_3.next(); !newEditors_3_1.done; newEditors_3_1 = newEditors_3.next()) {
                                    var editor = newEditors_3_1.value;
                                    editor.remove();
                                }
                            }
                            catch (e_24_1) { e_24 = { error: e_24_1 }; }
                            finally {
                                try {
                                    if (newEditors_3_1 && !newEditors_3_1.done && (_g = newEditors_3.return)) _g.call(newEditors_3);
                                }
                                finally { if (e_24) throw e_24.error; }
                            }
                        };
                        this.addCommands({
                            cmd: cmd,
                            undo: undo,
                            mustExec: true
                        });
                        return [3 /*break*/, 11];
                    case 10:
                        ex_1 = _p.sent();
                        warn("paste: \"".concat(ex_1.message, "\"."));
                        return [3 /*break*/, 11];
                    case 11: return [2 /*return*/];
                }
            });
        });
    };
    AnnotationEditorUIManager.prototype.keydown = function (event) {
        if (!this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = true;
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== AnnotationEditorType.NONE && !this.isEditorHandlingKeyboard) {
            AnnotationEditorUIManager._keyboardManager.exec(this, event);
        }
    };
    AnnotationEditorUIManager.prototype.keyup = function (event) {
        if (this.isShiftKeyDown && event.key === "Shift") {
            this.isShiftKeyDown = false;
            if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightWhenShiftUp, "f")) {
                __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightWhenShiftUp, false, "f");
                __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_onSelectEnd).call(this, "main_toolbar");
            }
        }
    };
    AnnotationEditorUIManager.prototype.onEditingAction = function (_g) {
        var name = _g.name;
        switch (name) {
            case "undo":
            case "redo":
            case "delete":
            case "selectAll":
                this[name]();
                break;
            case "highlightSelection":
                this.highlightSelection("context_menu");
                break;
        }
    };
    AnnotationEditorUIManager.prototype.setEditingState = function (isEditing) {
        if (isEditing) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addFocusManager).call(this);
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addCopyPasteListeners).call(this);
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                isEditing: __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== AnnotationEditorType.NONE,
                isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this),
                hasSomethingToUndo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToUndo(),
                hasSomethingToRedo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToRedo(),
                hasSelectedEditor: false
            });
        }
        else {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeFocusManager).call(this);
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_removeCopyPasteListeners).call(this);
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                isEditing: false
            });
            this.disableUserSelect(false);
        }
    };
    AnnotationEditorUIManager.prototype.registerEditorTypes = function (types) {
        var e_25, _g;
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_editorTypes, types, "f");
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")), _j = _h.next(); !_j.done; _j = _h.next()) {
                var editorType = _j.value;
                __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editorType.defaultPropertiesToUpdate);
            }
        }
        catch (e_25_1) { e_25 = { error: e_25_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_25) throw e_25.error; }
        }
    };
    AnnotationEditorUIManager.prototype.getId = function () {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_idManager, "f").id;
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "currentLayer", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").get(__classPrivateFieldGet(this, _AnnotationEditorUIManager_currentPageIndex, "f"));
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.getLayer = function (pageIndex) {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").get(pageIndex);
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "currentPageIndex", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_currentPageIndex, "f");
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.addLayer = function (layer) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").set(layer.pageIndex, layer);
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_isEnabled, "f")) {
            layer.enable();
        }
        else {
            layer.disable();
        }
    };
    AnnotationEditorUIManager.prototype.removeLayer = function (layer) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").delete(layer.pageIndex);
    };
    AnnotationEditorUIManager.prototype.updateMode = function (mode_1) {
        return __awaiter(this, arguments, void 0, function (mode, editId, isFromKeyboard) {
            var _g, _h, layer, _j, _k, editor;
            var e_26, _l, e_27, _m;
            var _o, _p, _q;
            if (editId === void 0) { editId = null; }
            if (isFromKeyboard === void 0) { isFromKeyboard = false; }
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === mode) {
                            return [2 /*return*/];
                        }
                        if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_updateModeCapability, "f")) return [3 /*break*/, 2];
                        return [4 /*yield*/, __classPrivateFieldGet(this, _AnnotationEditorUIManager_updateModeCapability, "f").promise];
                    case 1:
                        _r.sent();
                        if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_updateModeCapability, "f")) {
                            return [2 /*return*/];
                        }
                        _r.label = 2;
                    case 2:
                        __classPrivateFieldSet(this, _AnnotationEditorUIManager_updateModeCapability, Promise.withResolvers(), "f");
                        (_o = __classPrivateFieldGet(this, _AnnotationEditorUIManager_currentDrawingSession, "f")) === null || _o === void 0 ? void 0 : _o.commitOrRemove();
                        __classPrivateFieldSet(this, _AnnotationEditorUIManager_mode, mode, "f");
                        if (mode === AnnotationEditorType.NONE) {
                            this.setEditingState(false);
                            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_disableAll).call(this);
                            (_p = this._editorUndoBar) === null || _p === void 0 ? void 0 : _p.hide();
                            __classPrivateFieldGet(this, _AnnotationEditorUIManager_updateModeCapability, "f").resolve();
                            return [2 /*return*/];
                        }
                        if (!(mode === AnnotationEditorType.SIGNATURE)) return [3 /*break*/, 4];
                        return [4 /*yield*/, ((_q = __classPrivateFieldGet(this, _AnnotationEditorUIManager_signatureManager, "f")) === null || _q === void 0 ? void 0 : _q.loadSignatures())];
                    case 3:
                        _r.sent();
                        _r.label = 4;
                    case 4:
                        this.setEditingState(true);
                        return [4 /*yield*/, __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_enableAll).call(this)];
                    case 5:
                        _r.sent();
                        this.unselectAll();
                        try {
                            for (_g = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()), _h = _g.next(); !_h.done; _h = _g.next()) {
                                layer = _h.value;
                                layer.updateMode(mode);
                            }
                        }
                        catch (e_26_1) { e_26 = { error: e_26_1 }; }
                        finally {
                            try {
                                if (_h && !_h.done && (_l = _g.return)) _l.call(_g);
                            }
                            finally { if (e_26) throw e_26.error; }
                        }
                        if (!editId) {
                            if (isFromKeyboard) {
                                this.addNewEditorFromKeyboard();
                            }
                            __classPrivateFieldGet(this, _AnnotationEditorUIManager_updateModeCapability, "f").resolve();
                            return [2 /*return*/];
                        }
                        try {
                            for (_j = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()), _k = _j.next(); !_k.done; _k = _j.next()) {
                                editor = _k.value;
                                if (editor.annotationElementId === editId) {
                                    this.setSelected(editor);
                                    editor.enterInEditMode();
                                }
                                else {
                                    editor.unselect();
                                }
                            }
                        }
                        catch (e_27_1) { e_27 = { error: e_27_1 }; }
                        finally {
                            try {
                                if (_k && !_k.done && (_m = _j.return)) _m.call(_j);
                            }
                            finally { if (e_27) throw e_27.error; }
                        }
                        __classPrivateFieldGet(this, _AnnotationEditorUIManager_updateModeCapability, "f").resolve();
                        return [2 /*return*/];
                }
            });
        });
    };
    AnnotationEditorUIManager.prototype.addNewEditorFromKeyboard = function () {
        if (this.currentLayer.canCreateNewEmptyEditor()) {
            this.currentLayer.addNewEditor();
        }
    };
    AnnotationEditorUIManager.prototype.updateToolbar = function (mode) {
        if (mode === __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f")) {
            return;
        }
        this._eventBus.dispatch("switchannotationeditormode", {
            source: this,
            mode: mode
        });
    };
    AnnotationEditorUIManager.prototype.updateParams = function (type, value) {
        var e_28, _g, e_29, _h;
        var _j;
        if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")) {
            return;
        }
        switch (type) {
            case AnnotationEditorParamsType.CREATE:
                this.currentLayer.addNewEditor(value);
                return;
            case AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
                (_j = __classPrivateFieldGet(this, _AnnotationEditorUIManager_mainHighlightColorPicker, "f")) === null || _j === void 0 ? void 0 : _j.updateColor(value);
                break;
            case AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL:
                this._eventBus.dispatch("reporttelemetry", {
                    source: this,
                    details: {
                        type: "editing",
                        data: {
                            type: "highlight",
                            action: "toggle_visibility"
                        }
                    }
                });
                (__classPrivateFieldSet(this, _AnnotationEditorUIManager_showAllStates, __classPrivateFieldGet(this, _AnnotationEditorUIManager_showAllStates, "f") || new Map(), "f")).set(type, value);
                this.showAllEditors("highlight", value);
                break;
        }
        try {
            for (var _k = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _l = _k.next(); !_l.done; _l = _k.next()) {
                var editor = _l.value;
                editor.updateParams(type, value);
            }
        }
        catch (e_28_1) { e_28 = { error: e_28_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_g = _k.return)) _g.call(_k);
            }
            finally { if (e_28) throw e_28.error; }
        }
        try {
            for (var _m = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_editorTypes, "f")), _o = _m.next(); !_o.done; _o = _m.next()) {
                var editorType = _o.value;
                editorType.updateDefaultParams(type, value);
            }
        }
        catch (e_29_1) { e_29 = { error: e_29_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_h = _m.return)) _h.call(_m);
            }
            finally { if (e_29) throw e_29.error; }
        }
    };
    AnnotationEditorUIManager.prototype.showAllEditors = function (type, visible, updateButton) {
        var e_30, _g;
        var _h, _j;
        if (updateButton === void 0) { updateButton = false; }
        try {
            for (var _k = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()), _l = _k.next(); !_l.done; _l = _k.next()) {
                var editor = _l.value;
                if (editor.editorType === type) {
                    editor.show(visible);
                }
            }
        }
        catch (e_30_1) { e_30 = { error: e_30_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_g = _k.return)) _g.call(_k);
            }
            finally { if (e_30) throw e_30.error; }
        }
        var state = (_j = (_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_showAllStates, "f")) === null || _h === void 0 ? void 0 : _h.get(AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL)) !== null && _j !== void 0 ? _j : true;
        if (state !== visible) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, [[AnnotationEditorParamsType.HIGHLIGHT_SHOW_ALL, visible]]);
        }
    };
    AnnotationEditorUIManager.prototype.enableWaiting = function (mustWait) {
        var e_31, _g;
        if (mustWait === void 0) { mustWait = false; }
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_isWaiting, "f") === mustWait) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_isWaiting, mustWait, "f");
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()), _j = _h.next(); !_j.done; _j = _h.next()) {
                var layer = _j.value;
                if (mustWait) {
                    layer.disableClick();
                }
                else {
                    layer.enableClick();
                }
                layer.div.classList.toggle("waiting", mustWait);
            }
        }
        catch (e_31_1) { e_31 = { error: e_31_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_31) throw e_31.error; }
        }
    };
    AnnotationEditorUIManager.prototype.getEditors = function (pageIndex) {
        var e_32, _g;
        var editors = [];
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()), _j = _h.next(); !_j.done; _j = _h.next()) {
                var editor = _j.value;
                if (editor.pageIndex === pageIndex) {
                    editors.push(editor);
                }
            }
        }
        catch (e_32_1) { e_32 = { error: e_32_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_32) throw e_32.error; }
        }
        return editors;
    };
    AnnotationEditorUIManager.prototype.getEditor = function (id) {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").get(id);
    };
    AnnotationEditorUIManager.prototype.addEditor = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").set(editor.id, editor);
    };
    AnnotationEditorUIManager.prototype.removeEditor = function (editor) {
        var _this = this;
        var _g, _h;
        if (editor.div.contains(document.activeElement)) {
            if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f")) {
                clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, "f"));
            }
            __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, setTimeout(function () {
                _this.focusMainContainer();
                __classPrivateFieldSet(_this, _AnnotationEditorUIManager_focusMainContainerTimeoutId, null, "f");
            }, 0), "f");
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").delete(editor.id);
        if (editor.annotationElementId) {
            (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_missingCanvases, "f")) === null || _g === void 0 ? void 0 : _g.delete(editor.annotationElementId);
        }
        this.unselect(editor);
        if (!editor.annotationElementId || !__classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").has(editor.annotationElementId)) {
            (_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f")) === null || _h === void 0 ? void 0 : _h.remove(editor.id);
        }
    };
    AnnotationEditorUIManager.prototype.addDeletedAnnotationElement = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").add(editor.annotationElementId);
        this.addChangedExistingAnnotation(editor);
        editor.deleted = true;
    };
    AnnotationEditorUIManager.prototype.isDeletedAnnotationElement = function (annotationElementId) {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").has(annotationElementId);
    };
    AnnotationEditorUIManager.prototype.removeDeletedAnnotationElement = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_deletedAnnotationsElementIds, "f").delete(editor.annotationElementId);
        this.removeChangedExistingAnnotation(editor);
        editor.deleted = false;
    };
    AnnotationEditorUIManager.prototype.setActiveEditor = function (editor) {
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f") === editor) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_activeEditor, editor, "f");
        if (editor) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
        }
    };
    AnnotationEditorUIManager.prototype.updateUI = function (editor) {
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "a", _AnnotationEditorUIManager_lastSelectedEditor_get) === editor) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
        }
    };
    AnnotationEditorUIManager.prototype.updateUIForDefaultProperties = function (editorType) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editorType.defaultPropertiesToUpdate);
    };
    AnnotationEditorUIManager.prototype.toggleSelected = function (editor) {
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").has(editor)) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").delete(editor);
            editor.unselect();
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                hasSelectedEditor: this.hasSelection
            });
            return;
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").add(editor);
        editor.select();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSelectedEditor: true
        });
    };
    AnnotationEditorUIManager.prototype.setSelected = function (editor) {
        var e_33, _g;
        var _h;
        (_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_currentDrawingSession, "f")) === null || _h === void 0 ? void 0 : _h.commitOrRemove();
        try {
            for (var _j = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _k = _j.next(); !_k.done; _k = _j.next()) {
                var ed = _k.value;
                if (ed !== editor) {
                    ed.unselect();
                }
            }
        }
        catch (e_33_1) { e_33 = { error: e_33_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
            }
            finally { if (e_33) throw e_33.error; }
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").add(editor);
        editor.select();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, editor.propertiesToUpdate);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSelectedEditor: true
        });
    };
    AnnotationEditorUIManager.prototype.isSelected = function (editor) {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").has(editor);
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "firstSelectedEditor", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").values().next().value;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.unselect = function (editor) {
        editor.unselect();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").delete(editor);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSelectedEditor: this.hasSelection
        });
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "hasSelection", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").size !== 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorUIManager.prototype, "isEnterHandled", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").size === 1 && this.firstSelectedEditor.isEnterHandled;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.undo = function () {
        var _g;
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").undo();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSomethingToUndo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToUndo(),
            hasSomethingToRedo: true,
            isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this)
        });
        (_g = this._editorUndoBar) === null || _g === void 0 ? void 0 : _g.hide();
    };
    AnnotationEditorUIManager.prototype.redo = function () {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").redo();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSomethingToUndo: true,
            hasSomethingToRedo: __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").hasSomethingToRedo(),
            isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this)
        });
    };
    AnnotationEditorUIManager.prototype.addCommands = function (params) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").add(params);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSomethingToUndo: true,
            hasSomethingToRedo: false,
            isEmpty: __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_isEmpty).call(this)
        });
    };
    AnnotationEditorUIManager.prototype.cleanUndoStack = function (type) {
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_commandManager, "f").cleanType(type);
    };
    AnnotationEditorUIManager.prototype.delete = function () {
        var _this = this;
        var _g;
        this.commitOrRemove();
        var drawingEditor = (_g = this.currentLayer) === null || _g === void 0 ? void 0 : _g.endDrawingSession(true);
        if (!this.hasSelection && !drawingEditor) {
            return;
        }
        var editors = drawingEditor ? [drawingEditor] : __spreadArray([], __read(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), false);
        var cmd = function () {
            var e_34, _g;
            var _h;
            (_h = _this._editorUndoBar) === null || _h === void 0 ? void 0 : _h.show(undo, editors.length === 1 ? editors[0].editorType : editors.length);
            try {
                for (var editors_1 = __values(editors), editors_1_1 = editors_1.next(); !editors_1_1.done; editors_1_1 = editors_1.next()) {
                    var editor = editors_1_1.value;
                    editor.remove();
                }
            }
            catch (e_34_1) { e_34 = { error: e_34_1 }; }
            finally {
                try {
                    if (editors_1_1 && !editors_1_1.done && (_g = editors_1.return)) _g.call(editors_1);
                }
                finally { if (e_34) throw e_34.error; }
            }
        };
        var undo = function () {
            var e_35, _g;
            try {
                for (var editors_2 = __values(editors), editors_2_1 = editors_2.next(); !editors_2_1.done; editors_2_1 = editors_2.next()) {
                    var editor = editors_2_1.value;
                    __classPrivateFieldGet(_this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_addEditorToLayer).call(_this, editor);
                }
            }
            catch (e_35_1) { e_35 = { error: e_35_1 }; }
            finally {
                try {
                    if (editors_2_1 && !editors_2_1.done && (_g = editors_2.return)) _g.call(editors_2);
                }
                finally { if (e_35) throw e_35.error; }
            }
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: true
        });
    };
    AnnotationEditorUIManager.prototype.commitOrRemove = function () {
        var _g;
        (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f")) === null || _g === void 0 ? void 0 : _g.commitOrRemove();
    };
    AnnotationEditorUIManager.prototype.hasSomethingToControl = function () {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f") || this.hasSelection;
    };
    AnnotationEditorUIManager.prototype.selectAll = function () {
        var e_36, _g;
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _j = _h.next(); !_j.done; _j = _h.next()) {
                var editor = _j.value;
                editor.commit();
            }
        }
        catch (e_36_1) { e_36 = { error: e_36_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_36) throw e_36.error; }
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_selectEditors).call(this, __classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values());
    };
    AnnotationEditorUIManager.prototype.unselectAll = function () {
        var e_37, _g;
        var _h;
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f")) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f").commitOrRemove();
            if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== AnnotationEditorType.NONE) {
                return;
            }
        }
        if ((_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_currentDrawingSession, "f")) === null || _h === void 0 ? void 0 : _h.commitOrRemove()) {
            return;
        }
        if (!this.hasSelection) {
            return;
        }
        try {
            for (var _j = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _k = _j.next(); !_k.done; _k = _j.next()) {
                var editor = _k.value;
                editor.unselect();
            }
        }
        catch (e_37_1) { e_37 = { error: e_37_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
            }
            finally { if (e_37) throw e_37.error; }
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSelectedEditor: false
        });
    };
    AnnotationEditorUIManager.prototype.translateSelectedEditors = function (x, y, noCommit) {
        var e_38, _g;
        var _this = this;
        if (noCommit === void 0) { noCommit = false; }
        if (!noCommit) {
            this.commitOrRemove();
        }
        if (!this.hasSelection) {
            return;
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f")[0] += x;
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f")[1] += y;
        var _h = __read(__classPrivateFieldGet(this, _AnnotationEditorUIManager_translation, "f"), 2), totalX = _h[0], totalY = _h[1];
        var editors = __spreadArray([], __read(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), false);
        var TIME_TO_WAIT = 1000;
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorUIManager_translationTimeoutId, "f"));
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_translationTimeoutId, setTimeout(function () {
            __classPrivateFieldSet(_this, _AnnotationEditorUIManager_translationTimeoutId, null, "f");
            __classPrivateFieldGet(_this, _AnnotationEditorUIManager_translation, "f")[0] = __classPrivateFieldGet(_this, _AnnotationEditorUIManager_translation, "f")[1] = 0;
            _this.addCommands({
                cmd: function () {
                    var e_39, _g;
                    try {
                        for (var editors_4 = __values(editors), editors_4_1 = editors_4.next(); !editors_4_1.done; editors_4_1 = editors_4.next()) {
                            var editor = editors_4_1.value;
                            if (__classPrivateFieldGet(_this, _AnnotationEditorUIManager_allEditors, "f").has(editor.id)) {
                                editor.translateInPage(totalX, totalY);
                                editor.translationDone();
                            }
                        }
                    }
                    catch (e_39_1) { e_39 = { error: e_39_1 }; }
                    finally {
                        try {
                            if (editors_4_1 && !editors_4_1.done && (_g = editors_4.return)) _g.call(editors_4);
                        }
                        finally { if (e_39) throw e_39.error; }
                    }
                },
                undo: function () {
                    var e_40, _g;
                    try {
                        for (var editors_5 = __values(editors), editors_5_1 = editors_5.next(); !editors_5_1.done; editors_5_1 = editors_5.next()) {
                            var editor = editors_5_1.value;
                            if (__classPrivateFieldGet(_this, _AnnotationEditorUIManager_allEditors, "f").has(editor.id)) {
                                editor.translateInPage(-totalX, -totalY);
                                editor.translationDone();
                            }
                        }
                    }
                    catch (e_40_1) { e_40 = { error: e_40_1 }; }
                    finally {
                        try {
                            if (editors_5_1 && !editors_5_1.done && (_g = editors_5.return)) _g.call(editors_5);
                        }
                        finally { if (e_40) throw e_40.error; }
                    }
                },
                mustExec: false
            });
        }, TIME_TO_WAIT), "f");
        try {
            for (var editors_3 = __values(editors), editors_3_1 = editors_3.next(); !editors_3_1.done; editors_3_1 = editors_3.next()) {
                var editor = editors_3_1.value;
                editor.translateInPage(x, y);
                editor.translationDone();
            }
        }
        catch (e_38_1) { e_38 = { error: e_38_1 }; }
        finally {
            try {
                if (editors_3_1 && !editors_3_1.done && (_g = editors_3.return)) _g.call(editors_3);
            }
            finally { if (e_38) throw e_38.error; }
        }
    };
    AnnotationEditorUIManager.prototype.setUpDragSession = function () {
        var e_41, _g;
        if (!this.hasSelection) {
            return;
        }
        this.disableUserSelect(true);
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_draggingEditors, new Map(), "f");
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _j = _h.next(); !_j.done; _j = _h.next()) {
                var editor = _j.value;
                __classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f").set(editor, {
                    savedX: editor.x,
                    savedY: editor.y,
                    savedPageIndex: editor.pageIndex,
                    newX: 0,
                    newY: 0,
                    newPageIndex: -1
                });
            }
        }
        catch (e_41_1) { e_41 = { error: e_41_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_41) throw e_41.error; }
        }
    };
    AnnotationEditorUIManager.prototype.endDragSession = function () {
        var e_42, _g;
        var _this = this;
        if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f")) {
            return false;
        }
        this.disableUserSelect(false);
        var map = __classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f");
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_draggingEditors, null, "f");
        var mustBeAddedInUndoStack = false;
        try {
            for (var map_1 = __values(map), map_1_1 = map_1.next(); !map_1_1.done; map_1_1 = map_1.next()) {
                var _h = __read(map_1_1.value, 2), _j = _h[0], x = _j.x, y = _j.y, pageIndex = _j.pageIndex, value = _h[1];
                value.newX = x;
                value.newY = y;
                value.newPageIndex = pageIndex;
                mustBeAddedInUndoStack || (mustBeAddedInUndoStack = x !== value.savedX || y !== value.savedY || pageIndex !== value.savedPageIndex);
            }
        }
        catch (e_42_1) { e_42 = { error: e_42_1 }; }
        finally {
            try {
                if (map_1_1 && !map_1_1.done && (_g = map_1.return)) _g.call(map_1);
            }
            finally { if (e_42) throw e_42.error; }
        }
        if (!mustBeAddedInUndoStack) {
            return false;
        }
        var move = function (editor, x, y, pageIndex) {
            if (__classPrivateFieldGet(_this, _AnnotationEditorUIManager_allEditors, "f").has(editor.id)) {
                var parent = __classPrivateFieldGet(_this, _AnnotationEditorUIManager_allLayers, "f").get(pageIndex);
                if (parent) {
                    editor._setParentAndPosition(parent, x, y);
                }
                else {
                    editor.pageIndex = pageIndex;
                    editor.x = x;
                    editor.y = y;
                }
            }
        };
        this.addCommands({
            cmd: function () {
                var e_43, _g;
                try {
                    for (var map_2 = __values(map), map_2_1 = map_2.next(); !map_2_1.done; map_2_1 = map_2.next()) {
                        var _h = __read(map_2_1.value, 2), editor = _h[0], _j = _h[1], newX = _j.newX, newY = _j.newY, newPageIndex = _j.newPageIndex;
                        move(editor, newX, newY, newPageIndex);
                    }
                }
                catch (e_43_1) { e_43 = { error: e_43_1 }; }
                finally {
                    try {
                        if (map_2_1 && !map_2_1.done && (_g = map_2.return)) _g.call(map_2);
                    }
                    finally { if (e_43) throw e_43.error; }
                }
            },
            undo: function () {
                var e_44, _g;
                try {
                    for (var map_3 = __values(map), map_3_1 = map_3.next(); !map_3_1.done; map_3_1 = map_3.next()) {
                        var _h = __read(map_3_1.value, 2), editor = _h[0], _j = _h[1], savedX = _j.savedX, savedY = _j.savedY, savedPageIndex = _j.savedPageIndex;
                        move(editor, savedX, savedY, savedPageIndex);
                    }
                }
                catch (e_44_1) { e_44 = { error: e_44_1 }; }
                finally {
                    try {
                        if (map_3_1 && !map_3_1.done && (_g = map_3.return)) _g.call(map_3);
                    }
                    finally { if (e_44) throw e_44.error; }
                }
            },
            mustExec: true
        });
        return true;
    };
    AnnotationEditorUIManager.prototype.dragSelectedEditors = function (tx, ty) {
        var e_45, _g;
        if (!__classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f")) {
            return;
        }
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_draggingEditors, "f").keys()), _j = _h.next(); !_j.done; _j = _h.next()) {
                var editor = _j.value;
                editor.drag(tx, ty);
            }
        }
        catch (e_45_1) { e_45 = { error: e_45_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_45) throw e_45.error; }
        }
    };
    AnnotationEditorUIManager.prototype.rebuild = function (editor) {
        if (editor.parent === null) {
            var parent = this.getLayer(editor.pageIndex);
            if (parent) {
                parent.changeParent(editor);
                parent.addOrRebuild(editor);
            }
            else {
                this.addEditor(editor);
                this.addToAnnotationStorage(editor);
                editor.rebuild();
            }
        }
        else {
            editor.parent.addOrRebuild(editor);
        }
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "isEditorHandlingKeyboard", {
        get: function () {
            var _g;
            return ((_g = this.getActive()) === null || _g === void 0 ? void 0 : _g.shouldGetKeyboardEvents()) || __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").size === 1 && this.firstSelectedEditor.shouldGetKeyboardEvents();
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.isActive = function (editor) {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f") === editor;
    };
    AnnotationEditorUIManager.prototype.getActive = function () {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_activeEditor, "f");
    };
    AnnotationEditorUIManager.prototype.getMode = function () {
        return __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f");
    };
    Object.defineProperty(AnnotationEditorUIManager.prototype, "imageManager", {
        get: function () {
            return shadow(this, "imageManager", new ImageManager());
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorUIManager.prototype.getSelectionBoxes = function (textLayer) {
        var e_46, _g;
        if (!textLayer) {
            return null;
        }
        var selection = document.getSelection();
        for (var i = 0, ii = selection.rangeCount; i < ii; i++) {
            if (!textLayer.contains(selection.getRangeAt(i).commonAncestorContainer)) {
                return null;
            }
        }
        var _h = textLayer.getBoundingClientRect(), layerX = _h.x, layerY = _h.y, parentWidth = _h.width, parentHeight = _h.height;
        var rotator;
        switch (textLayer.getAttribute("data-main-rotation")) {
            case "90":
                rotator = function (x, y, w, h) { return ({
                    x: (y - layerY) / parentHeight,
                    y: 1 - (x + w - layerX) / parentWidth,
                    width: h / parentHeight,
                    height: w / parentWidth
                }); };
                break;
            case "180":
                rotator = function (x, y, w, h) { return ({
                    x: 1 - (x + w - layerX) / parentWidth,
                    y: 1 - (y + h - layerY) / parentHeight,
                    width: w / parentWidth,
                    height: h / parentHeight
                }); };
                break;
            case "270":
                rotator = function (x, y, w, h) { return ({
                    x: 1 - (y + h - layerY) / parentHeight,
                    y: (x - layerX) / parentWidth,
                    width: h / parentHeight,
                    height: w / parentWidth
                }); };
                break;
            default:
                rotator = function (x, y, w, h) { return ({
                    x: (x - layerX) / parentWidth,
                    y: (y - layerY) / parentHeight,
                    width: w / parentWidth,
                    height: h / parentHeight
                }); };
                break;
        }
        var boxes = [];
        for (var i = 0, ii = selection.rangeCount; i < ii; i++) {
            var range = selection.getRangeAt(i);
            if (range.collapsed) {
                continue;
            }
            try {
                for (var _j = (e_46 = void 0, __values(range.getClientRects())), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var _l = _k.value, x = _l.x, y = _l.y, width = _l.width, height = _l.height;
                    if (width === 0 || height === 0) {
                        continue;
                    }
                    boxes.push(rotator(x, y, width, height));
                }
            }
            catch (e_46_1) { e_46 = { error: e_46_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
                }
                finally { if (e_46) throw e_46.error; }
            }
        }
        return boxes.length === 0 ? null : boxes;
    };
    AnnotationEditorUIManager.prototype.addChangedExistingAnnotation = function (_g) {
        var annotationElementId = _g.annotationElementId, id = _g.id;
        (__classPrivateFieldSet(this, _AnnotationEditorUIManager_changedExistingAnnotations, __classPrivateFieldGet(this, _AnnotationEditorUIManager_changedExistingAnnotations, "f") || new Map(), "f")).set(annotationElementId, id);
    };
    AnnotationEditorUIManager.prototype.removeChangedExistingAnnotation = function (_g) {
        var _h;
        var annotationElementId = _g.annotationElementId;
        (_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_changedExistingAnnotations, "f")) === null || _h === void 0 ? void 0 : _h.delete(annotationElementId);
    };
    AnnotationEditorUIManager.prototype.renderAnnotationElement = function (annotation) {
        var _g;
        var editorId = (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_changedExistingAnnotations, "f")) === null || _g === void 0 ? void 0 : _g.get(annotation.data.id);
        if (!editorId) {
            return;
        }
        var editor = __classPrivateFieldGet(this, _AnnotationEditorUIManager_annotationStorage, "f").getRawValue(editorId);
        if (!editor) {
            return;
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === AnnotationEditorType.NONE && !editor.hasBeenModified) {
            return;
        }
        editor.renderAnnotationElement(annotation);
    };
    AnnotationEditorUIManager.prototype.setMissingCanvas = function (annotationId, annotationElementId, canvas) {
        var _g;
        var editor = (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_missingCanvases, "f")) === null || _g === void 0 ? void 0 : _g.get(annotationId);
        if (!editor) {
            return;
        }
        editor.setCanvas(annotationElementId, canvas);
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_missingCanvases, "f").delete(annotationId);
    };
    AnnotationEditorUIManager.prototype.addMissingCanvas = function (annotationId, editor) {
        (__classPrivateFieldSet(this, _AnnotationEditorUIManager_missingCanvases, __classPrivateFieldGet(this, _AnnotationEditorUIManager_missingCanvases, "f") || new Map(), "f")).set(annotationId, editor);
    };
    var _AnnotationEditorUIManager_instances, _AnnotationEditorUIManager_abortController, _AnnotationEditorUIManager_activeEditor, _AnnotationEditorUIManager_allEditors, _AnnotationEditorUIManager_allLayers, _AnnotationEditorUIManager_altTextManager, _AnnotationEditorUIManager_annotationStorage, _AnnotationEditorUIManager_changedExistingAnnotations, _AnnotationEditorUIManager_commandManager, _AnnotationEditorUIManager_copyPasteAC, _AnnotationEditorUIManager_currentDrawingSession, _AnnotationEditorUIManager_currentPageIndex, _AnnotationEditorUIManager_deletedAnnotationsElementIds, _AnnotationEditorUIManager_draggingEditors, _AnnotationEditorUIManager_editorTypes, _AnnotationEditorUIManager_editorsToRescale, _AnnotationEditorUIManager_enableHighlightFloatingButton, _AnnotationEditorUIManager_enableUpdatedAddImage, _AnnotationEditorUIManager_enableNewAltTextWhenAddingImage, _AnnotationEditorUIManager_filterFactory, _AnnotationEditorUIManager_focusMainContainerTimeoutId, _AnnotationEditorUIManager_focusManagerAC, _AnnotationEditorUIManager_highlightColors, _AnnotationEditorUIManager_highlightWhenShiftUp, _AnnotationEditorUIManager_highlightToolbar, _AnnotationEditorUIManager_idManager, _AnnotationEditorUIManager_isEnabled, _AnnotationEditorUIManager_isWaiting, _AnnotationEditorUIManager_keyboardManagerAC, _AnnotationEditorUIManager_lastActiveElement, _AnnotationEditorUIManager_mainHighlightColorPicker, _AnnotationEditorUIManager_missingCanvases, _AnnotationEditorUIManager_mlManager, _AnnotationEditorUIManager_mode, _AnnotationEditorUIManager_selectedEditors, _AnnotationEditorUIManager_selectedTextNode, _AnnotationEditorUIManager_signatureManager, _AnnotationEditorUIManager_pageColors, _AnnotationEditorUIManager_showAllStates, _AnnotationEditorUIManager_previousStates, _AnnotationEditorUIManager_translation, _AnnotationEditorUIManager_translationTimeoutId, _AnnotationEditorUIManager_container, _AnnotationEditorUIManager_viewer, _AnnotationEditorUIManager_updateModeCapability, _AnnotationEditorUIManager_getAnchorElementForSelection, _AnnotationEditorUIManager_getLayerForTextLayer, _AnnotationEditorUIManager_displayHighlightToolbar, _AnnotationEditorUIManager_selectionChange, _AnnotationEditorUIManager_onSelectEnd, _AnnotationEditorUIManager_addSelectionListener, _AnnotationEditorUIManager_addFocusManager, _AnnotationEditorUIManager_removeFocusManager, _AnnotationEditorUIManager_addKeyboardManager, _AnnotationEditorUIManager_removeKeyboardManager, _AnnotationEditorUIManager_addCopyPasteListeners, _AnnotationEditorUIManager_removeCopyPasteListeners, _AnnotationEditorUIManager_addDragAndDropListeners, _AnnotationEditorUIManager_dispatchUpdateStates, _AnnotationEditorUIManager_dispatchUpdateUI, _AnnotationEditorUIManager_enableAll, _AnnotationEditorUIManager_disableAll, _AnnotationEditorUIManager_addEditorToLayer, _AnnotationEditorUIManager_lastSelectedEditor_get, _AnnotationEditorUIManager_isEmpty, _AnnotationEditorUIManager_selectEditors;
    _AnnotationEditorUIManager_abortController = new WeakMap(), _AnnotationEditorUIManager_activeEditor = new WeakMap(), _AnnotationEditorUIManager_allEditors = new WeakMap(), _AnnotationEditorUIManager_allLayers = new WeakMap(), _AnnotationEditorUIManager_altTextManager = new WeakMap(), _AnnotationEditorUIManager_annotationStorage = new WeakMap(), _AnnotationEditorUIManager_changedExistingAnnotations = new WeakMap(), _AnnotationEditorUIManager_commandManager = new WeakMap(), _AnnotationEditorUIManager_copyPasteAC = new WeakMap(), _AnnotationEditorUIManager_currentDrawingSession = new WeakMap(), _AnnotationEditorUIManager_currentPageIndex = new WeakMap(), _AnnotationEditorUIManager_deletedAnnotationsElementIds = new WeakMap(), _AnnotationEditorUIManager_draggingEditors = new WeakMap(), _AnnotationEditorUIManager_editorTypes = new WeakMap(), _AnnotationEditorUIManager_editorsToRescale = new WeakMap(), _AnnotationEditorUIManager_enableHighlightFloatingButton = new WeakMap(), _AnnotationEditorUIManager_enableUpdatedAddImage = new WeakMap(), _AnnotationEditorUIManager_enableNewAltTextWhenAddingImage = new WeakMap(), _AnnotationEditorUIManager_filterFactory = new WeakMap(), _AnnotationEditorUIManager_focusMainContainerTimeoutId = new WeakMap(), _AnnotationEditorUIManager_focusManagerAC = new WeakMap(), _AnnotationEditorUIManager_highlightColors = new WeakMap(), _AnnotationEditorUIManager_highlightWhenShiftUp = new WeakMap(), _AnnotationEditorUIManager_highlightToolbar = new WeakMap(), _AnnotationEditorUIManager_idManager = new WeakMap(), _AnnotationEditorUIManager_isEnabled = new WeakMap(), _AnnotationEditorUIManager_isWaiting = new WeakMap(), _AnnotationEditorUIManager_keyboardManagerAC = new WeakMap(), _AnnotationEditorUIManager_lastActiveElement = new WeakMap(), _AnnotationEditorUIManager_mainHighlightColorPicker = new WeakMap(), _AnnotationEditorUIManager_missingCanvases = new WeakMap(), _AnnotationEditorUIManager_mlManager = new WeakMap(), _AnnotationEditorUIManager_mode = new WeakMap(), _AnnotationEditorUIManager_selectedEditors = new WeakMap(), _AnnotationEditorUIManager_selectedTextNode = new WeakMap(), _AnnotationEditorUIManager_signatureManager = new WeakMap(), _AnnotationEditorUIManager_pageColors = new WeakMap(), _AnnotationEditorUIManager_showAllStates = new WeakMap(), _AnnotationEditorUIManager_previousStates = new WeakMap(), _AnnotationEditorUIManager_translation = new WeakMap(), _AnnotationEditorUIManager_translationTimeoutId = new WeakMap(), _AnnotationEditorUIManager_container = new WeakMap(), _AnnotationEditorUIManager_viewer = new WeakMap(), _AnnotationEditorUIManager_updateModeCapability = new WeakMap(), _AnnotationEditorUIManager_instances = new WeakSet(), _AnnotationEditorUIManager_getAnchorElementForSelection = function _AnnotationEditorUIManager_getAnchorElementForSelection(_g) {
        var anchorNode = _g.anchorNode;
        return anchorNode.nodeType === Node.TEXT_NODE ? anchorNode.parentElement : anchorNode;
    }, _AnnotationEditorUIManager_getLayerForTextLayer = function _AnnotationEditorUIManager_getLayerForTextLayer(textLayer) {
        var e_47, _g;
        var currentLayer = this.currentLayer;
        if (currentLayer.hasTextLayer(textLayer)) {
            return currentLayer;
        }
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()), _j = _h.next(); !_j.done; _j = _h.next()) {
                var layer = _j.value;
                if (layer.hasTextLayer(textLayer)) {
                    return layer;
                }
            }
        }
        catch (e_47_1) { e_47 = { error: e_47_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_47) throw e_47.error; }
        }
        return null;
    }, _AnnotationEditorUIManager_displayHighlightToolbar = function _AnnotationEditorUIManager_displayHighlightToolbar() {
        var selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            return;
        }
        var anchorElement = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getAnchorElementForSelection).call(this, selection);
        var textLayer = anchorElement.closest(".textLayer");
        var boxes = this.getSelectionBoxes(textLayer);
        if (!boxes) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightToolbar, __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f") || new HighlightToolbar(this), "f");
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f").show(textLayer, boxes, this.direction === "ltr");
    }, _AnnotationEditorUIManager_selectionChange = function _AnnotationEditorUIManager_selectionChange() {
        var _this = this;
        var _g, _h, _j;
        var selection = document.getSelection();
        if (!selection || selection.isCollapsed) {
            if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedTextNode, "f")) {
                (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f")) === null || _g === void 0 ? void 0 : _g.hide();
                __classPrivateFieldSet(this, _AnnotationEditorUIManager_selectedTextNode, null, "f");
                __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                    hasSelectedText: false
                });
            }
            return;
        }
        var anchorNode = selection.anchorNode;
        if (anchorNode === __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedTextNode, "f")) {
            return;
        }
        var anchorElement = __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getAnchorElementForSelection).call(this, selection);
        var textLayer = anchorElement.closest(".textLayer");
        if (!textLayer) {
            if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedTextNode, "f")) {
                (_h = __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f")) === null || _h === void 0 ? void 0 : _h.hide();
                __classPrivateFieldSet(this, _AnnotationEditorUIManager_selectedTextNode, null, "f");
                __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
                    hasSelectedText: false
                });
            }
            return;
        }
        (_j = __classPrivateFieldGet(this, _AnnotationEditorUIManager_highlightToolbar, "f")) === null || _j === void 0 ? void 0 : _j.hide();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_selectedTextNode, anchorNode, "f");
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSelectedText: true
        });
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== AnnotationEditorType.HIGHLIGHT && __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") !== AnnotationEditorType.NONE) {
            return;
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === AnnotationEditorType.HIGHLIGHT) {
            this.showAllEditors("highlight", true, true);
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_highlightWhenShiftUp, this.isShiftKeyDown, "f");
        if (!this.isShiftKeyDown) {
            var activeLayer_1 = __classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === AnnotationEditorType.HIGHLIGHT ? __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_getLayerForTextLayer).call(this, textLayer) : null;
            activeLayer_1 === null || activeLayer_1 === void 0 ? void 0 : activeLayer_1.toggleDrawing();
            var ac_1 = new AbortController();
            var signal = this.combinedSignal(ac_1);
            var pointerup = function (e) {
                if (e.type === "pointerup" && e.button !== 0) {
                    return;
                }
                ac_1.abort();
                activeLayer_1 === null || activeLayer_1 === void 0 ? void 0 : activeLayer_1.toggleDrawing(true);
                if (e.type === "pointerup") {
                    __classPrivateFieldGet(_this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_onSelectEnd).call(_this, "main_toolbar");
                }
            };
            window.addEventListener("pointerup", pointerup, {
                signal: signal
            });
            window.addEventListener("blur", pointerup, {
                signal: signal
            });
        }
    }, _AnnotationEditorUIManager_onSelectEnd = function _AnnotationEditorUIManager_onSelectEnd(methodOfCreation) {
        if (methodOfCreation === void 0) { methodOfCreation = ""; }
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === AnnotationEditorType.HIGHLIGHT) {
            this.highlightSelection(methodOfCreation);
        }
        else if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_enableHighlightFloatingButton, "f")) {
            __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_displayHighlightToolbar).call(this);
        }
    }, _AnnotationEditorUIManager_addSelectionListener = function _AnnotationEditorUIManager_addSelectionListener() {
        document.addEventListener("selectionchange", __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_selectionChange).bind(this), {
            signal: this._signal
        });
    }, _AnnotationEditorUIManager_addFocusManager = function _AnnotationEditorUIManager_addFocusManager() {
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusManagerAC, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusManagerAC, new AbortController(), "f");
        var signal = this.combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorUIManager_focusManagerAC, "f"));
        window.addEventListener("focus", this.focus.bind(this), {
            signal: signal
        });
        window.addEventListener("blur", this.blur.bind(this), {
            signal: signal
        });
    }, _AnnotationEditorUIManager_removeFocusManager = function _AnnotationEditorUIManager_removeFocusManager() {
        var _g;
        (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_focusManagerAC, "f")) === null || _g === void 0 ? void 0 : _g.abort();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_focusManagerAC, null, "f");
    }, _AnnotationEditorUIManager_addKeyboardManager = function _AnnotationEditorUIManager_addKeyboardManager() {
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_keyboardManagerAC, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_keyboardManagerAC, new AbortController(), "f");
        var signal = this.combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorUIManager_keyboardManagerAC, "f"));
        window.addEventListener("keydown", this.keydown.bind(this), {
            signal: signal
        });
        window.addEventListener("keyup", this.keyup.bind(this), {
            signal: signal
        });
    }, _AnnotationEditorUIManager_removeKeyboardManager = function _AnnotationEditorUIManager_removeKeyboardManager() {
        var _g;
        (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_keyboardManagerAC, "f")) === null || _g === void 0 ? void 0 : _g.abort();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_keyboardManagerAC, null, "f");
    }, _AnnotationEditorUIManager_addCopyPasteListeners = function _AnnotationEditorUIManager_addCopyPasteListeners() {
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_copyPasteAC, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_copyPasteAC, new AbortController(), "f");
        var signal = this.combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorUIManager_copyPasteAC, "f"));
        document.addEventListener("copy", this.copy.bind(this), {
            signal: signal
        });
        document.addEventListener("cut", this.cut.bind(this), {
            signal: signal
        });
        document.addEventListener("paste", this.paste.bind(this), {
            signal: signal
        });
    }, _AnnotationEditorUIManager_removeCopyPasteListeners = function _AnnotationEditorUIManager_removeCopyPasteListeners() {
        var _g;
        (_g = __classPrivateFieldGet(this, _AnnotationEditorUIManager_copyPasteAC, "f")) === null || _g === void 0 ? void 0 : _g.abort();
        __classPrivateFieldSet(this, _AnnotationEditorUIManager_copyPasteAC, null, "f");
    }, _AnnotationEditorUIManager_addDragAndDropListeners = function _AnnotationEditorUIManager_addDragAndDropListeners() {
        var signal = this._signal;
        document.addEventListener("dragover", this.dragOver.bind(this), {
            signal: signal
        });
        document.addEventListener("drop", this.drop.bind(this), {
            signal: signal
        });
    }, _AnnotationEditorUIManager_dispatchUpdateStates = function _AnnotationEditorUIManager_dispatchUpdateStates(details) {
        var _this = this;
        var hasChanged = Object.entries(details).some(function (_g) {
            var _h = __read(_g, 2), key = _h[0], value = _h[1];
            return __classPrivateFieldGet(_this, _AnnotationEditorUIManager_previousStates, "f")[key] !== value;
        });
        if (hasChanged) {
            this._eventBus.dispatch("annotationeditorstateschanged", {
                source: this,
                details: Object.assign(__classPrivateFieldGet(this, _AnnotationEditorUIManager_previousStates, "f"), details)
            });
            if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_mode, "f") === AnnotationEditorType.HIGHLIGHT && details.hasSelectedEditor === false) {
                __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateUI).call(this, [[AnnotationEditorParamsType.HIGHLIGHT_FREE, true]]);
            }
        }
    }, _AnnotationEditorUIManager_dispatchUpdateUI = function _AnnotationEditorUIManager_dispatchUpdateUI(details) {
        this._eventBus.dispatch("annotationeditorparamschanged", {
            source: this,
            details: details
        });
    }, _AnnotationEditorUIManager_enableAll = function _AnnotationEditorUIManager_enableAll() {
        return __awaiter(this, void 0, void 0, function () {
            var promises, _g, _h, layer, _j, _k, editor;
            var e_48, _l, e_49, _m;
            return __generator(this, function (_o) {
                switch (_o.label) {
                    case 0:
                        if (!!__classPrivateFieldGet(this, _AnnotationEditorUIManager_isEnabled, "f")) return [3 /*break*/, 2];
                        __classPrivateFieldSet(this, _AnnotationEditorUIManager_isEnabled, true, "f");
                        promises = [];
                        try {
                            for (_g = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()), _h = _g.next(); !_h.done; _h = _g.next()) {
                                layer = _h.value;
                                promises.push(layer.enable());
                            }
                        }
                        catch (e_48_1) { e_48 = { error: e_48_1 }; }
                        finally {
                            try {
                                if (_h && !_h.done && (_l = _g.return)) _l.call(_g);
                            }
                            finally { if (e_48) throw e_48.error; }
                        }
                        return [4 /*yield*/, Promise.all(promises)];
                    case 1:
                        _o.sent();
                        try {
                            for (_j = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()), _k = _j.next(); !_k.done; _k = _j.next()) {
                                editor = _k.value;
                                editor.enable();
                            }
                        }
                        catch (e_49_1) { e_49 = { error: e_49_1 }; }
                        finally {
                            try {
                                if (_k && !_k.done && (_m = _j.return)) _m.call(_j);
                            }
                            finally { if (e_49) throw e_49.error; }
                        }
                        _o.label = 2;
                    case 2: return [2 /*return*/];
                }
            });
        });
    }, _AnnotationEditorUIManager_disableAll = function _AnnotationEditorUIManager_disableAll() {
        var e_50, _g, e_51, _h;
        this.unselectAll();
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_isEnabled, "f")) {
            __classPrivateFieldSet(this, _AnnotationEditorUIManager_isEnabled, false, "f");
            try {
                for (var _j = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").values()), _k = _j.next(); !_k.done; _k = _j.next()) {
                    var layer = _k.value;
                    layer.disable();
                }
            }
            catch (e_50_1) { e_50 = { error: e_50_1 }; }
            finally {
                try {
                    if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
                }
                finally { if (e_50) throw e_50.error; }
            }
            try {
                for (var _l = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var editor = _m.value;
                    editor.disable();
                }
            }
            catch (e_51_1) { e_51 = { error: e_51_1 }; }
            finally {
                try {
                    if (_m && !_m.done && (_h = _l.return)) _h.call(_l);
                }
                finally { if (e_51) throw e_51.error; }
            }
        }
    }, _AnnotationEditorUIManager_addEditorToLayer = function _AnnotationEditorUIManager_addEditorToLayer(editor) {
        var layer = __classPrivateFieldGet(this, _AnnotationEditorUIManager_allLayers, "f").get(editor.pageIndex);
        if (layer) {
            layer.addOrRebuild(editor);
        }
        else {
            this.addEditor(editor);
            this.addToAnnotationStorage(editor);
        }
    }, _AnnotationEditorUIManager_lastSelectedEditor_get = function _AnnotationEditorUIManager_lastSelectedEditor_get() {
        var e_52, _g;
        var ed = null;
        try {
            for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _j = _h.next(); !_j.done; _j = _h.next()) {
                ed = _j.value;
            }
        }
        catch (e_52_1) { e_52 = { error: e_52_1 }; }
        finally {
            try {
                if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
            }
            finally { if (e_52) throw e_52.error; }
        }
        return ed;
    }, _AnnotationEditorUIManager_isEmpty = function _AnnotationEditorUIManager_isEmpty() {
        var e_53, _g;
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").size === 0) {
            return true;
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").size === 1) {
            try {
                for (var _h = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_allEditors, "f").values()), _j = _h.next(); !_j.done; _j = _h.next()) {
                    var editor = _j.value;
                    return editor.isEmpty();
                }
            }
            catch (e_53_1) { e_53 = { error: e_53_1 }; }
            finally {
                try {
                    if (_j && !_j.done && (_g = _h.return)) _g.call(_h);
                }
                finally { if (e_53) throw e_53.error; }
            }
        }
        return false;
    }, _AnnotationEditorUIManager_selectEditors = function _AnnotationEditorUIManager_selectEditors(editors) {
        var e_54, _g, e_55, _h;
        try {
            for (var _j = __values(__classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f")), _k = _j.next(); !_k.done; _k = _j.next()) {
                var editor = _k.value;
                editor.unselect();
            }
        }
        catch (e_54_1) { e_54 = { error: e_54_1 }; }
        finally {
            try {
                if (_k && !_k.done && (_g = _j.return)) _g.call(_j);
            }
            finally { if (e_54) throw e_54.error; }
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").clear();
        try {
            for (var editors_6 = __values(editors), editors_6_1 = editors_6.next(); !editors_6_1.done; editors_6_1 = editors_6.next()) {
                var editor = editors_6_1.value;
                if (editor.isEmpty()) {
                    continue;
                }
                __classPrivateFieldGet(this, _AnnotationEditorUIManager_selectedEditors, "f").add(editor);
                editor.select();
            }
        }
        catch (e_55_1) { e_55 = { error: e_55_1 }; }
        finally {
            try {
                if (editors_6_1 && !editors_6_1.done && (_h = editors_6.return)) _h.call(editors_6);
            }
            finally { if (e_55) throw e_55.error; }
        }
        __classPrivateFieldGet(this, _AnnotationEditorUIManager_instances, "m", _AnnotationEditorUIManager_dispatchUpdateStates).call(this, {
            hasSelectedEditor: this.hasSelection
        });
    };
    AnnotationEditorUIManager.TRANSLATE_SMALL = 1;
    AnnotationEditorUIManager.TRANSLATE_BIG = 10;
    return AnnotationEditorUIManager;
}());
; // ./src/display/editor/alt_text.js
var AltText = /** @class */ (function () {
    function AltText(editor) {
        var _h;
        _AltText_instances.add(this);
        _AltText_altText.set(this, null);
        _AltText_altTextDecorative.set(this, false);
        _AltText_altTextButton.set(this, null);
        _AltText_altTextButtonLabel.set(this, null);
        _AltText_altTextTooltip.set(this, null);
        _AltText_altTextTooltipTimeout.set(this, null);
        _AltText_altTextWasFromKeyBoard.set(this, false);
        _AltText_badge.set(this, null);
        _AltText_editor.set(this, null);
        _AltText_guessedText.set(this, null);
        _AltText_textWithDisclaimer.set(this, null);
        _AltText_useNewAltTextFlow.set(this, false);
        __classPrivateFieldSet(this, _AltText_editor, editor, "f");
        __classPrivateFieldSet(this, _AltText_useNewAltTextFlow, editor._uiManager.useNewAltTextFlow, "f");
        __classPrivateFieldSet(_h = _g, _g, __classPrivateFieldGet(_h, _g, "f", _AltText_l10nNewButton) || Object.freeze({
            added: "pdfjs-editor-new-alt-text-added-button",
            "added-label": "pdfjs-editor-new-alt-text-added-button-label",
            missing: "pdfjs-editor-new-alt-text-missing-button",
            "missing-label": "pdfjs-editor-new-alt-text-missing-button-label",
            review: "pdfjs-editor-new-alt-text-to-review-button",
            "review-label": "pdfjs-editor-new-alt-text-to-review-button-label"
        }), "f", _AltText_l10nNewButton);
    }
    AltText.initialize = function (l10n) {
        var _h;
        (_h = _g._l10n) !== null && _h !== void 0 ? _h : (_g._l10n = l10n);
    };
    AltText.prototype.render = function () {
        return __awaiter(this, void 0, void 0, function () {
            var altText, label, signal, onClick;
            var _this = this;
            return __generator(this, function (_h) {
                switch (_h.label) {
                    case 0:
                        altText = __classPrivateFieldSet(this, _AltText_altTextButton, document.createElement("button"), "f");
                        altText.className = "altText";
                        altText.tabIndex = "0";
                        label = __classPrivateFieldSet(this, _AltText_altTextButtonLabel, document.createElement("span"), "f");
                        altText.append(label);
                        if (__classPrivateFieldGet(this, _AltText_useNewAltTextFlow, "f")) {
                            altText.classList.add("new");
                            altText.setAttribute("data-l10n-id", __classPrivateFieldGet(_g, _g, "f", _AltText_l10nNewButton).missing);
                            label.setAttribute("data-l10n-id", __classPrivateFieldGet(_g, _g, "f", _AltText_l10nNewButton)["missing-label"]);
                        }
                        else {
                            altText.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button");
                            label.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-button-label");
                        }
                        signal = __classPrivateFieldGet(this, _AltText_editor, "f")._uiManager._signal;
                        altText.addEventListener("contextmenu", noContextMenu, {
                            signal: signal
                        });
                        altText.addEventListener("pointerdown", function (event) { return event.stopPropagation(); }, {
                            signal: signal
                        });
                        onClick = function (event) {
                            event.preventDefault();
                            __classPrivateFieldGet(_this, _AltText_editor, "f")._uiManager.editAltText(__classPrivateFieldGet(_this, _AltText_editor, "f"));
                            if (__classPrivateFieldGet(_this, _AltText_useNewAltTextFlow, "f")) {
                                __classPrivateFieldGet(_this, _AltText_editor, "f")._reportTelemetry({
                                    action: "pdfjs.image.alt_text.image_status_label_clicked",
                                    data: {
                                        label: __classPrivateFieldGet(_this, _AltText_instances, "a", _AltText_label_get)
                                    }
                                });
                            }
                        };
                        altText.addEventListener("click", onClick, {
                            capture: true,
                            signal: signal
                        });
                        altText.addEventListener("keydown", function (event) {
                            if (event.target === altText && event.key === "Enter") {
                                __classPrivateFieldSet(_this, _AltText_altTextWasFromKeyBoard, true, "f");
                                onClick(event);
                            }
                        }, {
                            signal: signal
                        });
                        return [4 /*yield*/, __classPrivateFieldGet(this, _AltText_instances, "m", _AltText_setState).call(this)];
                    case 1:
                        _h.sent();
                        return [2 /*return*/, altText];
                }
            });
        });
    };
    AltText.prototype.finish = function () {
        if (!__classPrivateFieldGet(this, _AltText_altTextButton, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _AltText_altTextButton, "f").focus({
            focusVisible: __classPrivateFieldGet(this, _AltText_altTextWasFromKeyBoard, "f")
        });
        __classPrivateFieldSet(this, _AltText_altTextWasFromKeyBoard, false, "f");
    };
    AltText.prototype.isEmpty = function () {
        if (__classPrivateFieldGet(this, _AltText_useNewAltTextFlow, "f")) {
            return __classPrivateFieldGet(this, _AltText_altText, "f") === null;
        }
        return !__classPrivateFieldGet(this, _AltText_altText, "f") && !__classPrivateFieldGet(this, _AltText_altTextDecorative, "f");
    };
    AltText.prototype.hasData = function () {
        if (__classPrivateFieldGet(this, _AltText_useNewAltTextFlow, "f")) {
            return __classPrivateFieldGet(this, _AltText_altText, "f") !== null || !!__classPrivateFieldGet(this, _AltText_guessedText, "f");
        }
        return this.isEmpty();
    };
    Object.defineProperty(AltText.prototype, "guessedText", {
        get: function () {
            return __classPrivateFieldGet(this, _AltText_guessedText, "f");
        },
        enumerable: false,
        configurable: true
    });
    AltText.prototype.setGuessedText = function (guessedText) {
        return __awaiter(this, void 0, void 0, function () {
            var _h;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (__classPrivateFieldGet(this, _AltText_altText, "f") !== null) {
                            return [2 /*return*/];
                        }
                        __classPrivateFieldSet(this, _AltText_guessedText, guessedText, "f");
                        _h = [this, _AltText_textWithDisclaimer];
                        return [4 /*yield*/, _g._l10n.get("pdfjs-editor-new-alt-text-generated-alt-text-with-disclaimer", {
                                generatedAltText: guessedText
                            })];
                    case 1:
                        __classPrivateFieldSet.apply(void 0, _h.concat([_j.sent(), "f"]));
                        __classPrivateFieldGet(this, _AltText_instances, "m", _AltText_setState).call(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    AltText.prototype.toggleAltTextBadge = function (visibility) {
        var _h;
        if (visibility === void 0) { visibility = false; }
        if (!__classPrivateFieldGet(this, _AltText_useNewAltTextFlow, "f") || __classPrivateFieldGet(this, _AltText_altText, "f")) {
            (_h = __classPrivateFieldGet(this, _AltText_badge, "f")) === null || _h === void 0 ? void 0 : _h.remove();
            __classPrivateFieldSet(this, _AltText_badge, null, "f");
            return;
        }
        if (!__classPrivateFieldGet(this, _AltText_badge, "f")) {
            var badge = __classPrivateFieldSet(this, _AltText_badge, document.createElement("div"), "f");
            badge.className = "noAltTextBadge";
            __classPrivateFieldGet(this, _AltText_editor, "f").div.append(badge);
        }
        __classPrivateFieldGet(this, _AltText_badge, "f").classList.toggle("hidden", !visibility);
    };
    AltText.prototype.serialize = function (isForCopying) {
        var altText = __classPrivateFieldGet(this, _AltText_altText, "f");
        if (!isForCopying && __classPrivateFieldGet(this, _AltText_guessedText, "f") === altText) {
            altText = __classPrivateFieldGet(this, _AltText_textWithDisclaimer, "f");
        }
        return {
            altText: altText,
            decorative: __classPrivateFieldGet(this, _AltText_altTextDecorative, "f"),
            guessedText: __classPrivateFieldGet(this, _AltText_guessedText, "f"),
            textWithDisclaimer: __classPrivateFieldGet(this, _AltText_textWithDisclaimer, "f")
        };
    };
    Object.defineProperty(AltText.prototype, "data", {
        get: function () {
            return {
                altText: __classPrivateFieldGet(this, _AltText_altText, "f"),
                decorative: __classPrivateFieldGet(this, _AltText_altTextDecorative, "f")
            };
        },
        set: function (_h) {
            var altText = _h.altText, decorative = _h.decorative, guessedText = _h.guessedText, textWithDisclaimer = _h.textWithDisclaimer, _j = _h.cancel, cancel = _j === void 0 ? false : _j;
            if (guessedText) {
                __classPrivateFieldSet(this, _AltText_guessedText, guessedText, "f");
                __classPrivateFieldSet(this, _AltText_textWithDisclaimer, textWithDisclaimer, "f");
            }
            if (__classPrivateFieldGet(this, _AltText_altText, "f") === altText && __classPrivateFieldGet(this, _AltText_altTextDecorative, "f") === decorative) {
                return;
            }
            if (!cancel) {
                __classPrivateFieldSet(this, _AltText_altText, altText, "f");
                __classPrivateFieldSet(this, _AltText_altTextDecorative, decorative, "f");
            }
            __classPrivateFieldGet(this, _AltText_instances, "m", _AltText_setState).call(this);
        },
        enumerable: false,
        configurable: true
    });
    AltText.prototype.toggle = function (enabled) {
        if (enabled === void 0) { enabled = false; }
        if (!__classPrivateFieldGet(this, _AltText_altTextButton, "f")) {
            return;
        }
        if (!enabled && __classPrivateFieldGet(this, _AltText_altTextTooltipTimeout, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _AltText_altTextTooltipTimeout, "f"));
            __classPrivateFieldSet(this, _AltText_altTextTooltipTimeout, null, "f");
        }
        __classPrivateFieldGet(this, _AltText_altTextButton, "f").disabled = !enabled;
    };
    AltText.prototype.shown = function () {
        __classPrivateFieldGet(this, _AltText_editor, "f")._reportTelemetry({
            action: "pdfjs.image.alt_text.image_status_label_displayed",
            data: {
                label: __classPrivateFieldGet(this, _AltText_instances, "a", _AltText_label_get)
            }
        });
    };
    AltText.prototype.destroy = function () {
        var _h, _j;
        (_h = __classPrivateFieldGet(this, _AltText_altTextButton, "f")) === null || _h === void 0 ? void 0 : _h.remove();
        __classPrivateFieldSet(this, _AltText_altTextButton, null, "f");
        __classPrivateFieldSet(this, _AltText_altTextButtonLabel, null, "f");
        __classPrivateFieldSet(this, _AltText_altTextTooltip, null, "f");
        (_j = __classPrivateFieldGet(this, _AltText_badge, "f")) === null || _j === void 0 ? void 0 : _j.remove();
        __classPrivateFieldSet(this, _AltText_badge, null, "f");
    };
    var _AltText_instances, _g, _AltText_altText, _AltText_altTextDecorative, _AltText_altTextButton, _AltText_altTextButtonLabel, _AltText_altTextTooltip, _AltText_altTextTooltipTimeout, _AltText_altTextWasFromKeyBoard, _AltText_badge, _AltText_editor, _AltText_guessedText, _AltText_textWithDisclaimer, _AltText_useNewAltTextFlow, _AltText_l10nNewButton, _AltText_label_get, _AltText_setState;
    _g = AltText, _AltText_altText = new WeakMap(), _AltText_altTextDecorative = new WeakMap(), _AltText_altTextButton = new WeakMap(), _AltText_altTextButtonLabel = new WeakMap(), _AltText_altTextTooltip = new WeakMap(), _AltText_altTextTooltipTimeout = new WeakMap(), _AltText_altTextWasFromKeyBoard = new WeakMap(), _AltText_badge = new WeakMap(), _AltText_editor = new WeakMap(), _AltText_guessedText = new WeakMap(), _AltText_textWithDisclaimer = new WeakMap(), _AltText_useNewAltTextFlow = new WeakMap(), _AltText_instances = new WeakSet(), _AltText_label_get = function _AltText_label_get() {
        return __classPrivateFieldGet(this, _AltText_altText, "f") && "added" || __classPrivateFieldGet(this, _AltText_altText, "f") === null && this.guessedText && "review" || "missing";
    }, _AltText_setState = function _AltText_setState() {
        return __awaiter(this, void 0, void 0, function () {
            var button, tooltip, DELAY_TO_SHOW_TOOLTIP_1, signal, element;
            var _this = this;
            var _h, _j, _k;
            return __generator(this, function (_l) {
                button = __classPrivateFieldGet(this, _AltText_altTextButton, "f");
                if (!button) {
                    return [2 /*return*/];
                }
                if (__classPrivateFieldGet(this, _AltText_useNewAltTextFlow, "f")) {
                    button.classList.toggle("done", !!__classPrivateFieldGet(this, _AltText_altText, "f"));
                    button.setAttribute("data-l10n-id", __classPrivateFieldGet(_g, _g, "f", _AltText_l10nNewButton)[__classPrivateFieldGet(this, _AltText_instances, "a", _AltText_label_get)]);
                    (_h = __classPrivateFieldGet(this, _AltText_altTextButtonLabel, "f")) === null || _h === void 0 ? void 0 : _h.setAttribute("data-l10n-id", __classPrivateFieldGet(_g, _g, "f", _AltText_l10nNewButton)["".concat(__classPrivateFieldGet(this, _AltText_instances, "a", _AltText_label_get), "-label")]);
                    if (!__classPrivateFieldGet(this, _AltText_altText, "f")) {
                        (_j = __classPrivateFieldGet(this, _AltText_altTextTooltip, "f")) === null || _j === void 0 ? void 0 : _j.remove();
                        return [2 /*return*/];
                    }
                }
                else {
                    if (!__classPrivateFieldGet(this, _AltText_altText, "f") && !__classPrivateFieldGet(this, _AltText_altTextDecorative, "f")) {
                        button.classList.remove("done");
                        (_k = __classPrivateFieldGet(this, _AltText_altTextTooltip, "f")) === null || _k === void 0 ? void 0 : _k.remove();
                        return [2 /*return*/];
                    }
                    button.classList.add("done");
                    button.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-edit-button");
                }
                tooltip = __classPrivateFieldGet(this, _AltText_altTextTooltip, "f");
                if (!tooltip) {
                    __classPrivateFieldSet(this, _AltText_altTextTooltip, tooltip = document.createElement("span"), "f");
                    tooltip.className = "tooltip";
                    tooltip.setAttribute("role", "tooltip");
                    tooltip.id = "alt-text-tooltip-".concat(__classPrivateFieldGet(this, _AltText_editor, "f").id);
                    DELAY_TO_SHOW_TOOLTIP_1 = 100;
                    signal = __classPrivateFieldGet(this, _AltText_editor, "f")._uiManager._signal;
                    signal.addEventListener("abort", function () {
                        clearTimeout(__classPrivateFieldGet(_this, _AltText_altTextTooltipTimeout, "f"));
                        __classPrivateFieldSet(_this, _AltText_altTextTooltipTimeout, null, "f");
                    }, {
                        once: true
                    });
                    button.addEventListener("mouseenter", function () {
                        __classPrivateFieldSet(_this, _AltText_altTextTooltipTimeout, setTimeout(function () {
                            __classPrivateFieldSet(_this, _AltText_altTextTooltipTimeout, null, "f");
                            __classPrivateFieldGet(_this, _AltText_altTextTooltip, "f").classList.add("show");
                            __classPrivateFieldGet(_this, _AltText_editor, "f")._reportTelemetry({
                                action: "alt_text_tooltip"
                            });
                        }, DELAY_TO_SHOW_TOOLTIP_1), "f");
                    }, {
                        signal: signal
                    });
                    button.addEventListener("mouseleave", function () {
                        var _h;
                        if (__classPrivateFieldGet(_this, _AltText_altTextTooltipTimeout, "f")) {
                            clearTimeout(__classPrivateFieldGet(_this, _AltText_altTextTooltipTimeout, "f"));
                            __classPrivateFieldSet(_this, _AltText_altTextTooltipTimeout, null, "f");
                        }
                        (_h = __classPrivateFieldGet(_this, _AltText_altTextTooltip, "f")) === null || _h === void 0 ? void 0 : _h.classList.remove("show");
                    }, {
                        signal: signal
                    });
                }
                if (__classPrivateFieldGet(this, _AltText_altTextDecorative, "f")) {
                    tooltip.setAttribute("data-l10n-id", "pdfjs-editor-alt-text-decorative-tooltip");
                }
                else {
                    tooltip.removeAttribute("data-l10n-id");
                    tooltip.textContent = __classPrivateFieldGet(this, _AltText_altText, "f");
                }
                if (!tooltip.parentNode) {
                    button.append(tooltip);
                }
                element = __classPrivateFieldGet(this, _AltText_editor, "f").getElementForAltText();
                element === null || element === void 0 ? void 0 : element.setAttribute("aria-describedby", tooltip.id);
                return [2 /*return*/];
            });
        });
    };
    _AltText_l10nNewButton = { value: null };
    AltText._l10n = null;
    return AltText;
}());
; // ./src/display/touch_manager.js
var TouchManager = /** @class */ (function () {
    function TouchManager(_h) {
        var container = _h.container, _j = _h.isPinchingDisabled, isPinchingDisabled = _j === void 0 ? null : _j, _k = _h.isPinchingStopped, isPinchingStopped = _k === void 0 ? null : _k, _l = _h.onPinchStart, onPinchStart = _l === void 0 ? null : _l, _m = _h.onPinching, onPinching = _m === void 0 ? null : _m, _o = _h.onPinchEnd, onPinchEnd = _o === void 0 ? null : _o, signal = _h.signal;
        _TouchManager_instances.add(this);
        _TouchManager_container.set(this, void 0);
        _TouchManager_isPinching.set(this, false);
        _TouchManager_isPinchingStopped.set(this, null);
        _TouchManager_isPinchingDisabled.set(this, void 0);
        _TouchManager_onPinchStart.set(this, void 0);
        _TouchManager_onPinching.set(this, void 0);
        _TouchManager_onPinchEnd.set(this, void 0);
        _TouchManager_pointerDownAC.set(this, null);
        _TouchManager_signal.set(this, void 0);
        _TouchManager_touchInfo.set(this, null);
        _TouchManager_touchManagerAC.set(this, void 0);
        _TouchManager_touchMoveAC.set(this, null);
        __classPrivateFieldSet(this, _TouchManager_container, container, "f");
        __classPrivateFieldSet(this, _TouchManager_isPinchingStopped, isPinchingStopped, "f");
        __classPrivateFieldSet(this, _TouchManager_isPinchingDisabled, isPinchingDisabled, "f");
        __classPrivateFieldSet(this, _TouchManager_onPinchStart, onPinchStart, "f");
        __classPrivateFieldSet(this, _TouchManager_onPinching, onPinching, "f");
        __classPrivateFieldSet(this, _TouchManager_onPinchEnd, onPinchEnd, "f");
        __classPrivateFieldSet(this, _TouchManager_touchManagerAC, new AbortController(), "f");
        __classPrivateFieldSet(this, _TouchManager_signal, AbortSignal.any([signal, __classPrivateFieldGet(this, _TouchManager_touchManagerAC, "f").signal]), "f");
        container.addEventListener("touchstart", __classPrivateFieldGet(this, _TouchManager_instances, "m", _TouchManager_onTouchStart).bind(this), {
            passive: false,
            signal: __classPrivateFieldGet(this, _TouchManager_signal, "f")
        });
    }
    Object.defineProperty(TouchManager.prototype, "MIN_TOUCH_DISTANCE_TO_PINCH", {
        get: function () {
            return 35 / OutputScale.pixelRatio;
        },
        enumerable: false,
        configurable: true
    });
    TouchManager.prototype.destroy = function () {
        var _h, _j;
        (_h = __classPrivateFieldGet(this, _TouchManager_touchManagerAC, "f")) === null || _h === void 0 ? void 0 : _h.abort();
        __classPrivateFieldSet(this, _TouchManager_touchManagerAC, null, "f");
        (_j = __classPrivateFieldGet(this, _TouchManager_pointerDownAC, "f")) === null || _j === void 0 ? void 0 : _j.abort();
        __classPrivateFieldSet(this, _TouchManager_pointerDownAC, null, "f");
    };
    return TouchManager;
}());
_d = TouchManager, _TouchManager_container = new WeakMap(), _TouchManager_isPinching = new WeakMap(), _TouchManager_isPinchingStopped = new WeakMap(), _TouchManager_isPinchingDisabled = new WeakMap(), _TouchManager_onPinchStart = new WeakMap(), _TouchManager_onPinching = new WeakMap(), _TouchManager_onPinchEnd = new WeakMap(), _TouchManager_pointerDownAC = new WeakMap(), _TouchManager_signal = new WeakMap(), _TouchManager_touchInfo = new WeakMap(), _TouchManager_touchManagerAC = new WeakMap(), _TouchManager_touchMoveAC = new WeakMap(), _TouchManager_instances = new WeakSet(), _TouchManager_onTouchStart = function _TouchManager_onTouchStart(evt) {
    var _h;
    var _this = this;
    var _j, _k, _l;
    if ((_j = __classPrivateFieldGet(this, _TouchManager_isPinchingDisabled, "f")) === null || _j === void 0 ? void 0 : _j.call(this)) {
        return;
    }
    if (evt.touches.length === 1) {
        if (__classPrivateFieldGet(this, _TouchManager_pointerDownAC, "f")) {
            return;
        }
        var pointerDownAC = __classPrivateFieldSet(this, _TouchManager_pointerDownAC, new AbortController(), "f");
        var signal = AbortSignal.any([__classPrivateFieldGet(this, _TouchManager_signal, "f"), pointerDownAC.signal]);
        var container = __classPrivateFieldGet(this, _TouchManager_container, "f");
        var opts = {
            capture: true,
            signal: signal,
            passive: false
        };
        var cancelPointerDown_1 = function (e) {
            var _h;
            if (e.pointerType === "touch") {
                (_h = __classPrivateFieldGet(_this, _TouchManager_pointerDownAC, "f")) === null || _h === void 0 ? void 0 : _h.abort();
                __classPrivateFieldSet(_this, _TouchManager_pointerDownAC, null, "f");
            }
        };
        container.addEventListener("pointerdown", function (e) {
            if (e.pointerType === "touch") {
                stopEvent(e);
                cancelPointerDown_1(e);
            }
        }, opts);
        container.addEventListener("pointerup", cancelPointerDown_1, opts);
        container.addEventListener("pointercancel", cancelPointerDown_1, opts);
        return;
    }
    if (!__classPrivateFieldGet(this, _TouchManager_touchMoveAC, "f")) {
        __classPrivateFieldSet(this, _TouchManager_touchMoveAC, new AbortController(), "f");
        var signal = AbortSignal.any([__classPrivateFieldGet(this, _TouchManager_signal, "f"), __classPrivateFieldGet(this, _TouchManager_touchMoveAC, "f").signal]);
        var container = __classPrivateFieldGet(this, _TouchManager_container, "f");
        var opt = {
            signal: signal,
            capture: false,
            passive: false
        };
        container.addEventListener("touchmove", __classPrivateFieldGet(this, _TouchManager_instances, "m", _TouchManager_onTouchMove).bind(this), opt);
        var onTouchEnd = __classPrivateFieldGet(this, _TouchManager_instances, "m", _TouchManager_onTouchEnd).bind(this);
        container.addEventListener("touchend", onTouchEnd, opt);
        container.addEventListener("touchcancel", onTouchEnd, opt);
        opt.capture = true;
        container.addEventListener("pointerdown", stopEvent, opt);
        container.addEventListener("pointermove", stopEvent, opt);
        container.addEventListener("pointercancel", stopEvent, opt);
        container.addEventListener("pointerup", stopEvent, opt);
        (_k = __classPrivateFieldGet(this, _TouchManager_onPinchStart, "f")) === null || _k === void 0 ? void 0 : _k.call(this);
    }
    stopEvent(evt);
    if (evt.touches.length !== 2 || ((_l = __classPrivateFieldGet(this, _TouchManager_isPinchingStopped, "f")) === null || _l === void 0 ? void 0 : _l.call(this))) {
        __classPrivateFieldSet(this, _TouchManager_touchInfo, null, "f");
        return;
    }
    var _m = __read(evt.touches, 2), touch0 = _m[0], touch1 = _m[1];
    if (touch0.identifier > touch1.identifier) {
        _h = __read([touch1, touch0], 2), touch0 = _h[0], touch1 = _h[1];
    }
    __classPrivateFieldSet(this, _TouchManager_touchInfo, {
        touch0X: touch0.screenX,
        touch0Y: touch0.screenY,
        touch1X: touch1.screenX,
        touch1Y: touch1.screenY
    }, "f");
}, _TouchManager_onTouchMove = function _TouchManager_onTouchMove(evt) {
    var _h;
    var _j;
    if (!__classPrivateFieldGet(this, _TouchManager_touchInfo, "f") || evt.touches.length !== 2) {
        return;
    }
    stopEvent(evt);
    var _k = __read(evt.touches, 2), touch0 = _k[0], touch1 = _k[1];
    if (touch0.identifier > touch1.identifier) {
        _h = __read([touch1, touch0], 2), touch0 = _h[0], touch1 = _h[1];
    }
    var screen0X = touch0.screenX, screen0Y = touch0.screenY;
    var screen1X = touch1.screenX, screen1Y = touch1.screenY;
    var touchInfo = __classPrivateFieldGet(this, _TouchManager_touchInfo, "f");
    var pTouch0X = touchInfo.touch0X, pTouch0Y = touchInfo.touch0Y, pTouch1X = touchInfo.touch1X, pTouch1Y = touchInfo.touch1Y;
    var prevGapX = pTouch1X - pTouch0X;
    var prevGapY = pTouch1Y - pTouch0Y;
    var currGapX = screen1X - screen0X;
    var currGapY = screen1Y - screen0Y;
    var distance = Math.hypot(currGapX, currGapY) || 1;
    var pDistance = Math.hypot(prevGapX, prevGapY) || 1;
    if (!__classPrivateFieldGet(this, _TouchManager_isPinching, "f") && Math.abs(pDistance - distance) <= _d.MIN_TOUCH_DISTANCE_TO_PINCH) {
        return;
    }
    touchInfo.touch0X = screen0X;
    touchInfo.touch0Y = screen0Y;
    touchInfo.touch1X = screen1X;
    touchInfo.touch1Y = screen1Y;
    if (!__classPrivateFieldGet(this, _TouchManager_isPinching, "f")) {
        __classPrivateFieldSet(this, _TouchManager_isPinching, true, "f");
        return;
    }
    var origin = [(screen0X + screen1X) / 2, (screen0Y + screen1Y) / 2];
    (_j = __classPrivateFieldGet(this, _TouchManager_onPinching, "f")) === null || _j === void 0 ? void 0 : _j.call(this, origin, pDistance, distance);
}, _TouchManager_onTouchEnd = function _TouchManager_onTouchEnd(evt) {
    var _h;
    if (evt.touches.length >= 2) {
        return;
    }
    if (__classPrivateFieldGet(this, _TouchManager_touchMoveAC, "f")) {
        __classPrivateFieldGet(this, _TouchManager_touchMoveAC, "f").abort();
        __classPrivateFieldSet(this, _TouchManager_touchMoveAC, null, "f");
        (_h = __classPrivateFieldGet(this, _TouchManager_onPinchEnd, "f")) === null || _h === void 0 ? void 0 : _h.call(this);
    }
    if (!__classPrivateFieldGet(this, _TouchManager_touchInfo, "f")) {
        return;
    }
    stopEvent(evt);
    __classPrivateFieldSet(this, _TouchManager_touchInfo, null, "f");
    __classPrivateFieldSet(this, _TouchManager_isPinching, false, "f");
};
; // ./src/display/editor/editor.js
var AnnotationEditor = /** @class */ (function () {
    function AnnotationEditor(parameters) {
        _AnnotationEditor_instances.add(this);
        _AnnotationEditor_accessibilityData.set(this, null);
        _AnnotationEditor_allResizerDivs.set(this, null);
        _AnnotationEditor_altText.set(this, null);
        _AnnotationEditor_disabled.set(this, false);
        _AnnotationEditor_dragPointerId.set(this, null);
        _AnnotationEditor_dragPointerType.set(this, "");
        _AnnotationEditor_keepAspectRatio.set(this, false);
        _AnnotationEditor_resizersDiv.set(this, null);
        _AnnotationEditor_lastPointerCoords.set(this, null);
        _AnnotationEditor_savedDimensions.set(this, null);
        _AnnotationEditor_focusAC.set(this, null);
        _AnnotationEditor_focusedResizerName.set(this, "");
        _AnnotationEditor_hasBeenClicked.set(this, false);
        _AnnotationEditor_initialRect.set(this, null);
        _AnnotationEditor_isEditing.set(this, false);
        _AnnotationEditor_isInEditMode.set(this, false);
        _AnnotationEditor_isResizerEnabledForKeyboard.set(this, false);
        _AnnotationEditor_moveInDOMTimeout.set(this, null);
        _AnnotationEditor_prevDragX.set(this, 0);
        _AnnotationEditor_prevDragY.set(this, 0);
        _AnnotationEditor_telemetryTimeouts.set(this, null);
        _AnnotationEditor_touchManager.set(this, null);
        this._isCopy = false;
        this._editToolbar = null;
        this._initialOptions = Object.create(null);
        this._initialData = null;
        this._isVisible = true;
        this._uiManager = null;
        this._focusEventsAllowed = true;
        _AnnotationEditor_isDraggable.set(this, false);
        _AnnotationEditor_zIndex.set(this, _h._zIndex++);
        this.parent = parameters.parent;
        this.id = parameters.id;
        this.width = this.height = null;
        this.pageIndex = parameters.parent.pageIndex;
        this.name = parameters.name;
        this.div = null;
        this._uiManager = parameters.uiManager;
        this.annotationElementId = null;
        this._willKeepAspectRatio = false;
        this._initialOptions.isCentered = parameters.isCentered;
        this._structTreeParentId = null;
        var _j = this.parent.viewport, rotation = _j.rotation, _k = _j.rawDims, pageWidth = _k.pageWidth, pageHeight = _k.pageHeight, pageX = _k.pageX, pageY = _k.pageY;
        this.rotation = rotation;
        this.pageRotation = (360 + rotation - this._uiManager.viewParameters.rotation) % 360;
        this.pageDimensions = [pageWidth, pageHeight];
        this.pageTranslation = [pageX, pageY];
        var _l = __read(this.parentDimensions, 2), width = _l[0], height = _l[1];
        this.x = parameters.x / width;
        this.y = parameters.y / height;
        this.isAttachedToDOM = false;
        this.deleted = false;
    }
    Object.defineProperty(AnnotationEditor, "_resizerKeyboardManager", {
        get: function () {
            var resize = _h.prototype._resizeWithKeyboard;
            var small = AnnotationEditorUIManager.TRANSLATE_SMALL;
            var big = AnnotationEditorUIManager.TRANSLATE_BIG;
            return shadow(this, "_resizerKeyboardManager", new KeyboardManager([[["ArrowLeft", "mac+ArrowLeft"], resize, {
                        args: [-small, 0]
                    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], resize, {
                        args: [-big, 0]
                    }], [["ArrowRight", "mac+ArrowRight"], resize, {
                        args: [small, 0]
                    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], resize, {
                        args: [big, 0]
                    }], [["ArrowUp", "mac+ArrowUp"], resize, {
                        args: [0, -small]
                    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], resize, {
                        args: [0, -big]
                    }], [["ArrowDown", "mac+ArrowDown"], resize, {
                        args: [0, small]
                    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], resize, {
                        args: [0, big]
                    }], [["Escape", "mac+Escape"], _h.prototype._stopResizingWithKeyboard]]));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "editorType", {
        get: function () {
            return Object.getPrototypeOf(this).constructor._type;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor, "isDrawer", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor, "_defaultLineColor", {
        get: function () {
            return shadow(this, "_defaultLineColor", this._colorManager.getHexCode("CanvasText"));
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.deleteAnnotationElement = function (editor) {
        var fakeEditor = new FakeEditor({
            id: editor.parent.getNextId(),
            parent: editor.parent,
            uiManager: editor._uiManager
        });
        fakeEditor.annotationElementId = editor.annotationElementId;
        fakeEditor.deleted = true;
        fakeEditor._uiManager.addToAnnotationStorage(fakeEditor);
    };
    AnnotationEditor.initialize = function (l10n, _uiManager) {
        var _j;
        (_j = _h._l10n) !== null && _j !== void 0 ? _j : (_h._l10n = l10n);
        _h._l10nResizer || (_h._l10nResizer = Object.freeze({
            topLeft: "pdfjs-editor-resizer-top-left",
            topMiddle: "pdfjs-editor-resizer-top-middle",
            topRight: "pdfjs-editor-resizer-top-right",
            middleRight: "pdfjs-editor-resizer-middle-right",
            bottomRight: "pdfjs-editor-resizer-bottom-right",
            bottomMiddle: "pdfjs-editor-resizer-bottom-middle",
            bottomLeft: "pdfjs-editor-resizer-bottom-left",
            middleLeft: "pdfjs-editor-resizer-middle-left"
        }));
        if (_h._borderLineWidth !== -1) {
            return;
        }
        var style = getComputedStyle(document.documentElement);
        _h._borderLineWidth = parseFloat(style.getPropertyValue("--outline-width")) || 0;
    };
    AnnotationEditor.updateDefaultParams = function (_type, _value) { };
    Object.defineProperty(AnnotationEditor, "defaultPropertiesToUpdate", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.isHandlingMimeForPasting = function (mime) {
        return false;
    };
    AnnotationEditor.paste = function (item, parent) {
        unreachable("Not implemented");
    };
    Object.defineProperty(AnnotationEditor.prototype, "propertiesToUpdate", {
        get: function () {
            return [];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "_isDraggable", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditor_isDraggable, "f");
        },
        set: function (value) {
            var _j;
            __classPrivateFieldSet(this, _AnnotationEditor_isDraggable, value, "f");
            (_j = this.div) === null || _j === void 0 ? void 0 : _j.classList.toggle("draggable", value);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "isEnterHandled", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.center = function () {
        var _j = __read(this.pageDimensions, 2), pageWidth = _j[0], pageHeight = _j[1];
        switch (this.parentRotation) {
            case 90:
                this.x -= this.height * pageHeight / (pageWidth * 2);
                this.y += this.width * pageWidth / (pageHeight * 2);
                break;
            case 180:
                this.x += this.width / 2;
                this.y += this.height / 2;
                break;
            case 270:
                this.x += this.height * pageHeight / (pageWidth * 2);
                this.y -= this.width * pageWidth / (pageHeight * 2);
                break;
            default:
                this.x -= this.width / 2;
                this.y -= this.height / 2;
                break;
        }
        this.fixAndSetPosition();
    };
    AnnotationEditor.prototype.addCommands = function (params) {
        this._uiManager.addCommands(params);
    };
    Object.defineProperty(AnnotationEditor.prototype, "currentLayer", {
        get: function () {
            return this._uiManager.currentLayer;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.setInBackground = function () {
        this.div.style.zIndex = 0;
    };
    AnnotationEditor.prototype.setInForeground = function () {
        this.div.style.zIndex = __classPrivateFieldGet(this, _AnnotationEditor_zIndex, "f");
    };
    AnnotationEditor.prototype.setParent = function (parent) {
        if (parent !== null) {
            this.pageIndex = parent.pageIndex;
            this.pageDimensions = parent.pageDimensions;
        }
        else {
            __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_stopResizing).call(this);
        }
        this.parent = parent;
    };
    AnnotationEditor.prototype.focusin = function (event) {
        if (!this._focusEventsAllowed) {
            return;
        }
        if (!__classPrivateFieldGet(this, _AnnotationEditor_hasBeenClicked, "f")) {
            this.parent.setSelected(this);
        }
        else {
            __classPrivateFieldSet(this, _AnnotationEditor_hasBeenClicked, false, "f");
        }
    };
    AnnotationEditor.prototype.focusout = function (event) {
        var _j;
        if (!this._focusEventsAllowed) {
            return;
        }
        if (!this.isAttachedToDOM) {
            return;
        }
        var target = event.relatedTarget;
        if (target === null || target === void 0 ? void 0 : target.closest("#".concat(this.id))) {
            return;
        }
        event.preventDefault();
        if (!((_j = this.parent) === null || _j === void 0 ? void 0 : _j.isMultipleSelection)) {
            this.commitOrRemove();
        }
    };
    AnnotationEditor.prototype.commitOrRemove = function () {
        if (this.isEmpty()) {
            this.remove();
        }
        else {
            this.commit();
        }
    };
    AnnotationEditor.prototype.commit = function () {
        this.addToAnnotationStorage();
    };
    AnnotationEditor.prototype.addToAnnotationStorage = function () {
        this._uiManager.addToAnnotationStorage(this);
    };
    AnnotationEditor.prototype.setAt = function (x, y, tx, ty) {
        var _j;
        var _k = __read(this.parentDimensions, 2), width = _k[0], height = _k[1];
        _j = __read(this.screenToPageTranslation(tx, ty), 2), tx = _j[0], ty = _j[1];
        this.x = (x + tx) / width;
        this.y = (y + ty) / height;
        this.fixAndSetPosition();
    };
    AnnotationEditor.prototype._moveAfterPaste = function (baseX, baseY) {
        var _j = __read(this.parentDimensions, 2), parentWidth = _j[0], parentHeight = _j[1];
        this.setAt(baseX * parentWidth, baseY * parentHeight, this.width * parentWidth, this.height * parentHeight);
        this._onTranslated();
    };
    AnnotationEditor.prototype.translate = function (x, y) {
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_translate).call(this, this.parentDimensions, x, y);
    };
    AnnotationEditor.prototype.translateInPage = function (x, y) {
        __classPrivateFieldSet(this, _AnnotationEditor_initialRect, __classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f") || [this.x, this.y, this.width, this.height], "f");
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_translate).call(this, this.pageDimensions, x, y);
        this.div.scrollIntoView({
            block: "nearest"
        });
    };
    AnnotationEditor.prototype.translationDone = function () {
        this._onTranslated(this.x, this.y);
    };
    AnnotationEditor.prototype.drag = function (tx, ty) {
        __classPrivateFieldSet(this, _AnnotationEditor_initialRect, __classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f") || [this.x, this.y, this.width, this.height], "f");
        var _j = this, div = _j.div, _k = __read(_j.parentDimensions, 2), parentWidth = _k[0], parentHeight = _k[1];
        this.x += tx / parentWidth;
        this.y += ty / parentHeight;
        if (this.parent && (this.x < 0 || this.x > 1 || this.y < 0 || this.y > 1)) {
            var _l = this.div.getBoundingClientRect(), x_1 = _l.x, y_1 = _l.y;
            if (this.parent.findNewParent(this, x_1, y_1)) {
                this.x -= Math.floor(this.x);
                this.y -= Math.floor(this.y);
            }
        }
        var _m = this, x = _m.x, y = _m.y;
        var _o = __read(this.getBaseTranslation(), 2), bx = _o[0], by = _o[1];
        x += bx;
        y += by;
        var style = div.style;
        style.left = "".concat((100 * x).toFixed(2), "%");
        style.top = "".concat((100 * y).toFixed(2), "%");
        this._onTranslating(x, y);
        div.scrollIntoView({
            block: "nearest"
        });
    };
    AnnotationEditor.prototype._onTranslating = function (x, y) { };
    AnnotationEditor.prototype._onTranslated = function (x, y) { };
    Object.defineProperty(AnnotationEditor.prototype, "_hasBeenMoved", {
        get: function () {
            return !!__classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f") && (__classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f")[0] !== this.x || __classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f")[1] !== this.y);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "_hasBeenResized", {
        get: function () {
            return !!__classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f") && (__classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f")[2] !== this.width || __classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f")[3] !== this.height);
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.getBaseTranslation = function () {
        var _j = __read(this.parentDimensions, 2), parentWidth = _j[0], parentHeight = _j[1];
        var _borderLineWidth = _h._borderLineWidth;
        var x = _borderLineWidth / parentWidth;
        var y = _borderLineWidth / parentHeight;
        switch (this.rotation) {
            case 90:
                return [-x, y];
            case 180:
                return [x, y];
            case 270:
                return [x, -y];
            default:
                return [-x, -y];
        }
    };
    Object.defineProperty(AnnotationEditor.prototype, "_mustFixPosition", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.fixAndSetPosition = function (rotation) {
        if (rotation === void 0) { rotation = this.rotation; }
        var _j = this, style = _j.div.style, _k = __read(_j.pageDimensions, 2), pageWidth = _k[0], pageHeight = _k[1];
        var _l = this, x = _l.x, y = _l.y, width = _l.width, height = _l.height;
        width *= pageWidth;
        height *= pageHeight;
        x *= pageWidth;
        y *= pageHeight;
        if (this._mustFixPosition) {
            switch (rotation) {
                case 0:
                    x = MathClamp(x, 0, pageWidth - width);
                    y = MathClamp(y, 0, pageHeight - height);
                    break;
                case 90:
                    x = MathClamp(x, 0, pageWidth - height);
                    y = MathClamp(y, width, pageHeight);
                    break;
                case 180:
                    x = MathClamp(x, width, pageWidth);
                    y = MathClamp(y, height, pageHeight);
                    break;
                case 270:
                    x = MathClamp(x, height, pageWidth);
                    y = MathClamp(y, 0, pageHeight - width);
                    break;
            }
        }
        this.x = x /= pageWidth;
        this.y = y /= pageHeight;
        var _m = __read(this.getBaseTranslation(), 2), bx = _m[0], by = _m[1];
        x += bx;
        y += by;
        style.left = "".concat((100 * x).toFixed(2), "%");
        style.top = "".concat((100 * y).toFixed(2), "%");
        this.moveInDOM();
    };
    AnnotationEditor.prototype.screenToPageTranslation = function (x, y) {
        return __classPrivateFieldGet(_h, _h, "m", _AnnotationEditor_rotatePoint).call(_h, x, y, this.parentRotation);
    };
    AnnotationEditor.prototype.pageTranslationToScreen = function (x, y) {
        return __classPrivateFieldGet(_h, _h, "m", _AnnotationEditor_rotatePoint).call(_h, x, y, 360 - this.parentRotation);
    };
    Object.defineProperty(AnnotationEditor.prototype, "parentScale", {
        get: function () {
            return this._uiManager.viewParameters.realScale;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "parentRotation", {
        get: function () {
            return (this._uiManager.viewParameters.rotation + this.pageRotation) % 360;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "parentDimensions", {
        get: function () {
            var _j = this, parentScale = _j.parentScale, _k = __read(_j.pageDimensions, 2), pageWidth = _k[0], pageHeight = _k[1];
            return [pageWidth * parentScale, pageHeight * parentScale];
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.setDims = function (width, height) {
        var _j = __read(this.parentDimensions, 2), parentWidth = _j[0], parentHeight = _j[1];
        var style = this.div.style;
        style.width = "".concat((100 * width / parentWidth).toFixed(2), "%");
        if (!__classPrivateFieldGet(this, _AnnotationEditor_keepAspectRatio, "f")) {
            style.height = "".concat((100 * height / parentHeight).toFixed(2), "%");
        }
    };
    AnnotationEditor.prototype.fixDims = function () {
        var style = this.div.style;
        var height = style.height, width = style.width;
        var widthPercent = width.endsWith("%");
        var heightPercent = !__classPrivateFieldGet(this, _AnnotationEditor_keepAspectRatio, "f") && height.endsWith("%");
        if (widthPercent && heightPercent) {
            return;
        }
        var _j = __read(this.parentDimensions, 2), parentWidth = _j[0], parentHeight = _j[1];
        if (!widthPercent) {
            style.width = "".concat((100 * parseFloat(width) / parentWidth).toFixed(2), "%");
        }
        if (!__classPrivateFieldGet(this, _AnnotationEditor_keepAspectRatio, "f") && !heightPercent) {
            style.height = "".concat((100 * parseFloat(height) / parentHeight).toFixed(2), "%");
        }
    };
    AnnotationEditor.prototype.getInitialTranslation = function () {
        return [0, 0];
    };
    AnnotationEditor.prototype._onResized = function () { };
    AnnotationEditor._round = function (x) {
        return Math.round(x * 10000) / 10000;
    };
    AnnotationEditor.prototype._onResizing = function () { };
    AnnotationEditor.prototype.altTextFinish = function () {
        var _j;
        (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.finish();
    };
    AnnotationEditor.prototype.addEditToolbar = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (this._editToolbar || __classPrivateFieldGet(this, _AnnotationEditor_isInEditMode, "f")) {
                            return [2 /*return*/, this._editToolbar];
                        }
                        this._editToolbar = new EditorToolbar(this);
                        this.div.append(this._editToolbar.render());
                        if (!__classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) return [3 /*break*/, 2];
                        return [4 /*yield*/, this._editToolbar.addAltText(__classPrivateFieldGet(this, _AnnotationEditor_altText, "f"))];
                    case 1:
                        _j.sent();
                        _j.label = 2;
                    case 2: return [2 /*return*/, this._editToolbar];
                }
            });
        });
    };
    AnnotationEditor.prototype.removeEditToolbar = function () {
        var _j;
        if (!this._editToolbar) {
            return;
        }
        this._editToolbar.remove();
        this._editToolbar = null;
        (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.destroy();
    };
    AnnotationEditor.prototype.addContainer = function (container) {
        var _j;
        var editToolbarDiv = (_j = this._editToolbar) === null || _j === void 0 ? void 0 : _j.div;
        if (editToolbarDiv) {
            editToolbarDiv.before(container);
        }
        else {
            this.div.append(container);
        }
    };
    AnnotationEditor.prototype.getClientDimensions = function () {
        return this.div.getBoundingClientRect();
    };
    AnnotationEditor.prototype.addAltTextButton = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (__classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) {
                            return [2 /*return*/];
                        }
                        AltText.initialize(_h._l10n);
                        __classPrivateFieldSet(this, _AnnotationEditor_altText, new AltText(this), "f");
                        if (__classPrivateFieldGet(this, _AnnotationEditor_accessibilityData, "f")) {
                            __classPrivateFieldGet(this, _AnnotationEditor_altText, "f").data = __classPrivateFieldGet(this, _AnnotationEditor_accessibilityData, "f");
                            __classPrivateFieldSet(this, _AnnotationEditor_accessibilityData, null, "f");
                        }
                        return [4 /*yield*/, this.addEditToolbar()];
                    case 1:
                        _j.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(AnnotationEditor.prototype, "altTextData", {
        get: function () {
            var _j;
            return (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.data;
        },
        set: function (data) {
            if (!__classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) {
                return;
            }
            __classPrivateFieldGet(this, _AnnotationEditor_altText, "f").data = data;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "guessedAltText", {
        get: function () {
            var _j;
            return (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.guessedText;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.setGuessedAltText = function (text) {
        return __awaiter(this, void 0, void 0, function () {
            var _j;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0: return [4 /*yield*/, ((_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.setGuessedText(text))];
                    case 1:
                        _k.sent();
                        return [2 /*return*/];
                }
            });
        });
    };
    AnnotationEditor.prototype.serializeAltText = function (isForCopying) {
        var _j;
        return (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.serialize(isForCopying);
    };
    AnnotationEditor.prototype.hasAltText = function () {
        return !!__classPrivateFieldGet(this, _AnnotationEditor_altText, "f") && !__classPrivateFieldGet(this, _AnnotationEditor_altText, "f").isEmpty();
    };
    AnnotationEditor.prototype.hasAltTextData = function () {
        var _j, _k;
        return (_k = (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.hasData()) !== null && _k !== void 0 ? _k : false;
    };
    AnnotationEditor.prototype.render = function () {
        var _this = this;
        var _j;
        var div = this.div = document.createElement("div");
        div.setAttribute("data-editor-rotation", (360 - this.rotation) % 360);
        div.className = this.name;
        div.setAttribute("id", this.id);
        div.tabIndex = __classPrivateFieldGet(this, _AnnotationEditor_disabled, "f") ? -1 : 0;
        div.setAttribute("role", "application");
        if (this.defaultL10nId) {
            div.setAttribute("data-l10n-id", this.defaultL10nId);
        }
        if (!this._isVisible) {
            div.classList.add("hidden");
        }
        this.setInForeground();
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_addFocusListeners).call(this);
        var _k = __read(this.parentDimensions, 2), parentWidth = _k[0], parentHeight = _k[1];
        if (this.parentRotation % 180 !== 0) {
            div.style.maxWidth = "".concat((100 * parentHeight / parentWidth).toFixed(2), "%");
            div.style.maxHeight = "".concat((100 * parentWidth / parentHeight).toFixed(2), "%");
        }
        var _l = __read(this.getInitialTranslation(), 2), tx = _l[0], ty = _l[1];
        this.translate(tx, ty);
        bindEvents(this, div, ["keydown", "pointerdown"]);
        if (this.isResizable && this._uiManager._supportsPinchToZoom) {
            __classPrivateFieldSet(this, _AnnotationEditor_touchManager, __classPrivateFieldGet(this, _AnnotationEditor_touchManager, "f") || new TouchManager({
                container: div,
                isPinchingDisabled: function () { return !_this.isSelected; },
                onPinchStart: __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_touchPinchStartCallback).bind(this),
                onPinching: __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_touchPinchCallback).bind(this),
                onPinchEnd: __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_touchPinchEndCallback).bind(this),
                signal: this._uiManager._signal
            }), "f");
        }
        (_j = this._uiManager._editorUndoBar) === null || _j === void 0 ? void 0 : _j.hide();
        return div;
    };
    AnnotationEditor.prototype.pointerdown = function (event) {
        var isMac = util_FeatureTest.platform.isMac;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            event.preventDefault();
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditor_hasBeenClicked, true, "f");
        if (this._isDraggable) {
            __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_setUpDragSession).call(this, event);
            return;
        }
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_selectOnPointerEvent).call(this, event);
    };
    Object.defineProperty(AnnotationEditor.prototype, "isSelected", {
        get: function () {
            return this._uiManager.isSelected(this);
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype._onStartDragging = function () { };
    AnnotationEditor.prototype._onStopDragging = function () { };
    AnnotationEditor.prototype.moveInDOM = function () {
        var _this = this;
        if (__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f"));
        }
        __classPrivateFieldSet(this, _AnnotationEditor_moveInDOMTimeout, setTimeout(function () {
            var _j;
            __classPrivateFieldSet(_this, _AnnotationEditor_moveInDOMTimeout, null, "f");
            (_j = _this.parent) === null || _j === void 0 ? void 0 : _j.moveEditorInDOM(_this);
        }, 0), "f");
    };
    AnnotationEditor.prototype._setParentAndPosition = function (parent, x, y) {
        parent.changeParent(this);
        this.x = x;
        this.y = y;
        this.fixAndSetPosition();
        this._onTranslated();
    };
    AnnotationEditor.prototype.getRect = function (tx, ty, rotation) {
        if (rotation === void 0) { rotation = this.rotation; }
        var scale = this.parentScale;
        var _j = __read(this.pageDimensions, 2), pageWidth = _j[0], pageHeight = _j[1];
        var _k = __read(this.pageTranslation, 2), pageX = _k[0], pageY = _k[1];
        var shiftX = tx / scale;
        var shiftY = ty / scale;
        var x = this.x * pageWidth;
        var y = this.y * pageHeight;
        var width = this.width * pageWidth;
        var height = this.height * pageHeight;
        switch (rotation) {
            case 0:
                return [x + shiftX + pageX, pageHeight - y - shiftY - height + pageY, x + shiftX + width + pageX, pageHeight - y - shiftY + pageY];
            case 90:
                return [x + shiftY + pageX, pageHeight - y + shiftX + pageY, x + shiftY + height + pageX, pageHeight - y + shiftX + width + pageY];
            case 180:
                return [x - shiftX - width + pageX, pageHeight - y + shiftY + pageY, x - shiftX + pageX, pageHeight - y + shiftY + height + pageY];
            case 270:
                return [x - shiftY - height + pageX, pageHeight - y - shiftX - width + pageY, x - shiftY + pageX, pageHeight - y - shiftX + pageY];
            default:
                throw new Error("Invalid rotation");
        }
    };
    AnnotationEditor.prototype.getRectInCurrentCoords = function (rect, pageHeight) {
        var _j = __read(rect, 4), x1 = _j[0], y1 = _j[1], x2 = _j[2], y2 = _j[3];
        var width = x2 - x1;
        var height = y2 - y1;
        switch (this.rotation) {
            case 0:
                return [x1, pageHeight - y2, width, height];
            case 90:
                return [x1, pageHeight - y1, height, width];
            case 180:
                return [x2, pageHeight - y1, width, height];
            case 270:
                return [x2, pageHeight - y2, height, width];
            default:
                throw new Error("Invalid rotation");
        }
    };
    AnnotationEditor.prototype.onceAdded = function (focus) { };
    AnnotationEditor.prototype.isEmpty = function () {
        return false;
    };
    AnnotationEditor.prototype.enableEditMode = function () {
        __classPrivateFieldSet(this, _AnnotationEditor_isInEditMode, true, "f");
    };
    AnnotationEditor.prototype.disableEditMode = function () {
        __classPrivateFieldSet(this, _AnnotationEditor_isInEditMode, false, "f");
    };
    AnnotationEditor.prototype.isInEditMode = function () {
        return __classPrivateFieldGet(this, _AnnotationEditor_isInEditMode, "f");
    };
    AnnotationEditor.prototype.shouldGetKeyboardEvents = function () {
        return __classPrivateFieldGet(this, _AnnotationEditor_isResizerEnabledForKeyboard, "f");
    };
    AnnotationEditor.prototype.needsToBeRebuilt = function () {
        return this.div && !this.isAttachedToDOM;
    };
    Object.defineProperty(AnnotationEditor.prototype, "isOnScreen", {
        get: function () {
            var _j = this.getClientDimensions(), top = _j.top, left = _j.left, bottom = _j.bottom, right = _j.right;
            var innerHeight = window.innerHeight, innerWidth = window.innerWidth;
            return left < innerWidth && right > 0 && top < innerHeight && bottom > 0;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.rebuild = function () {
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_addFocusListeners).call(this);
    };
    AnnotationEditor.prototype.rotate = function (_angle) { };
    AnnotationEditor.prototype.resize = function () { };
    AnnotationEditor.prototype.serializeDeleted = function () {
        var _j;
        return {
            id: this.annotationElementId,
            deleted: true,
            pageIndex: this.pageIndex,
            popupRef: ((_j = this._initialData) === null || _j === void 0 ? void 0 : _j.popupRef) || ""
        };
    };
    AnnotationEditor.prototype.serialize = function (isForCopying, context) {
        if (isForCopying === void 0) { isForCopying = false; }
        if (context === void 0) { context = null; }
        unreachable("An editor must be serializable");
    };
    AnnotationEditor.deserialize = function (data, parent, uiManager) {
        return __awaiter(this, void 0, void 0, function () {
            var editor, _j, pageWidth, pageHeight, _k, x, y, width, height;
            return __generator(this, function (_l) {
                editor = new this.prototype.constructor({
                    parent: parent,
                    id: parent.getNextId(),
                    uiManager: uiManager
                });
                editor.rotation = data.rotation;
                __classPrivateFieldSet(editor, _AnnotationEditor_accessibilityData, data.accessibilityData, "f");
                editor._isCopy = data.isCopy || false;
                _j = __read(editor.pageDimensions, 2), pageWidth = _j[0], pageHeight = _j[1];
                _k = __read(editor.getRectInCurrentCoords(data.rect, pageHeight), 4), x = _k[0], y = _k[1], width = _k[2], height = _k[3];
                editor.x = x / pageWidth;
                editor.y = y / pageHeight;
                editor.width = width / pageWidth;
                editor.height = height / pageHeight;
                return [2 /*return*/, editor];
            });
        });
    };
    Object.defineProperty(AnnotationEditor.prototype, "hasBeenModified", {
        get: function () {
            return !!this.annotationElementId && (this.deleted || this.serialize() !== null);
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.remove = function () {
        var e_56, _j;
        var _k, _l;
        (_k = __classPrivateFieldGet(this, _AnnotationEditor_focusAC, "f")) === null || _k === void 0 ? void 0 : _k.abort();
        __classPrivateFieldSet(this, _AnnotationEditor_focusAC, null, "f");
        if (!this.isEmpty()) {
            this.commit();
        }
        if (this.parent) {
            this.parent.remove(this);
        }
        else {
            this._uiManager.removeEditor(this);
        }
        if (__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _AnnotationEditor_moveInDOMTimeout, "f"));
            __classPrivateFieldSet(this, _AnnotationEditor_moveInDOMTimeout, null, "f");
        }
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_stopResizing).call(this);
        this.removeEditToolbar();
        if (__classPrivateFieldGet(this, _AnnotationEditor_telemetryTimeouts, "f")) {
            try {
                for (var _m = __values(__classPrivateFieldGet(this, _AnnotationEditor_telemetryTimeouts, "f").values()), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var timeout = _o.value;
                    clearTimeout(timeout);
                }
            }
            catch (e_56_1) { e_56 = { error: e_56_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_j = _m.return)) _j.call(_m);
                }
                finally { if (e_56) throw e_56.error; }
            }
            __classPrivateFieldSet(this, _AnnotationEditor_telemetryTimeouts, null, "f");
        }
        this.parent = null;
        (_l = __classPrivateFieldGet(this, _AnnotationEditor_touchManager, "f")) === null || _l === void 0 ? void 0 : _l.destroy();
        __classPrivateFieldSet(this, _AnnotationEditor_touchManager, null, "f");
    };
    Object.defineProperty(AnnotationEditor.prototype, "isResizable", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.makeResizable = function () {
        if (this.isResizable) {
            __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_createResizers).call(this);
            __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").classList.remove("hidden");
        }
    };
    Object.defineProperty(AnnotationEditor.prototype, "toolbarPosition", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.keydown = function (event) {
        var e_57, _j, e_58, _k, e_59, _l;
        if (!this.isResizable || event.target !== this.div || event.key !== "Enter") {
            return;
        }
        this._uiManager.setSelected(this);
        __classPrivateFieldSet(this, _AnnotationEditor_savedDimensions, {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        }, "f");
        var children = __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").children;
        if (!__classPrivateFieldGet(this, _AnnotationEditor_allResizerDivs, "f")) {
            __classPrivateFieldSet(this, _AnnotationEditor_allResizerDivs, Array.from(children), "f");
            var boundResizerKeydown = __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resizerKeydown).bind(this);
            var boundResizerBlur = __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resizerBlur).bind(this);
            var signal = this._uiManager._signal;
            try {
                for (var _m = __values(__classPrivateFieldGet(this, _AnnotationEditor_allResizerDivs, "f")), _o = _m.next(); !_o.done; _o = _m.next()) {
                    var div = _o.value;
                    var name = div.getAttribute("data-resizer-name");
                    div.setAttribute("role", "spinbutton");
                    div.addEventListener("keydown", boundResizerKeydown, {
                        signal: signal
                    });
                    div.addEventListener("blur", boundResizerBlur, {
                        signal: signal
                    });
                    div.addEventListener("focus", __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resizerFocus).bind(this, name), {
                        signal: signal
                    });
                    div.setAttribute("data-l10n-id", _h._l10nResizer[name]);
                }
            }
            catch (e_57_1) { e_57 = { error: e_57_1 }; }
            finally {
                try {
                    if (_o && !_o.done && (_j = _m.return)) _j.call(_m);
                }
                finally { if (e_57) throw e_57.error; }
            }
        }
        var first = __classPrivateFieldGet(this, _AnnotationEditor_allResizerDivs, "f")[0];
        var firstPosition = 0;
        try {
            for (var children_1 = __values(children), children_1_1 = children_1.next(); !children_1_1.done; children_1_1 = children_1.next()) {
                var div = children_1_1.value;
                if (div === first) {
                    break;
                }
                firstPosition++;
            }
        }
        catch (e_58_1) { e_58 = { error: e_58_1 }; }
        finally {
            try {
                if (children_1_1 && !children_1_1.done && (_k = children_1.return)) _k.call(children_1);
            }
            finally { if (e_58) throw e_58.error; }
        }
        var nextFirstPosition = (360 - this.rotation + this.parentRotation) % 360 / 90 * (__classPrivateFieldGet(this, _AnnotationEditor_allResizerDivs, "f").length / 4);
        if (nextFirstPosition !== firstPosition) {
            if (nextFirstPosition < firstPosition) {
                for (var i_1 = 0; i_1 < firstPosition - nextFirstPosition; i_1++) {
                    __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").append(__classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").firstChild);
                }
            }
            else if (nextFirstPosition > firstPosition) {
                for (var i_2 = 0; i_2 < nextFirstPosition - firstPosition; i_2++) {
                    __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").firstChild.before(__classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").lastChild);
                }
            }
            var i = 0;
            try {
                for (var children_2 = __values(children), children_2_1 = children_2.next(); !children_2_1.done; children_2_1 = children_2.next()) {
                    var child = children_2_1.value;
                    var div = __classPrivateFieldGet(this, _AnnotationEditor_allResizerDivs, "f")[i++];
                    var name = div.getAttribute("data-resizer-name");
                    child.setAttribute("data-l10n-id", _h._l10nResizer[name]);
                }
            }
            catch (e_59_1) { e_59 = { error: e_59_1 }; }
            finally {
                try {
                    if (children_2_1 && !children_2_1.done && (_l = children_2.return)) _l.call(children_2);
                }
                finally { if (e_59) throw e_59.error; }
            }
        }
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_setResizerTabIndex).call(this, 0);
        __classPrivateFieldSet(this, _AnnotationEditor_isResizerEnabledForKeyboard, true, "f");
        __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").firstChild.focus({
            focusVisible: true
        });
        event.preventDefault();
        event.stopImmediatePropagation();
    };
    AnnotationEditor.prototype._resizeWithKeyboard = function (x, y) {
        if (!__classPrivateFieldGet(this, _AnnotationEditor_isResizerEnabledForKeyboard, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resizerPointermove).call(this, __classPrivateFieldGet(this, _AnnotationEditor_focusedResizerName, "f"), {
            deltaX: x,
            deltaY: y,
            fromKeyboard: true
        });
    };
    AnnotationEditor.prototype._stopResizingWithKeyboard = function () {
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_stopResizing).call(this);
        this.div.focus();
    };
    AnnotationEditor.prototype.select = function () {
        var _this = this;
        var _j, _k, _l;
        this.makeResizable();
        (_j = this.div) === null || _j === void 0 ? void 0 : _j.classList.add("selectedEditor");
        if (!this._editToolbar) {
            this.addEditToolbar().then(function () {
                var _j, _k;
                if ((_j = _this.div) === null || _j === void 0 ? void 0 : _j.classList.contains("selectedEditor")) {
                    (_k = _this._editToolbar) === null || _k === void 0 ? void 0 : _k.show();
                }
            });
            return;
        }
        (_k = this._editToolbar) === null || _k === void 0 ? void 0 : _k.show();
        (_l = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _l === void 0 ? void 0 : _l.toggleAltTextBadge(false);
    };
    AnnotationEditor.prototype.unselect = function () {
        var _j, _k, _l, _m, _o;
        (_j = __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f")) === null || _j === void 0 ? void 0 : _j.classList.add("hidden");
        (_k = this.div) === null || _k === void 0 ? void 0 : _k.classList.remove("selectedEditor");
        if ((_l = this.div) === null || _l === void 0 ? void 0 : _l.contains(document.activeElement)) {
            this._uiManager.currentLayer.div.focus({
                preventScroll: true
            });
        }
        (_m = this._editToolbar) === null || _m === void 0 ? void 0 : _m.hide();
        (_o = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _o === void 0 ? void 0 : _o.toggleAltTextBadge(true);
    };
    AnnotationEditor.prototype.updateParams = function (type, value) { };
    AnnotationEditor.prototype.disableEditing = function () { };
    AnnotationEditor.prototype.enableEditing = function () { };
    AnnotationEditor.prototype.enterInEditMode = function () { };
    AnnotationEditor.prototype.getElementForAltText = function () {
        return this.div;
    };
    Object.defineProperty(AnnotationEditor.prototype, "contentDiv", {
        get: function () {
            return this.div;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "isEditing", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditor_isEditing, "f");
        },
        set: function (value) {
            __classPrivateFieldSet(this, _AnnotationEditor_isEditing, value, "f");
            if (!this.parent) {
                return;
            }
            if (value) {
                this.parent.setSelected(this);
                this.parent.setActiveEditor(this);
            }
            else {
                this.parent.setActiveEditor(null);
            }
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype.setAspectRatio = function (width, height) {
        __classPrivateFieldSet(this, _AnnotationEditor_keepAspectRatio, true, "f");
        var aspectRatio = width / height;
        var style = this.div.style;
        style.aspectRatio = aspectRatio;
        style.height = "auto";
    };
    Object.defineProperty(AnnotationEditor, "MIN_SIZE", {
        get: function () {
            return 16;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.canCreateNewEmptyEditor = function () {
        return true;
    };
    Object.defineProperty(AnnotationEditor.prototype, "telemetryInitialData", {
        get: function () {
            return {
                action: "added"
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditor.prototype, "telemetryFinalData", {
        get: function () {
            return null;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditor.prototype._reportTelemetry = function (data, mustWait) {
        var _this = this;
        if (mustWait === void 0) { mustWait = false; }
        if (mustWait) {
            __classPrivateFieldSet(this, _AnnotationEditor_telemetryTimeouts, __classPrivateFieldGet(this, _AnnotationEditor_telemetryTimeouts, "f") || new Map(), "f");
            var action_1 = data.action;
            var timeout = __classPrivateFieldGet(this, _AnnotationEditor_telemetryTimeouts, "f").get(action_1);
            if (timeout) {
                clearTimeout(timeout);
            }
            timeout = setTimeout(function () {
                _this._reportTelemetry(data);
                __classPrivateFieldGet(_this, _AnnotationEditor_telemetryTimeouts, "f").delete(action_1);
                if (__classPrivateFieldGet(_this, _AnnotationEditor_telemetryTimeouts, "f").size === 0) {
                    __classPrivateFieldSet(_this, _AnnotationEditor_telemetryTimeouts, null, "f");
                }
            }, _h._telemetryTimeout);
            __classPrivateFieldGet(this, _AnnotationEditor_telemetryTimeouts, "f").set(action_1, timeout);
            return;
        }
        data.type || (data.type = this.editorType);
        this._uiManager._eventBus.dispatch("reporttelemetry", {
            source: this,
            details: {
                type: "editing",
                data: data
            }
        });
    };
    AnnotationEditor.prototype.show = function (visible) {
        if (visible === void 0) { visible = this._isVisible; }
        this.div.classList.toggle("hidden", !visible);
        this._isVisible = visible;
    };
    AnnotationEditor.prototype.enable = function () {
        if (this.div) {
            this.div.tabIndex = 0;
        }
        __classPrivateFieldSet(this, _AnnotationEditor_disabled, false, "f");
    };
    AnnotationEditor.prototype.disable = function () {
        if (this.div) {
            this.div.tabIndex = -1;
        }
        __classPrivateFieldSet(this, _AnnotationEditor_disabled, true, "f");
    };
    AnnotationEditor.prototype.renderAnnotationElement = function (annotation) {
        var content = annotation.container.querySelector(".annotationContent");
        if (!content) {
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            annotation.container.prepend(content);
        }
        else if (content.nodeName === "CANVAS") {
            var canvas = content;
            content = document.createElement("div");
            content.classList.add("annotationContent", this.editorType);
            canvas.before(content);
        }
        return content;
    };
    AnnotationEditor.prototype.resetAnnotationElement = function (annotation) {
        var firstChild = annotation.container.firstChild;
        if ((firstChild === null || firstChild === void 0 ? void 0 : firstChild.nodeName) === "DIV" && firstChild.classList.contains("annotationContent")) {
            firstChild.remove();
        }
    };
    var _AnnotationEditor_instances, _h, _AnnotationEditor_accessibilityData, _AnnotationEditor_allResizerDivs, _AnnotationEditor_altText, _AnnotationEditor_disabled, _AnnotationEditor_dragPointerId, _AnnotationEditor_dragPointerType, _AnnotationEditor_keepAspectRatio, _AnnotationEditor_resizersDiv, _AnnotationEditor_lastPointerCoords, _AnnotationEditor_savedDimensions, _AnnotationEditor_focusAC, _AnnotationEditor_focusedResizerName, _AnnotationEditor_hasBeenClicked, _AnnotationEditor_initialRect, _AnnotationEditor_isEditing, _AnnotationEditor_isInEditMode, _AnnotationEditor_isResizerEnabledForKeyboard, _AnnotationEditor_moveInDOMTimeout, _AnnotationEditor_prevDragX, _AnnotationEditor_prevDragY, _AnnotationEditor_telemetryTimeouts, _AnnotationEditor_touchManager, _AnnotationEditor_isDraggable, _AnnotationEditor_zIndex, _AnnotationEditor_translate, _AnnotationEditor_rotatePoint, _AnnotationEditor_getRotationMatrix, _AnnotationEditor_createResizers, _AnnotationEditor_resizerPointerdown, _AnnotationEditor_resize, _AnnotationEditor_addResizeToUndoStack, _AnnotationEditor_resizerPointermove, _AnnotationEditor_touchPinchStartCallback, _AnnotationEditor_touchPinchCallback, _AnnotationEditor_touchPinchEndCallback, _AnnotationEditor_selectOnPointerEvent, _AnnotationEditor_setUpDragSession, _AnnotationEditor_addFocusListeners, _AnnotationEditor_resizerKeydown, _AnnotationEditor_resizerBlur, _AnnotationEditor_resizerFocus, _AnnotationEditor_setResizerTabIndex, _AnnotationEditor_stopResizing;
    _h = AnnotationEditor, _AnnotationEditor_accessibilityData = new WeakMap(), _AnnotationEditor_allResizerDivs = new WeakMap(), _AnnotationEditor_altText = new WeakMap(), _AnnotationEditor_disabled = new WeakMap(), _AnnotationEditor_dragPointerId = new WeakMap(), _AnnotationEditor_dragPointerType = new WeakMap(), _AnnotationEditor_keepAspectRatio = new WeakMap(), _AnnotationEditor_resizersDiv = new WeakMap(), _AnnotationEditor_lastPointerCoords = new WeakMap(), _AnnotationEditor_savedDimensions = new WeakMap(), _AnnotationEditor_focusAC = new WeakMap(), _AnnotationEditor_focusedResizerName = new WeakMap(), _AnnotationEditor_hasBeenClicked = new WeakMap(), _AnnotationEditor_initialRect = new WeakMap(), _AnnotationEditor_isEditing = new WeakMap(), _AnnotationEditor_isInEditMode = new WeakMap(), _AnnotationEditor_isResizerEnabledForKeyboard = new WeakMap(), _AnnotationEditor_moveInDOMTimeout = new WeakMap(), _AnnotationEditor_prevDragX = new WeakMap(), _AnnotationEditor_prevDragY = new WeakMap(), _AnnotationEditor_telemetryTimeouts = new WeakMap(), _AnnotationEditor_touchManager = new WeakMap(), _AnnotationEditor_isDraggable = new WeakMap(), _AnnotationEditor_zIndex = new WeakMap(), _AnnotationEditor_instances = new WeakSet(), _AnnotationEditor_translate = function _AnnotationEditor_translate(_j, x, y) {
        var _k;
        var _l = __read(_j, 2), width = _l[0], height = _l[1];
        _k = __read(this.screenToPageTranslation(x, y), 2), x = _k[0], y = _k[1];
        this.x += x / width;
        this.y += y / height;
        this._onTranslating(this.x, this.y);
        this.fixAndSetPosition();
    }, _AnnotationEditor_rotatePoint = function _AnnotationEditor_rotatePoint(x, y, angle) {
        switch (angle) {
            case 90:
                return [y, -x];
            case 180:
                return [-x, -y];
            case 270:
                return [-y, x];
            default:
                return [x, y];
        }
    }, _AnnotationEditor_getRotationMatrix = function _AnnotationEditor_getRotationMatrix(rotation) {
        switch (rotation) {
            case 90:
                {
                    var _j = __read(this.pageDimensions, 2), pageWidth = _j[0], pageHeight = _j[1];
                    return [0, -pageWidth / pageHeight, pageHeight / pageWidth, 0];
                }
            case 180:
                return [-1, 0, 0, -1];
            case 270:
                {
                    var _k = __read(this.pageDimensions, 2), pageWidth = _k[0], pageHeight = _k[1];
                    return [0, pageWidth / pageHeight, -pageHeight / pageWidth, 0];
                }
            default:
                return [1, 0, 0, 1];
        }
    }, _AnnotationEditor_createResizers = function _AnnotationEditor_createResizers() {
        var e_60, _j;
        if (__classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditor_resizersDiv, document.createElement("div"), "f");
        __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").classList.add("resizers");
        var classes = this._willKeepAspectRatio ? ["topLeft", "topRight", "bottomRight", "bottomLeft"] : ["topLeft", "topMiddle", "topRight", "middleRight", "bottomRight", "bottomMiddle", "bottomLeft", "middleLeft"];
        var signal = this._uiManager._signal;
        try {
            for (var classes_1 = __values(classes), classes_1_1 = classes_1.next(); !classes_1_1.done; classes_1_1 = classes_1.next()) {
                var name = classes_1_1.value;
                var div = document.createElement("div");
                __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f").append(div);
                div.classList.add("resizer", name);
                div.setAttribute("data-resizer-name", name);
                div.addEventListener("pointerdown", __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resizerPointerdown).bind(this, name), {
                    signal: signal
                });
                div.addEventListener("contextmenu", noContextMenu, {
                    signal: signal
                });
                div.tabIndex = -1;
            }
        }
        catch (e_60_1) { e_60 = { error: e_60_1 }; }
        finally {
            try {
                if (classes_1_1 && !classes_1_1.done && (_j = classes_1.return)) _j.call(classes_1);
            }
            finally { if (e_60) throw e_60.error; }
        }
        this.div.prepend(__classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f"));
    }, _AnnotationEditor_resizerPointerdown = function _AnnotationEditor_resizerPointerdown(name, event) {
        var _this = this;
        var _j;
        event.preventDefault();
        var isMac = util_FeatureTest.platform.isMac;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            return;
        }
        (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.toggle(false);
        var savedDraggable = this._isDraggable;
        this._isDraggable = false;
        __classPrivateFieldSet(this, _AnnotationEditor_lastPointerCoords, [event.screenX, event.screenY], "f");
        var ac = new AbortController();
        var signal = this._uiManager.combinedSignal(ac);
        this.parent.togglePointerEvents(false);
        window.addEventListener("pointermove", __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resizerPointermove).bind(this, name), {
            passive: true,
            capture: true,
            signal: signal
        });
        window.addEventListener("touchmove", stopEvent, {
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", noContextMenu, {
            signal: signal
        });
        __classPrivateFieldSet(this, _AnnotationEditor_savedDimensions, {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        }, "f");
        var savedParentCursor = this.parent.div.style.cursor;
        var savedCursor = this.div.style.cursor;
        this.div.style.cursor = this.parent.div.style.cursor = window.getComputedStyle(event.target).cursor;
        var pointerUpCallback = function () {
            var _j;
            ac.abort();
            _this.parent.togglePointerEvents(true);
            (_j = __classPrivateFieldGet(_this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.toggle(true);
            _this._isDraggable = savedDraggable;
            _this.parent.div.style.cursor = savedParentCursor;
            _this.div.style.cursor = savedCursor;
            __classPrivateFieldGet(_this, _AnnotationEditor_instances, "m", _AnnotationEditor_addResizeToUndoStack).call(_this);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }, _AnnotationEditor_resize = function _AnnotationEditor_resize(x, y, width, height) {
        this.width = width;
        this.height = height;
        this.x = x;
        this.y = y;
        var _j = __read(this.parentDimensions, 2), parentWidth = _j[0], parentHeight = _j[1];
        this.setDims(parentWidth * width, parentHeight * height);
        this.fixAndSetPosition();
        this._onResized();
    }, _AnnotationEditor_addResizeToUndoStack = function _AnnotationEditor_addResizeToUndoStack() {
        if (!__classPrivateFieldGet(this, _AnnotationEditor_savedDimensions, "f")) {
            return;
        }
        var _j = __classPrivateFieldGet(this, _AnnotationEditor_savedDimensions, "f"), savedX = _j.savedX, savedY = _j.savedY, savedWidth = _j.savedWidth, savedHeight = _j.savedHeight;
        __classPrivateFieldSet(this, _AnnotationEditor_savedDimensions, null, "f");
        var newX = this.x;
        var newY = this.y;
        var newWidth = this.width;
        var newHeight = this.height;
        if (newX === savedX && newY === savedY && newWidth === savedWidth && newHeight === savedHeight) {
            return;
        }
        this.addCommands({
            cmd: __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resize).bind(this, newX, newY, newWidth, newHeight),
            undo: __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_resize).bind(this, savedX, savedY, savedWidth, savedHeight),
            mustExec: true
        });
    }, _AnnotationEditor_resizerPointermove = function _AnnotationEditor_resizerPointermove(name, event) {
        var _j, _k;
        var _l = __read(this.parentDimensions, 2), parentWidth = _l[0], parentHeight = _l[1];
        var savedX = this.x;
        var savedY = this.y;
        var savedWidth = this.width;
        var savedHeight = this.height;
        var minWidth = _h.MIN_SIZE / parentWidth;
        var minHeight = _h.MIN_SIZE / parentHeight;
        var rotationMatrix = __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_getRotationMatrix).call(this, this.rotation);
        var transf = function (x, y) { return [rotationMatrix[0] * x + rotationMatrix[2] * y, rotationMatrix[1] * x + rotationMatrix[3] * y]; };
        var invRotationMatrix = __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_getRotationMatrix).call(this, 360 - this.rotation);
        var invTransf = function (x, y) { return [invRotationMatrix[0] * x + invRotationMatrix[2] * y, invRotationMatrix[1] * x + invRotationMatrix[3] * y]; };
        var getPoint;
        var getOpposite;
        var isDiagonal = false;
        var isHorizontal = false;
        switch (name) {
            case "topLeft":
                isDiagonal = true;
                getPoint = function (w, h) { return [0, 0]; };
                getOpposite = function (w, h) { return [w, h]; };
                break;
            case "topMiddle":
                getPoint = function (w, h) { return [w / 2, 0]; };
                getOpposite = function (w, h) { return [w / 2, h]; };
                break;
            case "topRight":
                isDiagonal = true;
                getPoint = function (w, h) { return [w, 0]; };
                getOpposite = function (w, h) { return [0, h]; };
                break;
            case "middleRight":
                isHorizontal = true;
                getPoint = function (w, h) { return [w, h / 2]; };
                getOpposite = function (w, h) { return [0, h / 2]; };
                break;
            case "bottomRight":
                isDiagonal = true;
                getPoint = function (w, h) { return [w, h]; };
                getOpposite = function (w, h) { return [0, 0]; };
                break;
            case "bottomMiddle":
                getPoint = function (w, h) { return [w / 2, h]; };
                getOpposite = function (w, h) { return [w / 2, 0]; };
                break;
            case "bottomLeft":
                isDiagonal = true;
                getPoint = function (w, h) { return [0, h]; };
                getOpposite = function (w, h) { return [w, 0]; };
                break;
            case "middleLeft":
                isHorizontal = true;
                getPoint = function (w, h) { return [0, h / 2]; };
                getOpposite = function (w, h) { return [w, h / 2]; };
                break;
        }
        var point = getPoint(savedWidth, savedHeight);
        var oppositePoint = getOpposite(savedWidth, savedHeight);
        var transfOppositePoint = transf.apply(void 0, __spreadArray([], __read(oppositePoint), false));
        var oppositeX = _h._round(savedX + transfOppositePoint[0]);
        var oppositeY = _h._round(savedY + transfOppositePoint[1]);
        var ratioX = 1;
        var ratioY = 1;
        var deltaX, deltaY;
        if (!event.fromKeyboard) {
            var screenX = event.screenX, screenY = event.screenY;
            var _m = __read(__classPrivateFieldGet(this, _AnnotationEditor_lastPointerCoords, "f"), 2), lastScreenX = _m[0], lastScreenY = _m[1];
            _j = __read(this.screenToPageTranslation(screenX - lastScreenX, screenY - lastScreenY), 2), deltaX = _j[0], deltaY = _j[1];
            __classPrivateFieldGet(this, _AnnotationEditor_lastPointerCoords, "f")[0] = screenX;
            __classPrivateFieldGet(this, _AnnotationEditor_lastPointerCoords, "f")[1] = screenY;
        }
        else {
            (deltaX = event.deltaX, deltaY = event.deltaY);
        }
        _k = __read(invTransf(deltaX / parentWidth, deltaY / parentHeight), 2), deltaX = _k[0], deltaY = _k[1];
        if (isDiagonal) {
            var oldDiag = Math.hypot(savedWidth, savedHeight);
            ratioX = ratioY = Math.max(Math.min(Math.hypot(oppositePoint[0] - point[0] - deltaX, oppositePoint[1] - point[1] - deltaY) / oldDiag, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        }
        else if (isHorizontal) {
            ratioX = MathClamp(Math.abs(oppositePoint[0] - point[0] - deltaX), minWidth, 1) / savedWidth;
        }
        else {
            ratioY = MathClamp(Math.abs(oppositePoint[1] - point[1] - deltaY), minHeight, 1) / savedHeight;
        }
        var newWidth = _h._round(savedWidth * ratioX);
        var newHeight = _h._round(savedHeight * ratioY);
        transfOppositePoint = transf.apply(void 0, __spreadArray([], __read(getOpposite(newWidth, newHeight)), false));
        var newX = oppositeX - transfOppositePoint[0];
        var newY = oppositeY - transfOppositePoint[1];
        __classPrivateFieldSet(this, _AnnotationEditor_initialRect, __classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f") || [this.x, this.y, this.width, this.height], "f");
        this.width = newWidth;
        this.height = newHeight;
        this.x = newX;
        this.y = newY;
        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
        this.fixAndSetPosition();
        this._onResizing();
    }, _AnnotationEditor_touchPinchStartCallback = function _AnnotationEditor_touchPinchStartCallback() {
        var _j;
        __classPrivateFieldSet(this, _AnnotationEditor_savedDimensions, {
            savedX: this.x,
            savedY: this.y,
            savedWidth: this.width,
            savedHeight: this.height
        }, "f");
        (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.toggle(false);
        this.parent.togglePointerEvents(false);
    }, _AnnotationEditor_touchPinchCallback = function _AnnotationEditor_touchPinchCallback(_origin, prevDistance, distance) {
        var slowDownFactor = 0.7;
        var factor = slowDownFactor * (distance / prevDistance) + 1 - slowDownFactor;
        if (factor === 1) {
            return;
        }
        var rotationMatrix = __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_getRotationMatrix).call(this, this.rotation);
        var transf = function (x, y) { return [rotationMatrix[0] * x + rotationMatrix[2] * y, rotationMatrix[1] * x + rotationMatrix[3] * y]; };
        var _j = __read(this.parentDimensions, 2), parentWidth = _j[0], parentHeight = _j[1];
        var savedX = this.x;
        var savedY = this.y;
        var savedWidth = this.width;
        var savedHeight = this.height;
        var minWidth = _h.MIN_SIZE / parentWidth;
        var minHeight = _h.MIN_SIZE / parentHeight;
        factor = Math.max(Math.min(factor, 1 / savedWidth, 1 / savedHeight), minWidth / savedWidth, minHeight / savedHeight);
        var newWidth = _h._round(savedWidth * factor);
        var newHeight = _h._round(savedHeight * factor);
        if (newWidth === savedWidth && newHeight === savedHeight) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditor_initialRect, __classPrivateFieldGet(this, _AnnotationEditor_initialRect, "f") || [savedX, savedY, savedWidth, savedHeight], "f");
        var transfCenterPoint = transf(savedWidth / 2, savedHeight / 2);
        var centerX = _h._round(savedX + transfCenterPoint[0]);
        var centerY = _h._round(savedY + transfCenterPoint[1]);
        var newTransfCenterPoint = transf(newWidth / 2, newHeight / 2);
        this.x = centerX - newTransfCenterPoint[0];
        this.y = centerY - newTransfCenterPoint[1];
        this.width = newWidth;
        this.height = newHeight;
        this.setDims(parentWidth * newWidth, parentHeight * newHeight);
        this.fixAndSetPosition();
        this._onResizing();
    }, _AnnotationEditor_touchPinchEndCallback = function _AnnotationEditor_touchPinchEndCallback() {
        var _j;
        (_j = __classPrivateFieldGet(this, _AnnotationEditor_altText, "f")) === null || _j === void 0 ? void 0 : _j.toggle(true);
        this.parent.togglePointerEvents(true);
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_addResizeToUndoStack).call(this);
    }, _AnnotationEditor_selectOnPointerEvent = function _AnnotationEditor_selectOnPointerEvent(event) {
        var isMac = util_FeatureTest.platform.isMac;
        if (event.ctrlKey && !isMac || event.shiftKey || event.metaKey && isMac) {
            this.parent.toggleSelected(this);
        }
        else {
            this.parent.setSelected(this);
        }
    }, _AnnotationEditor_setUpDragSession = function _AnnotationEditor_setUpDragSession(event) {
        var _this = this;
        var isSelected = this.isSelected;
        this._uiManager.setUpDragSession();
        var hasDraggingStarted = false;
        var ac = new AbortController();
        var signal = this._uiManager.combinedSignal(ac);
        var opts = {
            capture: true,
            passive: false,
            signal: signal
        };
        var cancelDrag = function (e) {
            ac.abort();
            __classPrivateFieldSet(_this, _AnnotationEditor_dragPointerId, null, "f");
            __classPrivateFieldSet(_this, _AnnotationEditor_hasBeenClicked, false, "f");
            if (!_this._uiManager.endDragSession()) {
                __classPrivateFieldGet(_this, _AnnotationEditor_instances, "m", _AnnotationEditor_selectOnPointerEvent).call(_this, e);
            }
            if (hasDraggingStarted) {
                _this._onStopDragging();
            }
        };
        if (isSelected) {
            __classPrivateFieldSet(this, _AnnotationEditor_prevDragX, event.clientX, "f");
            __classPrivateFieldSet(this, _AnnotationEditor_prevDragY, event.clientY, "f");
            __classPrivateFieldSet(this, _AnnotationEditor_dragPointerId, event.pointerId, "f");
            __classPrivateFieldSet(this, _AnnotationEditor_dragPointerType, event.pointerType, "f");
            window.addEventListener("pointermove", function (e) {
                if (!hasDraggingStarted) {
                    hasDraggingStarted = true;
                    _this._onStartDragging();
                }
                var x = e.clientX, y = e.clientY, pointerId = e.pointerId;
                if (pointerId !== __classPrivateFieldGet(_this, _AnnotationEditor_dragPointerId, "f")) {
                    stopEvent(e);
                    return;
                }
                var _j = __read(_this.screenToPageTranslation(x - __classPrivateFieldGet(_this, _AnnotationEditor_prevDragX, "f"), y - __classPrivateFieldGet(_this, _AnnotationEditor_prevDragY, "f")), 2), tx = _j[0], ty = _j[1];
                __classPrivateFieldSet(_this, _AnnotationEditor_prevDragX, x, "f");
                __classPrivateFieldSet(_this, _AnnotationEditor_prevDragY, y, "f");
                _this._uiManager.dragSelectedEditors(tx, ty);
            }, opts);
            window.addEventListener("touchmove", stopEvent, opts);
            window.addEventListener("pointerdown", function (e) {
                if (e.pointerType === __classPrivateFieldGet(_this, _AnnotationEditor_dragPointerType, "f")) {
                    if (__classPrivateFieldGet(_this, _AnnotationEditor_touchManager, "f") || e.isPrimary) {
                        cancelDrag(e);
                    }
                }
                stopEvent(e);
            }, opts);
        }
        var pointerUpCallback = function (e) {
            if (!__classPrivateFieldGet(_this, _AnnotationEditor_dragPointerId, "f") || __classPrivateFieldGet(_this, _AnnotationEditor_dragPointerId, "f") === e.pointerId) {
                cancelDrag(e);
                return;
            }
            stopEvent(e);
        };
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
    }, _AnnotationEditor_addFocusListeners = function _AnnotationEditor_addFocusListeners() {
        if (__classPrivateFieldGet(this, _AnnotationEditor_focusAC, "f") || !this.div) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditor_focusAC, new AbortController(), "f");
        var signal = this._uiManager.combinedSignal(__classPrivateFieldGet(this, _AnnotationEditor_focusAC, "f"));
        this.div.addEventListener("focusin", this.focusin.bind(this), {
            signal: signal
        });
        this.div.addEventListener("focusout", this.focusout.bind(this), {
            signal: signal
        });
    }, _AnnotationEditor_resizerKeydown = function _AnnotationEditor_resizerKeydown(event) {
        _h._resizerKeyboardManager.exec(this, event);
    }, _AnnotationEditor_resizerBlur = function _AnnotationEditor_resizerBlur(event) {
        var _j;
        if (__classPrivateFieldGet(this, _AnnotationEditor_isResizerEnabledForKeyboard, "f") && ((_j = event.relatedTarget) === null || _j === void 0 ? void 0 : _j.parentNode) !== __classPrivateFieldGet(this, _AnnotationEditor_resizersDiv, "f")) {
            __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_stopResizing).call(this);
        }
    }, _AnnotationEditor_resizerFocus = function _AnnotationEditor_resizerFocus(name) {
        __classPrivateFieldSet(this, _AnnotationEditor_focusedResizerName, __classPrivateFieldGet(this, _AnnotationEditor_isResizerEnabledForKeyboard, "f") ? name : "", "f");
    }, _AnnotationEditor_setResizerTabIndex = function _AnnotationEditor_setResizerTabIndex(value) {
        var e_61, _j;
        if (!__classPrivateFieldGet(this, _AnnotationEditor_allResizerDivs, "f")) {
            return;
        }
        try {
            for (var _k = __values(__classPrivateFieldGet(this, _AnnotationEditor_allResizerDivs, "f")), _l = _k.next(); !_l.done; _l = _k.next()) {
                var div = _l.value;
                div.tabIndex = value;
            }
        }
        catch (e_61_1) { e_61 = { error: e_61_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
            }
            finally { if (e_61) throw e_61.error; }
        }
    }, _AnnotationEditor_stopResizing = function _AnnotationEditor_stopResizing() {
        __classPrivateFieldSet(this, _AnnotationEditor_isResizerEnabledForKeyboard, false, "f");
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_setResizerTabIndex).call(this, -1);
        __classPrivateFieldGet(this, _AnnotationEditor_instances, "m", _AnnotationEditor_addResizeToUndoStack).call(this);
    };
    AnnotationEditor._l10n = null;
    AnnotationEditor._l10nResizer = null;
    AnnotationEditor._borderLineWidth = -1;
    AnnotationEditor._colorManager = new ColorManager();
    AnnotationEditor._zIndex = 1;
    AnnotationEditor._telemetryTimeout = 1000;
    return AnnotationEditor;
}());
var FakeEditor = /** @class */ (function (_super) {
    __extends(FakeEditor, _super);
    function FakeEditor(params) {
        var _this = _super.call(this, params) || this;
        _this.annotationElementId = params.annotationElementId;
        _this.deleted = true;
        return _this;
    }
    FakeEditor.prototype.serialize = function () {
        return this.serializeDeleted();
    };
    return FakeEditor;
}(AnnotationEditor));
; // ./src/shared/murmurhash3.js
var SEED = 0xc3d2e1f0;
var MASK_HIGH = 0xffff0000;
var MASK_LOW = 0xffff;
var MurmurHash3_64 = /** @class */ (function () {
    function MurmurHash3_64(seed) {
        this.h1 = seed ? seed & 0xffffffff : SEED;
        this.h2 = seed ? seed & 0xffffffff : SEED;
    }
    MurmurHash3_64.prototype.update = function (input) {
        var data, length;
        if (typeof input === "string") {
            data = new Uint8Array(input.length * 2);
            length = 0;
            for (var i = 0, ii = input.length; i < ii; i++) {
                var code = input.charCodeAt(i);
                if (code <= 0xff) {
                    data[length++] = code;
                }
                else {
                    data[length++] = code >>> 8;
                    data[length++] = code & 0xff;
                }
            }
        }
        else if (ArrayBuffer.isView(input)) {
            data = input.slice();
            length = data.byteLength;
        }
        else {
            throw new Error("Invalid data format, must be a string or TypedArray.");
        }
        var blockCounts = length >> 2;
        var tailLength = length - blockCounts * 4;
        var dataUint32 = new Uint32Array(data.buffer, 0, blockCounts);
        var k1 = 0, k2 = 0;
        var h1 = this.h1, h2 = this.h2;
        var C1 = 0xcc9e2d51, C2 = 0x1b873593;
        var C1_LOW = C1 & MASK_LOW, C2_LOW = C2 & MASK_LOW;
        for (var i = 0; i < blockCounts; i++) {
            if (i & 1) {
                k1 = dataUint32[i];
                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                h1 ^= k1;
                h1 = h1 << 13 | h1 >>> 19;
                h1 = h1 * 5 + 0xe6546b64;
            }
            else {
                k2 = dataUint32[i];
                k2 = k2 * C1 & MASK_HIGH | k2 * C1_LOW & MASK_LOW;
                k2 = k2 << 15 | k2 >>> 17;
                k2 = k2 * C2 & MASK_HIGH | k2 * C2_LOW & MASK_LOW;
                h2 ^= k2;
                h2 = h2 << 13 | h2 >>> 19;
                h2 = h2 * 5 + 0xe6546b64;
            }
        }
        k1 = 0;
        switch (tailLength) {
            case 3:
                k1 ^= data[blockCounts * 4 + 2] << 16;
            case 2:
                k1 ^= data[blockCounts * 4 + 1] << 8;
            case 1:
                k1 ^= data[blockCounts * 4];
                k1 = k1 * C1 & MASK_HIGH | k1 * C1_LOW & MASK_LOW;
                k1 = k1 << 15 | k1 >>> 17;
                k1 = k1 * C2 & MASK_HIGH | k1 * C2_LOW & MASK_LOW;
                if (blockCounts & 1) {
                    h1 ^= k1;
                }
                else {
                    h2 ^= k1;
                }
        }
        this.h1 = h1;
        this.h2 = h2;
    };
    MurmurHash3_64.prototype.hexdigest = function () {
        var h1 = this.h1, h2 = this.h2;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0xed558ccd & MASK_HIGH | h1 * 0x8ccd & MASK_LOW;
        h2 = h2 * 0xff51afd7 & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xafd7ed55 & MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        h1 = h1 * 0x1a85ec53 & MASK_HIGH | h1 * 0xec53 & MASK_LOW;
        h2 = h2 * 0xc4ceb9fe & MASK_HIGH | ((h2 << 16 | h1 >>> 16) * 0xb9fe1a85 & MASK_HIGH) >>> 16;
        h1 ^= h2 >>> 1;
        return (h1 >>> 0).toString(16).padStart(8, "0") + (h2 >>> 0).toString(16).padStart(8, "0");
    };
    return MurmurHash3_64;
}());
; // ./src/display/annotation_storage.js
var SerializableEmpty = Object.freeze({
    map: null,
    hash: "",
    transfer: undefined
});
var AnnotationStorage = /** @class */ (function () {
    function AnnotationStorage() {
        _AnnotationStorage_instances.add(this);
        _AnnotationStorage_modified.set(this, false);
        _AnnotationStorage_modifiedIds.set(this, null);
        _AnnotationStorage_storage.set(this, new Map());
        this.onSetModified = null;
        this.onResetModified = null;
        this.onAnnotationEditor = null;
    }
    AnnotationStorage.prototype.getValue = function (key, defaultValue) {
        var value = __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").get(key);
        if (value === undefined) {
            return defaultValue;
        }
        return Object.assign(defaultValue, value);
    };
    AnnotationStorage.prototype.getRawValue = function (key) {
        return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").get(key);
    };
    AnnotationStorage.prototype.remove = function (key) {
        var e_62, _j;
        __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").delete(key);
        if (__classPrivateFieldGet(this, _AnnotationStorage_storage, "f").size === 0) {
            this.resetModified();
        }
        if (typeof this.onAnnotationEditor === "function") {
            try {
                for (var _k = __values(__classPrivateFieldGet(this, _AnnotationStorage_storage, "f").values()), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var value = _l.value;
                    if (value instanceof AnnotationEditor) {
                        return;
                    }
                }
            }
            catch (e_62_1) { e_62 = { error: e_62_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
                }
                finally { if (e_62) throw e_62.error; }
            }
            this.onAnnotationEditor(null);
        }
    };
    AnnotationStorage.prototype.setValue = function (key, value) {
        var e_63, _j;
        var obj = __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").get(key);
        var modified = false;
        if (obj !== undefined) {
            try {
                for (var _k = __values(Object.entries(value)), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var _m = __read(_l.value, 2), entry = _m[0], val = _m[1];
                    if (obj[entry] !== val) {
                        modified = true;
                        obj[entry] = val;
                    }
                }
            }
            catch (e_63_1) { e_63 = { error: e_63_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
                }
                finally { if (e_63) throw e_63.error; }
            }
        }
        else {
            modified = true;
            __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").set(key, value);
        }
        if (modified) {
            __classPrivateFieldGet(this, _AnnotationStorage_instances, "m", _AnnotationStorage_setModified).call(this);
        }
        if (value instanceof AnnotationEditor && typeof this.onAnnotationEditor === "function") {
            this.onAnnotationEditor(value.constructor._type);
        }
    };
    AnnotationStorage.prototype.has = function (key) {
        return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").has(key);
    };
    Object.defineProperty(AnnotationStorage.prototype, "size", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").size;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationStorage.prototype.resetModified = function () {
        if (__classPrivateFieldGet(this, _AnnotationStorage_modified, "f")) {
            __classPrivateFieldSet(this, _AnnotationStorage_modified, false, "f");
            if (typeof this.onResetModified === "function") {
                this.onResetModified();
            }
        }
    };
    Object.defineProperty(AnnotationStorage.prototype, "print", {
        get: function () {
            return new PrintAnnotationStorage(this);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationStorage.prototype, "serializable", {
        get: function () {
            var e_64, _j, e_65, _k;
            if (__classPrivateFieldGet(this, _AnnotationStorage_storage, "f").size === 0) {
                return SerializableEmpty;
            }
            var map = new Map(), hash = new MurmurHash3_64(), transfer = [];
            var context = Object.create(null);
            var hasBitmap = false;
            try {
                for (var _l = __values(__classPrivateFieldGet(this, _AnnotationStorage_storage, "f")), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var _o = __read(_m.value, 2), key = _o[0], val = _o[1];
                    var serialized = val instanceof AnnotationEditor ? val.serialize(false, context) : val;
                    if (serialized) {
                        map.set(key, serialized);
                        hash.update("".concat(key, ":").concat(JSON.stringify(serialized)));
                        hasBitmap || (hasBitmap = !!serialized.bitmap);
                    }
                }
            }
            catch (e_64_1) { e_64 = { error: e_64_1 }; }
            finally {
                try {
                    if (_m && !_m.done && (_j = _l.return)) _j.call(_l);
                }
                finally { if (e_64) throw e_64.error; }
            }
            if (hasBitmap) {
                try {
                    for (var _p = __values(map.values()), _q = _p.next(); !_q.done; _q = _p.next()) {
                        var value = _q.value;
                        if (value.bitmap) {
                            transfer.push(value.bitmap);
                        }
                    }
                }
                catch (e_65_1) { e_65 = { error: e_65_1 }; }
                finally {
                    try {
                        if (_q && !_q.done && (_k = _p.return)) _k.call(_p);
                    }
                    finally { if (e_65) throw e_65.error; }
                }
            }
            return map.size > 0 ? {
                map: map,
                hash: hash.hexdigest(),
                transfer: transfer
            } : SerializableEmpty;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationStorage.prototype, "editorStats", {
        get: function () {
            var e_66, _j, e_67, _k, e_68, _l;
            var _m;
            var stats = null;
            var typeToEditor = new Map();
            try {
                for (var _o = __values(__classPrivateFieldGet(this, _AnnotationStorage_storage, "f").values()), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var value = _p.value;
                    if (!(value instanceof AnnotationEditor)) {
                        continue;
                    }
                    var editorStats = value.telemetryFinalData;
                    if (!editorStats) {
                        continue;
                    }
                    var type = editorStats.type;
                    if (!typeToEditor.has(type)) {
                        typeToEditor.set(type, Object.getPrototypeOf(value).constructor);
                    }
                    stats || (stats = Object.create(null));
                    var map = stats[type] || (stats[type] = new Map());
                    try {
                        for (var _q = (e_67 = void 0, __values(Object.entries(editorStats))), _r = _q.next(); !_r.done; _r = _q.next()) {
                            var _s = __read(_r.value, 2), key = _s[0], val = _s[1];
                            if (key === "type") {
                                continue;
                            }
                            var counters = map.get(key);
                            if (!counters) {
                                counters = new Map();
                                map.set(key, counters);
                            }
                            var count = (_m = counters.get(val)) !== null && _m !== void 0 ? _m : 0;
                            counters.set(val, count + 1);
                        }
                    }
                    catch (e_67_1) { e_67 = { error: e_67_1 }; }
                    finally {
                        try {
                            if (_r && !_r.done && (_k = _q.return)) _k.call(_q);
                        }
                        finally { if (e_67) throw e_67.error; }
                    }
                }
            }
            catch (e_66_1) { e_66 = { error: e_66_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_j = _o.return)) _j.call(_o);
                }
                finally { if (e_66) throw e_66.error; }
            }
            try {
                for (var typeToEditor_1 = __values(typeToEditor), typeToEditor_1_1 = typeToEditor_1.next(); !typeToEditor_1_1.done; typeToEditor_1_1 = typeToEditor_1.next()) {
                    var _t = __read(typeToEditor_1_1.value, 2), type = _t[0], editor = _t[1];
                    stats[type] = editor.computeTelemetryFinalData(stats[type]);
                }
            }
            catch (e_68_1) { e_68 = { error: e_68_1 }; }
            finally {
                try {
                    if (typeToEditor_1_1 && !typeToEditor_1_1.done && (_l = typeToEditor_1.return)) _l.call(typeToEditor_1);
                }
                finally { if (e_68) throw e_68.error; }
            }
            return stats;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationStorage.prototype.resetModifiedIds = function () {
        __classPrivateFieldSet(this, _AnnotationStorage_modifiedIds, null, "f");
    };
    Object.defineProperty(AnnotationStorage.prototype, "modifiedIds", {
        get: function () {
            var e_69, _j;
            if (__classPrivateFieldGet(this, _AnnotationStorage_modifiedIds, "f")) {
                return __classPrivateFieldGet(this, _AnnotationStorage_modifiedIds, "f");
            }
            var ids = [];
            try {
                for (var _k = __values(__classPrivateFieldGet(this, _AnnotationStorage_storage, "f").values()), _l = _k.next(); !_l.done; _l = _k.next()) {
                    var value = _l.value;
                    if (!(value instanceof AnnotationEditor) || !value.annotationElementId || !value.serialize()) {
                        continue;
                    }
                    ids.push(value.annotationElementId);
                }
            }
            catch (e_69_1) { e_69 = { error: e_69_1 }; }
            finally {
                try {
                    if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
                }
                finally { if (e_69) throw e_69.error; }
            }
            return __classPrivateFieldSet(this, _AnnotationStorage_modifiedIds, {
                ids: new Set(ids),
                hash: ids.join(",")
            }, "f");
        },
        enumerable: false,
        configurable: true
    });
    AnnotationStorage.prototype[(_AnnotationStorage_modified = new WeakMap(), _AnnotationStorage_modifiedIds = new WeakMap(), _AnnotationStorage_storage = new WeakMap(), _AnnotationStorage_instances = new WeakSet(), _AnnotationStorage_setModified = function _AnnotationStorage_setModified() {
        if (!__classPrivateFieldGet(this, _AnnotationStorage_modified, "f")) {
            __classPrivateFieldSet(this, _AnnotationStorage_modified, true, "f");
            if (typeof this.onSetModified === "function") {
                this.onSetModified();
            }
        }
    }, Symbol.iterator)] = function () {
        return __classPrivateFieldGet(this, _AnnotationStorage_storage, "f").entries();
    };
    return AnnotationStorage;
}());
var PrintAnnotationStorage = /** @class */ (function (_super) {
    __extends(PrintAnnotationStorage, _super);
    function PrintAnnotationStorage(parent) {
        var _this = _super.call(this) || this;
        _PrintAnnotationStorage_serializable.set(_this, void 0);
        var _j = parent.serializable, map = _j.map, hash = _j.hash, transfer = _j.transfer;
        var clone = structuredClone(map, transfer ? {
            transfer: transfer
        } : null);
        __classPrivateFieldSet(_this, _PrintAnnotationStorage_serializable, {
            map: clone,
            hash: hash,
            transfer: transfer
        }, "f");
        return _this;
    }
    Object.defineProperty(PrintAnnotationStorage.prototype, "print", {
        get: function () {
            unreachable("Should not call PrintAnnotationStorage.print");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrintAnnotationStorage.prototype, "serializable", {
        get: function () {
            return __classPrivateFieldGet(this, _PrintAnnotationStorage_serializable, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PrintAnnotationStorage.prototype, "modifiedIds", {
        get: function () {
            return shadow(this, "modifiedIds", {
                ids: new Set(),
                hash: ""
            });
        },
        enumerable: false,
        configurable: true
    });
    return PrintAnnotationStorage;
}(AnnotationStorage));
_PrintAnnotationStorage_serializable = new WeakMap();
; // ./src/display/font_loader.js
var FontLoader = /** @class */ (function () {
    function FontLoader(_j) {
        var _k = _j.ownerDocument, ownerDocument = _k === void 0 ? globalThis.document : _k, _l = _j.styleElement, styleElement = _l === void 0 ? null : _l;
        _FontLoader_systemFonts.set(this, new Set());
        this._document = ownerDocument;
        this.nativeFontFaces = new Set();
        this.styleElement = null;
        this.loadingRequests = [];
        this.loadTestFontId = 0;
    }
    FontLoader.prototype.addNativeFontFace = function (nativeFontFace) {
        this.nativeFontFaces.add(nativeFontFace);
        this._document.fonts.add(nativeFontFace);
    };
    FontLoader.prototype.removeNativeFontFace = function (nativeFontFace) {
        this.nativeFontFaces.delete(nativeFontFace);
        this._document.fonts.delete(nativeFontFace);
    };
    FontLoader.prototype.insertRule = function (rule) {
        if (!this.styleElement) {
            this.styleElement = this._document.createElement("style");
            this._document.documentElement.getElementsByTagName("head")[0].append(this.styleElement);
        }
        var styleSheet = this.styleElement.sheet;
        styleSheet.insertRule(rule, styleSheet.cssRules.length);
    };
    FontLoader.prototype.clear = function () {
        var e_70, _j;
        try {
            for (var _k = __values(this.nativeFontFaces), _l = _k.next(); !_l.done; _l = _k.next()) {
                var nativeFontFace = _l.value;
                this._document.fonts.delete(nativeFontFace);
            }
        }
        catch (e_70_1) { e_70 = { error: e_70_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
            }
            finally { if (e_70) throw e_70.error; }
        }
        this.nativeFontFaces.clear();
        __classPrivateFieldGet(this, _FontLoader_systemFonts, "f").clear();
        if (this.styleElement) {
            this.styleElement.remove();
            this.styleElement = null;
        }
    };
    FontLoader.prototype.loadSystemFont = function (_j) {
        return __awaiter(this, arguments, void 0, function (_k) {
            var loadedName, src, style, fontFace, _l;
            var info = _k.systemFontInfo, disableFontFace = _k.disableFontFace, _inspectFont = _k._inspectFont;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0:
                        if (!info || __classPrivateFieldGet(this, _FontLoader_systemFonts, "f").has(info.loadedName)) {
                            return [2 /*return*/];
                        }
                        assert(!disableFontFace, "loadSystemFont shouldn't be called when `disableFontFace` is set.");
                        if (!this.isFontLoadingAPISupported) return [3 /*break*/, 5];
                        loadedName = info.loadedName, src = info.src, style = info.style;
                        fontFace = new FontFace(loadedName, src, style);
                        this.addNativeFontFace(fontFace);
                        _m.label = 1;
                    case 1:
                        _m.trys.push([1, 3, , 4]);
                        return [4 /*yield*/, fontFace.load()];
                    case 2:
                        _m.sent();
                        __classPrivateFieldGet(this, _FontLoader_systemFonts, "f").add(loadedName);
                        _inspectFont === null || _inspectFont === void 0 ? void 0 : _inspectFont(info);
                        return [3 /*break*/, 4];
                    case 3:
                        _l = _m.sent();
                        warn("Cannot load system font: ".concat(info.baseFontName, ", installing it could help to improve PDF rendering."));
                        this.removeNativeFontFace(fontFace);
                        return [3 /*break*/, 4];
                    case 4: return [2 /*return*/];
                    case 5:
                        unreachable("Not implemented: loadSystemFont without the Font Loading API.");
                        return [2 /*return*/];
                }
            });
        });
    };
    FontLoader.prototype.bind = function (font) {
        return __awaiter(this, void 0, void 0, function () {
            var nativeFontFace, ex_2, rule;
            var _this = this;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0:
                        if (font.attached || font.missingFile && !font.systemFontInfo) {
                            return [2 /*return*/];
                        }
                        font.attached = true;
                        if (!font.systemFontInfo) return [3 /*break*/, 2];
                        return [4 /*yield*/, this.loadSystemFont(font)];
                    case 1:
                        _j.sent();
                        return [2 /*return*/];
                    case 2:
                        if (!this.isFontLoadingAPISupported) return [3 /*break*/, 7];
                        nativeFontFace = font.createNativeFontFace();
                        if (!nativeFontFace) return [3 /*break*/, 6];
                        this.addNativeFontFace(nativeFontFace);
                        _j.label = 3;
                    case 3:
                        _j.trys.push([3, 5, , 6]);
                        return [4 /*yield*/, nativeFontFace.loaded];
                    case 4:
                        _j.sent();
                        return [3 /*break*/, 6];
                    case 5:
                        ex_2 = _j.sent();
                        warn("Failed to load font '".concat(nativeFontFace.family, "': '").concat(ex_2, "'."));
                        font.disableFontFace = true;
                        throw ex_2;
                    case 6: return [2 /*return*/];
                    case 7:
                        rule = font.createFontFaceRule();
                        if (!rule) return [3 /*break*/, 9];
                        this.insertRule(rule);
                        if (this.isSyncFontLoadingSupported) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, new Promise(function (resolve) {
                                var request = _this._queueLoadingCallback(resolve);
                                _this._prepareFontLoadEvent(font, request);
                            })];
                    case 8:
                        _j.sent();
                        _j.label = 9;
                    case 9: return [2 /*return*/];
                }
            });
        });
    };
    Object.defineProperty(FontLoader.prototype, "isFontLoadingAPISupported", {
        get: function () {
            var _j;
            var hasFonts = !!((_j = this._document) === null || _j === void 0 ? void 0 : _j.fonts);
            return shadow(this, "isFontLoadingAPISupported", hasFonts);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FontLoader.prototype, "isSyncFontLoadingSupported", {
        get: function () {
            return shadow(this, "isSyncFontLoadingSupported", isNodeJS || util_FeatureTest.platform.isFirefox);
        },
        enumerable: false,
        configurable: true
    });
    FontLoader.prototype._queueLoadingCallback = function (callback) {
        function completeRequest() {
            assert(!request.done, "completeRequest() cannot be called twice.");
            request.done = true;
            while (loadingRequests.length > 0 && loadingRequests[0].done) {
                var otherRequest = loadingRequests.shift();
                setTimeout(otherRequest.callback, 0);
            }
        }
        var loadingRequests = this.loadingRequests;
        var request = {
            done: false,
            complete: completeRequest,
            callback: callback
        };
        loadingRequests.push(request);
        return request;
    };
    Object.defineProperty(FontLoader.prototype, "_loadTestFont", {
        get: function () {
            var testFont = atob("T1RUTwALAIAAAwAwQ0ZGIDHtZg4AAAOYAAAAgUZGVE1lkzZwAAAEHAAAABxHREVGABQA" + "FQAABDgAAAAeT1MvMlYNYwkAAAEgAAAAYGNtYXABDQLUAAACNAAAAUJoZWFk/xVFDQAA" + "ALwAAAA2aGhlYQdkA+oAAAD0AAAAJGhtdHgD6AAAAAAEWAAAAAZtYXhwAAJQAAAAARgA" + "AAAGbmFtZVjmdH4AAAGAAAAAsXBvc3T/hgAzAAADeAAAACAAAQAAAAEAALZRFsRfDzz1" + "AAsD6AAAAADOBOTLAAAAAM4KHDwAAAAAA+gDIQAAAAgAAgAAAAAAAAABAAADIQAAAFoD" + "6AAAAAAD6AABAAAAAAAAAAAAAAAAAAAAAQAAUAAAAgAAAAQD6AH0AAUAAAKKArwAAACM" + "AooCvAAAAeAAMQECAAACAAYJAAAAAAAAAAAAAQAAAAAAAAAAAAAAAFBmRWQAwAAuAC4D" + "IP84AFoDIQAAAAAAAQAAAAAAAAAAACAAIAABAAAADgCuAAEAAAAAAAAAAQAAAAEAAAAA" + "AAEAAQAAAAEAAAAAAAIAAQAAAAEAAAAAAAMAAQAAAAEAAAAAAAQAAQAAAAEAAAAAAAUA" + "AQAAAAEAAAAAAAYAAQAAAAMAAQQJAAAAAgABAAMAAQQJAAEAAgABAAMAAQQJAAIAAgAB" + "AAMAAQQJAAMAAgABAAMAAQQJAAQAAgABAAMAAQQJAAUAAgABAAMAAQQJAAYAAgABWABY" + "AAAAAAAAAwAAAAMAAAAcAAEAAAAAADwAAwABAAAAHAAEACAAAAAEAAQAAQAAAC7//wAA" + "AC7////TAAEAAAAAAAABBgAAAQAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAEAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAAA" + "AAAAAAAAAAAAAAAAAAAAAAAAAAAAAAMAAAAAAAD/gwAyAAAAAQAAAAAAAAAAAAAAAAAA" + "AAABAAQEAAEBAQJYAAEBASH4DwD4GwHEAvgcA/gXBIwMAYuL+nz5tQXkD5j3CBLnEQAC" + "AQEBIVhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYWFhYAAABAQAADwACAQEEE/t3" + "Dov6fAH6fAT+fPp8+nwHDosMCvm1Cvm1DAz6fBQAAAAAAAABAAAAAMmJbzEAAAAAzgTj" + "FQAAAADOBOQpAAEAAAAAAAAADAAUAAQAAAABAAAAAgABAAAAAAAAAAAD6AAAAAAAAA==");
            return shadow(this, "_loadTestFont", testFont);
        },
        enumerable: false,
        configurable: true
    });
    FontLoader.prototype._prepareFontLoadEvent = function (font, request) {
        var e_71, _j;
        function int32(data, offset) {
            return data.charCodeAt(offset) << 24 | data.charCodeAt(offset + 1) << 16 | data.charCodeAt(offset + 2) << 8 | data.charCodeAt(offset + 3) & 0xff;
        }
        function spliceString(s, offset, remove, insert) {
            var chunk1 = s.substring(0, offset);
            var chunk2 = s.substring(offset + remove);
            return chunk1 + insert + chunk2;
        }
        var i, ii;
        var canvas = this._document.createElement("canvas");
        canvas.width = 1;
        canvas.height = 1;
        var ctx = canvas.getContext("2d");
        var called = 0;
        function isFontReady(name, callback) {
            if (++called > 30) {
                warn("Load test font never loaded.");
                callback();
                return;
            }
            ctx.font = "30px " + name;
            ctx.fillText(".", 0, 20);
            var imageData = ctx.getImageData(0, 0, 1, 1);
            if (imageData.data[3] > 0) {
                callback();
                return;
            }
            setTimeout(isFontReady.bind(null, name, callback));
        }
        var loadTestFontId = "lt".concat(Date.now()).concat(this.loadTestFontId++);
        var data = this._loadTestFont;
        var COMMENT_OFFSET = 976;
        data = spliceString(data, COMMENT_OFFSET, loadTestFontId.length, loadTestFontId);
        var CFF_CHECKSUM_OFFSET = 16;
        var XXXX_VALUE = 0x58585858;
        var checksum = int32(data, CFF_CHECKSUM_OFFSET);
        for (i = 0, ii = loadTestFontId.length - 3; i < ii; i += 4) {
            checksum = checksum - XXXX_VALUE + int32(loadTestFontId, i) | 0;
        }
        if (i < loadTestFontId.length) {
            checksum = checksum - XXXX_VALUE + int32(loadTestFontId + "XXX", i) | 0;
        }
        data = spliceString(data, CFF_CHECKSUM_OFFSET, 4, string32(checksum));
        var url = "url(data:font/opentype;base64,".concat(btoa(data), ");");
        var rule = "@font-face {font-family:\"".concat(loadTestFontId, "\";src:").concat(url, "}");
        this.insertRule(rule);
        var div = this._document.createElement("div");
        div.style.visibility = "hidden";
        div.style.width = div.style.height = "10px";
        div.style.position = "absolute";
        div.style.top = div.style.left = "0px";
        try {
            for (var _k = __values([font.loadedName, loadTestFontId]), _l = _k.next(); !_l.done; _l = _k.next()) {
                var name = _l.value;
                var span = this._document.createElement("span");
                span.textContent = "Hi";
                span.style.fontFamily = name;
                div.append(span);
            }
        }
        catch (e_71_1) { e_71 = { error: e_71_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
            }
            finally { if (e_71) throw e_71.error; }
        }
        this._document.body.append(div);
        isFontReady(loadTestFontId, function () {
            div.remove();
            request.complete();
        });
    };
    return FontLoader;
}());
_FontLoader_systemFonts = new WeakMap();
var FontFaceObject = /** @class */ (function () {
    function FontFaceObject(translatedData, inspectFont) {
        if (inspectFont === void 0) { inspectFont = null; }
        this.compiledGlyphs = Object.create(null);
        for (var i in translatedData) {
            this[i] = translatedData[i];
        }
        this._inspectFont = inspectFont;
    }
    FontFaceObject.prototype.createNativeFontFace = function () {
        var _j;
        if (!this.data || this.disableFontFace) {
            return null;
        }
        var nativeFontFace;
        if (!this.cssFontInfo) {
            nativeFontFace = new FontFace(this.loadedName, this.data, {});
        }
        else {
            var css = {
                weight: this.cssFontInfo.fontWeight
            };
            if (this.cssFontInfo.italicAngle) {
                css.style = "oblique ".concat(this.cssFontInfo.italicAngle, "deg");
            }
            nativeFontFace = new FontFace(this.cssFontInfo.fontFamily, this.data, css);
        }
        (_j = this._inspectFont) === null || _j === void 0 ? void 0 : _j.call(this, this);
        return nativeFontFace;
    };
    FontFaceObject.prototype.createFontFaceRule = function () {
        var _j;
        if (!this.data || this.disableFontFace) {
            return null;
        }
        var url = "url(data:".concat(this.mimetype, ";base64,").concat(toBase64Util(this.data), ");");
        var rule;
        if (!this.cssFontInfo) {
            rule = "@font-face {font-family:\"".concat(this.loadedName, "\";src:").concat(url, "}");
        }
        else {
            var css = "font-weight: ".concat(this.cssFontInfo.fontWeight, ";");
            if (this.cssFontInfo.italicAngle) {
                css += "font-style: oblique ".concat(this.cssFontInfo.italicAngle, "deg;");
            }
            rule = "@font-face {font-family:\"".concat(this.cssFontInfo.fontFamily, "\";").concat(css, "src:").concat(url, "}");
        }
        (_j = this._inspectFont) === null || _j === void 0 ? void 0 : _j.call(this, this, url);
        return rule;
    };
    FontFaceObject.prototype.getPathGenerator = function (objs, character) {
        if (this.compiledGlyphs[character] !== undefined) {
            return this.compiledGlyphs[character];
        }
        var objId = this.loadedName + "_path_" + character;
        var cmds;
        try {
            cmds = objs.get(objId);
        }
        catch (ex) {
            warn("getPathGenerator - ignoring character: \"".concat(ex, "\"."));
        }
        var path = new Path2D(cmds || "");
        if (!this.fontExtraProperties) {
            objs.delete(objId);
        }
        return this.compiledGlyphs[character] = path;
    };
    return FontFaceObject;
}());
; // ./src/shared/message_handler.js
var CallbackKind = {
    DATA: 1,
    ERROR: 2
};
var StreamKind = {
    CANCEL: 1,
    CANCEL_COMPLETE: 2,
    CLOSE: 3,
    ENQUEUE: 4,
    ERROR: 5,
    PULL: 6,
    PULL_COMPLETE: 7,
    START_COMPLETE: 8
};
function onFn() { }
function wrapReason(ex) {
    if (ex instanceof AbortException || ex instanceof InvalidPDFException || ex instanceof PasswordException || ex instanceof ResponseException || ex instanceof UnknownErrorException) {
        return ex;
    }
    if (!(ex instanceof Error || typeof ex === "object" && ex !== null)) {
        unreachable('wrapReason: Expected "reason" to be a (possibly cloned) Error.');
    }
    switch (ex.name) {
        case "AbortException":
            return new AbortException(ex.message);
        case "InvalidPDFException":
            return new InvalidPDFException(ex.message);
        case "PasswordException":
            return new PasswordException(ex.message, ex.code);
        case "ResponseException":
            return new ResponseException(ex.message, ex.status, ex.missing);
        case "UnknownErrorException":
            return new UnknownErrorException(ex.message, ex.details);
    }
    return new UnknownErrorException(ex.message, ex.toString());
}
var MessageHandler = /** @class */ (function () {
    function MessageHandler(sourceName, targetName, comObj) {
        _MessageHandler_instances.add(this);
        _MessageHandler_messageAC.set(this, new AbortController());
        this.sourceName = sourceName;
        this.targetName = targetName;
        this.comObj = comObj;
        this.callbackId = 1;
        this.streamId = 1;
        this.streamSinks = Object.create(null);
        this.streamControllers = Object.create(null);
        this.callbackCapabilities = Object.create(null);
        this.actionHandler = Object.create(null);
        comObj.addEventListener("message", __classPrivateFieldGet(this, _MessageHandler_instances, "m", _MessageHandler_onMessage).bind(this), {
            signal: __classPrivateFieldGet(this, _MessageHandler_messageAC, "f").signal
        });
    }
    MessageHandler.prototype.on = function (actionName, handler) {
        var ah = this.actionHandler;
        if (ah[actionName]) {
            throw new Error("There is already an actionName called \"".concat(actionName, "\""));
        }
        ah[actionName] = handler;
    };
    MessageHandler.prototype.send = function (actionName, data, transfers) {
        this.comObj.postMessage({
            sourceName: this.sourceName,
            targetName: this.targetName,
            action: actionName,
            data: data
        }, transfers);
    };
    MessageHandler.prototype.sendWithPromise = function (actionName, data, transfers) {
        var callbackId = this.callbackId++;
        var capability = Promise.withResolvers();
        this.callbackCapabilities[callbackId] = capability;
        try {
            this.comObj.postMessage({
                sourceName: this.sourceName,
                targetName: this.targetName,
                action: actionName,
                callbackId: callbackId,
                data: data
            }, transfers);
        }
        catch (ex) {
            capability.reject(ex);
        }
        return capability.promise;
    };
    MessageHandler.prototype.sendWithStream = function (actionName, data, queueingStrategy, transfers) {
        var _this = this;
        var streamId = this.streamId++, sourceName = this.sourceName, targetName = this.targetName, comObj = this.comObj;
        return new ReadableStream({
            start: function (controller) {
                var startCapability = Promise.withResolvers();
                _this.streamControllers[streamId] = {
                    controller: controller,
                    startCall: startCapability,
                    pullCall: null,
                    cancelCall: null,
                    isClosed: false
                };
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    action: actionName,
                    streamId: streamId,
                    data: data,
                    desiredSize: controller.desiredSize
                }, transfers);
                return startCapability.promise;
            },
            pull: function (controller) {
                var pullCapability = Promise.withResolvers();
                _this.streamControllers[streamId].pullCall = pullCapability;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL,
                    streamId: streamId,
                    desiredSize: controller.desiredSize
                });
                return pullCapability.promise;
            },
            cancel: function (reason) {
                assert(reason instanceof Error, "cancel must have a valid reason");
                var cancelCapability = Promise.withResolvers();
                _this.streamControllers[streamId].cancelCall = cancelCapability;
                _this.streamControllers[streamId].isClosed = true;
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.CANCEL,
                    streamId: streamId,
                    reason: wrapReason(reason)
                });
                return cancelCapability.promise;
            }
        }, queueingStrategy);
    };
    MessageHandler.prototype.destroy = function () {
        var _j;
        (_j = __classPrivateFieldGet(this, _MessageHandler_messageAC, "f")) === null || _j === void 0 ? void 0 : _j.abort();
        __classPrivateFieldSet(this, _MessageHandler_messageAC, null, "f");
    };
    return MessageHandler;
}());
_MessageHandler_messageAC = new WeakMap(), _MessageHandler_instances = new WeakSet(), _MessageHandler_onMessage = function _MessageHandler_onMessage(_j) {
    var data = _j.data;
    if (data.targetName !== this.sourceName) {
        return;
    }
    if (data.stream) {
        __classPrivateFieldGet(this, _MessageHandler_instances, "m", _MessageHandler_processStreamMessage).call(this, data);
        return;
    }
    if (data.callback) {
        var callbackId = data.callbackId;
        var capability = this.callbackCapabilities[callbackId];
        if (!capability) {
            throw new Error("Cannot resolve callback ".concat(callbackId));
        }
        delete this.callbackCapabilities[callbackId];
        if (data.callback === CallbackKind.DATA) {
            capability.resolve(data.data);
        }
        else if (data.callback === CallbackKind.ERROR) {
            capability.reject(wrapReason(data.reason));
        }
        else {
            throw new Error("Unexpected callback case");
        }
        return;
    }
    var action = this.actionHandler[data.action];
    if (!action) {
        throw new Error("Unknown action from worker: ".concat(data.action));
    }
    if (data.callbackId) {
        var sourceName_1 = this.sourceName, targetName_1 = data.sourceName, comObj_1 = this.comObj;
        Promise.try(action, data.data).then(function (result) {
            comObj_1.postMessage({
                sourceName: sourceName_1,
                targetName: targetName_1,
                callback: CallbackKind.DATA,
                callbackId: data.callbackId,
                data: result
            });
        }, function (reason) {
            comObj_1.postMessage({
                sourceName: sourceName_1,
                targetName: targetName_1,
                callback: CallbackKind.ERROR,
                callbackId: data.callbackId,
                reason: wrapReason(reason)
            });
        });
        return;
    }
    if (data.streamId) {
        __classPrivateFieldGet(this, _MessageHandler_instances, "m", _MessageHandler_createStreamSink).call(this, data);
        return;
    }
    action(data.data);
}, _MessageHandler_createStreamSink = function _MessageHandler_createStreamSink(data) {
    var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
    var self = this, action = this.actionHandler[data.action];
    var streamSink = {
        enqueue: function (chunk, size, transfers) {
            if (size === void 0) { size = 1; }
            if (this.isCancelled) {
                return;
            }
            var lastDesiredSize = this.desiredSize;
            this.desiredSize -= size;
            if (lastDesiredSize > 0 && this.desiredSize <= 0) {
                this.sinkCapability = Promise.withResolvers();
                this.ready = this.sinkCapability.promise;
            }
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: StreamKind.ENQUEUE,
                streamId: streamId,
                chunk: chunk
            }, transfers);
        },
        close: function () {
            if (this.isCancelled) {
                return;
            }
            this.isCancelled = true;
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: StreamKind.CLOSE,
                streamId: streamId
            });
            delete self.streamSinks[streamId];
        },
        error: function (reason) {
            assert(reason instanceof Error, "error must have a valid reason");
            if (this.isCancelled) {
                return;
            }
            this.isCancelled = true;
            comObj.postMessage({
                sourceName: sourceName,
                targetName: targetName,
                stream: StreamKind.ERROR,
                streamId: streamId,
                reason: wrapReason(reason)
            });
        },
        sinkCapability: Promise.withResolvers(),
        onPull: null,
        onCancel: null,
        isCancelled: false,
        desiredSize: data.desiredSize,
        ready: null
    };
    streamSink.sinkCapability.resolve();
    streamSink.ready = streamSink.sinkCapability.promise;
    this.streamSinks[streamId] = streamSink;
    Promise.try(action, data.data, streamSink).then(function () {
        comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.START_COMPLETE,
            streamId: streamId,
            success: true
        });
    }, function (reason) {
        comObj.postMessage({
            sourceName: sourceName,
            targetName: targetName,
            stream: StreamKind.START_COMPLETE,
            streamId: streamId,
            reason: wrapReason(reason)
        });
    });
}, _MessageHandler_processStreamMessage = function _MessageHandler_processStreamMessage(data) {
    var streamId = data.streamId, sourceName = this.sourceName, targetName = data.sourceName, comObj = this.comObj;
    var streamController = this.streamControllers[streamId], streamSink = this.streamSinks[streamId];
    switch (data.stream) {
        case StreamKind.START_COMPLETE:
            if (data.success) {
                streamController.startCall.resolve();
            }
            else {
                streamController.startCall.reject(wrapReason(data.reason));
            }
            break;
        case StreamKind.PULL_COMPLETE:
            if (data.success) {
                streamController.pullCall.resolve();
            }
            else {
                streamController.pullCall.reject(wrapReason(data.reason));
            }
            break;
        case StreamKind.PULL:
            if (!streamSink) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    success: true
                });
                break;
            }
            if (streamSink.desiredSize <= 0 && data.desiredSize > 0) {
                streamSink.sinkCapability.resolve();
            }
            streamSink.desiredSize = data.desiredSize;
            Promise.try(streamSink.onPull || onFn).then(function () {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    success: true
                });
            }, function (reason) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.PULL_COMPLETE,
                    streamId: streamId,
                    reason: wrapReason(reason)
                });
            });
            break;
        case StreamKind.ENQUEUE:
            assert(streamController, "enqueue should have stream controller");
            if (streamController.isClosed) {
                break;
            }
            streamController.controller.enqueue(data.chunk);
            break;
        case StreamKind.CLOSE:
            assert(streamController, "close should have stream controller");
            if (streamController.isClosed) {
                break;
            }
            streamController.isClosed = true;
            streamController.controller.close();
            __classPrivateFieldGet(this, _MessageHandler_instances, "m", _MessageHandler_deleteStreamController).call(this, streamController, streamId);
            break;
        case StreamKind.ERROR:
            assert(streamController, "error should have stream controller");
            streamController.controller.error(wrapReason(data.reason));
            __classPrivateFieldGet(this, _MessageHandler_instances, "m", _MessageHandler_deleteStreamController).call(this, streamController, streamId);
            break;
        case StreamKind.CANCEL_COMPLETE:
            if (data.success) {
                streamController.cancelCall.resolve();
            }
            else {
                streamController.cancelCall.reject(wrapReason(data.reason));
            }
            __classPrivateFieldGet(this, _MessageHandler_instances, "m", _MessageHandler_deleteStreamController).call(this, streamController, streamId);
            break;
        case StreamKind.CANCEL:
            if (!streamSink) {
                break;
            }
            var dataReason = wrapReason(data.reason);
            Promise.try(streamSink.onCancel || onFn, dataReason).then(function () {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.CANCEL_COMPLETE,
                    streamId: streamId,
                    success: true
                });
            }, function (reason) {
                comObj.postMessage({
                    sourceName: sourceName,
                    targetName: targetName,
                    stream: StreamKind.CANCEL_COMPLETE,
                    streamId: streamId,
                    reason: wrapReason(reason)
                });
            });
            streamSink.sinkCapability.reject(dataReason);
            streamSink.isCancelled = true;
            delete this.streamSinks[streamId];
            break;
        default:
            throw new Error("Unexpected stream case");
    }
}, _MessageHandler_deleteStreamController = function _MessageHandler_deleteStreamController(streamController, streamId) {
    return __awaiter(this, void 0, void 0, function () {
        var _j, _k, _l;
        return __generator(this, function (_m) {
            switch (_m.label) {
                case 0: return [4 /*yield*/, Promise.allSettled([(_j = streamController.startCall) === null || _j === void 0 ? void 0 : _j.promise, (_k = streamController.pullCall) === null || _k === void 0 ? void 0 : _k.promise, (_l = streamController.cancelCall) === null || _l === void 0 ? void 0 : _l.promise])];
                case 1:
                    _m.sent();
                    delete this.streamControllers[streamId];
                    return [2 /*return*/];
            }
        });
    });
};
; // ./src/display/canvas_factory.js
var BaseCanvasFactory = /** @class */ (function () {
    function BaseCanvasFactory(_j) {
        var _k = _j.enableHWA, enableHWA = _k === void 0 ? false : _k;
        _BaseCanvasFactory_enableHWA.set(this, false);
        __classPrivateFieldSet(this, _BaseCanvasFactory_enableHWA, enableHWA, "f");
    }
    BaseCanvasFactory.prototype.create = function (width, height) {
        if (width <= 0 || height <= 0) {
            throw new Error("Invalid canvas size");
        }
        var canvas = this._createCanvas(width, height);
        return {
            canvas: canvas,
            context: canvas.getContext("2d", {
                willReadFrequently: !__classPrivateFieldGet(this, _BaseCanvasFactory_enableHWA, "f")
            })
        };
    };
    BaseCanvasFactory.prototype.reset = function (canvasAndContext, width, height) {
        if (!canvasAndContext.canvas) {
            throw new Error("Canvas is not specified");
        }
        if (width <= 0 || height <= 0) {
            throw new Error("Invalid canvas size");
        }
        canvasAndContext.canvas.width = width;
        canvasAndContext.canvas.height = height;
    };
    BaseCanvasFactory.prototype.destroy = function (canvasAndContext) {
        if (!canvasAndContext.canvas) {
            throw new Error("Canvas is not specified");
        }
        canvasAndContext.canvas.width = 0;
        canvasAndContext.canvas.height = 0;
        canvasAndContext.canvas = null;
        canvasAndContext.context = null;
    };
    BaseCanvasFactory.prototype._createCanvas = function (width, height) {
        unreachable("Abstract method `_createCanvas` called.");
    };
    return BaseCanvasFactory;
}());
_BaseCanvasFactory_enableHWA = new WeakMap();
var DOMCanvasFactory = /** @class */ (function (_super) {
    __extends(DOMCanvasFactory, _super);
    function DOMCanvasFactory(_j) {
        var _k = _j.ownerDocument, ownerDocument = _k === void 0 ? globalThis.document : _k, _l = _j.enableHWA, enableHWA = _l === void 0 ? false : _l;
        var _this = _super.call(this, {
            enableHWA: enableHWA
        }) || this;
        _this._document = ownerDocument;
        return _this;
    }
    DOMCanvasFactory.prototype._createCanvas = function (width, height) {
        var canvas = this._document.createElement("canvas");
        canvas.width = width;
        canvas.height = height;
        return canvas;
    };
    return DOMCanvasFactory;
}(BaseCanvasFactory));
; // ./src/display/cmap_reader_factory.js
var BaseCMapReaderFactory = /** @class */ (function () {
    function BaseCMapReaderFactory(_j) {
        var _k = _j.baseUrl, baseUrl = _k === void 0 ? null : _k, _l = _j.isCompressed, isCompressed = _l === void 0 ? true : _l;
        this.baseUrl = baseUrl;
        this.isCompressed = isCompressed;
    }
    BaseCMapReaderFactory.prototype.fetch = function (_j) {
        return __awaiter(this, arguments, void 0, function (_k) {
            var url;
            var _this = this;
            var name = _k.name;
            return __generator(this, function (_l) {
                if (!this.baseUrl) {
                    throw new Error("Ensure that the `cMapUrl` and `cMapPacked` API parameters are provided.");
                }
                if (!name) {
                    throw new Error("CMap name must be specified.");
                }
                url = this.baseUrl + name + (this.isCompressed ? ".bcmap" : "");
                return [2 /*return*/, this._fetch(url).then(function (cMapData) { return ({
                        cMapData: cMapData,
                        isCompressed: _this.isCompressed
                    }); }).catch(function (reason) {
                        throw new Error("Unable to load ".concat(_this.isCompressed ? "binary " : "", "CMap at: ").concat(url));
                    })];
            });
        });
    };
    BaseCMapReaderFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                unreachable("Abstract method `_fetch` called.");
                return [2 /*return*/];
            });
        });
    };
    return BaseCMapReaderFactory;
}());
var DOMCMapReaderFactory = /** @class */ (function (_super) {
    __extends(DOMCMapReaderFactory, _super);
    function DOMCMapReaderFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DOMCMapReaderFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, fetchData(url, this.isCompressed ? "arraybuffer" : "text")];
                    case 1:
                        data = _j.sent();
                        return [2 /*return*/, data instanceof ArrayBuffer ? new Uint8Array(data) : stringToBytes(data)];
                }
            });
        });
    };
    return DOMCMapReaderFactory;
}(BaseCMapReaderFactory));
; // ./src/display/filter_factory.js
var BaseFilterFactory = /** @class */ (function () {
    function BaseFilterFactory() {
    }
    BaseFilterFactory.prototype.addFilter = function (maps) {
        return "none";
    };
    BaseFilterFactory.prototype.addHCMFilter = function (fgColor, bgColor) {
        return "none";
    };
    BaseFilterFactory.prototype.addAlphaFilter = function (map) {
        return "none";
    };
    BaseFilterFactory.prototype.addLuminosityFilter = function (map) {
        return "none";
    };
    BaseFilterFactory.prototype.addHighlightHCMFilter = function (filterName, fgColor, bgColor, newFgColor, newBgColor) {
        return "none";
    };
    BaseFilterFactory.prototype.destroy = function (keepHCM) {
        if (keepHCM === void 0) { keepHCM = false; }
    };
    return BaseFilterFactory;
}());
var DOMFilterFactory = /** @class */ (function (_super) {
    __extends(DOMFilterFactory, _super);
    function DOMFilterFactory(_j) {
        var docId = _j.docId, _k = _j.ownerDocument, ownerDocument = _k === void 0 ? globalThis.document : _k;
        var _this = _super.call(this) || this;
        _DOMFilterFactory_instances.add(_this);
        _DOMFilterFactory_baseUrl.set(_this, void 0);
        _DOMFilterFactory__cache.set(_this, void 0);
        _DOMFilterFactory__defs.set(_this, void 0);
        _DOMFilterFactory_docId.set(_this, void 0);
        _DOMFilterFactory_document.set(_this, void 0);
        _DOMFilterFactory__hcmCache.set(_this, void 0);
        _DOMFilterFactory_id.set(_this, 0);
        __classPrivateFieldSet(_this, _DOMFilterFactory_docId, docId, "f");
        __classPrivateFieldSet(_this, _DOMFilterFactory_document, ownerDocument, "f");
        return _this;
    }
    DOMFilterFactory.prototype.addFilter = function (maps) {
        var _j, _k;
        if (!maps) {
            return "none";
        }
        var value = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).get(maps);
        if (value) {
            return value;
        }
        var _l = __read(__classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createTables).call(this, maps), 3), tableR = _l[0], tableG = _l[1], tableB = _l[2];
        var key = maps.length === 1 ? tableR : "".concat(tableR).concat(tableG).concat(tableB);
        value = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).get(key);
        if (value) {
            __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(maps, value);
            return value;
        }
        var id = "g_".concat(__classPrivateFieldGet(this, _DOMFilterFactory_docId, "f"), "_transfer_map_").concat((__classPrivateFieldSet(this, _DOMFilterFactory_id, (_k = __classPrivateFieldGet(this, _DOMFilterFactory_id, "f"), _j = _k++, _k), "f"), _j));
        var url = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createUrl).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(maps, url);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(key, url);
        var filter = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createFilter).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addTransferMapConversion).call(this, tableR, tableG, tableB, filter);
        return url;
    };
    DOMFilterFactory.prototype.addHCMFilter = function (fgColor, bgColor) {
        var _j;
        var key = "".concat(fgColor, "-").concat(bgColor);
        var filterName = "base";
        var info = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_hcmCache_get).get(filterName);
        if ((info === null || info === void 0 ? void 0 : info.key) === key) {
            return info.url;
        }
        if (info) {
            (_j = info.filter) === null || _j === void 0 ? void 0 : _j.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        }
        else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_hcmCache_get).set(filterName, info);
        }
        if (!fgColor || !bgColor) {
            return info.url;
        }
        var fgRGB = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_getRGB).call(this, fgColor);
        fgColor = Util.makeHexColor.apply(Util, __spreadArray([], __read(fgRGB), false));
        var bgRGB = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_getRGB).call(this, bgColor);
        bgColor = Util.makeHexColor.apply(Util, __spreadArray([], __read(bgRGB), false));
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_defs_get).style.color = "";
        if (fgColor === "#000000" && bgColor === "#ffffff" || fgColor === bgColor) {
            return info.url;
        }
        var map = new Array(256);
        for (var i = 0; i <= 255; i++) {
            var x = i / 255;
            map[i] = x <= 0.03928 ? x / 12.92 : Math.pow(((x + 0.055) / 1.055), 2.4);
        }
        var table = map.join(",");
        var id = "g_".concat(__classPrivateFieldGet(this, _DOMFilterFactory_docId, "f"), "_hcm_filter");
        var filter = info.filter = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createFilter).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addTransferMapConversion).call(this, table, table, table, filter);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addGrayConversion).call(this, filter);
        var getSteps = function (c, n) {
            var start = fgRGB[c] / 255;
            var end = bgRGB[c] / 255;
            var arr = new Array(n + 1);
            for (var i = 0; i <= n; i++) {
                arr[i] = start + i / n * (end - start);
            }
            return arr.join(",");
        };
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addTransferMapConversion).call(this, getSteps(0, 5), getSteps(1, 5), getSteps(2, 5), filter);
        info.url = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createUrl).call(this, id);
        return info.url;
    };
    DOMFilterFactory.prototype.addAlphaFilter = function (map) {
        var _j, _k;
        var value = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).get(map);
        if (value) {
            return value;
        }
        var _l = __read(__classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createTables).call(this, [map]), 1), tableA = _l[0];
        var key = "alpha_".concat(tableA);
        value = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).get(key);
        if (value) {
            __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(map, value);
            return value;
        }
        var id = "g_".concat(__classPrivateFieldGet(this, _DOMFilterFactory_docId, "f"), "_alpha_map_").concat((__classPrivateFieldSet(this, _DOMFilterFactory_id, (_k = __classPrivateFieldGet(this, _DOMFilterFactory_id, "f"), _j = _k++, _k), "f"), _j));
        var url = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createUrl).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(map, url);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(key, url);
        var filter = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createFilter).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addTransferMapAlphaConversion).call(this, tableA, filter);
        return url;
    };
    DOMFilterFactory.prototype.addLuminosityFilter = function (map) {
        var _j;
        var _k, _l;
        var value = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).get(map || "luminosity");
        if (value) {
            return value;
        }
        var tableA, key;
        if (map) {
            _j = __read(__classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createTables).call(this, [map]), 1), tableA = _j[0];
            key = "luminosity_".concat(tableA);
        }
        else {
            key = "luminosity";
        }
        value = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).get(key);
        if (value) {
            __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(map, value);
            return value;
        }
        var id = "g_".concat(__classPrivateFieldGet(this, _DOMFilterFactory_docId, "f"), "_luminosity_map_").concat((__classPrivateFieldSet(this, _DOMFilterFactory_id, (_l = __classPrivateFieldGet(this, _DOMFilterFactory_id, "f"), _k = _l++, _l), "f"), _k));
        var url = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createUrl).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(map, url);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_cache_get).set(key, url);
        var filter = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createFilter).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addLuminosityConversion).call(this, filter);
        if (map) {
            __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addTransferMapAlphaConversion).call(this, tableA, filter);
        }
        return url;
    };
    DOMFilterFactory.prototype.addHighlightHCMFilter = function (filterName, fgColor, bgColor, newFgColor, newBgColor) {
        var _j;
        var _k;
        var key = "".concat(fgColor, "-").concat(bgColor, "-").concat(newFgColor, "-").concat(newBgColor);
        var info = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_hcmCache_get).get(filterName);
        if ((info === null || info === void 0 ? void 0 : info.key) === key) {
            return info.url;
        }
        if (info) {
            (_k = info.filter) === null || _k === void 0 ? void 0 : _k.remove();
            info.key = key;
            info.url = "none";
            info.filter = null;
        }
        else {
            info = {
                key: key,
                url: "none",
                filter: null
            };
            __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_hcmCache_get).set(filterName, info);
        }
        if (!fgColor || !bgColor) {
            return info.url;
        }
        var _l = __read([fgColor, bgColor].map(__classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_getRGB).bind(this)), 2), fgRGB = _l[0], bgRGB = _l[1];
        var fgGray = Math.round(0.2126 * fgRGB[0] + 0.7152 * fgRGB[1] + 0.0722 * fgRGB[2]);
        var bgGray = Math.round(0.2126 * bgRGB[0] + 0.7152 * bgRGB[1] + 0.0722 * bgRGB[2]);
        var _m = __read([newFgColor, newBgColor].map(__classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_getRGB).bind(this)), 2), newFgRGB = _m[0], newBgRGB = _m[1];
        if (bgGray < fgGray) {
            _j = __read([bgGray, fgGray, newBgRGB, newFgRGB], 4), fgGray = _j[0], bgGray = _j[1], newFgRGB = _j[2], newBgRGB = _j[3];
        }
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_defs_get).style.color = "";
        var getSteps = function (fg, bg, n) {
            var arr = new Array(256);
            var step = (bgGray - fgGray) / n;
            var newStart = fg / 255;
            var newStep = (bg - fg) / (255 * n);
            var prev = 0;
            for (var i = 0; i <= n; i++) {
                var k = Math.round(fgGray + i * step);
                var value = newStart + i * newStep;
                for (var j = prev; j <= k; j++) {
                    arr[j] = value;
                }
                prev = k + 1;
            }
            for (var i = prev; i < 256; i++) {
                arr[i] = arr[prev - 1];
            }
            return arr.join(",");
        };
        var id = "g_".concat(__classPrivateFieldGet(this, _DOMFilterFactory_docId, "f"), "_hcm_").concat(filterName, "_filter");
        var filter = info.filter = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createFilter).call(this, id);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addGrayConversion).call(this, filter);
        __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_addTransferMapConversion).call(this, getSteps(newFgRGB[0], newBgRGB[0], 5), getSteps(newFgRGB[1], newBgRGB[1], 5), getSteps(newFgRGB[2], newBgRGB[2], 5), filter);
        info.url = __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_createUrl).call(this, id);
        return info.url;
    };
    DOMFilterFactory.prototype.destroy = function (keepHCM) {
        var _j, _k, _l, _m;
        if (keepHCM === void 0) { keepHCM = false; }
        if (keepHCM && ((_j = __classPrivateFieldGet(this, _DOMFilterFactory__hcmCache, "f")) === null || _j === void 0 ? void 0 : _j.size)) {
            return;
        }
        (_k = __classPrivateFieldGet(this, _DOMFilterFactory__defs, "f")) === null || _k === void 0 ? void 0 : _k.parentNode.parentNode.remove();
        __classPrivateFieldSet(this, _DOMFilterFactory__defs, null, "f");
        (_l = __classPrivateFieldGet(this, _DOMFilterFactory__cache, "f")) === null || _l === void 0 ? void 0 : _l.clear();
        __classPrivateFieldSet(this, _DOMFilterFactory__cache, null, "f");
        (_m = __classPrivateFieldGet(this, _DOMFilterFactory__hcmCache, "f")) === null || _m === void 0 ? void 0 : _m.clear();
        __classPrivateFieldSet(this, _DOMFilterFactory__hcmCache, null, "f");
        __classPrivateFieldSet(this, _DOMFilterFactory_id, 0, "f");
    };
    return DOMFilterFactory;
}(BaseFilterFactory));
_DOMFilterFactory_baseUrl = new WeakMap(), _DOMFilterFactory__cache = new WeakMap(), _DOMFilterFactory__defs = new WeakMap(), _DOMFilterFactory_docId = new WeakMap(), _DOMFilterFactory_document = new WeakMap(), _DOMFilterFactory__hcmCache = new WeakMap(), _DOMFilterFactory_id = new WeakMap(), _DOMFilterFactory_instances = new WeakSet(), _DOMFilterFactory_cache_get = function _DOMFilterFactory_cache_get() {
    return __classPrivateFieldSet(this, _DOMFilterFactory__cache, __classPrivateFieldGet(this, _DOMFilterFactory__cache, "f") || new Map(), "f");
}, _DOMFilterFactory_hcmCache_get = function _DOMFilterFactory_hcmCache_get() {
    return __classPrivateFieldSet(this, _DOMFilterFactory__hcmCache, __classPrivateFieldGet(this, _DOMFilterFactory__hcmCache, "f") || new Map(), "f");
}, _DOMFilterFactory_defs_get = function _DOMFilterFactory_defs_get() {
    if (!__classPrivateFieldGet(this, _DOMFilterFactory__defs, "f")) {
        var div = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElement("div");
        var style = div.style;
        style.visibility = "hidden";
        style.contain = "strict";
        style.width = style.height = 0;
        style.position = "absolute";
        style.top = style.left = 0;
        style.zIndex = -1;
        var svg = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, "svg");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        __classPrivateFieldSet(this, _DOMFilterFactory__defs, __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, "defs"), "f");
        div.append(svg);
        svg.append(__classPrivateFieldGet(this, _DOMFilterFactory__defs, "f"));
        __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").body.append(div);
    }
    return __classPrivateFieldGet(this, _DOMFilterFactory__defs, "f");
}, _DOMFilterFactory_createTables = function _DOMFilterFactory_createTables(maps) {
    if (maps.length === 1) {
        var mapR_1 = maps[0];
        var buffer = new Array(256);
        for (var i = 0; i < 256; i++) {
            buffer[i] = mapR_1[i] / 255;
        }
        var table = buffer.join(",");
        return [table, table, table];
    }
    var _j = __read(maps, 3), mapR = _j[0], mapG = _j[1], mapB = _j[2];
    var bufferR = new Array(256);
    var bufferG = new Array(256);
    var bufferB = new Array(256);
    for (var i = 0; i < 256; i++) {
        bufferR[i] = mapR[i] / 255;
        bufferG[i] = mapG[i] / 255;
        bufferB[i] = mapB[i] / 255;
    }
    return [bufferR.join(","), bufferG.join(","), bufferB.join(",")];
}, _DOMFilterFactory_createUrl = function _DOMFilterFactory_createUrl(id) {
    if (__classPrivateFieldGet(this, _DOMFilterFactory_baseUrl, "f") === undefined) {
        __classPrivateFieldSet(this, _DOMFilterFactory_baseUrl, "", "f");
        var url = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").URL;
        if (url !== __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").baseURI) {
            if (isDataScheme(url)) {
                warn('#createUrl: ignore "data:"-URL for performance reasons.');
            }
            else {
                __classPrivateFieldSet(this, _DOMFilterFactory_baseUrl, updateUrlHash(url, ""), "f");
            }
        }
    }
    return "url(".concat(__classPrivateFieldGet(this, _DOMFilterFactory_baseUrl, "f"), "#").concat(id, ")");
}, _DOMFilterFactory_addLuminosityConversion = function _DOMFilterFactory_addLuminosityConversion(filter) {
    var feColorMatrix = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, "feColorMatrix");
    feColorMatrix.setAttribute("type", "matrix");
    feColorMatrix.setAttribute("values", "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.3 0.59 0.11 0 0");
    filter.append(feColorMatrix);
}, _DOMFilterFactory_addGrayConversion = function _DOMFilterFactory_addGrayConversion(filter) {
    var feColorMatrix = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, "feColorMatrix");
    feColorMatrix.setAttribute("type", "matrix");
    feColorMatrix.setAttribute("values", "0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0.2126 0.7152 0.0722 0 0 0 0 0 1 0");
    filter.append(feColorMatrix);
}, _DOMFilterFactory_createFilter = function _DOMFilterFactory_createFilter(id) {
    var filter = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, "filter");
    filter.setAttribute("color-interpolation-filters", "sRGB");
    filter.setAttribute("id", id);
    __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_defs_get).append(filter);
    return filter;
}, _DOMFilterFactory_appendFeFunc = function _DOMFilterFactory_appendFeFunc(feComponentTransfer, func, table) {
    var feFunc = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, func);
    feFunc.setAttribute("type", "discrete");
    feFunc.setAttribute("tableValues", table);
    feComponentTransfer.append(feFunc);
}, _DOMFilterFactory_addTransferMapConversion = function _DOMFilterFactory_addTransferMapConversion(rTable, gTable, bTable, filter) {
    var feComponentTransfer = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, "feComponentTransfer");
    filter.append(feComponentTransfer);
    __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_appendFeFunc).call(this, feComponentTransfer, "feFuncR", rTable);
    __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_appendFeFunc).call(this, feComponentTransfer, "feFuncG", gTable);
    __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_appendFeFunc).call(this, feComponentTransfer, "feFuncB", bTable);
}, _DOMFilterFactory_addTransferMapAlphaConversion = function _DOMFilterFactory_addTransferMapAlphaConversion(aTable, filter) {
    var feComponentTransfer = __classPrivateFieldGet(this, _DOMFilterFactory_document, "f").createElementNS(SVG_NS, "feComponentTransfer");
    filter.append(feComponentTransfer);
    __classPrivateFieldGet(this, _DOMFilterFactory_instances, "m", _DOMFilterFactory_appendFeFunc).call(this, feComponentTransfer, "feFuncA", aTable);
}, _DOMFilterFactory_getRGB = function _DOMFilterFactory_getRGB(color) {
    __classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_defs_get).style.color = color;
    return getRGB(getComputedStyle(__classPrivateFieldGet(this, _DOMFilterFactory_instances, "a", _DOMFilterFactory_defs_get)).getPropertyValue("color"));
};
; // ./src/display/standard_fontdata_factory.js
var BaseStandardFontDataFactory = /** @class */ (function () {
    function BaseStandardFontDataFactory(_j) {
        var _k = _j.baseUrl, baseUrl = _k === void 0 ? null : _k;
        this.baseUrl = baseUrl;
    }
    BaseStandardFontDataFactory.prototype.fetch = function (_j) {
        return __awaiter(this, arguments, void 0, function (_k) {
            var url;
            var filename = _k.filename;
            return __generator(this, function (_l) {
                if (!this.baseUrl) {
                    throw new Error("Ensure that the `standardFontDataUrl` API parameter is provided.");
                }
                if (!filename) {
                    throw new Error("Font filename must be specified.");
                }
                url = "".concat(this.baseUrl).concat(filename);
                return [2 /*return*/, this._fetch(url).catch(function (reason) {
                        throw new Error("Unable to load font data at: ".concat(url));
                    })];
            });
        });
    };
    BaseStandardFontDataFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                unreachable("Abstract method `_fetch` called.");
                return [2 /*return*/];
            });
        });
    };
    return BaseStandardFontDataFactory;
}());
var DOMStandardFontDataFactory = /** @class */ (function (_super) {
    __extends(DOMStandardFontDataFactory, _super);
    function DOMStandardFontDataFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DOMStandardFontDataFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, fetchData(url, "arraybuffer")];
                    case 1:
                        data = _j.sent();
                        return [2 /*return*/, new Uint8Array(data)];
                }
            });
        });
    };
    return DOMStandardFontDataFactory;
}(BaseStandardFontDataFactory));
; // ./src/display/wasm_factory.js
var BaseWasmFactory = /** @class */ (function () {
    function BaseWasmFactory(_j) {
        var _k = _j.baseUrl, baseUrl = _k === void 0 ? null : _k;
        this.baseUrl = baseUrl;
    }
    BaseWasmFactory.prototype.fetch = function (_j) {
        return __awaiter(this, arguments, void 0, function (_k) {
            var url;
            var filename = _k.filename;
            return __generator(this, function (_l) {
                if (!this.baseUrl) {
                    throw new Error("Ensure that the `wasmUrl` API parameter is provided.");
                }
                if (!filename) {
                    throw new Error("Wasm filename must be specified.");
                }
                url = "".concat(this.baseUrl).concat(filename);
                return [2 /*return*/, this._fetch(url).catch(function (reason) {
                        throw new Error("Unable to load wasm data at: ".concat(url));
                    })];
            });
        });
    };
    BaseWasmFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                unreachable("Abstract method `_fetch` called.");
                return [2 /*return*/];
            });
        });
    };
    return BaseWasmFactory;
}());
var DOMWasmFactory = /** @class */ (function (_super) {
    __extends(DOMWasmFactory, _super);
    function DOMWasmFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DOMWasmFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            var data;
            return __generator(this, function (_j) {
                switch (_j.label) {
                    case 0: return [4 /*yield*/, fetchData(url, "arraybuffer")];
                    case 1:
                        data = _j.sent();
                        return [2 /*return*/, new Uint8Array(data)];
                }
            });
        });
    };
    return DOMWasmFactory;
}(BaseWasmFactory));
; // ./src/display/node_utils.js
if (isNodeJS) {
    warn("Please use the `legacy` build in Node.js environments.");
}
function node_utils_fetchData(url) {
    return __awaiter(this, void 0, void 0, function () {
        var fs, data;
        return __generator(this, function (_j) {
            switch (_j.label) {
                case 0:
                    fs = process.getBuiltinModule("fs");
                    return [4 /*yield*/, fs.promises.readFile(url)];
                case 1:
                    data = _j.sent();
                    return [2 /*return*/, new Uint8Array(data)];
            }
        });
    });
}
var NodeFilterFactory = /** @class */ (function (_super) {
    __extends(NodeFilterFactory, _super);
    function NodeFilterFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    return NodeFilterFactory;
}(BaseFilterFactory));
var NodeCanvasFactory = /** @class */ (function (_super) {
    __extends(NodeCanvasFactory, _super);
    function NodeCanvasFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeCanvasFactory.prototype._createCanvas = function (width, height) {
        var require = process.getBuiltinModule("module").createRequire(import.meta.url);
        var canvas = require("@napi-rs/canvas");
        return canvas.createCanvas(width, height);
    };
    return NodeCanvasFactory;
}(BaseCanvasFactory));
var NodeCMapReaderFactory = /** @class */ (function (_super) {
    __extends(NodeCMapReaderFactory, _super);
    function NodeCMapReaderFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeCMapReaderFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                return [2 /*return*/, node_utils_fetchData(url)];
            });
        });
    };
    return NodeCMapReaderFactory;
}(BaseCMapReaderFactory));
var NodeStandardFontDataFactory = /** @class */ (function (_super) {
    __extends(NodeStandardFontDataFactory, _super);
    function NodeStandardFontDataFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeStandardFontDataFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                return [2 /*return*/, node_utils_fetchData(url)];
            });
        });
    };
    return NodeStandardFontDataFactory;
}(BaseStandardFontDataFactory));
var NodeWasmFactory = /** @class */ (function (_super) {
    __extends(NodeWasmFactory, _super);
    function NodeWasmFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    NodeWasmFactory.prototype._fetch = function (url) {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_j) {
                return [2 /*return*/, node_utils_fetchData(url)];
            });
        });
    };
    return NodeWasmFactory;
}(BaseWasmFactory));
; // ./src/display/pattern_helper.js
var PathType = {
    FILL: "Fill",
    STROKE: "Stroke",
    SHADING: "Shading"
};
function applyBoundingBox(ctx, bbox) {
    if (!bbox) {
        return;
    }
    var width = bbox[2] - bbox[0];
    var height = bbox[3] - bbox[1];
    var region = new Path2D();
    region.rect(bbox[0], bbox[1], width, height);
    ctx.clip(region);
}
var BaseShadingPattern = /** @class */ (function () {
    function BaseShadingPattern() {
    }
    BaseShadingPattern.prototype.isModifyingCurrentTransform = function () {
        return false;
    };
    BaseShadingPattern.prototype.getPattern = function () {
        unreachable("Abstract method `getPattern` called.");
    };
    return BaseShadingPattern;
}());
var RadialAxialShadingPattern = /** @class */ (function (_super) {
    __extends(RadialAxialShadingPattern, _super);
    function RadialAxialShadingPattern(IR) {
        var _this = _super.call(this) || this;
        _this._type = IR[1];
        _this._bbox = IR[2];
        _this._colorStops = IR[3];
        _this._p0 = IR[4];
        _this._p1 = IR[5];
        _this._r0 = IR[6];
        _this._r1 = IR[7];
        _this.matrix = null;
        return _this;
    }
    RadialAxialShadingPattern.prototype._createGradient = function (ctx) {
        var e_72, _j;
        var grad;
        if (this._type === "axial") {
            grad = ctx.createLinearGradient(this._p0[0], this._p0[1], this._p1[0], this._p1[1]);
        }
        else if (this._type === "radial") {
            grad = ctx.createRadialGradient(this._p0[0], this._p0[1], this._r0, this._p1[0], this._p1[1], this._r1);
        }
        try {
            for (var _k = __values(this._colorStops), _l = _k.next(); !_l.done; _l = _k.next()) {
                var colorStop = _l.value;
                grad.addColorStop(colorStop[0], colorStop[1]);
            }
        }
        catch (e_72_1) { e_72 = { error: e_72_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
            }
            finally { if (e_72) throw e_72.error; }
        }
        return grad;
    };
    RadialAxialShadingPattern.prototype.getPattern = function (ctx, owner, inverse, pathType) {
        var pattern;
        if (pathType === PathType.STROKE || pathType === PathType.FILL) {
            var ownerBBox = owner.current.getClippedPathBoundingBox(pathType, getCurrentTransform(ctx)) || [0, 0, 0, 0];
            var width = Math.ceil(ownerBBox[2] - ownerBBox[0]) || 1;
            var height = Math.ceil(ownerBBox[3] - ownerBBox[1]) || 1;
            var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", width, height);
            var tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.beginPath();
            tmpCtx.rect(0, 0, tmpCtx.canvas.width, tmpCtx.canvas.height);
            tmpCtx.translate(-ownerBBox[0], -ownerBBox[1]);
            inverse = Util.transform(inverse, [1, 0, 0, 1, ownerBBox[0], ownerBBox[1]]);
            tmpCtx.transform.apply(tmpCtx, __spreadArray([], __read(owner.baseTransform), false));
            if (this.matrix) {
                tmpCtx.transform.apply(tmpCtx, __spreadArray([], __read(this.matrix), false));
            }
            applyBoundingBox(tmpCtx, this._bbox);
            tmpCtx.fillStyle = this._createGradient(tmpCtx);
            tmpCtx.fill();
            pattern = ctx.createPattern(tmpCanvas.canvas, "no-repeat");
            var domMatrix = new DOMMatrix(inverse);
            pattern.setTransform(domMatrix);
        }
        else {
            applyBoundingBox(ctx, this._bbox);
            pattern = this._createGradient(ctx);
        }
        return pattern;
    };
    return RadialAxialShadingPattern;
}(BaseShadingPattern));
function drawTriangle(data, context, p1, p2, p3, c1, c2, c3) {
    var coords = context.coords, colors = context.colors;
    var bytes = data.data, rowSize = data.width * 4;
    var tmp;
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    if (coords[p2 + 1] > coords[p3 + 1]) {
        tmp = p2;
        p2 = p3;
        p3 = tmp;
        tmp = c2;
        c2 = c3;
        c3 = tmp;
    }
    if (coords[p1 + 1] > coords[p2 + 1]) {
        tmp = p1;
        p1 = p2;
        p2 = tmp;
        tmp = c1;
        c1 = c2;
        c2 = tmp;
    }
    var x1 = (coords[p1] + context.offsetX) * context.scaleX;
    var y1 = (coords[p1 + 1] + context.offsetY) * context.scaleY;
    var x2 = (coords[p2] + context.offsetX) * context.scaleX;
    var y2 = (coords[p2 + 1] + context.offsetY) * context.scaleY;
    var x3 = (coords[p3] + context.offsetX) * context.scaleX;
    var y3 = (coords[p3 + 1] + context.offsetY) * context.scaleY;
    if (y1 >= y3) {
        return;
    }
    var c1r = colors[c1], c1g = colors[c1 + 1], c1b = colors[c1 + 2];
    var c2r = colors[c2], c2g = colors[c2 + 1], c2b = colors[c2 + 2];
    var c3r = colors[c3], c3g = colors[c3 + 1], c3b = colors[c3 + 2];
    var minY = Math.round(y1), maxY = Math.round(y3);
    var xa, car, cag, cab;
    var xb, cbr, cbg, cbb;
    for (var y = minY; y <= maxY; y++) {
        if (y < y2) {
            var k_1 = y < y1 ? 0 : (y1 - y) / (y1 - y2);
            xa = x1 - (x1 - x2) * k_1;
            car = c1r - (c1r - c2r) * k_1;
            cag = c1g - (c1g - c2g) * k_1;
            cab = c1b - (c1b - c2b) * k_1;
        }
        else {
            var k_2 = void 0;
            if (y > y3) {
                k_2 = 1;
            }
            else if (y2 === y3) {
                k_2 = 0;
            }
            else {
                k_2 = (y2 - y) / (y2 - y3);
            }
            xa = x2 - (x2 - x3) * k_2;
            car = c2r - (c2r - c3r) * k_2;
            cag = c2g - (c2g - c3g) * k_2;
            cab = c2b - (c2b - c3b) * k_2;
        }
        var k = void 0;
        if (y < y1) {
            k = 0;
        }
        else if (y > y3) {
            k = 1;
        }
        else {
            k = (y1 - y) / (y1 - y3);
        }
        xb = x1 - (x1 - x3) * k;
        cbr = c1r - (c1r - c3r) * k;
        cbg = c1g - (c1g - c3g) * k;
        cbb = c1b - (c1b - c3b) * k;
        var x1_ = Math.round(Math.min(xa, xb));
        var x2_ = Math.round(Math.max(xa, xb));
        var j = rowSize * y + x1_ * 4;
        for (var x = x1_; x <= x2_; x++) {
            k = (xa - x) / (xa - xb);
            if (k < 0) {
                k = 0;
            }
            else if (k > 1) {
                k = 1;
            }
            bytes[j++] = car - (car - cbr) * k | 0;
            bytes[j++] = cag - (cag - cbg) * k | 0;
            bytes[j++] = cab - (cab - cbb) * k | 0;
            bytes[j++] = 255;
        }
    }
}
function drawFigure(data, figure, context) {
    var ps = figure.coords;
    var cs = figure.colors;
    var i, ii;
    switch (figure.type) {
        case "lattice":
            var verticesPerRow = figure.verticesPerRow;
            var rows = Math.floor(ps.length / verticesPerRow) - 1;
            var cols = verticesPerRow - 1;
            for (i = 0; i < rows; i++) {
                var q = i * verticesPerRow;
                for (var j = 0; j < cols; j++, q++) {
                    drawTriangle(data, context, ps[q], ps[q + 1], ps[q + verticesPerRow], cs[q], cs[q + 1], cs[q + verticesPerRow]);
                    drawTriangle(data, context, ps[q + verticesPerRow + 1], ps[q + 1], ps[q + verticesPerRow], cs[q + verticesPerRow + 1], cs[q + 1], cs[q + verticesPerRow]);
                }
            }
            break;
        case "triangles":
            for (i = 0, ii = ps.length; i < ii; i += 3) {
                drawTriangle(data, context, ps[i], ps[i + 1], ps[i + 2], cs[i], cs[i + 1], cs[i + 2]);
            }
            break;
        default:
            throw new Error("illegal figure");
    }
}
var MeshShadingPattern = /** @class */ (function (_super) {
    __extends(MeshShadingPattern, _super);
    function MeshShadingPattern(IR) {
        var _this = _super.call(this) || this;
        _this._coords = IR[2];
        _this._colors = IR[3];
        _this._figures = IR[4];
        _this._bounds = IR[5];
        _this._bbox = IR[6];
        _this._background = IR[7];
        _this.matrix = null;
        return _this;
    }
    MeshShadingPattern.prototype._createMeshCanvas = function (combinedScale, backgroundColor, cachedCanvases) {
        var e_73, _j;
        var EXPECTED_SCALE = 1.1;
        var MAX_PATTERN_SIZE = 3000;
        var BORDER_SIZE = 2;
        var offsetX = Math.floor(this._bounds[0]);
        var offsetY = Math.floor(this._bounds[1]);
        var boundsWidth = Math.ceil(this._bounds[2]) - offsetX;
        var boundsHeight = Math.ceil(this._bounds[3]) - offsetY;
        var width = Math.min(Math.ceil(Math.abs(boundsWidth * combinedScale[0] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        var height = Math.min(Math.ceil(Math.abs(boundsHeight * combinedScale[1] * EXPECTED_SCALE)), MAX_PATTERN_SIZE);
        var scaleX = boundsWidth / width;
        var scaleY = boundsHeight / height;
        var context = {
            coords: this._coords,
            colors: this._colors,
            offsetX: -offsetX,
            offsetY: -offsetY,
            scaleX: 1 / scaleX,
            scaleY: 1 / scaleY
        };
        var paddedWidth = width + BORDER_SIZE * 2;
        var paddedHeight = height + BORDER_SIZE * 2;
        var tmpCanvas = cachedCanvases.getCanvas("mesh", paddedWidth, paddedHeight);
        var tmpCtx = tmpCanvas.context;
        var data = tmpCtx.createImageData(width, height);
        if (backgroundColor) {
            var bytes = data.data;
            for (var i = 0, ii = bytes.length; i < ii; i += 4) {
                bytes[i] = backgroundColor[0];
                bytes[i + 1] = backgroundColor[1];
                bytes[i + 2] = backgroundColor[2];
                bytes[i + 3] = 255;
            }
        }
        try {
            for (var _k = __values(this._figures), _l = _k.next(); !_l.done; _l = _k.next()) {
                var figure = _l.value;
                drawFigure(data, figure, context);
            }
        }
        catch (e_73_1) { e_73 = { error: e_73_1 }; }
        finally {
            try {
                if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
            }
            finally { if (e_73) throw e_73.error; }
        }
        tmpCtx.putImageData(data, BORDER_SIZE, BORDER_SIZE);
        var canvas = tmpCanvas.canvas;
        return {
            canvas: canvas,
            offsetX: offsetX - BORDER_SIZE * scaleX,
            offsetY: offsetY - BORDER_SIZE * scaleY,
            scaleX: scaleX,
            scaleY: scaleY
        };
    };
    MeshShadingPattern.prototype.isModifyingCurrentTransform = function () {
        return true;
    };
    MeshShadingPattern.prototype.getPattern = function (ctx, owner, inverse, pathType) {
        applyBoundingBox(ctx, this._bbox);
        var scale = new Float32Array(2);
        if (pathType === PathType.SHADING) {
            Util.singularValueDecompose2dScale(getCurrentTransform(ctx), scale);
        }
        else if (this.matrix) {
            Util.singularValueDecompose2dScale(this.matrix, scale);
            var _j = __read(scale, 2), matrixScaleX = _j[0], matrixScaleY = _j[1];
            Util.singularValueDecompose2dScale(owner.baseTransform, scale);
            scale[0] *= matrixScaleX;
            scale[1] *= matrixScaleY;
        }
        else {
            Util.singularValueDecompose2dScale(owner.baseTransform, scale);
        }
        var temporaryPatternCanvas = this._createMeshCanvas(scale, pathType === PathType.SHADING ? null : this._background, owner.cachedCanvases);
        if (pathType !== PathType.SHADING) {
            ctx.setTransform.apply(ctx, __spreadArray([], __read(owner.baseTransform), false));
            if (this.matrix) {
                ctx.transform.apply(ctx, __spreadArray([], __read(this.matrix), false));
            }
        }
        ctx.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        ctx.scale(temporaryPatternCanvas.scaleX, temporaryPatternCanvas.scaleY);
        return ctx.createPattern(temporaryPatternCanvas.canvas, "no-repeat");
    };
    return MeshShadingPattern;
}(BaseShadingPattern));
var DummyShadingPattern = /** @class */ (function (_super) {
    __extends(DummyShadingPattern, _super);
    function DummyShadingPattern() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DummyShadingPattern.prototype.getPattern = function () {
        return "hotpink";
    };
    return DummyShadingPattern;
}(BaseShadingPattern));
function getShadingPattern(IR) {
    switch (IR[0]) {
        case "RadialAxial":
            return new RadialAxialShadingPattern(IR);
        case "Mesh":
            return new MeshShadingPattern(IR);
        case "Dummy":
            return new DummyShadingPattern();
    }
    throw new Error("Unknown IR type: ".concat(IR[0]));
}
var PaintType = {
    COLORED: 1,
    UNCOLORED: 2
};
var TilingPattern = /** @class */ (function () {
    function TilingPattern(IR, ctx, canvasGraphicsFactory, baseTransform) {
        this.color = IR[1];
        this.operatorList = IR[2];
        this.matrix = IR[3];
        this.bbox = IR[4];
        this.xstep = IR[5];
        this.ystep = IR[6];
        this.paintType = IR[7];
        this.tilingType = IR[8];
        this.ctx = ctx;
        this.canvasGraphicsFactory = canvasGraphicsFactory;
        this.baseTransform = baseTransform;
    }
    TilingPattern.prototype.createPatternCanvas = function (owner) {
        var _j = this, bbox = _j.bbox, operatorList = _j.operatorList, paintType = _j.paintType, tilingType = _j.tilingType, color = _j.color, canvasGraphicsFactory = _j.canvasGraphicsFactory;
        var _k = this, xstep = _k.xstep, ystep = _k.ystep;
        xstep = Math.abs(xstep);
        ystep = Math.abs(ystep);
        info("TilingType: " + tilingType);
        var x0 = bbox[0], y0 = bbox[1], x1 = bbox[2], y1 = bbox[3];
        var width = x1 - x0;
        var height = y1 - y0;
        var scale = new Float32Array(2);
        Util.singularValueDecompose2dScale(this.matrix, scale);
        var _l = __read(scale, 2), matrixScaleX = _l[0], matrixScaleY = _l[1];
        Util.singularValueDecompose2dScale(this.baseTransform, scale);
        var combinedScaleX = matrixScaleX * scale[0];
        var combinedScaleY = matrixScaleY * scale[1];
        var canvasWidth = width, canvasHeight = height, redrawHorizontally = false, redrawVertically = false;
        var xScaledStep = Math.ceil(xstep * combinedScaleX);
        var yScaledStep = Math.ceil(ystep * combinedScaleY);
        var xScaledWidth = Math.ceil(width * combinedScaleX);
        var yScaledHeight = Math.ceil(height * combinedScaleY);
        if (xScaledStep >= xScaledWidth) {
            canvasWidth = xstep;
        }
        else {
            redrawHorizontally = true;
        }
        if (yScaledStep >= yScaledHeight) {
            canvasHeight = ystep;
        }
        else {
            redrawVertically = true;
        }
        var dimx = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
        var dimy = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
        var tmpCanvas = owner.cachedCanvases.getCanvas("pattern", dimx.size, dimy.size);
        var tmpCtx = tmpCanvas.context;
        var graphics = canvasGraphicsFactory.createCanvasGraphics(tmpCtx);
        graphics.groupLevel = owner.groupLevel;
        this.setFillAndStrokeStyleToContext(graphics, paintType, color);
        tmpCtx.translate(-dimx.scale * x0, -dimy.scale * y0);
        graphics.transform(dimx.scale, 0, 0, dimy.scale, 0, 0);
        tmpCtx.save();
        this.clipBbox(graphics, x0, y0, x1, y1);
        graphics.baseTransform = getCurrentTransform(graphics.ctx);
        graphics.executeOperatorList(operatorList);
        graphics.endDrawing();
        tmpCtx.restore();
        if (redrawHorizontally || redrawVertically) {
            var image = tmpCanvas.canvas;
            if (redrawHorizontally) {
                canvasWidth = xstep;
            }
            if (redrawVertically) {
                canvasHeight = ystep;
            }
            var dimx2 = this.getSizeAndScale(canvasWidth, this.ctx.canvas.width, combinedScaleX);
            var dimy2 = this.getSizeAndScale(canvasHeight, this.ctx.canvas.height, combinedScaleY);
            var xSize = dimx2.size;
            var ySize = dimy2.size;
            var tmpCanvas2 = owner.cachedCanvases.getCanvas("pattern-workaround", xSize, ySize);
            var tmpCtx2 = tmpCanvas2.context;
            var ii = redrawHorizontally ? Math.floor(width / xstep) : 0;
            var jj = redrawVertically ? Math.floor(height / ystep) : 0;
            for (var i = 0; i <= ii; i++) {
                for (var j = 0; j <= jj; j++) {
                    tmpCtx2.drawImage(image, xSize * i, ySize * j, xSize, ySize, 0, 0, xSize, ySize);
                }
            }
            return {
                canvas: tmpCanvas2.canvas,
                scaleX: dimx2.scale,
                scaleY: dimy2.scale,
                offsetX: x0,
                offsetY: y0
            };
        }
        return {
            canvas: tmpCanvas.canvas,
            scaleX: dimx.scale,
            scaleY: dimy.scale,
            offsetX: x0,
            offsetY: y0
        };
    };
    TilingPattern.prototype.getSizeAndScale = function (step, realOutputSize, scale) {
        var maxSize = Math.max(TilingPattern.MAX_PATTERN_SIZE, realOutputSize);
        var size = Math.ceil(step * scale);
        if (size >= maxSize) {
            size = maxSize;
        }
        else {
            scale = size / step;
        }
        return {
            scale: scale,
            size: size
        };
    };
    TilingPattern.prototype.clipBbox = function (graphics, x0, y0, x1, y1) {
        var bboxWidth = x1 - x0;
        var bboxHeight = y1 - y0;
        graphics.ctx.rect(x0, y0, bboxWidth, bboxHeight);
        Util.axialAlignedBoundingBox([x0, y0, x1, y1], getCurrentTransform(graphics.ctx), graphics.current.minMax);
        graphics.clip();
        graphics.endPath();
    };
    TilingPattern.prototype.setFillAndStrokeStyleToContext = function (graphics, paintType, color) {
        var context = graphics.ctx, current = graphics.current;
        switch (paintType) {
            case PaintType.COLORED:
                var ctx = this.ctx;
                context.fillStyle = ctx.fillStyle;
                context.strokeStyle = ctx.strokeStyle;
                current.fillColor = ctx.fillStyle;
                current.strokeColor = ctx.strokeStyle;
                break;
            case PaintType.UNCOLORED:
                var cssColor = Util.makeHexColor(color[0], color[1], color[2]);
                context.fillStyle = cssColor;
                context.strokeStyle = cssColor;
                current.fillColor = cssColor;
                current.strokeColor = cssColor;
                break;
            default:
                throw new FormatError("Unsupported paint type: ".concat(paintType));
        }
    };
    TilingPattern.prototype.isModifyingCurrentTransform = function () {
        return false;
    };
    TilingPattern.prototype.getPattern = function (ctx, owner, inverse, pathType) {
        var matrix = inverse;
        if (pathType !== PathType.SHADING) {
            matrix = Util.transform(matrix, owner.baseTransform);
            if (this.matrix) {
                matrix = Util.transform(matrix, this.matrix);
            }
        }
        var temporaryPatternCanvas = this.createPatternCanvas(owner);
        var domMatrix = new DOMMatrix(matrix);
        domMatrix = domMatrix.translate(temporaryPatternCanvas.offsetX, temporaryPatternCanvas.offsetY);
        domMatrix = domMatrix.scale(1 / temporaryPatternCanvas.scaleX, 1 / temporaryPatternCanvas.scaleY);
        var pattern = ctx.createPattern(temporaryPatternCanvas.canvas, "repeat");
        pattern.setTransform(domMatrix);
        return pattern;
    };
    TilingPattern.MAX_PATTERN_SIZE = 3000;
    return TilingPattern;
}());
; // ./src/shared/image_utils.js
function convertToRGBA(params) {
    switch (params.kind) {
        case ImageKind.GRAYSCALE_1BPP:
            return convertBlackAndWhiteToRGBA(params);
        case ImageKind.RGB_24BPP:
            return convertRGBToRGBA(params);
    }
    return null;
}
function convertBlackAndWhiteToRGBA(_j) {
    var src = _j.src, _k = _j.srcPos, srcPos = _k === void 0 ? 0 : _k, dest = _j.dest, width = _j.width, height = _j.height, _l = _j.nonBlackColor, nonBlackColor = _l === void 0 ? 0xffffffff : _l, _m = _j.inverseDecode, inverseDecode = _m === void 0 ? false : _m;
    var black = util_FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
    var _o = __read(inverseDecode ? [nonBlackColor, black] : [black, nonBlackColor], 2), zeroMapping = _o[0], oneMapping = _o[1];
    var widthInSource = width >> 3;
    var widthRemainder = width & 7;
    var srcLength = src.length;
    dest = new Uint32Array(dest.buffer);
    var destPos = 0;
    for (var i = 0; i < height; i++) {
        for (var max = srcPos + widthInSource; srcPos < max; srcPos++) {
            var elem_1 = srcPos < srcLength ? src[srcPos] : 255;
            dest[destPos++] = elem_1 & 128 ? oneMapping : zeroMapping;
            dest[destPos++] = elem_1 & 64 ? oneMapping : zeroMapping;
            dest[destPos++] = elem_1 & 32 ? oneMapping : zeroMapping;
            dest[destPos++] = elem_1 & 16 ? oneMapping : zeroMapping;
            dest[destPos++] = elem_1 & 8 ? oneMapping : zeroMapping;
            dest[destPos++] = elem_1 & 4 ? oneMapping : zeroMapping;
            dest[destPos++] = elem_1 & 2 ? oneMapping : zeroMapping;
            dest[destPos++] = elem_1 & 1 ? oneMapping : zeroMapping;
        }
        if (widthRemainder === 0) {
            continue;
        }
        var elem = srcPos < srcLength ? src[srcPos++] : 255;
        for (var j = 0; j < widthRemainder; j++) {
            dest[destPos++] = elem & 1 << 7 - j ? oneMapping : zeroMapping;
        }
    }
    return {
        srcPos: srcPos,
        destPos: destPos
    };
}
function convertRGBToRGBA(_j) {
    var src = _j.src, _k = _j.srcPos, srcPos = _k === void 0 ? 0 : _k, dest = _j.dest, _l = _j.destPos, destPos = _l === void 0 ? 0 : _l, width = _j.width, height = _j.height;
    var i = 0;
    var len = width * height * 3;
    var len32 = len >> 2;
    var src32 = new Uint32Array(src.buffer, srcPos, len32);
    if (FeatureTest.isLittleEndian) {
        for (; i < len32 - 2; i += 3, destPos += 4) {
            var s1 = src32[i];
            var s2 = src32[i + 1];
            var s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff000000;
            dest[destPos + 1] = s1 >>> 24 | s2 << 8 | 0xff000000;
            dest[destPos + 2] = s2 >>> 16 | s3 << 16 | 0xff000000;
            dest[destPos + 3] = s3 >>> 8 | 0xff000000;
        }
        for (var j = i * 4, jj = srcPos + len; j < jj; j += 3) {
            dest[destPos++] = src[j] | src[j + 1] << 8 | src[j + 2] << 16 | 0xff000000;
        }
    }
    else {
        for (; i < len32 - 2; i += 3, destPos += 4) {
            var s1 = src32[i];
            var s2 = src32[i + 1];
            var s3 = src32[i + 2];
            dest[destPos] = s1 | 0xff;
            dest[destPos + 1] = s1 << 24 | s2 >>> 8 | 0xff;
            dest[destPos + 2] = s2 << 16 | s3 >>> 16 | 0xff;
            dest[destPos + 3] = s3 << 8 | 0xff;
        }
        for (var j = i * 4, jj = srcPos + len; j < jj; j += 3) {
            dest[destPos++] = src[j] << 24 | src[j + 1] << 16 | src[j + 2] << 8 | 0xff;
        }
    }
    return {
        srcPos: srcPos + len,
        destPos: destPos
    };
}
function grayToRGBA(src, dest) {
    if (FeatureTest.isLittleEndian) {
        for (var i = 0, ii = src.length; i < ii; i++) {
            dest[i] = src[i] * 0x10101 | 0xff000000;
        }
    }
    else {
        for (var i = 0, ii = src.length; i < ii; i++) {
            dest[i] = src[i] * 0x1010100 | 0x000000ff;
        }
    }
}
; // ./src/display/canvas.js
var MIN_FONT_SIZE = 16;
var MAX_FONT_SIZE = 100;
var EXECUTION_TIME = 15;
var EXECUTION_STEPS = 10;
var FULL_CHUNK_HEIGHT = 16;
var SCALE_MATRIX = new DOMMatrix();
var XY = new Float32Array(2);
var MIN_MAX_INIT = new Float32Array([Infinity, Infinity, -Infinity, -Infinity]);
function mirrorContextOperations(ctx, destCtx) {
    if (ctx._removeMirroring) {
        throw new Error("Context is already forwarding operations.");
    }
    ctx.__originalSave = ctx.save;
    ctx.__originalRestore = ctx.restore;
    ctx.__originalRotate = ctx.rotate;
    ctx.__originalScale = ctx.scale;
    ctx.__originalTranslate = ctx.translate;
    ctx.__originalTransform = ctx.transform;
    ctx.__originalSetTransform = ctx.setTransform;
    ctx.__originalResetTransform = ctx.resetTransform;
    ctx.__originalClip = ctx.clip;
    ctx.__originalMoveTo = ctx.moveTo;
    ctx.__originalLineTo = ctx.lineTo;
    ctx.__originalBezierCurveTo = ctx.bezierCurveTo;
    ctx.__originalRect = ctx.rect;
    ctx.__originalClosePath = ctx.closePath;
    ctx.__originalBeginPath = ctx.beginPath;
    ctx._removeMirroring = function () {
        ctx.save = ctx.__originalSave;
        ctx.restore = ctx.__originalRestore;
        ctx.rotate = ctx.__originalRotate;
        ctx.scale = ctx.__originalScale;
        ctx.translate = ctx.__originalTranslate;
        ctx.transform = ctx.__originalTransform;
        ctx.setTransform = ctx.__originalSetTransform;
        ctx.resetTransform = ctx.__originalResetTransform;
        ctx.clip = ctx.__originalClip;
        ctx.moveTo = ctx.__originalMoveTo;
        ctx.lineTo = ctx.__originalLineTo;
        ctx.bezierCurveTo = ctx.__originalBezierCurveTo;
        ctx.rect = ctx.__originalRect;
        ctx.closePath = ctx.__originalClosePath;
        ctx.beginPath = ctx.__originalBeginPath;
        delete ctx._removeMirroring;
    };
    ctx.save = function () {
        destCtx.save();
        this.__originalSave();
    };
    ctx.restore = function () {
        destCtx.restore();
        this.__originalRestore();
    };
    ctx.translate = function (x, y) {
        destCtx.translate(x, y);
        this.__originalTranslate(x, y);
    };
    ctx.scale = function (x, y) {
        destCtx.scale(x, y);
        this.__originalScale(x, y);
    };
    ctx.transform = function (a, b, c, d, e, f) {
        destCtx.transform(a, b, c, d, e, f);
        this.__originalTransform(a, b, c, d, e, f);
    };
    ctx.setTransform = function (a, b, c, d, e, f) {
        destCtx.setTransform(a, b, c, d, e, f);
        this.__originalSetTransform(a, b, c, d, e, f);
    };
    ctx.resetTransform = function () {
        destCtx.resetTransform();
        this.__originalResetTransform();
    };
    ctx.rotate = function (angle) {
        destCtx.rotate(angle);
        this.__originalRotate(angle);
    };
    ctx.clip = function (rule) {
        destCtx.clip(rule);
        this.__originalClip(rule);
    };
    ctx.moveTo = function (x, y) {
        destCtx.moveTo(x, y);
        this.__originalMoveTo(x, y);
    };
    ctx.lineTo = function (x, y) {
        destCtx.lineTo(x, y);
        this.__originalLineTo(x, y);
    };
    ctx.bezierCurveTo = function (cp1x, cp1y, cp2x, cp2y, x, y) {
        destCtx.bezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
        this.__originalBezierCurveTo(cp1x, cp1y, cp2x, cp2y, x, y);
    };
    ctx.rect = function (x, y, width, height) {
        destCtx.rect(x, y, width, height);
        this.__originalRect(x, y, width, height);
    };
    ctx.closePath = function () {
        destCtx.closePath();
        this.__originalClosePath();
    };
    ctx.beginPath = function () {
        destCtx.beginPath();
        this.__originalBeginPath();
    };
}
var CachedCanvases = /** @class */ (function () {
    function CachedCanvases(canvasFactory) {
        this.canvasFactory = canvasFactory;
        this.cache = Object.create(null);
    }
    CachedCanvases.prototype.getCanvas = function (id, width, height) {
        var canvasEntry;
        if (this.cache[id] !== undefined) {
            canvasEntry = this.cache[id];
            this.canvasFactory.reset(canvasEntry, width, height);
        }
        else {
            canvasEntry = this.canvasFactory.create(width, height);
            this.cache[id] = canvasEntry;
        }
        return canvasEntry;
    };
    CachedCanvases.prototype.delete = function (id) {
        delete this.cache[id];
    };
    CachedCanvases.prototype.clear = function () {
        for (var id in this.cache) {
            var canvasEntry = this.cache[id];
            this.canvasFactory.destroy(canvasEntry);
            delete this.cache[id];
        }
    };
    return CachedCanvases;
}());
function drawImageAtIntegerCoords(ctx, srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH) {
    var _j = __read(getCurrentTransform(ctx), 6), a = _j[0], b = _j[1], c = _j[2], d = _j[3], tx = _j[4], ty = _j[5];
    if (b === 0 && c === 0) {
        var tlX = destX * a + tx;
        var rTlX = Math.round(tlX);
        var tlY = destY * d + ty;
        var rTlY = Math.round(tlY);
        var brX = (destX + destW) * a + tx;
        var rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        var brY = (destY + destH) * d + ty;
        var rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(Math.sign(a), 0, 0, Math.sign(d), rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rWidth, rHeight);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [rWidth, rHeight];
    }
    if (a === 0 && d === 0) {
        var tlX = destY * c + tx;
        var rTlX = Math.round(tlX);
        var tlY = destX * b + ty;
        var rTlY = Math.round(tlY);
        var brX = (destY + destH) * c + tx;
        var rWidth = Math.abs(Math.round(brX) - rTlX) || 1;
        var brY = (destX + destW) * b + ty;
        var rHeight = Math.abs(Math.round(brY) - rTlY) || 1;
        ctx.setTransform(0, Math.sign(b), Math.sign(c), 0, rTlX, rTlY);
        ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, 0, 0, rHeight, rWidth);
        ctx.setTransform(a, b, c, d, tx, ty);
        return [rHeight, rWidth];
    }
    ctx.drawImage(srcImg, srcX, srcY, srcW, srcH, destX, destY, destW, destH);
    var scaleX = Math.hypot(a, b);
    var scaleY = Math.hypot(c, d);
    return [scaleX * destW, scaleY * destH];
}
var CanvasExtraState = /** @class */ (function () {
    function CanvasExtraState(width, height) {
        this.alphaIsShape = false;
        this.fontSize = 0;
        this.fontSizeScale = 1;
        this.textMatrix = null;
        this.textMatrixScale = 1;
        this.fontMatrix = FONT_IDENTITY_MATRIX;
        this.leading = 0;
        this.x = 0;
        this.y = 0;
        this.lineX = 0;
        this.lineY = 0;
        this.charSpacing = 0;
        this.wordSpacing = 0;
        this.textHScale = 1;
        this.textRenderingMode = TextRenderingMode.FILL;
        this.textRise = 0;
        this.fillColor = "#000000";
        this.strokeColor = "#000000";
        this.patternFill = false;
        this.patternStroke = false;
        this.fillAlpha = 1;
        this.strokeAlpha = 1;
        this.lineWidth = 1;
        this.activeSMask = null;
        this.transferMaps = "none";
        this.clipBox = new Float32Array([0, 0, width, height]);
        this.minMax = MIN_MAX_INIT.slice();
    }
    CanvasExtraState.prototype.clone = function () {
        var clone = Object.create(this);
        clone.clipBox = this.clipBox.slice();
        clone.minMax = this.minMax.slice();
        return clone;
    };
    CanvasExtraState.prototype.getPathBoundingBox = function (pathType, transform) {
        if (pathType === void 0) { pathType = PathType.FILL; }
        if (transform === void 0) { transform = null; }
        var box = this.minMax.slice();
        if (pathType === PathType.STROKE) {
            if (!transform) {
                unreachable("Stroke bounding box must include transform.");
            }
            Util.singularValueDecompose2dScale(transform, XY);
            var xStrokePad = XY[0] * this.lineWidth / 2;
            var yStrokePad = XY[1] * this.lineWidth / 2;
            box[0] -= xStrokePad;
            box[1] -= yStrokePad;
            box[2] += xStrokePad;
            box[3] += yStrokePad;
        }
        return box;
    };
    CanvasExtraState.prototype.updateClipFromPath = function () {
        var intersect = Util.intersect(this.clipBox, this.getPathBoundingBox());
        this.startNewPathAndClipBox(intersect || [0, 0, 0, 0]);
    };
    CanvasExtraState.prototype.isEmptyClip = function () {
        return this.minMax[0] === Infinity;
    };
    CanvasExtraState.prototype.startNewPathAndClipBox = function (box) {
        this.clipBox.set(box, 0);
        this.minMax.set(MIN_MAX_INIT, 0);
    };
    CanvasExtraState.prototype.getClippedPathBoundingBox = function (pathType, transform) {
        if (pathType === void 0) { pathType = PathType.FILL; }
        if (transform === void 0) { transform = null; }
        return Util.intersect(this.clipBox, this.getPathBoundingBox(pathType, transform));
    };
    return CanvasExtraState;
}());
function putBinaryImageData(ctx, imgData) {
    if (imgData instanceof ImageData) {
        ctx.putImageData(imgData, 0, 0);
        return;
    }
    var height = imgData.height, width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0, destPos;
    var src = imgData.data;
    var dest = chunkImgData.data;
    var i, j, thisChunkHeight, elemsInThisChunk;
    if (imgData.kind === util_ImageKind.GRAYSCALE_1BPP) {
        var srcLength = src.byteLength;
        var dest32 = new Uint32Array(dest.buffer, 0, dest.byteLength >> 2);
        var dest32DataLength = dest32.length;
        var fullSrcDiff = width + 7 >> 3;
        var white = 0xffffffff;
        var black = util_FeatureTest.isLittleEndian ? 0xff000000 : 0x000000ff;
        for (i = 0; i < totalChunks; i++) {
            thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
            destPos = 0;
            for (j = 0; j < thisChunkHeight; j++) {
                var srcDiff = srcLength - srcPos;
                var k = 0;
                var kEnd = srcDiff > fullSrcDiff ? width : srcDiff * 8 - 7;
                var kEndUnrolled = kEnd & ~7;
                var mask = 0;
                var srcByte = 0;
                for (; k < kEndUnrolled; k += 8) {
                    srcByte = src[srcPos++];
                    dest32[destPos++] = srcByte & 128 ? white : black;
                    dest32[destPos++] = srcByte & 64 ? white : black;
                    dest32[destPos++] = srcByte & 32 ? white : black;
                    dest32[destPos++] = srcByte & 16 ? white : black;
                    dest32[destPos++] = srcByte & 8 ? white : black;
                    dest32[destPos++] = srcByte & 4 ? white : black;
                    dest32[destPos++] = srcByte & 2 ? white : black;
                    dest32[destPos++] = srcByte & 1 ? white : black;
                }
                for (; k < kEnd; k++) {
                    if (mask === 0) {
                        srcByte = src[srcPos++];
                        mask = 128;
                    }
                    dest32[destPos++] = srcByte & mask ? white : black;
                    mask >>= 1;
                }
            }
            while (destPos < dest32DataLength) {
                dest32[destPos++] = 0;
            }
            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
        }
    }
    else if (imgData.kind === util_ImageKind.RGBA_32BPP) {
        j = 0;
        elemsInThisChunk = width * FULL_CHUNK_HEIGHT * 4;
        for (i = 0; i < fullChunks; i++) {
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            srcPos += elemsInThisChunk;
            ctx.putImageData(chunkImgData, 0, j);
            j += FULL_CHUNK_HEIGHT;
        }
        if (i < totalChunks) {
            elemsInThisChunk = width * partialChunkHeight * 4;
            dest.set(src.subarray(srcPos, srcPos + elemsInThisChunk));
            ctx.putImageData(chunkImgData, 0, j);
        }
    }
    else if (imgData.kind === util_ImageKind.RGB_24BPP) {
        thisChunkHeight = FULL_CHUNK_HEIGHT;
        elemsInThisChunk = width * thisChunkHeight;
        for (i = 0; i < totalChunks; i++) {
            if (i >= fullChunks) {
                thisChunkHeight = partialChunkHeight;
                elemsInThisChunk = width * thisChunkHeight;
            }
            destPos = 0;
            for (j = elemsInThisChunk; j--;) {
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = src[srcPos++];
                dest[destPos++] = 255;
            }
            ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
        }
    }
    else {
        throw new Error("bad image kind: ".concat(imgData.kind));
    }
}
function putBinaryImageMask(ctx, imgData) {
    if (imgData.bitmap) {
        ctx.drawImage(imgData.bitmap, 0, 0);
        return;
    }
    var height = imgData.height, width = imgData.width;
    var partialChunkHeight = height % FULL_CHUNK_HEIGHT;
    var fullChunks = (height - partialChunkHeight) / FULL_CHUNK_HEIGHT;
    var totalChunks = partialChunkHeight === 0 ? fullChunks : fullChunks + 1;
    var chunkImgData = ctx.createImageData(width, FULL_CHUNK_HEIGHT);
    var srcPos = 0;
    var src = imgData.data;
    var dest = chunkImgData.data;
    for (var i = 0; i < totalChunks; i++) {
        var thisChunkHeight = i < fullChunks ? FULL_CHUNK_HEIGHT : partialChunkHeight;
        (srcPos = convertBlackAndWhiteToRGBA({
            src: src,
            srcPos: srcPos,
            dest: dest,
            width: width,
            height: thisChunkHeight,
            nonBlackColor: 0
        }).srcPos);
        ctx.putImageData(chunkImgData, 0, i * FULL_CHUNK_HEIGHT);
    }
}
function copyCtxState(sourceCtx, destCtx) {
    var e_74, _j;
    var properties = ["strokeStyle", "fillStyle", "fillRule", "globalAlpha", "lineWidth", "lineCap", "lineJoin", "miterLimit", "globalCompositeOperation", "font", "filter"];
    try {
        for (var properties_1 = __values(properties), properties_1_1 = properties_1.next(); !properties_1_1.done; properties_1_1 = properties_1.next()) {
            var property = properties_1_1.value;
            if (sourceCtx[property] !== undefined) {
                destCtx[property] = sourceCtx[property];
            }
        }
    }
    catch (e_74_1) { e_74 = { error: e_74_1 }; }
    finally {
        try {
            if (properties_1_1 && !properties_1_1.done && (_j = properties_1.return)) _j.call(properties_1);
        }
        finally { if (e_74) throw e_74.error; }
    }
    if (sourceCtx.setLineDash !== undefined) {
        destCtx.setLineDash(sourceCtx.getLineDash());
        destCtx.lineDashOffset = sourceCtx.lineDashOffset;
    }
}
function resetCtxToDefault(ctx) {
    ctx.strokeStyle = ctx.fillStyle = "#000000";
    ctx.fillRule = "nonzero";
    ctx.globalAlpha = 1;
    ctx.lineWidth = 1;
    ctx.lineCap = "butt";
    ctx.lineJoin = "miter";
    ctx.miterLimit = 10;
    ctx.globalCompositeOperation = "source-over";
    ctx.font = "10px sans-serif";
    if (ctx.setLineDash !== undefined) {
        ctx.setLineDash([]);
        ctx.lineDashOffset = 0;
    }
    var filter = ctx.filter;
    if (filter !== "none" && filter !== "") {
        ctx.filter = "none";
    }
}
function getImageSmoothingEnabled(transform, interpolate) {
    if (interpolate) {
        return true;
    }
    Util.singularValueDecompose2dScale(transform, XY);
    var actualScale = Math.fround(OutputScale.pixelRatio * PixelsPerInch.PDF_TO_CSS_UNITS);
    return XY[0] <= actualScale && XY[1] <= actualScale;
}
var LINE_CAP_STYLES = ["butt", "round", "square"];
var LINE_JOIN_STYLES = ["miter", "round", "bevel"];
var NORMAL_CLIP = {};
var EO_CLIP = {};
var CanvasGraphics = /** @class */ (function () {
    function CanvasGraphics(canvasCtx, commonObjs, objs, canvasFactory, filterFactory, _j, annotationCanvasMap, pageColors) {
        var optionalContentConfig = _j.optionalContentConfig, _k = _j.markedContentStack, markedContentStack = _k === void 0 ? null : _k;
        _CanvasGraphics_instances.add(this);
        this.ctx = canvasCtx;
        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.stateStack = [];
        this.pendingClip = null;
        this.pendingEOFill = false;
        this.res = null;
        this.xobjs = null;
        this.commonObjs = commonObjs;
        this.objs = objs;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this.groupStack = [];
        this.baseTransform = null;
        this.baseTransformStack = [];
        this.groupLevel = 0;
        this.smaskStack = [];
        this.smaskCounter = 0;
        this.tempSMask = null;
        this.suspendedCtx = null;
        this.contentVisible = true;
        this.markedContentStack = markedContentStack || [];
        this.optionalContentConfig = optionalContentConfig;
        this.cachedCanvases = new CachedCanvases(this.canvasFactory);
        this.cachedPatterns = new Map();
        this.annotationCanvasMap = annotationCanvasMap;
        this.viewportScale = 1;
        this.outputScaleX = 1;
        this.outputScaleY = 1;
        this.pageColors = pageColors;
        this._cachedScaleForStroking = [-1, 0];
        this._cachedGetSinglePixelWidth = null;
        this._cachedBitmapsMap = new Map();
    }
    CanvasGraphics.prototype.getObject = function (data, fallback) {
        if (fallback === void 0) { fallback = null; }
        if (typeof data === "string") {
            return data.startsWith("g_") ? this.commonObjs.get(data) : this.objs.get(data);
        }
        return fallback;
    };
    CanvasGraphics.prototype.beginDrawing = function (_j) {
        var _k, _l, _m;
        var transform = _j.transform, viewport = _j.viewport, _o = _j.transparency, transparency = _o === void 0 ? false : _o, _p = _j.background, background = _p === void 0 ? null : _p;
        var width = this.ctx.canvas.width;
        var height = this.ctx.canvas.height;
        var savedFillStyle = this.ctx.fillStyle;
        this.ctx.fillStyle = background || "#ffffff";
        this.ctx.fillRect(0, 0, width, height);
        this.ctx.fillStyle = savedFillStyle;
        if (transparency) {
            var transparentCanvas = this.cachedCanvases.getCanvas("transparent", width, height);
            this.compositeCtx = this.ctx;
            this.transparentCanvas = transparentCanvas.canvas;
            this.ctx = transparentCanvas.context;
            this.ctx.save();
            (_k = this.ctx).transform.apply(_k, __spreadArray([], __read(getCurrentTransform(this.compositeCtx)), false));
        }
        this.ctx.save();
        resetCtxToDefault(this.ctx);
        if (transform) {
            (_l = this.ctx).transform.apply(_l, __spreadArray([], __read(transform), false));
            this.outputScaleX = transform[0];
            this.outputScaleY = transform[0];
        }
        (_m = this.ctx).transform.apply(_m, __spreadArray([], __read(viewport.transform), false));
        this.viewportScale = viewport.scale;
        this.baseTransform = getCurrentTransform(this.ctx);
    };
    CanvasGraphics.prototype.executeOperatorList = function (operatorList, executionStartIdx, continueCallback, stepper) {
        var e_75, _j;
        var argsArray = operatorList.argsArray;
        var fnArray = operatorList.fnArray;
        var i = executionStartIdx || 0;
        var argsArrayLen = argsArray.length;
        if (argsArrayLen === i) {
            return i;
        }
        var chunkOperations = argsArrayLen - i > EXECUTION_STEPS && typeof continueCallback === "function";
        var endTime = chunkOperations ? Date.now() + EXECUTION_TIME : 0;
        var steps = 0;
        var commonObjs = this.commonObjs;
        var objs = this.objs;
        var fnId;
        while (true) {
            if (stepper !== undefined && i === stepper.nextBreakPoint) {
                stepper.breakIt(i, continueCallback);
                return i;
            }
            fnId = fnArray[i];
            if (fnId !== OPS.dependency) {
                this[fnId].apply(this, argsArray[i]);
            }
            else {
                try {
                    for (var _k = (e_75 = void 0, __values(argsArray[i])), _l = _k.next(); !_l.done; _l = _k.next()) {
                        var depObjId = _l.value;
                        var objsPool = depObjId.startsWith("g_") ? commonObjs : objs;
                        if (!objsPool.has(depObjId)) {
                            objsPool.get(depObjId, continueCallback);
                            return i;
                        }
                    }
                }
                catch (e_75_1) { e_75 = { error: e_75_1 }; }
                finally {
                    try {
                        if (_l && !_l.done && (_j = _k.return)) _j.call(_k);
                    }
                    finally { if (e_75) throw e_75.error; }
                }
            }
            i++;
            if (i === argsArrayLen) {
                return i;
            }
            if (chunkOperations && ++steps > EXECUTION_STEPS) {
                if (Date.now() > endTime) {
                    continueCallback();
                    return i;
                }
                steps = 0;
            }
        }
    };
    CanvasGraphics.prototype.endDrawing = function () {
        var e_76, _j, e_77, _k;
        __classPrivateFieldGet(this, _CanvasGraphics_instances, "m", _CanvasGraphics_restoreInitialState).call(this);
        this.cachedCanvases.clear();
        this.cachedPatterns.clear();
        try {
            for (var _l = __values(this._cachedBitmapsMap.values()), _m = _l.next(); !_m.done; _m = _l.next()) {
                var cache = _m.value;
                try {
                    for (var _o = (e_77 = void 0, __values(cache.values())), _p = _o.next(); !_p.done; _p = _o.next()) {
                        var canvas = _p.value;
                        if (typeof HTMLCanvasElement !== "undefined" && canvas instanceof HTMLCanvasElement) {
                            canvas.width = canvas.height = 0;
                        }
                    }
                }
                catch (e_77_1) { e_77 = { error: e_77_1 }; }
                finally {
                    try {
                        if (_p && !_p.done && (_k = _o.return)) _k.call(_o);
                    }
                    finally { if (e_77) throw e_77.error; }
                }
                cache.clear();
            }
        }
        catch (e_76_1) { e_76 = { error: e_76_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_j = _l.return)) _j.call(_l);
            }
            finally { if (e_76) throw e_76.error; }
        }
        this._cachedBitmapsMap.clear();
        __classPrivateFieldGet(this, _CanvasGraphics_instances, "m", _CanvasGraphics_drawFilter).call(this);
    };
    CanvasGraphics.prototype._scaleImage = function (img, inverseTransform) {
        var _j, _k;
        var width = (_j = img.width) !== null && _j !== void 0 ? _j : img.displayWidth;
        var height = (_k = img.height) !== null && _k !== void 0 ? _k : img.displayHeight;
        var widthScale = Math.max(Math.hypot(inverseTransform[0], inverseTransform[1]), 1);
        var heightScale = Math.max(Math.hypot(inverseTransform[2], inverseTransform[3]), 1);
        var paintWidth = width, paintHeight = height;
        var tmpCanvasId = "prescale1";
        var tmpCanvas, tmpCtx;
        while (widthScale > 2 && paintWidth > 1 || heightScale > 2 && paintHeight > 1) {
            var newWidth = paintWidth, newHeight = paintHeight;
            if (widthScale > 2 && paintWidth > 1) {
                newWidth = paintWidth >= 16384 ? Math.floor(paintWidth / 2) - 1 || 1 : Math.ceil(paintWidth / 2);
                widthScale /= paintWidth / newWidth;
            }
            if (heightScale > 2 && paintHeight > 1) {
                newHeight = paintHeight >= 16384 ? Math.floor(paintHeight / 2) - 1 || 1 : Math.ceil(paintHeight) / 2;
                heightScale /= paintHeight / newHeight;
            }
            tmpCanvas = this.cachedCanvases.getCanvas(tmpCanvasId, newWidth, newHeight);
            tmpCtx = tmpCanvas.context;
            tmpCtx.clearRect(0, 0, newWidth, newHeight);
            tmpCtx.drawImage(img, 0, 0, paintWidth, paintHeight, 0, 0, newWidth, newHeight);
            img = tmpCanvas.canvas;
            paintWidth = newWidth;
            paintHeight = newHeight;
            tmpCanvasId = tmpCanvasId === "prescale1" ? "prescale2" : "prescale1";
        }
        return {
            img: img,
            paintWidth: paintWidth,
            paintHeight: paintHeight
        };
    };
    CanvasGraphics.prototype._createMaskCanvas = function (img) {
        var ctx = this.ctx;
        var width = img.width, height = img.height;
        var fillColor = this.current.fillColor;
        var isPatternFill = this.current.patternFill;
        var currentTransform = getCurrentTransform(ctx);
        var cache, cacheKey, scaled, maskCanvas;
        if ((img.bitmap || img.data) && img.count > 1) {
            var mainKey = img.bitmap || img.data.buffer;
            cacheKey = JSON.stringify(isPatternFill ? currentTransform : [currentTransform.slice(0, 4), fillColor]);
            cache = this._cachedBitmapsMap.get(mainKey);
            if (!cache) {
                cache = new Map();
                this._cachedBitmapsMap.set(mainKey, cache);
            }
            var cachedImage = cache.get(cacheKey);
            if (cachedImage && !isPatternFill) {
                var offsetX_1 = Math.round(Math.min(currentTransform[0], currentTransform[2]) + currentTransform[4]);
                var offsetY_1 = Math.round(Math.min(currentTransform[1], currentTransform[3]) + currentTransform[5]);
                return {
                    canvas: cachedImage,
                    offsetX: offsetX_1,
                    offsetY: offsetY_1
                };
            }
            scaled = cachedImage;
        }
        if (!scaled) {
            maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
            putBinaryImageMask(maskCanvas.context, img);
        }
        var maskToCanvas = Util.transform(currentTransform, [1 / width, 0, 0, -1 / height, 0, 0]);
        maskToCanvas = Util.transform(maskToCanvas, [1, 0, 0, 1, 0, -height]);
        var minMax = MIN_MAX_INIT.slice();
        Util.axialAlignedBoundingBox([0, 0, width, height], maskToCanvas, minMax);
        var _j = __read(minMax, 4), minX = _j[0], minY = _j[1], maxX = _j[2], maxY = _j[3];
        var drawnWidth = Math.round(maxX - minX) || 1;
        var drawnHeight = Math.round(maxY - minY) || 1;
        var fillCanvas = this.cachedCanvases.getCanvas("fillCanvas", drawnWidth, drawnHeight);
        var fillCtx = fillCanvas.context;
        var offsetX = minX;
        var offsetY = minY;
        fillCtx.translate(-offsetX, -offsetY);
        fillCtx.transform.apply(fillCtx, __spreadArray([], __read(maskToCanvas), false));
        if (!scaled) {
            scaled = this._scaleImage(maskCanvas.canvas, getCurrentTransformInverse(fillCtx));
            scaled = scaled.img;
            if (cache && isPatternFill) {
                cache.set(cacheKey, scaled);
            }
        }
        fillCtx.imageSmoothingEnabled = getImageSmoothingEnabled(getCurrentTransform(fillCtx), img.interpolate);
        drawImageAtIntegerCoords(fillCtx, scaled, 0, 0, scaled.width, scaled.height, 0, 0, width, height);
        fillCtx.globalCompositeOperation = "source-in";
        var inverse = Util.transform(getCurrentTransformInverse(fillCtx), [1, 0, 0, 1, -offsetX, -offsetY]);
        fillCtx.fillStyle = isPatternFill ? fillColor.getPattern(ctx, this, inverse, PathType.FILL) : fillColor;
        fillCtx.fillRect(0, 0, width, height);
        if (cache && !isPatternFill) {
            this.cachedCanvases.delete("fillCanvas");
            cache.set(cacheKey, fillCanvas.canvas);
        }
        return {
            canvas: fillCanvas.canvas,
            offsetX: Math.round(offsetX),
            offsetY: Math.round(offsetY)
        };
    };
    CanvasGraphics.prototype.setLineWidth = function (width) {
        if (width !== this.current.lineWidth) {
            this._cachedScaleForStroking[0] = -1;
        }
        this.current.lineWidth = width;
        this.ctx.lineWidth = width;
    };
    CanvasGraphics.prototype.setLineCap = function (style) {
        this.ctx.lineCap = LINE_CAP_STYLES[style];
    };
    CanvasGraphics.prototype.setLineJoin = function (style) {
        this.ctx.lineJoin = LINE_JOIN_STYLES[style];
    };
    CanvasGraphics.prototype.setMiterLimit = function (limit) {
        this.ctx.miterLimit = limit;
    };
    CanvasGraphics.prototype.setDash = function (dashArray, dashPhase) {
        var ctx = this.ctx;
        if (ctx.setLineDash !== undefined) {
            ctx.setLineDash(dashArray);
            ctx.lineDashOffset = dashPhase;
        }
    };
    CanvasGraphics.prototype.setRenderingIntent = function (intent) { };
    CanvasGraphics.prototype.setFlatness = function (flatness) { };
    CanvasGraphics.prototype.setGState = function (states) {
        var e_78, _j;
        try {
            for (var states_1 = __values(states), states_1_1 = states_1.next(); !states_1_1.done; states_1_1 = states_1.next()) {
                var _k = __read(states_1_1.value, 2), key = _k[0], value = _k[1];
                switch (key) {
                    case "LW":
                        this.setLineWidth(value);
                        break;
                    case "LC":
                        this.setLineCap(value);
                        break;
                    case "LJ":
                        this.setLineJoin(value);
                        break;
                    case "ML":
                        this.setMiterLimit(value);
                        break;
                    case "D":
                        this.setDash(value[0], value[1]);
                        break;
                    case "RI":
                        this.setRenderingIntent(value);
                        break;
                    case "FL":
                        this.setFlatness(value);
                        break;
                    case "Font":
                        this.setFont(value[0], value[1]);
                        break;
                    case "CA":
                        this.current.strokeAlpha = value;
                        break;
                    case "ca":
                        this.ctx.globalAlpha = this.current.fillAlpha = value;
                        break;
                    case "BM":
                        this.ctx.globalCompositeOperation = value;
                        break;
                    case "SMask":
                        this.current.activeSMask = value ? this.tempSMask : null;
                        this.tempSMask = null;
                        this.checkSMaskState();
                        break;
                    case "TR":
                        this.ctx.filter = this.current.transferMaps = this.filterFactory.addFilter(value);
                        break;
                }
            }
        }
        catch (e_78_1) { e_78 = { error: e_78_1 }; }
        finally {
            try {
                if (states_1_1 && !states_1_1.done && (_j = states_1.return)) _j.call(states_1);
            }
            finally { if (e_78) throw e_78.error; }
        }
    };
    Object.defineProperty(CanvasGraphics.prototype, "inSMaskMode", {
        get: function () {
            return !!this.suspendedCtx;
        },
        enumerable: false,
        configurable: true
    });
    CanvasGraphics.prototype.checkSMaskState = function () {
        var inSMaskMode = this.inSMaskMode;
        if (this.current.activeSMask && !inSMaskMode) {
            this.beginSMaskMode();
        }
        else if (!this.current.activeSMask && inSMaskMode) {
            this.endSMaskMode();
        }
    };
    CanvasGraphics.prototype.beginSMaskMode = function () {
        if (this.inSMaskMode) {
            throw new Error("beginSMaskMode called while already in smask mode");
        }
        var drawnWidth = this.ctx.canvas.width;
        var drawnHeight = this.ctx.canvas.height;
        var cacheId = "smaskGroupAt" + this.groupLevel;
        var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        this.suspendedCtx = this.ctx;
        var ctx = this.ctx = scratchCanvas.context;
        ctx.setTransform(this.suspendedCtx.getTransform());
        copyCtxState(this.suspendedCtx, ctx);
        mirrorContextOperations(ctx, this.suspendedCtx);
        this.setGState([["BM", "source-over"]]);
    };
    CanvasGraphics.prototype.endSMaskMode = function () {
        if (!this.inSMaskMode) {
            throw new Error("endSMaskMode called while not in smask mode");
        }
        this.ctx._removeMirroring();
        copyCtxState(this.ctx, this.suspendedCtx);
        this.ctx = this.suspendedCtx;
        this.suspendedCtx = null;
    };
    CanvasGraphics.prototype.compose = function (dirtyBox) {
        if (!this.current.activeSMask) {
            return;
        }
        if (!dirtyBox) {
            dirtyBox = [0, 0, this.ctx.canvas.width, this.ctx.canvas.height];
        }
        else {
            dirtyBox[0] = Math.floor(dirtyBox[0]);
            dirtyBox[1] = Math.floor(dirtyBox[1]);
            dirtyBox[2] = Math.ceil(dirtyBox[2]);
            dirtyBox[3] = Math.ceil(dirtyBox[3]);
        }
        var smask = this.current.activeSMask;
        var suspendedCtx = this.suspendedCtx;
        this.composeSMask(suspendedCtx, smask, this.ctx, dirtyBox);
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.clearRect(0, 0, this.ctx.canvas.width, this.ctx.canvas.height);
        this.ctx.restore();
    };
    CanvasGraphics.prototype.composeSMask = function (ctx, smask, layerCtx, layerBox) {
        var layerOffsetX = layerBox[0];
        var layerOffsetY = layerBox[1];
        var layerWidth = layerBox[2] - layerOffsetX;
        var layerHeight = layerBox[3] - layerOffsetY;
        if (layerWidth === 0 || layerHeight === 0) {
            return;
        }
        this.genericComposeSMask(smask.context, layerCtx, layerWidth, layerHeight, smask.subtype, smask.backdrop, smask.transferMap, layerOffsetX, layerOffsetY, smask.offsetX, smask.offsetY);
        ctx.save();
        ctx.globalAlpha = 1;
        ctx.globalCompositeOperation = "source-over";
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(layerCtx.canvas, 0, 0);
        ctx.restore();
    };
    CanvasGraphics.prototype.genericComposeSMask = function (maskCtx, layerCtx, width, height, subtype, backdrop, transferMap, layerOffsetX, layerOffsetY, maskOffsetX, maskOffsetY) {
        var maskCanvas = maskCtx.canvas;
        var maskX = layerOffsetX - maskOffsetX;
        var maskY = layerOffsetY - maskOffsetY;
        if (backdrop) {
            var backdropRGB = Util.makeHexColor.apply(Util, __spreadArray([], __read(backdrop), false));
            if (maskX < 0 || maskY < 0 || maskX + width > maskCanvas.width || maskY + height > maskCanvas.height) {
                var canvas = this.cachedCanvases.getCanvas("maskExtension", width, height);
                var ctx = canvas.context;
                ctx.drawImage(maskCanvas, -maskX, -maskY);
                ctx.globalCompositeOperation = "destination-atop";
                ctx.fillStyle = backdropRGB;
                ctx.fillRect(0, 0, width, height);
                ctx.globalCompositeOperation = "source-over";
                maskCanvas = canvas.canvas;
                maskX = maskY = 0;
            }
            else {
                maskCtx.save();
                maskCtx.globalAlpha = 1;
                maskCtx.setTransform(1, 0, 0, 1, 0, 0);
                var clip_1 = new Path2D();
                clip_1.rect(maskX, maskY, width, height);
                maskCtx.clip(clip_1);
                maskCtx.globalCompositeOperation = "destination-atop";
                maskCtx.fillStyle = backdropRGB;
                maskCtx.fillRect(maskX, maskY, width, height);
                maskCtx.restore();
            }
        }
        layerCtx.save();
        layerCtx.globalAlpha = 1;
        layerCtx.setTransform(1, 0, 0, 1, 0, 0);
        if (subtype === "Alpha" && transferMap) {
            layerCtx.filter = this.filterFactory.addAlphaFilter(transferMap);
        }
        else if (subtype === "Luminosity") {
            layerCtx.filter = this.filterFactory.addLuminosityFilter(transferMap);
        }
        var clip = new Path2D();
        clip.rect(layerOffsetX, layerOffsetY, width, height);
        layerCtx.clip(clip);
        layerCtx.globalCompositeOperation = "destination-in";
        layerCtx.drawImage(maskCanvas, maskX, maskY, width, height, layerOffsetX, layerOffsetY, width, height);
        layerCtx.restore();
    };
    CanvasGraphics.prototype.save = function () {
        if (this.inSMaskMode) {
            copyCtxState(this.ctx, this.suspendedCtx);
        }
        this.ctx.save();
        var old = this.current;
        this.stateStack.push(old);
        this.current = old.clone();
    };
    CanvasGraphics.prototype.restore = function () {
        if (this.stateStack.length === 0) {
            if (this.inSMaskMode) {
                this.endSMaskMode();
            }
            return;
        }
        this.current = this.stateStack.pop();
        this.ctx.restore();
        if (this.inSMaskMode) {
            copyCtxState(this.suspendedCtx, this.ctx);
        }
        this.checkSMaskState();
        this.pendingClip = null;
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    };
    CanvasGraphics.prototype.transform = function (a, b, c, d, e, f) {
        this.ctx.transform(a, b, c, d, e, f);
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
    };
    CanvasGraphics.prototype.constructPath = function (op, data, minMax) {
        var _j = __read(data, 1), path = _j[0];
        if (!minMax) {
            path || (path = data[0] = new Path2D());
            this[op](path);
            return;
        }
        if (!(path instanceof Path2D)) {
            var path2d = data[0] = new Path2D();
            for (var i = 0, ii = path.length; i < ii;) {
                switch (path[i++]) {
                    case DrawOPS.moveTo:
                        path2d.moveTo(path[i++], path[i++]);
                        break;
                    case DrawOPS.lineTo:
                        path2d.lineTo(path[i++], path[i++]);
                        break;
                    case DrawOPS.curveTo:
                        path2d.bezierCurveTo(path[i++], path[i++], path[i++], path[i++], path[i++], path[i++]);
                        break;
                    case DrawOPS.closePath:
                        path2d.closePath();
                        break;
                    default:
                        warn("Unrecognized drawing path operator: ".concat(path[i - 1]));
                        break;
                }
            }
            path = path2d;
        }
        Util.axialAlignedBoundingBox(minMax, getCurrentTransform(this.ctx), this.current.minMax);
        this[op](path);
    };
    CanvasGraphics.prototype.closePath = function () {
        this.ctx.closePath();
    };
    CanvasGraphics.prototype.stroke = function (path, consumePath) {
        if (consumePath === void 0) { consumePath = true; }
        var ctx = this.ctx;
        var strokeColor = this.current.strokeColor;
        ctx.globalAlpha = this.current.strokeAlpha;
        if (this.contentVisible) {
            if (typeof strokeColor === "object" && (strokeColor === null || strokeColor === void 0 ? void 0 : strokeColor.getPattern)) {
                var baseTransform = strokeColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
                ctx.save();
                ctx.strokeStyle = strokeColor.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.STROKE);
                if (baseTransform) {
                    var newPath = new Path2D();
                    newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                    path = newPath;
                }
                this.rescaleAndStroke(path, false);
                ctx.restore();
            }
            else {
                this.rescaleAndStroke(path, true);
            }
        }
        if (consumePath) {
            this.consumePath(path, this.current.getClippedPathBoundingBox(PathType.STROKE, getCurrentTransform(this.ctx)));
        }
        ctx.globalAlpha = this.current.fillAlpha;
    };
    CanvasGraphics.prototype.closeStroke = function (path) {
        this.stroke(path);
    };
    CanvasGraphics.prototype.fill = function (path, consumePath) {
        if (consumePath === void 0) { consumePath = true; }
        var ctx = this.ctx;
        var fillColor = this.current.fillColor;
        var isPatternFill = this.current.patternFill;
        var needRestore = false;
        if (isPatternFill) {
            var baseTransform = fillColor.isModifyingCurrentTransform() ? ctx.getTransform() : null;
            ctx.save();
            ctx.fillStyle = fillColor.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.FILL);
            if (baseTransform) {
                var newPath = new Path2D();
                newPath.addPath(path, ctx.getTransform().invertSelf().multiplySelf(baseTransform));
                path = newPath;
            }
            needRestore = true;
        }
        var intersect = this.current.getClippedPathBoundingBox();
        if (this.contentVisible && intersect !== null) {
            if (this.pendingEOFill) {
                ctx.fill(path, "evenodd");
                this.pendingEOFill = false;
            }
            else {
                ctx.fill(path);
            }
        }
        if (needRestore) {
            ctx.restore();
        }
        if (consumePath) {
            this.consumePath(path, intersect);
        }
    };
    CanvasGraphics.prototype.eoFill = function (path) {
        this.pendingEOFill = true;
        this.fill(path);
    };
    CanvasGraphics.prototype.fillStroke = function (path) {
        this.fill(path, false);
        this.stroke(path, false);
        this.consumePath(path);
    };
    CanvasGraphics.prototype.eoFillStroke = function (path) {
        this.pendingEOFill = true;
        this.fillStroke(path);
    };
    CanvasGraphics.prototype.closeFillStroke = function (path) {
        this.fillStroke(path);
    };
    CanvasGraphics.prototype.closeEOFillStroke = function (path) {
        this.pendingEOFill = true;
        this.fillStroke(path);
    };
    CanvasGraphics.prototype.endPath = function (path) {
        this.consumePath(path);
    };
    CanvasGraphics.prototype.rawFillPath = function (path) {
        this.ctx.fill(path);
    };
    CanvasGraphics.prototype.clip = function () {
        this.pendingClip = NORMAL_CLIP;
    };
    CanvasGraphics.prototype.eoClip = function () {
        this.pendingClip = EO_CLIP;
    };
    CanvasGraphics.prototype.beginText = function () {
        this.current.textMatrix = null;
        this.current.textMatrixScale = 1;
        this.current.x = this.current.lineX = 0;
        this.current.y = this.current.lineY = 0;
    };
    CanvasGraphics.prototype.endText = function () {
        var e_79, _j;
        var paths = this.pendingTextPaths;
        var ctx = this.ctx;
        if (paths === undefined) {
            return;
        }
        var newPath = new Path2D();
        var invTransf = ctx.getTransform().invertSelf();
        try {
            for (var paths_1 = __values(paths), paths_1_1 = paths_1.next(); !paths_1_1.done; paths_1_1 = paths_1.next()) {
                var _k = paths_1_1.value, transform = _k.transform, x = _k.x, y = _k.y, fontSize = _k.fontSize, path = _k.path;
                newPath.addPath(path, new DOMMatrix(transform).preMultiplySelf(invTransf).translate(x, y).scale(fontSize, -fontSize));
            }
        }
        catch (e_79_1) { e_79 = { error: e_79_1 }; }
        finally {
            try {
                if (paths_1_1 && !paths_1_1.done && (_j = paths_1.return)) _j.call(paths_1);
            }
            finally { if (e_79) throw e_79.error; }
        }
        ctx.clip(newPath);
        delete this.pendingTextPaths;
    };
    CanvasGraphics.prototype.setCharSpacing = function (spacing) {
        this.current.charSpacing = spacing;
    };
    CanvasGraphics.prototype.setWordSpacing = function (spacing) {
        this.current.wordSpacing = spacing;
    };
    CanvasGraphics.prototype.setHScale = function (scale) {
        this.current.textHScale = scale / 100;
    };
    CanvasGraphics.prototype.setLeading = function (leading) {
        this.current.leading = -leading;
    };
    CanvasGraphics.prototype.setFont = function (fontRefName, size) {
        var _j;
        var fontObj = this.commonObjs.get(fontRefName);
        var current = this.current;
        if (!fontObj) {
            throw new Error("Can't find font for ".concat(fontRefName));
        }
        current.fontMatrix = fontObj.fontMatrix || FONT_IDENTITY_MATRIX;
        if (current.fontMatrix[0] === 0 || current.fontMatrix[3] === 0) {
            warn("Invalid font matrix for font " + fontRefName);
        }
        if (size < 0) {
            size = -size;
            current.fontDirection = -1;
        }
        else {
            current.fontDirection = 1;
        }
        this.current.font = fontObj;
        this.current.fontSize = size;
        if (fontObj.isType3Font) {
            return;
        }
        var name = fontObj.loadedName || "sans-serif";
        var typeface = ((_j = fontObj.systemFontInfo) === null || _j === void 0 ? void 0 : _j.css) || "\"".concat(name, "\", ").concat(fontObj.fallbackName);
        var bold = "normal";
        if (fontObj.black) {
            bold = "900";
        }
        else if (fontObj.bold) {
            bold = "bold";
        }
        var italic = fontObj.italic ? "italic" : "normal";
        var browserFontSize = size;
        if (size < MIN_FONT_SIZE) {
            browserFontSize = MIN_FONT_SIZE;
        }
        else if (size > MAX_FONT_SIZE) {
            browserFontSize = MAX_FONT_SIZE;
        }
        this.current.fontSizeScale = size / browserFontSize;
        this.ctx.font = "".concat(italic, " ").concat(bold, " ").concat(browserFontSize, "px ").concat(typeface);
    };
    CanvasGraphics.prototype.setTextRenderingMode = function (mode) {
        this.current.textRenderingMode = mode;
    };
    CanvasGraphics.prototype.setTextRise = function (rise) {
        this.current.textRise = rise;
    };
    CanvasGraphics.prototype.moveText = function (x, y) {
        this.current.x = this.current.lineX += x;
        this.current.y = this.current.lineY += y;
    };
    CanvasGraphics.prototype.setLeadingMoveText = function (x, y) {
        this.setLeading(-y);
        this.moveText(x, y);
    };
    CanvasGraphics.prototype.setTextMatrix = function (matrix) {
        var current = this.current;
        current.textMatrix = matrix;
        current.textMatrixScale = Math.hypot(matrix[0], matrix[1]);
        current.x = current.lineX = 0;
        current.y = current.lineY = 0;
    };
    CanvasGraphics.prototype.nextLine = function () {
        this.moveText(0, this.current.leading);
    };
    CanvasGraphics.prototype.paintChar = function (character, x, y, patternFillTransform, patternStrokeTransform) {
        var ctx = this.ctx;
        var current = this.current;
        var font = current.font;
        var textRenderingMode = current.textRenderingMode;
        var fontSize = current.fontSize / current.fontSizeScale;
        var fillStrokeMode = textRenderingMode & TextRenderingMode.FILL_STROKE_MASK;
        var isAddToPathSet = !!(textRenderingMode & TextRenderingMode.ADD_TO_PATH_FLAG);
        var patternFill = current.patternFill && !font.missingFile;
        var patternStroke = current.patternStroke && !font.missingFile;
        var path;
        if (font.disableFontFace || isAddToPathSet || patternFill || patternStroke) {
            path = font.getPathGenerator(this.commonObjs, character);
        }
        if (font.disableFontFace || patternFill || patternStroke) {
            ctx.save();
            ctx.translate(x, y);
            ctx.scale(fontSize, -fontSize);
            var currentTransform = void 0;
            if (fillStrokeMode === TextRenderingMode.FILL || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
                if (patternFillTransform) {
                    currentTransform = ctx.getTransform();
                    ctx.setTransform.apply(ctx, __spreadArray([], __read(patternFillTransform), false));
                    ctx.fill(__classPrivateFieldGet(this, _CanvasGraphics_instances, "m", _CanvasGraphics_getScaledPath).call(this, path, currentTransform, patternFillTransform));
                }
                else {
                    ctx.fill(path);
                }
            }
            if (fillStrokeMode === TextRenderingMode.STROKE || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
                if (patternStrokeTransform) {
                    currentTransform || (currentTransform = ctx.getTransform());
                    ctx.setTransform.apply(ctx, __spreadArray([], __read(patternStrokeTransform), false));
                    var a = currentTransform.a, b = currentTransform.b, c = currentTransform.c, d = currentTransform.d;
                    var invPatternTransform = Util.inverseTransform(patternStrokeTransform);
                    var transf = Util.transform([a, b, c, d, 0, 0], invPatternTransform);
                    Util.singularValueDecompose2dScale(transf, XY);
                    ctx.lineWidth *= Math.max(XY[0], XY[1]) / fontSize;
                    ctx.stroke(__classPrivateFieldGet(this, _CanvasGraphics_instances, "m", _CanvasGraphics_getScaledPath).call(this, path, currentTransform, patternStrokeTransform));
                }
                else {
                    ctx.lineWidth /= fontSize;
                    ctx.stroke(path);
                }
            }
            ctx.restore();
        }
        else {
            if (fillStrokeMode === TextRenderingMode.FILL || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
                ctx.fillText(character, x, y);
            }
            if (fillStrokeMode === TextRenderingMode.STROKE || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
                ctx.strokeText(character, x, y);
            }
        }
        if (isAddToPathSet) {
            var paths = this.pendingTextPaths || (this.pendingTextPaths = []);
            paths.push({
                transform: getCurrentTransform(ctx),
                x: x,
                y: y,
                fontSize: fontSize,
                path: path
            });
        }
    };
    Object.defineProperty(CanvasGraphics.prototype, "isFontSubpixelAAEnabled", {
        get: function () {
            var ctx = this.cachedCanvases.getCanvas("isFontSubpixelAAEnabled", 10, 10).context;
            ctx.scale(1.5, 1);
            ctx.fillText("I", 0, 10);
            var data = ctx.getImageData(0, 0, 10, 10).data;
            var enabled = false;
            for (var i = 3; i < data.length; i += 4) {
                if (data[i] > 0 && data[i] < 255) {
                    enabled = true;
                    break;
                }
            }
            return shadow(this, "isFontSubpixelAAEnabled", enabled);
        },
        enumerable: false,
        configurable: true
    });
    CanvasGraphics.prototype.showText = function (glyphs) {
        var e_80, _j;
        var current = this.current;
        var font = current.font;
        if (font.isType3Font) {
            return this.showType3Text(glyphs);
        }
        var fontSize = current.fontSize;
        if (fontSize === 0) {
            return undefined;
        }
        var ctx = this.ctx;
        var fontSizeScale = current.fontSizeScale;
        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var fontDirection = current.fontDirection;
        var textHScale = current.textHScale * fontDirection;
        var glyphsLength = glyphs.length;
        var vertical = font.vertical;
        var spacingDir = vertical ? 1 : -1;
        var defaultVMetrics = font.defaultVMetrics;
        var widthAdvanceScale = fontSize * current.fontMatrix[0];
        var simpleFillText = current.textRenderingMode === TextRenderingMode.FILL && !font.disableFontFace && !current.patternFill;
        ctx.save();
        if (current.textMatrix) {
            ctx.transform.apply(ctx, __spreadArray([], __read(current.textMatrix), false));
        }
        ctx.translate(current.x, current.y + current.textRise);
        if (fontDirection > 0) {
            ctx.scale(textHScale, -1);
        }
        else {
            ctx.scale(textHScale, 1);
        }
        var patternFillTransform, patternStrokeTransform;
        if (current.patternFill) {
            ctx.save();
            var pattern = current.fillColor.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.FILL);
            patternFillTransform = getCurrentTransform(ctx);
            ctx.restore();
            ctx.fillStyle = pattern;
        }
        if (current.patternStroke) {
            ctx.save();
            var pattern = current.strokeColor.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.STROKE);
            patternStrokeTransform = getCurrentTransform(ctx);
            ctx.restore();
            ctx.strokeStyle = pattern;
        }
        var lineWidth = current.lineWidth;
        var scale = current.textMatrixScale;
        if (scale === 0 || lineWidth === 0) {
            var fillStrokeMode = current.textRenderingMode & TextRenderingMode.FILL_STROKE_MASK;
            if (fillStrokeMode === TextRenderingMode.STROKE || fillStrokeMode === TextRenderingMode.FILL_STROKE) {
                lineWidth = this.getSinglePixelWidth();
            }
        }
        else {
            lineWidth /= scale;
        }
        if (fontSizeScale !== 1.0) {
            ctx.scale(fontSizeScale, fontSizeScale);
            lineWidth /= fontSizeScale;
        }
        ctx.lineWidth = lineWidth;
        if (font.isInvalidPDFjsFont) {
            var chars = [];
            var width = 0;
            try {
                for (var glyphs_1 = __values(glyphs), glyphs_1_1 = glyphs_1.next(); !glyphs_1_1.done; glyphs_1_1 = glyphs_1.next()) {
                    var glyph = glyphs_1_1.value;
                    chars.push(glyph.unicode);
                    width += glyph.width;
                }
            }
            catch (e_80_1) { e_80 = { error: e_80_1 }; }
            finally {
                try {
                    if (glyphs_1_1 && !glyphs_1_1.done && (_j = glyphs_1.return)) _j.call(glyphs_1);
                }
                finally { if (e_80) throw e_80.error; }
            }
            ctx.fillText(chars.join(""), 0, 0);
            current.x += width * widthAdvanceScale * textHScale;
            ctx.restore();
            this.compose();
            return undefined;
        }
        var x = 0, i;
        for (i = 0; i < glyphsLength; ++i) {
            var glyph = glyphs[i];
            if (typeof glyph === "number") {
                x += spacingDir * glyph * fontSize / 1000;
                continue;
            }
            var restoreNeeded = false;
            var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            var character = glyph.fontChar;
            var accent = glyph.accent;
            var scaledX = void 0, scaledY = void 0;
            var width = glyph.width;
            if (vertical) {
                var vmetric = glyph.vmetric || defaultVMetrics;
                var vx = -(glyph.vmetric ? vmetric[1] : width * 0.5) * widthAdvanceScale;
                var vy = vmetric[2] * widthAdvanceScale;
                width = vmetric ? -vmetric[0] : width;
                scaledX = vx / fontSizeScale;
                scaledY = (x + vy) / fontSizeScale;
            }
            else {
                scaledX = x / fontSizeScale;
                scaledY = 0;
            }
            if (font.remeasure && width > 0) {
                var measuredWidth = ctx.measureText(character).width * 1000 / fontSize * fontSizeScale;
                if (width < measuredWidth && this.isFontSubpixelAAEnabled) {
                    var characterScaleX = width / measuredWidth;
                    restoreNeeded = true;
                    ctx.save();
                    ctx.scale(characterScaleX, 1);
                    scaledX /= characterScaleX;
                }
                else if (width !== measuredWidth) {
                    scaledX += (width - measuredWidth) / 2000 * fontSize / fontSizeScale;
                }
            }
            if (this.contentVisible && (glyph.isInFont || font.missingFile)) {
                if (simpleFillText && !accent) {
                    ctx.fillText(character, scaledX, scaledY);
                }
                else {
                    this.paintChar(character, scaledX, scaledY, patternFillTransform, patternStrokeTransform);
                    if (accent) {
                        var scaledAccentX = scaledX + fontSize * accent.offset.x / fontSizeScale;
                        var scaledAccentY = scaledY - fontSize * accent.offset.y / fontSizeScale;
                        this.paintChar(accent.fontChar, scaledAccentX, scaledAccentY, patternFillTransform, patternStrokeTransform);
                    }
                }
            }
            var charWidth = vertical ? width * widthAdvanceScale - spacing * fontDirection : width * widthAdvanceScale + spacing * fontDirection;
            x += charWidth;
            if (restoreNeeded) {
                ctx.restore();
            }
        }
        if (vertical) {
            current.y -= x;
        }
        else {
            current.x += x * textHScale;
        }
        ctx.restore();
        this.compose();
        return undefined;
    };
    CanvasGraphics.prototype.showType3Text = function (glyphs) {
        var ctx = this.ctx;
        var current = this.current;
        var font = current.font;
        var fontSize = current.fontSize;
        var fontDirection = current.fontDirection;
        var spacingDir = font.vertical ? 1 : -1;
        var charSpacing = current.charSpacing;
        var wordSpacing = current.wordSpacing;
        var textHScale = current.textHScale * fontDirection;
        var fontMatrix = current.fontMatrix || FONT_IDENTITY_MATRIX;
        var glyphsLength = glyphs.length;
        var isTextInvisible = current.textRenderingMode === TextRenderingMode.INVISIBLE;
        var i, glyph, width, spacingLength;
        if (isTextInvisible || fontSize === 0) {
            return;
        }
        this._cachedScaleForStroking[0] = -1;
        this._cachedGetSinglePixelWidth = null;
        ctx.save();
        if (current.textMatrix) {
            ctx.transform.apply(ctx, __spreadArray([], __read(current.textMatrix), false));
        }
        ctx.translate(current.x, current.y + current.textRise);
        ctx.scale(textHScale, fontDirection);
        for (i = 0; i < glyphsLength; ++i) {
            glyph = glyphs[i];
            if (typeof glyph === "number") {
                spacingLength = spacingDir * glyph * fontSize / 1000;
                this.ctx.translate(spacingLength, 0);
                current.x += spacingLength * textHScale;
                continue;
            }
            var spacing = (glyph.isSpace ? wordSpacing : 0) + charSpacing;
            var operatorList = font.charProcOperatorList[glyph.operatorListId];
            if (!operatorList) {
                warn("Type3 character \"".concat(glyph.operatorListId, "\" is not available."));
            }
            else if (this.contentVisible) {
                this.save();
                ctx.scale(fontSize, fontSize);
                ctx.transform.apply(ctx, __spreadArray([], __read(fontMatrix), false));
                this.executeOperatorList(operatorList);
                this.restore();
            }
            var p = [glyph.width, 0];
            Util.applyTransform(p, fontMatrix);
            width = p[0] * fontSize + spacing;
            ctx.translate(width, 0);
            current.x += width * textHScale;
        }
        ctx.restore();
    };
    CanvasGraphics.prototype.setCharWidth = function (xWidth, yWidth) { };
    CanvasGraphics.prototype.setCharWidthAndBounds = function (xWidth, yWidth, llx, lly, urx, ury) {
        var clip = new Path2D();
        clip.rect(llx, lly, urx - llx, ury - lly);
        this.ctx.clip(clip);
        this.endPath();
    };
    CanvasGraphics.prototype.getColorN_Pattern = function (IR) {
        var _this = this;
        var pattern;
        if (IR[0] === "TilingPattern") {
            var baseTransform = this.baseTransform || getCurrentTransform(this.ctx);
            var canvasGraphicsFactory = {
                createCanvasGraphics: function (ctx) { return new CanvasGraphics(ctx, _this.commonObjs, _this.objs, _this.canvasFactory, _this.filterFactory, {
                    optionalContentConfig: _this.optionalContentConfig,
                    markedContentStack: _this.markedContentStack
                }); }
            };
            pattern = new TilingPattern(IR, this.ctx, canvasGraphicsFactory, baseTransform);
        }
        else {
            pattern = this._getPattern(IR[1], IR[2]);
        }
        return pattern;
    };
    CanvasGraphics.prototype.setStrokeColorN = function () {
        this.current.strokeColor = this.getColorN_Pattern(arguments);
        this.current.patternStroke = true;
    };
    CanvasGraphics.prototype.setFillColorN = function () {
        this.current.fillColor = this.getColorN_Pattern(arguments);
        this.current.patternFill = true;
    };
    CanvasGraphics.prototype.setStrokeRGBColor = function (r, g, b) {
        this.ctx.strokeStyle = this.current.strokeColor = Util.makeHexColor(r, g, b);
        this.current.patternStroke = false;
    };
    CanvasGraphics.prototype.setStrokeTransparent = function () {
        this.ctx.strokeStyle = this.current.strokeColor = "transparent";
        this.current.patternStroke = false;
    };
    CanvasGraphics.prototype.setFillRGBColor = function (r, g, b) {
        this.ctx.fillStyle = this.current.fillColor = Util.makeHexColor(r, g, b);
        this.current.patternFill = false;
    };
    CanvasGraphics.prototype.setFillTransparent = function () {
        this.ctx.fillStyle = this.current.fillColor = "transparent";
        this.current.patternFill = false;
    };
    CanvasGraphics.prototype._getPattern = function (objId, matrix) {
        if (matrix === void 0) { matrix = null; }
        var pattern;
        if (this.cachedPatterns.has(objId)) {
            pattern = this.cachedPatterns.get(objId);
        }
        else {
            pattern = getShadingPattern(this.getObject(objId));
            this.cachedPatterns.set(objId, pattern);
        }
        if (matrix) {
            pattern.matrix = matrix;
        }
        return pattern;
    };
    CanvasGraphics.prototype.shadingFill = function (objId) {
        if (!this.contentVisible) {
            return;
        }
        var ctx = this.ctx;
        this.save();
        var pattern = this._getPattern(objId);
        ctx.fillStyle = pattern.getPattern(ctx, this, getCurrentTransformInverse(ctx), PathType.SHADING);
        var inv = getCurrentTransformInverse(ctx);
        if (inv) {
            var _j = ctx.canvas, width = _j.width, height = _j.height;
            var minMax = MIN_MAX_INIT.slice();
            Util.axialAlignedBoundingBox([0, 0, width, height], inv, minMax);
            var _k = __read(minMax, 4), x0 = _k[0], y0 = _k[1], x1 = _k[2], y1 = _k[3];
            this.ctx.fillRect(x0, y0, x1 - x0, y1 - y0);
        }
        else {
            this.ctx.fillRect(-1e10, -1e10, 2e10, 2e10);
        }
        this.compose(this.current.getClippedPathBoundingBox());
        this.restore();
    };
    CanvasGraphics.prototype.beginInlineImage = function () {
        unreachable("Should not call beginInlineImage");
    };
    CanvasGraphics.prototype.beginImageData = function () {
        unreachable("Should not call beginImageData");
    };
    CanvasGraphics.prototype.paintFormXObjectBegin = function (matrix, bbox) {
        if (!this.contentVisible) {
            return;
        }
        this.save();
        this.baseTransformStack.push(this.baseTransform);
        if (matrix) {
            this.transform.apply(this, __spreadArray([], __read(matrix), false));
        }
        this.baseTransform = getCurrentTransform(this.ctx);
        if (bbox) {
            Util.axialAlignedBoundingBox(bbox, this.baseTransform, this.current.minMax);
            var _j = __read(bbox, 4), x0 = _j[0], y0 = _j[1], x1 = _j[2], y1 = _j[3];
            var clip = new Path2D();
            clip.rect(x0, y0, x1 - x0, y1 - y0);
            this.ctx.clip(clip);
            this.endPath();
        }
    };
    CanvasGraphics.prototype.paintFormXObjectEnd = function () {
        if (!this.contentVisible) {
            return;
        }
        this.restore();
        this.baseTransform = this.baseTransformStack.pop();
    };
    CanvasGraphics.prototype.beginGroup = function (group) {
        if (!this.contentVisible) {
            return;
        }
        this.save();
        if (this.inSMaskMode) {
            this.endSMaskMode();
            this.current.activeSMask = null;
        }
        var currentCtx = this.ctx;
        if (!group.isolated) {
            info("TODO: Support non-isolated groups.");
        }
        if (group.knockout) {
            warn("Knockout groups not supported.");
        }
        var currentTransform = getCurrentTransform(currentCtx);
        if (group.matrix) {
            currentCtx.transform.apply(currentCtx, __spreadArray([], __read(group.matrix), false));
        }
        if (!group.bbox) {
            throw new Error("Bounding box is required.");
        }
        var bounds = MIN_MAX_INIT.slice();
        Util.axialAlignedBoundingBox(group.bbox, getCurrentTransform(currentCtx), bounds);
        var canvasBounds = [0, 0, currentCtx.canvas.width, currentCtx.canvas.height];
        bounds = Util.intersect(bounds, canvasBounds) || [0, 0, 0, 0];
        var offsetX = Math.floor(bounds[0]);
        var offsetY = Math.floor(bounds[1]);
        var drawnWidth = Math.max(Math.ceil(bounds[2]) - offsetX, 1);
        var drawnHeight = Math.max(Math.ceil(bounds[3]) - offsetY, 1);
        this.current.startNewPathAndClipBox([0, 0, drawnWidth, drawnHeight]);
        var cacheId = "groupAt" + this.groupLevel;
        if (group.smask) {
            cacheId += "_smask_" + this.smaskCounter++ % 2;
        }
        var scratchCanvas = this.cachedCanvases.getCanvas(cacheId, drawnWidth, drawnHeight);
        var groupCtx = scratchCanvas.context;
        groupCtx.translate(-offsetX, -offsetY);
        groupCtx.transform.apply(groupCtx, __spreadArray([], __read(currentTransform), false));
        var clip = new Path2D();
        var _j = __read(group.bbox, 4), x0 = _j[0], y0 = _j[1], x1 = _j[2], y1 = _j[3];
        clip.rect(x0, y0, x1 - x0, y1 - y0);
        if (group.matrix) {
            var path = new Path2D();
            path.addPath(clip, new DOMMatrix(group.matrix));
            clip = path;
        }
        groupCtx.clip(clip);
        if (group.smask) {
            this.smaskStack.push({
                canvas: scratchCanvas.canvas,
                context: groupCtx,
                offsetX: offsetX,
                offsetY: offsetY,
                subtype: group.smask.subtype,
                backdrop: group.smask.backdrop,
                transferMap: group.smask.transferMap || null,
                startTransformInverse: null
            });
        }
        else {
            currentCtx.setTransform(1, 0, 0, 1, 0, 0);
            currentCtx.translate(offsetX, offsetY);
            currentCtx.save();
        }
        copyCtxState(currentCtx, groupCtx);
        this.ctx = groupCtx;
        this.setGState([["BM", "source-over"], ["ca", 1], ["CA", 1]]);
        this.groupStack.push(currentCtx);
        this.groupLevel++;
    };
    CanvasGraphics.prototype.endGroup = function (group) {
        var _j;
        if (!this.contentVisible) {
            return;
        }
        this.groupLevel--;
        var groupCtx = this.ctx;
        var ctx = this.groupStack.pop();
        this.ctx = ctx;
        this.ctx.imageSmoothingEnabled = false;
        if (group.smask) {
            this.tempSMask = this.smaskStack.pop();
            this.restore();
        }
        else {
            this.ctx.restore();
            var currentMtx = getCurrentTransform(this.ctx);
            this.restore();
            this.ctx.save();
            (_j = this.ctx).setTransform.apply(_j, __spreadArray([], __read(currentMtx), false));
            var dirtyBox = MIN_MAX_INIT.slice();
            Util.axialAlignedBoundingBox([0, 0, groupCtx.canvas.width, groupCtx.canvas.height], currentMtx, dirtyBox);
            this.ctx.drawImage(groupCtx.canvas, 0, 0);
            this.ctx.restore();
            this.compose(dirtyBox);
        }
    };
    CanvasGraphics.prototype.beginAnnotation = function (id, rect, transform, matrix, hasOwnCanvas) {
        var _j;
        __classPrivateFieldGet(this, _CanvasGraphics_instances, "m", _CanvasGraphics_restoreInitialState).call(this);
        resetCtxToDefault(this.ctx);
        this.ctx.save();
        this.save();
        if (this.baseTransform) {
            (_j = this.ctx).setTransform.apply(_j, __spreadArray([], __read(this.baseTransform), false));
        }
        if (rect) {
            var width = rect[2] - rect[0];
            var height = rect[3] - rect[1];
            if (hasOwnCanvas && this.annotationCanvasMap) {
                transform = transform.slice();
                transform[4] -= rect[0];
                transform[5] -= rect[1];
                rect = rect.slice();
                rect[0] = rect[1] = 0;
                rect[2] = width;
                rect[3] = height;
                Util.singularValueDecompose2dScale(getCurrentTransform(this.ctx), XY);
                var viewportScale = this.viewportScale;
                var canvasWidth = Math.ceil(width * this.outputScaleX * viewportScale);
                var canvasHeight = Math.ceil(height * this.outputScaleY * viewportScale);
                this.annotationCanvas = this.canvasFactory.create(canvasWidth, canvasHeight);
                var _k = this.annotationCanvas, canvas = _k.canvas, context = _k.context;
                this.annotationCanvasMap.set(id, canvas);
                this.annotationCanvas.savedCtx = this.ctx;
                this.ctx = context;
                this.ctx.save();
                this.ctx.setTransform(XY[0], 0, 0, -XY[1], 0, height * XY[1]);
                resetCtxToDefault(this.ctx);
            }
            else {
                resetCtxToDefault(this.ctx);
                this.endPath();
                var clip = new Path2D();
                clip.rect(rect[0], rect[1], width, height);
                this.ctx.clip(clip);
            }
        }
        this.current = new CanvasExtraState(this.ctx.canvas.width, this.ctx.canvas.height);
        this.transform.apply(this, __spreadArray([], __read(transform), false));
        this.transform.apply(this, __spreadArray([], __read(matrix), false));
    };
    CanvasGraphics.prototype.endAnnotation = function () {
        if (this.annotationCanvas) {
            this.ctx.restore();
            __classPrivateFieldGet(this, _CanvasGraphics_instances, "m", _CanvasGraphics_drawFilter).call(this);
            this.ctx = this.annotationCanvas.savedCtx;
            delete this.annotationCanvas.savedCtx;
            delete this.annotationCanvas;
        }
    };
    CanvasGraphics.prototype.paintImageMaskXObject = function (img) {
        if (!this.contentVisible) {
            return;
        }
        var count = img.count;
        img = this.getObject(img.data, img);
        img.count = count;
        var ctx = this.ctx;
        var mask = this._createMaskCanvas(img);
        var maskCanvas = mask.canvas;
        ctx.save();
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        ctx.drawImage(maskCanvas, mask.offsetX, mask.offsetY);
        ctx.restore();
        this.compose();
    };
    CanvasGraphics.prototype.paintImageMaskXObjectRepeat = function (img, scaleX, skewX, skewY, scaleY, positions) {
        if (skewX === void 0) { skewX = 0; }
        if (skewY === void 0) { skewY = 0; }
        if (!this.contentVisible) {
            return;
        }
        img = this.getObject(img.data, img);
        var ctx = this.ctx;
        ctx.save();
        var currentTransform = getCurrentTransform(ctx);
        ctx.transform(scaleX, skewX, skewY, scaleY, 0, 0);
        var mask = this._createMaskCanvas(img);
        ctx.setTransform(1, 0, 0, 1, mask.offsetX - currentTransform[4], mask.offsetY - currentTransform[5]);
        for (var i = 0, ii = positions.length; i < ii; i += 2) {
            var trans = Util.transform(currentTransform, [scaleX, skewX, skewY, scaleY, positions[i], positions[i + 1]]);
            ctx.drawImage(mask.canvas, trans[4], trans[5]);
        }
        ctx.restore();
        this.compose();
    };
    CanvasGraphics.prototype.paintImageMaskXObjectGroup = function (images) {
        var e_81, _j;
        if (!this.contentVisible) {
            return;
        }
        var ctx = this.ctx;
        var fillColor = this.current.fillColor;
        var isPatternFill = this.current.patternFill;
        try {
            for (var images_1 = __values(images), images_1_1 = images_1.next(); !images_1_1.done; images_1_1 = images_1.next()) {
                var image = images_1_1.value;
                var data = image.data, width = image.width, height = image.height, transform = image.transform;
                var maskCanvas = this.cachedCanvases.getCanvas("maskCanvas", width, height);
                var maskCtx = maskCanvas.context;
                maskCtx.save();
                var img = this.getObject(data, image);
                putBinaryImageMask(maskCtx, img);
                maskCtx.globalCompositeOperation = "source-in";
                maskCtx.fillStyle = isPatternFill ? fillColor.getPattern(maskCtx, this, getCurrentTransformInverse(ctx), PathType.FILL) : fillColor;
                maskCtx.fillRect(0, 0, width, height);
                maskCtx.restore();
                ctx.save();
                ctx.transform.apply(ctx, __spreadArray([], __read(transform), false));
                ctx.scale(1, -1);
                drawImageAtIntegerCoords(ctx, maskCanvas.canvas, 0, 0, width, height, 0, -1, 1, 1);
                ctx.restore();
            }
        }
        catch (e_81_1) { e_81 = { error: e_81_1 }; }
        finally {
            try {
                if (images_1_1 && !images_1_1.done && (_j = images_1.return)) _j.call(images_1);
            }
            finally { if (e_81) throw e_81.error; }
        }
        this.compose();
    };
    CanvasGraphics.prototype.paintImageXObject = function (objId) {
        if (!this.contentVisible) {
            return;
        }
        var imgData = this.getObject(objId);
        if (!imgData) {
            warn("Dependent image isn't ready yet");
            return;
        }
        this.paintInlineImageXObject(imgData);
    };
    CanvasGraphics.prototype.paintImageXObjectRepeat = function (objId, scaleX, scaleY, positions) {
        if (!this.contentVisible) {
            return;
        }
        var imgData = this.getObject(objId);
        if (!imgData) {
            warn("Dependent image isn't ready yet");
            return;
        }
        var width = imgData.width;
        var height = imgData.height;
        var map = [];
        for (var i = 0, ii = positions.length; i < ii; i += 2) {
            map.push({
                transform: [scaleX, 0, 0, scaleY, positions[i], positions[i + 1]],
                x: 0,
                y: 0,
                w: width,
                h: height
            });
        }
        this.paintInlineImageXObjectGroup(imgData, map);
    };
    CanvasGraphics.prototype.applyTransferMapsToCanvas = function (ctx) {
        if (this.current.transferMaps !== "none") {
            ctx.filter = this.current.transferMaps;
            ctx.drawImage(ctx.canvas, 0, 0);
            ctx.filter = "none";
        }
        return ctx.canvas;
    };
    CanvasGraphics.prototype.applyTransferMapsToBitmap = function (imgData) {
        if (this.current.transferMaps === "none") {
            return imgData.bitmap;
        }
        var bitmap = imgData.bitmap, width = imgData.width, height = imgData.height;
        var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
        var tmpCtx = tmpCanvas.context;
        tmpCtx.filter = this.current.transferMaps;
        tmpCtx.drawImage(bitmap, 0, 0);
        tmpCtx.filter = "none";
        return tmpCanvas.canvas;
    };
    CanvasGraphics.prototype.paintInlineImageXObject = function (imgData) {
        if (!this.contentVisible) {
            return;
        }
        var width = imgData.width;
        var height = imgData.height;
        var ctx = this.ctx;
        this.save();
        var filter = ctx.filter;
        if (filter !== "none" && filter !== "") {
            ctx.filter = "none";
        }
        ctx.scale(1 / width, -1 / height);
        var imgToPaint;
        if (imgData.bitmap) {
            imgToPaint = this.applyTransferMapsToBitmap(imgData);
        }
        else if (typeof HTMLElement === "function" && imgData instanceof HTMLElement || !imgData.data) {
            imgToPaint = imgData;
        }
        else {
            var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", width, height);
            var tmpCtx = tmpCanvas.context;
            putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        var scaled = this._scaleImage(imgToPaint, getCurrentTransformInverse(ctx));
        ctx.imageSmoothingEnabled = getImageSmoothingEnabled(getCurrentTransform(ctx), imgData.interpolate);
        drawImageAtIntegerCoords(ctx, scaled.img, 0, 0, scaled.paintWidth, scaled.paintHeight, 0, -height, width, height);
        this.compose();
        this.restore();
    };
    CanvasGraphics.prototype.paintInlineImageXObjectGroup = function (imgData, map) {
        var e_82, _j;
        if (!this.contentVisible) {
            return;
        }
        var ctx = this.ctx;
        var imgToPaint;
        if (imgData.bitmap) {
            imgToPaint = imgData.bitmap;
        }
        else {
            var w = imgData.width;
            var h = imgData.height;
            var tmpCanvas = this.cachedCanvases.getCanvas("inlineImage", w, h);
            var tmpCtx = tmpCanvas.context;
            putBinaryImageData(tmpCtx, imgData);
            imgToPaint = this.applyTransferMapsToCanvas(tmpCtx);
        }
        try {
            for (var map_4 = __values(map), map_4_1 = map_4.next(); !map_4_1.done; map_4_1 = map_4.next()) {
                var entry = map_4_1.value;
                ctx.save();
                ctx.transform.apply(ctx, __spreadArray([], __read(entry.transform), false));
                ctx.scale(1, -1);
                drawImageAtIntegerCoords(ctx, imgToPaint, entry.x, entry.y, entry.w, entry.h, 0, -1, 1, 1);
                ctx.restore();
            }
        }
        catch (e_82_1) { e_82 = { error: e_82_1 }; }
        finally {
            try {
                if (map_4_1 && !map_4_1.done && (_j = map_4.return)) _j.call(map_4);
            }
            finally { if (e_82) throw e_82.error; }
        }
        this.compose();
    };
    CanvasGraphics.prototype.paintSolidColorImageMask = function () {
        if (!this.contentVisible) {
            return;
        }
        this.ctx.fillRect(0, 0, 1, 1);
        this.compose();
    };
    CanvasGraphics.prototype.markPoint = function (tag) { };
    CanvasGraphics.prototype.markPointProps = function (tag, properties) { };
    CanvasGraphics.prototype.beginMarkedContent = function (tag) {
        this.markedContentStack.push({
            visible: true
        });
    };
    CanvasGraphics.prototype.beginMarkedContentProps = function (tag, properties) {
        if (tag === "OC") {
            this.markedContentStack.push({
                visible: this.optionalContentConfig.isVisible(properties)
            });
        }
        else {
            this.markedContentStack.push({
                visible: true
            });
        }
        this.contentVisible = this.isContentVisible();
    };
    CanvasGraphics.prototype.endMarkedContent = function () {
        this.markedContentStack.pop();
        this.contentVisible = this.isContentVisible();
    };
    CanvasGraphics.prototype.beginCompat = function () { };
    CanvasGraphics.prototype.endCompat = function () { };
    CanvasGraphics.prototype.consumePath = function (path, clipBox) {
        var isEmpty = this.current.isEmptyClip();
        if (this.pendingClip) {
            this.current.updateClipFromPath();
        }
        if (!this.pendingClip) {
            this.compose(clipBox);
        }
        var ctx = this.ctx;
        if (this.pendingClip) {
            if (!isEmpty) {
                if (this.pendingClip === EO_CLIP) {
                    ctx.clip(path, "evenodd");
                }
                else {
                    ctx.clip(path);
                }
            }
            this.pendingClip = null;
        }
        this.current.startNewPathAndClipBox(this.current.clipBox);
    };
    CanvasGraphics.prototype.getSinglePixelWidth = function () {
        if (!this._cachedGetSinglePixelWidth) {
            var m = getCurrentTransform(this.ctx);
            if (m[1] === 0 && m[2] === 0) {
                this._cachedGetSinglePixelWidth = 1 / Math.min(Math.abs(m[0]), Math.abs(m[3]));
            }
            else {
                var absDet = Math.abs(m[0] * m[3] - m[2] * m[1]);
                var normX = Math.hypot(m[0], m[2]);
                var normY = Math.hypot(m[1], m[3]);
                this._cachedGetSinglePixelWidth = Math.max(normX, normY) / absDet;
            }
        }
        return this._cachedGetSinglePixelWidth;
    };
    CanvasGraphics.prototype.getScaleForStroking = function () {
        if (this._cachedScaleForStroking[0] === -1) {
            var lineWidth = this.current.lineWidth;
            var _j = this.ctx.getTransform(), a = _j.a, b = _j.b, c = _j.c, d = _j.d;
            var scaleX = void 0, scaleY = void 0;
            if (b === 0 && c === 0) {
                var normX = Math.abs(a);
                var normY = Math.abs(d);
                if (normX === normY) {
                    if (lineWidth === 0) {
                        scaleX = scaleY = 1 / normX;
                    }
                    else {
                        var scaledLineWidth = normX * lineWidth;
                        scaleX = scaleY = scaledLineWidth < 1 ? 1 / scaledLineWidth : 1;
                    }
                }
                else if (lineWidth === 0) {
                    scaleX = 1 / normX;
                    scaleY = 1 / normY;
                }
                else {
                    var scaledXLineWidth = normX * lineWidth;
                    var scaledYLineWidth = normY * lineWidth;
                    scaleX = scaledXLineWidth < 1 ? 1 / scaledXLineWidth : 1;
                    scaleY = scaledYLineWidth < 1 ? 1 / scaledYLineWidth : 1;
                }
            }
            else {
                var absDet = Math.abs(a * d - b * c);
                var normX = Math.hypot(a, b);
                var normY = Math.hypot(c, d);
                if (lineWidth === 0) {
                    scaleX = normY / absDet;
                    scaleY = normX / absDet;
                }
                else {
                    var baseArea = lineWidth * absDet;
                    scaleX = normY > baseArea ? normY / baseArea : 1;
                    scaleY = normX > baseArea ? normX / baseArea : 1;
                }
            }
            this._cachedScaleForStroking[0] = scaleX;
            this._cachedScaleForStroking[1] = scaleY;
        }
        return this._cachedScaleForStroking;
    };
    CanvasGraphics.prototype.rescaleAndStroke = function (path, saveRestore) {
        var _j = this, ctx = _j.ctx, lineWidth = _j.current.lineWidth;
        var _k = __read(this.getScaleForStroking(), 2), scaleX = _k[0], scaleY = _k[1];
        if (scaleX === scaleY) {
            ctx.lineWidth = (lineWidth || 1) * scaleX;
            ctx.stroke(path);
            return;
        }
        var dashes = ctx.getLineDash();
        if (saveRestore) {
            ctx.save();
        }
        ctx.scale(scaleX, scaleY);
        SCALE_MATRIX.a = 1 / scaleX;
        SCALE_MATRIX.d = 1 / scaleY;
        var newPath = new Path2D();
        newPath.addPath(path, SCALE_MATRIX);
        if (dashes.length > 0) {
            var scale_1 = Math.max(scaleX, scaleY);
            ctx.setLineDash(dashes.map(function (x) { return x / scale_1; }));
            ctx.lineDashOffset /= scale_1;
        }
        ctx.lineWidth = lineWidth || 1;
        ctx.stroke(newPath);
        if (saveRestore) {
            ctx.restore();
        }
    };
    CanvasGraphics.prototype.isContentVisible = function () {
        for (var i = this.markedContentStack.length - 1; i >= 0; i--) {
            if (!this.markedContentStack[i].visible) {
                return false;
            }
        }
        return true;
    };
    return CanvasGraphics;
}());
_CanvasGraphics_instances = new WeakSet(), _CanvasGraphics_restoreInitialState = function _CanvasGraphics_restoreInitialState() {
    while (this.stateStack.length || this.inSMaskMode) {
        this.restore();
    }
    this.current.activeSMask = null;
    this.ctx.restore();
    if (this.transparentCanvas) {
        this.ctx = this.compositeCtx;
        this.ctx.save();
        this.ctx.setTransform(1, 0, 0, 1, 0, 0);
        this.ctx.drawImage(this.transparentCanvas, 0, 0);
        this.ctx.restore();
        this.transparentCanvas = null;
    }
}, _CanvasGraphics_drawFilter = function _CanvasGraphics_drawFilter() {
    if (this.pageColors) {
        var hcmFilterId = this.filterFactory.addHCMFilter(this.pageColors.foreground, this.pageColors.background);
        if (hcmFilterId !== "none") {
            var savedFilter = this.ctx.filter;
            this.ctx.filter = hcmFilterId;
            this.ctx.drawImage(this.ctx.canvas, 0, 0);
            this.ctx.filter = savedFilter;
        }
    }
}, _CanvasGraphics_getScaledPath = function _CanvasGraphics_getScaledPath(path, currentTransform, transform) {
    var newPath = new Path2D();
    newPath.addPath(path, new DOMMatrix(transform).invertSelf().multiplySelf(currentTransform));
    return newPath;
};
for (var op in OPS) {
    if (CanvasGraphics.prototype[op] !== undefined) {
        CanvasGraphics.prototype[OPS[op]] = CanvasGraphics.prototype[op];
    }
}
; // ./src/display/worker_options.js
var GlobalWorkerOptions = /** @class */ (function () {
    function GlobalWorkerOptions() {
    }
    Object.defineProperty(GlobalWorkerOptions, "workerPort", {
        get: function () {
            return __classPrivateFieldGet(this, _j, "f", _GlobalWorkerOptions_port);
        },
        set: function (val) {
            if (!(typeof Worker !== "undefined" && val instanceof Worker) && val !== null) {
                throw new Error("Invalid `workerPort` type.");
            }
            __classPrivateFieldSet(this, _j, val, "f", _GlobalWorkerOptions_port);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(GlobalWorkerOptions, "workerSrc", {
        get: function () {
            return __classPrivateFieldGet(this, _j, "f", _GlobalWorkerOptions_src);
        },
        set: function (val) {
            if (typeof val !== "string") {
                throw new Error("Invalid `workerSrc` type.");
            }
            __classPrivateFieldSet(this, _j, val, "f", _GlobalWorkerOptions_src);
        },
        enumerable: false,
        configurable: true
    });
    var _j, _GlobalWorkerOptions_port, _GlobalWorkerOptions_src;
    _j = GlobalWorkerOptions;
    _GlobalWorkerOptions_port = { value: null };
    _GlobalWorkerOptions_src = { value: "" };
    return GlobalWorkerOptions;
}());
; // ./src/display/metadata.js
var Metadata = /** @class */ (function () {
    function Metadata(_k) {
        var parsedData = _k.parsedData, rawData = _k.rawData;
        _Metadata_map.set(this, void 0);
        _Metadata_data.set(this, void 0);
        __classPrivateFieldSet(this, _Metadata_map, parsedData, "f");
        __classPrivateFieldSet(this, _Metadata_data, rawData, "f");
    }
    Metadata.prototype.getRaw = function () {
        return __classPrivateFieldGet(this, _Metadata_data, "f");
    };
    Metadata.prototype.get = function (name) {
        var _k;
        return (_k = __classPrivateFieldGet(this, _Metadata_map, "f").get(name)) !== null && _k !== void 0 ? _k : null;
    };
    Metadata.prototype[(_Metadata_map = new WeakMap(), _Metadata_data = new WeakMap(), Symbol.iterator)] = function () {
        return __classPrivateFieldGet(this, _Metadata_map, "f").entries();
    };
    return Metadata;
}());
; // ./src/display/optional_content_config.js
var INTERNAL = Symbol("INTERNAL");
var OptionalContentGroup = /** @class */ (function () {
    function OptionalContentGroup(renderingIntent, _k) {
        var name = _k.name, intent = _k.intent, usage = _k.usage, rbGroups = _k.rbGroups;
        _OptionalContentGroup_isDisplay.set(this, false);
        _OptionalContentGroup_isPrint.set(this, false);
        _OptionalContentGroup_userSet.set(this, false);
        _OptionalContentGroup_visible.set(this, true);
        __classPrivateFieldSet(this, _OptionalContentGroup_isDisplay, !!(renderingIntent & RenderingIntentFlag.DISPLAY), "f");
        __classPrivateFieldSet(this, _OptionalContentGroup_isPrint, !!(renderingIntent & RenderingIntentFlag.PRINT), "f");
        this.name = name;
        this.intent = intent;
        this.usage = usage;
        this.rbGroups = rbGroups;
    }
    Object.defineProperty(OptionalContentGroup.prototype, "visible", {
        get: function () {
            if (__classPrivateFieldGet(this, _OptionalContentGroup_userSet, "f")) {
                return __classPrivateFieldGet(this, _OptionalContentGroup_visible, "f");
            }
            if (!__classPrivateFieldGet(this, _OptionalContentGroup_visible, "f")) {
                return false;
            }
            var _k = this.usage, print = _k.print, view = _k.view;
            if (__classPrivateFieldGet(this, _OptionalContentGroup_isDisplay, "f")) {
                return (view === null || view === void 0 ? void 0 : view.viewState) !== "OFF";
            }
            else if (__classPrivateFieldGet(this, _OptionalContentGroup_isPrint, "f")) {
                return (print === null || print === void 0 ? void 0 : print.printState) !== "OFF";
            }
            return true;
        },
        enumerable: false,
        configurable: true
    });
    OptionalContentGroup.prototype._setVisible = function (internal, visible, userSet) {
        if (userSet === void 0) { userSet = false; }
        if (internal !== INTERNAL) {
            unreachable("Internal method `_setVisible` called.");
        }
        __classPrivateFieldSet(this, _OptionalContentGroup_userSet, userSet, "f");
        __classPrivateFieldSet(this, _OptionalContentGroup_visible, visible, "f");
    };
    return OptionalContentGroup;
}());
_OptionalContentGroup_isDisplay = new WeakMap(), _OptionalContentGroup_isPrint = new WeakMap(), _OptionalContentGroup_userSet = new WeakMap(), _OptionalContentGroup_visible = new WeakMap();
var OptionalContentConfig = /** @class */ (function () {
    function OptionalContentConfig(data, renderingIntent) {
        var e_83, _k, e_84, _l, e_85, _m, e_86, _o;
        if (renderingIntent === void 0) { renderingIntent = RenderingIntentFlag.DISPLAY; }
        _OptionalContentConfig_instances.add(this);
        _OptionalContentConfig_cachedGetHash.set(this, null);
        _OptionalContentConfig_groups.set(this, new Map());
        _OptionalContentConfig_initialHash.set(this, null);
        _OptionalContentConfig_order.set(this, null);
        this.renderingIntent = renderingIntent;
        this.name = null;
        this.creator = null;
        if (data === null) {
            return;
        }
        this.name = data.name;
        this.creator = data.creator;
        __classPrivateFieldSet(this, _OptionalContentConfig_order, data.order, "f");
        try {
            for (var _p = __values(data.groups), _q = _p.next(); !_q.done; _q = _p.next()) {
                var group = _q.value;
                __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").set(group.id, new OptionalContentGroup(renderingIntent, group));
            }
        }
        catch (e_83_1) { e_83 = { error: e_83_1 }; }
        finally {
            try {
                if (_q && !_q.done && (_k = _p.return)) _k.call(_p);
            }
            finally { if (e_83) throw e_83.error; }
        }
        if (data.baseState === "OFF") {
            try {
                for (var _r = __values(__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").values()), _s = _r.next(); !_s.done; _s = _r.next()) {
                    var group = _s.value;
                    group._setVisible(INTERNAL, false);
                }
            }
            catch (e_84_1) { e_84 = { error: e_84_1 }; }
            finally {
                try {
                    if (_s && !_s.done && (_l = _r.return)) _l.call(_r);
                }
                finally { if (e_84) throw e_84.error; }
            }
        }
        try {
            for (var _t = __values(data.on), _u = _t.next(); !_u.done; _u = _t.next()) {
                var on = _u.value;
                __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(on)._setVisible(INTERNAL, true);
            }
        }
        catch (e_85_1) { e_85 = { error: e_85_1 }; }
        finally {
            try {
                if (_u && !_u.done && (_m = _t.return)) _m.call(_t);
            }
            finally { if (e_85) throw e_85.error; }
        }
        try {
            for (var _v = __values(data.off), _w = _v.next(); !_w.done; _w = _v.next()) {
                var off = _w.value;
                __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(off)._setVisible(INTERNAL, false);
            }
        }
        catch (e_86_1) { e_86 = { error: e_86_1 }; }
        finally {
            try {
                if (_w && !_w.done && (_o = _v.return)) _o.call(_v);
            }
            finally { if (e_86) throw e_86.error; }
        }
        __classPrivateFieldSet(this, _OptionalContentConfig_initialHash, this.getHash(), "f");
    }
    OptionalContentConfig.prototype.isVisible = function (group) {
        var e_87, _k, e_88, _l, e_89, _m, e_90, _o;
        if (__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").size === 0) {
            return true;
        }
        if (!group) {
            info("Optional content group not defined.");
            return true;
        }
        if (group.type === "OCG") {
            if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").has(group.id)) {
                warn("Optional content group not found: ".concat(group.id));
                return true;
            }
            return __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(group.id).visible;
        }
        else if (group.type === "OCMD") {
            if (group.expression) {
                return __classPrivateFieldGet(this, _OptionalContentConfig_instances, "m", _OptionalContentConfig_evaluateVisibilityExpression).call(this, group.expression);
            }
            if (!group.policy || group.policy === "AnyOn") {
                try {
                    for (var _p = __values(group.ids), _q = _p.next(); !_q.done; _q = _p.next()) {
                        var id = _q.value;
                        if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").has(id)) {
                            warn("Optional content group not found: ".concat(id));
                            return true;
                        }
                        if (__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(id).visible) {
                            return true;
                        }
                    }
                }
                catch (e_87_1) { e_87 = { error: e_87_1 }; }
                finally {
                    try {
                        if (_q && !_q.done && (_k = _p.return)) _k.call(_p);
                    }
                    finally { if (e_87) throw e_87.error; }
                }
                return false;
            }
            else if (group.policy === "AllOn") {
                try {
                    for (var _r = __values(group.ids), _s = _r.next(); !_s.done; _s = _r.next()) {
                        var id = _s.value;
                        if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").has(id)) {
                            warn("Optional content group not found: ".concat(id));
                            return true;
                        }
                        if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(id).visible) {
                            return false;
                        }
                    }
                }
                catch (e_88_1) { e_88 = { error: e_88_1 }; }
                finally {
                    try {
                        if (_s && !_s.done && (_l = _r.return)) _l.call(_r);
                    }
                    finally { if (e_88) throw e_88.error; }
                }
                return true;
            }
            else if (group.policy === "AnyOff") {
                try {
                    for (var _t = __values(group.ids), _u = _t.next(); !_u.done; _u = _t.next()) {
                        var id = _u.value;
                        if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").has(id)) {
                            warn("Optional content group not found: ".concat(id));
                            return true;
                        }
                        if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(id).visible) {
                            return true;
                        }
                    }
                }
                catch (e_89_1) { e_89 = { error: e_89_1 }; }
                finally {
                    try {
                        if (_u && !_u.done && (_m = _t.return)) _m.call(_t);
                    }
                    finally { if (e_89) throw e_89.error; }
                }
                return false;
            }
            else if (group.policy === "AllOff") {
                try {
                    for (var _v = __values(group.ids), _w = _v.next(); !_w.done; _w = _v.next()) {
                        var id = _w.value;
                        if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").has(id)) {
                            warn("Optional content group not found: ".concat(id));
                            return true;
                        }
                        if (__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(id).visible) {
                            return false;
                        }
                    }
                }
                catch (e_90_1) { e_90 = { error: e_90_1 }; }
                finally {
                    try {
                        if (_w && !_w.done && (_o = _v.return)) _o.call(_v);
                    }
                    finally { if (e_90) throw e_90.error; }
                }
                return true;
            }
            warn("Unknown optional content policy ".concat(group.policy, "."));
            return true;
        }
        warn("Unknown group type ".concat(group.type, "."));
        return true;
    };
    OptionalContentConfig.prototype.setVisibility = function (id, visible, preserveRB) {
        var e_91, _k, e_92, _l;
        var _m;
        if (visible === void 0) { visible = true; }
        if (preserveRB === void 0) { preserveRB = true; }
        var group = __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(id);
        if (!group) {
            warn("Optional content group not found: ".concat(id));
            return;
        }
        if (preserveRB && visible && group.rbGroups.length) {
            try {
                for (var _o = __values(group.rbGroups), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var rbGroup = _p.value;
                    try {
                        for (var rbGroup_1 = (e_92 = void 0, __values(rbGroup)), rbGroup_1_1 = rbGroup_1.next(); !rbGroup_1_1.done; rbGroup_1_1 = rbGroup_1.next()) {
                            var otherId = rbGroup_1_1.value;
                            if (otherId !== id) {
                                (_m = __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(otherId)) === null || _m === void 0 ? void 0 : _m._setVisible(INTERNAL, false, true);
                            }
                        }
                    }
                    catch (e_92_1) { e_92 = { error: e_92_1 }; }
                    finally {
                        try {
                            if (rbGroup_1_1 && !rbGroup_1_1.done && (_l = rbGroup_1.return)) _l.call(rbGroup_1);
                        }
                        finally { if (e_92) throw e_92.error; }
                    }
                }
            }
            catch (e_91_1) { e_91 = { error: e_91_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_k = _o.return)) _k.call(_o);
                }
                finally { if (e_91) throw e_91.error; }
            }
        }
        group._setVisible(INTERNAL, !!visible, true);
        __classPrivateFieldSet(this, _OptionalContentConfig_cachedGetHash, null, "f");
    };
    OptionalContentConfig.prototype.setOCGState = function (_k) {
        var e_93, _l;
        var state = _k.state, preserveRB = _k.preserveRB;
        var operator;
        try {
            for (var state_1 = __values(state), state_1_1 = state_1.next(); !state_1_1.done; state_1_1 = state_1.next()) {
                var elem = state_1_1.value;
                switch (elem) {
                    case "ON":
                    case "OFF":
                    case "Toggle":
                        operator = elem;
                        continue;
                }
                var group = __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(elem);
                if (!group) {
                    continue;
                }
                switch (operator) {
                    case "ON":
                        this.setVisibility(elem, true, preserveRB);
                        break;
                    case "OFF":
                        this.setVisibility(elem, false, preserveRB);
                        break;
                    case "Toggle":
                        this.setVisibility(elem, !group.visible, preserveRB);
                        break;
                }
            }
        }
        catch (e_93_1) { e_93 = { error: e_93_1 }; }
        finally {
            try {
                if (state_1_1 && !state_1_1.done && (_l = state_1.return)) _l.call(state_1);
            }
            finally { if (e_93) throw e_93.error; }
        }
        __classPrivateFieldSet(this, _OptionalContentConfig_cachedGetHash, null, "f");
    };
    Object.defineProperty(OptionalContentConfig.prototype, "hasInitialVisibility", {
        get: function () {
            return __classPrivateFieldGet(this, _OptionalContentConfig_initialHash, "f") === null || this.getHash() === __classPrivateFieldGet(this, _OptionalContentConfig_initialHash, "f");
        },
        enumerable: false,
        configurable: true
    });
    OptionalContentConfig.prototype.getOrder = function () {
        if (!__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").size) {
            return null;
        }
        if (__classPrivateFieldGet(this, _OptionalContentConfig_order, "f")) {
            return __classPrivateFieldGet(this, _OptionalContentConfig_order, "f").slice();
        }
        return __spreadArray([], __read(__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").keys()), false);
    };
    OptionalContentConfig.prototype.getGroup = function (id) {
        return __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(id) || null;
    };
    OptionalContentConfig.prototype.getHash = function () {
        var e_94, _k;
        if (__classPrivateFieldGet(this, _OptionalContentConfig_cachedGetHash, "f") !== null) {
            return __classPrivateFieldGet(this, _OptionalContentConfig_cachedGetHash, "f");
        }
        var hash = new MurmurHash3_64();
        try {
            for (var _l = __values(__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f")), _m = _l.next(); !_m.done; _m = _l.next()) {
                var _o = __read(_m.value, 2), id = _o[0], group = _o[1];
                hash.update("".concat(id, ":").concat(group.visible));
            }
        }
        catch (e_94_1) { e_94 = { error: e_94_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_94) throw e_94.error; }
        }
        return __classPrivateFieldSet(this, _OptionalContentConfig_cachedGetHash, hash.hexdigest(), "f");
    };
    OptionalContentConfig.prototype[(_OptionalContentConfig_cachedGetHash = new WeakMap(), _OptionalContentConfig_groups = new WeakMap(), _OptionalContentConfig_initialHash = new WeakMap(), _OptionalContentConfig_order = new WeakMap(), _OptionalContentConfig_instances = new WeakSet(), _OptionalContentConfig_evaluateVisibilityExpression = function _OptionalContentConfig_evaluateVisibilityExpression(array) {
        var length = array.length;
        if (length < 2) {
            return true;
        }
        var operator = array[0];
        for (var i = 1; i < length; i++) {
            var element = array[i];
            var state = void 0;
            if (Array.isArray(element)) {
                state = __classPrivateFieldGet(this, _OptionalContentConfig_instances, "m", _OptionalContentConfig_evaluateVisibilityExpression).call(this, element);
            }
            else if (__classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").has(element)) {
                state = __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").get(element).visible;
            }
            else {
                warn("Optional content group not found: ".concat(element));
                return true;
            }
            switch (operator) {
                case "And":
                    if (!state) {
                        return false;
                    }
                    break;
                case "Or":
                    if (state) {
                        return true;
                    }
                    break;
                case "Not":
                    return !state;
                default:
                    return true;
            }
        }
        return operator === "And";
    }, Symbol.iterator)] = function () {
        return __classPrivateFieldGet(this, _OptionalContentConfig_groups, "f").entries();
    };
    return OptionalContentConfig;
}());
; // ./src/display/transport_stream.js
var PDFDataTransportStream = /** @class */ (function () {
    function PDFDataTransportStream(pdfDataRangeTransport, _k) {
        var _l = _k.disableRange, disableRange = _l === void 0 ? false : _l, _m = _k.disableStream, disableStream = _m === void 0 ? false : _m;
        var _this = this;
        assert(pdfDataRangeTransport, 'PDFDataTransportStream - missing required "pdfDataRangeTransport" argument.');
        var length = pdfDataRangeTransport.length, initialData = pdfDataRangeTransport.initialData, progressiveDone = pdfDataRangeTransport.progressiveDone, contentDispositionFilename = pdfDataRangeTransport.contentDispositionFilename;
        this._queuedChunks = [];
        this._progressiveDone = progressiveDone;
        this._contentDispositionFilename = contentDispositionFilename;
        if ((initialData === null || initialData === void 0 ? void 0 : initialData.length) > 0) {
            var buffer = initialData instanceof Uint8Array && initialData.byteLength === initialData.buffer.byteLength ? initialData.buffer : new Uint8Array(initialData).buffer;
            this._queuedChunks.push(buffer);
        }
        this._pdfDataRangeTransport = pdfDataRangeTransport;
        this._isStreamingSupported = !disableStream;
        this._isRangeSupported = !disableRange;
        this._contentLength = length;
        this._fullRequestReader = null;
        this._rangeReaders = [];
        pdfDataRangeTransport.addRangeListener(function (begin, chunk) {
            _this._onReceiveData({
                begin: begin,
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressListener(function (loaded, total) {
            _this._onProgress({
                loaded: loaded,
                total: total
            });
        });
        pdfDataRangeTransport.addProgressiveReadListener(function (chunk) {
            _this._onReceiveData({
                chunk: chunk
            });
        });
        pdfDataRangeTransport.addProgressiveDoneListener(function () {
            _this._onProgressiveDone();
        });
        pdfDataRangeTransport.transportReady();
    }
    PDFDataTransportStream.prototype._onReceiveData = function (_k) {
        var begin = _k.begin, chunk = _k.chunk;
        var buffer = chunk instanceof Uint8Array && chunk.byteLength === chunk.buffer.byteLength ? chunk.buffer : new Uint8Array(chunk).buffer;
        if (begin === undefined) {
            if (this._fullRequestReader) {
                this._fullRequestReader._enqueue(buffer);
            }
            else {
                this._queuedChunks.push(buffer);
            }
        }
        else {
            var found = this._rangeReaders.some(function (rangeReader) {
                if (rangeReader._begin !== begin) {
                    return false;
                }
                rangeReader._enqueue(buffer);
                return true;
            });
            assert(found, "_onReceiveData - no `PDFDataTransportStreamRangeReader` instance found.");
        }
    };
    Object.defineProperty(PDFDataTransportStream.prototype, "_progressiveDataLength", {
        get: function () {
            var _k, _l;
            return (_l = (_k = this._fullRequestReader) === null || _k === void 0 ? void 0 : _k._loaded) !== null && _l !== void 0 ? _l : 0;
        },
        enumerable: false,
        configurable: true
    });
    PDFDataTransportStream.prototype._onProgress = function (evt) {
        var _k, _l, _m, _o;
        if (evt.total === undefined) {
            (_l = (_k = this._rangeReaders[0]) === null || _k === void 0 ? void 0 : _k.onProgress) === null || _l === void 0 ? void 0 : _l.call(_k, {
                loaded: evt.loaded
            });
        }
        else {
            (_o = (_m = this._fullRequestReader) === null || _m === void 0 ? void 0 : _m.onProgress) === null || _o === void 0 ? void 0 : _o.call(_m, {
                loaded: evt.loaded,
                total: evt.total
            });
        }
    };
    PDFDataTransportStream.prototype._onProgressiveDone = function () {
        var _k;
        (_k = this._fullRequestReader) === null || _k === void 0 ? void 0 : _k.progressiveDone();
        this._progressiveDone = true;
    };
    PDFDataTransportStream.prototype._removeRangeReader = function (reader) {
        var i = this._rangeReaders.indexOf(reader);
        if (i >= 0) {
            this._rangeReaders.splice(i, 1);
        }
    };
    PDFDataTransportStream.prototype.getFullReader = function () {
        assert(!this._fullRequestReader, "PDFDataTransportStream.getFullReader can only be called once.");
        var queuedChunks = this._queuedChunks;
        this._queuedChunks = null;
        return new PDFDataTransportStreamReader(this, queuedChunks, this._progressiveDone, this._contentDispositionFilename);
    };
    PDFDataTransportStream.prototype.getRangeReader = function (begin, end) {
        if (end <= this._progressiveDataLength) {
            return null;
        }
        var reader = new PDFDataTransportStreamRangeReader(this, begin, end);
        this._pdfDataRangeTransport.requestDataRange(begin, end);
        this._rangeReaders.push(reader);
        return reader;
    };
    PDFDataTransportStream.prototype.cancelAllRequests = function (reason) {
        var e_95, _k;
        var _l;
        (_l = this._fullRequestReader) === null || _l === void 0 ? void 0 : _l.cancel(reason);
        try {
            for (var _m = __values(this._rangeReaders.slice(0)), _o = _m.next(); !_o.done; _o = _m.next()) {
                var reader = _o.value;
                reader.cancel(reason);
            }
        }
        catch (e_95_1) { e_95 = { error: e_95_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_k = _m.return)) _k.call(_m);
            }
            finally { if (e_95) throw e_95.error; }
        }
        this._pdfDataRangeTransport.abort();
    };
    return PDFDataTransportStream;
}());
var PDFDataTransportStreamReader = /** @class */ (function () {
    function PDFDataTransportStreamReader(stream, queuedChunks, progressiveDone, contentDispositionFilename) {
        var e_96, _k;
        if (progressiveDone === void 0) { progressiveDone = false; }
        if (contentDispositionFilename === void 0) { contentDispositionFilename = null; }
        this._stream = stream;
        this._done = progressiveDone || false;
        this._filename = isPdfFile(contentDispositionFilename) ? contentDispositionFilename : null;
        this._queuedChunks = queuedChunks || [];
        this._loaded = 0;
        try {
            for (var _l = __values(this._queuedChunks), _m = _l.next(); !_m.done; _m = _l.next()) {
                var chunk = _m.value;
                this._loaded += chunk.byteLength;
            }
        }
        catch (e_96_1) { e_96 = { error: e_96_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_96) throw e_96.error; }
        }
        this._requests = [];
        this._headersReady = Promise.resolve();
        stream._fullRequestReader = this;
        this.onProgress = null;
    }
    PDFDataTransportStreamReader.prototype._enqueue = function (chunk) {
        if (this._done) {
            return;
        }
        if (this._requests.length > 0) {
            var requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        }
        else {
            this._queuedChunks.push(chunk);
        }
        this._loaded += chunk.byteLength;
    };
    Object.defineProperty(PDFDataTransportStreamReader.prototype, "headersReady", {
        get: function () {
            return this._headersReady;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDataTransportStreamReader.prototype, "filename", {
        get: function () {
            return this._filename;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDataTransportStreamReader.prototype, "isRangeSupported", {
        get: function () {
            return this._stream._isRangeSupported;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDataTransportStreamReader.prototype, "isStreamingSupported", {
        get: function () {
            return this._stream._isStreamingSupported;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDataTransportStreamReader.prototype, "contentLength", {
        get: function () {
            return this._stream._contentLength;
        },
        enumerable: false,
        configurable: true
    });
    PDFDataTransportStreamReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk, requestCapability;
            return __generator(this, function (_k) {
                if (this._queuedChunks.length > 0) {
                    chunk = this._queuedChunks.shift();
                    return [2 /*return*/, {
                            value: chunk,
                            done: false
                        }];
                }
                if (this._done) {
                    return [2 /*return*/, {
                            value: undefined,
                            done: true
                        }];
                }
                requestCapability = Promise.withResolvers();
                this._requests.push(requestCapability);
                return [2 /*return*/, requestCapability.promise];
            });
        });
    };
    PDFDataTransportStreamReader.prototype.cancel = function (reason) {
        var e_97, _k;
        this._done = true;
        try {
            for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                var requestCapability = _m.value;
                requestCapability.resolve({
                    value: undefined,
                    done: true
                });
            }
        }
        catch (e_97_1) { e_97 = { error: e_97_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_97) throw e_97.error; }
        }
        this._requests.length = 0;
    };
    PDFDataTransportStreamReader.prototype.progressiveDone = function () {
        if (this._done) {
            return;
        }
        this._done = true;
    };
    return PDFDataTransportStreamReader;
}());
var PDFDataTransportStreamRangeReader = /** @class */ (function () {
    function PDFDataTransportStreamRangeReader(stream, begin, end) {
        this._stream = stream;
        this._begin = begin;
        this._end = end;
        this._queuedChunk = null;
        this._requests = [];
        this._done = false;
        this.onProgress = null;
    }
    PDFDataTransportStreamRangeReader.prototype._enqueue = function (chunk) {
        var e_98, _k;
        if (this._done) {
            return;
        }
        if (this._requests.length === 0) {
            this._queuedChunk = chunk;
        }
        else {
            var requestsCapability = this._requests.shift();
            requestsCapability.resolve({
                value: chunk,
                done: false
            });
            try {
                for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                    var requestCapability = _m.value;
                    requestCapability.resolve({
                        value: undefined,
                        done: true
                    });
                }
            }
            catch (e_98_1) { e_98 = { error: e_98_1 }; }
            finally {
                try {
                    if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
                }
                finally { if (e_98) throw e_98.error; }
            }
            this._requests.length = 0;
        }
        this._done = true;
        this._stream._removeRangeReader(this);
    };
    Object.defineProperty(PDFDataTransportStreamRangeReader.prototype, "isStreamingSupported", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    PDFDataTransportStreamRangeReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk, requestCapability;
            return __generator(this, function (_k) {
                if (this._queuedChunk) {
                    chunk = this._queuedChunk;
                    this._queuedChunk = null;
                    return [2 /*return*/, {
                            value: chunk,
                            done: false
                        }];
                }
                if (this._done) {
                    return [2 /*return*/, {
                            value: undefined,
                            done: true
                        }];
                }
                requestCapability = Promise.withResolvers();
                this._requests.push(requestCapability);
                return [2 /*return*/, requestCapability.promise];
            });
        });
    };
    PDFDataTransportStreamRangeReader.prototype.cancel = function (reason) {
        var e_99, _k;
        this._done = true;
        try {
            for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                var requestCapability = _m.value;
                requestCapability.resolve({
                    value: undefined,
                    done: true
                });
            }
        }
        catch (e_99_1) { e_99 = { error: e_99_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_99) throw e_99.error; }
        }
        this._requests.length = 0;
        this._stream._removeRangeReader(this);
    };
    return PDFDataTransportStreamRangeReader;
}());
; // ./src/display/content_disposition.js
function getFilenameFromContentDispositionHeader(contentDisposition) {
    var needsEncodingFixup = true;
    var tmp = toParamRegExp("filename\\*", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        var filename = rfc2616unquote(tmp);
        filename = unescape(filename);
        filename = rfc5987decode(filename);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    tmp = rfc2231getparam(contentDisposition);
    if (tmp) {
        var filename = rfc2047decode(tmp);
        return fixupEncoding(filename);
    }
    tmp = toParamRegExp("filename", "i").exec(contentDisposition);
    if (tmp) {
        tmp = tmp[1];
        var filename = rfc2616unquote(tmp);
        filename = rfc2047decode(filename);
        return fixupEncoding(filename);
    }
    function toParamRegExp(attributePattern, flags) {
        return new RegExp("(?:^|;)\\s*" + attributePattern + "\\s*=\\s*" + "(" + '[^";\\s][^;\\s]*' + "|" + '"(?:[^"\\\\]|\\\\"?)+"?' + ")", flags);
    }
    function textdecode(encoding, value) {
        if (encoding) {
            if (!/^[\x00-\xFF]+$/.test(value)) {
                return value;
            }
            try {
                var decoder = new TextDecoder(encoding, {
                    fatal: true
                });
                var buffer = stringToBytes(value);
                value = decoder.decode(buffer);
                needsEncodingFixup = false;
            }
            catch (_k) { }
        }
        return value;
    }
    function fixupEncoding(value) {
        if (needsEncodingFixup && /[\x80-\xff]/.test(value)) {
            value = textdecode("utf-8", value);
            if (needsEncodingFixup) {
                value = textdecode("iso-8859-1", value);
            }
        }
        return value;
    }
    function rfc2231getparam(contentDispositionStr) {
        var matches = [];
        var match;
        var iter = toParamRegExp("filename\\*((?!0\\d)\\d+)(\\*?)", "ig");
        while ((match = iter.exec(contentDispositionStr)) !== null) {
            var _k = __read(match, 4), n = _k[1], quot = _k[2], part = _k[3];
            n = parseInt(n, 10);
            if (n in matches) {
                if (n === 0) {
                    break;
                }
                continue;
            }
            matches[n] = [quot, part];
        }
        var parts = [];
        for (var n = 0; n < matches.length; ++n) {
            if (!(n in matches)) {
                break;
            }
            var _l = __read(matches[n], 2), quot = _l[0], part = _l[1];
            part = rfc2616unquote(part);
            if (quot) {
                part = unescape(part);
                if (n === 0) {
                    part = rfc5987decode(part);
                }
            }
            parts.push(part);
        }
        return parts.join("");
    }
    function rfc2616unquote(value) {
        if (value.startsWith('"')) {
            var parts = value.slice(1).split('\\"');
            for (var i = 0; i < parts.length; ++i) {
                var quotindex = parts[i].indexOf('"');
                if (quotindex !== -1) {
                    parts[i] = parts[i].slice(0, quotindex);
                    parts.length = i + 1;
                }
                parts[i] = parts[i].replaceAll(/\\(.)/g, "$1");
            }
            value = parts.join('"');
        }
        return value;
    }
    function rfc5987decode(extvalue) {
        var encodingend = extvalue.indexOf("'");
        if (encodingend === -1) {
            return extvalue;
        }
        var encoding = extvalue.slice(0, encodingend);
        var langvalue = extvalue.slice(encodingend + 1);
        var value = langvalue.replace(/^[^']*'/, "");
        return textdecode(encoding, value);
    }
    function rfc2047decode(value) {
        if (!value.startsWith("=?") || /[\x00-\x19\x80-\xff]/.test(value)) {
            return value;
        }
        return value.replaceAll(/=\?([\w-]*)\?([QqBb])\?((?:[^?]|\?(?!=))*)\?=/g, function (matches, charset, encoding, text) {
            if (encoding === "q" || encoding === "Q") {
                text = text.replaceAll("_", " ");
                text = text.replaceAll(/=([0-9a-fA-F]{2})/g, function (match, hex) {
                    return String.fromCharCode(parseInt(hex, 16));
                });
                return textdecode(charset, text);
            }
            try {
                text = atob(text);
            }
            catch (_k) { }
            return textdecode(charset, text);
        });
    }
    return "";
}
; // ./src/display/network_utils.js
function createHeaders(isHttp, httpHeaders) {
    var headers = new Headers();
    if (!isHttp || !httpHeaders || typeof httpHeaders !== "object") {
        return headers;
    }
    for (var key in httpHeaders) {
        var val = httpHeaders[key];
        if (val !== undefined) {
            headers.append(key, val);
        }
    }
    return headers;
}
function getResponseOrigin(url) {
    var _k, _l;
    return (_l = (_k = URL.parse(url)) === null || _k === void 0 ? void 0 : _k.origin) !== null && _l !== void 0 ? _l : null;
}
function validateRangeRequestCapabilities(_k) {
    var responseHeaders = _k.responseHeaders, isHttp = _k.isHttp, rangeChunkSize = _k.rangeChunkSize, disableRange = _k.disableRange;
    var returnValues = {
        allowRangeRequests: false,
        suggestedLength: undefined
    };
    var length = parseInt(responseHeaders.get("Content-Length"), 10);
    if (!Number.isInteger(length)) {
        return returnValues;
    }
    returnValues.suggestedLength = length;
    if (length <= 2 * rangeChunkSize) {
        return returnValues;
    }
    if (disableRange || !isHttp) {
        return returnValues;
    }
    if (responseHeaders.get("Accept-Ranges") !== "bytes") {
        return returnValues;
    }
    var contentEncoding = responseHeaders.get("Content-Encoding") || "identity";
    if (contentEncoding !== "identity") {
        return returnValues;
    }
    returnValues.allowRangeRequests = true;
    return returnValues;
}
function extractFilenameFromHeader(responseHeaders) {
    var contentDisposition = responseHeaders.get("Content-Disposition");
    if (contentDisposition) {
        var filename = getFilenameFromContentDispositionHeader(contentDisposition);
        if (filename.includes("%")) {
            try {
                filename = decodeURIComponent(filename);
            }
            catch (_k) { }
        }
        if (isPdfFile(filename)) {
            return filename;
        }
    }
    return null;
}
function createResponseError(status, url) {
    return new ResponseException("Unexpected server response (".concat(status, ") while retrieving PDF \"").concat(url, "\"."), status, status === 404 || status === 0 && url.startsWith("file:"));
}
function validateResponseStatus(status) {
    return status === 200 || status === 206;
}
; // ./src/display/fetch_stream.js
function createFetchOptions(headers, withCredentials, abortController) {
    return {
        method: "GET",
        headers: headers,
        signal: abortController.signal,
        mode: "cors",
        credentials: withCredentials ? "include" : "same-origin",
        redirect: "follow"
    };
}
function getArrayBuffer(val) {
    if (val instanceof Uint8Array) {
        return val.buffer;
    }
    if (val instanceof ArrayBuffer) {
        return val;
    }
    warn("getArrayBuffer - unexpected data format: ".concat(val));
    return new Uint8Array(val).buffer;
}
var PDFFetchStream = /** @class */ (function () {
    function PDFFetchStream(source) {
        this._responseOrigin = null;
        this.source = source;
        this.isHttp = /^https?:/i.test(source.url);
        this.headers = createHeaders(this.isHttp, source.httpHeaders);
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    Object.defineProperty(PDFFetchStream.prototype, "_progressiveDataLength", {
        get: function () {
            var _k, _l;
            return (_l = (_k = this._fullRequestReader) === null || _k === void 0 ? void 0 : _k._loaded) !== null && _l !== void 0 ? _l : 0;
        },
        enumerable: false,
        configurable: true
    });
    PDFFetchStream.prototype.getFullReader = function () {
        assert(!this._fullRequestReader, "PDFFetchStream.getFullReader can only be called once.");
        this._fullRequestReader = new PDFFetchStreamReader(this);
        return this._fullRequestReader;
    };
    PDFFetchStream.prototype.getRangeReader = function (begin, end) {
        if (end <= this._progressiveDataLength) {
            return null;
        }
        var reader = new PDFFetchStreamRangeReader(this, begin, end);
        this._rangeRequestReaders.push(reader);
        return reader;
    };
    PDFFetchStream.prototype.cancelAllRequests = function (reason) {
        var e_100, _k;
        var _l;
        (_l = this._fullRequestReader) === null || _l === void 0 ? void 0 : _l.cancel(reason);
        try {
            for (var _m = __values(this._rangeRequestReaders.slice(0)), _o = _m.next(); !_o.done; _o = _m.next()) {
                var reader = _o.value;
                reader.cancel(reason);
            }
        }
        catch (e_100_1) { e_100 = { error: e_100_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_k = _m.return)) _k.call(_m);
            }
            finally { if (e_100) throw e_100.error; }
        }
    };
    return PDFFetchStream;
}());
var PDFFetchStreamReader = /** @class */ (function () {
    function PDFFetchStreamReader(stream) {
        var _this = this;
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        this._filename = null;
        var source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._contentLength = source.length;
        this._headersCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
        }
        this._abortController = new AbortController();
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        var headers = new Headers(stream.headers);
        var url = source.url;
        fetch(url, createFetchOptions(headers, this._withCredentials, this._abortController)).then(function (response) {
            stream._responseOrigin = getResponseOrigin(response.url);
            if (!validateResponseStatus(response.status)) {
                throw createResponseError(response.status, url);
            }
            _this._reader = response.body.getReader();
            _this._headersCapability.resolve();
            var responseHeaders = response.headers;
            var _k = validateRangeRequestCapabilities({
                responseHeaders: responseHeaders,
                isHttp: stream.isHttp,
                rangeChunkSize: _this._rangeChunkSize,
                disableRange: _this._disableRange
            }), allowRangeRequests = _k.allowRangeRequests, suggestedLength = _k.suggestedLength;
            _this._isRangeSupported = allowRangeRequests;
            _this._contentLength = suggestedLength || _this._contentLength;
            _this._filename = extractFilenameFromHeader(responseHeaders);
            if (!_this._isStreamingSupported && _this._isRangeSupported) {
                _this.cancel(new AbortException("Streaming is disabled."));
            }
        }).catch(this._headersCapability.reject);
        this.onProgress = null;
    }
    Object.defineProperty(PDFFetchStreamReader.prototype, "headersReady", {
        get: function () {
            return this._headersCapability.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFFetchStreamReader.prototype, "filename", {
        get: function () {
            return this._filename;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFFetchStreamReader.prototype, "contentLength", {
        get: function () {
            return this._contentLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFFetchStreamReader.prototype, "isRangeSupported", {
        get: function () {
            return this._isRangeSupported;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFFetchStreamReader.prototype, "isStreamingSupported", {
        get: function () {
            return this._isStreamingSupported;
        },
        enumerable: false,
        configurable: true
    });
    PDFFetchStreamReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _k, value, done;
            var _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0: return [4 /*yield*/, this._headersCapability.promise];
                    case 1:
                        _m.sent();
                        return [4 /*yield*/, this._reader.read()];
                    case 2:
                        _k = _m.sent(), value = _k.value, done = _k.done;
                        if (done) {
                            return [2 /*return*/, {
                                    value: value,
                                    done: done
                                }];
                        }
                        this._loaded += value.byteLength;
                        (_l = this.onProgress) === null || _l === void 0 ? void 0 : _l.call(this, {
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        return [2 /*return*/, {
                                value: getArrayBuffer(value),
                                done: false
                            }];
                }
            });
        });
    };
    PDFFetchStreamReader.prototype.cancel = function (reason) {
        var _k;
        (_k = this._reader) === null || _k === void 0 ? void 0 : _k.cancel(reason);
        this._abortController.abort();
    };
    return PDFFetchStreamReader;
}());
var PDFFetchStreamRangeReader = /** @class */ (function () {
    function PDFFetchStreamRangeReader(stream, begin, end) {
        var _this = this;
        this._stream = stream;
        this._reader = null;
        this._loaded = 0;
        var source = stream.source;
        this._withCredentials = source.withCredentials || false;
        this._readCapability = Promise.withResolvers();
        this._isStreamingSupported = !source.disableStream;
        this._abortController = new AbortController();
        var headers = new Headers(stream.headers);
        headers.append("Range", "bytes=".concat(begin, "-").concat(end - 1));
        var url = source.url;
        fetch(url, createFetchOptions(headers, this._withCredentials, this._abortController)).then(function (response) {
            var responseOrigin = getResponseOrigin(response.url);
            if (responseOrigin !== stream._responseOrigin) {
                throw new Error("Expected range response-origin \"".concat(responseOrigin, "\" to match \"").concat(stream._responseOrigin, "\"."));
            }
            if (!validateResponseStatus(response.status)) {
                throw createResponseError(response.status, url);
            }
            _this._readCapability.resolve();
            _this._reader = response.body.getReader();
        }).catch(this._readCapability.reject);
        this.onProgress = null;
    }
    Object.defineProperty(PDFFetchStreamRangeReader.prototype, "isStreamingSupported", {
        get: function () {
            return this._isStreamingSupported;
        },
        enumerable: false,
        configurable: true
    });
    PDFFetchStreamRangeReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _k, value, done;
            var _l;
            return __generator(this, function (_m) {
                switch (_m.label) {
                    case 0: return [4 /*yield*/, this._readCapability.promise];
                    case 1:
                        _m.sent();
                        return [4 /*yield*/, this._reader.read()];
                    case 2:
                        _k = _m.sent(), value = _k.value, done = _k.done;
                        if (done) {
                            return [2 /*return*/, {
                                    value: value,
                                    done: done
                                }];
                        }
                        this._loaded += value.byteLength;
                        (_l = this.onProgress) === null || _l === void 0 ? void 0 : _l.call(this, {
                            loaded: this._loaded
                        });
                        return [2 /*return*/, {
                                value: getArrayBuffer(value),
                                done: false
                            }];
                }
            });
        });
    };
    PDFFetchStreamRangeReader.prototype.cancel = function (reason) {
        var _k;
        (_k = this._reader) === null || _k === void 0 ? void 0 : _k.cancel(reason);
        this._abortController.abort();
    };
    return PDFFetchStreamRangeReader;
}());
; // ./src/display/network.js
var OK_RESPONSE = 200;
var PARTIAL_CONTENT_RESPONSE = 206;
function network_getArrayBuffer(xhr) {
    var data = xhr.response;
    if (typeof data !== "string") {
        return data;
    }
    return stringToBytes(data).buffer;
}
var NetworkManager = /** @class */ (function () {
    function NetworkManager(_k) {
        var url = _k.url, httpHeaders = _k.httpHeaders, withCredentials = _k.withCredentials;
        this._responseOrigin = null;
        this.url = url;
        this.isHttp = /^https?:/i.test(url);
        this.headers = createHeaders(this.isHttp, httpHeaders);
        this.withCredentials = withCredentials || false;
        this.currXhrId = 0;
        this.pendingRequests = Object.create(null);
    }
    NetworkManager.prototype.request = function (args) {
        var e_101, _k;
        var xhr = new XMLHttpRequest();
        var xhrId = this.currXhrId++;
        var pendingRequest = this.pendingRequests[xhrId] = {
            xhr: xhr
        };
        xhr.open("GET", this.url);
        xhr.withCredentials = this.withCredentials;
        try {
            for (var _l = __values(this.headers), _m = _l.next(); !_m.done; _m = _l.next()) {
                var _o = __read(_m.value, 2), key = _o[0], val = _o[1];
                xhr.setRequestHeader(key, val);
            }
        }
        catch (e_101_1) { e_101 = { error: e_101_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_101) throw e_101.error; }
        }
        if (this.isHttp && "begin" in args && "end" in args) {
            xhr.setRequestHeader("Range", "bytes=".concat(args.begin, "-").concat(args.end - 1));
            pendingRequest.expectedStatus = PARTIAL_CONTENT_RESPONSE;
        }
        else {
            pendingRequest.expectedStatus = OK_RESPONSE;
        }
        xhr.responseType = "arraybuffer";
        assert(args.onError, "Expected `onError` callback to be provided.");
        xhr.onerror = function () {
            args.onError(xhr.status);
        };
        xhr.onreadystatechange = this.onStateChange.bind(this, xhrId);
        xhr.onprogress = this.onProgress.bind(this, xhrId);
        pendingRequest.onHeadersReceived = args.onHeadersReceived;
        pendingRequest.onDone = args.onDone;
        pendingRequest.onError = args.onError;
        pendingRequest.onProgress = args.onProgress;
        xhr.send(null);
        return xhrId;
    };
    NetworkManager.prototype.onProgress = function (xhrId, evt) {
        var _k;
        var pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) {
            return;
        }
        (_k = pendingRequest.onProgress) === null || _k === void 0 ? void 0 : _k.call(pendingRequest, evt);
    };
    NetworkManager.prototype.onStateChange = function (xhrId, evt) {
        var pendingRequest = this.pendingRequests[xhrId];
        if (!pendingRequest) {
            return;
        }
        var xhr = pendingRequest.xhr;
        if (xhr.readyState >= 2 && pendingRequest.onHeadersReceived) {
            pendingRequest.onHeadersReceived();
            delete pendingRequest.onHeadersReceived;
        }
        if (xhr.readyState !== 4) {
            return;
        }
        if (!(xhrId in this.pendingRequests)) {
            return;
        }
        delete this.pendingRequests[xhrId];
        if (xhr.status === 0 && this.isHttp) {
            pendingRequest.onError(xhr.status);
            return;
        }
        var xhrStatus = xhr.status || OK_RESPONSE;
        var ok_response_on_range_request = xhrStatus === OK_RESPONSE && pendingRequest.expectedStatus === PARTIAL_CONTENT_RESPONSE;
        if (!ok_response_on_range_request && xhrStatus !== pendingRequest.expectedStatus) {
            pendingRequest.onError(xhr.status);
            return;
        }
        var chunk = network_getArrayBuffer(xhr);
        if (xhrStatus === PARTIAL_CONTENT_RESPONSE) {
            var rangeHeader = xhr.getResponseHeader("Content-Range");
            var matches = /bytes (\d+)-(\d+)\/(\d+)/.exec(rangeHeader);
            if (matches) {
                pendingRequest.onDone({
                    begin: parseInt(matches[1], 10),
                    chunk: chunk
                });
            }
            else {
                warn("Missing or invalid \"Content-Range\" header.");
                pendingRequest.onError(0);
            }
        }
        else if (chunk) {
            pendingRequest.onDone({
                begin: 0,
                chunk: chunk
            });
        }
        else {
            pendingRequest.onError(xhr.status);
        }
    };
    NetworkManager.prototype.getRequestXhr = function (xhrId) {
        return this.pendingRequests[xhrId].xhr;
    };
    NetworkManager.prototype.isPendingRequest = function (xhrId) {
        return xhrId in this.pendingRequests;
    };
    NetworkManager.prototype.abortRequest = function (xhrId) {
        var xhr = this.pendingRequests[xhrId].xhr;
        delete this.pendingRequests[xhrId];
        xhr.abort();
    };
    return NetworkManager;
}());
var PDFNetworkStream = /** @class */ (function () {
    function PDFNetworkStream(source) {
        this._source = source;
        this._manager = new NetworkManager(source);
        this._rangeChunkSize = source.rangeChunkSize;
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    PDFNetworkStream.prototype._onRangeRequestReaderClosed = function (reader) {
        var i = this._rangeRequestReaders.indexOf(reader);
        if (i >= 0) {
            this._rangeRequestReaders.splice(i, 1);
        }
    };
    PDFNetworkStream.prototype.getFullReader = function () {
        assert(!this._fullRequestReader, "PDFNetworkStream.getFullReader can only be called once.");
        this._fullRequestReader = new PDFNetworkStreamFullRequestReader(this._manager, this._source);
        return this._fullRequestReader;
    };
    PDFNetworkStream.prototype.getRangeReader = function (begin, end) {
        var reader = new PDFNetworkStreamRangeRequestReader(this._manager, begin, end);
        reader.onClosed = this._onRangeRequestReaderClosed.bind(this);
        this._rangeRequestReaders.push(reader);
        return reader;
    };
    PDFNetworkStream.prototype.cancelAllRequests = function (reason) {
        var e_102, _k;
        var _l;
        (_l = this._fullRequestReader) === null || _l === void 0 ? void 0 : _l.cancel(reason);
        try {
            for (var _m = __values(this._rangeRequestReaders.slice(0)), _o = _m.next(); !_o.done; _o = _m.next()) {
                var reader = _o.value;
                reader.cancel(reason);
            }
        }
        catch (e_102_1) { e_102 = { error: e_102_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_k = _m.return)) _k.call(_m);
            }
            finally { if (e_102) throw e_102.error; }
        }
    };
    return PDFNetworkStream;
}());
var PDFNetworkStreamFullRequestReader = /** @class */ (function () {
    function PDFNetworkStreamFullRequestReader(manager, source) {
        this._manager = manager;
        this._url = source.url;
        this._fullRequestId = manager.request({
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        });
        this._headersCapability = Promise.withResolvers();
        this._disableRange = source.disableRange || false;
        this._contentLength = source.length;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
        }
        this._isStreamingSupported = false;
        this._isRangeSupported = false;
        this._cachedChunks = [];
        this._requests = [];
        this._done = false;
        this._storedError = undefined;
        this._filename = null;
        this.onProgress = null;
    }
    PDFNetworkStreamFullRequestReader.prototype._onHeadersReceived = function () {
        var fullRequestXhrId = this._fullRequestId;
        var fullRequestXhr = this._manager.getRequestXhr(fullRequestXhrId);
        this._manager._responseOrigin = getResponseOrigin(fullRequestXhr.responseURL);
        var rawResponseHeaders = fullRequestXhr.getAllResponseHeaders();
        var responseHeaders = new Headers(rawResponseHeaders ? rawResponseHeaders.trimStart().replace(/[^\S ]+$/, "").split(/[\r\n]+/).map(function (x) {
            var _k = __read(x.split(": ")), key = _k[0], val = _k.slice(1);
            return [key, val.join(": ")];
        }) : []);
        var _k = validateRangeRequestCapabilities({
            responseHeaders: responseHeaders,
            isHttp: this._manager.isHttp,
            rangeChunkSize: this._rangeChunkSize,
            disableRange: this._disableRange
        }), allowRangeRequests = _k.allowRangeRequests, suggestedLength = _k.suggestedLength;
        if (allowRangeRequests) {
            this._isRangeSupported = true;
        }
        this._contentLength = suggestedLength || this._contentLength;
        this._filename = extractFilenameFromHeader(responseHeaders);
        if (this._isRangeSupported) {
            this._manager.abortRequest(fullRequestXhrId);
        }
        this._headersCapability.resolve();
    };
    PDFNetworkStreamFullRequestReader.prototype._onDone = function (data) {
        var e_103, _k;
        if (data) {
            if (this._requests.length > 0) {
                var requestCapability = this._requests.shift();
                requestCapability.resolve({
                    value: data.chunk,
                    done: false
                });
            }
            else {
                this._cachedChunks.push(data.chunk);
            }
        }
        this._done = true;
        if (this._cachedChunks.length > 0) {
            return;
        }
        try {
            for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                var requestCapability = _m.value;
                requestCapability.resolve({
                    value: undefined,
                    done: true
                });
            }
        }
        catch (e_103_1) { e_103 = { error: e_103_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_103) throw e_103.error; }
        }
        this._requests.length = 0;
    };
    PDFNetworkStreamFullRequestReader.prototype._onError = function (status) {
        var e_104, _k;
        this._storedError = createResponseError(status, this._url);
        this._headersCapability.reject(this._storedError);
        try {
            for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                var requestCapability = _m.value;
                requestCapability.reject(this._storedError);
            }
        }
        catch (e_104_1) { e_104 = { error: e_104_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_104) throw e_104.error; }
        }
        this._requests.length = 0;
        this._cachedChunks.length = 0;
    };
    PDFNetworkStreamFullRequestReader.prototype._onProgress = function (evt) {
        var _k;
        (_k = this.onProgress) === null || _k === void 0 ? void 0 : _k.call(this, {
            loaded: evt.loaded,
            total: evt.lengthComputable ? evt.total : this._contentLength
        });
    };
    Object.defineProperty(PDFNetworkStreamFullRequestReader.prototype, "filename", {
        get: function () {
            return this._filename;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNetworkStreamFullRequestReader.prototype, "isRangeSupported", {
        get: function () {
            return this._isRangeSupported;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNetworkStreamFullRequestReader.prototype, "isStreamingSupported", {
        get: function () {
            return this._isStreamingSupported;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNetworkStreamFullRequestReader.prototype, "contentLength", {
        get: function () {
            return this._contentLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNetworkStreamFullRequestReader.prototype, "headersReady", {
        get: function () {
            return this._headersCapability.promise;
        },
        enumerable: false,
        configurable: true
    });
    PDFNetworkStreamFullRequestReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk, requestCapability;
            return __generator(this, function (_k) {
                switch (_k.label) {
                    case 0: return [4 /*yield*/, this._headersCapability.promise];
                    case 1:
                        _k.sent();
                        if (this._storedError) {
                            throw this._storedError;
                        }
                        if (this._cachedChunks.length > 0) {
                            chunk = this._cachedChunks.shift();
                            return [2 /*return*/, {
                                    value: chunk,
                                    done: false
                                }];
                        }
                        if (this._done) {
                            return [2 /*return*/, {
                                    value: undefined,
                                    done: true
                                }];
                        }
                        requestCapability = Promise.withResolvers();
                        this._requests.push(requestCapability);
                        return [2 /*return*/, requestCapability.promise];
                }
            });
        });
    };
    PDFNetworkStreamFullRequestReader.prototype.cancel = function (reason) {
        var e_105, _k;
        this._done = true;
        this._headersCapability.reject(reason);
        try {
            for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                var requestCapability = _m.value;
                requestCapability.resolve({
                    value: undefined,
                    done: true
                });
            }
        }
        catch (e_105_1) { e_105 = { error: e_105_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_105) throw e_105.error; }
        }
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._fullRequestId)) {
            this._manager.abortRequest(this._fullRequestId);
        }
        this._fullRequestReader = null;
    };
    return PDFNetworkStreamFullRequestReader;
}());
var PDFNetworkStreamRangeRequestReader = /** @class */ (function () {
    function PDFNetworkStreamRangeRequestReader(manager, begin, end) {
        this._manager = manager;
        this._url = manager.url;
        this._requestId = manager.request({
            begin: begin,
            end: end,
            onHeadersReceived: this._onHeadersReceived.bind(this),
            onDone: this._onDone.bind(this),
            onError: this._onError.bind(this),
            onProgress: this._onProgress.bind(this)
        });
        this._requests = [];
        this._queuedChunk = null;
        this._done = false;
        this._storedError = undefined;
        this.onProgress = null;
        this.onClosed = null;
    }
    PDFNetworkStreamRangeRequestReader.prototype._onHeadersReceived = function () {
        var _k;
        var responseOrigin = getResponseOrigin((_k = this._manager.getRequestXhr(this._requestId)) === null || _k === void 0 ? void 0 : _k.responseURL);
        if (responseOrigin !== this._manager._responseOrigin) {
            this._storedError = new Error("Expected range response-origin \"".concat(responseOrigin, "\" to match \"").concat(this._manager._responseOrigin, "\"."));
            this._onError(0);
        }
    };
    PDFNetworkStreamRangeRequestReader.prototype._close = function () {
        var _k;
        (_k = this.onClosed) === null || _k === void 0 ? void 0 : _k.call(this, this);
    };
    PDFNetworkStreamRangeRequestReader.prototype._onDone = function (data) {
        var e_106, _k;
        var chunk = data.chunk;
        if (this._requests.length > 0) {
            var requestCapability = this._requests.shift();
            requestCapability.resolve({
                value: chunk,
                done: false
            });
        }
        else {
            this._queuedChunk = chunk;
        }
        this._done = true;
        try {
            for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                var requestCapability = _m.value;
                requestCapability.resolve({
                    value: undefined,
                    done: true
                });
            }
        }
        catch (e_106_1) { e_106 = { error: e_106_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_106) throw e_106.error; }
        }
        this._requests.length = 0;
        this._close();
    };
    PDFNetworkStreamRangeRequestReader.prototype._onError = function (status) {
        var e_107, _k;
        var _l;
        (_l = this._storedError) !== null && _l !== void 0 ? _l : (this._storedError = createResponseError(status, this._url));
        try {
            for (var _m = __values(this._requests), _o = _m.next(); !_o.done; _o = _m.next()) {
                var requestCapability = _o.value;
                requestCapability.reject(this._storedError);
            }
        }
        catch (e_107_1) { e_107 = { error: e_107_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_k = _m.return)) _k.call(_m);
            }
            finally { if (e_107) throw e_107.error; }
        }
        this._requests.length = 0;
        this._queuedChunk = null;
    };
    PDFNetworkStreamRangeRequestReader.prototype._onProgress = function (evt) {
        var _k;
        if (!this.isStreamingSupported) {
            (_k = this.onProgress) === null || _k === void 0 ? void 0 : _k.call(this, {
                loaded: evt.loaded
            });
        }
    };
    Object.defineProperty(PDFNetworkStreamRangeRequestReader.prototype, "isStreamingSupported", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    PDFNetworkStreamRangeRequestReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk, requestCapability;
            return __generator(this, function (_k) {
                if (this._storedError) {
                    throw this._storedError;
                }
                if (this._queuedChunk !== null) {
                    chunk = this._queuedChunk;
                    this._queuedChunk = null;
                    return [2 /*return*/, {
                            value: chunk,
                            done: false
                        }];
                }
                if (this._done) {
                    return [2 /*return*/, {
                            value: undefined,
                            done: true
                        }];
                }
                requestCapability = Promise.withResolvers();
                this._requests.push(requestCapability);
                return [2 /*return*/, requestCapability.promise];
            });
        });
    };
    PDFNetworkStreamRangeRequestReader.prototype.cancel = function (reason) {
        var e_108, _k;
        this._done = true;
        try {
            for (var _l = __values(this._requests), _m = _l.next(); !_m.done; _m = _l.next()) {
                var requestCapability = _m.value;
                requestCapability.resolve({
                    value: undefined,
                    done: true
                });
            }
        }
        catch (e_108_1) { e_108 = { error: e_108_1 }; }
        finally {
            try {
                if (_m && !_m.done && (_k = _l.return)) _k.call(_l);
            }
            finally { if (e_108) throw e_108.error; }
        }
        this._requests.length = 0;
        if (this._manager.isPendingRequest(this._requestId)) {
            this._manager.abortRequest(this._requestId);
        }
        this._close();
    };
    return PDFNetworkStreamRangeRequestReader;
}());
; // ./src/display/node_stream.js
var urlRegex = /^[a-z][a-z0-9\-+.]+:/i;
function parseUrlOrPath(sourceUrl) {
    if (urlRegex.test(sourceUrl)) {
        return new URL(sourceUrl);
    }
    var url = process.getBuiltinModule("url");
    return new URL(url.pathToFileURL(sourceUrl));
}
var PDFNodeStream = /** @class */ (function () {
    function PDFNodeStream(source) {
        this.source = source;
        this.url = parseUrlOrPath(source.url);
        assert(this.url.protocol === "file:", "PDFNodeStream only supports file:// URLs.");
        this._fullRequestReader = null;
        this._rangeRequestReaders = [];
    }
    Object.defineProperty(PDFNodeStream.prototype, "_progressiveDataLength", {
        get: function () {
            var _k, _l;
            return (_l = (_k = this._fullRequestReader) === null || _k === void 0 ? void 0 : _k._loaded) !== null && _l !== void 0 ? _l : 0;
        },
        enumerable: false,
        configurable: true
    });
    PDFNodeStream.prototype.getFullReader = function () {
        assert(!this._fullRequestReader, "PDFNodeStream.getFullReader can only be called once.");
        this._fullRequestReader = new PDFNodeStreamFsFullReader(this);
        return this._fullRequestReader;
    };
    PDFNodeStream.prototype.getRangeReader = function (start, end) {
        if (end <= this._progressiveDataLength) {
            return null;
        }
        var rangeReader = new PDFNodeStreamFsRangeReader(this, start, end);
        this._rangeRequestReaders.push(rangeReader);
        return rangeReader;
    };
    PDFNodeStream.prototype.cancelAllRequests = function (reason) {
        var e_109, _k;
        var _l;
        (_l = this._fullRequestReader) === null || _l === void 0 ? void 0 : _l.cancel(reason);
        try {
            for (var _m = __values(this._rangeRequestReaders.slice(0)), _o = _m.next(); !_o.done; _o = _m.next()) {
                var reader = _o.value;
                reader.cancel(reason);
            }
        }
        catch (e_109_1) { e_109 = { error: e_109_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_k = _m.return)) _k.call(_m);
            }
            finally { if (e_109) throw e_109.error; }
        }
    };
    return PDFNodeStream;
}());
var PDFNodeStreamFsFullReader = /** @class */ (function () {
    function PDFNodeStreamFsFullReader(stream) {
        var _this = this;
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        var source = stream.source;
        this._contentLength = source.length;
        this._loaded = 0;
        this._filename = null;
        this._disableRange = source.disableRange || false;
        this._rangeChunkSize = source.rangeChunkSize;
        if (!this._rangeChunkSize && !this._disableRange) {
            this._disableRange = true;
        }
        this._isStreamingSupported = !source.disableStream;
        this._isRangeSupported = !source.disableRange;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        this._headersCapability = Promise.withResolvers();
        var fs = process.getBuiltinModule("fs");
        fs.promises.lstat(this._url).then(function (stat) {
            _this._contentLength = stat.size;
            _this._setReadableStream(fs.createReadStream(_this._url));
            _this._headersCapability.resolve();
        }, function (error) {
            if (error.code === "ENOENT") {
                error = createResponseError(0, _this._url.href);
            }
            _this._storedError = error;
            _this._headersCapability.reject(error);
        });
    }
    Object.defineProperty(PDFNodeStreamFsFullReader.prototype, "headersReady", {
        get: function () {
            return this._headersCapability.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNodeStreamFsFullReader.prototype, "filename", {
        get: function () {
            return this._filename;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNodeStreamFsFullReader.prototype, "contentLength", {
        get: function () {
            return this._contentLength;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNodeStreamFsFullReader.prototype, "isRangeSupported", {
        get: function () {
            return this._isRangeSupported;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFNodeStreamFsFullReader.prototype, "isStreamingSupported", {
        get: function () {
            return this._isStreamingSupported;
        },
        enumerable: false,
        configurable: true
    });
    PDFNodeStreamFsFullReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk, buffer;
            var _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0: return [4 /*yield*/, this._readCapability.promise];
                    case 1:
                        _l.sent();
                        if (this._done) {
                            return [2 /*return*/, {
                                    value: undefined,
                                    done: true
                                }];
                        }
                        if (this._storedError) {
                            throw this._storedError;
                        }
                        chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = Promise.withResolvers();
                            return [2 /*return*/, this.read()];
                        }
                        this._loaded += chunk.length;
                        (_k = this.onProgress) === null || _k === void 0 ? void 0 : _k.call(this, {
                            loaded: this._loaded,
                            total: this._contentLength
                        });
                        buffer = new Uint8Array(chunk).buffer;
                        return [2 /*return*/, {
                                value: buffer,
                                done: false
                            }];
                }
            });
        });
    };
    PDFNodeStreamFsFullReader.prototype.cancel = function (reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    };
    PDFNodeStreamFsFullReader.prototype._error = function (reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    };
    PDFNodeStreamFsFullReader.prototype._setReadableStream = function (readableStream) {
        var _this = this;
        this._readableStream = readableStream;
        readableStream.on("readable", function () {
            _this._readCapability.resolve();
        });
        readableStream.on("end", function () {
            readableStream.destroy();
            _this._done = true;
            _this._readCapability.resolve();
        });
        readableStream.on("error", function (reason) {
            _this._error(reason);
        });
        if (!this._isStreamingSupported && this._isRangeSupported) {
            this._error(new AbortException("streaming is disabled"));
        }
        if (this._storedError) {
            this._readableStream.destroy(this._storedError);
        }
    };
    return PDFNodeStreamFsFullReader;
}());
var PDFNodeStreamFsRangeReader = /** @class */ (function () {
    function PDFNodeStreamFsRangeReader(stream, start, end) {
        this._url = stream.url;
        this._done = false;
        this._storedError = null;
        this.onProgress = null;
        this._loaded = 0;
        this._readableStream = null;
        this._readCapability = Promise.withResolvers();
        var source = stream.source;
        this._isStreamingSupported = !source.disableStream;
        var fs = process.getBuiltinModule("fs");
        this._setReadableStream(fs.createReadStream(this._url, {
            start: start,
            end: end - 1
        }));
    }
    Object.defineProperty(PDFNodeStreamFsRangeReader.prototype, "isStreamingSupported", {
        get: function () {
            return this._isStreamingSupported;
        },
        enumerable: false,
        configurable: true
    });
    PDFNodeStreamFsRangeReader.prototype.read = function () {
        return __awaiter(this, void 0, void 0, function () {
            var chunk, buffer;
            var _k;
            return __generator(this, function (_l) {
                switch (_l.label) {
                    case 0: return [4 /*yield*/, this._readCapability.promise];
                    case 1:
                        _l.sent();
                        if (this._done) {
                            return [2 /*return*/, {
                                    value: undefined,
                                    done: true
                                }];
                        }
                        if (this._storedError) {
                            throw this._storedError;
                        }
                        chunk = this._readableStream.read();
                        if (chunk === null) {
                            this._readCapability = Promise.withResolvers();
                            return [2 /*return*/, this.read()];
                        }
                        this._loaded += chunk.length;
                        (_k = this.onProgress) === null || _k === void 0 ? void 0 : _k.call(this, {
                            loaded: this._loaded
                        });
                        buffer = new Uint8Array(chunk).buffer;
                        return [2 /*return*/, {
                                value: buffer,
                                done: false
                            }];
                }
            });
        });
    };
    PDFNodeStreamFsRangeReader.prototype.cancel = function (reason) {
        if (!this._readableStream) {
            this._error(reason);
            return;
        }
        this._readableStream.destroy(reason);
    };
    PDFNodeStreamFsRangeReader.prototype._error = function (reason) {
        this._storedError = reason;
        this._readCapability.resolve();
    };
    PDFNodeStreamFsRangeReader.prototype._setReadableStream = function (readableStream) {
        var _this = this;
        this._readableStream = readableStream;
        readableStream.on("readable", function () {
            _this._readCapability.resolve();
        });
        readableStream.on("end", function () {
            readableStream.destroy();
            _this._done = true;
            _this._readCapability.resolve();
        });
        readableStream.on("error", function (reason) {
            _this._error(reason);
        });
        if (this._storedError) {
            this._readableStream.destroy(this._storedError);
        }
    };
    return PDFNodeStreamFsRangeReader;
}());
; // ./src/display/text_layer.js
var MAX_TEXT_DIVS_TO_RENDER = 100000;
var DEFAULT_FONT_SIZE = 30;
var TextLayer = /** @class */ (function () {
    function TextLayer(_l) {
        var textContentSource = _l.textContentSource, container = _l.container, viewport = _l.viewport;
        var _this = this;
        var _m;
        _TextLayer_instances.add(this);
        _TextLayer_capability.set(this, Promise.withResolvers());
        _TextLayer_container.set(this, null);
        _TextLayer_disableProcessItems.set(this, false);
        _TextLayer_fontInspectorEnabled.set(this, !!((_m = globalThis.FontInspector) === null || _m === void 0 ? void 0 : _m.enabled));
        _TextLayer_lang.set(this, null);
        _TextLayer_layoutTextParams.set(this, null);
        _TextLayer_pageHeight.set(this, 0);
        _TextLayer_pageWidth.set(this, 0);
        _TextLayer_reader.set(this, null);
        _TextLayer_rootContainer.set(this, null);
        _TextLayer_rotation.set(this, 0);
        _TextLayer_scale.set(this, 0);
        _TextLayer_styleCache.set(this, Object.create(null));
        _TextLayer_textContentItemsStr.set(this, []);
        _TextLayer_textContentSource.set(this, null);
        _TextLayer_textDivs.set(this, []);
        _TextLayer_textDivProperties.set(this, new WeakMap());
        _TextLayer_transform.set(this, null);
        if (textContentSource instanceof ReadableStream) {
            __classPrivateFieldSet(this, _TextLayer_textContentSource, textContentSource, "f");
        }
        else if (typeof textContentSource === "object") {
            __classPrivateFieldSet(this, _TextLayer_textContentSource, new ReadableStream({
                start: function (controller) {
                    controller.enqueue(textContentSource);
                    controller.close();
                }
            }), "f");
        }
        else {
            throw new Error('No "textContentSource" parameter specified.');
        }
        __classPrivateFieldSet(this, _TextLayer_container, __classPrivateFieldSet(this, _TextLayer_rootContainer, container, "f"), "f");
        __classPrivateFieldSet(this, _TextLayer_scale, viewport.scale * OutputScale.pixelRatio, "f");
        __classPrivateFieldSet(this, _TextLayer_rotation, viewport.rotation, "f");
        __classPrivateFieldSet(this, _TextLayer_layoutTextParams, {
            div: null,
            properties: null,
            ctx: null
        }, "f");
        var _o = viewport.rawDims, pageWidth = _o.pageWidth, pageHeight = _o.pageHeight, pageX = _o.pageX, pageY = _o.pageY;
        __classPrivateFieldSet(this, _TextLayer_transform, [1, 0, 0, -1, -pageX, pageY + pageHeight], "f");
        __classPrivateFieldSet(this, _TextLayer_pageWidth, pageWidth, "f");
        __classPrivateFieldSet(this, _TextLayer_pageHeight, pageHeight, "f");
        __classPrivateFieldGet(_k, _k, "m", _TextLayer_ensureMinFontSizeComputed).call(_k);
        setLayerDimensions(container, viewport);
        __classPrivateFieldGet(this, _TextLayer_capability, "f").promise.finally(function () {
            __classPrivateFieldGet(_k, _k, "f", _TextLayer_pendingTextLayers).delete(_this);
            __classPrivateFieldSet(_this, _TextLayer_layoutTextParams, null, "f");
            __classPrivateFieldSet(_this, _TextLayer_styleCache, null, "f");
        }).catch(function () { });
    }
    Object.defineProperty(TextLayer, "fontFamilyMap", {
        get: function () {
            var _l = util_FeatureTest.platform, isWindows = _l.isWindows, isFirefox = _l.isFirefox;
            return shadow(this, "fontFamilyMap", new Map([["sans-serif", "".concat(isWindows && isFirefox ? "Calibri, " : "", "sans-serif")], ["monospace", "".concat(isWindows && isFirefox ? "Lucida Console, " : "", "monospace")]]));
        },
        enumerable: false,
        configurable: true
    });
    TextLayer.prototype.render = function () {
        var _this = this;
        var pump = function () {
            __classPrivateFieldGet(_this, _TextLayer_reader, "f").read().then(function (_l) {
                var _m;
                var value = _l.value, done = _l.done;
                if (done) {
                    __classPrivateFieldGet(_this, _TextLayer_capability, "f").resolve();
                    return;
                }
                __classPrivateFieldSet(_this, _TextLayer_lang, (_m = __classPrivateFieldGet(_this, _TextLayer_lang, "f")) !== null && _m !== void 0 ? _m : value.lang, "f");
                Object.assign(__classPrivateFieldGet(_this, _TextLayer_styleCache, "f"), value.styles);
                __classPrivateFieldGet(_this, _TextLayer_instances, "m", _TextLayer_processItems).call(_this, value.items);
                pump();
            }, __classPrivateFieldGet(_this, _TextLayer_capability, "f").reject);
        };
        __classPrivateFieldSet(this, _TextLayer_reader, __classPrivateFieldGet(this, _TextLayer_textContentSource, "f").getReader(), "f");
        __classPrivateFieldGet(_k, _k, "f", _TextLayer_pendingTextLayers).add(this);
        pump();
        return __classPrivateFieldGet(this, _TextLayer_capability, "f").promise;
    };
    TextLayer.prototype.update = function (_l) {
        var e_110, _m;
        var viewport = _l.viewport, _o = _l.onBefore, onBefore = _o === void 0 ? null : _o;
        var scale = viewport.scale * OutputScale.pixelRatio;
        var rotation = viewport.rotation;
        if (rotation !== __classPrivateFieldGet(this, _TextLayer_rotation, "f")) {
            onBefore === null || onBefore === void 0 ? void 0 : onBefore();
            __classPrivateFieldSet(this, _TextLayer_rotation, rotation, "f");
            setLayerDimensions(__classPrivateFieldGet(this, _TextLayer_rootContainer, "f"), {
                rotation: rotation
            });
        }
        if (scale !== __classPrivateFieldGet(this, _TextLayer_scale, "f")) {
            onBefore === null || onBefore === void 0 ? void 0 : onBefore();
            __classPrivateFieldSet(this, _TextLayer_scale, scale, "f");
            var params = {
                div: null,
                properties: null,
                ctx: __classPrivateFieldGet(_k, _k, "m", _TextLayer_getCtx).call(_k, __classPrivateFieldGet(this, _TextLayer_lang, "f"))
            };
            try {
                for (var _p = __values(__classPrivateFieldGet(this, _TextLayer_textDivs, "f")), _q = _p.next(); !_q.done; _q = _p.next()) {
                    var div = _q.value;
                    params.properties = __classPrivateFieldGet(this, _TextLayer_textDivProperties, "f").get(div);
                    params.div = div;
                    __classPrivateFieldGet(this, _TextLayer_instances, "m", _TextLayer_layout).call(this, params);
                }
            }
            catch (e_110_1) { e_110 = { error: e_110_1 }; }
            finally {
                try {
                    if (_q && !_q.done && (_m = _p.return)) _m.call(_p);
                }
                finally { if (e_110) throw e_110.error; }
            }
        }
    };
    TextLayer.prototype.cancel = function () {
        var _l;
        var abortEx = new AbortException("TextLayer task cancelled.");
        (_l = __classPrivateFieldGet(this, _TextLayer_reader, "f")) === null || _l === void 0 ? void 0 : _l.cancel(abortEx).catch(function () { });
        __classPrivateFieldSet(this, _TextLayer_reader, null, "f");
        __classPrivateFieldGet(this, _TextLayer_capability, "f").reject(abortEx);
    };
    Object.defineProperty(TextLayer.prototype, "textDivs", {
        get: function () {
            return __classPrivateFieldGet(this, _TextLayer_textDivs, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(TextLayer.prototype, "textContentItemsStr", {
        get: function () {
            return __classPrivateFieldGet(this, _TextLayer_textContentItemsStr, "f");
        },
        enumerable: false,
        configurable: true
    });
    TextLayer.cleanup = function () {
        var e_111, _l;
        if (__classPrivateFieldGet(this, _k, "f", _TextLayer_pendingTextLayers).size > 0) {
            return;
        }
        __classPrivateFieldGet(this, _k, "f", _TextLayer_ascentCache).clear();
        try {
            for (var _m = __values(__classPrivateFieldGet(this, _k, "f", _TextLayer_canvasContexts).values()), _o = _m.next(); !_o.done; _o = _m.next()) {
                var canvas = _o.value.canvas;
                canvas.remove();
            }
        }
        catch (e_111_1) { e_111 = { error: e_111_1 }; }
        finally {
            try {
                if (_o && !_o.done && (_l = _m.return)) _l.call(_m);
            }
            finally { if (e_111) throw e_111.error; }
        }
        __classPrivateFieldGet(this, _k, "f", _TextLayer_canvasContexts).clear();
    };
    var _TextLayer_instances, _k, _TextLayer_capability, _TextLayer_container, _TextLayer_disableProcessItems, _TextLayer_fontInspectorEnabled, _TextLayer_lang, _TextLayer_layoutTextParams, _TextLayer_pageHeight, _TextLayer_pageWidth, _TextLayer_reader, _TextLayer_rootContainer, _TextLayer_rotation, _TextLayer_scale, _TextLayer_styleCache, _TextLayer_textContentItemsStr, _TextLayer_textContentSource, _TextLayer_textDivs, _TextLayer_textDivProperties, _TextLayer_transform, _TextLayer_ascentCache, _TextLayer_canvasContexts, _TextLayer_canvasCtxFonts, _TextLayer_minFontSize, _TextLayer_pendingTextLayers, _TextLayer_processItems, _TextLayer_appendText, _TextLayer_layout, _TextLayer_getCtx, _TextLayer_ensureCtxFont, _TextLayer_ensureMinFontSizeComputed, _TextLayer_getAscent;
    _k = TextLayer, _TextLayer_capability = new WeakMap(), _TextLayer_container = new WeakMap(), _TextLayer_disableProcessItems = new WeakMap(), _TextLayer_fontInspectorEnabled = new WeakMap(), _TextLayer_lang = new WeakMap(), _TextLayer_layoutTextParams = new WeakMap(), _TextLayer_pageHeight = new WeakMap(), _TextLayer_pageWidth = new WeakMap(), _TextLayer_reader = new WeakMap(), _TextLayer_rootContainer = new WeakMap(), _TextLayer_rotation = new WeakMap(), _TextLayer_scale = new WeakMap(), _TextLayer_styleCache = new WeakMap(), _TextLayer_textContentItemsStr = new WeakMap(), _TextLayer_textContentSource = new WeakMap(), _TextLayer_textDivs = new WeakMap(), _TextLayer_textDivProperties = new WeakMap(), _TextLayer_transform = new WeakMap(), _TextLayer_instances = new WeakSet(), _TextLayer_processItems = function _TextLayer_processItems(items) {
        var e_112, _l;
        var _m;
        var _o;
        if (__classPrivateFieldGet(this, _TextLayer_disableProcessItems, "f")) {
            return;
        }
        (_m = (_o = __classPrivateFieldGet(this, _TextLayer_layoutTextParams, "f")).ctx) !== null && _m !== void 0 ? _m : (_o.ctx = __classPrivateFieldGet(_k, _k, "m", _TextLayer_getCtx).call(_k, __classPrivateFieldGet(this, _TextLayer_lang, "f")));
        var textDivs = __classPrivateFieldGet(this, _TextLayer_textDivs, "f"), textContentItemsStr = __classPrivateFieldGet(this, _TextLayer_textContentItemsStr, "f");
        try {
            for (var items_1 = __values(items), items_1_1 = items_1.next(); !items_1_1.done; items_1_1 = items_1.next()) {
                var item = items_1_1.value;
                if (textDivs.length > MAX_TEXT_DIVS_TO_RENDER) {
                    warn("Ignoring additional textDivs for performance reasons.");
                    __classPrivateFieldSet(this, _TextLayer_disableProcessItems, true, "f");
                    return;
                }
                if (item.str === undefined) {
                    if (item.type === "beginMarkedContentProps" || item.type === "beginMarkedContent") {
                        var parent = __classPrivateFieldGet(this, _TextLayer_container, "f");
                        __classPrivateFieldSet(this, _TextLayer_container, document.createElement("span"), "f");
                        __classPrivateFieldGet(this, _TextLayer_container, "f").classList.add("markedContent");
                        if (item.id !== null) {
                            __classPrivateFieldGet(this, _TextLayer_container, "f").setAttribute("id", "".concat(item.id));
                        }
                        parent.append(__classPrivateFieldGet(this, _TextLayer_container, "f"));
                    }
                    else if (item.type === "endMarkedContent") {
                        __classPrivateFieldSet(this, _TextLayer_container, __classPrivateFieldGet(this, _TextLayer_container, "f").parentNode, "f");
                    }
                    continue;
                }
                textContentItemsStr.push(item.str);
                __classPrivateFieldGet(this, _TextLayer_instances, "m", _TextLayer_appendText).call(this, item);
            }
        }
        catch (e_112_1) { e_112 = { error: e_112_1 }; }
        finally {
            try {
                if (items_1_1 && !items_1_1.done && (_l = items_1.return)) _l.call(items_1);
            }
            finally { if (e_112) throw e_112.error; }
        }
    }, _TextLayer_appendText = function _TextLayer_appendText(geom) {
        var textDiv = document.createElement("span");
        var textDivProperties = {
            angle: 0,
            canvasWidth: 0,
            hasText: geom.str !== "",
            hasEOL: geom.hasEOL,
            fontSize: 0
        };
        __classPrivateFieldGet(this, _TextLayer_textDivs, "f").push(textDiv);
        var tx = Util.transform(__classPrivateFieldGet(this, _TextLayer_transform, "f"), geom.transform);
        var angle = Math.atan2(tx[1], tx[0]);
        var style = __classPrivateFieldGet(this, _TextLayer_styleCache, "f")[geom.fontName];
        if (style.vertical) {
            angle += Math.PI / 2;
        }
        var fontFamily = __classPrivateFieldGet(this, _TextLayer_fontInspectorEnabled, "f") && style.fontSubstitution || style.fontFamily;
        fontFamily = _k.fontFamilyMap.get(fontFamily) || fontFamily;
        var fontHeight = Math.hypot(tx[2], tx[3]);
        var fontAscent = fontHeight * __classPrivateFieldGet(_k, _k, "m", _TextLayer_getAscent).call(_k, fontFamily, style, __classPrivateFieldGet(this, _TextLayer_lang, "f"));
        var left, top;
        if (angle === 0) {
            left = tx[4];
            top = tx[5] - fontAscent;
        }
        else {
            left = tx[4] + fontAscent * Math.sin(angle);
            top = tx[5] - fontAscent * Math.cos(angle);
        }
        var scaleFactorStr = "calc(var(--total-scale-factor) *";
        var divStyle = textDiv.style;
        if (__classPrivateFieldGet(this, _TextLayer_container, "f") === __classPrivateFieldGet(this, _TextLayer_rootContainer, "f")) {
            divStyle.left = "".concat((100 * left / __classPrivateFieldGet(this, _TextLayer_pageWidth, "f")).toFixed(2), "%");
            divStyle.top = "".concat((100 * top / __classPrivateFieldGet(this, _TextLayer_pageHeight, "f")).toFixed(2), "%");
        }
        else {
            divStyle.left = "".concat(scaleFactorStr).concat(left.toFixed(2), "px)");
            divStyle.top = "".concat(scaleFactorStr).concat(top.toFixed(2), "px)");
        }
        divStyle.fontSize = "".concat(scaleFactorStr).concat((__classPrivateFieldGet(_k, _k, "f", _TextLayer_minFontSize) * fontHeight).toFixed(2), "px)");
        divStyle.fontFamily = fontFamily;
        textDivProperties.fontSize = fontHeight;
        textDiv.setAttribute("role", "presentation");
        textDiv.textContent = geom.str;
        textDiv.dir = geom.dir;
        if (__classPrivateFieldGet(this, _TextLayer_fontInspectorEnabled, "f")) {
            textDiv.dataset.fontName = style.fontSubstitutionLoadedName || geom.fontName;
        }
        if (angle !== 0) {
            textDivProperties.angle = angle * (180 / Math.PI);
        }
        var shouldScaleText = false;
        if (geom.str.length > 1) {
            shouldScaleText = true;
        }
        else if (geom.str !== " " && geom.transform[0] !== geom.transform[3]) {
            var absScaleX = Math.abs(geom.transform[0]), absScaleY = Math.abs(geom.transform[3]);
            if (absScaleX !== absScaleY && Math.max(absScaleX, absScaleY) / Math.min(absScaleX, absScaleY) > 1.5) {
                shouldScaleText = true;
            }
        }
        if (shouldScaleText) {
            textDivProperties.canvasWidth = style.vertical ? geom.height : geom.width;
        }
        __classPrivateFieldGet(this, _TextLayer_textDivProperties, "f").set(textDiv, textDivProperties);
        __classPrivateFieldGet(this, _TextLayer_layoutTextParams, "f").div = textDiv;
        __classPrivateFieldGet(this, _TextLayer_layoutTextParams, "f").properties = textDivProperties;
        __classPrivateFieldGet(this, _TextLayer_instances, "m", _TextLayer_layout).call(this, __classPrivateFieldGet(this, _TextLayer_layoutTextParams, "f"));
        if (textDivProperties.hasText) {
            __classPrivateFieldGet(this, _TextLayer_container, "f").append(textDiv);
        }
        if (textDivProperties.hasEOL) {
            var br = document.createElement("br");
            br.setAttribute("role", "presentation");
            __classPrivateFieldGet(this, _TextLayer_container, "f").append(br);
        }
    }, _TextLayer_layout = function _TextLayer_layout(params) {
        var div = params.div, properties = params.properties, ctx = params.ctx;
        var style = div.style;
        var transform = "";
        if (__classPrivateFieldGet(_k, _k, "f", _TextLayer_minFontSize) > 1) {
            transform = "scale(".concat(1 / __classPrivateFieldGet(_k, _k, "f", _TextLayer_minFontSize), ")");
        }
        if (properties.canvasWidth !== 0 && properties.hasText) {
            var fontFamily = style.fontFamily;
            var canvasWidth = properties.canvasWidth, fontSize = properties.fontSize;
            __classPrivateFieldGet(_k, _k, "m", _TextLayer_ensureCtxFont).call(_k, ctx, fontSize * __classPrivateFieldGet(this, _TextLayer_scale, "f"), fontFamily);
            var width = ctx.measureText(div.textContent).width;
            if (width > 0) {
                transform = "scaleX(".concat(canvasWidth * __classPrivateFieldGet(this, _TextLayer_scale, "f") / width, ") ").concat(transform);
            }
        }
        if (properties.angle !== 0) {
            transform = "rotate(".concat(properties.angle, "deg) ").concat(transform);
        }
        if (transform.length > 0) {
            style.transform = transform;
        }
    }, _TextLayer_getCtx = function _TextLayer_getCtx(lang) {
        if (lang === void 0) { lang = null; }
        var ctx = __classPrivateFieldGet(this, _k, "f", _TextLayer_canvasContexts).get(lang || (lang = ""));
        if (!ctx) {
            var canvas = document.createElement("canvas");
            canvas.className = "hiddenCanvasElement";
            canvas.lang = lang;
            document.body.append(canvas);
            ctx = canvas.getContext("2d", {
                alpha: false,
                willReadFrequently: true
            });
            __classPrivateFieldGet(this, _k, "f", _TextLayer_canvasContexts).set(lang, ctx);
            __classPrivateFieldGet(this, _k, "f", _TextLayer_canvasCtxFonts).set(ctx, {
                size: 0,
                family: ""
            });
        }
        return ctx;
    }, _TextLayer_ensureCtxFont = function _TextLayer_ensureCtxFont(ctx, size, family) {
        var cached = __classPrivateFieldGet(this, _k, "f", _TextLayer_canvasCtxFonts).get(ctx);
        if (size === cached.size && family === cached.family) {
            return;
        }
        ctx.font = "".concat(size, "px ").concat(family);
        cached.size = size;
        cached.family = family;
    }, _TextLayer_ensureMinFontSizeComputed = function _TextLayer_ensureMinFontSizeComputed() {
        if (__classPrivateFieldGet(this, _k, "f", _TextLayer_minFontSize) !== null) {
            return;
        }
        var div = document.createElement("div");
        div.style.opacity = 0;
        div.style.lineHeight = 1;
        div.style.fontSize = "1px";
        div.style.position = "absolute";
        div.textContent = "X";
        document.body.append(div);
        __classPrivateFieldSet(this, _k, div.getBoundingClientRect().height, "f", _TextLayer_minFontSize);
        div.remove();
    }, _TextLayer_getAscent = function _TextLayer_getAscent(fontFamily, style, lang) {
        var cachedAscent = __classPrivateFieldGet(this, _k, "f", _TextLayer_ascentCache).get(fontFamily);
        if (cachedAscent) {
            return cachedAscent;
        }
        var ctx = __classPrivateFieldGet(this, _k, "m", _TextLayer_getCtx).call(this, lang);
        ctx.canvas.width = ctx.canvas.height = DEFAULT_FONT_SIZE;
        __classPrivateFieldGet(this, _k, "m", _TextLayer_ensureCtxFont).call(this, ctx, DEFAULT_FONT_SIZE, fontFamily);
        var metrics = ctx.measureText("");
        var ascent = metrics.fontBoundingBoxAscent;
        var descent = Math.abs(metrics.fontBoundingBoxDescent);
        ctx.canvas.width = ctx.canvas.height = 0;
        var ratio = 0.8;
        if (ascent) {
            ratio = ascent / (ascent + descent);
        }
        else {
            if (util_FeatureTest.platform.isFirefox) {
                warn("Enable the `dom.textMetrics.fontBoundingBox.enabled` preference " + "in `about:config` to improve TextLayer rendering.");
            }
            if (style.ascent) {
                ratio = style.ascent;
            }
            else if (style.descent) {
                ratio = 1 + style.descent;
            }
        }
        __classPrivateFieldGet(this, _k, "f", _TextLayer_ascentCache).set(fontFamily, ratio);
        return ratio;
    };
    _TextLayer_ascentCache = { value: new Map() };
    _TextLayer_canvasContexts = { value: new Map() };
    _TextLayer_canvasCtxFonts = { value: new WeakMap() };
    _TextLayer_minFontSize = { value: null };
    _TextLayer_pendingTextLayers = { value: new Set() };
    return TextLayer;
}());
; // ./src/display/xfa_text.js
var XfaText = /** @class */ (function () {
    function XfaText() {
    }
    XfaText.textContent = function (xfa) {
        var items = [];
        var output = {
            items: items,
            styles: Object.create(null)
        };
        function walk(node) {
            var e_113, _l;
            var _m;
            if (!node) {
                return;
            }
            var str = null;
            var name = node.name;
            if (name === "#text") {
                str = node.value;
            }
            else if (!XfaText.shouldBuildText(name)) {
                return;
            }
            else if ((_m = node === null || node === void 0 ? void 0 : node.attributes) === null || _m === void 0 ? void 0 : _m.textContent) {
                str = node.attributes.textContent;
            }
            else if (node.value) {
                str = node.value;
            }
            if (str !== null) {
                items.push({
                    str: str
                });
            }
            if (!node.children) {
                return;
            }
            try {
                for (var _o = __values(node.children), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var child = _p.value;
                    walk(child);
                }
            }
            catch (e_113_1) { e_113 = { error: e_113_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_l = _o.return)) _l.call(_o);
                }
                finally { if (e_113) throw e_113.error; }
            }
        }
        walk(xfa);
        return output;
    };
    XfaText.shouldBuildText = function (name) {
        return !(name === "textarea" || name === "input" || name === "option" || name === "select");
    };
    return XfaText;
}());
; // ./src/display/api.js
var DEFAULT_RANGE_CHUNK_SIZE = 65536;
var RENDERING_CANCELLED_TIMEOUT = 100;
function getDocument(src) {
    var _l, _m;
    if (src === void 0) { src = {}; }
    if (typeof src === "string" || src instanceof URL) {
        src = {
            url: src
        };
    }
    else if (src instanceof ArrayBuffer || ArrayBuffer.isView(src)) {
        src = {
            data: src
        };
    }
    var task = new PDFDocumentLoadingTask();
    var docId = task.docId;
    var url = src.url ? getUrlProp(src.url) : null;
    var data = src.data ? getDataProp(src.data) : null;
    var httpHeaders = src.httpHeaders || null;
    var withCredentials = src.withCredentials === true;
    var password = (_l = src.password) !== null && _l !== void 0 ? _l : null;
    var rangeTransport = src.range instanceof PDFDataRangeTransport ? src.range : null;
    var rangeChunkSize = Number.isInteger(src.rangeChunkSize) && src.rangeChunkSize > 0 ? src.rangeChunkSize : DEFAULT_RANGE_CHUNK_SIZE;
    var worker = src.worker instanceof PDFWorker ? src.worker : null;
    var verbosity = src.verbosity;
    var docBaseUrl = typeof src.docBaseUrl === "string" && !isDataScheme(src.docBaseUrl) ? src.docBaseUrl : null;
    var cMapUrl = getFactoryUrlProp(src.cMapUrl);
    var cMapPacked = src.cMapPacked !== false;
    var CMapReaderFactory = src.CMapReaderFactory || (isNodeJS ? NodeCMapReaderFactory : DOMCMapReaderFactory);
    var iccUrl = getFactoryUrlProp(src.iccUrl);
    var standardFontDataUrl = getFactoryUrlProp(src.standardFontDataUrl);
    var StandardFontDataFactory = src.StandardFontDataFactory || (isNodeJS ? NodeStandardFontDataFactory : DOMStandardFontDataFactory);
    var wasmUrl = getFactoryUrlProp(src.wasmUrl);
    var WasmFactory = src.WasmFactory || (isNodeJS ? NodeWasmFactory : DOMWasmFactory);
    var ignoreErrors = src.stopAtErrors !== true;
    var maxImageSize = Number.isInteger(src.maxImageSize) && src.maxImageSize > -1 ? src.maxImageSize : -1;
    var isEvalSupported = src.isEvalSupported !== false;
    var isOffscreenCanvasSupported = typeof src.isOffscreenCanvasSupported === "boolean" ? src.isOffscreenCanvasSupported : !isNodeJS;
    var isImageDecoderSupported = typeof src.isImageDecoderSupported === "boolean" ? src.isImageDecoderSupported : !isNodeJS && (util_FeatureTest.platform.isFirefox || !globalThis.chrome);
    var canvasMaxAreaInBytes = Number.isInteger(src.canvasMaxAreaInBytes) ? src.canvasMaxAreaInBytes : -1;
    var disableFontFace = typeof src.disableFontFace === "boolean" ? src.disableFontFace : isNodeJS;
    var fontExtraProperties = src.fontExtraProperties === true;
    var enableXfa = src.enableXfa === true;
    var ownerDocument = src.ownerDocument || globalThis.document;
    var disableRange = src.disableRange === true;
    var disableStream = src.disableStream === true;
    var disableAutoFetch = src.disableAutoFetch === true;
    var pdfBug = src.pdfBug === true;
    var CanvasFactory = src.CanvasFactory || (isNodeJS ? NodeCanvasFactory : DOMCanvasFactory);
    var FilterFactory = src.FilterFactory || (isNodeJS ? NodeFilterFactory : DOMFilterFactory);
    var enableHWA = src.enableHWA === true;
    var useWasm = src.useWasm !== false;
    var length = rangeTransport ? rangeTransport.length : (_m = src.length) !== null && _m !== void 0 ? _m : NaN;
    var useSystemFonts = typeof src.useSystemFonts === "boolean" ? src.useSystemFonts : !isNodeJS && !disableFontFace;
    var useWorkerFetch = typeof src.useWorkerFetch === "boolean" ? src.useWorkerFetch : !!(CMapReaderFactory === DOMCMapReaderFactory && StandardFontDataFactory === DOMStandardFontDataFactory && WasmFactory === DOMWasmFactory && cMapUrl && standardFontDataUrl && wasmUrl && isValidFetchUrl(cMapUrl, document.baseURI) && isValidFetchUrl(standardFontDataUrl, document.baseURI) && isValidFetchUrl(wasmUrl, document.baseURI));
    var styleElement = null;
    setVerbosityLevel(verbosity);
    var transportFactory = {
        canvasFactory: new CanvasFactory({
            ownerDocument: ownerDocument,
            enableHWA: enableHWA
        }),
        filterFactory: new FilterFactory({
            docId: docId,
            ownerDocument: ownerDocument
        }),
        cMapReaderFactory: useWorkerFetch ? null : new CMapReaderFactory({
            baseUrl: cMapUrl,
            isCompressed: cMapPacked
        }),
        standardFontDataFactory: useWorkerFetch ? null : new StandardFontDataFactory({
            baseUrl: standardFontDataUrl
        }),
        wasmFactory: useWorkerFetch ? null : new WasmFactory({
            baseUrl: wasmUrl
        })
    };
    if (!worker) {
        var workerParams = {
            verbosity: verbosity,
            port: GlobalWorkerOptions.workerPort
        };
        worker = workerParams.port ? PDFWorker.fromPort(workerParams) : new PDFWorker(workerParams);
        task._worker = worker;
    }
    var docParams = {
        docId: docId,
        apiVersion: "5.2.133",
        data: data,
        password: password,
        disableAutoFetch: disableAutoFetch,
        rangeChunkSize: rangeChunkSize,
        length: length,
        docBaseUrl: docBaseUrl,
        enableXfa: enableXfa,
        evaluatorOptions: {
            maxImageSize: maxImageSize,
            disableFontFace: disableFontFace,
            ignoreErrors: ignoreErrors,
            isEvalSupported: isEvalSupported,
            isOffscreenCanvasSupported: isOffscreenCanvasSupported,
            isImageDecoderSupported: isImageDecoderSupported,
            canvasMaxAreaInBytes: canvasMaxAreaInBytes,
            fontExtraProperties: fontExtraProperties,
            useSystemFonts: useSystemFonts,
            useWasm: useWasm,
            useWorkerFetch: useWorkerFetch,
            cMapUrl: cMapUrl,
            iccUrl: iccUrl,
            standardFontDataUrl: standardFontDataUrl,
            wasmUrl: wasmUrl
        }
    };
    var transportParams = {
        ownerDocument: ownerDocument,
        pdfBug: pdfBug,
        styleElement: styleElement,
        loadingParams: {
            disableAutoFetch: disableAutoFetch,
            enableXfa: enableXfa
        }
    };
    worker.promise.then(function () {
        if (task.destroyed) {
            throw new Error("Loading aborted");
        }
        if (worker.destroyed) {
            throw new Error("Worker was destroyed");
        }
        var workerIdPromise = worker.messageHandler.sendWithPromise("GetDocRequest", docParams, data ? [data.buffer] : null);
        var networkStream;
        if (rangeTransport) {
            networkStream = new PDFDataTransportStream(rangeTransport, {
                disableRange: disableRange,
                disableStream: disableStream
            });
        }
        else if (!data) {
            if (!url) {
                throw new Error("getDocument - no `url` parameter provided.");
            }
            var NetworkStream = void 0;
            if (isNodeJS) {
                if (isValidFetchUrl(url)) {
                    if (typeof fetch === "undefined" || typeof Response === "undefined" || !("body" in Response.prototype)) {
                        throw new Error("getDocument - the Fetch API was disabled in Node.js, see `--no-experimental-fetch`.");
                    }
                    NetworkStream = PDFFetchStream;
                }
                else {
                    NetworkStream = PDFNodeStream;
                }
            }
            else {
                NetworkStream = isValidFetchUrl(url) ? PDFFetchStream : PDFNetworkStream;
            }
            networkStream = new NetworkStream({
                url: url,
                length: length,
                httpHeaders: httpHeaders,
                withCredentials: withCredentials,
                rangeChunkSize: rangeChunkSize,
                disableRange: disableRange,
                disableStream: disableStream
            });
        }
        return workerIdPromise.then(function (workerId) {
            if (task.destroyed) {
                throw new Error("Loading aborted");
            }
            if (worker.destroyed) {
                throw new Error("Worker was destroyed");
            }
            var messageHandler = new MessageHandler(docId, workerId, worker.port);
            var transport = new WorkerTransport(messageHandler, task, networkStream, transportParams, transportFactory);
            task._transport = transport;
            messageHandler.send("Ready", null);
        });
    }).catch(task._capability.reject);
    return task;
}
function getUrlProp(val) {
    if (val instanceof URL) {
        return val.href;
    }
    if (typeof val === "string") {
        if (isNodeJS) {
            return val;
        }
        var url = URL.parse(val, window.location);
        if (url) {
            return url.href;
        }
    }
    throw new Error("Invalid PDF url data: " + "either string or URL-object is expected in the url property.");
}
function getDataProp(val) {
    if (isNodeJS && typeof Buffer !== "undefined" && val instanceof Buffer) {
        throw new Error("Please provide binary data as `Uint8Array`, rather than `Buffer`.");
    }
    if (val instanceof Uint8Array && val.byteLength === val.buffer.byteLength) {
        return val;
    }
    if (typeof val === "string") {
        return stringToBytes(val);
    }
    if (val instanceof ArrayBuffer || ArrayBuffer.isView(val) || typeof val === "object" && !isNaN(val === null || val === void 0 ? void 0 : val.length)) {
        return new Uint8Array(val);
    }
    throw new Error("Invalid PDF binary data: either TypedArray, " + "string, or array-like object is expected in the data property.");
}
function getFactoryUrlProp(val) {
    if (typeof val !== "string") {
        return null;
    }
    if (val.endsWith("/")) {
        return val;
    }
    throw new Error("Invalid factory url: \"".concat(val, "\" must include trailing slash."));
}
var isRefProxy = function (v) { return typeof v === "object" && Number.isInteger(v === null || v === void 0 ? void 0 : v.num) && v.num >= 0 && Number.isInteger(v === null || v === void 0 ? void 0 : v.gen) && v.gen >= 0; };
var isNameProxy = function (v) { return typeof v === "object" && typeof (v === null || v === void 0 ? void 0 : v.name) === "string"; };
var isValidExplicitDest = _isValidExplicitDest.bind(null, isRefProxy, isNameProxy);
var PDFDocumentLoadingTask = /** @class */ (function () {
    function PDFDocumentLoadingTask() {
        var _m, _o, _p;
        this._capability = Promise.withResolvers();
        this._transport = null;
        this._worker = null;
        this.docId = "d".concat((__classPrivateFieldSet(_m = _l, _l, (_p = __classPrivateFieldGet(_m, _l, "f", _PDFDocumentLoadingTask_docId), _o = _p++, _p), "f", _PDFDocumentLoadingTask_docId), _o));
        this.destroyed = false;
        this.onPassword = null;
        this.onProgress = null;
    }
    Object.defineProperty(PDFDocumentLoadingTask.prototype, "promise", {
        get: function () {
            return this._capability.promise;
        },
        enumerable: false,
        configurable: true
    });
    PDFDocumentLoadingTask.prototype.destroy = function () {
        return __awaiter(this, void 0, void 0, function () {
            var ex_3;
            var _m, _o, _p, _q;
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        this.destroyed = true;
                        _r.label = 1;
                    case 1:
                        _r.trys.push([1, 3, , 4]);
                        if ((_m = this._worker) === null || _m === void 0 ? void 0 : _m.port) {
                            this._worker._pendingDestroy = true;
                        }
                        return [4 /*yield*/, ((_o = this._transport) === null || _o === void 0 ? void 0 : _o.destroy())];
                    case 2:
                        _r.sent();
                        return [3 /*break*/, 4];
                    case 3:
                        ex_3 = _r.sent();
                        if ((_p = this._worker) === null || _p === void 0 ? void 0 : _p.port) {
                            delete this._worker._pendingDestroy;
                        }
                        throw ex_3;
                    case 4:
                        this._transport = null;
                        (_q = this._worker) === null || _q === void 0 ? void 0 : _q.destroy();
                        this._worker = null;
                        return [2 /*return*/];
                }
            });
        });
    };
    PDFDocumentLoadingTask.prototype.getData = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_m) {
                return [2 /*return*/, this._transport.getData()];
            });
        });
    };
    var _l, _PDFDocumentLoadingTask_docId;
    _l = PDFDocumentLoadingTask;
    _PDFDocumentLoadingTask_docId = { value: 0 };
    return PDFDocumentLoadingTask;
}());
var PDFDataRangeTransport = /** @class */ (function () {
    function PDFDataRangeTransport(length, initialData, progressiveDone, contentDispositionFilename) {
        if (progressiveDone === void 0) { progressiveDone = false; }
        if (contentDispositionFilename === void 0) { contentDispositionFilename = null; }
        this.length = length;
        this.initialData = initialData;
        this.progressiveDone = progressiveDone;
        this.contentDispositionFilename = contentDispositionFilename;
        this._rangeListeners = [];
        this._progressListeners = [];
        this._progressiveReadListeners = [];
        this._progressiveDoneListeners = [];
        this._readyCapability = Promise.withResolvers();
    }
    PDFDataRangeTransport.prototype.addRangeListener = function (listener) {
        this._rangeListeners.push(listener);
    };
    PDFDataRangeTransport.prototype.addProgressListener = function (listener) {
        this._progressListeners.push(listener);
    };
    PDFDataRangeTransport.prototype.addProgressiveReadListener = function (listener) {
        this._progressiveReadListeners.push(listener);
    };
    PDFDataRangeTransport.prototype.addProgressiveDoneListener = function (listener) {
        this._progressiveDoneListeners.push(listener);
    };
    PDFDataRangeTransport.prototype.onDataRange = function (begin, chunk) {
        var e_114, _m;
        try {
            for (var _o = __values(this._rangeListeners), _p = _o.next(); !_p.done; _p = _o.next()) {
                var listener = _p.value;
                listener(begin, chunk);
            }
        }
        catch (e_114_1) { e_114 = { error: e_114_1 }; }
        finally {
            try {
                if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
            }
            finally { if (e_114) throw e_114.error; }
        }
    };
    PDFDataRangeTransport.prototype.onDataProgress = function (loaded, total) {
        var _this = this;
        this._readyCapability.promise.then(function () {
            var e_115, _m;
            try {
                for (var _o = __values(_this._progressListeners), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var listener = _p.value;
                    listener(loaded, total);
                }
            }
            catch (e_115_1) { e_115 = { error: e_115_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
                }
                finally { if (e_115) throw e_115.error; }
            }
        });
    };
    PDFDataRangeTransport.prototype.onDataProgressiveRead = function (chunk) {
        var _this = this;
        this._readyCapability.promise.then(function () {
            var e_116, _m;
            try {
                for (var _o = __values(_this._progressiveReadListeners), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var listener = _p.value;
                    listener(chunk);
                }
            }
            catch (e_116_1) { e_116 = { error: e_116_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
                }
                finally { if (e_116) throw e_116.error; }
            }
        });
    };
    PDFDataRangeTransport.prototype.onDataProgressiveDone = function () {
        var _this = this;
        this._readyCapability.promise.then(function () {
            var e_117, _m;
            try {
                for (var _o = __values(_this._progressiveDoneListeners), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var listener = _p.value;
                    listener();
                }
            }
            catch (e_117_1) { e_117 = { error: e_117_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
                }
                finally { if (e_117) throw e_117.error; }
            }
        });
    };
    PDFDataRangeTransport.prototype.transportReady = function () {
        this._readyCapability.resolve();
    };
    PDFDataRangeTransport.prototype.requestDataRange = function (begin, end) {
        unreachable("Abstract method PDFDataRangeTransport.requestDataRange");
    };
    PDFDataRangeTransport.prototype.abort = function () { };
    return PDFDataRangeTransport;
}());
var PDFDocumentProxy = /** @class */ (function () {
    function PDFDocumentProxy(pdfInfo, transport) {
        this._pdfInfo = pdfInfo;
        this._transport = transport;
    }
    Object.defineProperty(PDFDocumentProxy.prototype, "annotationStorage", {
        get: function () {
            return this._transport.annotationStorage;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDocumentProxy.prototype, "canvasFactory", {
        get: function () {
            return this._transport.canvasFactory;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDocumentProxy.prototype, "filterFactory", {
        get: function () {
            return this._transport.filterFactory;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDocumentProxy.prototype, "numPages", {
        get: function () {
            return this._pdfInfo.numPages;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDocumentProxy.prototype, "fingerprints", {
        get: function () {
            return this._pdfInfo.fingerprints;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDocumentProxy.prototype, "isPureXfa", {
        get: function () {
            return shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDocumentProxy.prototype, "allXfaHtml", {
        get: function () {
            return this._transport._htmlForXfa;
        },
        enumerable: false,
        configurable: true
    });
    PDFDocumentProxy.prototype.getPage = function (pageNumber) {
        return this._transport.getPage(pageNumber);
    };
    PDFDocumentProxy.prototype.getPageIndex = function (ref) {
        return this._transport.getPageIndex(ref);
    };
    PDFDocumentProxy.prototype.getDestinations = function () {
        return this._transport.getDestinations();
    };
    PDFDocumentProxy.prototype.getDestination = function (id) {
        return this._transport.getDestination(id);
    };
    PDFDocumentProxy.prototype.getPageLabels = function () {
        return this._transport.getPageLabels();
    };
    PDFDocumentProxy.prototype.getPageLayout = function () {
        return this._transport.getPageLayout();
    };
    PDFDocumentProxy.prototype.getPageMode = function () {
        return this._transport.getPageMode();
    };
    PDFDocumentProxy.prototype.getViewerPreferences = function () {
        return this._transport.getViewerPreferences();
    };
    PDFDocumentProxy.prototype.getOpenAction = function () {
        return this._transport.getOpenAction();
    };
    PDFDocumentProxy.prototype.getAttachments = function () {
        return this._transport.getAttachments();
    };
    PDFDocumentProxy.prototype.getJSActions = function () {
        return this._transport.getDocJSActions();
    };
    PDFDocumentProxy.prototype.getOutline = function () {
        return this._transport.getOutline();
    };
    PDFDocumentProxy.prototype.getOptionalContentConfig = function (_m) {
        var _o = _m === void 0 ? {} : _m, _p = _o.intent, intent = _p === void 0 ? "display" : _p;
        var renderingIntent = this._transport.getRenderingIntent(intent).renderingIntent;
        return this._transport.getOptionalContentConfig(renderingIntent);
    };
    PDFDocumentProxy.prototype.getPermissions = function () {
        return this._transport.getPermissions();
    };
    PDFDocumentProxy.prototype.getMetadata = function () {
        return this._transport.getMetadata();
    };
    PDFDocumentProxy.prototype.getMarkInfo = function () {
        return this._transport.getMarkInfo();
    };
    PDFDocumentProxy.prototype.getData = function () {
        return this._transport.getData();
    };
    PDFDocumentProxy.prototype.saveDocument = function () {
        return this._transport.saveDocument();
    };
    PDFDocumentProxy.prototype.getDownloadInfo = function () {
        return this._transport.downloadInfoCapability.promise;
    };
    PDFDocumentProxy.prototype.cleanup = function (keepLoadedFonts) {
        if (keepLoadedFonts === void 0) { keepLoadedFonts = false; }
        return this._transport.startCleanup(keepLoadedFonts || this.isPureXfa);
    };
    PDFDocumentProxy.prototype.destroy = function () {
        return this.loadingTask.destroy();
    };
    PDFDocumentProxy.prototype.cachedPageNumber = function (ref) {
        return this._transport.cachedPageNumber(ref);
    };
    Object.defineProperty(PDFDocumentProxy.prototype, "loadingParams", {
        get: function () {
            return this._transport.loadingParams;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFDocumentProxy.prototype, "loadingTask", {
        get: function () {
            return this._transport.loadingTask;
        },
        enumerable: false,
        configurable: true
    });
    PDFDocumentProxy.prototype.getFieldObjects = function () {
        return this._transport.getFieldObjects();
    };
    PDFDocumentProxy.prototype.hasJSActions = function () {
        return this._transport.hasJSActions();
    };
    PDFDocumentProxy.prototype.getCalculationOrderIds = function () {
        return this._transport.getCalculationOrderIds();
    };
    return PDFDocumentProxy;
}());
var PDFPageProxy = /** @class */ (function () {
    function PDFPageProxy(pageIndex, pageInfo, transport, pdfBug) {
        if (pdfBug === void 0) { pdfBug = false; }
        _PDFPageProxy_instances.add(this);
        _PDFPageProxy_pendingCleanup.set(this, false);
        this._pageIndex = pageIndex;
        this._pageInfo = pageInfo;
        this._transport = transport;
        this._stats = pdfBug ? new StatTimer() : null;
        this._pdfBug = pdfBug;
        this.commonObjs = transport.commonObjs;
        this.objs = new PDFObjects();
        this._intentStates = new Map();
        this.destroyed = false;
    }
    Object.defineProperty(PDFPageProxy.prototype, "pageNumber", {
        get: function () {
            return this._pageIndex + 1;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFPageProxy.prototype, "rotate", {
        get: function () {
            return this._pageInfo.rotate;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFPageProxy.prototype, "ref", {
        get: function () {
            return this._pageInfo.ref;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFPageProxy.prototype, "userUnit", {
        get: function () {
            return this._pageInfo.userUnit;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFPageProxy.prototype, "view", {
        get: function () {
            return this._pageInfo.view;
        },
        enumerable: false,
        configurable: true
    });
    PDFPageProxy.prototype.getViewport = function (_m) {
        var _o = _m === void 0 ? {} : _m, scale = _o.scale, _p = _o.rotation, rotation = _p === void 0 ? this.rotate : _p, _q = _o.offsetX, offsetX = _q === void 0 ? 0 : _q, _r = _o.offsetY, offsetY = _r === void 0 ? 0 : _r, _s = _o.dontFlip, dontFlip = _s === void 0 ? false : _s;
        return new PageViewport({
            viewBox: this.view,
            userUnit: this.userUnit,
            scale: scale,
            rotation: rotation,
            offsetX: offsetX,
            offsetY: offsetY,
            dontFlip: dontFlip
        });
    };
    PDFPageProxy.prototype.getAnnotations = function (_m) {
        var _o = _m === void 0 ? {} : _m, _p = _o.intent, intent = _p === void 0 ? "display" : _p;
        var renderingIntent = this._transport.getRenderingIntent(intent).renderingIntent;
        return this._transport.getAnnotations(this._pageIndex, renderingIntent);
    };
    PDFPageProxy.prototype.getJSActions = function () {
        return this._transport.getPageJSActions(this._pageIndex);
    };
    Object.defineProperty(PDFPageProxy.prototype, "filterFactory", {
        get: function () {
            return this._transport.filterFactory;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFPageProxy.prototype, "isPureXfa", {
        get: function () {
            return shadow(this, "isPureXfa", !!this._transport._htmlForXfa);
        },
        enumerable: false,
        configurable: true
    });
    PDFPageProxy.prototype.getXfa = function () {
        return __awaiter(this, void 0, void 0, function () {
            var _m;
            return __generator(this, function (_o) {
                return [2 /*return*/, ((_m = this._transport._htmlForXfa) === null || _m === void 0 ? void 0 : _m.children[this._pageIndex]) || null];
            });
        });
    };
    PDFPageProxy.prototype.render = function (_m) {
        var _this = this;
        var _o, _p;
        var canvasContext = _m.canvasContext, viewport = _m.viewport, _q = _m.intent, intent = _q === void 0 ? "display" : _q, _r = _m.annotationMode, annotationMode = _r === void 0 ? AnnotationMode.ENABLE : _r, _s = _m.transform, transform = _s === void 0 ? null : _s, _t = _m.background, background = _t === void 0 ? null : _t, _u = _m.optionalContentConfigPromise, optionalContentConfigPromise = _u === void 0 ? null : _u, _v = _m.annotationCanvasMap, annotationCanvasMap = _v === void 0 ? null : _v, _w = _m.pageColors, pageColors = _w === void 0 ? null : _w, _z = _m.printAnnotationStorage, printAnnotationStorage = _z === void 0 ? null : _z, _0 = _m.isEditing, isEditing = _0 === void 0 ? false : _0;
        (_o = this._stats) === null || _o === void 0 ? void 0 : _o.time("Overall");
        var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing);
        var renderingIntent = intentArgs.renderingIntent, cacheKey = intentArgs.cacheKey;
        __classPrivateFieldSet(this, _PDFPageProxy_pendingCleanup, false, "f");
        optionalContentConfigPromise || (optionalContentConfigPromise = this._transport.getOptionalContentConfig(renderingIntent));
        var intentState = this._intentStates.get(cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(cacheKey, intentState);
        }
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        var intentPrint = !!(renderingIntent & RenderingIntentFlag.PRINT);
        if (!intentState.displayReadyCapability) {
            intentState.displayReadyCapability = Promise.withResolvers();
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            (_p = this._stats) === null || _p === void 0 ? void 0 : _p.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        var complete = function (error) {
            var _m;
            intentState.renderTasks.delete(internalRenderTask);
            if (intentPrint) {
                __classPrivateFieldSet(_this, _PDFPageProxy_pendingCleanup, true, "f");
            }
            __classPrivateFieldGet(_this, _PDFPageProxy_instances, "m", _PDFPageProxy_tryCleanup).call(_this);
            if (error) {
                internalRenderTask.capability.reject(error);
                _this._abortOperatorList({
                    intentState: intentState,
                    reason: error instanceof Error ? error : new Error(error)
                });
            }
            else {
                internalRenderTask.capability.resolve();
            }
            if (_this._stats) {
                _this._stats.timeEnd("Rendering");
                _this._stats.timeEnd("Overall");
                if ((_m = globalThis.Stats) === null || _m === void 0 ? void 0 : _m.enabled) {
                    globalThis.Stats.add(_this.pageNumber, _this._stats);
                }
            }
        };
        var internalRenderTask = new InternalRenderTask({
            callback: complete,
            params: {
                canvasContext: canvasContext,
                viewport: viewport,
                transform: transform,
                background: background
            },
            objs: this.objs,
            commonObjs: this.commonObjs,
            annotationCanvasMap: annotationCanvasMap,
            operatorList: intentState.operatorList,
            pageIndex: this._pageIndex,
            canvasFactory: this._transport.canvasFactory,
            filterFactory: this._transport.filterFactory,
            useRequestAnimationFrame: !intentPrint,
            pdfBug: this._pdfBug,
            pageColors: pageColors
        });
        (intentState.renderTasks || (intentState.renderTasks = new Set())).add(internalRenderTask);
        var renderTask = internalRenderTask.task;
        Promise.all([intentState.displayReadyCapability.promise, optionalContentConfigPromise]).then(function (_m) {
            var _o;
            var _p = __read(_m, 2), transparency = _p[0], optionalContentConfig = _p[1];
            if (_this.destroyed) {
                complete();
                return;
            }
            (_o = _this._stats) === null || _o === void 0 ? void 0 : _o.time("Rendering");
            if (!(optionalContentConfig.renderingIntent & renderingIntent)) {
                throw new Error("Must use the same `intent`-argument when calling the `PDFPageProxy.render` " + "and `PDFDocumentProxy.getOptionalContentConfig` methods.");
            }
            internalRenderTask.initializeGraphics({
                transparency: transparency,
                optionalContentConfig: optionalContentConfig
            });
            internalRenderTask.operatorListChanged();
        }).catch(complete);
        return renderTask;
    };
    PDFPageProxy.prototype.getOperatorList = function (_m) {
        var _o;
        var _p = _m === void 0 ? {} : _m, _q = _p.intent, intent = _q === void 0 ? "display" : _q, _r = _p.annotationMode, annotationMode = _r === void 0 ? AnnotationMode.ENABLE : _r, _s = _p.printAnnotationStorage, printAnnotationStorage = _s === void 0 ? null : _s, _t = _p.isEditing, isEditing = _t === void 0 ? false : _t;
        function operatorListChanged() {
            if (intentState.operatorList.lastChunk) {
                intentState.opListReadCapability.resolve(intentState.operatorList);
                intentState.renderTasks.delete(opListTask);
            }
        }
        var intentArgs = this._transport.getRenderingIntent(intent, annotationMode, printAnnotationStorage, isEditing, true);
        var intentState = this._intentStates.get(intentArgs.cacheKey);
        if (!intentState) {
            intentState = Object.create(null);
            this._intentStates.set(intentArgs.cacheKey, intentState);
        }
        var opListTask;
        if (!intentState.opListReadCapability) {
            opListTask = Object.create(null);
            opListTask.operatorListChanged = operatorListChanged;
            intentState.opListReadCapability = Promise.withResolvers();
            (intentState.renderTasks || (intentState.renderTasks = new Set())).add(opListTask);
            intentState.operatorList = {
                fnArray: [],
                argsArray: [],
                lastChunk: false,
                separateAnnots: null
            };
            (_o = this._stats) === null || _o === void 0 ? void 0 : _o.time("Page Request");
            this._pumpOperatorList(intentArgs);
        }
        return intentState.opListReadCapability.promise;
    };
    PDFPageProxy.prototype.streamTextContent = function (_m) {
        var _o = _m === void 0 ? {} : _m, _p = _o.includeMarkedContent, includeMarkedContent = _p === void 0 ? false : _p, _q = _o.disableNormalization, disableNormalization = _q === void 0 ? false : _q;
        var TEXT_CONTENT_CHUNK_SIZE = 100;
        return this._transport.messageHandler.sendWithStream("GetTextContent", {
            pageIndex: this._pageIndex,
            includeMarkedContent: includeMarkedContent === true,
            disableNormalization: disableNormalization === true
        }, {
            highWaterMark: TEXT_CONTENT_CHUNK_SIZE,
            size: function (textContent) {
                return textContent.items.length;
            }
        });
    };
    PDFPageProxy.prototype.getTextContent = function (params) {
        if (params === void 0) { params = {}; }
        if (this._transport._htmlForXfa) {
            return this.getXfa().then(function (xfa) { return XfaText.textContent(xfa); });
        }
        var readableStream = this.streamTextContent(params);
        return new Promise(function (resolve, reject) {
            function pump() {
                reader.read().then(function (_m) {
                    var _o;
                    var _p;
                    var value = _m.value, done = _m.done;
                    if (done) {
                        resolve(textContent);
                        return;
                    }
                    (_p = textContent.lang) !== null && _p !== void 0 ? _p : (textContent.lang = value.lang);
                    Object.assign(textContent.styles, value.styles);
                    (_o = textContent.items).push.apply(_o, __spreadArray([], __read(value.items), false));
                    pump();
                }, reject);
            }
            var reader = readableStream.getReader();
            var textContent = {
                items: [],
                styles: Object.create(null),
                lang: null
            };
            pump();
        });
    };
    PDFPageProxy.prototype.getStructTree = function () {
        return this._transport.getStructTree(this._pageIndex);
    };
    PDFPageProxy.prototype._destroy = function () {
        var e_118, _m, e_119, _o;
        this.destroyed = true;
        var waitOn = [];
        try {
            for (var _p = __values(this._intentStates.values()), _q = _p.next(); !_q.done; _q = _p.next()) {
                var intentState = _q.value;
                this._abortOperatorList({
                    intentState: intentState,
                    reason: new Error("Page was destroyed."),
                    force: true
                });
                if (intentState.opListReadCapability) {
                    continue;
                }
                try {
                    for (var _r = (e_119 = void 0, __values(intentState.renderTasks)), _s = _r.next(); !_s.done; _s = _r.next()) {
                        var internalRenderTask = _s.value;
                        waitOn.push(internalRenderTask.completed);
                        internalRenderTask.cancel();
                    }
                }
                catch (e_119_1) { e_119 = { error: e_119_1 }; }
                finally {
                    try {
                        if (_s && !_s.done && (_o = _r.return)) _o.call(_r);
                    }
                    finally { if (e_119) throw e_119.error; }
                }
            }
        }
        catch (e_118_1) { e_118 = { error: e_118_1 }; }
        finally {
            try {
                if (_q && !_q.done && (_m = _p.return)) _m.call(_p);
            }
            finally { if (e_118) throw e_118.error; }
        }
        this.objs.clear();
        __classPrivateFieldSet(this, _PDFPageProxy_pendingCleanup, false, "f");
        return Promise.all(waitOn);
    };
    PDFPageProxy.prototype.cleanup = function (resetStats) {
        if (resetStats === void 0) { resetStats = false; }
        __classPrivateFieldSet(this, _PDFPageProxy_pendingCleanup, true, "f");
        var success = __classPrivateFieldGet(this, _PDFPageProxy_instances, "m", _PDFPageProxy_tryCleanup).call(this);
        if (resetStats && success) {
            this._stats && (this._stats = new StatTimer());
        }
        return success;
    };
    PDFPageProxy.prototype._startRenderPage = function (transparency, cacheKey) {
        var _m, _o;
        var intentState = this._intentStates.get(cacheKey);
        if (!intentState) {
            return;
        }
        (_m = this._stats) === null || _m === void 0 ? void 0 : _m.timeEnd("Page Request");
        (_o = intentState.displayReadyCapability) === null || _o === void 0 ? void 0 : _o.resolve(transparency);
    };
    PDFPageProxy.prototype._renderPageChunk = function (operatorListChunk, intentState) {
        var e_120, _m;
        for (var i = 0, ii = operatorListChunk.length; i < ii; i++) {
            intentState.operatorList.fnArray.push(operatorListChunk.fnArray[i]);
            intentState.operatorList.argsArray.push(operatorListChunk.argsArray[i]);
        }
        intentState.operatorList.lastChunk = operatorListChunk.lastChunk;
        intentState.operatorList.separateAnnots = operatorListChunk.separateAnnots;
        try {
            for (var _o = __values(intentState.renderTasks), _p = _o.next(); !_p.done; _p = _o.next()) {
                var internalRenderTask = _p.value;
                internalRenderTask.operatorListChanged();
            }
        }
        catch (e_120_1) { e_120 = { error: e_120_1 }; }
        finally {
            try {
                if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
            }
            finally { if (e_120) throw e_120.error; }
        }
        if (operatorListChunk.lastChunk) {
            __classPrivateFieldGet(this, _PDFPageProxy_instances, "m", _PDFPageProxy_tryCleanup).call(this);
        }
    };
    PDFPageProxy.prototype._pumpOperatorList = function (_m) {
        var _this = this;
        var renderingIntent = _m.renderingIntent, cacheKey = _m.cacheKey, annotationStorageSerializable = _m.annotationStorageSerializable, modifiedIds = _m.modifiedIds;
        var map = annotationStorageSerializable.map, transfer = annotationStorageSerializable.transfer;
        var readableStream = this._transport.messageHandler.sendWithStream("GetOperatorList", {
            pageIndex: this._pageIndex,
            intent: renderingIntent,
            cacheKey: cacheKey,
            annotationStorage: map,
            modifiedIds: modifiedIds
        }, transfer);
        var reader = readableStream.getReader();
        var intentState = this._intentStates.get(cacheKey);
        intentState.streamReader = reader;
        var pump = function () {
            reader.read().then(function (_m) {
                var value = _m.value, done = _m.done;
                if (done) {
                    intentState.streamReader = null;
                    return;
                }
                if (_this._transport.destroyed) {
                    return;
                }
                _this._renderPageChunk(value, intentState);
                pump();
            }, function (reason) {
                var e_121, _m;
                intentState.streamReader = null;
                if (_this._transport.destroyed) {
                    return;
                }
                if (intentState.operatorList) {
                    intentState.operatorList.lastChunk = true;
                    try {
                        for (var _o = __values(intentState.renderTasks), _p = _o.next(); !_p.done; _p = _o.next()) {
                            var internalRenderTask = _p.value;
                            internalRenderTask.operatorListChanged();
                        }
                    }
                    catch (e_121_1) { e_121 = { error: e_121_1 }; }
                    finally {
                        try {
                            if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
                        }
                        finally { if (e_121) throw e_121.error; }
                    }
                    __classPrivateFieldGet(_this, _PDFPageProxy_instances, "m", _PDFPageProxy_tryCleanup).call(_this);
                }
                if (intentState.displayReadyCapability) {
                    intentState.displayReadyCapability.reject(reason);
                }
                else if (intentState.opListReadCapability) {
                    intentState.opListReadCapability.reject(reason);
                }
                else {
                    throw reason;
                }
            });
        };
        pump();
    };
    PDFPageProxy.prototype._abortOperatorList = function (_m) {
        var e_122, _o;
        var _this = this;
        var intentState = _m.intentState, reason = _m.reason, _p = _m.force, force = _p === void 0 ? false : _p;
        if (!intentState.streamReader) {
            return;
        }
        if (intentState.streamReaderCancelTimeout) {
            clearTimeout(intentState.streamReaderCancelTimeout);
            intentState.streamReaderCancelTimeout = null;
        }
        if (!force) {
            if (intentState.renderTasks.size > 0) {
                return;
            }
            if (reason instanceof RenderingCancelledException) {
                var delay = RENDERING_CANCELLED_TIMEOUT;
                if (reason.extraDelay > 0 && reason.extraDelay < 1000) {
                    delay += reason.extraDelay;
                }
                intentState.streamReaderCancelTimeout = setTimeout(function () {
                    intentState.streamReaderCancelTimeout = null;
                    _this._abortOperatorList({
                        intentState: intentState,
                        reason: reason,
                        force: true
                    });
                }, delay);
                return;
            }
        }
        intentState.streamReader.cancel(new AbortException(reason.message)).catch(function () { });
        intentState.streamReader = null;
        if (this._transport.destroyed) {
            return;
        }
        try {
            for (var _q = __values(this._intentStates), _r = _q.next(); !_r.done; _r = _q.next()) {
                var _s = __read(_r.value, 2), curCacheKey = _s[0], curIntentState = _s[1];
                if (curIntentState === intentState) {
                    this._intentStates.delete(curCacheKey);
                    break;
                }
            }
        }
        catch (e_122_1) { e_122 = { error: e_122_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_o = _q.return)) _o.call(_q);
            }
            finally { if (e_122) throw e_122.error; }
        }
        this.cleanup();
    };
    Object.defineProperty(PDFPageProxy.prototype, "stats", {
        get: function () {
            return this._stats;
        },
        enumerable: false,
        configurable: true
    });
    return PDFPageProxy;
}());
_PDFPageProxy_pendingCleanup = new WeakMap(), _PDFPageProxy_instances = new WeakSet(), _PDFPageProxy_tryCleanup = function _PDFPageProxy_tryCleanup() {
    var e_123, _m;
    if (!__classPrivateFieldGet(this, _PDFPageProxy_pendingCleanup, "f") || this.destroyed) {
        return false;
    }
    try {
        for (var _o = __values(this._intentStates.values()), _p = _o.next(); !_p.done; _p = _o.next()) {
            var _q = _p.value, renderTasks = _q.renderTasks, operatorList = _q.operatorList;
            if (renderTasks.size > 0 || !operatorList.lastChunk) {
                return false;
            }
        }
    }
    catch (e_123_1) { e_123 = { error: e_123_1 }; }
    finally {
        try {
            if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
        }
        finally { if (e_123) throw e_123.error; }
    }
    this._intentStates.clear();
    this.objs.clear();
    __classPrivateFieldSet(this, _PDFPageProxy_pendingCleanup, false, "f");
    return true;
};
var LoopbackPort = /** @class */ (function () {
    function LoopbackPort() {
        _LoopbackPort_listeners.set(this, new Map());
        _LoopbackPort_deferred.set(this, Promise.resolve());
    }
    LoopbackPort.prototype.postMessage = function (obj, transfer) {
        var _this = this;
        var event = {
            data: structuredClone(obj, transfer ? {
                transfer: transfer
            } : null)
        };
        __classPrivateFieldGet(this, _LoopbackPort_deferred, "f").then(function () {
            var e_124, _m;
            try {
                for (var _o = __values(__classPrivateFieldGet(_this, _LoopbackPort_listeners, "f")), _p = _o.next(); !_p.done; _p = _o.next()) {
                    var _q = __read(_p.value, 1), listener = _q[0];
                    listener.call(_this, event);
                }
            }
            catch (e_124_1) { e_124 = { error: e_124_1 }; }
            finally {
                try {
                    if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
                }
                finally { if (e_124) throw e_124.error; }
            }
        });
    };
    LoopbackPort.prototype.addEventListener = function (name, listener, options) {
        var _this = this;
        if (options === void 0) { options = null; }
        var rmAbort = null;
        if ((options === null || options === void 0 ? void 0 : options.signal) instanceof AbortSignal) {
            var signal_1 = options.signal;
            if (signal_1.aborted) {
                warn("LoopbackPort - cannot use an `aborted` signal.");
                return;
            }
            var onAbort_1 = function () { return _this.removeEventListener(name, listener); };
            rmAbort = function () { return signal_1.removeEventListener("abort", onAbort_1); };
            signal_1.addEventListener("abort", onAbort_1);
        }
        __classPrivateFieldGet(this, _LoopbackPort_listeners, "f").set(listener, rmAbort);
    };
    LoopbackPort.prototype.removeEventListener = function (name, listener) {
        var rmAbort = __classPrivateFieldGet(this, _LoopbackPort_listeners, "f").get(listener);
        rmAbort === null || rmAbort === void 0 ? void 0 : rmAbort();
        __classPrivateFieldGet(this, _LoopbackPort_listeners, "f").delete(listener);
    };
    LoopbackPort.prototype.terminate = function () {
        var e_125, _m;
        try {
            for (var _o = __values(__classPrivateFieldGet(this, _LoopbackPort_listeners, "f")), _p = _o.next(); !_p.done; _p = _o.next()) {
                var _q = __read(_p.value, 2), rmAbort = _q[1];
                rmAbort === null || rmAbort === void 0 ? void 0 : rmAbort();
            }
        }
        catch (e_125_1) { e_125 = { error: e_125_1 }; }
        finally {
            try {
                if (_p && !_p.done && (_m = _o.return)) _m.call(_o);
            }
            finally { if (e_125) throw e_125.error; }
        }
        __classPrivateFieldGet(this, _LoopbackPort_listeners, "f").clear();
    };
    return LoopbackPort;
}());
_LoopbackPort_listeners = new WeakMap(), _LoopbackPort_deferred = new WeakMap();
var PDFWorker = /** @class */ (function () {
    function PDFWorker(_o) {
        var _p = _o === void 0 ? {} : _o, _q = _p.name, name = _q === void 0 ? null : _q, _r = _p.port, port = _r === void 0 ? null : _r, _s = _p.verbosity, verbosity = _s === void 0 ? getVerbosityLevel() : _s;
        var _t;
        var _u;
        _PDFWorker_instances.add(this);
        this.name = name;
        this.destroyed = false;
        this.verbosity = verbosity;
        this._readyCapability = Promise.withResolvers();
        this._port = null;
        this._webWorker = null;
        this._messageHandler = null;
        if (port) {
            if ((_t = __classPrivateFieldGet(_m, _m, "f", _PDFWorker_workerPorts)) === null || _t === void 0 ? void 0 : _t.has(port)) {
                throw new Error("Cannot use more than one PDFWorker per port.");
            }
            (__classPrivateFieldSet(_u = _m, _m, __classPrivateFieldGet(_u, _m, "f", _PDFWorker_workerPorts) || new WeakMap(), "f", _PDFWorker_workerPorts)).set(port, this);
            this._initializeFromPort(port);
            return;
        }
        this._initialize();
    }
    Object.defineProperty(PDFWorker.prototype, "promise", {
        get: function () {
            return this._readyCapability.promise;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFWorker.prototype, "port", {
        get: function () {
            return this._port;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFWorker.prototype, "messageHandler", {
        get: function () {
            return this._messageHandler;
        },
        enumerable: false,
        configurable: true
    });
    PDFWorker.prototype._initializeFromPort = function (port) {
        this._port = port;
        this._messageHandler = new MessageHandler("main", "worker", port);
        this._messageHandler.on("ready", function () { });
        __classPrivateFieldGet(this, _PDFWorker_instances, "m", _PDFWorker_resolve).call(this);
    };
    PDFWorker.prototype._initialize = function () {
        var _this = this;
        if (__classPrivateFieldGet(_m, _m, "f", _PDFWorker_isWorkerDisabled) || __classPrivateFieldGet(_m, _m, "a", _PDFWorker_mainThreadWorkerMessageHandler_get)) {
            this._setupFakeWorker();
            return;
        }
        var workerSrc = _m.workerSrc;
        try {
            if (!_m._isSameOrigin(window.location, workerSrc)) {
                workerSrc = _m._createCDNWrapper(new URL(workerSrc, window.location).href);
            }
            var worker_1 = new Worker(workerSrc, {
                type: "module"
            });
            var messageHandler_1 = new MessageHandler("main", "worker", worker_1);
            var terminateEarly_1 = function () {
                ac_2.abort();
                messageHandler_1.destroy();
                worker_1.terminate();
                if (_this.destroyed) {
                    _this._readyCapability.reject(new Error("Worker was destroyed"));
                }
                else {
                    _this._setupFakeWorker();
                }
            };
            var ac_2 = new AbortController();
            worker_1.addEventListener("error", function () {
                if (!_this._webWorker) {
                    terminateEarly_1();
                }
            }, {
                signal: ac_2.signal
            });
            messageHandler_1.on("test", function (data) {
                ac_2.abort();
                if (_this.destroyed || !data) {
                    terminateEarly_1();
                    return;
                }
                _this._messageHandler = messageHandler_1;
                _this._port = worker_1;
                _this._webWorker = worker_1;
                __classPrivateFieldGet(_this, _PDFWorker_instances, "m", _PDFWorker_resolve).call(_this);
            });
            messageHandler_1.on("ready", function (data) {
                ac_2.abort();
                if (_this.destroyed) {
                    terminateEarly_1();
                    return;
                }
                try {
                    sendTest_1();
                }
                catch (_o) {
                    _this._setupFakeWorker();
                }
            });
            var sendTest_1 = function () {
                var testObj = new Uint8Array();
                messageHandler_1.send("test", testObj, [testObj.buffer]);
            };
            sendTest_1();
            return;
        }
        catch (_o) {
            info("The worker has been disabled.");
        }
        this._setupFakeWorker();
    };
    PDFWorker.prototype._setupFakeWorker = function () {
        var _this = this;
        if (!__classPrivateFieldGet(_m, _m, "f", _PDFWorker_isWorkerDisabled)) {
            warn("Setting up fake worker.");
            __classPrivateFieldSet(_m, _m, true, "f", _PDFWorker_isWorkerDisabled);
        }
        _m._setupFakeWorkerGlobal.then(function (WorkerMessageHandler) {
            var _o, _p, _q;
            if (_this.destroyed) {
                _this._readyCapability.reject(new Error("Worker was destroyed"));
                return;
            }
            var port = new LoopbackPort();
            _this._port = port;
            var id = "fake".concat((__classPrivateFieldSet(_o = _m, _m, (_q = __classPrivateFieldGet(_o, _m, "f", _PDFWorker_fakeWorkerId), _p = _q++, _q), "f", _PDFWorker_fakeWorkerId), _p));
            var workerHandler = new MessageHandler(id + "_worker", id, port);
            WorkerMessageHandler.setup(workerHandler, port);
            _this._messageHandler = new MessageHandler(id, id + "_worker", port);
            __classPrivateFieldGet(_this, _PDFWorker_instances, "m", _PDFWorker_resolve).call(_this);
        }).catch(function (reason) {
            _this._readyCapability.reject(new Error("Setting up fake worker failed: \"".concat(reason.message, "\".")));
        });
    };
    PDFWorker.prototype.destroy = function () {
        var _o, _p, _q;
        this.destroyed = true;
        (_o = this._webWorker) === null || _o === void 0 ? void 0 : _o.terminate();
        this._webWorker = null;
        (_p = __classPrivateFieldGet(_m, _m, "f", _PDFWorker_workerPorts)) === null || _p === void 0 ? void 0 : _p.delete(this._port);
        this._port = null;
        (_q = this._messageHandler) === null || _q === void 0 ? void 0 : _q.destroy();
        this._messageHandler = null;
    };
    PDFWorker.fromPort = function (params) {
        var _o;
        if (!(params === null || params === void 0 ? void 0 : params.port)) {
            throw new Error("PDFWorker.fromPort - invalid method signature.");
        }
        var cachedPort = (_o = __classPrivateFieldGet(this, _m, "f", _PDFWorker_workerPorts)) === null || _o === void 0 ? void 0 : _o.get(params.port);
        if (cachedPort) {
            if (cachedPort._pendingDestroy) {
                throw new Error("PDFWorker.fromPort - the worker is being destroyed.\n" + "Please remember to await `PDFDocumentLoadingTask.destroy()`-calls.");
            }
            return cachedPort;
        }
        return new _m(params);
    };
    Object.defineProperty(PDFWorker, "workerSrc", {
        get: function () {
            if (GlobalWorkerOptions.workerSrc) {
                return GlobalWorkerOptions.workerSrc;
            }
            throw new Error('No "GlobalWorkerOptions.workerSrc" specified.');
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(PDFWorker, "_setupFakeWorkerGlobal", {
        get: function () {
            var _this = this;
            var loader = function () { return __awaiter(_this, void 0, void 0, function () {
                var worker;
                return __generator(this, function (_o) {
                    switch (_o.label) {
                        case 0:
                            if (__classPrivateFieldGet(this, _m, "a", _PDFWorker_mainThreadWorkerMessageHandler_get)) {
                                return [2 /*return*/, __classPrivateFieldGet(this, _m, "a", _PDFWorker_mainThreadWorkerMessageHandler_get)];
                            }
                            return [4 /*yield*/, import(
                                /*webpackIgnore: true*/
                                /*@vite-ignore*/
                                this.workerSrc)];
                        case 1:
                            worker = _o.sent();
                            return [2 /*return*/, worker.WorkerMessageHandler];
                    }
                });
            }); };
            return shadow(this, "_setupFakeWorkerGlobal", loader());
        },
        enumerable: false,
        configurable: true
    });
    var _PDFWorker_instances, _m, _PDFWorker_fakeWorkerId, _PDFWorker_isWorkerDisabled, _PDFWorker_workerPorts, _PDFWorker_resolve, _PDFWorker_mainThreadWorkerMessageHandler_get;
    _m = PDFWorker, _PDFWorker_instances = new WeakSet(), _PDFWorker_resolve = function _PDFWorker_resolve() {
        this._readyCapability.resolve();
        this._messageHandler.send("configure", {
            verbosity: this.verbosity
        });
    }, _PDFWorker_mainThreadWorkerMessageHandler_get = function _PDFWorker_mainThreadWorkerMessageHandler_get() {
        var _o;
        try {
            return ((_o = globalThis.pdfjsWorker) === null || _o === void 0 ? void 0 : _o.WorkerMessageHandler) || null;
        }
        catch (_p) {
            return null;
        }
    };
    _PDFWorker_fakeWorkerId = { value: 0 };
    _PDFWorker_isWorkerDisabled = { value: false };
    _PDFWorker_workerPorts = { value: void 0 };
    (function () {
        if (isNodeJS) {
            __classPrivateFieldSet(_m, _m, true, "f", _PDFWorker_isWorkerDisabled);
            GlobalWorkerOptions.workerSrc || (GlobalWorkerOptions.workerSrc = "./pdf.worker.mjs");
        }
        _m._isSameOrigin = function (baseUrl, otherUrl) {
            var base = URL.parse(baseUrl);
            if (!(base === null || base === void 0 ? void 0 : base.origin) || base.origin === "null") {
                return false;
            }
            var other = new URL(otherUrl, base);
            return base.origin === other.origin;
        };
        _m._createCDNWrapper = function (url) {
            var wrapper = "await import(\"".concat(url, "\");");
            return URL.createObjectURL(new Blob([wrapper], {
                type: "text/javascript"
            }));
        };
    })();
    return PDFWorker;
}());
var WorkerTransport = /** @class */ (function () {
    function WorkerTransport(messageHandler, loadingTask, networkStream, params, factory) {
        _WorkerTransport_instances.add(this);
        _WorkerTransport_methodPromises.set(this, new Map());
        _WorkerTransport_pageCache.set(this, new Map());
        _WorkerTransport_pagePromises.set(this, new Map());
        _WorkerTransport_pageRefCache.set(this, new Map());
        _WorkerTransport_passwordCapability.set(this, null);
        this.messageHandler = messageHandler;
        this.loadingTask = loadingTask;
        this.commonObjs = new PDFObjects();
        this.fontLoader = new FontLoader({
            ownerDocument: params.ownerDocument,
            styleElement: params.styleElement
        });
        this.loadingParams = params.loadingParams;
        this._params = params;
        this.canvasFactory = factory.canvasFactory;
        this.filterFactory = factory.filterFactory;
        this.cMapReaderFactory = factory.cMapReaderFactory;
        this.standardFontDataFactory = factory.standardFontDataFactory;
        this.wasmFactory = factory.wasmFactory;
        this.destroyed = false;
        this.destroyCapability = null;
        this._networkStream = networkStream;
        this._fullReader = null;
        this._lastProgress = null;
        this.downloadInfoCapability = Promise.withResolvers();
        this.setupMessageHandler();
    }
    Object.defineProperty(WorkerTransport.prototype, "annotationStorage", {
        get: function () {
            return shadow(this, "annotationStorage", new AnnotationStorage());
        },
        enumerable: false,
        configurable: true
    });
    WorkerTransport.prototype.getRenderingIntent = function (intent, annotationMode, printAnnotationStorage, isEditing, isOpList) {
        if (annotationMode === void 0) { annotationMode = AnnotationMode.ENABLE; }
        if (printAnnotationStorage === void 0) { printAnnotationStorage = null; }
        if (isEditing === void 0) { isEditing = false; }
        if (isOpList === void 0) { isOpList = false; }
        var renderingIntent = RenderingIntentFlag.DISPLAY;
        var annotationStorageSerializable = SerializableEmpty;
        switch (intent) {
            case "any":
                renderingIntent = RenderingIntentFlag.ANY;
                break;
            case "display":
                break;
            case "print":
                renderingIntent = RenderingIntentFlag.PRINT;
                break;
            default:
                warn("getRenderingIntent - invalid intent: ".concat(intent));
        }
        var annotationStorage = renderingIntent & RenderingIntentFlag.PRINT && printAnnotationStorage instanceof PrintAnnotationStorage ? printAnnotationStorage : this.annotationStorage;
        switch (annotationMode) {
            case AnnotationMode.DISABLE:
                renderingIntent += RenderingIntentFlag.ANNOTATIONS_DISABLE;
                break;
            case AnnotationMode.ENABLE:
                break;
            case AnnotationMode.ENABLE_FORMS:
                renderingIntent += RenderingIntentFlag.ANNOTATIONS_FORMS;
                break;
            case AnnotationMode.ENABLE_STORAGE:
                renderingIntent += RenderingIntentFlag.ANNOTATIONS_STORAGE;
                annotationStorageSerializable = annotationStorage.serializable;
                break;
            default:
                warn("getRenderingIntent - invalid annotationMode: ".concat(annotationMode));
        }
        if (isEditing) {
            renderingIntent += RenderingIntentFlag.IS_EDITING;
        }
        if (isOpList) {
            renderingIntent += RenderingIntentFlag.OPLIST;
        }
        var _o = annotationStorage.modifiedIds, modifiedIds = _o.ids, modifiedIdsHash = _o.hash;
        var cacheKeyBuf = [renderingIntent, annotationStorageSerializable.hash, modifiedIdsHash];
        return {
            renderingIntent: renderingIntent,
            cacheKey: cacheKeyBuf.join("_"),
            annotationStorageSerializable: annotationStorageSerializable,
            modifiedIds: modifiedIds
        };
    };
    WorkerTransport.prototype.destroy = function () {
        var e_126, _o;
        var _this = this;
        var _p;
        if (this.destroyCapability) {
            return this.destroyCapability.promise;
        }
        this.destroyed = true;
        this.destroyCapability = Promise.withResolvers();
        (_p = __classPrivateFieldGet(this, _WorkerTransport_passwordCapability, "f")) === null || _p === void 0 ? void 0 : _p.reject(new Error("Worker was destroyed during onPassword callback"));
        var waitOn = [];
        try {
            for (var _q = __values(__classPrivateFieldGet(this, _WorkerTransport_pageCache, "f").values()), _r = _q.next(); !_r.done; _r = _q.next()) {
                var page = _r.value;
                waitOn.push(page._destroy());
            }
        }
        catch (e_126_1) { e_126 = { error: e_126_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_o = _q.return)) _o.call(_q);
            }
            finally { if (e_126) throw e_126.error; }
        }
        __classPrivateFieldGet(this, _WorkerTransport_pageCache, "f").clear();
        __classPrivateFieldGet(this, _WorkerTransport_pagePromises, "f").clear();
        __classPrivateFieldGet(this, _WorkerTransport_pageRefCache, "f").clear();
        if (this.hasOwnProperty("annotationStorage")) {
            this.annotationStorage.resetModified();
        }
        var terminated = this.messageHandler.sendWithPromise("Terminate", null);
        waitOn.push(terminated);
        Promise.all(waitOn).then(function () {
            var _o, _p;
            _this.commonObjs.clear();
            _this.fontLoader.clear();
            __classPrivateFieldGet(_this, _WorkerTransport_methodPromises, "f").clear();
            _this.filterFactory.destroy();
            TextLayer.cleanup();
            (_o = _this._networkStream) === null || _o === void 0 ? void 0 : _o.cancelAllRequests(new AbortException("Worker was terminated."));
            (_p = _this.messageHandler) === null || _p === void 0 ? void 0 : _p.destroy();
            _this.messageHandler = null;
            _this.destroyCapability.resolve();
        }, this.destroyCapability.reject);
        return this.destroyCapability.promise;
    };
    WorkerTransport.prototype.setupMessageHandler = function () {
        var _this = this;
        var _o = this, messageHandler = _o.messageHandler, loadingTask = _o.loadingTask;
        messageHandler.on("GetReader", function (data, sink) {
            assert(_this._networkStream, "GetReader - no `IPDFStream` instance available.");
            _this._fullReader = _this._networkStream.getFullReader();
            _this._fullReader.onProgress = function (evt) {
                _this._lastProgress = {
                    loaded: evt.loaded,
                    total: evt.total
                };
            };
            sink.onPull = function () {
                _this._fullReader.read().then(function (_o) {
                    var value = _o.value, done = _o.done;
                    if (done) {
                        sink.close();
                        return;
                    }
                    assert(value instanceof ArrayBuffer, "GetReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [value]);
                }).catch(function (reason) {
                    sink.error(reason);
                });
            };
            sink.onCancel = function (reason) {
                _this._fullReader.cancel(reason);
                sink.ready.catch(function (readyReason) {
                    if (_this.destroyed) {
                        return;
                    }
                    throw readyReason;
                });
            };
        });
        messageHandler.on("ReaderHeadersReady", function (data) { return __awaiter(_this, void 0, void 0, function () {
            var _o, isStreamingSupported, isRangeSupported, contentLength;
            var _p;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0: return [4 /*yield*/, this._fullReader.headersReady];
                    case 1:
                        _q.sent();
                        _o = this._fullReader, isStreamingSupported = _o.isStreamingSupported, isRangeSupported = _o.isRangeSupported, contentLength = _o.contentLength;
                        if (!isStreamingSupported || !isRangeSupported) {
                            if (this._lastProgress) {
                                (_p = loadingTask.onProgress) === null || _p === void 0 ? void 0 : _p.call(loadingTask, this._lastProgress);
                            }
                            this._fullReader.onProgress = function (evt) {
                                var _o;
                                (_o = loadingTask.onProgress) === null || _o === void 0 ? void 0 : _o.call(loadingTask, {
                                    loaded: evt.loaded,
                                    total: evt.total
                                });
                            };
                        }
                        return [2 /*return*/, {
                                isStreamingSupported: isStreamingSupported,
                                isRangeSupported: isRangeSupported,
                                contentLength: contentLength
                            }];
                }
            });
        }); });
        messageHandler.on("GetRangeReader", function (data, sink) {
            assert(_this._networkStream, "GetRangeReader - no `IPDFStream` instance available.");
            var rangeReader = _this._networkStream.getRangeReader(data.begin, data.end);
            if (!rangeReader) {
                sink.close();
                return;
            }
            sink.onPull = function () {
                rangeReader.read().then(function (_o) {
                    var value = _o.value, done = _o.done;
                    if (done) {
                        sink.close();
                        return;
                    }
                    assert(value instanceof ArrayBuffer, "GetRangeReader - expected an ArrayBuffer.");
                    sink.enqueue(new Uint8Array(value), 1, [value]);
                }).catch(function (reason) {
                    sink.error(reason);
                });
            };
            sink.onCancel = function (reason) {
                rangeReader.cancel(reason);
                sink.ready.catch(function (readyReason) {
                    if (_this.destroyed) {
                        return;
                    }
                    throw readyReason;
                });
            };
        });
        messageHandler.on("GetDoc", function (_o) {
            var pdfInfo = _o.pdfInfo;
            _this._numPages = pdfInfo.numPages;
            _this._htmlForXfa = pdfInfo.htmlForXfa;
            delete pdfInfo.htmlForXfa;
            loadingTask._capability.resolve(new PDFDocumentProxy(pdfInfo, _this));
        });
        messageHandler.on("DocException", function (ex) {
            loadingTask._capability.reject(wrapReason(ex));
        });
        messageHandler.on("PasswordRequest", function (ex) {
            __classPrivateFieldSet(_this, _WorkerTransport_passwordCapability, Promise.withResolvers(), "f");
            try {
                if (!loadingTask.onPassword) {
                    throw wrapReason(ex);
                }
                var updatePassword = function (password) {
                    if (password instanceof Error) {
                        __classPrivateFieldGet(_this, _WorkerTransport_passwordCapability, "f").reject(password);
                    }
                    else {
                        __classPrivateFieldGet(_this, _WorkerTransport_passwordCapability, "f").resolve({
                            password: password
                        });
                    }
                };
                loadingTask.onPassword(updatePassword, ex.code);
            }
            catch (err) {
                __classPrivateFieldGet(_this, _WorkerTransport_passwordCapability, "f").reject(err);
            }
            return __classPrivateFieldGet(_this, _WorkerTransport_passwordCapability, "f").promise;
        });
        messageHandler.on("DataLoaded", function (data) {
            var _o;
            (_o = loadingTask.onProgress) === null || _o === void 0 ? void 0 : _o.call(loadingTask, {
                loaded: data.length,
                total: data.length
            });
            _this.downloadInfoCapability.resolve(data);
        });
        messageHandler.on("StartRenderPage", function (data) {
            if (_this.destroyed) {
                return;
            }
            var page = __classPrivateFieldGet(_this, _WorkerTransport_pageCache, "f").get(data.pageIndex);
            page._startRenderPage(data.transparency, data.cacheKey);
        });
        messageHandler.on("commonobj", function (_o) {
            var e_127, _p, e_128, _q;
            var _r;
            var _s = __read(_o, 3), id = _s[0], type = _s[1], exportedData = _s[2];
            if (_this.destroyed) {
                return null;
            }
            if (_this.commonObjs.has(id)) {
                return null;
            }
            switch (type) {
                case "Font":
                    if ("error" in exportedData) {
                        var exportedError = exportedData.error;
                        warn("Error during font loading: ".concat(exportedError));
                        _this.commonObjs.resolve(id, exportedError);
                        break;
                    }
                    var inspectFont = _this._params.pdfBug && ((_r = globalThis.FontInspector) === null || _r === void 0 ? void 0 : _r.enabled) ? function (font, url) { return globalThis.FontInspector.fontAdded(font, url); } : null;
                    var font_1 = new FontFaceObject(exportedData, inspectFont);
                    _this.fontLoader.bind(font_1).catch(function () { return messageHandler.sendWithPromise("FontFallback", {
                        id: id
                    }); }).finally(function () {
                        if (!font_1.fontExtraProperties && font_1.data) {
                            font_1.data = null;
                        }
                        _this.commonObjs.resolve(id, font_1);
                    });
                    break;
                case "CopyLocalImage":
                    var imageRef = exportedData.imageRef;
                    assert(imageRef, "The imageRef must be defined.");
                    try {
                        for (var _t = __values(__classPrivateFieldGet(_this, _WorkerTransport_pageCache, "f").values()), _u = _t.next(); !_u.done; _u = _t.next()) {
                            var pageProxy = _u.value;
                            try {
                                for (var _v = (e_128 = void 0, __values(pageProxy.objs)), _w = _v.next(); !_w.done; _w = _v.next()) {
                                    var _z = __read(_w.value, 2), data = _z[1];
                                    if ((data === null || data === void 0 ? void 0 : data.ref) !== imageRef) {
                                        continue;
                                    }
                                    if (!data.dataLen) {
                                        return null;
                                    }
                                    _this.commonObjs.resolve(id, structuredClone(data));
                                    return data.dataLen;
                                }
                            }
                            catch (e_128_1) { e_128 = { error: e_128_1 }; }
                            finally {
                                try {
                                    if (_w && !_w.done && (_q = _v.return)) _q.call(_v);
                                }
                                finally { if (e_128) throw e_128.error; }
                            }
                        }
                    }
                    catch (e_127_1) { e_127 = { error: e_127_1 }; }
                    finally {
                        try {
                            if (_u && !_u.done && (_p = _t.return)) _p.call(_t);
                        }
                        finally { if (e_127) throw e_127.error; }
                    }
                    break;
                case "FontPath":
                case "Image":
                case "Pattern":
                    _this.commonObjs.resolve(id, exportedData);
                    break;
                default:
                    throw new Error("Got unknown common object type ".concat(type));
            }
            return null;
        });
        messageHandler.on("obj", function (_o) {
            var _p;
            var _q = __read(_o, 4), id = _q[0], pageIndex = _q[1], type = _q[2], imageData = _q[3];
            if (_this.destroyed) {
                return;
            }
            var pageProxy = __classPrivateFieldGet(_this, _WorkerTransport_pageCache, "f").get(pageIndex);
            if (pageProxy.objs.has(id)) {
                return;
            }
            if (pageProxy._intentStates.size === 0) {
                (_p = imageData === null || imageData === void 0 ? void 0 : imageData.bitmap) === null || _p === void 0 ? void 0 : _p.close();
                return;
            }
            switch (type) {
                case "Image":
                case "Pattern":
                    pageProxy.objs.resolve(id, imageData);
                    break;
                default:
                    throw new Error("Got unknown object type ".concat(type));
            }
        });
        messageHandler.on("DocProgress", function (data) {
            var _o;
            if (_this.destroyed) {
                return;
            }
            (_o = loadingTask.onProgress) === null || _o === void 0 ? void 0 : _o.call(loadingTask, {
                loaded: data.loaded,
                total: data.total
            });
        });
        messageHandler.on("FetchBinaryData", function (data) { return __awaiter(_this, void 0, void 0, function () {
            var factory;
            return __generator(this, function (_o) {
                if (this.destroyed) {
                    throw new Error("Worker was destroyed.");
                }
                factory = this[data.type];
                if (!factory) {
                    throw new Error("".concat(data.type, " not initialized, see the `useWorkerFetch` parameter."));
                }
                return [2 /*return*/, factory.fetch(data)];
            });
        }); });
    };
    WorkerTransport.prototype.getData = function () {
        return this.messageHandler.sendWithPromise("GetData", null);
    };
    WorkerTransport.prototype.saveDocument = function () {
        var _this = this;
        var _o, _p;
        if (this.annotationStorage.size <= 0) {
            warn("saveDocument called while `annotationStorage` is empty, " + "please use the getData-method instead.");
        }
        var _q = this.annotationStorage.serializable, map = _q.map, transfer = _q.transfer;
        return this.messageHandler.sendWithPromise("SaveDocument", {
            isPureXfa: !!this._htmlForXfa,
            numPages: this._numPages,
            annotationStorage: map,
            filename: (_p = (_o = this._fullReader) === null || _o === void 0 ? void 0 : _o.filename) !== null && _p !== void 0 ? _p : null
        }, transfer).finally(function () {
            _this.annotationStorage.resetModified();
        });
    };
    WorkerTransport.prototype.getPage = function (pageNumber) {
        var _this = this;
        if (!Number.isInteger(pageNumber) || pageNumber <= 0 || pageNumber > this._numPages) {
            return Promise.reject(new Error("Invalid page request."));
        }
        var pageIndex = pageNumber - 1, cachedPromise = __classPrivateFieldGet(this, _WorkerTransport_pagePromises, "f").get(pageIndex);
        if (cachedPromise) {
            return cachedPromise;
        }
        var promise = this.messageHandler.sendWithPromise("GetPage", {
            pageIndex: pageIndex
        }).then(function (pageInfo) {
            if (_this.destroyed) {
                throw new Error("Transport destroyed");
            }
            if (pageInfo.refStr) {
                __classPrivateFieldGet(_this, _WorkerTransport_pageRefCache, "f").set(pageInfo.refStr, pageNumber);
            }
            var page = new PDFPageProxy(pageIndex, pageInfo, _this, _this._params.pdfBug);
            __classPrivateFieldGet(_this, _WorkerTransport_pageCache, "f").set(pageIndex, page);
            return page;
        });
        __classPrivateFieldGet(this, _WorkerTransport_pagePromises, "f").set(pageIndex, promise);
        return promise;
    };
    WorkerTransport.prototype.getPageIndex = function (ref) {
        if (!isRefProxy(ref)) {
            return Promise.reject(new Error("Invalid pageIndex request."));
        }
        return this.messageHandler.sendWithPromise("GetPageIndex", {
            num: ref.num,
            gen: ref.gen
        });
    };
    WorkerTransport.prototype.getAnnotations = function (pageIndex, intent) {
        return this.messageHandler.sendWithPromise("GetAnnotations", {
            pageIndex: pageIndex,
            intent: intent
        });
    };
    WorkerTransport.prototype.getFieldObjects = function () {
        return __classPrivateFieldGet(this, _WorkerTransport_instances, "m", _WorkerTransport_cacheSimpleMethod).call(this, "GetFieldObjects");
    };
    WorkerTransport.prototype.hasJSActions = function () {
        return __classPrivateFieldGet(this, _WorkerTransport_instances, "m", _WorkerTransport_cacheSimpleMethod).call(this, "HasJSActions");
    };
    WorkerTransport.prototype.getCalculationOrderIds = function () {
        return this.messageHandler.sendWithPromise("GetCalculationOrderIds", null);
    };
    WorkerTransport.prototype.getDestinations = function () {
        return this.messageHandler.sendWithPromise("GetDestinations", null);
    };
    WorkerTransport.prototype.getDestination = function (id) {
        if (typeof id !== "string") {
            return Promise.reject(new Error("Invalid destination request."));
        }
        return this.messageHandler.sendWithPromise("GetDestination", {
            id: id
        });
    };
    WorkerTransport.prototype.getPageLabels = function () {
        return this.messageHandler.sendWithPromise("GetPageLabels", null);
    };
    WorkerTransport.prototype.getPageLayout = function () {
        return this.messageHandler.sendWithPromise("GetPageLayout", null);
    };
    WorkerTransport.prototype.getPageMode = function () {
        return this.messageHandler.sendWithPromise("GetPageMode", null);
    };
    WorkerTransport.prototype.getViewerPreferences = function () {
        return this.messageHandler.sendWithPromise("GetViewerPreferences", null);
    };
    WorkerTransport.prototype.getOpenAction = function () {
        return this.messageHandler.sendWithPromise("GetOpenAction", null);
    };
    WorkerTransport.prototype.getAttachments = function () {
        return this.messageHandler.sendWithPromise("GetAttachments", null);
    };
    WorkerTransport.prototype.getDocJSActions = function () {
        return __classPrivateFieldGet(this, _WorkerTransport_instances, "m", _WorkerTransport_cacheSimpleMethod).call(this, "GetDocJSActions");
    };
    WorkerTransport.prototype.getPageJSActions = function (pageIndex) {
        return this.messageHandler.sendWithPromise("GetPageJSActions", {
            pageIndex: pageIndex
        });
    };
    WorkerTransport.prototype.getStructTree = function (pageIndex) {
        return this.messageHandler.sendWithPromise("GetStructTree", {
            pageIndex: pageIndex
        });
    };
    WorkerTransport.prototype.getOutline = function () {
        return this.messageHandler.sendWithPromise("GetOutline", null);
    };
    WorkerTransport.prototype.getOptionalContentConfig = function (renderingIntent) {
        return __classPrivateFieldGet(this, _WorkerTransport_instances, "m", _WorkerTransport_cacheSimpleMethod).call(this, "GetOptionalContentConfig").then(function (data) { return new OptionalContentConfig(data, renderingIntent); });
    };
    WorkerTransport.prototype.getPermissions = function () {
        return this.messageHandler.sendWithPromise("GetPermissions", null);
    };
    WorkerTransport.prototype.getMetadata = function () {
        var _this = this;
        var name = "GetMetadata", cachedPromise = __classPrivateFieldGet(this, _WorkerTransport_methodPromises, "f").get(name);
        if (cachedPromise) {
            return cachedPromise;
        }
        var promise = this.messageHandler.sendWithPromise(name, null).then(function (results) {
            var _o, _p, _q, _r;
            return ({
                info: results[0],
                metadata: results[1] ? new Metadata(results[1]) : null,
                contentDispositionFilename: (_p = (_o = _this._fullReader) === null || _o === void 0 ? void 0 : _o.filename) !== null && _p !== void 0 ? _p : null,
                contentLength: (_r = (_q = _this._fullReader) === null || _q === void 0 ? void 0 : _q.contentLength) !== null && _r !== void 0 ? _r : null
            });
        });
        __classPrivateFieldGet(this, _WorkerTransport_methodPromises, "f").set(name, promise);
        return promise;
    };
    WorkerTransport.prototype.getMarkInfo = function () {
        return this.messageHandler.sendWithPromise("GetMarkInfo", null);
    };
    WorkerTransport.prototype.startCleanup = function () {
        return __awaiter(this, arguments, void 0, function (keepLoadedFonts) {
            var _o, _p, page, cleanupSuccessful;
            var e_129, _q;
            if (keepLoadedFonts === void 0) { keepLoadedFonts = false; }
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        if (this.destroyed) {
                            return [2 /*return*/];
                        }
                        return [4 /*yield*/, this.messageHandler.sendWithPromise("Cleanup", null)];
                    case 1:
                        _r.sent();
                        try {
                            for (_o = __values(__classPrivateFieldGet(this, _WorkerTransport_pageCache, "f").values()), _p = _o.next(); !_p.done; _p = _o.next()) {
                                page = _p.value;
                                cleanupSuccessful = page.cleanup();
                                if (!cleanupSuccessful) {
                                    throw new Error("startCleanup: Page ".concat(page.pageNumber, " is currently rendering."));
                                }
                            }
                        }
                        catch (e_129_1) { e_129 = { error: e_129_1 }; }
                        finally {
                            try {
                                if (_p && !_p.done && (_q = _o.return)) _q.call(_o);
                            }
                            finally { if (e_129) throw e_129.error; }
                        }
                        this.commonObjs.clear();
                        if (!keepLoadedFonts) {
                            this.fontLoader.clear();
                        }
                        __classPrivateFieldGet(this, _WorkerTransport_methodPromises, "f").clear();
                        this.filterFactory.destroy(true);
                        TextLayer.cleanup();
                        return [2 /*return*/];
                }
            });
        });
    };
    WorkerTransport.prototype.cachedPageNumber = function (ref) {
        var _o;
        if (!isRefProxy(ref)) {
            return null;
        }
        var refStr = ref.gen === 0 ? "".concat(ref.num, "R") : "".concat(ref.num, "R").concat(ref.gen);
        return (_o = __classPrivateFieldGet(this, _WorkerTransport_pageRefCache, "f").get(refStr)) !== null && _o !== void 0 ? _o : null;
    };
    return WorkerTransport;
}());
_WorkerTransport_methodPromises = new WeakMap(), _WorkerTransport_pageCache = new WeakMap(), _WorkerTransport_pagePromises = new WeakMap(), _WorkerTransport_pageRefCache = new WeakMap(), _WorkerTransport_passwordCapability = new WeakMap(), _WorkerTransport_instances = new WeakSet(), _WorkerTransport_cacheSimpleMethod = function _WorkerTransport_cacheSimpleMethod(name, data) {
    if (data === void 0) { data = null; }
    var cachedPromise = __classPrivateFieldGet(this, _WorkerTransport_methodPromises, "f").get(name);
    if (cachedPromise) {
        return cachedPromise;
    }
    var promise = this.messageHandler.sendWithPromise(name, data);
    __classPrivateFieldGet(this, _WorkerTransport_methodPromises, "f").set(name, promise);
    return promise;
};
var INITIAL_DATA = Symbol("INITIAL_DATA");
var PDFObjects = /** @class */ (function () {
    function PDFObjects() {
        _PDFObjects_instances.add(this);
        _PDFObjects_objs.set(this, Object.create(null));
    }
    PDFObjects.prototype.get = function (objId, callback) {
        if (callback === void 0) { callback = null; }
        if (callback) {
            var obj_1 = __classPrivateFieldGet(this, _PDFObjects_instances, "m", _PDFObjects_ensureObj).call(this, objId);
            obj_1.promise.then(function () { return callback(obj_1.data); });
            return null;
        }
        var obj = __classPrivateFieldGet(this, _PDFObjects_objs, "f")[objId];
        if (!obj || obj.data === INITIAL_DATA) {
            throw new Error("Requesting object that isn't resolved yet ".concat(objId, "."));
        }
        return obj.data;
    };
    PDFObjects.prototype.has = function (objId) {
        var obj = __classPrivateFieldGet(this, _PDFObjects_objs, "f")[objId];
        return !!obj && obj.data !== INITIAL_DATA;
    };
    PDFObjects.prototype.delete = function (objId) {
        var obj = __classPrivateFieldGet(this, _PDFObjects_objs, "f")[objId];
        if (!obj || obj.data === INITIAL_DATA) {
            return false;
        }
        delete __classPrivateFieldGet(this, _PDFObjects_objs, "f")[objId];
        return true;
    };
    PDFObjects.prototype.resolve = function (objId, data) {
        if (data === void 0) { data = null; }
        var obj = __classPrivateFieldGet(this, _PDFObjects_instances, "m", _PDFObjects_ensureObj).call(this, objId);
        obj.data = data;
        obj.resolve();
    };
    PDFObjects.prototype.clear = function () {
        var _o;
        for (var objId in __classPrivateFieldGet(this, _PDFObjects_objs, "f")) {
            var data = __classPrivateFieldGet(this, _PDFObjects_objs, "f")[objId].data;
            (_o = data === null || data === void 0 ? void 0 : data.bitmap) === null || _o === void 0 ? void 0 : _o.close();
        }
        __classPrivateFieldSet(this, _PDFObjects_objs, Object.create(null), "f");
    };
    PDFObjects.prototype[(_PDFObjects_objs = new WeakMap(), _PDFObjects_instances = new WeakSet(), _PDFObjects_ensureObj = function _PDFObjects_ensureObj(objId) {
        var _o;
        return (_o = __classPrivateFieldGet(this, _PDFObjects_objs, "f"))[objId] || (_o[objId] = __assign(__assign({}, Promise.withResolvers()), { data: INITIAL_DATA }));
    }, Symbol.iterator)] = function () {
        var _o, _p, _q, _i, objId, data;
        return __generator(this, function (_r) {
            switch (_r.label) {
                case 0:
                    _o = __classPrivateFieldGet(this, _PDFObjects_objs, "f");
                    _p = [];
                    for (_q in _o)
                        _p.push(_q);
                    _i = 0;
                    _r.label = 1;
                case 1:
                    if (!(_i < _p.length)) return [3 /*break*/, 4];
                    _q = _p[_i];
                    if (!(_q in _o)) return [3 /*break*/, 3];
                    objId = _q;
                    data = __classPrivateFieldGet(this, _PDFObjects_objs, "f")[objId].data;
                    if (data === INITIAL_DATA) {
                        return [3 /*break*/, 3];
                    }
                    return [4 /*yield*/, [objId, data]];
                case 2:
                    _r.sent();
                    _r.label = 3;
                case 3:
                    _i++;
                    return [3 /*break*/, 1];
                case 4: return [2 /*return*/];
            }
        });
    };
    return PDFObjects;
}());
var RenderTask = /** @class */ (function () {
    function RenderTask(internalRenderTask) {
        _RenderTask_internalRenderTask.set(this, null);
        this.onContinue = null;
        this.onError = null;
        __classPrivateFieldSet(this, _RenderTask_internalRenderTask, internalRenderTask, "f");
    }
    Object.defineProperty(RenderTask.prototype, "promise", {
        get: function () {
            return __classPrivateFieldGet(this, _RenderTask_internalRenderTask, "f").capability.promise;
        },
        enumerable: false,
        configurable: true
    });
    RenderTask.prototype.cancel = function (extraDelay) {
        if (extraDelay === void 0) { extraDelay = 0; }
        __classPrivateFieldGet(this, _RenderTask_internalRenderTask, "f").cancel(null, extraDelay);
    };
    Object.defineProperty(RenderTask.prototype, "separateAnnots", {
        get: function () {
            var separateAnnots = __classPrivateFieldGet(this, _RenderTask_internalRenderTask, "f").operatorList.separateAnnots;
            if (!separateAnnots) {
                return false;
            }
            var annotationCanvasMap = __classPrivateFieldGet(this, _RenderTask_internalRenderTask, "f").annotationCanvasMap;
            return separateAnnots.form || separateAnnots.canvas && (annotationCanvasMap === null || annotationCanvasMap === void 0 ? void 0 : annotationCanvasMap.size) > 0;
        },
        enumerable: false,
        configurable: true
    });
    return RenderTask;
}());
_RenderTask_internalRenderTask = new WeakMap();
var InternalRenderTask = /** @class */ (function () {
    function InternalRenderTask(_p) {
        var callback = _p.callback, params = _p.params, objs = _p.objs, commonObjs = _p.commonObjs, annotationCanvasMap = _p.annotationCanvasMap, operatorList = _p.operatorList, pageIndex = _p.pageIndex, canvasFactory = _p.canvasFactory, filterFactory = _p.filterFactory, _q = _p.useRequestAnimationFrame, useRequestAnimationFrame = _q === void 0 ? false : _q, _r = _p.pdfBug, pdfBug = _r === void 0 ? false : _r, _s = _p.pageColors, pageColors = _s === void 0 ? null : _s;
        _InternalRenderTask_rAF.set(this, null);
        this.callback = callback;
        this.params = params;
        this.objs = objs;
        this.commonObjs = commonObjs;
        this.annotationCanvasMap = annotationCanvasMap;
        this.operatorListIdx = null;
        this.operatorList = operatorList;
        this._pageIndex = pageIndex;
        this.canvasFactory = canvasFactory;
        this.filterFactory = filterFactory;
        this._pdfBug = pdfBug;
        this.pageColors = pageColors;
        this.running = false;
        this.graphicsReadyCallback = null;
        this.graphicsReady = false;
        this._useRequestAnimationFrame = useRequestAnimationFrame === true && typeof window !== "undefined";
        this.cancelled = false;
        this.capability = Promise.withResolvers();
        this.task = new RenderTask(this);
        this._cancelBound = this.cancel.bind(this);
        this._continueBound = this._continue.bind(this);
        this._scheduleNextBound = this._scheduleNext.bind(this);
        this._nextBound = this._next.bind(this);
        this._canvas = params.canvasContext.canvas;
    }
    Object.defineProperty(InternalRenderTask.prototype, "completed", {
        get: function () {
            return this.capability.promise.catch(function () { });
        },
        enumerable: false,
        configurable: true
    });
    InternalRenderTask.prototype.initializeGraphics = function (_p) {
        var _q, _r;
        var _s = _p.transparency, transparency = _s === void 0 ? false : _s, optionalContentConfig = _p.optionalContentConfig;
        if (this.cancelled) {
            return;
        }
        if (this._canvas) {
            if (__classPrivateFieldGet(_o, _o, "f", _InternalRenderTask_canvasInUse).has(this._canvas)) {
                throw new Error("Cannot use the same canvas during multiple render() operations. " + "Use different canvas or ensure previous operations were " + "cancelled or completed.");
            }
            __classPrivateFieldGet(_o, _o, "f", _InternalRenderTask_canvasInUse).add(this._canvas);
        }
        if (this._pdfBug && ((_q = globalThis.StepperManager) === null || _q === void 0 ? void 0 : _q.enabled)) {
            this.stepper = globalThis.StepperManager.create(this._pageIndex);
            this.stepper.init(this.operatorList);
            this.stepper.nextBreakPoint = this.stepper.getNextBreakPoint();
        }
        var _t = this.params, canvasContext = _t.canvasContext, viewport = _t.viewport, transform = _t.transform, background = _t.background;
        this.gfx = new CanvasGraphics(canvasContext, this.commonObjs, this.objs, this.canvasFactory, this.filterFactory, {
            optionalContentConfig: optionalContentConfig
        }, this.annotationCanvasMap, this.pageColors);
        this.gfx.beginDrawing({
            transform: transform,
            viewport: viewport,
            transparency: transparency,
            background: background
        });
        this.operatorListIdx = 0;
        this.graphicsReady = true;
        (_r = this.graphicsReadyCallback) === null || _r === void 0 ? void 0 : _r.call(this);
    };
    InternalRenderTask.prototype.cancel = function (error, extraDelay) {
        var _p, _q, _r;
        if (error === void 0) { error = null; }
        if (extraDelay === void 0) { extraDelay = 0; }
        this.running = false;
        this.cancelled = true;
        (_p = this.gfx) === null || _p === void 0 ? void 0 : _p.endDrawing();
        if (__classPrivateFieldGet(this, _InternalRenderTask_rAF, "f")) {
            window.cancelAnimationFrame(__classPrivateFieldGet(this, _InternalRenderTask_rAF, "f"));
            __classPrivateFieldSet(this, _InternalRenderTask_rAF, null, "f");
        }
        __classPrivateFieldGet(_o, _o, "f", _InternalRenderTask_canvasInUse).delete(this._canvas);
        error || (error = new RenderingCancelledException("Rendering cancelled, page ".concat(this._pageIndex + 1), extraDelay));
        this.callback(error);
        (_r = (_q = this.task).onError) === null || _r === void 0 ? void 0 : _r.call(_q, error);
    };
    InternalRenderTask.prototype.operatorListChanged = function () {
        var _p;
        if (!this.graphicsReady) {
            this.graphicsReadyCallback || (this.graphicsReadyCallback = this._continueBound);
            return;
        }
        (_p = this.stepper) === null || _p === void 0 ? void 0 : _p.updateOperatorList(this.operatorList);
        if (this.running) {
            return;
        }
        this._continue();
    };
    InternalRenderTask.prototype._continue = function () {
        this.running = true;
        if (this.cancelled) {
            return;
        }
        if (this.task.onContinue) {
            this.task.onContinue(this._scheduleNextBound);
        }
        else {
            this._scheduleNext();
        }
    };
    InternalRenderTask.prototype._scheduleNext = function () {
        var _this = this;
        if (this._useRequestAnimationFrame) {
            __classPrivateFieldSet(this, _InternalRenderTask_rAF, window.requestAnimationFrame(function () {
                __classPrivateFieldSet(_this, _InternalRenderTask_rAF, null, "f");
                _this._nextBound().catch(_this._cancelBound);
            }), "f");
        }
        else {
            Promise.resolve().then(this._nextBound).catch(this._cancelBound);
        }
    };
    InternalRenderTask.prototype._next = function () {
        return __awaiter(this, void 0, void 0, function () {
            return __generator(this, function (_p) {
                if (this.cancelled) {
                    return [2 /*return*/];
                }
                this.operatorListIdx = this.gfx.executeOperatorList(this.operatorList, this.operatorListIdx, this._continueBound, this.stepper);
                if (this.operatorListIdx === this.operatorList.argsArray.length) {
                    this.running = false;
                    if (this.operatorList.lastChunk) {
                        this.gfx.endDrawing();
                        __classPrivateFieldGet(_o, _o, "f", _InternalRenderTask_canvasInUse).delete(this._canvas);
                        this.callback();
                    }
                }
                return [2 /*return*/];
            });
        });
    };
    var _o, _InternalRenderTask_rAF, _InternalRenderTask_canvasInUse;
    _o = InternalRenderTask, _InternalRenderTask_rAF = new WeakMap();
    _InternalRenderTask_canvasInUse = { value: new WeakSet() };
    return InternalRenderTask;
}());
var version = "5.2.133";
var build = "4f7761353";
; // ./src/shared/scripting_utils.js
function makeColorComp(n) {
    return Math.floor(Math.max(0, Math.min(1, n)) * 255).toString(16).padStart(2, "0");
}
function scaleAndClamp(x) {
    return Math.max(0, Math.min(255, 255 * x));
}
var ColorConverters = /** @class */ (function () {
    function ColorConverters() {
    }
    ColorConverters.CMYK_G = function (_p) {
        var _q = __read(_p, 4), c = _q[0], y = _q[1], m = _q[2], k = _q[3];
        return ["G", 1 - Math.min(1, 0.3 * c + 0.59 * m + 0.11 * y + k)];
    };
    ColorConverters.G_CMYK = function (_p) {
        var _q = __read(_p, 1), g = _q[0];
        return ["CMYK", 0, 0, 0, 1 - g];
    };
    ColorConverters.G_RGB = function (_p) {
        var _q = __read(_p, 1), g = _q[0];
        return ["RGB", g, g, g];
    };
    ColorConverters.G_rgb = function (_p) {
        var _q = __read(_p, 1), g = _q[0];
        g = scaleAndClamp(g);
        return [g, g, g];
    };
    ColorConverters.G_HTML = function (_p) {
        var _q = __read(_p, 1), g = _q[0];
        var G = makeColorComp(g);
        return "#".concat(G).concat(G).concat(G);
    };
    ColorConverters.RGB_G = function (_p) {
        var _q = __read(_p, 3), r = _q[0], g = _q[1], b = _q[2];
        return ["G", 0.3 * r + 0.59 * g + 0.11 * b];
    };
    ColorConverters.RGB_rgb = function (color) {
        return color.map(scaleAndClamp);
    };
    ColorConverters.RGB_HTML = function (color) {
        return "#".concat(color.map(makeColorComp).join(""));
    };
    ColorConverters.T_HTML = function () {
        return "#00000000";
    };
    ColorConverters.T_rgb = function () {
        return [null];
    };
    ColorConverters.CMYK_RGB = function (_p) {
        var _q = __read(_p, 4), c = _q[0], y = _q[1], m = _q[2], k = _q[3];
        return ["RGB", 1 - Math.min(1, c + k), 1 - Math.min(1, m + k), 1 - Math.min(1, y + k)];
    };
    ColorConverters.CMYK_rgb = function (_p) {
        var _q = __read(_p, 4), c = _q[0], y = _q[1], m = _q[2], k = _q[3];
        return [scaleAndClamp(1 - Math.min(1, c + k)), scaleAndClamp(1 - Math.min(1, m + k)), scaleAndClamp(1 - Math.min(1, y + k))];
    };
    ColorConverters.CMYK_HTML = function (components) {
        var rgb = this.CMYK_RGB(components).slice(1);
        return this.RGB_HTML(rgb);
    };
    ColorConverters.RGB_CMYK = function (_p) {
        var _q = __read(_p, 3), r = _q[0], g = _q[1], b = _q[2];
        var c = 1 - r;
        var m = 1 - g;
        var y = 1 - b;
        var k = Math.min(c, m, y);
        return ["CMYK", c, m, y, k];
    };
    return ColorConverters;
}());
; // ./src/display/svg_factory.js
var BaseSVGFactory = /** @class */ (function () {
    function BaseSVGFactory() {
    }
    BaseSVGFactory.prototype.create = function (width, height, skipDimensions) {
        if (skipDimensions === void 0) { skipDimensions = false; }
        if (width <= 0 || height <= 0) {
            throw new Error("Invalid SVG dimensions");
        }
        var svg = this._createSVG("svg:svg");
        svg.setAttribute("version", "1.1");
        if (!skipDimensions) {
            svg.setAttribute("width", "".concat(width, "px"));
            svg.setAttribute("height", "".concat(height, "px"));
        }
        svg.setAttribute("preserveAspectRatio", "none");
        svg.setAttribute("viewBox", "0 0 ".concat(width, " ").concat(height));
        return svg;
    };
    BaseSVGFactory.prototype.createElement = function (type) {
        if (typeof type !== "string") {
            throw new Error("Invalid SVG element type");
        }
        return this._createSVG(type);
    };
    BaseSVGFactory.prototype._createSVG = function (type) {
        unreachable("Abstract method `_createSVG` called.");
    };
    return BaseSVGFactory;
}());
var DOMSVGFactory = /** @class */ (function (_super) {
    __extends(DOMSVGFactory, _super);
    function DOMSVGFactory() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    DOMSVGFactory.prototype._createSVG = function (type) {
        return document.createElementNS(SVG_NS, type);
    };
    return DOMSVGFactory;
}(BaseSVGFactory));
; // ./src/display/xfa_layer.js
var XfaLayer = /** @class */ (function () {
    function XfaLayer() {
    }
    XfaLayer.setupStorage = function (html, id, element, storage, intent) {
        var e_130, _p;
        var storedData = storage.getValue(id, {
            value: null
        });
        switch (element.name) {
            case "textarea":
                if (storedData.value !== null) {
                    html.textContent = storedData.value;
                }
                if (intent === "print") {
                    break;
                }
                html.addEventListener("input", function (event) {
                    storage.setValue(id, {
                        value: event.target.value
                    });
                });
                break;
            case "input":
                if (element.attributes.type === "radio" || element.attributes.type === "checkbox") {
                    if (storedData.value === element.attributes.xfaOn) {
                        html.setAttribute("checked", true);
                    }
                    else if (storedData.value === element.attributes.xfaOff) {
                        html.removeAttribute("checked");
                    }
                    if (intent === "print") {
                        break;
                    }
                    html.addEventListener("change", function (event) {
                        storage.setValue(id, {
                            value: event.target.checked ? event.target.getAttribute("xfaOn") : event.target.getAttribute("xfaOff")
                        });
                    });
                }
                else {
                    if (storedData.value !== null) {
                        html.setAttribute("value", storedData.value);
                    }
                    if (intent === "print") {
                        break;
                    }
                    html.addEventListener("input", function (event) {
                        storage.setValue(id, {
                            value: event.target.value
                        });
                    });
                }
                break;
            case "select":
                if (storedData.value !== null) {
                    html.setAttribute("value", storedData.value);
                    try {
                        for (var _q = __values(element.children), _r = _q.next(); !_r.done; _r = _q.next()) {
                            var option = _r.value;
                            if (option.attributes.value === storedData.value) {
                                option.attributes.selected = true;
                            }
                            else if (option.attributes.hasOwnProperty("selected")) {
                                delete option.attributes.selected;
                            }
                        }
                    }
                    catch (e_130_1) { e_130 = { error: e_130_1 }; }
                    finally {
                        try {
                            if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
                        }
                        finally { if (e_130) throw e_130.error; }
                    }
                }
                html.addEventListener("input", function (event) {
                    var options = event.target.options;
                    var value = options.selectedIndex === -1 ? "" : options[options.selectedIndex].value;
                    storage.setValue(id, {
                        value: value
                    });
                });
                break;
        }
    };
    XfaLayer.setAttributes = function (_p) {
        var e_131, _q;
        var html = _p.html, element = _p.element, _r = _p.storage, storage = _r === void 0 ? null : _r, intent = _p.intent, linkService = _p.linkService;
        var attributes = element.attributes;
        var isHTMLAnchorElement = html instanceof HTMLAnchorElement;
        if (attributes.type === "radio") {
            attributes.name = "".concat(attributes.name, "-").concat(intent);
        }
        try {
            for (var _s = __values(Object.entries(attributes)), _t = _s.next(); !_t.done; _t = _s.next()) {
                var _u = __read(_t.value, 2), key = _u[0], value = _u[1];
                if (value === null || value === undefined) {
                    continue;
                }
                switch (key) {
                    case "class":
                        if (value.length) {
                            html.setAttribute(key, value.join(" "));
                        }
                        break;
                    case "dataId":
                        break;
                    case "id":
                        html.setAttribute("data-element-id", value);
                        break;
                    case "style":
                        Object.assign(html.style, value);
                        break;
                    case "textContent":
                        html.textContent = value;
                        break;
                    default:
                        if (!isHTMLAnchorElement || key !== "href" && key !== "newWindow") {
                            html.setAttribute(key, value);
                        }
                }
            }
        }
        catch (e_131_1) { e_131 = { error: e_131_1 }; }
        finally {
            try {
                if (_t && !_t.done && (_q = _s.return)) _q.call(_s);
            }
            finally { if (e_131) throw e_131.error; }
        }
        if (isHTMLAnchorElement) {
            linkService.addLinkAttributes(html, attributes.href, attributes.newWindow);
        }
        if (storage && attributes.dataId) {
            this.setupStorage(html, attributes.dataId, element, storage);
        }
    };
    XfaLayer.render = function (parameters) {
        var e_132, _p;
        var _q, _r;
        var storage = parameters.annotationStorage;
        var linkService = parameters.linkService;
        var root = parameters.xfaHtml;
        var intent = parameters.intent || "display";
        var rootHtml = document.createElement(root.name);
        if (root.attributes) {
            this.setAttributes({
                html: rootHtml,
                element: root,
                intent: intent,
                linkService: linkService
            });
        }
        var isNotForRichText = intent !== "richText";
        var rootDiv = parameters.div;
        rootDiv.append(rootHtml);
        if (parameters.viewport) {
            var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
            rootDiv.style.transform = transform;
        }
        if (isNotForRichText) {
            rootDiv.setAttribute("class", "xfaLayer xfaFont");
        }
        var textDivs = [];
        if (root.children.length === 0) {
            if (root.value) {
                var node = document.createTextNode(root.value);
                rootHtml.append(node);
                if (isNotForRichText && XfaText.shouldBuildText(root.name)) {
                    textDivs.push(node);
                }
            }
            return {
                textDivs: textDivs
            };
        }
        var stack = [[root, -1, rootHtml]];
        while (stack.length > 0) {
            var _s = __read(stack.at(-1), 3), parent = _s[0], i = _s[1], html = _s[2];
            if (i + 1 === parent.children.length) {
                stack.pop();
                continue;
            }
            var child = parent.children[++stack.at(-1)[1]];
            if (child === null) {
                continue;
            }
            var name = child.name;
            if (name === "#text") {
                var node = document.createTextNode(child.value);
                textDivs.push(node);
                html.append(node);
                continue;
            }
            var childHtml = ((_q = child === null || child === void 0 ? void 0 : child.attributes) === null || _q === void 0 ? void 0 : _q.xmlns) ? document.createElementNS(child.attributes.xmlns, name) : document.createElement(name);
            html.append(childHtml);
            if (child.attributes) {
                this.setAttributes({
                    html: childHtml,
                    element: child,
                    storage: storage,
                    intent: intent,
                    linkService: linkService
                });
            }
            if (((_r = child.children) === null || _r === void 0 ? void 0 : _r.length) > 0) {
                stack.push([child, -1, childHtml]);
            }
            else if (child.value) {
                var node = document.createTextNode(child.value);
                if (isNotForRichText && XfaText.shouldBuildText(name)) {
                    textDivs.push(node);
                }
                childHtml.append(node);
            }
        }
        try {
            for (var _t = __values(rootDiv.querySelectorAll(".xfaNonInteractive input, .xfaNonInteractive textarea")), _u = _t.next(); !_u.done; _u = _t.next()) {
                var el = _u.value;
                el.setAttribute("readOnly", true);
            }
        }
        catch (e_132_1) { e_132 = { error: e_132_1 }; }
        finally {
            try {
                if (_u && !_u.done && (_p = _t.return)) _p.call(_t);
            }
            finally { if (e_132) throw e_132.error; }
        }
        return {
            textDivs: textDivs
        };
    };
    XfaLayer.update = function (parameters) {
        var transform = "matrix(".concat(parameters.viewport.transform.join(","), ")");
        parameters.div.style.transform = transform;
        parameters.div.hidden = false;
    };
    return XfaLayer;
}());
; // ./src/display/annotation_layer.js
var DEFAULT_TAB_INDEX = 1000;
var annotation_layer_DEFAULT_FONT_SIZE = 9;
var GetElementsByNameSet = new WeakSet();
var AnnotationElementFactory = /** @class */ (function () {
    function AnnotationElementFactory() {
    }
    AnnotationElementFactory.create = function (parameters) {
        var subtype = parameters.data.annotationType;
        switch (subtype) {
            case AnnotationType.LINK:
                return new LinkAnnotationElement(parameters);
            case AnnotationType.TEXT:
                return new TextAnnotationElement(parameters);
            case AnnotationType.WIDGET:
                var fieldType = parameters.data.fieldType;
                switch (fieldType) {
                    case "Tx":
                        return new TextWidgetAnnotationElement(parameters);
                    case "Btn":
                        if (parameters.data.radioButton) {
                            return new RadioButtonWidgetAnnotationElement(parameters);
                        }
                        else if (parameters.data.checkBox) {
                            return new CheckboxWidgetAnnotationElement(parameters);
                        }
                        return new PushButtonWidgetAnnotationElement(parameters);
                    case "Ch":
                        return new ChoiceWidgetAnnotationElement(parameters);
                    case "Sig":
                        return new SignatureWidgetAnnotationElement(parameters);
                }
                return new WidgetAnnotationElement(parameters);
            case AnnotationType.POPUP:
                return new PopupAnnotationElement(parameters);
            case AnnotationType.FREETEXT:
                return new FreeTextAnnotationElement(parameters);
            case AnnotationType.LINE:
                return new LineAnnotationElement(parameters);
            case AnnotationType.SQUARE:
                return new SquareAnnotationElement(parameters);
            case AnnotationType.CIRCLE:
                return new CircleAnnotationElement(parameters);
            case AnnotationType.POLYLINE:
                return new PolylineAnnotationElement(parameters);
            case AnnotationType.CARET:
                return new CaretAnnotationElement(parameters);
            case AnnotationType.INK:
                return new InkAnnotationElement(parameters);
            case AnnotationType.POLYGON:
                return new PolygonAnnotationElement(parameters);
            case AnnotationType.HIGHLIGHT:
                return new HighlightAnnotationElement(parameters);
            case AnnotationType.UNDERLINE:
                return new UnderlineAnnotationElement(parameters);
            case AnnotationType.SQUIGGLY:
                return new SquigglyAnnotationElement(parameters);
            case AnnotationType.STRIKEOUT:
                return new StrikeOutAnnotationElement(parameters);
            case AnnotationType.STAMP:
                return new StampAnnotationElement(parameters);
            case AnnotationType.FILEATTACHMENT:
                return new FileAttachmentAnnotationElement(parameters);
            default:
                return new AnnotationElement(parameters);
        }
    };
    return AnnotationElementFactory;
}());
var AnnotationElement = /** @class */ (function () {
    function AnnotationElement(parameters, _p) {
        var _q = _p === void 0 ? {} : _p, _r = _q.isRenderable, isRenderable = _r === void 0 ? false : _r, _s = _q.ignoreBorder, ignoreBorder = _s === void 0 ? false : _s, _t = _q.createQuadrilaterals, createQuadrilaterals = _t === void 0 ? false : _t;
        _AnnotationElement_instances.add(this);
        _AnnotationElement_updates.set(this, null);
        _AnnotationElement_hasBorder.set(this, false);
        _AnnotationElement_popupElement.set(this, null);
        this.isRenderable = isRenderable;
        this.data = parameters.data;
        this.layer = parameters.layer;
        this.linkService = parameters.linkService;
        this.downloadManager = parameters.downloadManager;
        this.imageResourcesPath = parameters.imageResourcesPath;
        this.renderForms = parameters.renderForms;
        this.svgFactory = parameters.svgFactory;
        this.annotationStorage = parameters.annotationStorage;
        this.enableScripting = parameters.enableScripting;
        this.hasJSActions = parameters.hasJSActions;
        this._fieldObjects = parameters.fieldObjects;
        this.parent = parameters.parent;
        if (isRenderable) {
            this.container = this._createContainer(ignoreBorder);
        }
        if (createQuadrilaterals) {
            this._createQuadrilaterals();
        }
    }
    AnnotationElement._hasPopupData = function (_p) {
        var titleObj = _p.titleObj, contentsObj = _p.contentsObj, richText = _p.richText;
        return !!((titleObj === null || titleObj === void 0 ? void 0 : titleObj.str) || (contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || (richText === null || richText === void 0 ? void 0 : richText.str));
    };
    Object.defineProperty(AnnotationElement.prototype, "_isEditable", {
        get: function () {
            return this.data.isEditable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationElement.prototype, "hasPopupData", {
        get: function () {
            return AnnotationElement._hasPopupData(this.data);
        },
        enumerable: false,
        configurable: true
    });
    AnnotationElement.prototype.updateEdited = function (params) {
        var _p;
        if (!this.container) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationElement_updates, __classPrivateFieldGet(this, _AnnotationElement_updates, "f") || {
            rect: this.data.rect.slice(0)
        }, "f");
        var rect = params.rect;
        if (rect) {
            __classPrivateFieldGet(this, _AnnotationElement_instances, "m", _AnnotationElement_setRectEdited).call(this, rect);
        }
        (_p = __classPrivateFieldGet(this, _AnnotationElement_popupElement, "f")) === null || _p === void 0 ? void 0 : _p.popup.updateEdited(params);
    };
    AnnotationElement.prototype.resetEdited = function () {
        var _p;
        if (!__classPrivateFieldGet(this, _AnnotationElement_updates, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _AnnotationElement_instances, "m", _AnnotationElement_setRectEdited).call(this, __classPrivateFieldGet(this, _AnnotationElement_updates, "f").rect);
        (_p = __classPrivateFieldGet(this, _AnnotationElement_popupElement, "f")) === null || _p === void 0 ? void 0 : _p.popup.resetEdited();
        __classPrivateFieldSet(this, _AnnotationElement_updates, null, "f");
    };
    AnnotationElement.prototype._createContainer = function (ignoreBorder) {
        var _p = this, data = _p.data, _q = _p.parent, page = _q.page, viewport = _q.viewport;
        var container = document.createElement("section");
        container.setAttribute("data-annotation-id", data.id);
        if (!(this instanceof WidgetAnnotationElement)) {
            container.tabIndex = DEFAULT_TAB_INDEX;
        }
        var style = container.style;
        style.zIndex = this.parent.zIndex++;
        if (data.alternativeText) {
            container.title = data.alternativeText;
        }
        if (data.noRotate) {
            container.classList.add("norotate");
        }
        if (!data.rect || this instanceof PopupAnnotationElement) {
            var rotation_1 = data.rotation;
            if (!data.hasOwnCanvas && rotation_1 !== 0) {
                this.setRotation(rotation_1, container);
            }
            return container;
        }
        var _r = this, width = _r.width, height = _r.height;
        if (!ignoreBorder && data.borderStyle.width > 0) {
            style.borderWidth = "".concat(data.borderStyle.width, "px");
            var horizontalRadius = data.borderStyle.horizontalCornerRadius;
            var verticalRadius = data.borderStyle.verticalCornerRadius;
            if (horizontalRadius > 0 || verticalRadius > 0) {
                var radius = "calc(".concat(horizontalRadius, "px * var(--total-scale-factor)) / calc(").concat(verticalRadius, "px * var(--total-scale-factor))");
                style.borderRadius = radius;
            }
            else if (this instanceof RadioButtonWidgetAnnotationElement) {
                var radius = "calc(".concat(width, "px * var(--total-scale-factor)) / calc(").concat(height, "px * var(--total-scale-factor))");
                style.borderRadius = radius;
            }
            switch (data.borderStyle.style) {
                case AnnotationBorderStyleType.SOLID:
                    style.borderStyle = "solid";
                    break;
                case AnnotationBorderStyleType.DASHED:
                    style.borderStyle = "dashed";
                    break;
                case AnnotationBorderStyleType.BEVELED:
                    warn("Unimplemented border style: beveled");
                    break;
                case AnnotationBorderStyleType.INSET:
                    warn("Unimplemented border style: inset");
                    break;
                case AnnotationBorderStyleType.UNDERLINE:
                    style.borderBottomStyle = "solid";
                    break;
                default:
                    break;
            }
            var borderColor = data.borderColor || null;
            if (borderColor) {
                __classPrivateFieldSet(this, _AnnotationElement_hasBorder, true, "f");
                style.borderColor = Util.makeHexColor(borderColor[0] | 0, borderColor[1] | 0, borderColor[2] | 0);
            }
            else {
                style.borderWidth = 0;
            }
        }
        var rect = Util.normalizeRect([data.rect[0], page.view[3] - data.rect[1] + page.view[1], data.rect[2], page.view[3] - data.rect[3] + page.view[1]]);
        var _s = viewport.rawDims, pageWidth = _s.pageWidth, pageHeight = _s.pageHeight, pageX = _s.pageX, pageY = _s.pageY;
        style.left = "".concat(100 * (rect[0] - pageX) / pageWidth, "%");
        style.top = "".concat(100 * (rect[1] - pageY) / pageHeight, "%");
        var rotation = data.rotation;
        if (data.hasOwnCanvas || rotation === 0) {
            style.width = "".concat(100 * width / pageWidth, "%");
            style.height = "".concat(100 * height / pageHeight, "%");
        }
        else {
            this.setRotation(rotation, container);
        }
        return container;
    };
    AnnotationElement.prototype.setRotation = function (angle, container) {
        var _p;
        if (container === void 0) { container = this.container; }
        if (!this.data.rect) {
            return;
        }
        var _q = this.parent.viewport.rawDims, pageWidth = _q.pageWidth, pageHeight = _q.pageHeight;
        var _r = this, width = _r.width, height = _r.height;
        if (angle % 180 !== 0) {
            _p = __read([height, width], 2), width = _p[0], height = _p[1];
        }
        container.style.width = "".concat(100 * width / pageWidth, "%");
        container.style.height = "".concat(100 * height / pageHeight, "%");
        container.setAttribute("data-main-rotation", (360 - angle) % 360);
    };
    Object.defineProperty(AnnotationElement.prototype, "_commonActions", {
        get: function () {
            var _this = this;
            var setColor = function (jsName, styleName, event) {
                var _p;
                var color = event.detail[jsName];
                var colorType = color[0];
                var colorArray = color.slice(1);
                event.target.style[styleName] = ColorConverters["".concat(colorType, "_HTML")](colorArray);
                _this.annotationStorage.setValue(_this.data.id, (_p = {},
                    _p[styleName] = ColorConverters["".concat(colorType, "_rgb")](colorArray),
                    _p));
            };
            return shadow(this, "_commonActions", {
                display: function (event) {
                    var display = event.detail.display;
                    var hidden = display % 2 === 1;
                    _this.container.style.visibility = hidden ? "hidden" : "visible";
                    _this.annotationStorage.setValue(_this.data.id, {
                        noView: hidden,
                        noPrint: display === 1 || display === 2
                    });
                },
                print: function (event) {
                    _this.annotationStorage.setValue(_this.data.id, {
                        noPrint: !event.detail.print
                    });
                },
                hidden: function (event) {
                    var hidden = event.detail.hidden;
                    _this.container.style.visibility = hidden ? "hidden" : "visible";
                    _this.annotationStorage.setValue(_this.data.id, {
                        noPrint: hidden,
                        noView: hidden
                    });
                },
                focus: function (event) {
                    setTimeout(function () { return event.target.focus({
                        preventScroll: false
                    }); }, 0);
                },
                userName: function (event) {
                    event.target.title = event.detail.userName;
                },
                readonly: function (event) {
                    event.target.disabled = event.detail.readonly;
                },
                required: function (event) {
                    _this._setRequired(event.target, event.detail.required);
                },
                bgColor: function (event) {
                    setColor("bgColor", "backgroundColor", event);
                },
                fillColor: function (event) {
                    setColor("fillColor", "backgroundColor", event);
                },
                fgColor: function (event) {
                    setColor("fgColor", "color", event);
                },
                textColor: function (event) {
                    setColor("textColor", "color", event);
                },
                borderColor: function (event) {
                    setColor("borderColor", "borderColor", event);
                },
                strokeColor: function (event) {
                    setColor("strokeColor", "borderColor", event);
                },
                rotation: function (event) {
                    var angle = event.detail.rotation;
                    _this.setRotation(angle);
                    _this.annotationStorage.setValue(_this.data.id, {
                        rotation: angle
                    });
                }
            });
        },
        enumerable: false,
        configurable: true
    });
    AnnotationElement.prototype._dispatchEventFromSandbox = function (actions, jsEvent) {
        var e_133, _p;
        var commonActions = this._commonActions;
        try {
            for (var _q = __values(Object.keys(jsEvent.detail)), _r = _q.next(); !_r.done; _r = _q.next()) {
                var name = _r.value;
                var action = actions[name] || commonActions[name];
                action === null || action === void 0 ? void 0 : action(jsEvent);
            }
        }
        catch (e_133_1) { e_133 = { error: e_133_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
            }
            finally { if (e_133) throw e_133.error; }
        }
    };
    AnnotationElement.prototype._setDefaultPropertiesFromJS = function (element) {
        var e_134, _p, _q;
        if (!this.enableScripting) {
            return;
        }
        var storedData = this.annotationStorage.getRawValue(this.data.id);
        if (!storedData) {
            return;
        }
        var commonActions = this._commonActions;
        try {
            for (var _r = __values(Object.entries(storedData)), _s = _r.next(); !_s.done; _s = _r.next()) {
                var _t = __read(_s.value, 2), actionName = _t[0], detail = _t[1];
                var action = commonActions[actionName];
                if (action) {
                    var eventProxy = {
                        detail: (_q = {},
                            _q[actionName] = detail,
                            _q),
                        target: element
                    };
                    action(eventProxy);
                    delete storedData[actionName];
                }
            }
        }
        catch (e_134_1) { e_134 = { error: e_134_1 }; }
        finally {
            try {
                if (_s && !_s.done && (_p = _r.return)) _p.call(_r);
            }
            finally { if (e_134) throw e_134.error; }
        }
    };
    AnnotationElement.prototype._createQuadrilaterals = function () {
        if (!this.container) {
            return;
        }
        var quadPoints = this.data.quadPoints;
        if (!quadPoints) {
            return;
        }
        var _p = __read(this.data.rect.map(function (x) { return Math.fround(x); }), 4), rectBlX = _p[0], rectBlY = _p[1], rectTrX = _p[2], rectTrY = _p[3];
        if (quadPoints.length === 8) {
            var _q = __read(quadPoints.subarray(2, 6), 4), trX = _q[0], trY = _q[1], blX = _q[2], blY = _q[3];
            if (rectTrX === trX && rectTrY === trY && rectBlX === blX && rectBlY === blY) {
                return;
            }
        }
        var style = this.container.style;
        var svgBuffer;
        if (__classPrivateFieldGet(this, _AnnotationElement_hasBorder, "f")) {
            var borderColor = style.borderColor, borderWidth = style.borderWidth;
            style.borderWidth = 0;
            svgBuffer = ["url('data:image/svg+xml;utf8,", "<svg xmlns=\"http://www.w3.org/2000/svg\"", " preserveAspectRatio=\"none\" viewBox=\"0 0 1 1\">", "<g fill=\"transparent\" stroke=\"".concat(borderColor, "\" stroke-width=\"").concat(borderWidth, "\">")];
            this.container.classList.add("hasBorder");
        }
        var width = rectTrX - rectBlX;
        var height = rectTrY - rectBlY;
        var svgFactory = this.svgFactory;
        var svg = svgFactory.createElement("svg");
        svg.classList.add("quadrilateralsContainer");
        svg.setAttribute("width", 0);
        svg.setAttribute("height", 0);
        var defs = svgFactory.createElement("defs");
        svg.append(defs);
        var clipPath = svgFactory.createElement("clipPath");
        var id = "clippath_".concat(this.data.id);
        clipPath.setAttribute("id", id);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        defs.append(clipPath);
        for (var i = 2, ii = quadPoints.length; i < ii; i += 8) {
            var trX = quadPoints[i];
            var trY = quadPoints[i + 1];
            var blX = quadPoints[i + 2];
            var blY = quadPoints[i + 3];
            var rect = svgFactory.createElement("rect");
            var x = (blX - rectBlX) / width;
            var y = (rectTrY - trY) / height;
            var rectWidth = (trX - blX) / width;
            var rectHeight = (trY - blY) / height;
            rect.setAttribute("x", x);
            rect.setAttribute("y", y);
            rect.setAttribute("width", rectWidth);
            rect.setAttribute("height", rectHeight);
            clipPath.append(rect);
            svgBuffer === null || svgBuffer === void 0 ? void 0 : svgBuffer.push("<rect vector-effect=\"non-scaling-stroke\" x=\"".concat(x, "\" y=\"").concat(y, "\" width=\"").concat(rectWidth, "\" height=\"").concat(rectHeight, "\"/>"));
        }
        if (__classPrivateFieldGet(this, _AnnotationElement_hasBorder, "f")) {
            svgBuffer.push("</g></svg>')");
            style.backgroundImage = svgBuffer.join("");
        }
        this.container.append(svg);
        this.container.style.clipPath = "url(#".concat(id, ")");
    };
    AnnotationElement.prototype._createPopup = function () {
        var data = this.data;
        var popup = __classPrivateFieldSet(this, _AnnotationElement_popupElement, new PopupAnnotationElement({
            data: {
                color: data.color,
                titleObj: data.titleObj,
                modificationDate: data.modificationDate,
                contentsObj: data.contentsObj,
                richText: data.richText,
                parentRect: data.rect,
                borderStyle: 0,
                id: "popup_".concat(data.id),
                rotation: data.rotation
            },
            parent: this.parent,
            elements: [this]
        }), "f");
        this.parent.div.append(popup.render());
    };
    AnnotationElement.prototype.render = function () {
        unreachable("Abstract method `AnnotationElement.render` called");
    };
    AnnotationElement.prototype._getElementsByName = function (name, skipId) {
        var e_135, _p, e_136, _q;
        if (skipId === void 0) { skipId = null; }
        var fields = [];
        if (this._fieldObjects) {
            var fieldObj = this._fieldObjects[name];
            if (fieldObj) {
                try {
                    for (var fieldObj_1 = __values(fieldObj), fieldObj_1_1 = fieldObj_1.next(); !fieldObj_1_1.done; fieldObj_1_1 = fieldObj_1.next()) {
                        var _r = fieldObj_1_1.value, page = _r.page, id = _r.id, exportValues = _r.exportValues;
                        if (page === -1) {
                            continue;
                        }
                        if (id === skipId) {
                            continue;
                        }
                        var exportValue = typeof exportValues === "string" ? exportValues : null;
                        var domElement = document.querySelector("[data-element-id=\"".concat(id, "\"]"));
                        if (domElement && !GetElementsByNameSet.has(domElement)) {
                            warn("_getElementsByName - element not allowed: ".concat(id));
                            continue;
                        }
                        fields.push({
                            id: id,
                            exportValue: exportValue,
                            domElement: domElement
                        });
                    }
                }
                catch (e_135_1) { e_135 = { error: e_135_1 }; }
                finally {
                    try {
                        if (fieldObj_1_1 && !fieldObj_1_1.done && (_p = fieldObj_1.return)) _p.call(fieldObj_1);
                    }
                    finally { if (e_135) throw e_135.error; }
                }
            }
            return fields;
        }
        try {
            for (var _s = __values(document.getElementsByName(name)), _t = _s.next(); !_t.done; _t = _s.next()) {
                var domElement = _t.value;
                var exportValue = domElement.exportValue;
                var id = domElement.getAttribute("data-element-id");
                if (id === skipId) {
                    continue;
                }
                if (!GetElementsByNameSet.has(domElement)) {
                    continue;
                }
                fields.push({
                    id: id,
                    exportValue: exportValue,
                    domElement: domElement
                });
            }
        }
        catch (e_136_1) { e_136 = { error: e_136_1 }; }
        finally {
            try {
                if (_t && !_t.done && (_q = _s.return)) _q.call(_s);
            }
            finally { if (e_136) throw e_136.error; }
        }
        return fields;
    };
    AnnotationElement.prototype.show = function () {
        var _p;
        if (this.container) {
            this.container.hidden = false;
        }
        (_p = this.popup) === null || _p === void 0 ? void 0 : _p.maybeShow();
    };
    AnnotationElement.prototype.hide = function () {
        var _p;
        if (this.container) {
            this.container.hidden = true;
        }
        (_p = this.popup) === null || _p === void 0 ? void 0 : _p.forceHide();
    };
    AnnotationElement.prototype.getElementsToTriggerPopup = function () {
        return this.container;
    };
    AnnotationElement.prototype.addHighlightArea = function () {
        var e_137, _p;
        var triggers = this.getElementsToTriggerPopup();
        if (Array.isArray(triggers)) {
            try {
                for (var triggers_1 = __values(triggers), triggers_1_1 = triggers_1.next(); !triggers_1_1.done; triggers_1_1 = triggers_1.next()) {
                    var element = triggers_1_1.value;
                    element.classList.add("highlightArea");
                }
            }
            catch (e_137_1) { e_137 = { error: e_137_1 }; }
            finally {
                try {
                    if (triggers_1_1 && !triggers_1_1.done && (_p = triggers_1.return)) _p.call(triggers_1);
                }
                finally { if (e_137) throw e_137.error; }
            }
        }
        else {
            triggers.classList.add("highlightArea");
        }
    };
    AnnotationElement.prototype._editOnDoubleClick = function () {
        var _this = this;
        if (!this._isEditable) {
            return;
        }
        var _p = this, mode = _p.annotationEditorType, editId = _p.data.id;
        this.container.addEventListener("dblclick", function () {
            var _p;
            (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("switchannotationeditormode", {
                source: _this,
                mode: mode,
                editId: editId
            });
        });
    };
    Object.defineProperty(AnnotationElement.prototype, "width", {
        get: function () {
            return this.data.rect[2] - this.data.rect[0];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationElement.prototype, "height", {
        get: function () {
            return this.data.rect[3] - this.data.rect[1];
        },
        enumerable: false,
        configurable: true
    });
    return AnnotationElement;
}());
_AnnotationElement_updates = new WeakMap(), _AnnotationElement_hasBorder = new WeakMap(), _AnnotationElement_popupElement = new WeakMap(), _AnnotationElement_instances = new WeakSet(), _AnnotationElement_setRectEdited = function _AnnotationElement_setRectEdited(rect) {
    var _p = this, style = _p.container.style, _q = _p.data, currentRect = _q.rect, rotation = _q.rotation, _r = _p.parent.viewport.rawDims, pageWidth = _r.pageWidth, pageHeight = _r.pageHeight, pageX = _r.pageX, pageY = _r.pageY;
    currentRect === null || currentRect === void 0 ? void 0 : currentRect.splice.apply(currentRect, __spreadArray([0, 4], __read(rect), false));
    style.left = "".concat(100 * (rect[0] - pageX) / pageWidth, "%");
    style.top = "".concat(100 * (pageHeight - rect[3] + pageY) / pageHeight, "%");
    if (rotation === 0) {
        style.width = "".concat(100 * (rect[2] - rect[0]) / pageWidth, "%");
        style.height = "".concat(100 * (rect[3] - rect[1]) / pageHeight, "%");
    }
    else {
        this.setRotation(rotation);
    }
};
var LinkAnnotationElement = /** @class */ (function (_super) {
    __extends(LinkAnnotationElement, _super);
    function LinkAnnotationElement(parameters, options) {
        if (options === void 0) { options = null; }
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: !!(options === null || options === void 0 ? void 0 : options.ignoreBorder),
            createQuadrilaterals: true
        }) || this;
        _LinkAnnotationElement_instances.add(_this);
        _this.isTooltipOnly = parameters.data.isTooltipOnly;
        return _this;
    }
    LinkAnnotationElement.prototype.render = function () {
        var _p = this, data = _p.data, linkService = _p.linkService;
        var link = document.createElement("a");
        link.setAttribute("data-element-id", data.id);
        var isBound = false;
        if (data.url) {
            linkService.addLinkAttributes(link, data.url, data.newWindow);
            isBound = true;
        }
        else if (data.action) {
            this._bindNamedAction(link, data.action);
            isBound = true;
        }
        else if (data.attachment) {
            __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_bindAttachment).call(this, link, data.attachment, data.attachmentDest);
            isBound = true;
        }
        else if (data.setOCGState) {
            __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_bindSetOCGState).call(this, link, data.setOCGState);
            isBound = true;
        }
        else if (data.dest) {
            this._bindLink(link, data.dest);
            isBound = true;
        }
        else {
            if (data.actions && (data.actions.Action || data.actions["Mouse Up"] || data.actions["Mouse Down"]) && this.enableScripting && this.hasJSActions) {
                this._bindJSAction(link, data);
                isBound = true;
            }
            if (data.resetForm) {
                this._bindResetFormAction(link, data.resetForm);
                isBound = true;
            }
            else if (this.isTooltipOnly && !isBound) {
                this._bindLink(link, "");
                isBound = true;
            }
        }
        this.container.classList.add("linkAnnotation");
        if (isBound) {
            this.container.append(link);
        }
        return this.container;
    };
    LinkAnnotationElement.prototype._bindLink = function (link, destination) {
        var _this = this;
        link.href = this.linkService.getDestinationHash(destination);
        link.onclick = function () {
            if (destination) {
                _this.linkService.goToDestination(destination);
            }
            return false;
        };
        if (destination || destination === "") {
            __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
        }
    };
    LinkAnnotationElement.prototype._bindNamedAction = function (link, action) {
        var _this = this;
        link.href = this.linkService.getAnchorUrl("");
        link.onclick = function () {
            _this.linkService.executeNamedAction(action);
            return false;
        };
        __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
    };
    LinkAnnotationElement.prototype._bindJSAction = function (link, data) {
        var e_138, _p;
        var _this = this;
        link.href = this.linkService.getAnchorUrl("");
        var map = new Map([["Action", "onclick"], ["Mouse Up", "onmouseup"], ["Mouse Down", "onmousedown"]]);
        var _loop_1 = function (name) {
            var jsName = map.get(name);
            if (!jsName) {
                return "continue";
            }
            link[jsName] = function () {
                var _p;
                (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("dispatcheventinsandbox", {
                    source: _this,
                    detail: {
                        id: data.id,
                        name: name
                    }
                });
                return false;
            };
        };
        try {
            for (var _q = __values(Object.keys(data.actions)), _r = _q.next(); !_r.done; _r = _q.next()) {
                var name = _r.value;
                _loop_1(name);
            }
        }
        catch (e_138_1) { e_138 = { error: e_138_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
            }
            finally { if (e_138) throw e_138.error; }
        }
        if (!link.onclick) {
            link.onclick = function () { return false; };
        }
        __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
    };
    LinkAnnotationElement.prototype._bindResetFormAction = function (link, resetForm) {
        var _this = this;
        var otherClickAction = link.onclick;
        if (!otherClickAction) {
            link.href = this.linkService.getAnchorUrl("");
        }
        __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
        if (!this._fieldObjects) {
            warn("_bindResetFormAction - \"resetForm\" action not supported, " + "ensure that the `fieldObjects` parameter is provided.");
            if (!otherClickAction) {
                link.onclick = function () { return false; };
            }
            return;
        }
        link.onclick = function () {
            var e_139, _p, e_140, _q, e_141, _r, e_142, _s, e_143, _t, e_144, _u;
            var _v;
            otherClickAction === null || otherClickAction === void 0 ? void 0 : otherClickAction();
            var resetFormFields = resetForm.fields, resetFormRefs = resetForm.refs, include = resetForm.include;
            var allFields = [];
            if (resetFormFields.length !== 0 || resetFormRefs.length !== 0) {
                var fieldIds = new Set(resetFormRefs);
                try {
                    for (var resetFormFields_1 = __values(resetFormFields), resetFormFields_1_1 = resetFormFields_1.next(); !resetFormFields_1_1.done; resetFormFields_1_1 = resetFormFields_1.next()) {
                        var fieldName = resetFormFields_1_1.value;
                        var fields = _this._fieldObjects[fieldName] || [];
                        try {
                            for (var fields_1 = (e_140 = void 0, __values(fields)), fields_1_1 = fields_1.next(); !fields_1_1.done; fields_1_1 = fields_1.next()) {
                                var id = fields_1_1.value.id;
                                fieldIds.add(id);
                            }
                        }
                        catch (e_140_1) { e_140 = { error: e_140_1 }; }
                        finally {
                            try {
                                if (fields_1_1 && !fields_1_1.done && (_q = fields_1.return)) _q.call(fields_1);
                            }
                            finally { if (e_140) throw e_140.error; }
                        }
                    }
                }
                catch (e_139_1) { e_139 = { error: e_139_1 }; }
                finally {
                    try {
                        if (resetFormFields_1_1 && !resetFormFields_1_1.done && (_p = resetFormFields_1.return)) _p.call(resetFormFields_1);
                    }
                    finally { if (e_139) throw e_139.error; }
                }
                try {
                    for (var _w = __values(Object.values(_this._fieldObjects)), _z = _w.next(); !_z.done; _z = _w.next()) {
                        var fields = _z.value;
                        try {
                            for (var fields_2 = (e_142 = void 0, __values(fields)), fields_2_1 = fields_2.next(); !fields_2_1.done; fields_2_1 = fields_2.next()) {
                                var field = fields_2_1.value;
                                if (fieldIds.has(field.id) === include) {
                                    allFields.push(field);
                                }
                            }
                        }
                        catch (e_142_1) { e_142 = { error: e_142_1 }; }
                        finally {
                            try {
                                if (fields_2_1 && !fields_2_1.done && (_s = fields_2.return)) _s.call(fields_2);
                            }
                            finally { if (e_142) throw e_142.error; }
                        }
                    }
                }
                catch (e_141_1) { e_141 = { error: e_141_1 }; }
                finally {
                    try {
                        if (_z && !_z.done && (_r = _w.return)) _r.call(_w);
                    }
                    finally { if (e_141) throw e_141.error; }
                }
            }
            else {
                try {
                    for (var _0 = __values(Object.values(_this._fieldObjects)), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                        var fields = _1.value;
                        allFields.push.apply(allFields, __spreadArray([], __read(fields), false));
                    }
                }
                catch (e_143_1) { e_143 = { error: e_143_1 }; }
                finally {
                    try {
                        if (_1 && !_1.done && (_t = _0.return)) _t.call(_0);
                    }
                    finally { if (e_143) throw e_143.error; }
                }
            }
            var storage = _this.annotationStorage;
            var allIds = [];
            try {
                for (var allFields_1 = __values(allFields), allFields_1_1 = allFields_1.next(); !allFields_1_1.done; allFields_1_1 = allFields_1.next()) {
                    var field = allFields_1_1.value;
                    var id = field.id;
                    allIds.push(id);
                    switch (field.type) {
                        case "text":
                            {
                                var value = field.defaultValue || "";
                                storage.setValue(id, {
                                    value: value
                                });
                                break;
                            }
                        case "checkbox":
                        case "radiobutton":
                            {
                                var value = field.defaultValue === field.exportValues;
                                storage.setValue(id, {
                                    value: value
                                });
                                break;
                            }
                        case "combobox":
                        case "listbox":
                            {
                                var value = field.defaultValue || "";
                                storage.setValue(id, {
                                    value: value
                                });
                                break;
                            }
                        default:
                            continue;
                    }
                    var domElement = document.querySelector("[data-element-id=\"".concat(id, "\"]"));
                    if (!domElement) {
                        continue;
                    }
                    else if (!GetElementsByNameSet.has(domElement)) {
                        warn("_bindResetFormAction - element not allowed: ".concat(id));
                        continue;
                    }
                    domElement.dispatchEvent(new Event("resetform"));
                }
            }
            catch (e_144_1) { e_144 = { error: e_144_1 }; }
            finally {
                try {
                    if (allFields_1_1 && !allFields_1_1.done && (_u = allFields_1.return)) _u.call(allFields_1);
                }
                finally { if (e_144) throw e_144.error; }
            }
            if (_this.enableScripting) {
                (_v = _this.linkService.eventBus) === null || _v === void 0 ? void 0 : _v.dispatch("dispatcheventinsandbox", {
                    source: _this,
                    detail: {
                        id: "app",
                        ids: allIds,
                        name: "ResetForm"
                    }
                });
            }
            return false;
        };
    };
    return LinkAnnotationElement;
}(AnnotationElement));
_LinkAnnotationElement_instances = new WeakSet(), _LinkAnnotationElement_setInternalLink = function _LinkAnnotationElement_setInternalLink() {
    this.container.setAttribute("data-internal-link", "");
}, _LinkAnnotationElement_bindAttachment = function _LinkAnnotationElement_bindAttachment(link, attachment, dest) {
    var _this = this;
    if (dest === void 0) { dest = null; }
    link.href = this.linkService.getAnchorUrl("");
    if (attachment.description) {
        link.title = attachment.description;
    }
    link.onclick = function () {
        var _p;
        (_p = _this.downloadManager) === null || _p === void 0 ? void 0 : _p.openOrDownloadData(attachment.content, attachment.filename, dest);
        return false;
    };
    __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
}, _LinkAnnotationElement_bindSetOCGState = function _LinkAnnotationElement_bindSetOCGState(link, action) {
    var _this = this;
    link.href = this.linkService.getAnchorUrl("");
    link.onclick = function () {
        _this.linkService.executeSetOCGState(action);
        return false;
    };
    __classPrivateFieldGet(this, _LinkAnnotationElement_instances, "m", _LinkAnnotationElement_setInternalLink).call(this);
};
var TextAnnotationElement = /** @class */ (function (_super) {
    __extends(TextAnnotationElement, _super);
    function TextAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: true
        }) || this;
    }
    TextAnnotationElement.prototype.render = function () {
        this.container.classList.add("textAnnotation");
        var image = document.createElement("img");
        image.src = this.imageResourcesPath + "annotation-" + this.data.name.toLowerCase() + ".svg";
        image.setAttribute("data-l10n-id", "pdfjs-text-annotation-type");
        image.setAttribute("data-l10n-args", JSON.stringify({
            type: this.data.name
        }));
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this.container.append(image);
        return this.container;
    };
    return TextAnnotationElement;
}(AnnotationElement));
var WidgetAnnotationElement = /** @class */ (function (_super) {
    __extends(WidgetAnnotationElement, _super);
    function WidgetAnnotationElement() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    WidgetAnnotationElement.prototype.render = function () {
        return this.container;
    };
    WidgetAnnotationElement.prototype.showElementAndHideCanvas = function (element) {
        var _p;
        if (this.data.hasOwnCanvas) {
            if (((_p = element.previousSibling) === null || _p === void 0 ? void 0 : _p.nodeName) === "CANVAS") {
                element.previousSibling.hidden = true;
            }
            element.hidden = false;
        }
    };
    WidgetAnnotationElement.prototype._getKeyModifier = function (event) {
        return util_FeatureTest.platform.isMac ? event.metaKey : event.ctrlKey;
    };
    WidgetAnnotationElement.prototype._setEventListener = function (element, elementData, baseName, eventName, valueGetter) {
        var _this = this;
        if (baseName.includes("mouse")) {
            element.addEventListener(baseName, function (event) {
                var _p;
                (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("dispatcheventinsandbox", {
                    source: _this,
                    detail: {
                        id: _this.data.id,
                        name: eventName,
                        value: valueGetter(event),
                        shift: event.shiftKey,
                        modifier: _this._getKeyModifier(event)
                    }
                });
            });
        }
        else {
            element.addEventListener(baseName, function (event) {
                var _p;
                if (baseName === "blur") {
                    if (!elementData.focused || !event.relatedTarget) {
                        return;
                    }
                    elementData.focused = false;
                }
                else if (baseName === "focus") {
                    if (elementData.focused) {
                        return;
                    }
                    elementData.focused = true;
                }
                if (!valueGetter) {
                    return;
                }
                (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("dispatcheventinsandbox", {
                    source: _this,
                    detail: {
                        id: _this.data.id,
                        name: eventName,
                        value: valueGetter(event)
                    }
                });
            });
        }
    };
    WidgetAnnotationElement.prototype._setEventListeners = function (element, elementData, names, getter) {
        var e_145, _p;
        var _q, _r, _s;
        try {
            for (var names_2 = __values(names), names_2_1 = names_2.next(); !names_2_1.done; names_2_1 = names_2.next()) {
                var _t = __read(names_2_1.value, 2), baseName = _t[0], eventName = _t[1];
                if (eventName === "Action" || ((_q = this.data.actions) === null || _q === void 0 ? void 0 : _q[eventName])) {
                    if (eventName === "Focus" || eventName === "Blur") {
                        elementData || (elementData = {
                            focused: false
                        });
                    }
                    this._setEventListener(element, elementData, baseName, eventName, getter);
                    if (eventName === "Focus" && !((_r = this.data.actions) === null || _r === void 0 ? void 0 : _r.Blur)) {
                        this._setEventListener(element, elementData, "blur", "Blur", null);
                    }
                    else if (eventName === "Blur" && !((_s = this.data.actions) === null || _s === void 0 ? void 0 : _s.Focus)) {
                        this._setEventListener(element, elementData, "focus", "Focus", null);
                    }
                }
            }
        }
        catch (e_145_1) { e_145 = { error: e_145_1 }; }
        finally {
            try {
                if (names_2_1 && !names_2_1.done && (_p = names_2.return)) _p.call(names_2);
            }
            finally { if (e_145) throw e_145.error; }
        }
    };
    WidgetAnnotationElement.prototype._setBackgroundColor = function (element) {
        var color = this.data.backgroundColor || null;
        element.style.backgroundColor = color === null ? "transparent" : Util.makeHexColor(color[0], color[1], color[2]);
    };
    WidgetAnnotationElement.prototype._setTextStyle = function (element) {
        var TEXT_ALIGNMENT = ["left", "center", "right"];
        var fontColor = this.data.defaultAppearanceData.fontColor;
        var fontSize = this.data.defaultAppearanceData.fontSize || annotation_layer_DEFAULT_FONT_SIZE;
        var style = element.style;
        var computedFontSize;
        var BORDER_SIZE = 2;
        var roundToOneDecimal = function (x) { return Math.round(10 * x) / 10; };
        if (this.data.multiLine) {
            var height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            var numberOfLines = Math.round(height / (LINE_FACTOR * fontSize)) || 1;
            var lineHeight = height / numberOfLines;
            computedFontSize = Math.min(fontSize, roundToOneDecimal(lineHeight / LINE_FACTOR));
        }
        else {
            var height = Math.abs(this.data.rect[3] - this.data.rect[1] - BORDER_SIZE);
            computedFontSize = Math.min(fontSize, roundToOneDecimal(height / LINE_FACTOR));
        }
        style.fontSize = "calc(".concat(computedFontSize, "px * var(--total-scale-factor))");
        style.color = Util.makeHexColor(fontColor[0], fontColor[1], fontColor[2]);
        if (this.data.textAlignment !== null) {
            style.textAlign = TEXT_ALIGNMENT[this.data.textAlignment];
        }
    };
    WidgetAnnotationElement.prototype._setRequired = function (element, isRequired) {
        if (isRequired) {
            element.setAttribute("required", true);
        }
        else {
            element.removeAttribute("required");
        }
        element.setAttribute("aria-required", isRequired);
    };
    return WidgetAnnotationElement;
}(AnnotationElement));
var TextWidgetAnnotationElement = /** @class */ (function (_super) {
    __extends(TextWidgetAnnotationElement, _super);
    function TextWidgetAnnotationElement(parameters) {
        var isRenderable = parameters.renderForms || parameters.data.hasOwnCanvas || !parameters.data.hasAppearance && !!parameters.data.fieldValue;
        return _super.call(this, parameters, {
            isRenderable: isRenderable
        }) || this;
    }
    TextWidgetAnnotationElement.prototype.setPropertyOnSiblings = function (base, key, value, keyInStorage) {
        var e_146, _p, _q;
        var storage = this.annotationStorage;
        try {
            for (var _r = __values(this._getElementsByName(base.name, base.id)), _s = _r.next(); !_s.done; _s = _r.next()) {
                var element = _s.value;
                if (element.domElement) {
                    element.domElement[key] = value;
                }
                storage.setValue(element.id, (_q = {},
                    _q[keyInStorage] = value,
                    _q));
            }
        }
        catch (e_146_1) { e_146 = { error: e_146_1 }; }
        finally {
            try {
                if (_s && !_s.done && (_p = _r.return)) _p.call(_r);
            }
            finally { if (e_146) throw e_146.error; }
        }
    };
    TextWidgetAnnotationElement.prototype.render = function () {
        var _this = this;
        var _p, _q;
        var storage = this.annotationStorage;
        var id = this.data.id;
        this.container.classList.add("textWidgetAnnotation");
        var element = null;
        if (this.renderForms) {
            var storedData = storage.getValue(id, {
                value: this.data.fieldValue
            });
            var textContent = storedData.value || "";
            var maxLen = storage.getValue(id, {
                charLimit: this.data.maxLen
            }).charLimit;
            if (maxLen && textContent.length > maxLen) {
                textContent = textContent.slice(0, maxLen);
            }
            var fieldFormattedValues = storedData.formattedValue || ((_p = this.data.textContent) === null || _p === void 0 ? void 0 : _p.join("\n")) || null;
            if (fieldFormattedValues && this.data.comb) {
                fieldFormattedValues = fieldFormattedValues.replaceAll(/\s+/g, "");
            }
            var elementData_1 = {
                userValue: textContent,
                formattedValue: fieldFormattedValues,
                lastCommittedValue: null,
                commitKey: 1,
                focused: false
            };
            if (this.data.multiLine) {
                element = document.createElement("textarea");
                element.textContent = fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent;
                if (this.data.doNotScroll) {
                    element.style.overflowY = "hidden";
                }
            }
            else {
                element = document.createElement("input");
                element.type = this.data.password ? "password" : "text";
                element.setAttribute("value", fieldFormattedValues !== null && fieldFormattedValues !== void 0 ? fieldFormattedValues : textContent);
                if (this.data.doNotScroll) {
                    element.style.overflowX = "hidden";
                }
            }
            if (this.data.hasOwnCanvas) {
                element.hidden = true;
            }
            GetElementsByNameSet.add(element);
            element.setAttribute("data-element-id", id);
            element.disabled = this.data.readOnly;
            element.name = this.data.fieldName;
            element.tabIndex = DEFAULT_TAB_INDEX;
            this._setRequired(element, this.data.required);
            if (maxLen) {
                element.maxLength = maxLen;
            }
            element.addEventListener("input", function (event) {
                storage.setValue(id, {
                    value: event.target.value
                });
                _this.setPropertyOnSiblings(element, "value", event.target.value, "value");
                elementData_1.formattedValue = null;
            });
            element.addEventListener("resetform", function (event) {
                var _p;
                var defaultValue = (_p = _this.data.defaultFieldValue) !== null && _p !== void 0 ? _p : "";
                element.value = elementData_1.userValue = defaultValue;
                elementData_1.formattedValue = null;
            });
            var blurListener = function (event) {
                var formattedValue = elementData_1.formattedValue;
                if (formattedValue !== null && formattedValue !== undefined) {
                    event.target.value = formattedValue;
                }
                event.target.scrollLeft = 0;
            };
            if (this.enableScripting && this.hasJSActions) {
                element.addEventListener("focus", function (event) {
                    var _p;
                    if (elementData_1.focused) {
                        return;
                    }
                    var target = event.target;
                    if (elementData_1.userValue) {
                        target.value = elementData_1.userValue;
                    }
                    elementData_1.lastCommittedValue = target.value;
                    elementData_1.commitKey = 1;
                    if (!((_p = _this.data.actions) === null || _p === void 0 ? void 0 : _p.Focus)) {
                        elementData_1.focused = true;
                    }
                });
                element.addEventListener("updatefromsandbox", function (jsEvent) {
                    _this.showElementAndHideCanvas(jsEvent.target);
                    var actions = {
                        value: function (event) {
                            var _p;
                            elementData_1.userValue = (_p = event.detail.value) !== null && _p !== void 0 ? _p : "";
                            storage.setValue(id, {
                                value: elementData_1.userValue.toString()
                            });
                            event.target.value = elementData_1.userValue;
                        },
                        formattedValue: function (event) {
                            var formattedValue = event.detail.formattedValue;
                            elementData_1.formattedValue = formattedValue;
                            if (formattedValue !== null && formattedValue !== undefined && event.target !== document.activeElement) {
                                event.target.value = formattedValue;
                            }
                            storage.setValue(id, {
                                formattedValue: formattedValue
                            });
                        },
                        selRange: function (event) {
                            var _p;
                            (_p = event.target).setSelectionRange.apply(_p, __spreadArray([], __read(event.detail.selRange), false));
                        },
                        charLimit: function (event) {
                            var _p;
                            var charLimit = event.detail.charLimit;
                            var target = event.target;
                            if (charLimit === 0) {
                                target.removeAttribute("maxLength");
                                return;
                            }
                            target.setAttribute("maxLength", charLimit);
                            var value = elementData_1.userValue;
                            if (!value || value.length <= charLimit) {
                                return;
                            }
                            value = value.slice(0, charLimit);
                            target.value = elementData_1.userValue = value;
                            storage.setValue(id, {
                                value: value
                            });
                            (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("dispatcheventinsandbox", {
                                source: _this,
                                detail: {
                                    id: id,
                                    name: "Keystroke",
                                    value: value,
                                    willCommit: true,
                                    commitKey: 1,
                                    selStart: target.selectionStart,
                                    selEnd: target.selectionEnd
                                }
                            });
                        }
                    };
                    _this._dispatchEventFromSandbox(actions, jsEvent);
                });
                element.addEventListener("keydown", function (event) {
                    var _p;
                    elementData_1.commitKey = 1;
                    var commitKey = -1;
                    if (event.key === "Escape") {
                        commitKey = 0;
                    }
                    else if (event.key === "Enter" && !_this.data.multiLine) {
                        commitKey = 2;
                    }
                    else if (event.key === "Tab") {
                        elementData_1.commitKey = 3;
                    }
                    if (commitKey === -1) {
                        return;
                    }
                    var value = event.target.value;
                    if (elementData_1.lastCommittedValue === value) {
                        return;
                    }
                    elementData_1.lastCommittedValue = value;
                    elementData_1.userValue = value;
                    (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("dispatcheventinsandbox", {
                        source: _this,
                        detail: {
                            id: id,
                            name: "Keystroke",
                            value: value,
                            willCommit: true,
                            commitKey: commitKey,
                            selStart: event.target.selectionStart,
                            selEnd: event.target.selectionEnd
                        }
                    });
                });
                var _blurListener_1 = blurListener;
                blurListener = null;
                element.addEventListener("blur", function (event) {
                    var _p, _q;
                    if (!elementData_1.focused || !event.relatedTarget) {
                        return;
                    }
                    if (!((_p = _this.data.actions) === null || _p === void 0 ? void 0 : _p.Blur)) {
                        elementData_1.focused = false;
                    }
                    var value = event.target.value;
                    elementData_1.userValue = value;
                    if (elementData_1.lastCommittedValue !== value) {
                        (_q = _this.linkService.eventBus) === null || _q === void 0 ? void 0 : _q.dispatch("dispatcheventinsandbox", {
                            source: _this,
                            detail: {
                                id: id,
                                name: "Keystroke",
                                value: value,
                                willCommit: true,
                                commitKey: elementData_1.commitKey,
                                selStart: event.target.selectionStart,
                                selEnd: event.target.selectionEnd
                            }
                        });
                    }
                    _blurListener_1(event);
                });
                if ((_q = this.data.actions) === null || _q === void 0 ? void 0 : _q.Keystroke) {
                    element.addEventListener("beforeinput", function (event) {
                        var _p;
                        elementData_1.lastCommittedValue = null;
                        var data = event.data, target = event.target;
                        var value = target.value, selectionStart = target.selectionStart, selectionEnd = target.selectionEnd;
                        var selStart = selectionStart, selEnd = selectionEnd;
                        switch (event.inputType) {
                            case "deleteWordBackward":
                                {
                                    var match = value.substring(0, selectionStart).match(/\w*[^\w]*$/);
                                    if (match) {
                                        selStart -= match[0].length;
                                    }
                                    break;
                                }
                            case "deleteWordForward":
                                {
                                    var match = value.substring(selectionStart).match(/^[^\w]*\w*/);
                                    if (match) {
                                        selEnd += match[0].length;
                                    }
                                    break;
                                }
                            case "deleteContentBackward":
                                if (selectionStart === selectionEnd) {
                                    selStart -= 1;
                                }
                                break;
                            case "deleteContentForward":
                                if (selectionStart === selectionEnd) {
                                    selEnd += 1;
                                }
                                break;
                        }
                        event.preventDefault();
                        (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("dispatcheventinsandbox", {
                            source: _this,
                            detail: {
                                id: id,
                                name: "Keystroke",
                                value: value,
                                change: data || "",
                                willCommit: false,
                                selStart: selStart,
                                selEnd: selEnd
                            }
                        });
                    });
                }
                this._setEventListeners(element, elementData_1, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) { return event.target.value; });
            }
            if (blurListener) {
                element.addEventListener("blur", blurListener);
            }
            if (this.data.comb) {
                var fieldWidth = this.data.rect[2] - this.data.rect[0];
                var combWidth = fieldWidth / maxLen;
                element.classList.add("comb");
                element.style.letterSpacing = "calc(".concat(combWidth, "px * var(--total-scale-factor) - 1ch)");
            }
        }
        else {
            element = document.createElement("div");
            element.textContent = this.data.fieldValue;
            element.style.verticalAlign = "middle";
            element.style.display = "table-cell";
            if (this.data.hasOwnCanvas) {
                element.hidden = true;
            }
        }
        this._setTextStyle(element);
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    };
    return TextWidgetAnnotationElement;
}(WidgetAnnotationElement));
var SignatureWidgetAnnotationElement = /** @class */ (function (_super) {
    __extends(SignatureWidgetAnnotationElement, _super);
    function SignatureWidgetAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: !!parameters.data.hasOwnCanvas
        }) || this;
    }
    return SignatureWidgetAnnotationElement;
}(WidgetAnnotationElement));
var CheckboxWidgetAnnotationElement = /** @class */ (function (_super) {
    __extends(CheckboxWidgetAnnotationElement, _super);
    function CheckboxWidgetAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: parameters.renderForms
        }) || this;
    }
    CheckboxWidgetAnnotationElement.prototype.render = function () {
        var _this = this;
        var storage = this.annotationStorage;
        var data = this.data;
        var id = data.id;
        var value = storage.getValue(id, {
            value: data.exportValue === data.fieldValue
        }).value;
        if (typeof value === "string") {
            value = value !== "Off";
            storage.setValue(id, {
                value: value
            });
        }
        this.container.classList.add("buttonWidgetAnnotation", "checkBox");
        var element = document.createElement("input");
        GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "checkbox";
        element.name = data.fieldName;
        if (value) {
            element.setAttribute("checked", true);
        }
        element.setAttribute("exportValue", data.exportValue);
        element.tabIndex = DEFAULT_TAB_INDEX;
        element.addEventListener("change", function (event) {
            var e_147, _p;
            var _q = event.target, name = _q.name, checked = _q.checked;
            try {
                for (var _r = __values(_this._getElementsByName(name, id)), _s = _r.next(); !_s.done; _s = _r.next()) {
                    var checkbox = _s.value;
                    var curChecked = checked && checkbox.exportValue === data.exportValue;
                    if (checkbox.domElement) {
                        checkbox.domElement.checked = curChecked;
                    }
                    storage.setValue(checkbox.id, {
                        value: curChecked
                    });
                }
            }
            catch (e_147_1) { e_147 = { error: e_147_1 }; }
            finally {
                try {
                    if (_s && !_s.done && (_p = _r.return)) _p.call(_r);
                }
                finally { if (e_147) throw e_147.error; }
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", function (event) {
            var defaultValue = data.defaultFieldValue || "Off";
            event.target.checked = defaultValue === data.exportValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            element.addEventListener("updatefromsandbox", function (jsEvent) {
                var actions = {
                    value: function (event) {
                        event.target.checked = event.detail.value !== "Off";
                        storage.setValue(id, {
                            value: event.target.checked
                        });
                    }
                };
                _this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) { return event.target.checked; });
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    };
    return CheckboxWidgetAnnotationElement;
}(WidgetAnnotationElement));
var RadioButtonWidgetAnnotationElement = /** @class */ (function (_super) {
    __extends(RadioButtonWidgetAnnotationElement, _super);
    function RadioButtonWidgetAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: parameters.renderForms
        }) || this;
    }
    RadioButtonWidgetAnnotationElement.prototype.render = function () {
        var e_148, _p;
        var _this = this;
        this.container.classList.add("buttonWidgetAnnotation", "radioButton");
        var storage = this.annotationStorage;
        var data = this.data;
        var id = data.id;
        var value = storage.getValue(id, {
            value: data.fieldValue === data.buttonValue
        }).value;
        if (typeof value === "string") {
            value = value !== data.buttonValue;
            storage.setValue(id, {
                value: value
            });
        }
        if (value) {
            try {
                for (var _q = __values(this._getElementsByName(data.fieldName, id)), _r = _q.next(); !_r.done; _r = _q.next()) {
                    var radio = _r.value;
                    storage.setValue(radio.id, {
                        value: false
                    });
                }
            }
            catch (e_148_1) { e_148 = { error: e_148_1 }; }
            finally {
                try {
                    if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
                }
                finally { if (e_148) throw e_148.error; }
            }
        }
        var element = document.createElement("input");
        GetElementsByNameSet.add(element);
        element.setAttribute("data-element-id", id);
        element.disabled = data.readOnly;
        this._setRequired(element, this.data.required);
        element.type = "radio";
        element.name = data.fieldName;
        if (value) {
            element.setAttribute("checked", true);
        }
        element.tabIndex = DEFAULT_TAB_INDEX;
        element.addEventListener("change", function (event) {
            var e_149, _p;
            var _q = event.target, name = _q.name, checked = _q.checked;
            try {
                for (var _r = __values(_this._getElementsByName(name, id)), _s = _r.next(); !_s.done; _s = _r.next()) {
                    var radio = _s.value;
                    storage.setValue(radio.id, {
                        value: false
                    });
                }
            }
            catch (e_149_1) { e_149 = { error: e_149_1 }; }
            finally {
                try {
                    if (_s && !_s.done && (_p = _r.return)) _p.call(_r);
                }
                finally { if (e_149) throw e_149.error; }
            }
            storage.setValue(id, {
                value: checked
            });
        });
        element.addEventListener("resetform", function (event) {
            var defaultValue = data.defaultFieldValue;
            event.target.checked = defaultValue !== null && defaultValue !== undefined && defaultValue === data.buttonValue;
        });
        if (this.enableScripting && this.hasJSActions) {
            var pdfButtonValue_1 = data.buttonValue;
            element.addEventListener("updatefromsandbox", function (jsEvent) {
                var actions = {
                    value: function (event) {
                        var e_150, _p;
                        var checked = pdfButtonValue_1 === event.detail.value;
                        try {
                            for (var _q = __values(_this._getElementsByName(event.target.name)), _r = _q.next(); !_r.done; _r = _q.next()) {
                                var radio = _r.value;
                                var curChecked = checked && radio.id === id;
                                if (radio.domElement) {
                                    radio.domElement.checked = curChecked;
                                }
                                storage.setValue(radio.id, {
                                    value: curChecked
                                });
                            }
                        }
                        catch (e_150_1) { e_150 = { error: e_150_1 }; }
                        finally {
                            try {
                                if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
                            }
                            finally { if (e_150) throw e_150.error; }
                        }
                    }
                };
                _this._dispatchEventFromSandbox(actions, jsEvent);
            });
            this._setEventListeners(element, null, [["change", "Validate"], ["change", "Action"], ["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"]], function (event) { return event.target.checked; });
        }
        this._setBackgroundColor(element);
        this._setDefaultPropertiesFromJS(element);
        this.container.append(element);
        return this.container;
    };
    return RadioButtonWidgetAnnotationElement;
}(WidgetAnnotationElement));
var PushButtonWidgetAnnotationElement = /** @class */ (function (_super) {
    __extends(PushButtonWidgetAnnotationElement, _super);
    function PushButtonWidgetAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            ignoreBorder: parameters.data.hasAppearance
        }) || this;
    }
    PushButtonWidgetAnnotationElement.prototype.render = function () {
        var _this = this;
        var container = _super.prototype.render.call(this);
        container.classList.add("buttonWidgetAnnotation", "pushButton");
        var linkElement = container.lastChild;
        if (this.enableScripting && this.hasJSActions && linkElement) {
            this._setDefaultPropertiesFromJS(linkElement);
            linkElement.addEventListener("updatefromsandbox", function (jsEvent) {
                _this._dispatchEventFromSandbox({}, jsEvent);
            });
        }
        return container;
    };
    return PushButtonWidgetAnnotationElement;
}(LinkAnnotationElement));
var ChoiceWidgetAnnotationElement = /** @class */ (function (_super) {
    __extends(ChoiceWidgetAnnotationElement, _super);
    function ChoiceWidgetAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: parameters.renderForms
        }) || this;
    }
    ChoiceWidgetAnnotationElement.prototype.render = function () {
        var e_151, _p;
        var _this = this;
        this.container.classList.add("choiceWidgetAnnotation");
        var storage = this.annotationStorage;
        var id = this.data.id;
        var storedData = storage.getValue(id, {
            value: this.data.fieldValue
        });
        var selectElement = document.createElement("select");
        GetElementsByNameSet.add(selectElement);
        selectElement.setAttribute("data-element-id", id);
        selectElement.disabled = this.data.readOnly;
        this._setRequired(selectElement, this.data.required);
        selectElement.name = this.data.fieldName;
        selectElement.tabIndex = DEFAULT_TAB_INDEX;
        var addAnEmptyEntry = this.data.combo && this.data.options.length > 0;
        if (!this.data.combo) {
            selectElement.size = this.data.options.length;
            if (this.data.multiSelect) {
                selectElement.multiple = true;
            }
        }
        selectElement.addEventListener("resetform", function (event) {
            var e_152, _p;
            var defaultValue = _this.data.defaultFieldValue;
            try {
                for (var _q = __values(selectElement.options), _r = _q.next(); !_r.done; _r = _q.next()) {
                    var option = _r.value;
                    option.selected = option.value === defaultValue;
                }
            }
            catch (e_152_1) { e_152 = { error: e_152_1 }; }
            finally {
                try {
                    if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
                }
                finally { if (e_152) throw e_152.error; }
            }
        });
        try {
            for (var _q = __values(this.data.options), _r = _q.next(); !_r.done; _r = _q.next()) {
                var option = _r.value;
                var optionElement = document.createElement("option");
                optionElement.textContent = option.displayValue;
                optionElement.value = option.exportValue;
                if (storedData.value.includes(option.exportValue)) {
                    optionElement.setAttribute("selected", true);
                    addAnEmptyEntry = false;
                }
                selectElement.append(optionElement);
            }
        }
        catch (e_151_1) { e_151 = { error: e_151_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
            }
            finally { if (e_151) throw e_151.error; }
        }
        var removeEmptyEntry = null;
        if (addAnEmptyEntry) {
            var noneOptionElement_1 = document.createElement("option");
            noneOptionElement_1.value = " ";
            noneOptionElement_1.setAttribute("hidden", true);
            noneOptionElement_1.setAttribute("selected", true);
            selectElement.prepend(noneOptionElement_1);
            removeEmptyEntry = function () {
                noneOptionElement_1.remove();
                selectElement.removeEventListener("input", removeEmptyEntry);
                removeEmptyEntry = null;
            };
            selectElement.addEventListener("input", removeEmptyEntry);
        }
        var getValue = function (isExport) {
            var name = isExport ? "value" : "textContent";
            var options = selectElement.options, multiple = selectElement.multiple;
            if (!multiple) {
                return options.selectedIndex === -1 ? null : options[options.selectedIndex][name];
            }
            return Array.prototype.filter.call(options, function (option) { return option.selected; }).map(function (option) { return option[name]; });
        };
        var selectedValues = getValue(false);
        var getItems = function (event) {
            var options = event.target.options;
            return Array.prototype.map.call(options, function (option) { return ({
                displayValue: option.textContent,
                exportValue: option.value
            }); });
        };
        if (this.enableScripting && this.hasJSActions) {
            selectElement.addEventListener("updatefromsandbox", function (jsEvent) {
                var actions = {
                    value: function (event) {
                        var e_153, _p;
                        removeEmptyEntry === null || removeEmptyEntry === void 0 ? void 0 : removeEmptyEntry();
                        var value = event.detail.value;
                        var values = new Set(Array.isArray(value) ? value : [value]);
                        try {
                            for (var _q = __values(selectElement.options), _r = _q.next(); !_r.done; _r = _q.next()) {
                                var option = _r.value;
                                option.selected = values.has(option.value);
                            }
                        }
                        catch (e_153_1) { e_153 = { error: e_153_1 }; }
                        finally {
                            try {
                                if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
                            }
                            finally { if (e_153) throw e_153.error; }
                        }
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    multipleSelection: function (event) {
                        selectElement.multiple = true;
                    },
                    remove: function (event) {
                        var options = selectElement.options;
                        var index = event.detail.remove;
                        options[index].selected = false;
                        selectElement.remove(index);
                        if (options.length > 0) {
                            var i = Array.prototype.findIndex.call(options, function (option) { return option.selected; });
                            if (i === -1) {
                                options[0].selected = true;
                            }
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    clear: function (event) {
                        while (selectElement.length !== 0) {
                            selectElement.remove(0);
                        }
                        storage.setValue(id, {
                            value: null,
                            items: []
                        });
                        selectedValues = getValue(false);
                    },
                    insert: function (event) {
                        var _p = event.detail.insert, index = _p.index, displayValue = _p.displayValue, exportValue = _p.exportValue;
                        var selectChild = selectElement.children[index];
                        var optionElement = document.createElement("option");
                        optionElement.textContent = displayValue;
                        optionElement.value = exportValue;
                        if (selectChild) {
                            selectChild.before(optionElement);
                        }
                        else {
                            selectElement.append(optionElement);
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    items: function (event) {
                        var e_154, _p;
                        var items = event.detail.items;
                        while (selectElement.length !== 0) {
                            selectElement.remove(0);
                        }
                        try {
                            for (var items_2 = __values(items), items_2_1 = items_2.next(); !items_2_1.done; items_2_1 = items_2.next()) {
                                var item = items_2_1.value;
                                var displayValue = item.displayValue, exportValue = item.exportValue;
                                var optionElement = document.createElement("option");
                                optionElement.textContent = displayValue;
                                optionElement.value = exportValue;
                                selectElement.append(optionElement);
                            }
                        }
                        catch (e_154_1) { e_154 = { error: e_154_1 }; }
                        finally {
                            try {
                                if (items_2_1 && !items_2_1.done && (_p = items_2.return)) _p.call(items_2);
                            }
                            finally { if (e_154) throw e_154.error; }
                        }
                        if (selectElement.options.length > 0) {
                            selectElement.options[0].selected = true;
                        }
                        storage.setValue(id, {
                            value: getValue(true),
                            items: getItems(event)
                        });
                        selectedValues = getValue(false);
                    },
                    indices: function (event) {
                        var e_155, _p;
                        var indices = new Set(event.detail.indices);
                        try {
                            for (var _q = __values(event.target.options), _r = _q.next(); !_r.done; _r = _q.next()) {
                                var option = _r.value;
                                option.selected = indices.has(option.index);
                            }
                        }
                        catch (e_155_1) { e_155 = { error: e_155_1 }; }
                        finally {
                            try {
                                if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
                            }
                            finally { if (e_155) throw e_155.error; }
                        }
                        storage.setValue(id, {
                            value: getValue(true)
                        });
                        selectedValues = getValue(false);
                    },
                    editable: function (event) {
                        event.target.disabled = !event.detail.editable;
                    }
                };
                _this._dispatchEventFromSandbox(actions, jsEvent);
            });
            selectElement.addEventListener("input", function (event) {
                var _p;
                var exportValue = getValue(true);
                var change = getValue(false);
                storage.setValue(id, {
                    value: exportValue
                });
                event.preventDefault();
                (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("dispatcheventinsandbox", {
                    source: _this,
                    detail: {
                        id: id,
                        name: "Keystroke",
                        value: selectedValues,
                        change: change,
                        changeEx: exportValue,
                        willCommit: false,
                        commitKey: 1,
                        keyDown: false
                    }
                });
            });
            this._setEventListeners(selectElement, null, [["focus", "Focus"], ["blur", "Blur"], ["mousedown", "Mouse Down"], ["mouseenter", "Mouse Enter"], ["mouseleave", "Mouse Exit"], ["mouseup", "Mouse Up"], ["input", "Action"], ["input", "Validate"]], function (event) { return event.target.value; });
        }
        else {
            selectElement.addEventListener("input", function (event) {
                storage.setValue(id, {
                    value: getValue(true)
                });
            });
        }
        if (this.data.combo) {
            this._setTextStyle(selectElement);
        }
        else { }
        this._setBackgroundColor(selectElement);
        this._setDefaultPropertiesFromJS(selectElement);
        this.container.append(selectElement);
        return this.container;
    };
    return ChoiceWidgetAnnotationElement;
}(WidgetAnnotationElement));
var PopupAnnotationElement = /** @class */ (function (_super) {
    __extends(PopupAnnotationElement, _super);
    function PopupAnnotationElement(parameters) {
        var _this = this;
        var data = parameters.data, elements = parameters.elements;
        _this = _super.call(this, parameters, {
            isRenderable: AnnotationElement._hasPopupData(data)
        }) || this;
        _this.elements = elements;
        _this.popup = null;
        return _this;
    }
    PopupAnnotationElement.prototype.render = function () {
        var e_156, _p;
        this.container.classList.add("popupAnnotation");
        var popup = this.popup = new PopupElement({
            container: this.container,
            color: this.data.color,
            titleObj: this.data.titleObj,
            modificationDate: this.data.modificationDate,
            contentsObj: this.data.contentsObj,
            richText: this.data.richText,
            rect: this.data.rect,
            parentRect: this.data.parentRect || null,
            parent: this.parent,
            elements: this.elements,
            open: this.data.open
        });
        var elementIds = [];
        try {
            for (var _q = __values(this.elements), _r = _q.next(); !_r.done; _r = _q.next()) {
                var element = _r.value;
                element.popup = popup;
                element.container.ariaHasPopup = "dialog";
                elementIds.push(element.data.id);
                element.addHighlightArea();
            }
        }
        catch (e_156_1) { e_156 = { error: e_156_1 }; }
        finally {
            try {
                if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
            }
            finally { if (e_156) throw e_156.error; }
        }
        this.container.setAttribute("aria-controls", elementIds.map(function (id) { return "".concat(AnnotationPrefix).concat(id); }).join(","));
        return this.container;
    };
    return PopupAnnotationElement;
}(AnnotationElement));
var PopupElement = /** @class */ (function () {
    function PopupElement(_p) {
        var e_157, _q, e_158, _r;
        var container = _p.container, color = _p.color, elements = _p.elements, titleObj = _p.titleObj, modificationDate = _p.modificationDate, contentsObj = _p.contentsObj, richText = _p.richText, parent = _p.parent, rect = _p.rect, parentRect = _p.parentRect, open = _p.open;
        var _s;
        _PopupElement_instances.add(this);
        _PopupElement_boundKeyDown.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_keyDown).bind(this));
        _PopupElement_boundHide.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_hide).bind(this));
        _PopupElement_boundShow.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_show).bind(this));
        _PopupElement_boundToggle.set(this, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_toggle).bind(this));
        _PopupElement_color.set(this, null);
        _PopupElement_container.set(this, null);
        _PopupElement_contentsObj.set(this, null);
        _PopupElement_dateObj.set(this, null);
        _PopupElement_elements.set(this, null);
        _PopupElement_parent.set(this, null);
        _PopupElement_parentRect.set(this, null);
        _PopupElement_pinned.set(this, false);
        _PopupElement_popup.set(this, null);
        _PopupElement_position.set(this, null);
        _PopupElement_rect.set(this, null);
        _PopupElement_richText.set(this, null);
        _PopupElement_titleObj.set(this, null);
        _PopupElement_updates.set(this, null);
        _PopupElement_wasVisible.set(this, false);
        __classPrivateFieldSet(this, _PopupElement_container, container, "f");
        __classPrivateFieldSet(this, _PopupElement_titleObj, titleObj, "f");
        __classPrivateFieldSet(this, _PopupElement_contentsObj, contentsObj, "f");
        __classPrivateFieldSet(this, _PopupElement_richText, richText, "f");
        __classPrivateFieldSet(this, _PopupElement_parent, parent, "f");
        __classPrivateFieldSet(this, _PopupElement_color, color, "f");
        __classPrivateFieldSet(this, _PopupElement_rect, rect, "f");
        __classPrivateFieldSet(this, _PopupElement_parentRect, parentRect, "f");
        __classPrivateFieldSet(this, _PopupElement_elements, elements, "f");
        __classPrivateFieldSet(this, _PopupElement_dateObj, PDFDateString.toDateObject(modificationDate), "f");
        this.trigger = elements.flatMap(function (e) { return e.getElementsToTriggerPopup(); });
        try {
            for (var _t = __values(this.trigger), _u = _t.next(); !_u.done; _u = _t.next()) {
                var element = _u.value;
                element.addEventListener("click", __classPrivateFieldGet(this, _PopupElement_boundToggle, "f"));
                element.addEventListener("mouseenter", __classPrivateFieldGet(this, _PopupElement_boundShow, "f"));
                element.addEventListener("mouseleave", __classPrivateFieldGet(this, _PopupElement_boundHide, "f"));
                element.classList.add("popupTriggerArea");
            }
        }
        catch (e_157_1) { e_157 = { error: e_157_1 }; }
        finally {
            try {
                if (_u && !_u.done && (_q = _t.return)) _q.call(_t);
            }
            finally { if (e_157) throw e_157.error; }
        }
        try {
            for (var elements_1 = __values(elements), elements_1_1 = elements_1.next(); !elements_1_1.done; elements_1_1 = elements_1.next()) {
                var element = elements_1_1.value;
                (_s = element.container) === null || _s === void 0 ? void 0 : _s.addEventListener("keydown", __classPrivateFieldGet(this, _PopupElement_boundKeyDown, "f"));
            }
        }
        catch (e_158_1) { e_158 = { error: e_158_1 }; }
        finally {
            try {
                if (elements_1_1 && !elements_1_1.done && (_r = elements_1.return)) _r.call(elements_1);
            }
            finally { if (e_158) throw e_158.error; }
        }
        __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = true;
        if (open) {
            __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_toggle).call(this);
        }
    }
    PopupElement.prototype.render = function () {
        var _p;
        if (__classPrivateFieldGet(this, _PopupElement_popup, "f")) {
            return;
        }
        var popup = __classPrivateFieldSet(this, _PopupElement_popup, document.createElement("div"), "f");
        popup.className = "popup";
        if (__classPrivateFieldGet(this, _PopupElement_color, "f")) {
            var baseColor = popup.style.outlineColor = Util.makeHexColor.apply(Util, __spreadArray([], __read(__classPrivateFieldGet(this, _PopupElement_color, "f")), false));
            popup.style.backgroundColor = "color-mix(in srgb, ".concat(baseColor, " 30%, white)");
        }
        var header = document.createElement("span");
        header.className = "header";
        var title = document.createElement("h1");
        header.append(title);
        (_p = __classPrivateFieldGet(this, _PopupElement_titleObj, "f"), title.dir = _p.dir, title.textContent = _p.str);
        popup.append(header);
        if (__classPrivateFieldGet(this, _PopupElement_dateObj, "f")) {
            var modificationDate = document.createElement("span");
            modificationDate.classList.add("popupDate");
            modificationDate.setAttribute("data-l10n-id", "pdfjs-annotation-date-time-string");
            modificationDate.setAttribute("data-l10n-args", JSON.stringify({
                dateObj: __classPrivateFieldGet(this, _PopupElement_dateObj, "f").valueOf()
            }));
            header.append(modificationDate);
        }
        var html = __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_html_get);
        if (html) {
            XfaLayer.render({
                xfaHtml: html,
                intent: "richText",
                div: popup
            });
            popup.lastChild.classList.add("richText", "popupContent");
        }
        else {
            var contents = this._formatContents(__classPrivateFieldGet(this, _PopupElement_contentsObj, "f"));
            popup.append(contents);
        }
        __classPrivateFieldGet(this, _PopupElement_container, "f").append(popup);
    };
    PopupElement.prototype._formatContents = function (_p) {
        var str = _p.str, dir = _p.dir;
        var p = document.createElement("p");
        p.classList.add("popupContent");
        p.dir = dir;
        var lines = str.split(/(?:\r\n?|\n)/);
        for (var i = 0, ii = lines.length; i < ii; ++i) {
            var line = lines[i];
            p.append(document.createTextNode(line));
            if (i < ii - 1) {
                p.append(document.createElement("br"));
            }
        }
        return p;
    };
    PopupElement.prototype.updateEdited = function (_p) {
        var _q;
        var rect = _p.rect, popupContent = _p.popupContent;
        __classPrivateFieldSet(this, _PopupElement_updates, __classPrivateFieldGet(this, _PopupElement_updates, "f") || {
            contentsObj: __classPrivateFieldGet(this, _PopupElement_contentsObj, "f"),
            richText: __classPrivateFieldGet(this, _PopupElement_richText, "f")
        }, "f");
        if (rect) {
            __classPrivateFieldSet(this, _PopupElement_position, null, "f");
        }
        if (popupContent) {
            __classPrivateFieldSet(this, _PopupElement_richText, __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_makePopupContent).call(this, popupContent), "f");
            __classPrivateFieldSet(this, _PopupElement_contentsObj, null, "f");
        }
        (_q = __classPrivateFieldGet(this, _PopupElement_popup, "f")) === null || _q === void 0 ? void 0 : _q.remove();
        __classPrivateFieldSet(this, _PopupElement_popup, null, "f");
    };
    PopupElement.prototype.resetEdited = function () {
        var _p;
        var _q;
        var _r, _s;
        if (!__classPrivateFieldGet(this, _PopupElement_updates, "f")) {
            return;
        }
        (_r = this, _s = this, _p = __classPrivateFieldGet(this, _PopupElement_updates, "f"), ({ set value(_p) { __classPrivateFieldSet(_r, _PopupElement_contentsObj, _p, "f"); } }).value = _p.contentsObj, ({ set value(_p) { __classPrivateFieldSet(_s, _PopupElement_richText, _p, "f"); } }).value = _p.richText);
        __classPrivateFieldSet(this, _PopupElement_updates, null, "f");
        (_q = __classPrivateFieldGet(this, _PopupElement_popup, "f")) === null || _q === void 0 ? void 0 : _q.remove();
        __classPrivateFieldSet(this, _PopupElement_popup, null, "f");
        __classPrivateFieldSet(this, _PopupElement_position, null, "f");
    };
    PopupElement.prototype.forceHide = function () {
        __classPrivateFieldSet(this, _PopupElement_wasVisible, this.isVisible, "f");
        if (!__classPrivateFieldGet(this, _PopupElement_wasVisible, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = true;
    };
    PopupElement.prototype.maybeShow = function () {
        if (!__classPrivateFieldGet(this, _PopupElement_wasVisible, "f")) {
            return;
        }
        if (!__classPrivateFieldGet(this, _PopupElement_popup, "f")) {
            __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_show).call(this);
        }
        __classPrivateFieldSet(this, _PopupElement_wasVisible, false, "f");
        __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = false;
    };
    Object.defineProperty(PopupElement.prototype, "isVisible", {
        get: function () {
            return __classPrivateFieldGet(this, _PopupElement_container, "f").hidden === false;
        },
        enumerable: false,
        configurable: true
    });
    return PopupElement;
}());
_PopupElement_boundKeyDown = new WeakMap(), _PopupElement_boundHide = new WeakMap(), _PopupElement_boundShow = new WeakMap(), _PopupElement_boundToggle = new WeakMap(), _PopupElement_color = new WeakMap(), _PopupElement_container = new WeakMap(), _PopupElement_contentsObj = new WeakMap(), _PopupElement_dateObj = new WeakMap(), _PopupElement_elements = new WeakMap(), _PopupElement_parent = new WeakMap(), _PopupElement_parentRect = new WeakMap(), _PopupElement_pinned = new WeakMap(), _PopupElement_popup = new WeakMap(), _PopupElement_position = new WeakMap(), _PopupElement_rect = new WeakMap(), _PopupElement_richText = new WeakMap(), _PopupElement_titleObj = new WeakMap(), _PopupElement_updates = new WeakMap(), _PopupElement_wasVisible = new WeakMap(), _PopupElement_instances = new WeakSet(), _PopupElement_html_get = function _PopupElement_html_get() {
    var richText = __classPrivateFieldGet(this, _PopupElement_richText, "f");
    var contentsObj = __classPrivateFieldGet(this, _PopupElement_contentsObj, "f");
    if ((richText === null || richText === void 0 ? void 0 : richText.str) && (!(contentsObj === null || contentsObj === void 0 ? void 0 : contentsObj.str) || contentsObj.str === richText.str)) {
        return __classPrivateFieldGet(this, _PopupElement_richText, "f").html || null;
    }
    return null;
}, _PopupElement_fontSize_get = function _PopupElement_fontSize_get() {
    var _p, _q, _r;
    return ((_r = (_q = (_p = __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_html_get)) === null || _p === void 0 ? void 0 : _p.attributes) === null || _q === void 0 ? void 0 : _q.style) === null || _r === void 0 ? void 0 : _r.fontSize) || 0;
}, _PopupElement_fontColor_get = function _PopupElement_fontColor_get() {
    var _p, _q, _r;
    return ((_r = (_q = (_p = __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_html_get)) === null || _p === void 0 ? void 0 : _p.attributes) === null || _q === void 0 ? void 0 : _q.style) === null || _r === void 0 ? void 0 : _r.color) || null;
}, _PopupElement_makePopupContent = function _PopupElement_makePopupContent(text) {
    var e_159, _p;
    var popupLines = [];
    var popupContent = {
        str: text,
        html: {
            name: "div",
            attributes: {
                dir: "auto"
            },
            children: [{
                    name: "p",
                    children: popupLines
                }]
        }
    };
    var lineAttributes = {
        style: {
            color: __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_fontColor_get),
            fontSize: __classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_fontSize_get) ? "calc(".concat(__classPrivateFieldGet(this, _PopupElement_instances, "a", _PopupElement_fontSize_get), "px * var(--total-scale-factor))") : ""
        }
    };
    try {
        for (var _q = __values(text.split("\n")), _r = _q.next(); !_r.done; _r = _q.next()) {
            var line = _r.value;
            popupLines.push({
                name: "span",
                value: line,
                attributes: lineAttributes
            });
        }
    }
    catch (e_159_1) { e_159 = { error: e_159_1 }; }
    finally {
        try {
            if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
        }
        finally { if (e_159) throw e_159.error; }
    }
    return popupContent;
}, _PopupElement_keyDown = function _PopupElement_keyDown(event) {
    if (event.altKey || event.shiftKey || event.ctrlKey || event.metaKey) {
        return;
    }
    if (event.key === "Enter" || event.key === "Escape" && __classPrivateFieldGet(this, _PopupElement_pinned, "f")) {
        __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_toggle).call(this);
    }
}, _PopupElement_setPosition = function _PopupElement_setPosition() {
    var e_160, _p;
    if (__classPrivateFieldGet(this, _PopupElement_position, "f") !== null) {
        return;
    }
    var _q = __classPrivateFieldGet(this, _PopupElement_parent, "f"), view = _q.page.view, _r = _q.viewport.rawDims, pageWidth = _r.pageWidth, pageHeight = _r.pageHeight, pageX = _r.pageX, pageY = _r.pageY;
    var useParentRect = !!__classPrivateFieldGet(this, _PopupElement_parentRect, "f");
    var rect = useParentRect ? __classPrivateFieldGet(this, _PopupElement_parentRect, "f") : __classPrivateFieldGet(this, _PopupElement_rect, "f");
    try {
        for (var _s = __values(__classPrivateFieldGet(this, _PopupElement_elements, "f")), _t = _s.next(); !_t.done; _t = _s.next()) {
            var element = _t.value;
            if (!rect || Util.intersect(element.data.rect, rect) !== null) {
                rect = element.data.rect;
                useParentRect = true;
                break;
            }
        }
    }
    catch (e_160_1) { e_160 = { error: e_160_1 }; }
    finally {
        try {
            if (_t && !_t.done && (_p = _s.return)) _p.call(_s);
        }
        finally { if (e_160) throw e_160.error; }
    }
    var normalizedRect = Util.normalizeRect([rect[0], view[3] - rect[1] + view[1], rect[2], view[3] - rect[3] + view[1]]);
    var HORIZONTAL_SPACE_AFTER_ANNOTATION = 5;
    var parentWidth = useParentRect ? rect[2] - rect[0] + HORIZONTAL_SPACE_AFTER_ANNOTATION : 0;
    var popupLeft = normalizedRect[0] + parentWidth;
    var popupTop = normalizedRect[1];
    __classPrivateFieldSet(this, _PopupElement_position, [100 * (popupLeft - pageX) / pageWidth, 100 * (popupTop - pageY) / pageHeight], "f");
    var style = __classPrivateFieldGet(this, _PopupElement_container, "f").style;
    style.left = "".concat(__classPrivateFieldGet(this, _PopupElement_position, "f")[0], "%");
    style.top = "".concat(__classPrivateFieldGet(this, _PopupElement_position, "f")[1], "%");
}, _PopupElement_toggle = function _PopupElement_toggle() {
    __classPrivateFieldSet(this, _PopupElement_pinned, !__classPrivateFieldGet(this, _PopupElement_pinned, "f"), "f");
    if (__classPrivateFieldGet(this, _PopupElement_pinned, "f")) {
        __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_show).call(this);
        __classPrivateFieldGet(this, _PopupElement_container, "f").addEventListener("click", __classPrivateFieldGet(this, _PopupElement_boundToggle, "f"));
        __classPrivateFieldGet(this, _PopupElement_container, "f").addEventListener("keydown", __classPrivateFieldGet(this, _PopupElement_boundKeyDown, "f"));
    }
    else {
        __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_hide).call(this);
        __classPrivateFieldGet(this, _PopupElement_container, "f").removeEventListener("click", __classPrivateFieldGet(this, _PopupElement_boundToggle, "f"));
        __classPrivateFieldGet(this, _PopupElement_container, "f").removeEventListener("keydown", __classPrivateFieldGet(this, _PopupElement_boundKeyDown, "f"));
    }
}, _PopupElement_show = function _PopupElement_show() {
    if (!__classPrivateFieldGet(this, _PopupElement_popup, "f")) {
        this.render();
    }
    if (!this.isVisible) {
        __classPrivateFieldGet(this, _PopupElement_instances, "m", _PopupElement_setPosition).call(this);
        __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = false;
        __classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex = parseInt(__classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex) + 1000;
    }
    else if (__classPrivateFieldGet(this, _PopupElement_pinned, "f")) {
        __classPrivateFieldGet(this, _PopupElement_container, "f").classList.add("focused");
    }
}, _PopupElement_hide = function _PopupElement_hide() {
    __classPrivateFieldGet(this, _PopupElement_container, "f").classList.remove("focused");
    if (__classPrivateFieldGet(this, _PopupElement_pinned, "f") || !this.isVisible) {
        return;
    }
    __classPrivateFieldGet(this, _PopupElement_container, "f").hidden = true;
    __classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex = parseInt(__classPrivateFieldGet(this, _PopupElement_container, "f").style.zIndex) - 1000;
};
var FreeTextAnnotationElement = /** @class */ (function (_super) {
    __extends(FreeTextAnnotationElement, _super);
    function FreeTextAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
        _this.textContent = parameters.data.textContent;
        _this.textPosition = parameters.data.textPosition;
        _this.annotationEditorType = AnnotationEditorType.FREETEXT;
        return _this;
    }
    FreeTextAnnotationElement.prototype.render = function () {
        var e_161, _p;
        this.container.classList.add("freeTextAnnotation");
        if (this.textContent) {
            var content = document.createElement("div");
            content.classList.add("annotationTextContent");
            content.setAttribute("role", "comment");
            try {
                for (var _q = __values(this.textContent), _r = _q.next(); !_r.done; _r = _q.next()) {
                    var line = _r.value;
                    var lineSpan = document.createElement("span");
                    lineSpan.textContent = line;
                    content.append(lineSpan);
                }
            }
            catch (e_161_1) { e_161 = { error: e_161_1 }; }
            finally {
                try {
                    if (_r && !_r.done && (_p = _q.return)) _p.call(_q);
                }
                finally { if (e_161) throw e_161.error; }
            }
            this.container.append(content);
        }
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    };
    return FreeTextAnnotationElement;
}(AnnotationElement));
var LineAnnotationElement = /** @class */ (function (_super) {
    __extends(LineAnnotationElement, _super);
    function LineAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
        _LineAnnotationElement_line.set(_this, null);
        return _this;
    }
    LineAnnotationElement.prototype.render = function () {
        this.container.classList.add("lineAnnotation");
        var _p = this, data = _p.data, width = _p.width, height = _p.height;
        var svg = this.svgFactory.create(width, height, true);
        var line = __classPrivateFieldSet(this, _LineAnnotationElement_line, this.svgFactory.createElement("svg:line"), "f");
        line.setAttribute("x1", data.rect[2] - data.lineCoordinates[0]);
        line.setAttribute("y1", data.rect[3] - data.lineCoordinates[1]);
        line.setAttribute("x2", data.rect[2] - data.lineCoordinates[2]);
        line.setAttribute("y2", data.rect[3] - data.lineCoordinates[3]);
        line.setAttribute("stroke-width", data.borderStyle.width || 1);
        line.setAttribute("stroke", "transparent");
        line.setAttribute("fill", "transparent");
        svg.append(line);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        return this.container;
    };
    LineAnnotationElement.prototype.getElementsToTriggerPopup = function () {
        return __classPrivateFieldGet(this, _LineAnnotationElement_line, "f");
    };
    LineAnnotationElement.prototype.addHighlightArea = function () {
        this.container.classList.add("highlightArea");
    };
    return LineAnnotationElement;
}(AnnotationElement));
_LineAnnotationElement_line = new WeakMap();
var SquareAnnotationElement = /** @class */ (function (_super) {
    __extends(SquareAnnotationElement, _super);
    function SquareAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
        _SquareAnnotationElement_square.set(_this, null);
        return _this;
    }
    SquareAnnotationElement.prototype.render = function () {
        this.container.classList.add("squareAnnotation");
        var _p = this, data = _p.data, width = _p.width, height = _p.height;
        var svg = this.svgFactory.create(width, height, true);
        var borderWidth = data.borderStyle.width;
        var square = __classPrivateFieldSet(this, _SquareAnnotationElement_square, this.svgFactory.createElement("svg:rect"), "f");
        square.setAttribute("x", borderWidth / 2);
        square.setAttribute("y", borderWidth / 2);
        square.setAttribute("width", width - borderWidth);
        square.setAttribute("height", height - borderWidth);
        square.setAttribute("stroke-width", borderWidth || 1);
        square.setAttribute("stroke", "transparent");
        square.setAttribute("fill", "transparent");
        svg.append(square);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        return this.container;
    };
    SquareAnnotationElement.prototype.getElementsToTriggerPopup = function () {
        return __classPrivateFieldGet(this, _SquareAnnotationElement_square, "f");
    };
    SquareAnnotationElement.prototype.addHighlightArea = function () {
        this.container.classList.add("highlightArea");
    };
    return SquareAnnotationElement;
}(AnnotationElement));
_SquareAnnotationElement_square = new WeakMap();
var CircleAnnotationElement = /** @class */ (function (_super) {
    __extends(CircleAnnotationElement, _super);
    function CircleAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
        _CircleAnnotationElement_circle.set(_this, null);
        return _this;
    }
    CircleAnnotationElement.prototype.render = function () {
        this.container.classList.add("circleAnnotation");
        var _p = this, data = _p.data, width = _p.width, height = _p.height;
        var svg = this.svgFactory.create(width, height, true);
        var borderWidth = data.borderStyle.width;
        var circle = __classPrivateFieldSet(this, _CircleAnnotationElement_circle, this.svgFactory.createElement("svg:ellipse"), "f");
        circle.setAttribute("cx", width / 2);
        circle.setAttribute("cy", height / 2);
        circle.setAttribute("rx", width / 2 - borderWidth / 2);
        circle.setAttribute("ry", height / 2 - borderWidth / 2);
        circle.setAttribute("stroke-width", borderWidth || 1);
        circle.setAttribute("stroke", "transparent");
        circle.setAttribute("fill", "transparent");
        svg.append(circle);
        this.container.append(svg);
        if (!data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        return this.container;
    };
    CircleAnnotationElement.prototype.getElementsToTriggerPopup = function () {
        return __classPrivateFieldGet(this, _CircleAnnotationElement_circle, "f");
    };
    CircleAnnotationElement.prototype.addHighlightArea = function () {
        this.container.classList.add("highlightArea");
    };
    return CircleAnnotationElement;
}(AnnotationElement));
_CircleAnnotationElement_circle = new WeakMap();
var PolylineAnnotationElement = /** @class */ (function (_super) {
    __extends(PolylineAnnotationElement, _super);
    function PolylineAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
        _PolylineAnnotationElement_polyline.set(_this, null);
        _this.containerClassName = "polylineAnnotation";
        _this.svgElementName = "svg:polyline";
        return _this;
    }
    PolylineAnnotationElement.prototype.render = function () {
        this.container.classList.add(this.containerClassName);
        var _p = this, _q = _p.data, rect = _q.rect, vertices = _q.vertices, borderStyle = _q.borderStyle, popupRef = _q.popupRef, width = _p.width, height = _p.height;
        if (!vertices) {
            return this.container;
        }
        var svg = this.svgFactory.create(width, height, true);
        var points = [];
        for (var i = 0, ii = vertices.length; i < ii; i += 2) {
            var x = vertices[i] - rect[0];
            var y = rect[3] - vertices[i + 1];
            points.push("".concat(x, ",").concat(y));
        }
        points = points.join(" ");
        var polyline = __classPrivateFieldSet(this, _PolylineAnnotationElement_polyline, this.svgFactory.createElement(this.svgElementName), "f");
        polyline.setAttribute("points", points);
        polyline.setAttribute("stroke-width", borderStyle.width || 1);
        polyline.setAttribute("stroke", "transparent");
        polyline.setAttribute("fill", "transparent");
        svg.append(polyline);
        this.container.append(svg);
        if (!popupRef && this.hasPopupData) {
            this._createPopup();
        }
        return this.container;
    };
    PolylineAnnotationElement.prototype.getElementsToTriggerPopup = function () {
        return __classPrivateFieldGet(this, _PolylineAnnotationElement_polyline, "f");
    };
    PolylineAnnotationElement.prototype.addHighlightArea = function () {
        this.container.classList.add("highlightArea");
    };
    return PolylineAnnotationElement;
}(AnnotationElement));
_PolylineAnnotationElement_polyline = new WeakMap();
var PolygonAnnotationElement = /** @class */ (function (_super) {
    __extends(PolygonAnnotationElement, _super);
    function PolygonAnnotationElement(parameters) {
        var _this = _super.call(this, parameters) || this;
        _this.containerClassName = "polygonAnnotation";
        _this.svgElementName = "svg:polygon";
        return _this;
    }
    return PolygonAnnotationElement;
}(PolylineAnnotationElement));
var CaretAnnotationElement = /** @class */ (function (_super) {
    __extends(CaretAnnotationElement, _super);
    function CaretAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
    }
    CaretAnnotationElement.prototype.render = function () {
        this.container.classList.add("caretAnnotation");
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        return this.container;
    };
    return CaretAnnotationElement;
}(AnnotationElement));
var InkAnnotationElement = /** @class */ (function (_super) {
    __extends(InkAnnotationElement, _super);
    function InkAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
        _InkAnnotationElement_instances.add(_this);
        _InkAnnotationElement_polylinesGroupElement.set(_this, null);
        _InkAnnotationElement_polylines.set(_this, []);
        _this.containerClassName = "inkAnnotation";
        _this.svgElementName = "svg:polyline";
        _this.annotationEditorType = _this.data.it === "InkHighlight" ? AnnotationEditorType.HIGHLIGHT : AnnotationEditorType.INK;
        return _this;
    }
    InkAnnotationElement.prototype.render = function () {
        this.container.classList.add(this.containerClassName);
        var _p = this.data, rect = _p.rect, rotation = _p.rotation, inkLists = _p.inkLists, borderStyle = _p.borderStyle, popupRef = _p.popupRef;
        var _q = __classPrivateFieldGet(this, _InkAnnotationElement_instances, "m", _InkAnnotationElement_getTransform).call(this, rotation, rect), transform = _q.transform, width = _q.width, height = _q.height;
        var svg = this.svgFactory.create(width, height, true);
        var g = __classPrivateFieldSet(this, _InkAnnotationElement_polylinesGroupElement, this.svgFactory.createElement("svg:g"), "f");
        svg.append(g);
        g.setAttribute("stroke-width", borderStyle.width || 1);
        g.setAttribute("stroke-linecap", "round");
        g.setAttribute("stroke-linejoin", "round");
        g.setAttribute("stroke-miterlimit", 10);
        g.setAttribute("stroke", "transparent");
        g.setAttribute("fill", "transparent");
        g.setAttribute("transform", transform);
        for (var i = 0, ii = inkLists.length; i < ii; i++) {
            var polyline = this.svgFactory.createElement(this.svgElementName);
            __classPrivateFieldGet(this, _InkAnnotationElement_polylines, "f").push(polyline);
            polyline.setAttribute("points", inkLists[i].join(","));
            g.append(polyline);
        }
        if (!popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this.container.append(svg);
        this._editOnDoubleClick();
        return this.container;
    };
    InkAnnotationElement.prototype.updateEdited = function (params) {
        _super.prototype.updateEdited.call(this, params);
        var thickness = params.thickness, points = params.points, rect = params.rect;
        var g = __classPrivateFieldGet(this, _InkAnnotationElement_polylinesGroupElement, "f");
        if (thickness >= 0) {
            g.setAttribute("stroke-width", thickness || 1);
        }
        if (points) {
            for (var i = 0, ii = __classPrivateFieldGet(this, _InkAnnotationElement_polylines, "f").length; i < ii; i++) {
                __classPrivateFieldGet(this, _InkAnnotationElement_polylines, "f")[i].setAttribute("points", points[i].join(","));
            }
        }
        if (rect) {
            var _p = __classPrivateFieldGet(this, _InkAnnotationElement_instances, "m", _InkAnnotationElement_getTransform).call(this, this.data.rotation, rect), transform = _p.transform, width = _p.width, height = _p.height;
            var root = g.parentElement;
            root.setAttribute("viewBox", "0 0 ".concat(width, " ").concat(height));
            g.setAttribute("transform", transform);
        }
    };
    InkAnnotationElement.prototype.getElementsToTriggerPopup = function () {
        return __classPrivateFieldGet(this, _InkAnnotationElement_polylines, "f");
    };
    InkAnnotationElement.prototype.addHighlightArea = function () {
        this.container.classList.add("highlightArea");
    };
    return InkAnnotationElement;
}(AnnotationElement));
_InkAnnotationElement_polylinesGroupElement = new WeakMap(), _InkAnnotationElement_polylines = new WeakMap(), _InkAnnotationElement_instances = new WeakSet(), _InkAnnotationElement_getTransform = function _InkAnnotationElement_getTransform(rotation, rect) {
    switch (rotation) {
        case 90:
            return {
                transform: "rotate(90) translate(".concat(-rect[0], ",").concat(rect[1], ") scale(1,-1)"),
                width: rect[3] - rect[1],
                height: rect[2] - rect[0]
            };
        case 180:
            return {
                transform: "rotate(180) translate(".concat(-rect[2], ",").concat(rect[1], ") scale(1,-1)"),
                width: rect[2] - rect[0],
                height: rect[3] - rect[1]
            };
        case 270:
            return {
                transform: "rotate(270) translate(".concat(-rect[2], ",").concat(rect[3], ") scale(1,-1)"),
                width: rect[3] - rect[1],
                height: rect[2] - rect[0]
            };
        default:
            return {
                transform: "translate(".concat(-rect[0], ",").concat(rect[3], ") scale(1,-1)"),
                width: rect[2] - rect[0],
                height: rect[3] - rect[1]
            };
    }
};
var HighlightAnnotationElement = /** @class */ (function (_super) {
    __extends(HighlightAnnotationElement, _super);
    function HighlightAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        }) || this;
        _this.annotationEditorType = AnnotationEditorType.HIGHLIGHT;
        return _this;
    }
    HighlightAnnotationElement.prototype.render = function () {
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this.container.classList.add("highlightAnnotation");
        this._editOnDoubleClick();
        return this.container;
    };
    return HighlightAnnotationElement;
}(AnnotationElement));
var UnderlineAnnotationElement = /** @class */ (function (_super) {
    __extends(UnderlineAnnotationElement, _super);
    function UnderlineAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        }) || this;
    }
    UnderlineAnnotationElement.prototype.render = function () {
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this.container.classList.add("underlineAnnotation");
        return this.container;
    };
    return UnderlineAnnotationElement;
}(AnnotationElement));
var SquigglyAnnotationElement = /** @class */ (function (_super) {
    __extends(SquigglyAnnotationElement, _super);
    function SquigglyAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        }) || this;
    }
    SquigglyAnnotationElement.prototype.render = function () {
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this.container.classList.add("squigglyAnnotation");
        return this.container;
    };
    return SquigglyAnnotationElement;
}(AnnotationElement));
var StrikeOutAnnotationElement = /** @class */ (function (_super) {
    __extends(StrikeOutAnnotationElement, _super);
    function StrikeOutAnnotationElement(parameters) {
        return _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true,
            createQuadrilaterals: true
        }) || this;
    }
    StrikeOutAnnotationElement.prototype.render = function () {
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this.container.classList.add("strikeoutAnnotation");
        return this.container;
    };
    return StrikeOutAnnotationElement;
}(AnnotationElement));
var StampAnnotationElement = /** @class */ (function (_super) {
    __extends(StampAnnotationElement, _super);
    function StampAnnotationElement(parameters) {
        var _this = _super.call(this, parameters, {
            isRenderable: true,
            ignoreBorder: true
        }) || this;
        _this.annotationEditorType = AnnotationEditorType.STAMP;
        return _this;
    }
    StampAnnotationElement.prototype.render = function () {
        this.container.classList.add("stampAnnotation");
        this.container.setAttribute("role", "img");
        if (!this.data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        this._editOnDoubleClick();
        return this.container;
    };
    return StampAnnotationElement;
}(AnnotationElement));
var FileAttachmentAnnotationElement = /** @class */ (function (_super) {
    __extends(FileAttachmentAnnotationElement, _super);
    function FileAttachmentAnnotationElement(parameters) {
        var _p;
        var _this = _super.call(this, parameters, {
            isRenderable: true
        }) || this;
        _FileAttachmentAnnotationElement_instances.add(_this);
        _FileAttachmentAnnotationElement_trigger.set(_this, null);
        var file = _this.data.file;
        _this.filename = file.filename;
        _this.content = file.content;
        (_p = _this.linkService.eventBus) === null || _p === void 0 ? void 0 : _p.dispatch("fileattachmentannotation", __assign({ source: _this }, file));
        return _this;
    }
    FileAttachmentAnnotationElement.prototype.render = function () {
        var _this = this;
        this.container.classList.add("fileAttachmentAnnotation");
        var _p = this, container = _p.container, data = _p.data;
        var trigger;
        if (data.hasAppearance || data.fillAlpha === 0) {
            trigger = document.createElement("div");
        }
        else {
            trigger = document.createElement("img");
            trigger.src = "".concat(this.imageResourcesPath, "annotation-").concat(/paperclip/i.test(data.name) ? "paperclip" : "pushpin", ".svg");
            if (data.fillAlpha && data.fillAlpha < 1) {
                trigger.style = "filter: opacity(".concat(Math.round(data.fillAlpha * 100), "%);");
            }
        }
        trigger.addEventListener("dblclick", __classPrivateFieldGet(this, _FileAttachmentAnnotationElement_instances, "m", _FileAttachmentAnnotationElement_download).bind(this));
        __classPrivateFieldSet(this, _FileAttachmentAnnotationElement_trigger, trigger, "f");
        var isMac = util_FeatureTest.platform.isMac;
        container.addEventListener("keydown", function (evt) {
            if (evt.key === "Enter" && (isMac ? evt.metaKey : evt.ctrlKey)) {
                __classPrivateFieldGet(_this, _FileAttachmentAnnotationElement_instances, "m", _FileAttachmentAnnotationElement_download).call(_this);
            }
        });
        if (!data.popupRef && this.hasPopupData) {
            this._createPopup();
        }
        else {
            trigger.classList.add("popupTriggerArea");
        }
        container.append(trigger);
        return container;
    };
    FileAttachmentAnnotationElement.prototype.getElementsToTriggerPopup = function () {
        return __classPrivateFieldGet(this, _FileAttachmentAnnotationElement_trigger, "f");
    };
    FileAttachmentAnnotationElement.prototype.addHighlightArea = function () {
        this.container.classList.add("highlightArea");
    };
    return FileAttachmentAnnotationElement;
}(AnnotationElement));
_FileAttachmentAnnotationElement_trigger = new WeakMap(), _FileAttachmentAnnotationElement_instances = new WeakSet(), _FileAttachmentAnnotationElement_download = function _FileAttachmentAnnotationElement_download() {
    var _p;
    (_p = this.downloadManager) === null || _p === void 0 ? void 0 : _p.openOrDownloadData(this.content, this.filename);
};
var AnnotationLayer = /** @class */ (function () {
    function AnnotationLayer(_p) {
        var div = _p.div, accessibilityManager = _p.accessibilityManager, annotationCanvasMap = _p.annotationCanvasMap, annotationEditorUIManager = _p.annotationEditorUIManager, page = _p.page, viewport = _p.viewport, structTreeLayer = _p.structTreeLayer;
        _AnnotationLayer_instances.add(this);
        _AnnotationLayer_accessibilityManager.set(this, null);
        _AnnotationLayer_annotationCanvasMap.set(this, null);
        _AnnotationLayer_editableAnnotations.set(this, new Map());
        _AnnotationLayer_structTreeLayer.set(this, null);
        this.div = div;
        __classPrivateFieldSet(this, _AnnotationLayer_accessibilityManager, accessibilityManager, "f");
        __classPrivateFieldSet(this, _AnnotationLayer_annotationCanvasMap, annotationCanvasMap, "f");
        __classPrivateFieldSet(this, _AnnotationLayer_structTreeLayer, structTreeLayer || null, "f");
        this.page = page;
        this.viewport = viewport;
        this.zIndex = 0;
        this._annotationEditorUIManager = annotationEditorUIManager;
    }
    AnnotationLayer.prototype.hasEditableAnnotations = function () {
        return __classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").size > 0;
    };
    AnnotationLayer.prototype.render = function (params) {
        return __awaiter(this, void 0, void 0, function () {
            var annotations, layer, popupToElements, elementParams, annotations_1, annotations_1_1, data, isPopupAnnotation, elements, element, elements, rendered, e_162_1;
            var e_162, _p;
            var _q;
            return __generator(this, function (_r) {
                switch (_r.label) {
                    case 0:
                        annotations = params.annotations;
                        layer = this.div;
                        setLayerDimensions(layer, this.viewport);
                        popupToElements = new Map();
                        elementParams = {
                            data: null,
                            layer: layer,
                            linkService: params.linkService,
                            downloadManager: params.downloadManager,
                            imageResourcesPath: params.imageResourcesPath || "",
                            renderForms: params.renderForms !== false,
                            svgFactory: new DOMSVGFactory(),
                            annotationStorage: params.annotationStorage || new AnnotationStorage(),
                            enableScripting: params.enableScripting === true,
                            hasJSActions: params.hasJSActions,
                            fieldObjects: params.fieldObjects,
                            parent: this,
                            elements: null
                        };
                        _r.label = 1;
                    case 1:
                        _r.trys.push([1, 6, 7, 8]);
                        annotations_1 = __values(annotations), annotations_1_1 = annotations_1.next();
                        _r.label = 2;
                    case 2:
                        if (!!annotations_1_1.done) return [3 /*break*/, 5];
                        data = annotations_1_1.value;
                        if (data.noHTML) {
                            return [3 /*break*/, 4];
                        }
                        isPopupAnnotation = data.annotationType === AnnotationType.POPUP;
                        if (!isPopupAnnotation) {
                            if (data.rect[2] === data.rect[0] || data.rect[3] === data.rect[1]) {
                                return [3 /*break*/, 4];
                            }
                        }
                        else {
                            elements = popupToElements.get(data.id);
                            if (!elements) {
                                return [3 /*break*/, 4];
                            }
                            elementParams.elements = elements;
                        }
                        elementParams.data = data;
                        element = AnnotationElementFactory.create(elementParams);
                        if (!element.isRenderable) {
                            return [3 /*break*/, 4];
                        }
                        if (!isPopupAnnotation && data.popupRef) {
                            elements = popupToElements.get(data.popupRef);
                            if (!elements) {
                                popupToElements.set(data.popupRef, [element]);
                            }
                            else {
                                elements.push(element);
                            }
                        }
                        rendered = element.render();
                        if (data.hidden) {
                            rendered.style.visibility = "hidden";
                        }
                        return [4 /*yield*/, __classPrivateFieldGet(this, _AnnotationLayer_instances, "m", _AnnotationLayer_appendElement).call(this, rendered, data.id)];
                    case 3:
                        _r.sent();
                        if (element._isEditable) {
                            __classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").set(element.data.id, element);
                            (_q = this._annotationEditorUIManager) === null || _q === void 0 ? void 0 : _q.renderAnnotationElement(element);
                        }
                        _r.label = 4;
                    case 4:
                        annotations_1_1 = annotations_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_162_1 = _r.sent();
                        e_162 = { error: e_162_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (annotations_1_1 && !annotations_1_1.done && (_p = annotations_1.return)) _p.call(annotations_1);
                        }
                        finally { if (e_162) throw e_162.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        __classPrivateFieldGet(this, _AnnotationLayer_instances, "m", _AnnotationLayer_setAnnotationCanvasMap).call(this);
                        return [2 /*return*/];
                }
            });
        });
    };
    AnnotationLayer.prototype.addLinkAnnotations = function (annotations, linkService) {
        return __awaiter(this, void 0, void 0, function () {
            var elementParams, annotations_2, annotations_2_1, data, element, rendered, e_163_1;
            var e_163, _p;
            return __generator(this, function (_q) {
                switch (_q.label) {
                    case 0:
                        elementParams = {
                            data: null,
                            layer: this.div,
                            linkService: linkService,
                            svgFactory: new DOMSVGFactory(),
                            parent: this
                        };
                        _q.label = 1;
                    case 1:
                        _q.trys.push([1, 6, 7, 8]);
                        annotations_2 = __values(annotations), annotations_2_1 = annotations_2.next();
                        _q.label = 2;
                    case 2:
                        if (!!annotations_2_1.done) return [3 /*break*/, 5];
                        data = annotations_2_1.value;
                        data.borderStyle || (data.borderStyle = AnnotationLayer._defaultBorderStyle);
                        elementParams.data = data;
                        element = AnnotationElementFactory.create(elementParams);
                        if (!element.isRenderable) {
                            return [3 /*break*/, 4];
                        }
                        rendered = element.render();
                        return [4 /*yield*/, __classPrivateFieldGet(this, _AnnotationLayer_instances, "m", _AnnotationLayer_appendElement).call(this, rendered, data.id)];
                    case 3:
                        _q.sent();
                        _q.label = 4;
                    case 4:
                        annotations_2_1 = annotations_2.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_163_1 = _q.sent();
                        e_163 = { error: e_163_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (annotations_2_1 && !annotations_2_1.done && (_p = annotations_2.return)) _p.call(annotations_2);
                        }
                        finally { if (e_163) throw e_163.error; }
                        return [7 /*endfinally*/];
                    case 8: return [2 /*return*/];
                }
            });
        });
    };
    AnnotationLayer.prototype.update = function (_p) {
        var viewport = _p.viewport;
        var layer = this.div;
        this.viewport = viewport;
        setLayerDimensions(layer, {
            rotation: viewport.rotation
        });
        __classPrivateFieldGet(this, _AnnotationLayer_instances, "m", _AnnotationLayer_setAnnotationCanvasMap).call(this);
        layer.hidden = false;
    };
    AnnotationLayer.prototype.getEditableAnnotations = function () {
        return Array.from(__classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").values());
    };
    AnnotationLayer.prototype.getEditableAnnotation = function (id) {
        return __classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").get(id);
    };
    Object.defineProperty(AnnotationLayer, "_defaultBorderStyle", {
        get: function () {
            return shadow(this, "_defaultBorderStyle", Object.freeze({
                width: 1,
                rawWidth: 1,
                style: AnnotationBorderStyleType.SOLID,
                dashArray: [3],
                horizontalCornerRadius: 0,
                verticalCornerRadius: 0
            }));
        },
        enumerable: false,
        configurable: true
    });
    return AnnotationLayer;
}());
_AnnotationLayer_accessibilityManager = new WeakMap(), _AnnotationLayer_annotationCanvasMap = new WeakMap(), _AnnotationLayer_editableAnnotations = new WeakMap(), _AnnotationLayer_structTreeLayer = new WeakMap(), _AnnotationLayer_instances = new WeakSet(), _AnnotationLayer_appendElement = function _AnnotationLayer_appendElement(element, id) {
    return __awaiter(this, void 0, void 0, function () {
        var contentElement, annotationId, ariaAttributes, ariaAttributes_1, ariaAttributes_1_1, _p, key, value;
        var e_164, _q;
        var _r, _s;
        return __generator(this, function (_t) {
            switch (_t.label) {
                case 0:
                    contentElement = element.firstChild || element;
                    annotationId = contentElement.id = "".concat(AnnotationPrefix).concat(id);
                    return [4 /*yield*/, ((_r = __classPrivateFieldGet(this, _AnnotationLayer_structTreeLayer, "f")) === null || _r === void 0 ? void 0 : _r.getAriaAttributes(annotationId))];
                case 1:
                    ariaAttributes = _t.sent();
                    if (ariaAttributes) {
                        try {
                            for (ariaAttributes_1 = __values(ariaAttributes), ariaAttributes_1_1 = ariaAttributes_1.next(); !ariaAttributes_1_1.done; ariaAttributes_1_1 = ariaAttributes_1.next()) {
                                _p = __read(ariaAttributes_1_1.value, 2), key = _p[0], value = _p[1];
                                contentElement.setAttribute(key, value);
                            }
                        }
                        catch (e_164_1) { e_164 = { error: e_164_1 }; }
                        finally {
                            try {
                                if (ariaAttributes_1_1 && !ariaAttributes_1_1.done && (_q = ariaAttributes_1.return)) _q.call(ariaAttributes_1);
                            }
                            finally { if (e_164) throw e_164.error; }
                        }
                    }
                    this.div.append(element);
                    (_s = __classPrivateFieldGet(this, _AnnotationLayer_accessibilityManager, "f")) === null || _s === void 0 ? void 0 : _s.moveElementInDOM(this.div, element, contentElement, false);
                    return [2 /*return*/];
            }
        });
    });
}, _AnnotationLayer_setAnnotationCanvasMap = function _AnnotationLayer_setAnnotationCanvasMap() {
    var e_165, _p;
    var _q;
    if (!__classPrivateFieldGet(this, _AnnotationLayer_annotationCanvasMap, "f")) {
        return;
    }
    var layer = this.div;
    try {
        for (var _r = __values(__classPrivateFieldGet(this, _AnnotationLayer_annotationCanvasMap, "f")), _s = _r.next(); !_s.done; _s = _r.next()) {
            var _t = __read(_s.value, 2), id = _t[0], canvas = _t[1];
            var element = layer.querySelector("[data-annotation-id=\"".concat(id, "\"]"));
            if (!element) {
                continue;
            }
            canvas.className = "annotationContent";
            var firstChild = element.firstChild;
            if (!firstChild) {
                element.append(canvas);
            }
            else if (firstChild.nodeName === "CANVAS") {
                firstChild.replaceWith(canvas);
            }
            else if (!firstChild.classList.contains("annotationContent")) {
                firstChild.before(canvas);
            }
            else {
                firstChild.after(canvas);
            }
            var editableAnnotation = __classPrivateFieldGet(this, _AnnotationLayer_editableAnnotations, "f").get(id);
            if (!editableAnnotation) {
                continue;
            }
            if (editableAnnotation._hasNoCanvas) {
                (_q = this._annotationEditorUIManager) === null || _q === void 0 ? void 0 : _q.setMissingCanvas(id, element.id, canvas);
                editableAnnotation._hasNoCanvas = false;
            }
            else {
                editableAnnotation.canvas = canvas;
            }
        }
    }
    catch (e_165_1) { e_165 = { error: e_165_1 }; }
    finally {
        try {
            if (_s && !_s.done && (_p = _r.return)) _p.call(_r);
        }
        finally { if (e_165) throw e_165.error; }
    }
    __classPrivateFieldGet(this, _AnnotationLayer_annotationCanvasMap, "f").clear();
};
; // ./src/display/editor/freetext.js
var EOL_PATTERN = /\r\n?|\n/g;
var FreeTextEditor = /** @class */ (function (_super) {
    __extends(FreeTextEditor, _super);
    function FreeTextEditor(params) {
        var _this = _super.call(this, __assign(__assign({}, params), { name: "freeTextEditor" })) || this;
        _FreeTextEditor_instances.add(_this);
        _FreeTextEditor_color.set(_this, void 0);
        _FreeTextEditor_content.set(_this, "");
        _FreeTextEditor_editorDivId.set(_this, "".concat(_this.id, "-editor"));
        _FreeTextEditor_editModeAC.set(_this, null);
        _FreeTextEditor_fontSize.set(_this, void 0);
        __classPrivateFieldSet(_this, _FreeTextEditor_color, params.color || _p._defaultColor || AnnotationEditor._defaultLineColor, "f");
        __classPrivateFieldSet(_this, _FreeTextEditor_fontSize, params.fontSize || _p._defaultFontSize, "f");
        return _this;
    }
    Object.defineProperty(FreeTextEditor, "_keyboardManager", {
        get: function () {
            var proto = _p.prototype;
            var arrowChecker = function (self) { return self.isEmpty(); };
            var small = AnnotationEditorUIManager.TRANSLATE_SMALL;
            var big = AnnotationEditorUIManager.TRANSLATE_BIG;
            return shadow(this, "_keyboardManager", new KeyboardManager([[["ctrl+s", "mac+meta+s", "ctrl+p", "mac+meta+p"], proto.commitOrRemove, {
                        bubbles: true
                    }], [["ctrl+Enter", "mac+meta+Enter", "Escape", "mac+Escape"], proto.commitOrRemove], [["ArrowLeft", "mac+ArrowLeft"], proto._translateEmpty, {
                        args: [-small, 0],
                        checker: arrowChecker
                    }], [["ctrl+ArrowLeft", "mac+shift+ArrowLeft"], proto._translateEmpty, {
                        args: [-big, 0],
                        checker: arrowChecker
                    }], [["ArrowRight", "mac+ArrowRight"], proto._translateEmpty, {
                        args: [small, 0],
                        checker: arrowChecker
                    }], [["ctrl+ArrowRight", "mac+shift+ArrowRight"], proto._translateEmpty, {
                        args: [big, 0],
                        checker: arrowChecker
                    }], [["ArrowUp", "mac+ArrowUp"], proto._translateEmpty, {
                        args: [0, -small],
                        checker: arrowChecker
                    }], [["ctrl+ArrowUp", "mac+shift+ArrowUp"], proto._translateEmpty, {
                        args: [0, -big],
                        checker: arrowChecker
                    }], [["ArrowDown", "mac+ArrowDown"], proto._translateEmpty, {
                        args: [0, small],
                        checker: arrowChecker
                    }], [["ctrl+ArrowDown", "mac+shift+ArrowDown"], proto._translateEmpty, {
                        args: [0, big],
                        checker: arrowChecker
                    }]]));
        },
        enumerable: false,
        configurable: true
    });
    FreeTextEditor.initialize = function (l10n, uiManager) {
        AnnotationEditor.initialize(l10n, uiManager);
        var style = getComputedStyle(document.documentElement);
        this._internalPadding = parseFloat(style.getPropertyValue("--freetext-padding"));
    };
    FreeTextEditor.updateDefaultParams = function (type, value) {
        switch (type) {
            case AnnotationEditorParamsType.FREETEXT_SIZE:
                _p._defaultFontSize = value;
                break;
            case AnnotationEditorParamsType.FREETEXT_COLOR:
                _p._defaultColor = value;
                break;
        }
    };
    FreeTextEditor.prototype.updateParams = function (type, value) {
        switch (type) {
            case AnnotationEditorParamsType.FREETEXT_SIZE:
                __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_updateFontSize).call(this, value);
                break;
            case AnnotationEditorParamsType.FREETEXT_COLOR:
                __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_updateColor).call(this, value);
                break;
        }
    };
    Object.defineProperty(FreeTextEditor, "defaultPropertiesToUpdate", {
        get: function () {
            return [[AnnotationEditorParamsType.FREETEXT_SIZE, _p._defaultFontSize], [AnnotationEditorParamsType.FREETEXT_COLOR, _p._defaultColor || AnnotationEditor._defaultLineColor]];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(FreeTextEditor.prototype, "propertiesToUpdate", {
        get: function () {
            return [[AnnotationEditorParamsType.FREETEXT_SIZE, __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f")], [AnnotationEditorParamsType.FREETEXT_COLOR, __classPrivateFieldGet(this, _FreeTextEditor_color, "f")]];
        },
        enumerable: false,
        configurable: true
    });
    FreeTextEditor.prototype._translateEmpty = function (x, y) {
        this._uiManager.translateSelectedEditors(x, y, true);
    };
    FreeTextEditor.prototype.getInitialTranslation = function () {
        var scale = this.parentScale;
        return [-_p._internalPadding * scale, -(_p._internalPadding + __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f")) * scale];
    };
    FreeTextEditor.prototype.rebuild = function () {
        if (!this.parent) {
            return;
        }
        _super.prototype.rebuild.call(this);
        if (this.div === null) {
            return;
        }
        if (!this.isAttachedToDOM) {
            this.parent.add(this);
        }
    };
    FreeTextEditor.prototype.enableEditMode = function () {
        if (this.isInEditMode()) {
            return;
        }
        this.parent.setEditingState(false);
        this.parent.updateToolbar(AnnotationEditorType.FREETEXT);
        _super.prototype.enableEditMode.call(this);
        this.overlayDiv.classList.remove("enabled");
        this.editorDiv.contentEditable = true;
        this._isDraggable = false;
        this.div.removeAttribute("aria-activedescendant");
        __classPrivateFieldSet(this, _FreeTextEditor_editModeAC, new AbortController(), "f");
        var signal = this._uiManager.combinedSignal(__classPrivateFieldGet(this, _FreeTextEditor_editModeAC, "f"));
        this.editorDiv.addEventListener("keydown", this.editorDivKeydown.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("focus", this.editorDivFocus.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("blur", this.editorDivBlur.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("input", this.editorDivInput.bind(this), {
            signal: signal
        });
        this.editorDiv.addEventListener("paste", this.editorDivPaste.bind(this), {
            signal: signal
        });
    };
    FreeTextEditor.prototype.disableEditMode = function () {
        var _q;
        if (!this.isInEditMode()) {
            return;
        }
        this.parent.setEditingState(true);
        _super.prototype.disableEditMode.call(this);
        this.overlayDiv.classList.add("enabled");
        this.editorDiv.contentEditable = false;
        this.div.setAttribute("aria-activedescendant", __classPrivateFieldGet(this, _FreeTextEditor_editorDivId, "f"));
        this._isDraggable = true;
        (_q = __classPrivateFieldGet(this, _FreeTextEditor_editModeAC, "f")) === null || _q === void 0 ? void 0 : _q.abort();
        __classPrivateFieldSet(this, _FreeTextEditor_editModeAC, null, "f");
        this.div.focus({
            preventScroll: true
        });
        this.isEditing = false;
        this.parent.div.classList.add("freetextEditing");
    };
    FreeTextEditor.prototype.focusin = function (event) {
        if (!this._focusEventsAllowed) {
            return;
        }
        _super.prototype.focusin.call(this, event);
        if (event.target !== this.editorDiv) {
            this.editorDiv.focus();
        }
    };
    FreeTextEditor.prototype.onceAdded = function (focus) {
        var _q;
        if (this.width) {
            return;
        }
        this.enableEditMode();
        if (focus) {
            this.editorDiv.focus();
        }
        if ((_q = this._initialOptions) === null || _q === void 0 ? void 0 : _q.isCentered) {
            this.center();
        }
        this._initialOptions = null;
    };
    FreeTextEditor.prototype.isEmpty = function () {
        return !this.editorDiv || this.editorDiv.innerText.trim() === "";
    };
    FreeTextEditor.prototype.remove = function () {
        this.isEditing = false;
        if (this.parent) {
            this.parent.setEditingState(true);
            this.parent.div.classList.add("freetextEditing");
        }
        _super.prototype.remove.call(this);
    };
    FreeTextEditor.prototype.commit = function () {
        var _this = this;
        if (!this.isInEditMode()) {
            return;
        }
        _super.prototype.commit.call(this);
        this.disableEditMode();
        var savedText = __classPrivateFieldGet(this, _FreeTextEditor_content, "f");
        var newText = __classPrivateFieldSet(this, _FreeTextEditor_content, __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_extractText).call(this).trimEnd(), "f");
        if (savedText === newText) {
            return;
        }
        var setText = function (text) {
            __classPrivateFieldSet(_this, _FreeTextEditor_content, text, "f");
            if (!text) {
                _this.remove();
                return;
            }
            __classPrivateFieldGet(_this, _FreeTextEditor_instances, "m", _FreeTextEditor_setContent).call(_this);
            _this._uiManager.rebuild(_this);
            __classPrivateFieldGet(_this, _FreeTextEditor_instances, "m", _FreeTextEditor_setEditorDimensions).call(_this);
        };
        this.addCommands({
            cmd: function () {
                setText(newText);
            },
            undo: function () {
                setText(savedText);
            },
            mustExec: false
        });
        __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setEditorDimensions).call(this);
    };
    FreeTextEditor.prototype.shouldGetKeyboardEvents = function () {
        return this.isInEditMode();
    };
    FreeTextEditor.prototype.enterInEditMode = function () {
        this.enableEditMode();
        this.editorDiv.focus();
    };
    FreeTextEditor.prototype.dblclick = function (event) {
        this.enterInEditMode();
    };
    FreeTextEditor.prototype.keydown = function (event) {
        if (event.target === this.div && event.key === "Enter") {
            this.enterInEditMode();
            event.preventDefault();
        }
    };
    FreeTextEditor.prototype.editorDivKeydown = function (event) {
        _p._keyboardManager.exec(this, event);
    };
    FreeTextEditor.prototype.editorDivFocus = function (event) {
        this.isEditing = true;
    };
    FreeTextEditor.prototype.editorDivBlur = function (event) {
        this.isEditing = false;
    };
    FreeTextEditor.prototype.editorDivInput = function (event) {
        this.parent.div.classList.toggle("freetextEditing", this.isEmpty());
    };
    FreeTextEditor.prototype.disableEditing = function () {
        this.editorDiv.setAttribute("role", "comment");
        this.editorDiv.removeAttribute("aria-multiline");
    };
    FreeTextEditor.prototype.enableEditing = function () {
        this.editorDiv.setAttribute("role", "textbox");
        this.editorDiv.setAttribute("aria-multiline", true);
    };
    FreeTextEditor.prototype.render = function () {
        var _q, _r, _s, _t;
        if (this.div) {
            return this.div;
        }
        var baseX, baseY;
        if (this._isCopy || this.annotationElementId) {
            baseX = this.x;
            baseY = this.y;
        }
        _super.prototype.render.call(this);
        this.editorDiv = document.createElement("div");
        this.editorDiv.className = "internal";
        this.editorDiv.setAttribute("id", __classPrivateFieldGet(this, _FreeTextEditor_editorDivId, "f"));
        this.editorDiv.setAttribute("data-l10n-id", "pdfjs-free-text2");
        this.editorDiv.setAttribute("data-l10n-attrs", "default-content");
        this.enableEditing();
        this.editorDiv.contentEditable = true;
        var style = this.editorDiv.style;
        style.fontSize = "calc(".concat(__classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f"), "px * var(--total-scale-factor))");
        style.color = __classPrivateFieldGet(this, _FreeTextEditor_color, "f");
        this.div.append(this.editorDiv);
        this.overlayDiv = document.createElement("div");
        this.overlayDiv.classList.add("overlay", "enabled");
        this.div.append(this.overlayDiv);
        bindEvents(this, this.div, ["dblclick", "keydown"]);
        if (this._isCopy || this.annotationElementId) {
            var _u = __read(this.parentDimensions, 2), parentWidth = _u[0], parentHeight = _u[1];
            if (this.annotationElementId) {
                var position = this._initialData.position;
                var _v = __read(this.getInitialTranslation(), 2), tx = _v[0], ty = _v[1];
                _q = __read(this.pageTranslationToScreen(tx, ty), 2), tx = _q[0], ty = _q[1];
                var _w = __read(this.pageDimensions, 2), pageWidth = _w[0], pageHeight = _w[1];
                var _z = __read(this.pageTranslation, 2), pageX = _z[0], pageY = _z[1];
                var posX = void 0, posY = void 0;
                switch (this.rotation) {
                    case 0:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY + this.height - (position[1] - pageY) / pageHeight;
                        break;
                    case 90:
                        posX = baseX + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        _r = __read([ty, -tx], 2), tx = _r[0], ty = _r[1];
                        break;
                    case 180:
                        posX = baseX - this.width + (position[0] - pageX) / pageWidth;
                        posY = baseY - (position[1] - pageY) / pageHeight;
                        _s = __read([-tx, -ty], 2), tx = _s[0], ty = _s[1];
                        break;
                    case 270:
                        posX = baseX + (position[0] - pageX - this.height * pageHeight) / pageWidth;
                        posY = baseY + (position[1] - pageY - this.width * pageWidth) / pageHeight;
                        _t = __read([-ty, tx], 2), tx = _t[0], ty = _t[1];
                        break;
                }
                this.setAt(posX * parentWidth, posY * parentHeight, tx, ty);
            }
            else {
                this._moveAfterPaste(baseX, baseY);
            }
            __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setContent).call(this);
            this._isDraggable = true;
            this.editorDiv.contentEditable = false;
        }
        else {
            this._isDraggable = false;
            this.editorDiv.contentEditable = true;
        }
        return this.div;
    };
    FreeTextEditor.prototype.editorDivPaste = function (event) {
        var e_166, _q, e_167, _r, e_168, _s;
        var clipboardData = event.clipboardData || window.clipboardData;
        var types = clipboardData.types;
        if (types.length === 1 && types[0] === "text/plain") {
            return;
        }
        event.preventDefault();
        var paste = __classPrivateFieldGet(_p, _p, "m", _FreeTextEditor_deserializeContent).call(_p, clipboardData.getData("text") || "").replaceAll(EOL_PATTERN, "\n");
        if (!paste) {
            return;
        }
        var selection = window.getSelection();
        if (!selection.rangeCount) {
            return;
        }
        this.editorDiv.normalize();
        selection.deleteFromDocument();
        var range = selection.getRangeAt(0);
        if (!paste.includes("\n")) {
            range.insertNode(document.createTextNode(paste));
            this.editorDiv.normalize();
            selection.collapseToStart();
            return;
        }
        var startContainer = range.startContainer, startOffset = range.startOffset;
        var bufferBefore = [];
        var bufferAfter = [];
        if (startContainer.nodeType === Node.TEXT_NODE) {
            var parent = startContainer.parentElement;
            bufferAfter.push(startContainer.nodeValue.slice(startOffset).replaceAll(EOL_PATTERN, ""));
            if (parent !== this.editorDiv) {
                var buffer = bufferBefore;
                try {
                    for (var _t = __values(this.editorDiv.childNodes), _u = _t.next(); !_u.done; _u = _t.next()) {
                        var child = _u.value;
                        if (child === parent) {
                            buffer = bufferAfter;
                            continue;
                        }
                        buffer.push(__classPrivateFieldGet(_p, _p, "m", _FreeTextEditor_getNodeContent).call(_p, child));
                    }
                }
                catch (e_166_1) { e_166 = { error: e_166_1 }; }
                finally {
                    try {
                        if (_u && !_u.done && (_q = _t.return)) _q.call(_t);
                    }
                    finally { if (e_166) throw e_166.error; }
                }
            }
            bufferBefore.push(startContainer.nodeValue.slice(0, startOffset).replaceAll(EOL_PATTERN, ""));
        }
        else if (startContainer === this.editorDiv) {
            var buffer = bufferBefore;
            var i = 0;
            try {
                for (var _v = __values(this.editorDiv.childNodes), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var child = _w.value;
                    if (i++ === startOffset) {
                        buffer = bufferAfter;
                    }
                    buffer.push(__classPrivateFieldGet(_p, _p, "m", _FreeTextEditor_getNodeContent).call(_p, child));
                }
            }
            catch (e_167_1) { e_167 = { error: e_167_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_r = _v.return)) _r.call(_v);
                }
                finally { if (e_167) throw e_167.error; }
            }
        }
        __classPrivateFieldSet(this, _FreeTextEditor_content, "".concat(bufferBefore.join("\n")).concat(paste).concat(bufferAfter.join("\n")), "f");
        __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_setContent).call(this);
        var newRange = new Range();
        var beforeLength = Math.sumPrecise(bufferBefore.map(function (line) { return line.length; }));
        try {
            for (var _z = __values(this.editorDiv.childNodes), _0 = _z.next(); !_0.done; _0 = _z.next()) {
                var firstChild = _0.value.firstChild;
                if (firstChild.nodeType === Node.TEXT_NODE) {
                    var length = firstChild.nodeValue.length;
                    if (beforeLength <= length) {
                        newRange.setStart(firstChild, beforeLength);
                        newRange.setEnd(firstChild, beforeLength);
                        break;
                    }
                    beforeLength -= length;
                }
            }
        }
        catch (e_168_1) { e_168 = { error: e_168_1 }; }
        finally {
            try {
                if (_0 && !_0.done && (_s = _z.return)) _s.call(_z);
            }
            finally { if (e_168) throw e_168.error; }
        }
        selection.removeAllRanges();
        selection.addRange(newRange);
    };
    Object.defineProperty(FreeTextEditor.prototype, "contentDiv", {
        get: function () {
            return this.editorDiv;
        },
        enumerable: false,
        configurable: true
    });
    FreeTextEditor.deserialize = function (data, parent, uiManager) {
        return __awaiter(this, void 0, void 0, function () {
            var initialData, _q, _r, fontSize, fontColor, rect, rotation, id, popupRef, textContent, textPosition, pageNumber, editor;
            return __generator(this, function (_s) {
                switch (_s.label) {
                    case 0:
                        initialData = null;
                        if (data instanceof FreeTextAnnotationElement) {
                            _q = data.data, _r = _q.defaultAppearanceData, fontSize = _r.fontSize, fontColor = _r.fontColor, rect = _q.rect, rotation = _q.rotation, id = _q.id, popupRef = _q.popupRef, textContent = data.textContent, textPosition = data.textPosition, pageNumber = data.parent.page.pageNumber;
                            if (!textContent || textContent.length === 0) {
                                return [2 /*return*/, null];
                            }
                            initialData = data = {
                                annotationType: AnnotationEditorType.FREETEXT,
                                color: Array.from(fontColor),
                                fontSize: fontSize,
                                value: textContent.join("\n"),
                                position: textPosition,
                                pageIndex: pageNumber - 1,
                                rect: rect.slice(0),
                                rotation: rotation,
                                id: id,
                                deleted: false,
                                popupRef: popupRef
                            };
                        }
                        return [4 /*yield*/, _super.deserialize.call(this, data, parent, uiManager)];
                    case 1:
                        editor = _s.sent();
                        __classPrivateFieldSet(editor, _FreeTextEditor_fontSize, data.fontSize, "f");
                        __classPrivateFieldSet(editor, _FreeTextEditor_color, Util.makeHexColor.apply(Util, __spreadArray([], __read(data.color), false)), "f");
                        __classPrivateFieldSet(editor, _FreeTextEditor_content, __classPrivateFieldGet(_p, _p, "m", _FreeTextEditor_deserializeContent).call(_p, data.value), "f");
                        editor.annotationElementId = data.id || null;
                        editor._initialData = initialData;
                        return [2 /*return*/, editor];
                }
            });
        });
    };
    FreeTextEditor.prototype.serialize = function (isForCopying) {
        if (isForCopying === void 0) { isForCopying = false; }
        if (this.isEmpty()) {
            return null;
        }
        if (this.deleted) {
            return this.serializeDeleted();
        }
        var padding = _p._internalPadding * this.parentScale;
        var rect = this.getRect(padding, padding);
        var color = AnnotationEditor._colorManager.convert(this.isAttachedToDOM ? getComputedStyle(this.editorDiv).color : __classPrivateFieldGet(this, _FreeTextEditor_color, "f"));
        var serialized = {
            annotationType: AnnotationEditorType.FREETEXT,
            color: color,
            fontSize: __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f"),
            value: __classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_serializeContent).call(this),
            pageIndex: this.pageIndex,
            rect: rect,
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId
        };
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !__classPrivateFieldGet(this, _FreeTextEditor_instances, "m", _FreeTextEditor_hasElementChanged).call(this, serialized)) {
            return null;
        }
        serialized.id = this.annotationElementId;
        return serialized;
    };
    FreeTextEditor.prototype.renderAnnotationElement = function (annotation) {
        var e_169, _q;
        var content = _super.prototype.renderAnnotationElement.call(this, annotation);
        if (this.deleted) {
            return content;
        }
        var style = content.style;
        style.fontSize = "calc(".concat(__classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f"), "px * var(--total-scale-factor))");
        style.color = __classPrivateFieldGet(this, _FreeTextEditor_color, "f");
        content.replaceChildren();
        try {
            for (var _r = __values(__classPrivateFieldGet(this, _FreeTextEditor_content, "f").split("\n")), _s = _r.next(); !_s.done; _s = _r.next()) {
                var line = _s.value;
                var div = document.createElement("div");
                div.append(line ? document.createTextNode(line) : document.createElement("br"));
                content.append(div);
            }
        }
        catch (e_169_1) { e_169 = { error: e_169_1 }; }
        finally {
            try {
                if (_s && !_s.done && (_q = _r.return)) _q.call(_r);
            }
            finally { if (e_169) throw e_169.error; }
        }
        var padding = _p._internalPadding * this.parentScale;
        annotation.updateEdited({
            rect: this.getRect(padding, padding),
            popupContent: __classPrivateFieldGet(this, _FreeTextEditor_content, "f")
        });
        return content;
    };
    FreeTextEditor.prototype.resetAnnotationElement = function (annotation) {
        _super.prototype.resetAnnotationElement.call(this, annotation);
        annotation.resetEdited();
    };
    var _FreeTextEditor_instances, _p, _FreeTextEditor_color, _FreeTextEditor_content, _FreeTextEditor_editorDivId, _FreeTextEditor_editModeAC, _FreeTextEditor_fontSize, _FreeTextEditor_updateFontSize, _FreeTextEditor_updateColor, _FreeTextEditor_extractText, _FreeTextEditor_setEditorDimensions, _FreeTextEditor_getNodeContent, _FreeTextEditor_setContent, _FreeTextEditor_serializeContent, _FreeTextEditor_deserializeContent, _FreeTextEditor_hasElementChanged;
    _p = FreeTextEditor, _FreeTextEditor_color = new WeakMap(), _FreeTextEditor_content = new WeakMap(), _FreeTextEditor_editorDivId = new WeakMap(), _FreeTextEditor_editModeAC = new WeakMap(), _FreeTextEditor_fontSize = new WeakMap(), _FreeTextEditor_instances = new WeakSet(), _FreeTextEditor_updateFontSize = function _FreeTextEditor_updateFontSize(fontSize) {
        var _this = this;
        var setFontsize = function (size) {
            _this.editorDiv.style.fontSize = "calc(".concat(size, "px * var(--total-scale-factor))");
            _this.translate(0, -(size - __classPrivateFieldGet(_this, _FreeTextEditor_fontSize, "f")) * _this.parentScale);
            __classPrivateFieldSet(_this, _FreeTextEditor_fontSize, size, "f");
            __classPrivateFieldGet(_this, _FreeTextEditor_instances, "m", _FreeTextEditor_setEditorDimensions).call(_this);
        };
        var savedFontsize = __classPrivateFieldGet(this, _FreeTextEditor_fontSize, "f");
        this.addCommands({
            cmd: setFontsize.bind(this, fontSize),
            undo: setFontsize.bind(this, savedFontsize),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: AnnotationEditorParamsType.FREETEXT_SIZE,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }, _FreeTextEditor_updateColor = function _FreeTextEditor_updateColor(color) {
        var _this = this;
        var setColor = function (col) {
            __classPrivateFieldSet(_this, _FreeTextEditor_color, _this.editorDiv.style.color = col, "f");
        };
        var savedColor = __classPrivateFieldGet(this, _FreeTextEditor_color, "f");
        this.addCommands({
            cmd: setColor.bind(this, color),
            undo: setColor.bind(this, savedColor),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: AnnotationEditorParamsType.FREETEXT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
    }, _FreeTextEditor_extractText = function _FreeTextEditor_extractText() {
        var e_170, _q;
        var buffer = [];
        this.editorDiv.normalize();
        var prevChild = null;
        try {
            for (var _r = __values(this.editorDiv.childNodes), _s = _r.next(); !_s.done; _s = _r.next()) {
                var child = _s.value;
                if ((prevChild === null || prevChild === void 0 ? void 0 : prevChild.nodeType) === Node.TEXT_NODE && child.nodeName === "BR") {
                    continue;
                }
                buffer.push(__classPrivateFieldGet(_p, _p, "m", _FreeTextEditor_getNodeContent).call(_p, child));
                prevChild = child;
            }
        }
        catch (e_170_1) { e_170 = { error: e_170_1 }; }
        finally {
            try {
                if (_s && !_s.done && (_q = _r.return)) _q.call(_r);
            }
            finally { if (e_170) throw e_170.error; }
        }
        return buffer.join("\n");
    }, _FreeTextEditor_setEditorDimensions = function _FreeTextEditor_setEditorDimensions() {
        var _q = __read(this.parentDimensions, 2), parentWidth = _q[0], parentHeight = _q[1];
        var rect;
        if (this.isAttachedToDOM) {
            rect = this.div.getBoundingClientRect();
        }
        else {
            var _r = this, currentLayer = _r.currentLayer, div = _r.div;
            var savedDisplay = div.style.display;
            var savedVisibility = div.classList.contains("hidden");
            div.classList.remove("hidden");
            div.style.display = "hidden";
            currentLayer.div.append(this.div);
            rect = div.getBoundingClientRect();
            div.remove();
            div.style.display = savedDisplay;
            div.classList.toggle("hidden", savedVisibility);
        }
        if (this.rotation % 180 === this.parentRotation % 180) {
            this.width = rect.width / parentWidth;
            this.height = rect.height / parentHeight;
        }
        else {
            this.width = rect.height / parentWidth;
            this.height = rect.width / parentHeight;
        }
        this.fixAndSetPosition();
    }, _FreeTextEditor_getNodeContent = function _FreeTextEditor_getNodeContent(node) {
        return (node.nodeType === Node.TEXT_NODE ? node.nodeValue : node.innerText).replaceAll(EOL_PATTERN, "");
    }, _FreeTextEditor_setContent = function _FreeTextEditor_setContent() {
        var e_171, _q;
        this.editorDiv.replaceChildren();
        if (!__classPrivateFieldGet(this, _FreeTextEditor_content, "f")) {
            return;
        }
        try {
            for (var _r = __values(__classPrivateFieldGet(this, _FreeTextEditor_content, "f").split("\n")), _s = _r.next(); !_s.done; _s = _r.next()) {
                var line = _s.value;
                var div = document.createElement("div");
                div.append(line ? document.createTextNode(line) : document.createElement("br"));
                this.editorDiv.append(div);
            }
        }
        catch (e_171_1) { e_171 = { error: e_171_1 }; }
        finally {
            try {
                if (_s && !_s.done && (_q = _r.return)) _q.call(_r);
            }
            finally { if (e_171) throw e_171.error; }
        }
    }, _FreeTextEditor_serializeContent = function _FreeTextEditor_serializeContent() {
        return __classPrivateFieldGet(this, _FreeTextEditor_content, "f").replaceAll("\xa0", " ");
    }, _FreeTextEditor_deserializeContent = function _FreeTextEditor_deserializeContent(content) {
        return content.replaceAll(" ", "\xa0");
    }, _FreeTextEditor_hasElementChanged = function _FreeTextEditor_hasElementChanged(serialized) {
        var _q = this._initialData, value = _q.value, fontSize = _q.fontSize, color = _q.color, pageIndex = _q.pageIndex;
        return this._hasBeenMoved || serialized.value !== value || serialized.fontSize !== fontSize || serialized.color.some(function (c, i) { return c !== color[i]; }) || serialized.pageIndex !== pageIndex;
    };
    FreeTextEditor._freeTextDefaultContent = "";
    FreeTextEditor._internalPadding = 0;
    FreeTextEditor._defaultColor = null;
    FreeTextEditor._defaultFontSize = 10;
    FreeTextEditor._type = "freetext";
    FreeTextEditor._editorType = AnnotationEditorType.FREETEXT;
    return FreeTextEditor;
}(AnnotationEditor));
; // ./src/display/editor/drawers/outline.js
var Outline = /** @class */ (function () {
    function Outline() {
    }
    Outline.prototype.toSVGPath = function () {
        unreachable("Abstract method `toSVGPath` must be implemented.");
    };
    Object.defineProperty(Outline.prototype, "box", {
        get: function () {
            unreachable("Abstract getter `box` must be implemented.");
        },
        enumerable: false,
        configurable: true
    });
    Outline.prototype.serialize = function (_bbox, _rotation) {
        unreachable("Abstract method `serialize` must be implemented.");
    };
    Outline._rescale = function (src, tx, ty, sx, sy, dest) {
        dest || (dest = new Float32Array(src.length));
        for (var i = 0, ii = src.length; i < ii; i += 2) {
            dest[i] = tx + src[i] * sx;
            dest[i + 1] = ty + src[i + 1] * sy;
        }
        return dest;
    };
    Outline._rescaleAndSwap = function (src, tx, ty, sx, sy, dest) {
        dest || (dest = new Float32Array(src.length));
        for (var i = 0, ii = src.length; i < ii; i += 2) {
            dest[i] = tx + src[i + 1] * sx;
            dest[i + 1] = ty + src[i] * sy;
        }
        return dest;
    };
    Outline._translate = function (src, tx, ty, dest) {
        dest || (dest = new Float32Array(src.length));
        for (var i = 0, ii = src.length; i < ii; i += 2) {
            dest[i] = tx + src[i];
            dest[i + 1] = ty + src[i + 1];
        }
        return dest;
    };
    Outline.svgRound = function (x) {
        return Math.round(x * 10000);
    };
    Outline._normalizePoint = function (x, y, parentWidth, parentHeight, rotation) {
        switch (rotation) {
            case 90:
                return [1 - y / parentWidth, x / parentHeight];
            case 180:
                return [1 - x / parentWidth, 1 - y / parentHeight];
            case 270:
                return [y / parentWidth, 1 - x / parentHeight];
            default:
                return [x / parentWidth, y / parentHeight];
        }
    };
    Outline._normalizePagePoint = function (x, y, rotation) {
        switch (rotation) {
            case 90:
                return [1 - y, x];
            case 180:
                return [1 - x, 1 - y];
            case 270:
                return [y, 1 - x];
            default:
                return [x, y];
        }
    };
    Outline.createBezierPoints = function (x1, y1, x2, y2, x3, y3) {
        return [(x1 + 5 * x2) / 6, (y1 + 5 * y2) / 6, (5 * x2 + x3) / 6, (5 * y2 + y3) / 6, (x2 + x3) / 2, (y2 + y3) / 2];
    };
    Outline.PRECISION = 1e-4;
    return Outline;
}());
; // ./src/display/editor/drawers/freedraw.js
var FreeDrawOutliner = /** @class */ (function () {
    function FreeDrawOutliner(_r, box, scaleFactor, thickness, isLTR, innerMargin) {
        var x = _r.x, y = _r.y;
        if (innerMargin === void 0) { innerMargin = 0; }
        _FreeDrawOutliner_instances.add(this);
        _FreeDrawOutliner_box.set(this, void 0);
        _FreeDrawOutliner_bottom.set(this, []);
        _FreeDrawOutliner_innerMargin.set(this, void 0);
        _FreeDrawOutliner_isLTR.set(this, void 0);
        _FreeDrawOutliner_top.set(this, []);
        _FreeDrawOutliner_last.set(this, new Float32Array(18));
        _FreeDrawOutliner_lastX.set(this, void 0);
        _FreeDrawOutliner_lastY.set(this, void 0);
        _FreeDrawOutliner_min.set(this, void 0);
        _FreeDrawOutliner_min_dist.set(this, void 0);
        _FreeDrawOutliner_scaleFactor.set(this, void 0);
        _FreeDrawOutliner_thickness.set(this, void 0);
        _FreeDrawOutliner_points.set(this, []);
        __classPrivateFieldSet(this, _FreeDrawOutliner_box, box, "f");
        __classPrivateFieldSet(this, _FreeDrawOutliner_thickness, thickness * scaleFactor, "f");
        __classPrivateFieldSet(this, _FreeDrawOutliner_isLTR, isLTR, "f");
        __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set([NaN, NaN, NaN, NaN, x, y], 6);
        __classPrivateFieldSet(this, _FreeDrawOutliner_innerMargin, innerMargin, "f");
        __classPrivateFieldSet(this, _FreeDrawOutliner_min_dist, __classPrivateFieldGet(_q, _q, "f", _FreeDrawOutliner_MIN_DIST) * scaleFactor, "f");
        __classPrivateFieldSet(this, _FreeDrawOutliner_min, __classPrivateFieldGet(_q, _q, "f", _FreeDrawOutliner_MIN) * scaleFactor, "f");
        __classPrivateFieldSet(this, _FreeDrawOutliner_scaleFactor, scaleFactor, "f");
        __classPrivateFieldGet(this, _FreeDrawOutliner_points, "f").push(x, y);
    }
    FreeDrawOutliner.prototype.isEmpty = function () {
        return isNaN(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[8]);
    };
    FreeDrawOutliner.prototype.add = function (_r) {
        var _s, _t, _u, _v;
        var _w;
        var x = _r.x, y = _r.y;
        __classPrivateFieldSet(this, _FreeDrawOutliner_lastX, x, "f");
        __classPrivateFieldSet(this, _FreeDrawOutliner_lastY, y, "f");
        var _z = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), 4), layerX = _z[0], layerY = _z[1], layerWidth = _z[2], layerHeight = _z[3];
        var _0 = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(8, 12), 4), x1 = _0[0], y1 = _0[1], x2 = _0[2], y2 = _0[3];
        var diffX = x - x2;
        var diffY = y - y2;
        var d = Math.hypot(diffX, diffY);
        if (d < __classPrivateFieldGet(this, _FreeDrawOutliner_min, "f")) {
            return false;
        }
        var diffD = d - __classPrivateFieldGet(this, _FreeDrawOutliner_min_dist, "f");
        var K = diffD / d;
        var shiftX = K * diffX;
        var shiftY = K * diffY;
        var x0 = x1;
        var y0 = y1;
        x1 = x2;
        y1 = y2;
        x2 += shiftX;
        y2 += shiftY;
        (_w = __classPrivateFieldGet(this, _FreeDrawOutliner_points, "f")) === null || _w === void 0 ? void 0 : _w.push(x, y);
        var nX = -shiftY / diffD;
        var nY = shiftX / diffD;
        var thX = nX * __classPrivateFieldGet(this, _FreeDrawOutliner_thickness, "f");
        var thY = nY * __classPrivateFieldGet(this, _FreeDrawOutliner_thickness, "f");
        __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(2, 8), 0);
        __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set([x2 + thX, y2 + thY], 4);
        __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(14, 18), 12);
        __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set([x2 - thX, y2 - thY], 16);
        if (isNaN(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[6])) {
            if (__classPrivateFieldGet(this, _FreeDrawOutliner_top, "f").length === 0) {
                __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set([x1 + thX, y1 + thY], 2);
                __classPrivateFieldGet(this, _FreeDrawOutliner_top, "f").push(NaN, NaN, NaN, NaN, (x1 + thX - layerX) / layerWidth, (y1 + thY - layerY) / layerHeight);
                __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set([x1 - thX, y1 - thY], 14);
                __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f").push(NaN, NaN, NaN, NaN, (x1 - thX - layerX) / layerWidth, (y1 - thY - layerY) / layerHeight);
            }
            __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set([x0, y0, x1, y1, x2, y2], 6);
            return !this.isEmpty();
        }
        __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").set([x0, y0, x1, y1, x2, y2], 6);
        var angle = Math.abs(Math.atan2(y0 - y1, x0 - x1) - Math.atan2(shiftY, shiftX));
        if (angle < Math.PI / 2) {
            _s = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(2, 6), 4), x1 = _s[0], y1 = _s[1], x2 = _s[2], y2 = _s[3];
            __classPrivateFieldGet(this, _FreeDrawOutliner_top, "f").push(NaN, NaN, NaN, NaN, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
            _t = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(14, 18), 4), x1 = _t[0], y1 = _t[1], x0 = _t[2], y0 = _t[3];
            __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f").push(NaN, NaN, NaN, NaN, ((x0 + x1) / 2 - layerX) / layerWidth, ((y0 + y1) / 2 - layerY) / layerHeight);
            return true;
        }
        _u = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(0, 6), 6), x0 = _u[0], y0 = _u[1], x1 = _u[2], y1 = _u[3], x2 = _u[4], y2 = _u[5];
        __classPrivateFieldGet(this, _FreeDrawOutliner_top, "f").push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        _v = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(12, 18), 6), x2 = _v[0], y2 = _v[1], x1 = _v[2], y1 = _v[3], x0 = _v[4], y0 = _v[5];
        __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f").push(((x0 + 5 * x1) / 6 - layerX) / layerWidth, ((y0 + 5 * y1) / 6 - layerY) / layerHeight, ((5 * x1 + x2) / 6 - layerX) / layerWidth, ((5 * y1 + y2) / 6 - layerY) / layerHeight, ((x1 + x2) / 2 - layerX) / layerWidth, ((y1 + y2) / 2 - layerY) / layerHeight);
        return true;
    };
    FreeDrawOutliner.prototype.toSVGPath = function () {
        if (this.isEmpty()) {
            return "";
        }
        var top = __classPrivateFieldGet(this, _FreeDrawOutliner_top, "f");
        var bottom = __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f");
        if (isNaN(__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[6]) && !this.isEmpty()) {
            return __classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_toSVGPathTwoPoints).call(this);
        }
        var buffer = [];
        buffer.push("M".concat(top[4], " ").concat(top[5]));
        for (var i = 6; i < top.length; i += 6) {
            if (isNaN(top[i])) {
                buffer.push("L".concat(top[i + 4], " ").concat(top[i + 5]));
            }
            else {
                buffer.push("C".concat(top[i], " ").concat(top[i + 1], " ").concat(top[i + 2], " ").concat(top[i + 3], " ").concat(top[i + 4], " ").concat(top[i + 5]));
            }
        }
        __classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_toSVGPathEnd).call(this, buffer);
        for (var i = bottom.length - 6; i >= 6; i -= 6) {
            if (isNaN(bottom[i])) {
                buffer.push("L".concat(bottom[i + 4], " ").concat(bottom[i + 5]));
            }
            else {
                buffer.push("C".concat(bottom[i], " ").concat(bottom[i + 1], " ").concat(bottom[i + 2], " ").concat(bottom[i + 3], " ").concat(bottom[i + 4], " ").concat(bottom[i + 5]));
            }
        }
        __classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_toSVGPathStart).call(this, buffer);
        return buffer.join(" ");
    };
    FreeDrawOutliner.prototype.newFreeDrawOutline = function (outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    };
    FreeDrawOutliner.prototype.getOutlines = function () {
        var _r, _s;
        var top = __classPrivateFieldGet(this, _FreeDrawOutliner_top, "f");
        var bottom = __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f");
        var last = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f");
        var _t = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), 4), layerX = _t[0], layerY = _t[1], layerWidth = _t[2], layerHeight = _t[3];
        var points = new Float32Array(((_s = (_r = __classPrivateFieldGet(this, _FreeDrawOutliner_points, "f")) === null || _r === void 0 ? void 0 : _r.length) !== null && _s !== void 0 ? _s : 0) + 2);
        for (var i = 0, ii = points.length - 2; i < ii; i += 2) {
            points[i] = (__classPrivateFieldGet(this, _FreeDrawOutliner_points, "f")[i] - layerX) / layerWidth;
            points[i + 1] = (__classPrivateFieldGet(this, _FreeDrawOutliner_points, "f")[i + 1] - layerY) / layerHeight;
        }
        points[points.length - 2] = (__classPrivateFieldGet(this, _FreeDrawOutliner_lastX, "f") - layerX) / layerWidth;
        points[points.length - 1] = (__classPrivateFieldGet(this, _FreeDrawOutliner_lastY, "f") - layerY) / layerHeight;
        if (isNaN(last[6]) && !this.isEmpty()) {
            return __classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_getOutlineTwoPoints).call(this, points);
        }
        var outline = new Float32Array(__classPrivateFieldGet(this, _FreeDrawOutliner_top, "f").length + 24 + __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f").length);
        var N = top.length;
        for (var i = 0; i < N; i += 2) {
            if (isNaN(top[i])) {
                outline[i] = outline[i + 1] = NaN;
                continue;
            }
            outline[i] = top[i];
            outline[i + 1] = top[i + 1];
        }
        N = __classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_getOutlineEnd).call(this, outline, N);
        for (var i = bottom.length - 6; i >= 6; i -= 6) {
            for (var j = 0; j < 6; j += 2) {
                if (isNaN(bottom[i + j])) {
                    outline[N] = outline[N + 1] = NaN;
                    N += 2;
                    continue;
                }
                outline[N] = bottom[i + j];
                outline[N + 1] = bottom[i + j + 1];
                N += 2;
            }
        }
        __classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_getOutlineStart).call(this, outline, N);
        return this.newFreeDrawOutline(outline, points, __classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), __classPrivateFieldGet(this, _FreeDrawOutliner_scaleFactor, "f"), __classPrivateFieldGet(this, _FreeDrawOutliner_innerMargin, "f"), __classPrivateFieldGet(this, _FreeDrawOutliner_isLTR, "f"));
    };
    var _FreeDrawOutliner_instances, _q, _FreeDrawOutliner_box, _FreeDrawOutliner_bottom, _FreeDrawOutliner_innerMargin, _FreeDrawOutliner_isLTR, _FreeDrawOutliner_top, _FreeDrawOutliner_last, _FreeDrawOutliner_lastX, _FreeDrawOutliner_lastY, _FreeDrawOutliner_min, _FreeDrawOutliner_min_dist, _FreeDrawOutliner_scaleFactor, _FreeDrawOutliner_thickness, _FreeDrawOutliner_points, _FreeDrawOutliner_MIN_DIST, _FreeDrawOutliner_MIN_DIFF, _FreeDrawOutliner_MIN, _FreeDrawOutliner_getLastCoords, _FreeDrawOutliner_toSVGPathTwoPoints, _FreeDrawOutliner_toSVGPathStart, _FreeDrawOutliner_toSVGPathEnd, _FreeDrawOutliner_getOutlineTwoPoints, _FreeDrawOutliner_getOutlineStart, _FreeDrawOutliner_getOutlineEnd;
    _q = FreeDrawOutliner, _FreeDrawOutliner_box = new WeakMap(), _FreeDrawOutliner_bottom = new WeakMap(), _FreeDrawOutliner_innerMargin = new WeakMap(), _FreeDrawOutliner_isLTR = new WeakMap(), _FreeDrawOutliner_top = new WeakMap(), _FreeDrawOutliner_last = new WeakMap(), _FreeDrawOutliner_lastX = new WeakMap(), _FreeDrawOutliner_lastY = new WeakMap(), _FreeDrawOutliner_min = new WeakMap(), _FreeDrawOutliner_min_dist = new WeakMap(), _FreeDrawOutliner_scaleFactor = new WeakMap(), _FreeDrawOutliner_thickness = new WeakMap(), _FreeDrawOutliner_points = new WeakMap(), _FreeDrawOutliner_instances = new WeakSet(), _FreeDrawOutliner_getLastCoords = function _FreeDrawOutliner_getLastCoords() {
        var lastTop = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(4, 6);
        var lastBottom = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(16, 18);
        var _r = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), 4), x = _r[0], y = _r[1], width = _r[2], height = _r[3];
        return [(__classPrivateFieldGet(this, _FreeDrawOutliner_lastX, "f") + (lastTop[0] - lastBottom[0]) / 2 - x) / width, (__classPrivateFieldGet(this, _FreeDrawOutliner_lastY, "f") + (lastTop[1] - lastBottom[1]) / 2 - y) / height, (__classPrivateFieldGet(this, _FreeDrawOutliner_lastX, "f") + (lastBottom[0] - lastTop[0]) / 2 - x) / width, (__classPrivateFieldGet(this, _FreeDrawOutliner_lastY, "f") + (lastBottom[1] - lastTop[1]) / 2 - y) / height];
    }, _FreeDrawOutliner_toSVGPathTwoPoints = function _FreeDrawOutliner_toSVGPathTwoPoints() {
        var _r = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), 4), x = _r[0], y = _r[1], width = _r[2], height = _r[3];
        var _s = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_getLastCoords).call(this), 4), lastTopX = _s[0], lastTopY = _s[1], lastBottomX = _s[2], lastBottomY = _s[3];
        return "M".concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[2] - x) / width, " ").concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[3] - y) / height, " L").concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[4] - x) / width, " ").concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[5] - y) / height, " L").concat(lastTopX, " ").concat(lastTopY, " L").concat(lastBottomX, " ").concat(lastBottomY, " L").concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[16] - x) / width, " ").concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[17] - y) / height, " L").concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[14] - x) / width, " ").concat((__classPrivateFieldGet(this, _FreeDrawOutliner_last, "f")[15] - y) / height, " Z");
    }, _FreeDrawOutliner_toSVGPathStart = function _FreeDrawOutliner_toSVGPathStart(buffer) {
        var bottom = __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f");
        buffer.push("L".concat(bottom[4], " ").concat(bottom[5], " Z"));
    }, _FreeDrawOutliner_toSVGPathEnd = function _FreeDrawOutliner_toSVGPathEnd(buffer) {
        var _r = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), 4), x = _r[0], y = _r[1], width = _r[2], height = _r[3];
        var lastTop = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(4, 6);
        var lastBottom = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(16, 18);
        var _s = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_getLastCoords).call(this), 4), lastTopX = _s[0], lastTopY = _s[1], lastBottomX = _s[2], lastBottomY = _s[3];
        buffer.push("L".concat((lastTop[0] - x) / width, " ").concat((lastTop[1] - y) / height, " L").concat(lastTopX, " ").concat(lastTopY, " L").concat(lastBottomX, " ").concat(lastBottomY, " L").concat((lastBottom[0] - x) / width, " ").concat((lastBottom[1] - y) / height));
    }, _FreeDrawOutliner_getOutlineTwoPoints = function _FreeDrawOutliner_getOutlineTwoPoints(points) {
        var last = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f");
        var _r = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), 4), layerX = _r[0], layerY = _r[1], layerWidth = _r[2], layerHeight = _r[3];
        var _s = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_getLastCoords).call(this), 4), lastTopX = _s[0], lastTopY = _s[1], lastBottomX = _s[2], lastBottomY = _s[3];
        var outline = new Float32Array(36);
        outline.set([NaN, NaN, NaN, NaN, (last[2] - layerX) / layerWidth, (last[3] - layerY) / layerHeight, NaN, NaN, NaN, NaN, (last[4] - layerX) / layerWidth, (last[5] - layerY) / layerHeight, NaN, NaN, NaN, NaN, lastTopX, lastTopY, NaN, NaN, NaN, NaN, lastBottomX, lastBottomY, NaN, NaN, NaN, NaN, (last[16] - layerX) / layerWidth, (last[17] - layerY) / layerHeight, NaN, NaN, NaN, NaN, (last[14] - layerX) / layerWidth, (last[15] - layerY) / layerHeight], 0);
        return this.newFreeDrawOutline(outline, points, __classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), __classPrivateFieldGet(this, _FreeDrawOutliner_scaleFactor, "f"), __classPrivateFieldGet(this, _FreeDrawOutliner_innerMargin, "f"), __classPrivateFieldGet(this, _FreeDrawOutliner_isLTR, "f"));
    }, _FreeDrawOutliner_getOutlineStart = function _FreeDrawOutliner_getOutlineStart(outline, pos) {
        var bottom = __classPrivateFieldGet(this, _FreeDrawOutliner_bottom, "f");
        outline.set([NaN, NaN, NaN, NaN, bottom[4], bottom[5]], pos);
        return pos += 6;
    }, _FreeDrawOutliner_getOutlineEnd = function _FreeDrawOutliner_getOutlineEnd(outline, pos) {
        var lastTop = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(4, 6);
        var lastBottom = __classPrivateFieldGet(this, _FreeDrawOutliner_last, "f").subarray(16, 18);
        var _r = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_box, "f"), 4), layerX = _r[0], layerY = _r[1], layerWidth = _r[2], layerHeight = _r[3];
        var _s = __read(__classPrivateFieldGet(this, _FreeDrawOutliner_instances, "m", _FreeDrawOutliner_getLastCoords).call(this), 4), lastTopX = _s[0], lastTopY = _s[1], lastBottomX = _s[2], lastBottomY = _s[3];
        outline.set([NaN, NaN, NaN, NaN, (lastTop[0] - layerX) / layerWidth, (lastTop[1] - layerY) / layerHeight, NaN, NaN, NaN, NaN, lastTopX, lastTopY, NaN, NaN, NaN, NaN, lastBottomX, lastBottomY, NaN, NaN, NaN, NaN, (lastBottom[0] - layerX) / layerWidth, (lastBottom[1] - layerY) / layerHeight], pos);
        return pos += 24;
    };
    _FreeDrawOutliner_MIN_DIST = { value: 8 };
    _FreeDrawOutliner_MIN_DIFF = { value: 2 };
    _FreeDrawOutliner_MIN = { value: __classPrivateFieldGet(_q, _q, "f", _FreeDrawOutliner_MIN_DIST) + __classPrivateFieldGet(_q, _q, "f", _FreeDrawOutliner_MIN_DIFF) };
    return FreeDrawOutliner;
}());
var FreeDrawOutline = /** @class */ (function (_super) {
    __extends(FreeDrawOutline, _super);
    function FreeDrawOutline(outline, points, box, scaleFactor, innerMargin, isLTR) {
        var _this = _super.call(this) || this;
        _FreeDrawOutline_instances.add(_this);
        _FreeDrawOutline_box.set(_this, void 0);
        _FreeDrawOutline_bbox.set(_this, new Float32Array(4));
        _FreeDrawOutline_innerMargin.set(_this, void 0);
        _FreeDrawOutline_isLTR.set(_this, void 0);
        _FreeDrawOutline_points.set(_this, void 0);
        _FreeDrawOutline_scaleFactor.set(_this, void 0);
        _FreeDrawOutline_outline.set(_this, void 0);
        __classPrivateFieldSet(_this, _FreeDrawOutline_outline, outline, "f");
        __classPrivateFieldSet(_this, _FreeDrawOutline_points, points, "f");
        __classPrivateFieldSet(_this, _FreeDrawOutline_box, box, "f");
        __classPrivateFieldSet(_this, _FreeDrawOutline_scaleFactor, scaleFactor, "f");
        __classPrivateFieldSet(_this, _FreeDrawOutline_innerMargin, innerMargin, "f");
        __classPrivateFieldSet(_this, _FreeDrawOutline_isLTR, isLTR, "f");
        _this.lastPoint = [NaN, NaN];
        __classPrivateFieldGet(_this, _FreeDrawOutline_instances, "m", _FreeDrawOutline_computeMinMax).call(_this, isLTR);
        var _r = __read(__classPrivateFieldGet(_this, _FreeDrawOutline_bbox, "f"), 4), x = _r[0], y = _r[1], width = _r[2], height = _r[3];
        for (var i = 0, ii = outline.length; i < ii; i += 2) {
            outline[i] = (outline[i] - x) / width;
            outline[i + 1] = (outline[i + 1] - y) / height;
        }
        for (var i = 0, ii = points.length; i < ii; i += 2) {
            points[i] = (points[i] - x) / width;
            points[i + 1] = (points[i + 1] - y) / height;
        }
        return _this;
    }
    FreeDrawOutline.prototype.toSVGPath = function () {
        var buffer = ["M".concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[4], " ").concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[5])];
        for (var i = 6, ii = __classPrivateFieldGet(this, _FreeDrawOutline_outline, "f").length; i < ii; i += 6) {
            if (isNaN(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i])) {
                buffer.push("L".concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i + 4], " ").concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i + 5]));
                continue;
            }
            buffer.push("C".concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i], " ").concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i + 1], " ").concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i + 2], " ").concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i + 3], " ").concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i + 4], " ").concat(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f")[i + 5]));
        }
        buffer.push("Z");
        return buffer.join(" ");
    };
    FreeDrawOutline.prototype.serialize = function (_r, rotation) {
        var _s = __read(_r, 4), blX = _s[0], blY = _s[1], trX = _s[2], trY = _s[3];
        var width = trX - blX;
        var height = trY - blY;
        var outline;
        var points;
        switch (rotation) {
            case 0:
                outline = Outline._rescale(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f"), blX, trY, width, -height);
                points = Outline._rescale(__classPrivateFieldGet(this, _FreeDrawOutline_points, "f"), blX, trY, width, -height);
                break;
            case 90:
                outline = Outline._rescaleAndSwap(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f"), blX, blY, width, height);
                points = Outline._rescaleAndSwap(__classPrivateFieldGet(this, _FreeDrawOutline_points, "f"), blX, blY, width, height);
                break;
            case 180:
                outline = Outline._rescale(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f"), trX, blY, -width, height);
                points = Outline._rescale(__classPrivateFieldGet(this, _FreeDrawOutline_points, "f"), trX, blY, -width, height);
                break;
            case 270:
                outline = Outline._rescaleAndSwap(__classPrivateFieldGet(this, _FreeDrawOutline_outline, "f"), trX, trY, -width, -height);
                points = Outline._rescaleAndSwap(__classPrivateFieldGet(this, _FreeDrawOutline_points, "f"), trX, trY, -width, -height);
                break;
        }
        return {
            outline: Array.from(outline),
            points: [Array.from(points)]
        };
    };
    Object.defineProperty(FreeDrawOutline.prototype, "box", {
        get: function () {
            return __classPrivateFieldGet(this, _FreeDrawOutline_bbox, "f");
        },
        enumerable: false,
        configurable: true
    });
    FreeDrawOutline.prototype.newOutliner = function (point, box, scaleFactor, thickness, isLTR, innerMargin) {
        if (innerMargin === void 0) { innerMargin = 0; }
        return new FreeDrawOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    };
    FreeDrawOutline.prototype.getNewOutline = function (thickness, innerMargin) {
        var _r = __read(__classPrivateFieldGet(this, _FreeDrawOutline_bbox, "f"), 4), x = _r[0], y = _r[1], width = _r[2], height = _r[3];
        var _s = __read(__classPrivateFieldGet(this, _FreeDrawOutline_box, "f"), 4), layerX = _s[0], layerY = _s[1], layerWidth = _s[2], layerHeight = _s[3];
        var sx = width * layerWidth;
        var sy = height * layerHeight;
        var tx = x * layerWidth + layerX;
        var ty = y * layerHeight + layerY;
        var outliner = this.newOutliner({
            x: __classPrivateFieldGet(this, _FreeDrawOutline_points, "f")[0] * sx + tx,
            y: __classPrivateFieldGet(this, _FreeDrawOutline_points, "f")[1] * sy + ty
        }, __classPrivateFieldGet(this, _FreeDrawOutline_box, "f"), __classPrivateFieldGet(this, _FreeDrawOutline_scaleFactor, "f"), thickness, __classPrivateFieldGet(this, _FreeDrawOutline_isLTR, "f"), innerMargin !== null && innerMargin !== void 0 ? innerMargin : __classPrivateFieldGet(this, _FreeDrawOutline_innerMargin, "f"));
        for (var i = 2; i < __classPrivateFieldGet(this, _FreeDrawOutline_points, "f").length; i += 2) {
            outliner.add({
                x: __classPrivateFieldGet(this, _FreeDrawOutline_points, "f")[i] * sx + tx,
                y: __classPrivateFieldGet(this, _FreeDrawOutline_points, "f")[i + 1] * sy + ty
            });
        }
        return outliner.getOutlines();
    };
    return FreeDrawOutline;
}(Outline));
_FreeDrawOutline_box = new WeakMap(), _FreeDrawOutline_bbox = new WeakMap(), _FreeDrawOutline_innerMargin = new WeakMap(), _FreeDrawOutline_isLTR = new WeakMap(), _FreeDrawOutline_points = new WeakMap(), _FreeDrawOutline_scaleFactor = new WeakMap(), _FreeDrawOutline_outline = new WeakMap(), _FreeDrawOutline_instances = new WeakSet(), _FreeDrawOutline_computeMinMax = function _FreeDrawOutline_computeMinMax(isLTR) {
    var outline = __classPrivateFieldGet(this, _FreeDrawOutline_outline, "f");
    var lastX = outline[4];
    var lastY = outline[5];
    var minMax = [lastX, lastY, lastX, lastY];
    var lastPointX = lastX;
    var lastPointY = lastY;
    var ltrCallback = isLTR ? Math.max : Math.min;
    for (var i = 6, ii = outline.length; i < ii; i += 6) {
        var x = outline[i + 4], y = outline[i + 5];
        if (isNaN(outline[i])) {
            Util.pointBoundingBox(x, y, minMax);
            if (lastPointY < y) {
                lastPointX = x;
                lastPointY = y;
            }
            else if (lastPointY === y) {
                lastPointX = ltrCallback(lastPointX, x);
            }
        }
        else {
            var bbox_1 = [Infinity, Infinity, -Infinity, -Infinity];
            Util.bezierBoundingBox.apply(Util, __spreadArray(__spreadArray([lastX, lastY], __read(outline.slice(i, i + 6)), false), [bbox_1], false));
            Util.rectBoundingBox.apply(Util, __spreadArray(__spreadArray([], __read(bbox_1), false), [minMax], false));
            if (lastPointY < bbox_1[3]) {
                lastPointX = bbox_1[2];
                lastPointY = bbox_1[3];
            }
            else if (lastPointY === bbox_1[3]) {
                lastPointX = ltrCallback(lastPointX, bbox_1[2]);
            }
        }
        lastX = x;
        lastY = y;
    }
    var bbox = __classPrivateFieldGet(this, _FreeDrawOutline_bbox, "f");
    bbox[0] = minMax[0] - __classPrivateFieldGet(this, _FreeDrawOutline_innerMargin, "f");
    bbox[1] = minMax[1] - __classPrivateFieldGet(this, _FreeDrawOutline_innerMargin, "f");
    bbox[2] = minMax[2] - minMax[0] + 2 * __classPrivateFieldGet(this, _FreeDrawOutline_innerMargin, "f");
    bbox[3] = minMax[3] - minMax[1] + 2 * __classPrivateFieldGet(this, _FreeDrawOutline_innerMargin, "f");
    this.lastPoint = [lastPointX, lastPointY];
};
; // ./src/display/editor/drawers/highlight.js
var HighlightOutliner = /** @class */ (function () {
    function HighlightOutliner(boxes, borderWidth, innerMargin, isLTR) {
        var e_172, _r, e_173, _s;
        if (borderWidth === void 0) { borderWidth = 0; }
        if (innerMargin === void 0) { innerMargin = 0; }
        if (isLTR === void 0) { isLTR = true; }
        _HighlightOutliner_instances.add(this);
        _HighlightOutliner_box.set(this, void 0);
        _HighlightOutliner_lastPoint.set(this, void 0);
        _HighlightOutliner_verticalEdges.set(this, []);
        _HighlightOutliner_intervals.set(this, []);
        var minMax = [Infinity, Infinity, -Infinity, -Infinity];
        var NUMBER_OF_DIGITS = 4;
        var EPSILON = Math.pow(10, -NUMBER_OF_DIGITS);
        try {
            for (var boxes_2 = __values(boxes), boxes_2_1 = boxes_2.next(); !boxes_2_1.done; boxes_2_1 = boxes_2.next()) {
                var _t = boxes_2_1.value, x = _t.x, y = _t.y, width = _t.width, height = _t.height;
                var x1 = Math.floor((x - borderWidth) / EPSILON) * EPSILON;
                var x2 = Math.ceil((x + width + borderWidth) / EPSILON) * EPSILON;
                var y1 = Math.floor((y - borderWidth) / EPSILON) * EPSILON;
                var y2 = Math.ceil((y + height + borderWidth) / EPSILON) * EPSILON;
                var left = [x1, y1, y2, true];
                var right = [x2, y1, y2, false];
                __classPrivateFieldGet(this, _HighlightOutliner_verticalEdges, "f").push(left, right);
                Util.rectBoundingBox(x1, y1, x2, y2, minMax);
            }
        }
        catch (e_172_1) { e_172 = { error: e_172_1 }; }
        finally {
            try {
                if (boxes_2_1 && !boxes_2_1.done && (_r = boxes_2.return)) _r.call(boxes_2);
            }
            finally { if (e_172) throw e_172.error; }
        }
        var bboxWidth = minMax[2] - minMax[0] + 2 * innerMargin;
        var bboxHeight = minMax[3] - minMax[1] + 2 * innerMargin;
        var shiftedMinX = minMax[0] - innerMargin;
        var shiftedMinY = minMax[1] - innerMargin;
        var lastEdge = __classPrivateFieldGet(this, _HighlightOutliner_verticalEdges, "f").at(isLTR ? -1 : -2);
        var lastPoint = [lastEdge[0], lastEdge[2]];
        try {
            for (var _u = __values(__classPrivateFieldGet(this, _HighlightOutliner_verticalEdges, "f")), _v = _u.next(); !_v.done; _v = _u.next()) {
                var edge = _v.value;
                var _w = __read(edge, 3), x = _w[0], y1 = _w[1], y2 = _w[2];
                edge[0] = (x - shiftedMinX) / bboxWidth;
                edge[1] = (y1 - shiftedMinY) / bboxHeight;
                edge[2] = (y2 - shiftedMinY) / bboxHeight;
            }
        }
        catch (e_173_1) { e_173 = { error: e_173_1 }; }
        finally {
            try {
                if (_v && !_v.done && (_s = _u.return)) _s.call(_u);
            }
            finally { if (e_173) throw e_173.error; }
        }
        __classPrivateFieldSet(this, _HighlightOutliner_box, new Float32Array([shiftedMinX, shiftedMinY, bboxWidth, bboxHeight]), "f");
        __classPrivateFieldSet(this, _HighlightOutliner_lastPoint, lastPoint, "f");
    }
    HighlightOutliner.prototype.getOutlines = function () {
        var e_174, _r;
        __classPrivateFieldGet(this, _HighlightOutliner_verticalEdges, "f").sort(function (a, b) { return a[0] - b[0] || a[1] - b[1] || a[2] - b[2]; });
        var outlineVerticalEdges = [];
        try {
            for (var _s = __values(__classPrivateFieldGet(this, _HighlightOutliner_verticalEdges, "f")), _t = _s.next(); !_t.done; _t = _s.next()) {
                var edge = _t.value;
                if (edge[3]) {
                    outlineVerticalEdges.push.apply(outlineVerticalEdges, __spreadArray([], __read(__classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_breakEdge).call(this, edge)), false));
                    __classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_insert).call(this, edge);
                }
                else {
                    __classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_remove).call(this, edge);
                    outlineVerticalEdges.push.apply(outlineVerticalEdges, __spreadArray([], __read(__classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_breakEdge).call(this, edge)), false));
                }
            }
        }
        catch (e_174_1) { e_174 = { error: e_174_1 }; }
        finally {
            try {
                if (_t && !_t.done && (_r = _s.return)) _r.call(_s);
            }
            finally { if (e_174) throw e_174.error; }
        }
        return __classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_getOutlines).call(this, outlineVerticalEdges);
    };
    return HighlightOutliner;
}());
_HighlightOutliner_box = new WeakMap(), _HighlightOutliner_lastPoint = new WeakMap(), _HighlightOutliner_verticalEdges = new WeakMap(), _HighlightOutliner_intervals = new WeakMap(), _HighlightOutliner_instances = new WeakSet(), _HighlightOutliner_getOutlines = function _HighlightOutliner_getOutlines(outlineVerticalEdges) {
    var e_175, _r, _s;
    var edges = [];
    var allEdges = new Set();
    try {
        for (var outlineVerticalEdges_1 = __values(outlineVerticalEdges), outlineVerticalEdges_1_1 = outlineVerticalEdges_1.next(); !outlineVerticalEdges_1_1.done; outlineVerticalEdges_1_1 = outlineVerticalEdges_1.next()) {
            var edge = outlineVerticalEdges_1_1.value;
            var _t = __read(edge, 3), x = _t[0], y1 = _t[1], y2 = _t[2];
            edges.push([x, y1, edge], [x, y2, edge]);
        }
    }
    catch (e_175_1) { e_175 = { error: e_175_1 }; }
    finally {
        try {
            if (outlineVerticalEdges_1_1 && !outlineVerticalEdges_1_1.done && (_r = outlineVerticalEdges_1.return)) _r.call(outlineVerticalEdges_1);
        }
        finally { if (e_175) throw e_175.error; }
    }
    edges.sort(function (a, b) { return a[1] - b[1] || a[0] - b[0]; });
    for (var i = 0, ii = edges.length; i < ii; i += 2) {
        var edge1 = edges[i][2];
        var edge2 = edges[i + 1][2];
        edge1.push(edge2);
        edge2.push(edge1);
        allEdges.add(edge1);
        allEdges.add(edge2);
    }
    var outlines = [];
    var outline;
    while (allEdges.size > 0) {
        var edge = allEdges.values().next().value;
        var _u = __read(edge, 5), x = _u[0], y1 = _u[1], y2 = _u[2], edge1 = _u[3], edge2 = _u[4];
        allEdges.delete(edge);
        var lastPointX = x;
        var lastPointY = y1;
        outline = [x, y2];
        outlines.push(outline);
        while (true) {
            var e = void 0;
            if (allEdges.has(edge1)) {
                e = edge1;
            }
            else if (allEdges.has(edge2)) {
                e = edge2;
            }
            else {
                break;
            }
            allEdges.delete(e);
            _s = __read(e, 5), x = _s[0], y1 = _s[1], y2 = _s[2], edge1 = _s[3], edge2 = _s[4];
            if (lastPointX !== x) {
                outline.push(lastPointX, lastPointY, x, lastPointY === y1 ? y1 : y2);
                lastPointX = x;
            }
            lastPointY = lastPointY === y1 ? y2 : y1;
        }
        outline.push(lastPointX, lastPointY);
    }
    return new HighlightOutline(outlines, __classPrivateFieldGet(this, _HighlightOutliner_box, "f"), __classPrivateFieldGet(this, _HighlightOutliner_lastPoint, "f"));
}, _HighlightOutliner_binarySearch = function _HighlightOutliner_binarySearch(y) {
    var array = __classPrivateFieldGet(this, _HighlightOutliner_intervals, "f");
    var start = 0;
    var end = array.length - 1;
    while (start <= end) {
        var middle = start + end >> 1;
        var y1 = array[middle][0];
        if (y1 === y) {
            return middle;
        }
        if (y1 < y) {
            start = middle + 1;
        }
        else {
            end = middle - 1;
        }
    }
    return end + 1;
}, _HighlightOutliner_insert = function _HighlightOutliner_insert(_r) {
    var _s = __read(_r, 3), y1 = _s[1], y2 = _s[2];
    var index = __classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_binarySearch).call(this, y1);
    __classPrivateFieldGet(this, _HighlightOutliner_intervals, "f").splice(index, 0, [y1, y2]);
}, _HighlightOutliner_remove = function _HighlightOutliner_remove(_r) {
    var _s = __read(_r, 3), y1 = _s[1], y2 = _s[2];
    var index = __classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_binarySearch).call(this, y1);
    for (var i = index; i < __classPrivateFieldGet(this, _HighlightOutliner_intervals, "f").length; i++) {
        var _t = __read(__classPrivateFieldGet(this, _HighlightOutliner_intervals, "f")[i], 2), start = _t[0], end = _t[1];
        if (start !== y1) {
            break;
        }
        if (start === y1 && end === y2) {
            __classPrivateFieldGet(this, _HighlightOutliner_intervals, "f").splice(i, 1);
            return;
        }
    }
    for (var i = index - 1; i >= 0; i--) {
        var _u = __read(__classPrivateFieldGet(this, _HighlightOutliner_intervals, "f")[i], 2), start = _u[0], end = _u[1];
        if (start !== y1) {
            break;
        }
        if (start === y1 && end === y2) {
            __classPrivateFieldGet(this, _HighlightOutliner_intervals, "f").splice(i, 1);
            return;
        }
    }
}, _HighlightOutliner_breakEdge = function _HighlightOutliner_breakEdge(edge) {
    var _r = __read(edge, 3), x = _r[0], y1 = _r[1], y2 = _r[2];
    var results = [[x, y1, y2]];
    var index = __classPrivateFieldGet(this, _HighlightOutliner_instances, "m", _HighlightOutliner_binarySearch).call(this, y2);
    for (var i = 0; i < index; i++) {
        var _s = __read(__classPrivateFieldGet(this, _HighlightOutliner_intervals, "f")[i], 2), start = _s[0], end = _s[1];
        for (var j = 0, jj = results.length; j < jj; j++) {
            var _t = __read(results[j], 3), y3 = _t[1], y4 = _t[2];
            if (end <= y3 || y4 <= start) {
                continue;
            }
            if (y3 >= start) {
                if (y4 > end) {
                    results[j][1] = end;
                }
                else {
                    if (jj === 1) {
                        return [];
                    }
                    results.splice(j, 1);
                    j--;
                    jj--;
                }
                continue;
            }
            results[j][2] = start;
            if (y4 > end) {
                results.push([x, end, y4]);
            }
        }
    }
    return results;
};
var HighlightOutline = /** @class */ (function (_super) {
    __extends(HighlightOutline, _super);
    function HighlightOutline(outlines, box, lastPoint) {
        var _this = _super.call(this) || this;
        _HighlightOutline_box.set(_this, void 0);
        _HighlightOutline_outlines.set(_this, void 0);
        __classPrivateFieldSet(_this, _HighlightOutline_outlines, outlines, "f");
        __classPrivateFieldSet(_this, _HighlightOutline_box, box, "f");
        _this.lastPoint = lastPoint;
        return _this;
    }
    HighlightOutline.prototype.toSVGPath = function () {
        var e_176, _r;
        var buffer = [];
        try {
            for (var _s = __values(__classPrivateFieldGet(this, _HighlightOutline_outlines, "f")), _t = _s.next(); !_t.done; _t = _s.next()) {
                var polygon = _t.value;
                var _u = __read(polygon, 2), prevX = _u[0], prevY = _u[1];
                buffer.push("M".concat(prevX, " ").concat(prevY));
                for (var i = 2; i < polygon.length; i += 2) {
                    var x = polygon[i];
                    var y = polygon[i + 1];
                    if (x === prevX) {
                        buffer.push("V".concat(y));
                        prevY = y;
                    }
                    else if (y === prevY) {
                        buffer.push("H".concat(x));
                        prevX = x;
                    }
                }
                buffer.push("Z");
            }
        }
        catch (e_176_1) { e_176 = { error: e_176_1 }; }
        finally {
            try {
                if (_t && !_t.done && (_r = _s.return)) _r.call(_s);
            }
            finally { if (e_176) throw e_176.error; }
        }
        return buffer.join(" ");
    };
    HighlightOutline.prototype.serialize = function (_r, _rotation) {
        var e_177, _s;
        var _t = __read(_r, 4), blX = _t[0], blY = _t[1], trX = _t[2], trY = _t[3];
        var outlines = [];
        var width = trX - blX;
        var height = trY - blY;
        try {
            for (var _u = __values(__classPrivateFieldGet(this, _HighlightOutline_outlines, "f")), _v = _u.next(); !_v.done; _v = _u.next()) {
                var outline = _v.value;
                var points = new Array(outline.length);
                for (var i = 0; i < outline.length; i += 2) {
                    points[i] = blX + outline[i] * width;
                    points[i + 1] = trY - outline[i + 1] * height;
                }
                outlines.push(points);
            }
        }
        catch (e_177_1) { e_177 = { error: e_177_1 }; }
        finally {
            try {
                if (_v && !_v.done && (_s = _u.return)) _s.call(_u);
            }
            finally { if (e_177) throw e_177.error; }
        }
        return outlines;
    };
    Object.defineProperty(HighlightOutline.prototype, "box", {
        get: function () {
            return __classPrivateFieldGet(this, _HighlightOutline_box, "f");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HighlightOutline.prototype, "classNamesForOutlining", {
        get: function () {
            return ["highlightOutline"];
        },
        enumerable: false,
        configurable: true
    });
    return HighlightOutline;
}(Outline));
_HighlightOutline_box = new WeakMap(), _HighlightOutline_outlines = new WeakMap();
var FreeHighlightOutliner = /** @class */ (function (_super) {
    __extends(FreeHighlightOutliner, _super);
    function FreeHighlightOutliner() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeHighlightOutliner.prototype.newFreeDrawOutline = function (outline, points, box, scaleFactor, innerMargin, isLTR) {
        return new FreeHighlightOutline(outline, points, box, scaleFactor, innerMargin, isLTR);
    };
    return FreeHighlightOutliner;
}(FreeDrawOutliner));
var FreeHighlightOutline = /** @class */ (function (_super) {
    __extends(FreeHighlightOutline, _super);
    function FreeHighlightOutline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    FreeHighlightOutline.prototype.newOutliner = function (point, box, scaleFactor, thickness, isLTR, innerMargin) {
        if (innerMargin === void 0) { innerMargin = 0; }
        return new FreeHighlightOutliner(point, box, scaleFactor, thickness, isLTR, innerMargin);
    };
    return FreeHighlightOutline;
}(FreeDrawOutline));
; // ./src/display/editor/color_picker.js
var ColorPicker = /** @class */ (function () {
    function ColorPicker(_s) {
        var _t = _s.editor, editor = _t === void 0 ? null : _t, _u = _s.uiManager, uiManager = _u === void 0 ? null : _u;
        var _v;
        var _w;
        _ColorPicker_instances.add(this);
        _ColorPicker_button.set(this, null);
        _ColorPicker_buttonSwatch.set(this, null);
        _ColorPicker_defaultColor.set(this, void 0);
        _ColorPicker_dropdown.set(this, null);
        _ColorPicker_dropdownWasFromKeyboard.set(this, false);
        _ColorPicker_isMainColorPicker.set(this, false);
        _ColorPicker_editor.set(this, null);
        _ColorPicker_eventBus.set(this, void 0);
        _ColorPicker_openDropdownAC.set(this, null);
        _ColorPicker_uiManager.set(this, null);
        _ColorPicker_type.set(this, void 0);
        if (editor) {
            __classPrivateFieldSet(this, _ColorPicker_isMainColorPicker, false, "f");
            __classPrivateFieldSet(this, _ColorPicker_type, AnnotationEditorParamsType.HIGHLIGHT_COLOR, "f");
            __classPrivateFieldSet(this, _ColorPicker_editor, editor, "f");
        }
        else {
            __classPrivateFieldSet(this, _ColorPicker_isMainColorPicker, true, "f");
            __classPrivateFieldSet(this, _ColorPicker_type, AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR, "f");
        }
        __classPrivateFieldSet(this, _ColorPicker_uiManager, (editor === null || editor === void 0 ? void 0 : editor._uiManager) || uiManager, "f");
        __classPrivateFieldSet(this, _ColorPicker_eventBus, __classPrivateFieldGet(this, _ColorPicker_uiManager, "f")._eventBus, "f");
        __classPrivateFieldSet(this, _ColorPicker_defaultColor, (editor === null || editor === void 0 ? void 0 : editor.color) || ((_v = __classPrivateFieldGet(this, _ColorPicker_uiManager, "f")) === null || _v === void 0 ? void 0 : _v.highlightColors.values().next().value) || "#FFFF98", "f");
        __classPrivateFieldSet(_w = _r, _r, __classPrivateFieldGet(_w, _r, "f", _ColorPicker_l10nColor) || Object.freeze({
            blue: "pdfjs-editor-colorpicker-blue",
            green: "pdfjs-editor-colorpicker-green",
            pink: "pdfjs-editor-colorpicker-pink",
            red: "pdfjs-editor-colorpicker-red",
            yellow: "pdfjs-editor-colorpicker-yellow"
        }), "f", _ColorPicker_l10nColor);
    }
    Object.defineProperty(ColorPicker, "_keyboardManager", {
        get: function () {
            return shadow(this, "_keyboardManager", new KeyboardManager([[["Escape", "mac+Escape"], _r.prototype._hideDropdownFromKeyboard], [[" ", "mac+ "], _r.prototype._colorSelectFromKeyboard], [["ArrowDown", "ArrowRight", "mac+ArrowDown", "mac+ArrowRight"], _r.prototype._moveToNext], [["ArrowUp", "ArrowLeft", "mac+ArrowUp", "mac+ArrowLeft"], _r.prototype._moveToPrevious], [["Home", "mac+Home"], _r.prototype._moveToBeginning], [["End", "mac+End"], _r.prototype._moveToEnd]]));
        },
        enumerable: false,
        configurable: true
    });
    ColorPicker.prototype.renderButton = function () {
        var button = __classPrivateFieldSet(this, _ColorPicker_button, document.createElement("button"), "f");
        button.className = "colorPicker";
        button.tabIndex = "0";
        button.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-button");
        button.setAttribute("aria-haspopup", true);
        var signal = __classPrivateFieldGet(this, _ColorPicker_uiManager, "f")._signal;
        button.addEventListener("click", __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_openDropdown).bind(this), {
            signal: signal
        });
        button.addEventListener("keydown", __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_keyDown).bind(this), {
            signal: signal
        });
        var swatch = __classPrivateFieldSet(this, _ColorPicker_buttonSwatch, document.createElement("span"), "f");
        swatch.className = "swatch";
        swatch.setAttribute("aria-hidden", true);
        swatch.style.backgroundColor = __classPrivateFieldGet(this, _ColorPicker_defaultColor, "f");
        button.append(swatch);
        return button;
    };
    ColorPicker.prototype.renderMainDropdown = function () {
        var dropdown = __classPrivateFieldSet(this, _ColorPicker_dropdown, __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_getDropdownRoot).call(this), "f");
        dropdown.setAttribute("aria-orientation", "horizontal");
        dropdown.setAttribute("aria-labelledby", "highlightColorPickerLabel");
        return dropdown;
    };
    ColorPicker.prototype._colorSelectFromKeyboard = function (event) {
        if (event.target === __classPrivateFieldGet(this, _ColorPicker_button, "f")) {
            __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_openDropdown).call(this, event);
            return;
        }
        var color = event.target.getAttribute("data-color");
        if (!color) {
            return;
        }
        __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_colorSelect).call(this, color, event);
    };
    ColorPicker.prototype._moveToNext = function (event) {
        var _s, _t;
        if (!__classPrivateFieldGet(this, _ColorPicker_instances, "a", _ColorPicker_isDropdownVisible_get)) {
            __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_openDropdown).call(this, event);
            return;
        }
        if (event.target === __classPrivateFieldGet(this, _ColorPicker_button, "f")) {
            (_s = __classPrivateFieldGet(this, _ColorPicker_dropdown, "f").firstChild) === null || _s === void 0 ? void 0 : _s.focus();
            return;
        }
        (_t = event.target.nextSibling) === null || _t === void 0 ? void 0 : _t.focus();
    };
    ColorPicker.prototype._moveToPrevious = function (event) {
        var _s, _t;
        if (event.target === ((_s = __classPrivateFieldGet(this, _ColorPicker_dropdown, "f")) === null || _s === void 0 ? void 0 : _s.firstChild) || event.target === __classPrivateFieldGet(this, _ColorPicker_button, "f")) {
            if (__classPrivateFieldGet(this, _ColorPicker_instances, "a", _ColorPicker_isDropdownVisible_get)) {
                this._hideDropdownFromKeyboard();
            }
            return;
        }
        if (!__classPrivateFieldGet(this, _ColorPicker_instances, "a", _ColorPicker_isDropdownVisible_get)) {
            __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_openDropdown).call(this, event);
        }
        (_t = event.target.previousSibling) === null || _t === void 0 ? void 0 : _t.focus();
    };
    ColorPicker.prototype._moveToBeginning = function (event) {
        var _s;
        if (!__classPrivateFieldGet(this, _ColorPicker_instances, "a", _ColorPicker_isDropdownVisible_get)) {
            __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_openDropdown).call(this, event);
            return;
        }
        (_s = __classPrivateFieldGet(this, _ColorPicker_dropdown, "f").firstChild) === null || _s === void 0 ? void 0 : _s.focus();
    };
    ColorPicker.prototype._moveToEnd = function (event) {
        var _s;
        if (!__classPrivateFieldGet(this, _ColorPicker_instances, "a", _ColorPicker_isDropdownVisible_get)) {
            __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_openDropdown).call(this, event);
            return;
        }
        (_s = __classPrivateFieldGet(this, _ColorPicker_dropdown, "f").lastChild) === null || _s === void 0 ? void 0 : _s.focus();
    };
    ColorPicker.prototype.hideDropdown = function () {
        var _s, _t;
        (_s = __classPrivateFieldGet(this, _ColorPicker_dropdown, "f")) === null || _s === void 0 ? void 0 : _s.classList.add("hidden");
        (_t = __classPrivateFieldGet(this, _ColorPicker_openDropdownAC, "f")) === null || _t === void 0 ? void 0 : _t.abort();
        __classPrivateFieldSet(this, _ColorPicker_openDropdownAC, null, "f");
    };
    ColorPicker.prototype._hideDropdownFromKeyboard = function () {
        var _s;
        if (__classPrivateFieldGet(this, _ColorPicker_isMainColorPicker, "f")) {
            return;
        }
        if (!__classPrivateFieldGet(this, _ColorPicker_instances, "a", _ColorPicker_isDropdownVisible_get)) {
            (_s = __classPrivateFieldGet(this, _ColorPicker_editor, "f")) === null || _s === void 0 ? void 0 : _s.unselect();
            return;
        }
        this.hideDropdown();
        __classPrivateFieldGet(this, _ColorPicker_button, "f").focus({
            preventScroll: true,
            focusVisible: __classPrivateFieldGet(this, _ColorPicker_dropdownWasFromKeyboard, "f")
        });
    };
    ColorPicker.prototype.updateColor = function (color) {
        var e_178, _s;
        if (__classPrivateFieldGet(this, _ColorPicker_buttonSwatch, "f")) {
            __classPrivateFieldGet(this, _ColorPicker_buttonSwatch, "f").style.backgroundColor = color;
        }
        if (!__classPrivateFieldGet(this, _ColorPicker_dropdown, "f")) {
            return;
        }
        var i = __classPrivateFieldGet(this, _ColorPicker_uiManager, "f").highlightColors.values();
        try {
            for (var _t = __values(__classPrivateFieldGet(this, _ColorPicker_dropdown, "f").children), _u = _t.next(); !_u.done; _u = _t.next()) {
                var child = _u.value;
                child.setAttribute("aria-selected", i.next().value === color);
            }
        }
        catch (e_178_1) { e_178 = { error: e_178_1 }; }
        finally {
            try {
                if (_u && !_u.done && (_s = _t.return)) _s.call(_t);
            }
            finally { if (e_178) throw e_178.error; }
        }
    };
    ColorPicker.prototype.destroy = function () {
        var _s, _t;
        (_s = __classPrivateFieldGet(this, _ColorPicker_button, "f")) === null || _s === void 0 ? void 0 : _s.remove();
        __classPrivateFieldSet(this, _ColorPicker_button, null, "f");
        __classPrivateFieldSet(this, _ColorPicker_buttonSwatch, null, "f");
        (_t = __classPrivateFieldGet(this, _ColorPicker_dropdown, "f")) === null || _t === void 0 ? void 0 : _t.remove();
        __classPrivateFieldSet(this, _ColorPicker_dropdown, null, "f");
    };
    var _ColorPicker_instances, _r, _ColorPicker_button, _ColorPicker_buttonSwatch, _ColorPicker_defaultColor, _ColorPicker_dropdown, _ColorPicker_dropdownWasFromKeyboard, _ColorPicker_isMainColorPicker, _ColorPicker_editor, _ColorPicker_eventBus, _ColorPicker_openDropdownAC, _ColorPicker_uiManager, _ColorPicker_type, _ColorPicker_l10nColor, _ColorPicker_getDropdownRoot, _ColorPicker_colorSelect, _ColorPicker_keyDown, _ColorPicker_openDropdown, _ColorPicker_pointerDown, _ColorPicker_isDropdownVisible_get;
    _r = ColorPicker, _ColorPicker_button = new WeakMap(), _ColorPicker_buttonSwatch = new WeakMap(), _ColorPicker_defaultColor = new WeakMap(), _ColorPicker_dropdown = new WeakMap(), _ColorPicker_dropdownWasFromKeyboard = new WeakMap(), _ColorPicker_isMainColorPicker = new WeakMap(), _ColorPicker_editor = new WeakMap(), _ColorPicker_eventBus = new WeakMap(), _ColorPicker_openDropdownAC = new WeakMap(), _ColorPicker_uiManager = new WeakMap(), _ColorPicker_type = new WeakMap(), _ColorPicker_instances = new WeakSet(), _ColorPicker_getDropdownRoot = function _ColorPicker_getDropdownRoot() {
        var e_179, _s;
        var div = document.createElement("div");
        var signal = __classPrivateFieldGet(this, _ColorPicker_uiManager, "f")._signal;
        div.addEventListener("contextmenu", noContextMenu, {
            signal: signal
        });
        div.className = "dropdown";
        div.role = "listbox";
        div.setAttribute("aria-multiselectable", false);
        div.setAttribute("aria-orientation", "vertical");
        div.setAttribute("data-l10n-id", "pdfjs-editor-colorpicker-dropdown");
        try {
            for (var _t = __values(__classPrivateFieldGet(this, _ColorPicker_uiManager, "f").highlightColors), _u = _t.next(); !_u.done; _u = _t.next()) {
                var _v = __read(_u.value, 2), name = _v[0], color = _v[1];
                var button = document.createElement("button");
                button.tabIndex = "0";
                button.role = "option";
                button.setAttribute("data-color", color);
                button.title = name;
                button.setAttribute("data-l10n-id", __classPrivateFieldGet(_r, _r, "f", _ColorPicker_l10nColor)[name]);
                var swatch = document.createElement("span");
                button.append(swatch);
                swatch.className = "swatch";
                swatch.style.backgroundColor = color;
                button.setAttribute("aria-selected", color === __classPrivateFieldGet(this, _ColorPicker_defaultColor, "f"));
                button.addEventListener("click", __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_colorSelect).bind(this, color), {
                    signal: signal
                });
                div.append(button);
            }
        }
        catch (e_179_1) { e_179 = { error: e_179_1 }; }
        finally {
            try {
                if (_u && !_u.done && (_s = _t.return)) _s.call(_t);
            }
            finally { if (e_179) throw e_179.error; }
        }
        div.addEventListener("keydown", __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_keyDown).bind(this), {
            signal: signal
        });
        return div;
    }, _ColorPicker_colorSelect = function _ColorPicker_colorSelect(color, event) {
        event.stopPropagation();
        __classPrivateFieldGet(this, _ColorPicker_eventBus, "f").dispatch("switchannotationeditorparams", {
            source: this,
            type: __classPrivateFieldGet(this, _ColorPicker_type, "f"),
            value: color
        });
    }, _ColorPicker_keyDown = function _ColorPicker_keyDown(event) {
        _r._keyboardManager.exec(this, event);
    }, _ColorPicker_openDropdown = function _ColorPicker_openDropdown(event) {
        if (__classPrivateFieldGet(this, _ColorPicker_instances, "a", _ColorPicker_isDropdownVisible_get)) {
            this.hideDropdown();
            return;
        }
        __classPrivateFieldSet(this, _ColorPicker_dropdownWasFromKeyboard, event.detail === 0, "f");
        if (!__classPrivateFieldGet(this, _ColorPicker_openDropdownAC, "f")) {
            __classPrivateFieldSet(this, _ColorPicker_openDropdownAC, new AbortController(), "f");
            window.addEventListener("pointerdown", __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_pointerDown).bind(this), {
                signal: __classPrivateFieldGet(this, _ColorPicker_uiManager, "f").combinedSignal(__classPrivateFieldGet(this, _ColorPicker_openDropdownAC, "f"))
            });
        }
        if (__classPrivateFieldGet(this, _ColorPicker_dropdown, "f")) {
            __classPrivateFieldGet(this, _ColorPicker_dropdown, "f").classList.remove("hidden");
            return;
        }
        var root = __classPrivateFieldSet(this, _ColorPicker_dropdown, __classPrivateFieldGet(this, _ColorPicker_instances, "m", _ColorPicker_getDropdownRoot).call(this), "f");
        __classPrivateFieldGet(this, _ColorPicker_button, "f").append(root);
    }, _ColorPicker_pointerDown = function _ColorPicker_pointerDown(event) {
        var _s;
        if ((_s = __classPrivateFieldGet(this, _ColorPicker_dropdown, "f")) === null || _s === void 0 ? void 0 : _s.contains(event.target)) {
            return;
        }
        this.hideDropdown();
    }, _ColorPicker_isDropdownVisible_get = function _ColorPicker_isDropdownVisible_get() {
        return __classPrivateFieldGet(this, _ColorPicker_dropdown, "f") && !__classPrivateFieldGet(this, _ColorPicker_dropdown, "f").classList.contains("hidden");
    };
    _ColorPicker_l10nColor = { value: null };
    return ColorPicker;
}());
; // ./src/display/editor/highlight.js
var HighlightEditor = /** @class */ (function (_super) {
    __extends(HighlightEditor, _super);
    function HighlightEditor(params) {
        var _this = _super.call(this, __assign(__assign({}, params), { name: "highlightEditor" })) || this;
        _HighlightEditor_instances.add(_this);
        _HighlightEditor_anchorNode.set(_this, null);
        _HighlightEditor_anchorOffset.set(_this, 0);
        _HighlightEditor_boxes.set(_this, void 0);
        _HighlightEditor_clipPathId.set(_this, null);
        _HighlightEditor_colorPicker.set(_this, null);
        _HighlightEditor_focusOutlines.set(_this, null);
        _HighlightEditor_focusNode.set(_this, null);
        _HighlightEditor_focusOffset.set(_this, 0);
        _HighlightEditor_highlightDiv.set(_this, null);
        _HighlightEditor_highlightOutlines.set(_this, null);
        _HighlightEditor_id.set(_this, null);
        _HighlightEditor_isFreeHighlight.set(_this, false);
        _HighlightEditor_lastPoint.set(_this, null);
        _HighlightEditor_opacity.set(_this, void 0);
        _HighlightEditor_outlineId.set(_this, null);
        _HighlightEditor_text.set(_this, "");
        _HighlightEditor_thickness.set(_this, void 0);
        _HighlightEditor_methodOfCreation.set(_this, "");
        _this.color = params.color || _s._defaultColor;
        __classPrivateFieldSet(_this, _HighlightEditor_thickness, params.thickness || _s._defaultThickness, "f");
        __classPrivateFieldSet(_this, _HighlightEditor_opacity, params.opacity || _s._defaultOpacity, "f");
        __classPrivateFieldSet(_this, _HighlightEditor_boxes, params.boxes || null, "f");
        __classPrivateFieldSet(_this, _HighlightEditor_methodOfCreation, params.methodOfCreation || "", "f");
        __classPrivateFieldSet(_this, _HighlightEditor_text, params.text || "", "f");
        _this._isDraggable = false;
        _this.defaultL10nId = "pdfjs-editor-highlight-editor";
        if (params.highlightId > -1) {
            __classPrivateFieldSet(_this, _HighlightEditor_isFreeHighlight, true, "f");
            __classPrivateFieldGet(_this, _HighlightEditor_instances, "m", _HighlightEditor_createFreeOutlines).call(_this, params);
            __classPrivateFieldGet(_this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(_this);
        }
        else if (__classPrivateFieldGet(_this, _HighlightEditor_boxes, "f")) {
            __classPrivateFieldSet(_this, _HighlightEditor_anchorNode, params.anchorNode, "f");
            __classPrivateFieldSet(_this, _HighlightEditor_anchorOffset, params.anchorOffset, "f");
            __classPrivateFieldSet(_this, _HighlightEditor_focusNode, params.focusNode, "f");
            __classPrivateFieldSet(_this, _HighlightEditor_focusOffset, params.focusOffset, "f");
            __classPrivateFieldGet(_this, _HighlightEditor_instances, "m", _HighlightEditor_createOutlines).call(_this);
            __classPrivateFieldGet(_this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(_this);
            _this.rotate(_this.rotation);
        }
        return _this;
    }
    Object.defineProperty(HighlightEditor, "_keyboardManager", {
        get: function () {
            var proto = _s.prototype;
            return shadow(this, "_keyboardManager", new KeyboardManager([[["ArrowLeft", "mac+ArrowLeft"], proto._moveCaret, {
                        args: [0]
                    }], [["ArrowRight", "mac+ArrowRight"], proto._moveCaret, {
                        args: [1]
                    }], [["ArrowUp", "mac+ArrowUp"], proto._moveCaret, {
                        args: [2]
                    }], [["ArrowDown", "mac+ArrowDown"], proto._moveCaret, {
                        args: [3]
                    }]]));
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HighlightEditor.prototype, "telemetryInitialData", {
        get: function () {
            return {
                action: "added",
                type: __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f") ? "free_highlight" : "highlight",
                color: this._uiManager.highlightColorNames.get(this.color),
                thickness: __classPrivateFieldGet(this, _HighlightEditor_thickness, "f"),
                methodOfCreation: __classPrivateFieldGet(this, _HighlightEditor_methodOfCreation, "f")
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HighlightEditor.prototype, "telemetryFinalData", {
        get: function () {
            return {
                type: "highlight",
                color: this._uiManager.highlightColorNames.get(this.color)
            };
        },
        enumerable: false,
        configurable: true
    });
    HighlightEditor.computeTelemetryFinalData = function (data) {
        return {
            numberOfColors: data.get("color").size
        };
    };
    HighlightEditor.initialize = function (l10n, uiManager) {
        var _t;
        AnnotationEditor.initialize(l10n, uiManager);
        _s._defaultColor || (_s._defaultColor = ((_t = uiManager.highlightColors) === null || _t === void 0 ? void 0 : _t.values().next().value) || "#fff066");
    };
    HighlightEditor.updateDefaultParams = function (type, value) {
        switch (type) {
            case AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR:
                _s._defaultColor = value;
                break;
            case AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
                _s._defaultThickness = value;
                break;
        }
    };
    HighlightEditor.prototype.translateInPage = function (x, y) { };
    Object.defineProperty(HighlightEditor.prototype, "toolbarPosition", {
        get: function () {
            return __classPrivateFieldGet(this, _HighlightEditor_lastPoint, "f");
        },
        enumerable: false,
        configurable: true
    });
    HighlightEditor.prototype.updateParams = function (type, value) {
        switch (type) {
            case AnnotationEditorParamsType.HIGHLIGHT_COLOR:
                __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_updateColor).call(this, value);
                break;
            case AnnotationEditorParamsType.HIGHLIGHT_THICKNESS:
                __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_updateThickness).call(this, value);
                break;
        }
    };
    Object.defineProperty(HighlightEditor, "defaultPropertiesToUpdate", {
        get: function () {
            return [[AnnotationEditorParamsType.HIGHLIGHT_DEFAULT_COLOR, _s._defaultColor], [AnnotationEditorParamsType.HIGHLIGHT_THICKNESS, _s._defaultThickness]];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(HighlightEditor.prototype, "propertiesToUpdate", {
        get: function () {
            return [[AnnotationEditorParamsType.HIGHLIGHT_COLOR, this.color || _s._defaultColor], [AnnotationEditorParamsType.HIGHLIGHT_THICKNESS, __classPrivateFieldGet(this, _HighlightEditor_thickness, "f") || _s._defaultThickness], [AnnotationEditorParamsType.HIGHLIGHT_FREE, __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")]];
        },
        enumerable: false,
        configurable: true
    });
    HighlightEditor.prototype.addEditToolbar = function () {
        return __awaiter(this, void 0, void 0, function () {
            var toolbar;
            return __generator(this, function (_t) {
                switch (_t.label) {
                    case 0: return [4 /*yield*/, _super.prototype.addEditToolbar.call(this)];
                    case 1:
                        toolbar = _t.sent();
                        if (!toolbar) {
                            return [2 /*return*/, null];
                        }
                        if (this._uiManager.highlightColors) {
                            __classPrivateFieldSet(this, _HighlightEditor_colorPicker, new ColorPicker({
                                editor: this
                            }), "f");
                            toolbar.addColorPicker(__classPrivateFieldGet(this, _HighlightEditor_colorPicker, "f"));
                        }
                        return [2 /*return*/, toolbar];
                }
            });
        });
    };
    HighlightEditor.prototype.disableEditing = function () {
        _super.prototype.disableEditing.call(this);
        this.div.classList.toggle("disabled", true);
    };
    HighlightEditor.prototype.enableEditing = function () {
        _super.prototype.enableEditing.call(this);
        this.div.classList.toggle("disabled", false);
    };
    HighlightEditor.prototype.fixAndSetPosition = function () {
        return _super.prototype.fixAndSetPosition.call(this, __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this));
    };
    HighlightEditor.prototype.getBaseTranslation = function () {
        return [0, 0];
    };
    HighlightEditor.prototype.getRect = function (tx, ty) {
        return _super.prototype.getRect.call(this, tx, ty, __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this));
    };
    HighlightEditor.prototype.onceAdded = function (focus) {
        if (!this.annotationElementId) {
            this.parent.addUndoableEditor(this);
        }
        if (focus) {
            this.div.focus();
        }
    };
    HighlightEditor.prototype.remove = function () {
        __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_cleanDrawLayer).call(this);
        this._reportTelemetry({
            action: "deleted"
        });
        _super.prototype.remove.call(this);
    };
    HighlightEditor.prototype.rebuild = function () {
        if (!this.parent) {
            return;
        }
        _super.prototype.rebuild.call(this);
        if (this.div === null) {
            return;
        }
        __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(this);
        if (!this.isAttachedToDOM) {
            this.parent.add(this);
        }
    };
    HighlightEditor.prototype.setParent = function (parent) {
        var _t;
        var mustBeSelected = false;
        if (this.parent && !parent) {
            __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_cleanDrawLayer).call(this);
        }
        else if (parent) {
            __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(this, parent);
            mustBeSelected = !this.parent && ((_t = this.div) === null || _t === void 0 ? void 0 : _t.classList.contains("selectedEditor"));
        }
        _super.prototype.setParent.call(this, parent);
        this.show(this._isVisible);
        if (mustBeSelected) {
            this.select();
        }
    };
    HighlightEditor.prototype.rotate = function (angle) {
        var drawLayer = this.parent.drawLayer;
        var box;
        if (__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
            angle = (angle - this.rotation + 360) % 360;
            box = __classPrivateFieldGet(_s, _s, "m", _HighlightEditor_rotateBbox).call(_s, __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").box, angle);
        }
        else {
            box = __classPrivateFieldGet(_s, _s, "m", _HighlightEditor_rotateBbox).call(_s, [this.x, this.y, this.width, this.height], angle);
        }
        drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), {
            bbox: box,
            root: {
                "data-main-rotation": angle
            }
        });
        drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), {
            bbox: __classPrivateFieldGet(_s, _s, "m", _HighlightEditor_rotateBbox).call(_s, __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box, angle),
            root: {
                "data-main-rotation": angle
            }
        });
    };
    HighlightEditor.prototype.render = function () {
        if (this.div) {
            return this.div;
        }
        var div = _super.prototype.render.call(this);
        if (__classPrivateFieldGet(this, _HighlightEditor_text, "f")) {
            div.setAttribute("aria-label", __classPrivateFieldGet(this, _HighlightEditor_text, "f"));
            div.setAttribute("role", "mark");
        }
        if (__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
            div.classList.add("free");
        }
        else {
            this.div.addEventListener("keydown", __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_keydown).bind(this), {
                signal: this._uiManager._signal
            });
        }
        var highlightDiv = __classPrivateFieldSet(this, _HighlightEditor_highlightDiv, document.createElement("div"), "f");
        div.append(highlightDiv);
        highlightDiv.setAttribute("aria-hidden", "true");
        highlightDiv.className = "internal";
        highlightDiv.style.clipPath = __classPrivateFieldGet(this, _HighlightEditor_clipPathId, "f");
        var _t = __read(this.parentDimensions, 2), parentWidth = _t[0], parentHeight = _t[1];
        this.setDims(this.width * parentWidth, this.height * parentHeight);
        bindEvents(this, __classPrivateFieldGet(this, _HighlightEditor_highlightDiv, "f"), ["pointerover", "pointerleave"]);
        this.enableEditing();
        return div;
    };
    HighlightEditor.prototype.pointerover = function () {
        var _t;
        if (!this.isSelected) {
            (_t = this.parent) === null || _t === void 0 ? void 0 : _t.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), {
                rootClass: {
                    hovered: true
                }
            });
        }
    };
    HighlightEditor.prototype.pointerleave = function () {
        var _t;
        if (!this.isSelected) {
            (_t = this.parent) === null || _t === void 0 ? void 0 : _t.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), {
                rootClass: {
                    hovered: false
                }
            });
        }
    };
    HighlightEditor.prototype._moveCaret = function (direction) {
        this.parent.unselect(this);
        switch (direction) {
            case 0:
            case 2:
                __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_setCaret).call(this, true);
                break;
            case 1:
            case 3:
                __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_setCaret).call(this, false);
                break;
        }
    };
    HighlightEditor.prototype.select = function () {
        var _t;
        _super.prototype.select.call(this);
        if (!__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f")) {
            return;
        }
        (_t = this.parent) === null || _t === void 0 ? void 0 : _t.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), {
            rootClass: {
                hovered: false,
                selected: true
            }
        });
    };
    HighlightEditor.prototype.unselect = function () {
        var _t;
        _super.prototype.unselect.call(this);
        if (!__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f")) {
            return;
        }
        (_t = this.parent) === null || _t === void 0 ? void 0 : _t.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), {
            rootClass: {
                selected: false
            }
        });
        if (!__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
            __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_setCaret).call(this, false);
        }
    };
    Object.defineProperty(HighlightEditor.prototype, "_mustFixPosition", {
        get: function () {
            return !__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f");
        },
        enumerable: false,
        configurable: true
    });
    HighlightEditor.prototype.show = function (visible) {
        if (visible === void 0) { visible = this._isVisible; }
        _super.prototype.show.call(this, visible);
        if (this.parent) {
            this.parent.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), {
                rootClass: {
                    hidden: !visible
                }
            });
            this.parent.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), {
                rootClass: {
                    hidden: !visible
                }
            });
        }
    };
    HighlightEditor.startHighlighting = function (parent, isLTR, _t) {
        var _u;
        var _this = this;
        var textLayer = _t.target, x = _t.x, y = _t.y;
        var _v = textLayer.getBoundingClientRect(), layerX = _v.x, layerY = _v.y, parentWidth = _v.width, parentHeight = _v.height;
        var ac = new AbortController();
        var signal = parent.combinedSignal(ac);
        var pointerUpCallback = function (e) {
            ac.abort();
            __classPrivateFieldGet(_this, _s, "m", _HighlightEditor_endHighlight).call(_this, parent, e);
        };
        window.addEventListener("blur", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerup", pointerUpCallback, {
            signal: signal
        });
        window.addEventListener("pointerdown", stopEvent, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", noContextMenu, {
            signal: signal
        });
        textLayer.addEventListener("pointermove", __classPrivateFieldGet(this, _s, "m", _HighlightEditor_highlightMove).bind(this, parent), {
            signal: signal
        });
        this._freeHighlight = new FreeHighlightOutliner({
            x: x,
            y: y
        }, [layerX, layerY, parentWidth, parentHeight], parent.scale, this._defaultThickness / 2, isLTR, 0.001);
        (_u = parent.drawLayer.draw({
            bbox: [0, 0, 1, 1],
            root: {
                viewBox: "0 0 1 1",
                fill: this._defaultColor,
                "fill-opacity": this._defaultOpacity
            },
            rootClass: {
                highlight: true,
                free: true
            },
            path: {
                d: this._freeHighlight.toSVGPath()
            }
        }, true, true), this._freeHighlightId = _u.id, this._freeHighlightClipId = _u.clipPathId);
    };
    HighlightEditor.deserialize = function (data, parent, uiManager) {
        return __awaiter(this, void 0, void 0, function () {
            var initialData, _t, quadPoints_1, rect, rotation, id, color_1, opacity_1, popupRef, pageNumber, _u, inkLists_1, rect, rotation, id, color_2, thickness, popupRef, pageNumber, color, quadPoints, inkLists, opacity, editor, _v, pageWidth, pageHeight, _w, pageX, pageY, boxes, i, points, point, outliner, i, ii, _z, id, clipPathId;
            return __generator(this, function (_0) {
                switch (_0.label) {
                    case 0:
                        initialData = null;
                        if (data instanceof HighlightAnnotationElement) {
                            _t = data.data, quadPoints_1 = _t.quadPoints, rect = _t.rect, rotation = _t.rotation, id = _t.id, color_1 = _t.color, opacity_1 = _t.opacity, popupRef = _t.popupRef, pageNumber = data.parent.page.pageNumber;
                            initialData = data = {
                                annotationType: AnnotationEditorType.HIGHLIGHT,
                                color: Array.from(color_1),
                                opacity: opacity_1,
                                quadPoints: quadPoints_1,
                                boxes: null,
                                pageIndex: pageNumber - 1,
                                rect: rect.slice(0),
                                rotation: rotation,
                                id: id,
                                deleted: false,
                                popupRef: popupRef
                            };
                        }
                        else if (data instanceof InkAnnotationElement) {
                            _u = data.data, inkLists_1 = _u.inkLists, rect = _u.rect, rotation = _u.rotation, id = _u.id, color_2 = _u.color, thickness = _u.borderStyle.rawWidth, popupRef = _u.popupRef, pageNumber = data.parent.page.pageNumber;
                            initialData = data = {
                                annotationType: AnnotationEditorType.HIGHLIGHT,
                                color: Array.from(color_2),
                                thickness: thickness,
                                inkLists: inkLists_1,
                                boxes: null,
                                pageIndex: pageNumber - 1,
                                rect: rect.slice(0),
                                rotation: rotation,
                                id: id,
                                deleted: false,
                                popupRef: popupRef
                            };
                        }
                        color = data.color, quadPoints = data.quadPoints, inkLists = data.inkLists, opacity = data.opacity;
                        return [4 /*yield*/, _super.deserialize.call(this, data, parent, uiManager)];
                    case 1:
                        editor = _0.sent();
                        editor.color = Util.makeHexColor.apply(Util, __spreadArray([], __read(color), false));
                        __classPrivateFieldSet(editor, _HighlightEditor_opacity, opacity || 1, "f");
                        if (inkLists) {
                            __classPrivateFieldSet(editor, _HighlightEditor_thickness, data.thickness, "f");
                        }
                        editor.annotationElementId = data.id || null;
                        editor._initialData = initialData;
                        _v = __read(editor.pageDimensions, 2), pageWidth = _v[0], pageHeight = _v[1];
                        _w = __read(editor.pageTranslation, 2), pageX = _w[0], pageY = _w[1];
                        if (quadPoints) {
                            boxes = __classPrivateFieldSet(editor, _HighlightEditor_boxes, [], "f");
                            for (i = 0; i < quadPoints.length; i += 8) {
                                boxes.push({
                                    x: (quadPoints[i] - pageX) / pageWidth,
                                    y: 1 - (quadPoints[i + 1] - pageY) / pageHeight,
                                    width: (quadPoints[i + 2] - quadPoints[i]) / pageWidth,
                                    height: (quadPoints[i + 1] - quadPoints[i + 5]) / pageHeight
                                });
                            }
                            __classPrivateFieldGet(editor, _HighlightEditor_instances, "m", _HighlightEditor_createOutlines).call(editor);
                            __classPrivateFieldGet(editor, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(editor);
                            editor.rotate(editor.rotation);
                        }
                        else if (inkLists) {
                            __classPrivateFieldSet(editor, _HighlightEditor_isFreeHighlight, true, "f");
                            points = inkLists[0];
                            point = {
                                x: points[0] - pageX,
                                y: pageHeight - (points[1] - pageY)
                            };
                            outliner = new FreeHighlightOutliner(point, [0, 0, pageWidth, pageHeight], 1, __classPrivateFieldGet(editor, _HighlightEditor_thickness, "f") / 2, true, 0.001);
                            for (i = 0, ii = points.length; i < ii; i += 2) {
                                point.x = points[i] - pageX;
                                point.y = pageHeight - (points[i + 1] - pageY);
                                outliner.add(point);
                            }
                            _z = parent.drawLayer.draw({
                                bbox: [0, 0, 1, 1],
                                root: {
                                    viewBox: "0 0 1 1",
                                    fill: editor.color,
                                    "fill-opacity": editor._defaultOpacity
                                },
                                rootClass: {
                                    highlight: true,
                                    free: true
                                },
                                path: {
                                    d: outliner.toSVGPath()
                                }
                            }, true, true), id = _z.id, clipPathId = _z.clipPathId;
                            __classPrivateFieldGet(editor, _HighlightEditor_instances, "m", _HighlightEditor_createFreeOutlines).call(editor, {
                                highlightOutlines: outliner.getOutlines(),
                                highlightId: id,
                                clipPathId: clipPathId
                            });
                            __classPrivateFieldGet(editor, _HighlightEditor_instances, "m", _HighlightEditor_addToDrawLayer).call(editor);
                            editor.rotate(editor.parentRotation);
                        }
                        return [2 /*return*/, editor];
                }
            });
        });
    };
    HighlightEditor.prototype.serialize = function (isForCopying) {
        if (isForCopying === void 0) { isForCopying = false; }
        if (this.isEmpty() || isForCopying) {
            return null;
        }
        if (this.deleted) {
            return this.serializeDeleted();
        }
        var rect = this.getRect(0, 0);
        var color = AnnotationEditor._colorManager.convert(this.color);
        var serialized = {
            annotationType: AnnotationEditorType.HIGHLIGHT,
            color: color,
            opacity: __classPrivateFieldGet(this, _HighlightEditor_opacity, "f"),
            thickness: __classPrivateFieldGet(this, _HighlightEditor_thickness, "f"),
            quadPoints: __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_serializeBoxes).call(this),
            outlines: __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_serializeOutlines).call(this, rect),
            pageIndex: this.pageIndex,
            rect: rect,
            rotation: __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this),
            structTreeParentId: this._structTreeParentId
        };
        if (this.annotationElementId && !__classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_hasElementChanged).call(this, serialized)) {
            return null;
        }
        serialized.id = this.annotationElementId;
        return serialized;
    };
    HighlightEditor.prototype.renderAnnotationElement = function (annotation) {
        annotation.updateEdited({
            rect: this.getRect(0, 0)
        });
        return null;
    };
    HighlightEditor.canCreateNewEmptyEditor = function () {
        return false;
    };
    var _HighlightEditor_instances, _s, _HighlightEditor_anchorNode, _HighlightEditor_anchorOffset, _HighlightEditor_boxes, _HighlightEditor_clipPathId, _HighlightEditor_colorPicker, _HighlightEditor_focusOutlines, _HighlightEditor_focusNode, _HighlightEditor_focusOffset, _HighlightEditor_highlightDiv, _HighlightEditor_highlightOutlines, _HighlightEditor_id, _HighlightEditor_isFreeHighlight, _HighlightEditor_lastPoint, _HighlightEditor_opacity, _HighlightEditor_outlineId, _HighlightEditor_text, _HighlightEditor_thickness, _HighlightEditor_methodOfCreation, _HighlightEditor_createOutlines, _HighlightEditor_createFreeOutlines, _HighlightEditor_updateColor, _HighlightEditor_updateThickness, _HighlightEditor_changeThickness, _HighlightEditor_cleanDrawLayer, _HighlightEditor_addToDrawLayer, _HighlightEditor_rotateBbox, _HighlightEditor_keydown, _HighlightEditor_setCaret, _HighlightEditor_getRotation, _HighlightEditor_serializeBoxes, _HighlightEditor_serializeOutlines, _HighlightEditor_highlightMove, _HighlightEditor_endHighlight, _HighlightEditor_hasElementChanged;
    _s = HighlightEditor, _HighlightEditor_anchorNode = new WeakMap(), _HighlightEditor_anchorOffset = new WeakMap(), _HighlightEditor_boxes = new WeakMap(), _HighlightEditor_clipPathId = new WeakMap(), _HighlightEditor_colorPicker = new WeakMap(), _HighlightEditor_focusOutlines = new WeakMap(), _HighlightEditor_focusNode = new WeakMap(), _HighlightEditor_focusOffset = new WeakMap(), _HighlightEditor_highlightDiv = new WeakMap(), _HighlightEditor_highlightOutlines = new WeakMap(), _HighlightEditor_id = new WeakMap(), _HighlightEditor_isFreeHighlight = new WeakMap(), _HighlightEditor_lastPoint = new WeakMap(), _HighlightEditor_opacity = new WeakMap(), _HighlightEditor_outlineId = new WeakMap(), _HighlightEditor_text = new WeakMap(), _HighlightEditor_thickness = new WeakMap(), _HighlightEditor_methodOfCreation = new WeakMap(), _HighlightEditor_instances = new WeakSet(), _HighlightEditor_createOutlines = function _HighlightEditor_createOutlines() {
        var _t;
        var outliner = new HighlightOutliner(__classPrivateFieldGet(this, _HighlightEditor_boxes, "f"), 0.001);
        __classPrivateFieldSet(this, _HighlightEditor_highlightOutlines, outliner.getOutlines(), "f");
        _t = __read(__classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").box, 4), this.x = _t[0], this.y = _t[1], this.width = _t[2], this.height = _t[3];
        var outlinerForOutline = new HighlightOutliner(__classPrivateFieldGet(this, _HighlightEditor_boxes, "f"), 0.0025, 0.001, this._uiManager.direction === "ltr");
        __classPrivateFieldSet(this, _HighlightEditor_focusOutlines, outlinerForOutline.getOutlines(), "f");
        var lastPoint = __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").lastPoint;
        __classPrivateFieldSet(this, _HighlightEditor_lastPoint, [(lastPoint[0] - this.x) / this.width, (lastPoint[1] - this.y) / this.height], "f");
    }, _HighlightEditor_createFreeOutlines = function _HighlightEditor_createFreeOutlines(_t) {
        var highlightOutlines = _t.highlightOutlines, highlightId = _t.highlightId, clipPathId = _t.clipPathId;
        __classPrivateFieldSet(this, _HighlightEditor_highlightOutlines, highlightOutlines, "f");
        var extraThickness = 1.5;
        __classPrivateFieldSet(this, _HighlightEditor_focusOutlines, highlightOutlines.getNewOutline(__classPrivateFieldGet(this, _HighlightEditor_thickness, "f") / 2 + extraThickness, 0.0025), "f");
        if (highlightId >= 0) {
            __classPrivateFieldSet(this, _HighlightEditor_id, highlightId, "f");
            __classPrivateFieldSet(this, _HighlightEditor_clipPathId, clipPathId, "f");
            this.parent.drawLayer.finalizeDraw(highlightId, {
                bbox: highlightOutlines.box,
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            __classPrivateFieldSet(this, _HighlightEditor_outlineId, this.parent.drawLayer.drawOutline({
                rootClass: {
                    highlightOutline: true,
                    free: true
                },
                bbox: __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box,
                path: {
                    d: __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").toSVGPath()
                }
            }, true), "f");
        }
        else if (this.parent) {
            var angle = this.parent.viewport.rotation;
            this.parent.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_id, "f"), {
                bbox: __classPrivateFieldGet(_s, _s, "m", _HighlightEditor_rotateBbox).call(_s, __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").box, (angle - this.rotation + 360) % 360),
                path: {
                    d: highlightOutlines.toSVGPath()
                }
            });
            this.parent.drawLayer.updateProperties(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"), {
                bbox: __classPrivateFieldGet(_s, _s, "m", _HighlightEditor_rotateBbox).call(_s, __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box, angle),
                path: {
                    d: __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").toSVGPath()
                }
            });
        }
        var _u = __read(highlightOutlines.box, 4), x = _u[0], y = _u[1], width = _u[2], height = _u[3];
        switch (this.rotation) {
            case 0:
                this.x = x;
                this.y = y;
                this.width = width;
                this.height = height;
                break;
            case 90:
                {
                    var _v = __read(this.parentDimensions, 2), pageWidth = _v[0], pageHeight = _v[1];
                    this.x = y;
                    this.y = 1 - x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
            case 180:
                this.x = 1 - x;
                this.y = 1 - y;
                this.width = width;
                this.height = height;
                break;
            case 270:
                {
                    var _w = __read(this.parentDimensions, 2), pageWidth = _w[0], pageHeight = _w[1];
                    this.x = 1 - y;
                    this.y = x;
                    this.width = width * pageHeight / pageWidth;
                    this.height = height * pageWidth / pageHeight;
                    break;
                }
        }
        var lastPoint = __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").lastPoint;
        __classPrivateFieldSet(this, _HighlightEditor_lastPoint, [(lastPoint[0] - x) / width, (lastPoint[1] - y) / height], "f");
    }, _HighlightEditor_updateColor = function _HighlightEditor_updateColor(color) {
        var _this = this;
        var setColorAndOpacity = function (col, opa) {
            var _t, _u;
            _this.color = col;
            __classPrivateFieldSet(_this, _HighlightEditor_opacity, opa, "f");
            (_t = _this.parent) === null || _t === void 0 ? void 0 : _t.drawLayer.updateProperties(__classPrivateFieldGet(_this, _HighlightEditor_id, "f"), {
                root: {
                    fill: col,
                    "fill-opacity": opa
                }
            });
            (_u = __classPrivateFieldGet(_this, _HighlightEditor_colorPicker, "f")) === null || _u === void 0 ? void 0 : _u.updateColor(col);
        };
        var savedColor = this.color;
        var savedOpacity = __classPrivateFieldGet(this, _HighlightEditor_opacity, "f");
        this.addCommands({
            cmd: setColorAndOpacity.bind(this, color, _s._defaultOpacity),
            undo: setColorAndOpacity.bind(this, savedColor, savedOpacity),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: AnnotationEditorParamsType.HIGHLIGHT_COLOR,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "color_changed",
            color: this._uiManager.highlightColorNames.get(color)
        }, true);
    }, _HighlightEditor_updateThickness = function _HighlightEditor_updateThickness(thickness) {
        var _this = this;
        var savedThickness = __classPrivateFieldGet(this, _HighlightEditor_thickness, "f");
        var setThickness = function (th) {
            __classPrivateFieldSet(_this, _HighlightEditor_thickness, th, "f");
            __classPrivateFieldGet(_this, _HighlightEditor_instances, "m", _HighlightEditor_changeThickness).call(_this, th);
        };
        this.addCommands({
            cmd: setThickness.bind(this, thickness),
            undo: setThickness.bind(this, savedThickness),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: AnnotationEditorParamsType.INK_THICKNESS,
            overwriteIfSameType: true,
            keepUndo: true
        });
        this._reportTelemetry({
            action: "thickness_changed",
            thickness: thickness
        }, true);
    }, _HighlightEditor_changeThickness = function _HighlightEditor_changeThickness(thickness) {
        if (!__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_createFreeOutlines).call(this, {
            highlightOutlines: __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").getNewOutline(thickness / 2)
        });
        this.fixAndSetPosition();
        var _t = __read(this.parentDimensions, 2), parentWidth = _t[0], parentHeight = _t[1];
        this.setDims(this.width * parentWidth, this.height * parentHeight);
    }, _HighlightEditor_cleanDrawLayer = function _HighlightEditor_cleanDrawLayer() {
        if (__classPrivateFieldGet(this, _HighlightEditor_id, "f") === null || !this.parent) {
            return;
        }
        this.parent.drawLayer.remove(__classPrivateFieldGet(this, _HighlightEditor_id, "f"));
        __classPrivateFieldSet(this, _HighlightEditor_id, null, "f");
        this.parent.drawLayer.remove(__classPrivateFieldGet(this, _HighlightEditor_outlineId, "f"));
        __classPrivateFieldSet(this, _HighlightEditor_outlineId, null, "f");
    }, _HighlightEditor_addToDrawLayer = function _HighlightEditor_addToDrawLayer(parent) {
        var _t;
        var _u, _v;
        if (parent === void 0) { parent = this.parent; }
        if (__classPrivateFieldGet(this, _HighlightEditor_id, "f") !== null) {
            return;
        }
        (_u = this, _v = this, _t = parent.drawLayer.draw({
            bbox: __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").box,
            root: {
                viewBox: "0 0 1 1",
                fill: this.color,
                "fill-opacity": __classPrivateFieldGet(this, _HighlightEditor_opacity, "f")
            },
            rootClass: {
                highlight: true,
                free: __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")
            },
            path: {
                d: __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").toSVGPath()
            }
        }, false, true), ({ set value(_t) { __classPrivateFieldSet(_u, _HighlightEditor_id, _t, "f"); } }).value = _t.id, ({ set value(_t) { __classPrivateFieldSet(_v, _HighlightEditor_clipPathId, _t, "f"); } }).value = _t.clipPathId);
        __classPrivateFieldSet(this, _HighlightEditor_outlineId, parent.drawLayer.drawOutline({
            rootClass: {
                highlightOutline: true,
                free: __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")
            },
            bbox: __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").box,
            path: {
                d: __classPrivateFieldGet(this, _HighlightEditor_focusOutlines, "f").toSVGPath()
            }
        }, __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")), "f");
        if (__classPrivateFieldGet(this, _HighlightEditor_highlightDiv, "f")) {
            __classPrivateFieldGet(this, _HighlightEditor_highlightDiv, "f").style.clipPath = __classPrivateFieldGet(this, _HighlightEditor_clipPathId, "f");
        }
    }, _HighlightEditor_rotateBbox = function _HighlightEditor_rotateBbox(_t, angle) {
        var _u = __read(_t, 4), x = _u[0], y = _u[1], width = _u[2], height = _u[3];
        switch (angle) {
            case 90:
                return [1 - y - height, x, height, width];
            case 180:
                return [1 - x - width, 1 - y - height, width, height];
            case 270:
                return [y, 1 - x - width, height, width];
        }
        return [x, y, width, height];
    }, _HighlightEditor_keydown = function _HighlightEditor_keydown(event) {
        _s._keyboardManager.exec(this, event);
    }, _HighlightEditor_setCaret = function _HighlightEditor_setCaret(start) {
        if (!__classPrivateFieldGet(this, _HighlightEditor_anchorNode, "f")) {
            return;
        }
        var selection = window.getSelection();
        if (start) {
            selection.setPosition(__classPrivateFieldGet(this, _HighlightEditor_anchorNode, "f"), __classPrivateFieldGet(this, _HighlightEditor_anchorOffset, "f"));
        }
        else {
            selection.setPosition(__classPrivateFieldGet(this, _HighlightEditor_focusNode, "f"), __classPrivateFieldGet(this, _HighlightEditor_focusOffset, "f"));
        }
    }, _HighlightEditor_getRotation = function _HighlightEditor_getRotation() {
        return __classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f") ? this.rotation : 0;
    }, _HighlightEditor_serializeBoxes = function _HighlightEditor_serializeBoxes() {
        var e_180, _t;
        if (__classPrivateFieldGet(this, _HighlightEditor_isFreeHighlight, "f")) {
            return null;
        }
        var _u = __read(this.pageDimensions, 2), pageWidth = _u[0], pageHeight = _u[1];
        var _v = __read(this.pageTranslation, 2), pageX = _v[0], pageY = _v[1];
        var boxes = __classPrivateFieldGet(this, _HighlightEditor_boxes, "f");
        var quadPoints = new Float32Array(boxes.length * 8);
        var i = 0;
        try {
            for (var boxes_3 = __values(boxes), boxes_3_1 = boxes_3.next(); !boxes_3_1.done; boxes_3_1 = boxes_3.next()) {
                var _w = boxes_3_1.value, x = _w.x, y = _w.y, width = _w.width, height = _w.height;
                var sx = x * pageWidth + pageX;
                var sy = (1 - y) * pageHeight + pageY;
                quadPoints[i] = quadPoints[i + 4] = sx;
                quadPoints[i + 1] = quadPoints[i + 3] = sy;
                quadPoints[i + 2] = quadPoints[i + 6] = sx + width * pageWidth;
                quadPoints[i + 5] = quadPoints[i + 7] = sy - height * pageHeight;
                i += 8;
            }
        }
        catch (e_180_1) { e_180 = { error: e_180_1 }; }
        finally {
            try {
                if (boxes_3_1 && !boxes_3_1.done && (_t = boxes_3.return)) _t.call(boxes_3);
            }
            finally { if (e_180) throw e_180.error; }
        }
        return quadPoints;
    }, _HighlightEditor_serializeOutlines = function _HighlightEditor_serializeOutlines(rect) {
        return __classPrivateFieldGet(this, _HighlightEditor_highlightOutlines, "f").serialize(rect, __classPrivateFieldGet(this, _HighlightEditor_instances, "m", _HighlightEditor_getRotation).call(this));
    }, _HighlightEditor_highlightMove = function _HighlightEditor_highlightMove(parent, event) {
        if (this._freeHighlight.add(event)) {
            parent.drawLayer.updateProperties(this._freeHighlightId, {
                path: {
                    d: this._freeHighlight.toSVGPath()
                }
            });
        }
    }, _HighlightEditor_endHighlight = function _HighlightEditor_endHighlight(parent, event) {
        if (!this._freeHighlight.isEmpty()) {
            parent.createAndAddNewEditor(event, false, {
                highlightId: this._freeHighlightId,
                highlightOutlines: this._freeHighlight.getOutlines(),
                clipPathId: this._freeHighlightClipId,
                methodOfCreation: "main_toolbar"
            });
        }
        else {
            parent.drawLayer.remove(this._freeHighlightId);
        }
        this._freeHighlightId = -1;
        this._freeHighlight = null;
        this._freeHighlightClipId = "";
    }, _HighlightEditor_hasElementChanged = function _HighlightEditor_hasElementChanged(serialized) {
        var color = this._initialData.color;
        return serialized.color.some(function (c, i) { return c !== color[i]; });
    };
    HighlightEditor._defaultColor = null;
    HighlightEditor._defaultOpacity = 1;
    HighlightEditor._defaultThickness = 12;
    HighlightEditor._type = "highlight";
    HighlightEditor._editorType = AnnotationEditorType.HIGHLIGHT;
    HighlightEditor._freeHighlightId = -1;
    HighlightEditor._freeHighlight = null;
    HighlightEditor._freeHighlightClipId = "";
    return HighlightEditor;
}(AnnotationEditor));
; // ./src/display/editor/draw.js
var DrawingOptions = /** @class */ (function () {
    function DrawingOptions() {
        _DrawingOptions_svgProperties.set(this, Object.create(null));
    }
    DrawingOptions.prototype.updateProperty = function (name, value) {
        this[name] = value;
        this.updateSVGProperty(name, value);
    };
    DrawingOptions.prototype.updateProperties = function (properties) {
        var e_181, _t;
        if (!properties) {
            return;
        }
        try {
            for (var _u = __values(Object.entries(properties)), _v = _u.next(); !_v.done; _v = _u.next()) {
                var _w = __read(_v.value, 2), name = _w[0], value = _w[1];
                if (!name.startsWith("_")) {
                    this.updateProperty(name, value);
                }
            }
        }
        catch (e_181_1) { e_181 = { error: e_181_1 }; }
        finally {
            try {
                if (_v && !_v.done && (_t = _u.return)) _t.call(_u);
            }
            finally { if (e_181) throw e_181.error; }
        }
    };
    DrawingOptions.prototype.updateSVGProperty = function (name, value) {
        __classPrivateFieldGet(this, _DrawingOptions_svgProperties, "f")[name] = value;
    };
    DrawingOptions.prototype.toSVGProperties = function () {
        var root = __classPrivateFieldGet(this, _DrawingOptions_svgProperties, "f");
        __classPrivateFieldSet(this, _DrawingOptions_svgProperties, Object.create(null), "f");
        return {
            root: root
        };
    };
    DrawingOptions.prototype.reset = function () {
        __classPrivateFieldSet(this, _DrawingOptions_svgProperties, Object.create(null), "f");
    };
    DrawingOptions.prototype.updateAll = function (options) {
        if (options === void 0) { options = this; }
        this.updateProperties(options);
    };
    DrawingOptions.prototype.clone = function () {
        unreachable("Not implemented");
    };
    return DrawingOptions;
}());
_DrawingOptions_svgProperties = new WeakMap();
var DrawingEditor = /** @class */ (function (_super) {
    __extends(DrawingEditor, _super);
    function DrawingEditor(params) {
        var _this = _super.call(this, params) || this;
        _DrawingEditor_instances.add(_this);
        _DrawingEditor_drawOutlines.set(_this, null);
        _DrawingEditor_mustBeCommitted.set(_this, void 0);
        _this._drawId = null;
        __classPrivateFieldSet(_this, _DrawingEditor_mustBeCommitted, params.mustBeCommitted || false, "f");
        _this._addOutlines(params);
        return _this;
    }
    DrawingEditor.prototype._addOutlines = function (params) {
        if (params.drawOutlines) {
            __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_createDrawOutlines).call(this, params);
            __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_addToDrawLayer).call(this);
        }
    };
    DrawingEditor._mergeSVGProperties = function (p1, p2) {
        var e_182, _u;
        var p1Keys = new Set(Object.keys(p1));
        try {
            for (var _v = __values(Object.entries(p2)), _w = _v.next(); !_w.done; _w = _v.next()) {
                var _z = __read(_w.value, 2), key = _z[0], value = _z[1];
                if (p1Keys.has(key)) {
                    Object.assign(p1[key], value);
                }
                else {
                    p1[key] = value;
                }
            }
        }
        catch (e_182_1) { e_182 = { error: e_182_1 }; }
        finally {
            try {
                if (_w && !_w.done && (_u = _v.return)) _u.call(_v);
            }
            finally { if (e_182) throw e_182.error; }
        }
        return p1;
    };
    DrawingEditor.getDefaultDrawingOptions = function (_options) {
        unreachable("Not implemented");
    };
    Object.defineProperty(DrawingEditor, "typesMap", {
        get: function () {
            unreachable("Not implemented");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DrawingEditor, "isDrawer", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DrawingEditor, "supportMultipleDrawings", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    DrawingEditor.updateDefaultParams = function (type, value) {
        var propertyName = this.typesMap.get(type);
        if (propertyName) {
            this._defaultDrawingOptions.updateProperty(propertyName, value);
        }
        if (this._currentParent) {
            __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).updateProperty(propertyName, value);
            this._currentParent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
        }
    };
    DrawingEditor.prototype.updateParams = function (type, value) {
        var propertyName = this.constructor.typesMap.get(type);
        if (propertyName) {
            this._updateProperty(type, propertyName, value);
        }
    };
    Object.defineProperty(DrawingEditor, "defaultPropertiesToUpdate", {
        get: function () {
            var e_183, _u;
            var properties = [];
            var options = this._defaultDrawingOptions;
            try {
                for (var _v = __values(this.typesMap), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var _z = __read(_w.value, 2), type = _z[0], name = _z[1];
                    properties.push([type, options[name]]);
                }
            }
            catch (e_183_1) { e_183 = { error: e_183_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_u = _v.return)) _u.call(_v);
                }
                finally { if (e_183) throw e_183.error; }
            }
            return properties;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(DrawingEditor.prototype, "propertiesToUpdate", {
        get: function () {
            var e_184, _u;
            var properties = [];
            var _drawingOptions = this._drawingOptions;
            try {
                for (var _v = __values(this.constructor.typesMap), _w = _v.next(); !_w.done; _w = _v.next()) {
                    var _z = __read(_w.value, 2), type = _z[0], name = _z[1];
                    properties.push([type, _drawingOptions[name]]);
                }
            }
            catch (e_184_1) { e_184 = { error: e_184_1 }; }
            finally {
                try {
                    if (_w && !_w.done && (_u = _v.return)) _u.call(_v);
                }
                finally { if (e_184) throw e_184.error; }
            }
            return properties;
        },
        enumerable: false,
        configurable: true
    });
    DrawingEditor.prototype._updateProperty = function (type, name, value) {
        var _this = this;
        var options = this._drawingOptions;
        var savedValue = options[name];
        var setter = function (val) {
            var _u;
            options.updateProperty(name, val);
            var bbox = __classPrivateFieldGet(_this, _DrawingEditor_drawOutlines, "f").updateProperty(name, val);
            if (bbox) {
                __classPrivateFieldGet(_this, _DrawingEditor_instances, "m", _DrawingEditor_updateBbox).call(_this, bbox);
            }
            (_u = _this.parent) === null || _u === void 0 ? void 0 : _u.drawLayer.updateProperties(_this._drawId, options.toSVGProperties());
        };
        this.addCommands({
            cmd: setter.bind(this, value),
            undo: setter.bind(this, savedValue),
            post: this._uiManager.updateUI.bind(this._uiManager, this),
            mustExec: true,
            type: type,
            overwriteIfSameType: true,
            keepUndo: true
        });
    };
    DrawingEditor.prototype._onResizing = function () {
        var _u;
        (_u = this.parent) === null || _u === void 0 ? void 0 : _u.drawLayer.updateProperties(this._drawId, _t._mergeSVGProperties(__classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f").getPathResizingSVGProperties(__classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_convertToDrawSpace).call(this)), {
            bbox: __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_rotateBox).call(this)
        }));
    };
    DrawingEditor.prototype._onResized = function () {
        var _u;
        (_u = this.parent) === null || _u === void 0 ? void 0 : _u.drawLayer.updateProperties(this._drawId, _t._mergeSVGProperties(__classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f").getPathResizedSVGProperties(__classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_convertToDrawSpace).call(this)), {
            bbox: __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_rotateBox).call(this)
        }));
    };
    DrawingEditor.prototype._onTranslating = function (_x, _y) {
        var _u;
        (_u = this.parent) === null || _u === void 0 ? void 0 : _u.drawLayer.updateProperties(this._drawId, {
            bbox: __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_rotateBox).call(this)
        });
    };
    DrawingEditor.prototype._onTranslated = function () {
        var _u;
        (_u = this.parent) === null || _u === void 0 ? void 0 : _u.drawLayer.updateProperties(this._drawId, _t._mergeSVGProperties(__classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f").getPathTranslatedSVGProperties(__classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_convertToDrawSpace).call(this), this.parentDimensions), {
            bbox: __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_rotateBox).call(this)
        }));
    };
    DrawingEditor.prototype._onStartDragging = function () {
        var _u;
        (_u = this.parent) === null || _u === void 0 ? void 0 : _u.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: true
            }
        });
    };
    DrawingEditor.prototype._onStopDragging = function () {
        var _u;
        (_u = this.parent) === null || _u === void 0 ? void 0 : _u.drawLayer.updateProperties(this._drawId, {
            rootClass: {
                moving: false
            }
        });
    };
    DrawingEditor.prototype.commit = function () {
        _super.prototype.commit.call(this);
        this.disableEditMode();
        this.disableEditing();
    };
    DrawingEditor.prototype.disableEditing = function () {
        _super.prototype.disableEditing.call(this);
        this.div.classList.toggle("disabled", true);
    };
    DrawingEditor.prototype.enableEditing = function () {
        _super.prototype.enableEditing.call(this);
        this.div.classList.toggle("disabled", false);
    };
    DrawingEditor.prototype.getBaseTranslation = function () {
        return [0, 0];
    };
    Object.defineProperty(DrawingEditor.prototype, "isResizable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    DrawingEditor.prototype.onceAdded = function (focus) {
        if (!this.annotationElementId) {
            this.parent.addUndoableEditor(this);
        }
        this._isDraggable = true;
        if (__classPrivateFieldGet(this, _DrawingEditor_mustBeCommitted, "f")) {
            __classPrivateFieldSet(this, _DrawingEditor_mustBeCommitted, false, "f");
            this.commit();
            this.parent.setSelected(this);
            if (focus && this.isOnScreen) {
                this.div.focus();
            }
        }
    };
    DrawingEditor.prototype.remove = function () {
        __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_cleanDrawLayer).call(this);
        _super.prototype.remove.call(this);
    };
    DrawingEditor.prototype.rebuild = function () {
        if (!this.parent) {
            return;
        }
        _super.prototype.rebuild.call(this);
        if (this.div === null) {
            return;
        }
        __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_addToDrawLayer).call(this);
        __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_updateBbox).call(this, __classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f").box);
        if (!this.isAttachedToDOM) {
            this.parent.add(this);
        }
    };
    DrawingEditor.prototype.setParent = function (parent) {
        var _u;
        var mustBeSelected = false;
        if (this.parent && !parent) {
            this._uiManager.removeShouldRescale(this);
            __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_cleanDrawLayer).call(this);
        }
        else if (parent) {
            this._uiManager.addShouldRescale(this);
            __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_addToDrawLayer).call(this, parent);
            mustBeSelected = !this.parent && ((_u = this.div) === null || _u === void 0 ? void 0 : _u.classList.contains("selectedEditor"));
        }
        _super.prototype.setParent.call(this, parent);
        if (mustBeSelected) {
            this.select();
        }
    };
    DrawingEditor.prototype.rotate = function () {
        if (!this.parent) {
            return;
        }
        this.parent.drawLayer.updateProperties(this._drawId, _t._mergeSVGProperties({
            bbox: __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_rotateBox).call(this)
        }, __classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f").updateRotation((this.parentRotation - this.rotation + 360) % 360)));
    };
    DrawingEditor.prototype.onScaleChanging = function () {
        if (!this.parent) {
            return;
        }
        __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_updateBbox).call(this, __classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f").updateParentDimensions(this.parentDimensions, this.parent.scale));
    };
    DrawingEditor.onScaleChangingWhenDrawing = function () { };
    DrawingEditor.prototype.render = function () {
        if (this.div) {
            return this.div;
        }
        var baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        var div = _super.prototype.render.call(this);
        div.classList.add("draw");
        var drawDiv = document.createElement("div");
        div.append(drawDiv);
        drawDiv.setAttribute("aria-hidden", "true");
        drawDiv.className = "internal";
        var _u = __read(this.parentDimensions, 2), parentWidth = _u[0], parentHeight = _u[1];
        this.setDims(this.width * parentWidth, this.height * parentHeight);
        this._uiManager.addShouldRescale(this);
        this.disableEditing();
        if (this._isCopy) {
            this._moveAfterPaste(baseX, baseY);
        }
        return div;
    };
    DrawingEditor.createDrawerInstance = function (_x, _y, _parentWidth, _parentHeight, _rotation) {
        unreachable("Not implemented");
    };
    DrawingEditor.startDrawing = function (parent, uiManager, _isLTR, event) {
        var _this = this;
        var _u, _v;
        var _w, _z;
        var target = event.target, x = event.offsetX, y = event.offsetY, pointerId = event.pointerId, pointerType = event.pointerType;
        if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerType) && __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerType) !== pointerType) {
            return;
        }
        var rotation = parent.viewport.rotation;
        var _0 = target.getBoundingClientRect(), parentWidth = _0.width, parentHeight = _0.height;
        var ac = __classPrivateFieldSet(_t, _t, new AbortController(), "f", _DrawingEditor_currentDrawingAC);
        var signal = parent.combinedSignal(ac);
        __classPrivateFieldSet(_w = _t, _t, __classPrivateFieldGet(_w, _t, "f", _DrawingEditor_currentPointerId) || pointerId, "f", _DrawingEditor_currentPointerId);
        __classPrivateFieldSet(_z = _t, _t, (_u = __classPrivateFieldGet(_z, _t, "f", _DrawingEditor_currentPointerType)) !== null && _u !== void 0 ? _u : pointerType, "f", _DrawingEditor_currentPointerType);
        window.addEventListener("pointerup", function (e) {
            var _u;
            if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerId) === e.pointerId) {
                _this._endDraw(e);
            }
            else {
                (_u = __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerIds)) === null || _u === void 0 ? void 0 : _u.delete(e.pointerId);
            }
        }, {
            signal: signal
        });
        window.addEventListener("pointercancel", function (e) {
            var _u;
            if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerId) === e.pointerId) {
                _this._currentParent.endDrawingSession();
            }
            else {
                (_u = __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerIds)) === null || _u === void 0 ? void 0 : _u.delete(e.pointerId);
            }
        }, {
            signal: signal
        });
        window.addEventListener("pointerdown", function (e) {
            var _u;
            if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerType) !== e.pointerType) {
                return;
            }
            (__classPrivateFieldSet(_u = _t, _t, __classPrivateFieldGet(_u, _t, "f", _DrawingEditor_currentPointerIds) || new Set(), "f", _DrawingEditor_currentPointerIds)).add(e.pointerId);
            if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).isCancellable()) {
                __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).removeLastElement();
                if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).isEmpty()) {
                    _this._currentParent.endDrawingSession(true);
                }
                else {
                    _this._endDraw(null);
                }
            }
        }, {
            capture: true,
            passive: false,
            signal: signal
        });
        window.addEventListener("contextmenu", noContextMenu, {
            signal: signal
        });
        target.addEventListener("pointermove", this._drawMove.bind(this), {
            signal: signal
        });
        target.addEventListener("touchmove", function (e) {
            if (e.timeStamp === __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentMoveTimestamp)) {
                stopEvent(e);
            }
        }, {
            signal: signal
        });
        parent.toggleDrawing();
        (_v = uiManager._editorUndoBar) === null || _v === void 0 ? void 0 : _v.hide();
        if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw)) {
            parent.drawLayer.updateProperties(this._currentDrawId, __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).startNew(x, y, parentWidth, parentHeight, rotation));
            return;
        }
        uiManager.updateUIForDefaultProperties(this);
        __classPrivateFieldSet(_t, _t, this.createDrawerInstance(x, y, parentWidth, parentHeight, rotation), "f", _DrawingEditor_currentDraw);
        __classPrivateFieldSet(_t, _t, this.getDefaultDrawingOptions(), "f", _DrawingEditor_currentDrawingOptions);
        this._currentParent = parent;
        (this._currentDrawId = parent.drawLayer.draw(this._mergeSVGProperties(__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDrawingOptions).toSVGProperties(), __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).defaultSVGProperties), true, false).id);
    };
    DrawingEditor._drawMove = function (event) {
        var _u;
        __classPrivateFieldSet(_t, _t, -1, "f", _DrawingEditor_currentMoveTimestamp);
        if (!__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw)) {
            return;
        }
        var offsetX = event.offsetX, offsetY = event.offsetY, pointerId = event.pointerId;
        if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerId) !== pointerId) {
            return;
        }
        if (((_u = __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentPointerIds)) === null || _u === void 0 ? void 0 : _u.size) >= 1) {
            this._endDraw(event);
            return;
        }
        this._currentParent.drawLayer.updateProperties(this._currentDrawId, __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).add(offsetX, offsetY));
        __classPrivateFieldSet(_t, _t, event.timeStamp, "f", _DrawingEditor_currentMoveTimestamp);
        stopEvent(event);
    };
    DrawingEditor._cleanup = function (all) {
        if (all) {
            this._currentDrawId = -1;
            this._currentParent = null;
            __classPrivateFieldSet(_t, _t, null, "f", _DrawingEditor_currentDraw);
            __classPrivateFieldSet(_t, _t, null, "f", _DrawingEditor_currentDrawingOptions);
            __classPrivateFieldSet(_t, _t, null, "f", _DrawingEditor_currentPointerType);
            __classPrivateFieldSet(_t, _t, NaN, "f", _DrawingEditor_currentMoveTimestamp);
        }
        if (__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDrawingAC)) {
            __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDrawingAC).abort();
            __classPrivateFieldSet(_t, _t, null, "f", _DrawingEditor_currentDrawingAC);
            __classPrivateFieldSet(_t, _t, NaN, "f", _DrawingEditor_currentPointerId);
            __classPrivateFieldSet(_t, _t, null, "f", _DrawingEditor_currentPointerIds);
        }
    };
    DrawingEditor._endDraw = function (event) {
        var parent = this._currentParent;
        if (!parent) {
            return;
        }
        parent.toggleDrawing(true);
        this._cleanup(false);
        if ((event === null || event === void 0 ? void 0 : event.target) === parent.div) {
            parent.drawLayer.updateProperties(this._currentDrawId, __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).end(event.offsetX, event.offsetY));
        }
        if (this.supportMultipleDrawings) {
            var draw_1 = __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw);
            var drawId_1 = this._currentDrawId;
            var lastElement_1 = draw_1.getLastElement();
            parent.addCommands({
                cmd: function () {
                    parent.drawLayer.updateProperties(drawId_1, draw_1.setLastElement(lastElement_1));
                },
                undo: function () {
                    parent.drawLayer.updateProperties(drawId_1, draw_1.removeLastElement());
                },
                mustExec: false,
                type: AnnotationEditorParamsType.DRAW_STEP
            });
            return;
        }
        this.endDrawing(false);
    };
    DrawingEditor.endDrawing = function (isAborted) {
        var parent = this._currentParent;
        if (!parent) {
            return null;
        }
        parent.toggleDrawing(true);
        parent.cleanUndoStack(AnnotationEditorParamsType.DRAW_STEP);
        if (!__classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).isEmpty()) {
            var _u = __read(parent.pageDimensions, 2), pageWidth = _u[0], pageHeight = _u[1], scale = parent.scale;
            var editor = parent.createAndAddNewEditor({
                offsetX: 0,
                offsetY: 0
            }, false, {
                drawId: this._currentDrawId,
                drawOutlines: __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDraw).getOutlines(pageWidth * scale, pageHeight * scale, scale, this._INNER_MARGIN),
                drawingOptions: __classPrivateFieldGet(_t, _t, "f", _DrawingEditor_currentDrawingOptions),
                mustBeCommitted: !isAborted
            });
            this._cleanup(true);
            return editor;
        }
        parent.drawLayer.remove(this._currentDrawId);
        this._cleanup(true);
        return null;
    };
    DrawingEditor.prototype.createDrawingOptions = function (_data) { };
    DrawingEditor.deserializeDraw = function (_pageX, _pageY, _pageWidth, _pageHeight, _innerWidth, _data) {
        unreachable("Not implemented");
    };
    DrawingEditor.deserialize = function (data, parent, uiManager) {
        return __awaiter(this, void 0, void 0, function () {
            var _u, pageWidth, pageHeight, pageX, pageY, drawOutlines, editor;
            return __generator(this, function (_v) {
                switch (_v.label) {
                    case 0:
                        _u = parent.viewport.rawDims, pageWidth = _u.pageWidth, pageHeight = _u.pageHeight, pageX = _u.pageX, pageY = _u.pageY;
                        drawOutlines = this.deserializeDraw(pageX, pageY, pageWidth, pageHeight, this._INNER_MARGIN, data);
                        return [4 /*yield*/, _super.deserialize.call(this, data, parent, uiManager)];
                    case 1:
                        editor = _v.sent();
                        editor.createDrawingOptions(data);
                        __classPrivateFieldGet(editor, _DrawingEditor_instances, "m", _DrawingEditor_createDrawOutlines).call(editor, {
                            drawOutlines: drawOutlines
                        });
                        __classPrivateFieldGet(editor, _DrawingEditor_instances, "m", _DrawingEditor_addToDrawLayer).call(editor);
                        editor.onScaleChanging();
                        editor.rotate();
                        return [2 /*return*/, editor];
                }
            });
        });
    };
    DrawingEditor.prototype.serializeDraw = function (isForCopying) {
        var _u = __read(this.pageTranslation, 2), pageX = _u[0], pageY = _u[1];
        var _v = __read(this.pageDimensions, 2), pageWidth = _v[0], pageHeight = _v[1];
        return __classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f").serialize([pageX, pageY, pageWidth, pageHeight], isForCopying);
    };
    DrawingEditor.prototype.renderAnnotationElement = function (annotation) {
        annotation.updateEdited({
            rect: this.getRect(0, 0)
        });
        return null;
    };
    DrawingEditor.canCreateNewEmptyEditor = function () {
        return false;
    };
    var _DrawingEditor_instances, _t, _DrawingEditor_drawOutlines, _DrawingEditor_mustBeCommitted, _DrawingEditor_currentDraw, _DrawingEditor_currentDrawingAC, _DrawingEditor_currentDrawingOptions, _DrawingEditor_currentPointerId, _DrawingEditor_currentPointerType, _DrawingEditor_currentPointerIds, _DrawingEditor_currentMoveTimestamp, _DrawingEditor_createDrawOutlines, _DrawingEditor_createDrawing, _DrawingEditor_cleanDrawLayer, _DrawingEditor_addToDrawLayer, _DrawingEditor_convertToParentSpace, _DrawingEditor_convertToDrawSpace, _DrawingEditor_updateBbox, _DrawingEditor_rotateBox;
    _t = DrawingEditor, _DrawingEditor_drawOutlines = new WeakMap(), _DrawingEditor_mustBeCommitted = new WeakMap(), _DrawingEditor_instances = new WeakSet(), _DrawingEditor_createDrawOutlines = function _DrawingEditor_createDrawOutlines(_u) {
        var drawOutlines = _u.drawOutlines, drawId = _u.drawId, drawingOptions = _u.drawingOptions;
        __classPrivateFieldSet(this, _DrawingEditor_drawOutlines, drawOutlines, "f");
        this._drawingOptions || (this._drawingOptions = drawingOptions);
        if (drawId >= 0) {
            this._drawId = drawId;
            this.parent.drawLayer.finalizeDraw(drawId, drawOutlines.defaultProperties);
        }
        else {
            this._drawId = __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_createDrawing).call(this, drawOutlines, this.parent);
        }
        __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_updateBbox).call(this, drawOutlines.box);
    }, _DrawingEditor_createDrawing = function _DrawingEditor_createDrawing(drawOutlines, parent) {
        var id = parent.drawLayer.draw(_t._mergeSVGProperties(this._drawingOptions.toSVGProperties(), drawOutlines.defaultSVGProperties), false, false).id;
        return id;
    }, _DrawingEditor_cleanDrawLayer = function _DrawingEditor_cleanDrawLayer() {
        if (this._drawId === null || !this.parent) {
            return;
        }
        this.parent.drawLayer.remove(this._drawId);
        this._drawId = null;
        this._drawingOptions.reset();
    }, _DrawingEditor_addToDrawLayer = function _DrawingEditor_addToDrawLayer(parent) {
        if (parent === void 0) { parent = this.parent; }
        if (this._drawId !== null && this.parent === parent) {
            return;
        }
        if (this._drawId !== null) {
            this.parent.drawLayer.updateParent(this._drawId, parent.drawLayer);
            return;
        }
        this._drawingOptions.updateAll();
        this._drawId = __classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_createDrawing).call(this, __classPrivateFieldGet(this, _DrawingEditor_drawOutlines, "f"), parent);
    }, _DrawingEditor_convertToParentSpace = function _DrawingEditor_convertToParentSpace(_u) {
        var _v = __read(_u, 4), x = _v[0], y = _v[1], width = _v[2], height = _v[3];
        var _w = this, _z = __read(_w.parentDimensions, 2), pW = _z[0], pH = _z[1], rotation = _w.rotation;
        switch (rotation) {
            case 90:
                return [y, 1 - x, width * (pH / pW), height * (pW / pH)];
            case 180:
                return [1 - x, 1 - y, width, height];
            case 270:
                return [1 - y, x, width * (pH / pW), height * (pW / pH)];
            default:
                return [x, y, width, height];
        }
    }, _DrawingEditor_convertToDrawSpace = function _DrawingEditor_convertToDrawSpace() {
        var _u = this, x = _u.x, y = _u.y, width = _u.width, height = _u.height, _v = __read(_u.parentDimensions, 2), pW = _v[0], pH = _v[1], rotation = _u.rotation;
        switch (rotation) {
            case 90:
                return [1 - y, x, width * (pW / pH), height * (pH / pW)];
            case 180:
                return [1 - x, 1 - y, width, height];
            case 270:
                return [y, 1 - x, width * (pW / pH), height * (pH / pW)];
            default:
                return [x, y, width, height];
        }
    }, _DrawingEditor_updateBbox = function _DrawingEditor_updateBbox(bbox) {
        var _u;
        _u = __read(__classPrivateFieldGet(this, _DrawingEditor_instances, "m", _DrawingEditor_convertToParentSpace).call(this, bbox), 4), this.x = _u[0], this.y = _u[1], this.width = _u[2], this.height = _u[3];
        if (this.div) {
            this.fixAndSetPosition();
            var _v = __read(this.parentDimensions, 2), parentWidth = _v[0], parentHeight = _v[1];
            this.setDims(this.width * parentWidth, this.height * parentHeight);
        }
        this._onResized();
    }, _DrawingEditor_rotateBox = function _DrawingEditor_rotateBox() {
        var _u = this, x = _u.x, y = _u.y, width = _u.width, height = _u.height, rotation = _u.rotation, parentRotation = _u.parentRotation, _v = __read(_u.parentDimensions, 2), pW = _v[0], pH = _v[1];
        switch ((rotation * 4 + parentRotation) / 90) {
            case 1:
                return [1 - y - height, x, height, width];
            case 2:
                return [1 - x - width, 1 - y - height, width, height];
            case 3:
                return [y, 1 - x - width, height, width];
            case 4:
                return [x, y - width * (pW / pH), height * (pH / pW), width * (pW / pH)];
            case 5:
                return [1 - y, x, width * (pW / pH), height * (pH / pW)];
            case 6:
                return [1 - x - height * (pH / pW), 1 - y, height * (pH / pW), width * (pW / pH)];
            case 7:
                return [y - width * (pW / pH), 1 - x - height * (pH / pW), width * (pW / pH), height * (pH / pW)];
            case 8:
                return [x - width, y - height, width, height];
            case 9:
                return [1 - y, x - width, height, width];
            case 10:
                return [1 - x, 1 - y, width, height];
            case 11:
                return [y - height, 1 - x, height, width];
            case 12:
                return [x - height * (pH / pW), y, height * (pH / pW), width * (pW / pH)];
            case 13:
                return [1 - y - width * (pW / pH), x - height * (pH / pW), width * (pW / pH), height * (pH / pW)];
            case 14:
                return [1 - x, 1 - y - width * (pW / pH), height * (pH / pW), width * (pW / pH)];
            case 15:
                return [y, 1 - x, width * (pW / pH), height * (pH / pW)];
            default:
                return [x, y, width, height];
        }
    };
    DrawingEditor._currentDrawId = -1;
    DrawingEditor._currentParent = null;
    _DrawingEditor_currentDraw = { value: null };
    _DrawingEditor_currentDrawingAC = { value: null };
    _DrawingEditor_currentDrawingOptions = { value: null };
    _DrawingEditor_currentPointerId = { value: NaN };
    _DrawingEditor_currentPointerType = { value: null };
    _DrawingEditor_currentPointerIds = { value: null };
    _DrawingEditor_currentMoveTimestamp = { value: NaN };
    DrawingEditor._INNER_MARGIN = 3;
    return DrawingEditor;
}(AnnotationEditor));
; // ./src/display/editor/drawers/inkdraw.js
var InkDrawOutliner = /** @class */ (function () {
    function InkDrawOutliner(x, y, parentWidth, parentHeight, rotation, thickness) {
        var _u;
        _InkDrawOutliner_instances.add(this);
        _InkDrawOutliner_last.set(this, new Float64Array(6));
        _InkDrawOutliner_line.set(this, void 0);
        _InkDrawOutliner_lines.set(this, void 0);
        _InkDrawOutliner_rotation.set(this, void 0);
        _InkDrawOutliner_thickness.set(this, void 0);
        _InkDrawOutliner_points.set(this, void 0);
        _InkDrawOutliner_lastSVGPath.set(this, "");
        _InkDrawOutliner_lastIndex.set(this, 0);
        _InkDrawOutliner_outlines.set(this, new InkDrawOutline());
        _InkDrawOutliner_parentWidth.set(this, void 0);
        _InkDrawOutliner_parentHeight.set(this, void 0);
        __classPrivateFieldSet(this, _InkDrawOutliner_parentWidth, parentWidth, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_parentHeight, parentHeight, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_rotation, rotation, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_thickness, thickness, "f");
        _u = __read(__classPrivateFieldGet(this, _InkDrawOutliner_instances, "m", _InkDrawOutliner_normalizePoint).call(this, x, y), 2), x = _u[0], y = _u[1];
        var line = __classPrivateFieldSet(this, _InkDrawOutliner_line, [NaN, NaN, NaN, NaN, x, y], "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_points, [x, y], "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_lines, [{
                line: line,
                points: __classPrivateFieldGet(this, _InkDrawOutliner_points, "f")
            }], "f");
        __classPrivateFieldGet(this, _InkDrawOutliner_last, "f").set(line, 0);
    }
    InkDrawOutliner.prototype.updateProperty = function (name, value) {
        if (name === "stroke-width") {
            __classPrivateFieldSet(this, _InkDrawOutliner_thickness, value, "f");
        }
    };
    InkDrawOutliner.prototype.isEmpty = function () {
        return !__classPrivateFieldGet(this, _InkDrawOutliner_lines, "f") || __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").length === 0;
    };
    InkDrawOutliner.prototype.isCancellable = function () {
        return __classPrivateFieldGet(this, _InkDrawOutliner_points, "f").length <= 10;
    };
    InkDrawOutliner.prototype.add = function (x, y) {
        var _u, _v;
        _u = __read(__classPrivateFieldGet(this, _InkDrawOutliner_instances, "m", _InkDrawOutliner_normalizePoint).call(this, x, y), 2), x = _u[0], y = _u[1];
        var _w = __read(__classPrivateFieldGet(this, _InkDrawOutliner_last, "f").subarray(2, 6), 4), x1 = _w[0], y1 = _w[1], x2 = _w[2], y2 = _w[3];
        var diffX = x - x2;
        var diffY = y - y2;
        var d = Math.hypot(__classPrivateFieldGet(this, _InkDrawOutliner_parentWidth, "f") * diffX, __classPrivateFieldGet(this, _InkDrawOutliner_parentHeight, "f") * diffY);
        if (d <= 2) {
            return null;
        }
        __classPrivateFieldGet(this, _InkDrawOutliner_points, "f").push(x, y);
        if (isNaN(x1)) {
            __classPrivateFieldGet(this, _InkDrawOutliner_last, "f").set([x2, y2, x, y], 2);
            __classPrivateFieldGet(this, _InkDrawOutliner_line, "f").push(NaN, NaN, NaN, NaN, x, y);
            return {
                path: {
                    d: this.toSVGPath()
                }
            };
        }
        if (isNaN(__classPrivateFieldGet(this, _InkDrawOutliner_last, "f")[0])) {
            __classPrivateFieldGet(this, _InkDrawOutliner_line, "f").splice(6, 6);
        }
        __classPrivateFieldGet(this, _InkDrawOutliner_last, "f").set([x1, y1, x2, y2, x, y], 0);
        (_v = __classPrivateFieldGet(this, _InkDrawOutliner_line, "f")).push.apply(_v, __spreadArray([], __read(Outline.createBezierPoints(x1, y1, x2, y2, x, y)), false));
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    };
    InkDrawOutliner.prototype.end = function (x, y) {
        var change = this.add(x, y);
        if (change) {
            return change;
        }
        if (__classPrivateFieldGet(this, _InkDrawOutliner_points, "f").length === 2) {
            return {
                path: {
                    d: this.toSVGPath()
                }
            };
        }
        return null;
    };
    InkDrawOutliner.prototype.startNew = function (x, y, parentWidth, parentHeight, rotation) {
        var _u;
        __classPrivateFieldSet(this, _InkDrawOutliner_parentWidth, parentWidth, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_parentHeight, parentHeight, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_rotation, rotation, "f");
        _u = __read(__classPrivateFieldGet(this, _InkDrawOutliner_instances, "m", _InkDrawOutliner_normalizePoint).call(this, x, y), 2), x = _u[0], y = _u[1];
        var line = __classPrivateFieldSet(this, _InkDrawOutliner_line, [NaN, NaN, NaN, NaN, x, y], "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_points, [x, y], "f");
        var last = __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").at(-1);
        if (last) {
            last.line = new Float32Array(last.line);
            last.points = new Float32Array(last.points);
        }
        __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").push({
            line: line,
            points: __classPrivateFieldGet(this, _InkDrawOutliner_points, "f")
        });
        __classPrivateFieldGet(this, _InkDrawOutliner_last, "f").set(line, 0);
        __classPrivateFieldSet(this, _InkDrawOutliner_lastIndex, 0, "f");
        this.toSVGPath();
        return null;
    };
    InkDrawOutliner.prototype.getLastElement = function () {
        return __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").at(-1);
    };
    InkDrawOutliner.prototype.setLastElement = function (element) {
        if (!__classPrivateFieldGet(this, _InkDrawOutliner_lines, "f")) {
            return __classPrivateFieldGet(this, _InkDrawOutliner_outlines, "f").setLastElement(element);
        }
        __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").push(element);
        __classPrivateFieldSet(this, _InkDrawOutliner_line, element.line, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_points, element.points, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_lastIndex, 0, "f");
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    };
    InkDrawOutliner.prototype.removeLastElement = function () {
        if (!__classPrivateFieldGet(this, _InkDrawOutliner_lines, "f")) {
            return __classPrivateFieldGet(this, _InkDrawOutliner_outlines, "f").removeLastElement();
        }
        __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").pop();
        __classPrivateFieldSet(this, _InkDrawOutliner_lastSVGPath, "", "f");
        for (var i = 0, ii = __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").length; i < ii; i++) {
            var _u = __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f")[i], line = _u.line, points = _u.points;
            __classPrivateFieldSet(this, _InkDrawOutliner_line, line, "f");
            __classPrivateFieldSet(this, _InkDrawOutliner_points, points, "f");
            __classPrivateFieldSet(this, _InkDrawOutliner_lastIndex, 0, "f");
            this.toSVGPath();
        }
        return {
            path: {
                d: __classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f")
            }
        };
    };
    InkDrawOutliner.prototype.toSVGPath = function () {
        var firstX = Outline.svgRound(__classPrivateFieldGet(this, _InkDrawOutliner_line, "f")[4]);
        var firstY = Outline.svgRound(__classPrivateFieldGet(this, _InkDrawOutliner_line, "f")[5]);
        if (__classPrivateFieldGet(this, _InkDrawOutliner_points, "f").length === 2) {
            __classPrivateFieldSet(this, _InkDrawOutliner_lastSVGPath, "".concat(__classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f"), " M ").concat(firstX, " ").concat(firstY, " Z"), "f");
            return __classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f");
        }
        if (__classPrivateFieldGet(this, _InkDrawOutliner_points, "f").length <= 6) {
            var i = __classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f").lastIndexOf("M");
            __classPrivateFieldSet(this, _InkDrawOutliner_lastSVGPath, "".concat(__classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f").slice(0, i), " M ").concat(firstX, " ").concat(firstY), "f");
            __classPrivateFieldSet(this, _InkDrawOutliner_lastIndex, 6, "f");
        }
        if (__classPrivateFieldGet(this, _InkDrawOutliner_points, "f").length === 4) {
            var secondX = Outline.svgRound(__classPrivateFieldGet(this, _InkDrawOutliner_line, "f")[10]);
            var secondY = Outline.svgRound(__classPrivateFieldGet(this, _InkDrawOutliner_line, "f")[11]);
            __classPrivateFieldSet(this, _InkDrawOutliner_lastSVGPath, "".concat(__classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f"), " L ").concat(secondX, " ").concat(secondY), "f");
            __classPrivateFieldSet(this, _InkDrawOutliner_lastIndex, 12, "f");
            return __classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f");
        }
        var buffer = [];
        if (__classPrivateFieldGet(this, _InkDrawOutliner_lastIndex, "f") === 0) {
            buffer.push("M ".concat(firstX, " ").concat(firstY));
            __classPrivateFieldSet(this, _InkDrawOutliner_lastIndex, 6, "f");
        }
        for (var i = __classPrivateFieldGet(this, _InkDrawOutliner_lastIndex, "f"), ii = __classPrivateFieldGet(this, _InkDrawOutliner_line, "f").length; i < ii; i += 6) {
            var _u = __read(__classPrivateFieldGet(this, _InkDrawOutliner_line, "f").slice(i, i + 6).map(Outline.svgRound), 6), c1x = _u[0], c1y = _u[1], c2x = _u[2], c2y = _u[3], x = _u[4], y = _u[5];
            buffer.push("C".concat(c1x, " ").concat(c1y, " ").concat(c2x, " ").concat(c2y, " ").concat(x, " ").concat(y));
        }
        __classPrivateFieldSet(this, _InkDrawOutliner_lastSVGPath, __classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f") + buffer.join(" "), "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_lastIndex, __classPrivateFieldGet(this, _InkDrawOutliner_line, "f").length, "f");
        return __classPrivateFieldGet(this, _InkDrawOutliner_lastSVGPath, "f");
    };
    InkDrawOutliner.prototype.getOutlines = function (parentWidth, parentHeight, scale, innerMargin) {
        var last = __classPrivateFieldGet(this, _InkDrawOutliner_lines, "f").at(-1);
        last.line = new Float32Array(last.line);
        last.points = new Float32Array(last.points);
        __classPrivateFieldGet(this, _InkDrawOutliner_outlines, "f").build(__classPrivateFieldGet(this, _InkDrawOutliner_lines, "f"), parentWidth, parentHeight, scale, __classPrivateFieldGet(this, _InkDrawOutliner_rotation, "f"), __classPrivateFieldGet(this, _InkDrawOutliner_thickness, "f"), innerMargin);
        __classPrivateFieldSet(this, _InkDrawOutliner_last, null, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_line, null, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_lines, null, "f");
        __classPrivateFieldSet(this, _InkDrawOutliner_lastSVGPath, null, "f");
        return __classPrivateFieldGet(this, _InkDrawOutliner_outlines, "f");
    };
    Object.defineProperty(InkDrawOutliner.prototype, "defaultSVGProperties", {
        get: function () {
            return {
                root: {
                    viewBox: "0 0 10000 10000"
                },
                rootClass: {
                    draw: true
                },
                bbox: [0, 0, 1, 1]
            };
        },
        enumerable: false,
        configurable: true
    });
    return InkDrawOutliner;
}());
_InkDrawOutliner_last = new WeakMap(), _InkDrawOutliner_line = new WeakMap(), _InkDrawOutliner_lines = new WeakMap(), _InkDrawOutliner_rotation = new WeakMap(), _InkDrawOutliner_thickness = new WeakMap(), _InkDrawOutliner_points = new WeakMap(), _InkDrawOutliner_lastSVGPath = new WeakMap(), _InkDrawOutliner_lastIndex = new WeakMap(), _InkDrawOutliner_outlines = new WeakMap(), _InkDrawOutliner_parentWidth = new WeakMap(), _InkDrawOutliner_parentHeight = new WeakMap(), _InkDrawOutliner_instances = new WeakSet(), _InkDrawOutliner_normalizePoint = function _InkDrawOutliner_normalizePoint(x, y) {
    return Outline._normalizePoint(x, y, __classPrivateFieldGet(this, _InkDrawOutliner_parentWidth, "f"), __classPrivateFieldGet(this, _InkDrawOutliner_parentHeight, "f"), __classPrivateFieldGet(this, _InkDrawOutliner_rotation, "f"));
};
var InkDrawOutline = /** @class */ (function (_super) {
    __extends(InkDrawOutline, _super);
    function InkDrawOutline() {
        var _this = _super.apply(this, __spreadArray([], __read(arguments), false)) || this;
        _InkDrawOutline_instances.add(_this);
        _InkDrawOutline_bbox.set(_this, void 0);
        _InkDrawOutline_currentRotation.set(_this, 0);
        _InkDrawOutline_innerMargin.set(_this, void 0);
        _InkDrawOutline_lines.set(_this, void 0);
        _InkDrawOutline_parentWidth.set(_this, void 0);
        _InkDrawOutline_parentHeight.set(_this, void 0);
        _InkDrawOutline_parentScale.set(_this, void 0);
        _InkDrawOutline_rotation.set(_this, void 0);
        _InkDrawOutline_thickness.set(_this, void 0);
        return _this;
    }
    InkDrawOutline.prototype.build = function (lines, parentWidth, parentHeight, parentScale, rotation, thickness, innerMargin) {
        __classPrivateFieldSet(this, _InkDrawOutline_parentWidth, parentWidth, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_parentHeight, parentHeight, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_parentScale, parentScale, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_rotation, rotation, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_thickness, thickness, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_innerMargin, innerMargin !== null && innerMargin !== void 0 ? innerMargin : 0, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_lines, lines, "f");
        __classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_computeBbox).call(this);
    };
    Object.defineProperty(InkDrawOutline.prototype, "thickness", {
        get: function () {
            return __classPrivateFieldGet(this, _InkDrawOutline_thickness, "f");
        },
        enumerable: false,
        configurable: true
    });
    InkDrawOutline.prototype.setLastElement = function (element) {
        __classPrivateFieldGet(this, _InkDrawOutline_lines, "f").push(element);
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    };
    InkDrawOutline.prototype.removeLastElement = function () {
        __classPrivateFieldGet(this, _InkDrawOutline_lines, "f").pop();
        return {
            path: {
                d: this.toSVGPath()
            }
        };
    };
    InkDrawOutline.prototype.toSVGPath = function () {
        var e_185, _u;
        var buffer = [];
        try {
            for (var _v = __values(__classPrivateFieldGet(this, _InkDrawOutline_lines, "f")), _w = _v.next(); !_w.done; _w = _v.next()) {
                var line = _w.value.line;
                buffer.push("M".concat(Outline.svgRound(line[4]), " ").concat(Outline.svgRound(line[5])));
                if (line.length === 6) {
                    buffer.push("Z");
                    continue;
                }
                if (line.length === 12 && isNaN(line[6])) {
                    buffer.push("L".concat(Outline.svgRound(line[10]), " ").concat(Outline.svgRound(line[11])));
                    continue;
                }
                for (var i = 6, ii = line.length; i < ii; i += 6) {
                    var _z = __read(line.subarray(i, i + 6).map(Outline.svgRound), 6), c1x = _z[0], c1y = _z[1], c2x = _z[2], c2y = _z[3], x = _z[4], y = _z[5];
                    buffer.push("C".concat(c1x, " ").concat(c1y, " ").concat(c2x, " ").concat(c2y, " ").concat(x, " ").concat(y));
                }
            }
        }
        catch (e_185_1) { e_185 = { error: e_185_1 }; }
        finally {
            try {
                if (_w && !_w.done && (_u = _v.return)) _u.call(_v);
            }
            finally { if (e_185) throw e_185.error; }
        }
        return buffer.join("");
    };
    InkDrawOutline.prototype.serialize = function (_u, isForCopying) {
        var e_186, _v;
        var _w = __read(_u, 4), pageX = _w[0], pageY = _w[1], pageWidth = _w[2], pageHeight = _w[3];
        var serializedLines = [];
        var serializedPoints = [];
        var _z = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getBBoxWithNoMargin).call(this), 4), x = _z[0], y = _z[1], width = _z[2], height = _z[3];
        var tx, ty, sx, sy, x1, y1, x2, y2, rescaleFn;
        switch (__classPrivateFieldGet(this, _InkDrawOutline_rotation, "f")) {
            case 0:
                rescaleFn = Outline._rescale;
                tx = pageX;
                ty = pageY + pageHeight;
                sx = pageWidth;
                sy = -pageHeight;
                x1 = pageX + x * pageWidth;
                y1 = pageY + (1 - y - height) * pageHeight;
                x2 = pageX + (x + width) * pageWidth;
                y2 = pageY + (1 - y) * pageHeight;
                break;
            case 90:
                rescaleFn = Outline._rescaleAndSwap;
                tx = pageX;
                ty = pageY;
                sx = pageWidth;
                sy = pageHeight;
                x1 = pageX + y * pageWidth;
                y1 = pageY + x * pageHeight;
                x2 = pageX + (y + height) * pageWidth;
                y2 = pageY + (x + width) * pageHeight;
                break;
            case 180:
                rescaleFn = Outline._rescale;
                tx = pageX + pageWidth;
                ty = pageY;
                sx = -pageWidth;
                sy = pageHeight;
                x1 = pageX + (1 - x - width) * pageWidth;
                y1 = pageY + y * pageHeight;
                x2 = pageX + (1 - x) * pageWidth;
                y2 = pageY + (y + height) * pageHeight;
                break;
            case 270:
                rescaleFn = Outline._rescaleAndSwap;
                tx = pageX + pageWidth;
                ty = pageY + pageHeight;
                sx = -pageWidth;
                sy = -pageHeight;
                x1 = pageX + (1 - y - height) * pageWidth;
                y1 = pageY + (1 - x - width) * pageHeight;
                x2 = pageX + (1 - y) * pageWidth;
                y2 = pageY + (1 - x) * pageHeight;
                break;
        }
        try {
            for (var _0 = __values(__classPrivateFieldGet(this, _InkDrawOutline_lines, "f")), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                var _2 = _1.value, line = _2.line, points = _2.points;
                serializedLines.push(rescaleFn(line, tx, ty, sx, sy, isForCopying ? new Array(line.length) : null));
                serializedPoints.push(rescaleFn(points, tx, ty, sx, sy, isForCopying ? new Array(points.length) : null));
            }
        }
        catch (e_186_1) { e_186 = { error: e_186_1 }; }
        finally {
            try {
                if (_1 && !_1.done && (_v = _0.return)) _v.call(_0);
            }
            finally { if (e_186) throw e_186.error; }
        }
        return {
            lines: serializedLines,
            points: serializedPoints,
            rect: [x1, y1, x2, y2]
        };
    };
    InkDrawOutline.deserialize = function (pageX, pageY, pageWidth, pageHeight, innerMargin, _u) {
        var e_187, _v, _w;
        var _z = _u.paths, lines = _z.lines, points = _z.points, rotation = _u.rotation, thickness = _u.thickness;
        var newLines = [];
        var tx, ty, sx, sy, rescaleFn;
        switch (rotation) {
            case 0:
                rescaleFn = Outline._rescale;
                tx = -pageX / pageWidth;
                ty = pageY / pageHeight + 1;
                sx = 1 / pageWidth;
                sy = -1 / pageHeight;
                break;
            case 90:
                rescaleFn = Outline._rescaleAndSwap;
                tx = -pageY / pageHeight;
                ty = -pageX / pageWidth;
                sx = 1 / pageHeight;
                sy = 1 / pageWidth;
                break;
            case 180:
                rescaleFn = Outline._rescale;
                tx = pageX / pageWidth + 1;
                ty = -pageY / pageHeight;
                sx = -1 / pageWidth;
                sy = 1 / pageHeight;
                break;
            case 270:
                rescaleFn = Outline._rescaleAndSwap;
                tx = pageY / pageHeight + 1;
                ty = pageX / pageWidth + 1;
                sx = -1 / pageHeight;
                sy = -1 / pageWidth;
                break;
        }
        if (!lines) {
            lines = [];
            try {
                for (var points_1 = __values(points), points_1_1 = points_1.next(); !points_1_1.done; points_1_1 = points_1.next()) {
                    var point = points_1_1.value;
                    var len = point.length;
                    if (len === 2) {
                        lines.push(new Float32Array([NaN, NaN, NaN, NaN, point[0], point[1]]));
                        continue;
                    }
                    if (len === 4) {
                        lines.push(new Float32Array([NaN, NaN, NaN, NaN, point[0], point[1], NaN, NaN, NaN, NaN, point[2], point[3]]));
                        continue;
                    }
                    var line = new Float32Array(3 * (len - 2));
                    lines.push(line);
                    var _0 = __read(point.subarray(0, 4), 4), x1 = _0[0], y1 = _0[1], x2 = _0[2], y2 = _0[3];
                    line.set([NaN, NaN, NaN, NaN, x1, y1], 0);
                    for (var i = 4; i < len; i += 2) {
                        var x = point[i];
                        var y = point[i + 1];
                        line.set(Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                        _w = __read([x2, y2, x, y], 4), x1 = _w[0], y1 = _w[1], x2 = _w[2], y2 = _w[3];
                    }
                }
            }
            catch (e_187_1) { e_187 = { error: e_187_1 }; }
            finally {
                try {
                    if (points_1_1 && !points_1_1.done && (_v = points_1.return)) _v.call(points_1);
                }
                finally { if (e_187) throw e_187.error; }
            }
        }
        for (var i = 0, ii = lines.length; i < ii; i++) {
            newLines.push({
                line: rescaleFn(lines[i].map(function (x) { return x !== null && x !== void 0 ? x : NaN; }), tx, ty, sx, sy),
                points: rescaleFn(points[i].map(function (x) { return x !== null && x !== void 0 ? x : NaN; }), tx, ty, sx, sy)
            });
        }
        var outlines = new this.prototype.constructor();
        outlines.build(newLines, pageWidth, pageHeight, 1, rotation, thickness, innerMargin);
        return outlines;
    };
    Object.defineProperty(InkDrawOutline.prototype, "box", {
        get: function () {
            return __classPrivateFieldGet(this, _InkDrawOutline_bbox, "f");
        },
        enumerable: false,
        configurable: true
    });
    InkDrawOutline.prototype.updateProperty = function (name, value) {
        if (name === "stroke-width") {
            return __classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_updateThickness).call(this, value);
        }
        return null;
    };
    InkDrawOutline.prototype.updateParentDimensions = function (_u, scale) {
        var _v = __read(_u, 2), width = _v[0], height = _v[1];
        var _w = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this), 2), oldMarginX = _w[0], oldMarginY = _w[1];
        __classPrivateFieldSet(this, _InkDrawOutline_parentWidth, width, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_parentHeight, height, "f");
        __classPrivateFieldSet(this, _InkDrawOutline_parentScale, scale, "f");
        var _z = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this), 2), newMarginX = _z[0], newMarginY = _z[1];
        var diffMarginX = newMarginX - oldMarginX;
        var diffMarginY = newMarginY - oldMarginY;
        var bbox = __classPrivateFieldGet(this, _InkDrawOutline_bbox, "f");
        bbox[0] -= diffMarginX;
        bbox[1] -= diffMarginY;
        bbox[2] += 2 * diffMarginX;
        bbox[3] += 2 * diffMarginY;
        return bbox;
    };
    InkDrawOutline.prototype.updateRotation = function (rotation) {
        __classPrivateFieldSet(this, _InkDrawOutline_currentRotation, rotation, "f");
        return {
            path: {
                transform: this.rotationTransform
            }
        };
    };
    Object.defineProperty(InkDrawOutline.prototype, "viewBox", {
        get: function () {
            return __classPrivateFieldGet(this, _InkDrawOutline_bbox, "f").map(Outline.svgRound).join(" ");
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InkDrawOutline.prototype, "defaultProperties", {
        get: function () {
            var _u = __read(__classPrivateFieldGet(this, _InkDrawOutline_bbox, "f"), 2), x = _u[0], y = _u[1];
            return {
                root: {
                    viewBox: this.viewBox
                },
                path: {
                    "transform-origin": "".concat(Outline.svgRound(x), " ").concat(Outline.svgRound(y))
                }
            };
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InkDrawOutline.prototype, "rotationTransform", {
        get: function () {
            var _u = __read(__classPrivateFieldGet(this, _InkDrawOutline_bbox, "f"), 4), width = _u[2], height = _u[3];
            var a = 0, b = 0, c = 0, d = 0, e = 0, f = 0;
            switch (__classPrivateFieldGet(this, _InkDrawOutline_currentRotation, "f")) {
                case 90:
                    b = height / width;
                    c = -width / height;
                    e = width;
                    break;
                case 180:
                    a = -1;
                    d = -1;
                    e = width;
                    f = height;
                    break;
                case 270:
                    b = -height / width;
                    c = width / height;
                    f = height;
                    break;
                default:
                    return "";
            }
            return "matrix(".concat(a, " ").concat(b, " ").concat(c, " ").concat(d, " ").concat(Outline.svgRound(e), " ").concat(Outline.svgRound(f), ")");
        },
        enumerable: false,
        configurable: true
    });
    InkDrawOutline.prototype.getPathResizingSVGProperties = function (_u) {
        var _v = __read(_u, 4), newX = _v[0], newY = _v[1], newWidth = _v[2], newHeight = _v[3];
        var _w = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this), 2), marginX = _w[0], marginY = _w[1];
        var _z = __read(__classPrivateFieldGet(this, _InkDrawOutline_bbox, "f"), 4), x = _z[0], y = _z[1], width = _z[2], height = _z[3];
        if (Math.abs(width - marginX) <= Outline.PRECISION || Math.abs(height - marginY) <= Outline.PRECISION) {
            var tx = newX + newWidth / 2 - (x + width / 2);
            var ty = newY + newHeight / 2 - (y + height / 2);
            return {
                path: {
                    "transform-origin": "".concat(Outline.svgRound(newX), " ").concat(Outline.svgRound(newY)),
                    transform: "".concat(this.rotationTransform, " translate(").concat(tx, " ").concat(ty, ")")
                }
            };
        }
        var s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        var s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        var s2x = width / newWidth;
        var s2y = height / newHeight;
        return {
            path: {
                "transform-origin": "".concat(Outline.svgRound(x), " ").concat(Outline.svgRound(y)),
                transform: "".concat(this.rotationTransform, " scale(").concat(s2x, " ").concat(s2y, ") ") + "translate(".concat(Outline.svgRound(marginX), " ").concat(Outline.svgRound(marginY), ") scale(").concat(s1x, " ").concat(s1y, ") ") + "translate(".concat(Outline.svgRound(-marginX), " ").concat(Outline.svgRound(-marginY), ")")
            }
        };
    };
    InkDrawOutline.prototype.getPathResizedSVGProperties = function (_u) {
        var e_188, _v, e_189, _w;
        var _z = __read(_u, 4), newX = _z[0], newY = _z[1], newWidth = _z[2], newHeight = _z[3];
        var _0 = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this), 2), marginX = _0[0], marginY = _0[1];
        var bbox = __classPrivateFieldGet(this, _InkDrawOutline_bbox, "f");
        var _1 = __read(bbox, 4), x = _1[0], y = _1[1], width = _1[2], height = _1[3];
        bbox[0] = newX;
        bbox[1] = newY;
        bbox[2] = newWidth;
        bbox[3] = newHeight;
        if (Math.abs(width - marginX) <= Outline.PRECISION || Math.abs(height - marginY) <= Outline.PRECISION) {
            var tx_1 = newX + newWidth / 2 - (x + width / 2);
            var ty_1 = newY + newHeight / 2 - (y + height / 2);
            try {
                for (var _2 = __values(__classPrivateFieldGet(this, _InkDrawOutline_lines, "f")), _3 = _2.next(); !_3.done; _3 = _2.next()) {
                    var _4 = _3.value, line = _4.line, points = _4.points;
                    Outline._translate(line, tx_1, ty_1, line);
                    Outline._translate(points, tx_1, ty_1, points);
                }
            }
            catch (e_188_1) { e_188 = { error: e_188_1 }; }
            finally {
                try {
                    if (_3 && !_3.done && (_v = _2.return)) _v.call(_2);
                }
                finally { if (e_188) throw e_188.error; }
            }
            return {
                root: {
                    viewBox: this.viewBox
                },
                path: {
                    "transform-origin": "".concat(Outline.svgRound(newX), " ").concat(Outline.svgRound(newY)),
                    transform: this.rotationTransform || null,
                    d: this.toSVGPath()
                }
            };
        }
        var s1x = (newWidth - 2 * marginX) / (width - 2 * marginX);
        var s1y = (newHeight - 2 * marginY) / (height - 2 * marginY);
        var tx = -s1x * (x + marginX) + newX + marginX;
        var ty = -s1y * (y + marginY) + newY + marginY;
        if (s1x !== 1 || s1y !== 1 || tx !== 0 || ty !== 0) {
            try {
                for (var _5 = __values(__classPrivateFieldGet(this, _InkDrawOutline_lines, "f")), _6 = _5.next(); !_6.done; _6 = _5.next()) {
                    var _7 = _6.value, line = _7.line, points = _7.points;
                    Outline._rescale(line, tx, ty, s1x, s1y, line);
                    Outline._rescale(points, tx, ty, s1x, s1y, points);
                }
            }
            catch (e_189_1) { e_189 = { error: e_189_1 }; }
            finally {
                try {
                    if (_6 && !_6.done && (_w = _5.return)) _w.call(_5);
                }
                finally { if (e_189) throw e_189.error; }
            }
        }
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                "transform-origin": "".concat(Outline.svgRound(newX), " ").concat(Outline.svgRound(newY)),
                transform: this.rotationTransform || null,
                d: this.toSVGPath()
            }
        };
    };
    InkDrawOutline.prototype.getPathTranslatedSVGProperties = function (_u, parentDimensions) {
        var e_190, _v, e_191, _w;
        var _z = __read(_u, 2), newX = _z[0], newY = _z[1];
        var _0 = __read(parentDimensions, 2), newParentWidth = _0[0], newParentHeight = _0[1];
        var bbox = __classPrivateFieldGet(this, _InkDrawOutline_bbox, "f");
        var tx = newX - bbox[0];
        var ty = newY - bbox[1];
        if (__classPrivateFieldGet(this, _InkDrawOutline_parentWidth, "f") === newParentWidth && __classPrivateFieldGet(this, _InkDrawOutline_parentHeight, "f") === newParentHeight) {
            try {
                for (var _1 = __values(__classPrivateFieldGet(this, _InkDrawOutline_lines, "f")), _2 = _1.next(); !_2.done; _2 = _1.next()) {
                    var _3 = _2.value, line = _3.line, points = _3.points;
                    Outline._translate(line, tx, ty, line);
                    Outline._translate(points, tx, ty, points);
                }
            }
            catch (e_190_1) { e_190 = { error: e_190_1 }; }
            finally {
                try {
                    if (_2 && !_2.done && (_v = _1.return)) _v.call(_1);
                }
                finally { if (e_190) throw e_190.error; }
            }
        }
        else {
            var sx = __classPrivateFieldGet(this, _InkDrawOutline_parentWidth, "f") / newParentWidth;
            var sy = __classPrivateFieldGet(this, _InkDrawOutline_parentHeight, "f") / newParentHeight;
            __classPrivateFieldSet(this, _InkDrawOutline_parentWidth, newParentWidth, "f");
            __classPrivateFieldSet(this, _InkDrawOutline_parentHeight, newParentHeight, "f");
            try {
                for (var _4 = __values(__classPrivateFieldGet(this, _InkDrawOutline_lines, "f")), _5 = _4.next(); !_5.done; _5 = _4.next()) {
                    var _6 = _5.value, line = _6.line, points = _6.points;
                    Outline._rescale(line, tx, ty, sx, sy, line);
                    Outline._rescale(points, tx, ty, sx, sy, points);
                }
            }
            catch (e_191_1) { e_191 = { error: e_191_1 }; }
            finally {
                try {
                    if (_5 && !_5.done && (_w = _4.return)) _w.call(_4);
                }
                finally { if (e_191) throw e_191.error; }
            }
            bbox[2] *= sx;
            bbox[3] *= sy;
        }
        bbox[0] = newX;
        bbox[1] = newY;
        return {
            root: {
                viewBox: this.viewBox
            },
            path: {
                d: this.toSVGPath(),
                "transform-origin": "".concat(Outline.svgRound(newX), " ").concat(Outline.svgRound(newY))
            }
        };
    };
    Object.defineProperty(InkDrawOutline.prototype, "defaultSVGProperties", {
        get: function () {
            var bbox = __classPrivateFieldGet(this, _InkDrawOutline_bbox, "f");
            return {
                root: {
                    viewBox: this.viewBox
                },
                rootClass: {
                    draw: true
                },
                path: {
                    d: this.toSVGPath(),
                    "transform-origin": "".concat(Outline.svgRound(bbox[0]), " ").concat(Outline.svgRound(bbox[1])),
                    transform: this.rotationTransform || null
                },
                bbox: bbox
            };
        },
        enumerable: false,
        configurable: true
    });
    return InkDrawOutline;
}(Outline));
_InkDrawOutline_bbox = new WeakMap(), _InkDrawOutline_currentRotation = new WeakMap(), _InkDrawOutline_innerMargin = new WeakMap(), _InkDrawOutline_lines = new WeakMap(), _InkDrawOutline_parentWidth = new WeakMap(), _InkDrawOutline_parentHeight = new WeakMap(), _InkDrawOutline_parentScale = new WeakMap(), _InkDrawOutline_rotation = new WeakMap(), _InkDrawOutline_thickness = new WeakMap(), _InkDrawOutline_instances = new WeakSet(), _InkDrawOutline_getMarginComponents = function _InkDrawOutline_getMarginComponents(thickness) {
    if (thickness === void 0) { thickness = __classPrivateFieldGet(this, _InkDrawOutline_thickness, "f"); }
    var margin = __classPrivateFieldGet(this, _InkDrawOutline_innerMargin, "f") + thickness / 2 * __classPrivateFieldGet(this, _InkDrawOutline_parentScale, "f");
    return __classPrivateFieldGet(this, _InkDrawOutline_rotation, "f") % 180 === 0 ? [margin / __classPrivateFieldGet(this, _InkDrawOutline_parentWidth, "f"), margin / __classPrivateFieldGet(this, _InkDrawOutline_parentHeight, "f")] : [margin / __classPrivateFieldGet(this, _InkDrawOutline_parentHeight, "f"), margin / __classPrivateFieldGet(this, _InkDrawOutline_parentWidth, "f")];
}, _InkDrawOutline_getBBoxWithNoMargin = function _InkDrawOutline_getBBoxWithNoMargin() {
    var _u = __read(__classPrivateFieldGet(this, _InkDrawOutline_bbox, "f"), 4), x = _u[0], y = _u[1], width = _u[2], height = _u[3];
    var _v = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this, 0), 2), marginX = _v[0], marginY = _v[1];
    return [x + marginX, y + marginY, width - 2 * marginX, height - 2 * marginY];
}, _InkDrawOutline_computeBbox = function _InkDrawOutline_computeBbox() {
    var e_192, _u;
    var bbox = __classPrivateFieldSet(this, _InkDrawOutline_bbox, new Float32Array([Infinity, Infinity, -Infinity, -Infinity]), "f");
    try {
        for (var _v = __values(__classPrivateFieldGet(this, _InkDrawOutline_lines, "f")), _w = _v.next(); !_w.done; _w = _v.next()) {
            var line = _w.value.line;
            if (line.length <= 12) {
                for (var i = 4, ii = line.length; i < ii; i += 6) {
                    Util.pointBoundingBox(line[i], line[i + 1], bbox);
                }
                continue;
            }
            var lastX = line[4], lastY = line[5];
            for (var i = 6, ii = line.length; i < ii; i += 6) {
                var _z = __read(line.subarray(i, i + 6), 6), c1x = _z[0], c1y = _z[1], c2x = _z[2], c2y = _z[3], x = _z[4], y = _z[5];
                Util.bezierBoundingBox(lastX, lastY, c1x, c1y, c2x, c2y, x, y, bbox);
                lastX = x;
                lastY = y;
            }
        }
    }
    catch (e_192_1) { e_192 = { error: e_192_1 }; }
    finally {
        try {
            if (_w && !_w.done && (_u = _v.return)) _u.call(_v);
        }
        finally { if (e_192) throw e_192.error; }
    }
    var _0 = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this), 2), marginX = _0[0], marginY = _0[1];
    bbox[0] = MathClamp(bbox[0] - marginX, 0, 1);
    bbox[1] = MathClamp(bbox[1] - marginY, 0, 1);
    bbox[2] = MathClamp(bbox[2] + marginX, 0, 1);
    bbox[3] = MathClamp(bbox[3] + marginY, 0, 1);
    bbox[2] -= bbox[0];
    bbox[3] -= bbox[1];
}, _InkDrawOutline_updateThickness = function _InkDrawOutline_updateThickness(thickness) {
    var _u = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this), 2), oldMarginX = _u[0], oldMarginY = _u[1];
    __classPrivateFieldSet(this, _InkDrawOutline_thickness, thickness, "f");
    var _v = __read(__classPrivateFieldGet(this, _InkDrawOutline_instances, "m", _InkDrawOutline_getMarginComponents).call(this), 2), newMarginX = _v[0], newMarginY = _v[1];
    var _w = __read([newMarginX - oldMarginX, newMarginY - oldMarginY], 2), diffMarginX = _w[0], diffMarginY = _w[1];
    var bbox = __classPrivateFieldGet(this, _InkDrawOutline_bbox, "f");
    bbox[0] -= diffMarginX;
    bbox[1] -= diffMarginY;
    bbox[2] += 2 * diffMarginX;
    bbox[3] += 2 * diffMarginY;
    return bbox;
};
; // ./src/display/editor/ink.js
var InkDrawingOptions = /** @class */ (function (_super) {
    __extends(InkDrawingOptions, _super);
    function InkDrawingOptions(viewerParameters) {
        var _this = _super.call(this) || this;
        _this._viewParameters = viewerParameters;
        _super.prototype.updateProperties.call(_this, {
            fill: "none",
            stroke: AnnotationEditor._defaultLineColor,
            "stroke-opacity": 1,
            "stroke-width": 1,
            "stroke-linecap": "round",
            "stroke-linejoin": "round",
            "stroke-miterlimit": 10
        });
        return _this;
    }
    InkDrawingOptions.prototype.updateSVGProperty = function (name, value) {
        if (name === "stroke-width") {
            value !== null && value !== void 0 ? value : (value = this["stroke-width"]);
            value *= this._viewParameters.realScale;
        }
        _super.prototype.updateSVGProperty.call(this, name, value);
    };
    InkDrawingOptions.prototype.clone = function () {
        var clone = new InkDrawingOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    };
    return InkDrawingOptions;
}(DrawingOptions));
var InkEditor = /** @class */ (function (_super) {
    __extends(InkEditor, _super);
    function InkEditor(params) {
        var _this = _super.call(this, __assign(__assign({}, params), { name: "inkEditor" })) || this;
        _InkEditor_instances.add(_this);
        _this._willKeepAspectRatio = true;
        _this.defaultL10nId = "pdfjs-editor-ink-editor";
        return _this;
    }
    InkEditor.initialize = function (l10n, uiManager) {
        AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new InkDrawingOptions(uiManager.viewParameters);
    };
    InkEditor.getDefaultDrawingOptions = function (options) {
        var clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    };
    Object.defineProperty(InkEditor, "supportMultipleDrawings", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(InkEditor, "typesMap", {
        get: function () {
            return shadow(this, "typesMap", new Map([[AnnotationEditorParamsType.INK_THICKNESS, "stroke-width"], [AnnotationEditorParamsType.INK_COLOR, "stroke"], [AnnotationEditorParamsType.INK_OPACITY, "stroke-opacity"]]));
        },
        enumerable: false,
        configurable: true
    });
    InkEditor.createDrawerInstance = function (x, y, parentWidth, parentHeight, rotation) {
        return new InkDrawOutliner(x, y, parentWidth, parentHeight, rotation, this._defaultDrawingOptions["stroke-width"]);
    };
    InkEditor.deserializeDraw = function (pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        return InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    };
    InkEditor.deserialize = function (data, parent, uiManager) {
        return __awaiter(this, void 0, void 0, function () {
            var initialData, _u, inkLists, rect, rotation, id, color, opacity, thickness, popupRef, pageNumber, editor;
            return __generator(this, function (_v) {
                switch (_v.label) {
                    case 0:
                        initialData = null;
                        if (data instanceof InkAnnotationElement) {
                            _u = data.data, inkLists = _u.inkLists, rect = _u.rect, rotation = _u.rotation, id = _u.id, color = _u.color, opacity = _u.opacity, thickness = _u.borderStyle.rawWidth, popupRef = _u.popupRef, pageNumber = data.parent.page.pageNumber;
                            initialData = data = {
                                annotationType: AnnotationEditorType.INK,
                                color: Array.from(color),
                                thickness: thickness,
                                opacity: opacity,
                                paths: {
                                    points: inkLists
                                },
                                boxes: null,
                                pageIndex: pageNumber - 1,
                                rect: rect.slice(0),
                                rotation: rotation,
                                id: id,
                                deleted: false,
                                popupRef: popupRef
                            };
                        }
                        return [4 /*yield*/, _super.deserialize.call(this, data, parent, uiManager)];
                    case 1:
                        editor = _v.sent();
                        editor.annotationElementId = data.id || null;
                        editor._initialData = initialData;
                        return [2 /*return*/, editor];
                }
            });
        });
    };
    InkEditor.prototype.onScaleChanging = function () {
        if (!this.parent) {
            return;
        }
        _super.prototype.onScaleChanging.call(this);
        var _u = this, _drawId = _u._drawId, _drawingOptions = _u._drawingOptions, parent = _u.parent;
        _drawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(_drawId, _drawingOptions.toSVGProperties());
    };
    InkEditor.onScaleChangingWhenDrawing = function () {
        var parent = this._currentParent;
        if (!parent) {
            return;
        }
        _super.onScaleChangingWhenDrawing.call(this);
        this._defaultDrawingOptions.updateSVGProperty("stroke-width");
        parent.drawLayer.updateProperties(this._currentDrawId, this._defaultDrawingOptions.toSVGProperties());
    };
    InkEditor.prototype.createDrawingOptions = function (_u) {
        var color = _u.color, thickness = _u.thickness, opacity = _u.opacity;
        this._drawingOptions = InkEditor.getDefaultDrawingOptions({
            stroke: Util.makeHexColor.apply(Util, __spreadArray([], __read(color), false)),
            "stroke-width": thickness,
            "stroke-opacity": opacity
        });
    };
    InkEditor.prototype.serialize = function (isForCopying) {
        if (isForCopying === void 0) { isForCopying = false; }
        if (this.isEmpty()) {
            return null;
        }
        if (this.deleted) {
            return this.serializeDeleted();
        }
        var _u = this.serializeDraw(isForCopying), lines = _u.lines, points = _u.points, rect = _u.rect;
        var _v = this._drawingOptions, stroke = _v.stroke, opacity = _v["stroke-opacity"], thickness = _v["stroke-width"];
        var serialized = {
            annotationType: AnnotationEditorType.INK,
            color: AnnotationEditor._colorManager.convert(stroke),
            opacity: opacity,
            thickness: thickness,
            paths: {
                lines: lines,
                points: points
            },
            pageIndex: this.pageIndex,
            rect: rect,
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId
        };
        if (isForCopying) {
            serialized.isCopy = true;
            return serialized;
        }
        if (this.annotationElementId && !__classPrivateFieldGet(this, _InkEditor_instances, "m", _InkEditor_hasElementChanged).call(this, serialized)) {
            return null;
        }
        serialized.id = this.annotationElementId;
        return serialized;
    };
    InkEditor.prototype.renderAnnotationElement = function (annotation) {
        var _u = this.serializeDraw(false), points = _u.points, rect = _u.rect;
        annotation.updateEdited({
            rect: rect,
            thickness: this._drawingOptions["stroke-width"],
            points: points
        });
        return null;
    };
    var _InkEditor_instances, _InkEditor_hasElementChanged;
    _InkEditor_instances = new WeakSet(), _InkEditor_hasElementChanged = function _InkEditor_hasElementChanged(serialized) {
        var _u = this._initialData, color = _u.color, thickness = _u.thickness, opacity = _u.opacity, pageIndex = _u.pageIndex;
        return this._hasBeenMoved || this._hasBeenResized || serialized.color.some(function (c, i) { return c !== color[i]; }) || serialized.thickness !== thickness || serialized.opacity !== opacity || serialized.pageIndex !== pageIndex;
    };
    InkEditor._type = "ink";
    InkEditor._editorType = AnnotationEditorType.INK;
    InkEditor._defaultDrawingOptions = null;
    return InkEditor;
}(DrawingEditor));
; // ./src/display/editor/drawers/contour.js
var ContourDrawOutline = /** @class */ (function (_super) {
    __extends(ContourDrawOutline, _super);
    function ContourDrawOutline() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    ContourDrawOutline.prototype.toSVGPath = function () {
        var path = _super.prototype.toSVGPath.call(this);
        if (!path.endsWith("Z")) {
            path += "Z";
        }
        return path;
    };
    return ContourDrawOutline;
}(InkDrawOutline));
; // ./src/display/editor/drawers/signaturedraw.js
var BASE_HEADER_LENGTH = 8;
var POINTS_PROPERTIES_NUMBER = 3;
var SignatureExtractor = /** @class */ (function () {
    function SignatureExtractor() {
    }
    SignatureExtractor.extractContoursFromText = function (text, _v, pageWidth, pageHeight, rotation, innerMargin) {
        var fontFamily = _v.fontFamily, fontStyle = _v.fontStyle, fontWeight = _v.fontWeight;
        var canvas = new OffscreenCanvas(1, 1);
        var ctx = canvas.getContext("2d", {
            alpha: false
        });
        var fontSize = 200;
        var font = ctx.font = "".concat(fontStyle, " ").concat(fontWeight, " ").concat(fontSize, "px ").concat(fontFamily);
        var _w = ctx.measureText(text), actualBoundingBoxLeft = _w.actualBoundingBoxLeft, actualBoundingBoxRight = _w.actualBoundingBoxRight, actualBoundingBoxAscent = _w.actualBoundingBoxAscent, actualBoundingBoxDescent = _w.actualBoundingBoxDescent, fontBoundingBoxAscent = _w.fontBoundingBoxAscent, fontBoundingBoxDescent = _w.fontBoundingBoxDescent, width = _w.width;
        var SCALE = 1.5;
        var canvasWidth = Math.ceil(Math.max(Math.abs(actualBoundingBoxLeft) + Math.abs(actualBoundingBoxRight) || 0, width) * SCALE);
        var canvasHeight = Math.ceil(Math.max(Math.abs(actualBoundingBoxAscent) + Math.abs(actualBoundingBoxDescent) || fontSize, Math.abs(fontBoundingBoxAscent) + Math.abs(fontBoundingBoxDescent) || fontSize) * SCALE);
        canvas = new OffscreenCanvas(canvasWidth, canvasHeight);
        ctx = canvas.getContext("2d", {
            alpha: true,
            willReadFrequently: true
        });
        ctx.font = font;
        ctx.filter = "grayscale(1)";
        ctx.fillStyle = "white";
        ctx.fillRect(0, 0, canvasWidth, canvasHeight);
        ctx.fillStyle = "black";
        ctx.fillText(text, canvasWidth * (SCALE - 1) / 2, canvasHeight * (3 - SCALE) / 2);
        var uint8Buf = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_toUint8).call(this, ctx.getImageData(0, 0, canvasWidth, canvasHeight).data);
        var histogram = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_getHistogram).call(this, uint8Buf);
        var threshold = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_guessThreshold).call(this, histogram);
        var contourList = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_findContours).call(this, uint8Buf, canvasWidth, canvasHeight, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: canvasWidth,
                height: canvasHeight
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    };
    SignatureExtractor.process = function (bitmap, pageWidth, pageHeight, rotation, innerMargin) {
        var _v = __read(__classPrivateFieldGet(this, _u, "m", _SignatureExtractor_getGrayPixels).call(this, bitmap), 3), uint8Buf = _v[0], width = _v[1], height = _v[2];
        var _w = __read(__classPrivateFieldGet(this, _u, "m", _SignatureExtractor_bilateralFilter).call(this, uint8Buf, width, height, Math.hypot(width, height) * __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_PARAMETERS).sigmaSFactor, __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_PARAMETERS).sigmaR, __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_PARAMETERS).kernelSize), 2), buffer = _w[0], histogram = _w[1];
        var threshold = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_guessThreshold).call(this, histogram);
        var contourList = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_findContours).call(this, buffer, width, height, threshold);
        return this.processDrawnLines({
            lines: {
                curves: contourList,
                width: width,
                height: height
            },
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: innerMargin,
            mustSmooth: true,
            areContours: true
        });
    };
    SignatureExtractor.processDrawnLines = function (_v) {
        var _w, e_193, _z, _0;
        var _1;
        var lines = _v.lines, pageWidth = _v.pageWidth, pageHeight = _v.pageHeight, rotation = _v.rotation, innerMargin = _v.innerMargin, mustSmooth = _v.mustSmooth, areContours = _v.areContours;
        if (rotation % 180 !== 0) {
            _w = __read([pageHeight, pageWidth], 2), pageWidth = _w[0], pageHeight = _w[1];
        }
        var curves = lines.curves, width = lines.width, height = lines.height;
        var thickness = (_1 = lines.thickness) !== null && _1 !== void 0 ? _1 : 0;
        var linesAndPoints = [];
        var ratio = Math.min(pageWidth / width, pageHeight / height);
        var xScale = ratio / pageWidth;
        var yScale = ratio / pageHeight;
        var newCurves = [];
        try {
            for (var curves_1 = __values(curves), curves_1_1 = curves_1.next(); !curves_1_1.done; curves_1_1 = curves_1.next()) {
                var points = curves_1_1.value.points;
                var reducedPoints = mustSmooth ? __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_douglasPeucker).call(this, points) : points;
                if (!reducedPoints) {
                    continue;
                }
                newCurves.push(reducedPoints);
                var len = reducedPoints.length;
                var newPoints = new Float32Array(len);
                var line = new Float32Array(3 * (len === 2 ? 2 : len - 2));
                linesAndPoints.push({
                    line: line,
                    points: newPoints
                });
                if (len === 2) {
                    newPoints[0] = reducedPoints[0] * xScale;
                    newPoints[1] = reducedPoints[1] * yScale;
                    line.set([NaN, NaN, NaN, NaN, newPoints[0], newPoints[1]], 0);
                    continue;
                }
                var _2 = __read(reducedPoints, 4), x1 = _2[0], y1 = _2[1], x2 = _2[2], y2 = _2[3];
                x1 *= xScale;
                y1 *= yScale;
                x2 *= xScale;
                y2 *= yScale;
                newPoints.set([x1, y1, x2, y2], 0);
                line.set([NaN, NaN, NaN, NaN, x1, y1], 0);
                for (var i = 4; i < len; i += 2) {
                    var x = newPoints[i] = reducedPoints[i] * xScale;
                    var y = newPoints[i + 1] = reducedPoints[i + 1] * yScale;
                    line.set(Outline.createBezierPoints(x1, y1, x2, y2, x, y), (i - 2) * 3);
                    _0 = __read([x2, y2, x, y], 4), x1 = _0[0], y1 = _0[1], x2 = _0[2], y2 = _0[3];
                }
            }
        }
        catch (e_193_1) { e_193 = { error: e_193_1 }; }
        finally {
            try {
                if (curves_1_1 && !curves_1_1.done && (_z = curves_1.return)) _z.call(curves_1);
            }
            finally { if (e_193) throw e_193.error; }
        }
        if (linesAndPoints.length === 0) {
            return null;
        }
        var outline = areContours ? new ContourDrawOutline() : new InkDrawOutline();
        outline.build(linesAndPoints, pageWidth, pageHeight, 1, rotation, areContours ? 0 : thickness, innerMargin);
        return {
            outline: outline,
            newCurves: newCurves,
            areContours: areContours,
            thickness: thickness,
            width: width,
            height: height
        };
    };
    SignatureExtractor.compressSignature = function (_v) {
        return __awaiter(this, arguments, void 0, function (_w) {
            var minDiff, maxDiff, outlinesLength, outlines_1, outlines_1_1, points, i, ii, dx, bufferType, len, headerLength, header, offset, outlines_2, outlines_2_1, points, cs, writer, BufferCtor, outlines_3, outlines_3_1, points, diffs, i, ii, buf, bytes;
            var e_194, _z, e_195, _0, e_196, _1;
            var outlines = _w.outlines, areContours = _w.areContours, thickness = _w.thickness, width = _w.width, height = _w.height;
            return __generator(this, function (_2) {
                switch (_2.label) {
                    case 0:
                        minDiff = Infinity;
                        maxDiff = -Infinity;
                        outlinesLength = 0;
                        try {
                            for (outlines_1 = __values(outlines), outlines_1_1 = outlines_1.next(); !outlines_1_1.done; outlines_1_1 = outlines_1.next()) {
                                points = outlines_1_1.value;
                                outlinesLength += points.length;
                                for (i = 2, ii = points.length; i < ii; i++) {
                                    dx = points[i] - points[i - 2];
                                    minDiff = Math.min(minDiff, dx);
                                    maxDiff = Math.max(maxDiff, dx);
                                }
                            }
                        }
                        catch (e_194_1) { e_194 = { error: e_194_1 }; }
                        finally {
                            try {
                                if (outlines_1_1 && !outlines_1_1.done && (_z = outlines_1.return)) _z.call(outlines_1);
                            }
                            finally { if (e_194) throw e_194.error; }
                        }
                        if (minDiff >= -128 && maxDiff <= 127) {
                            bufferType = Int8Array;
                        }
                        else if (minDiff >= -32768 && maxDiff <= 32767) {
                            bufferType = Int16Array;
                        }
                        else {
                            bufferType = Int32Array;
                        }
                        len = outlines.length;
                        headerLength = BASE_HEADER_LENGTH + POINTS_PROPERTIES_NUMBER * len;
                        header = new Uint32Array(headerLength);
                        offset = 0;
                        header[offset++] = headerLength * Uint32Array.BYTES_PER_ELEMENT + (outlinesLength - 2 * len) * bufferType.BYTES_PER_ELEMENT;
                        header[offset++] = 0;
                        header[offset++] = width;
                        header[offset++] = height;
                        header[offset++] = areContours ? 0 : 1;
                        header[offset++] = Math.max(0, Math.floor(thickness !== null && thickness !== void 0 ? thickness : 0));
                        header[offset++] = len;
                        header[offset++] = bufferType.BYTES_PER_ELEMENT;
                        try {
                            for (outlines_2 = __values(outlines), outlines_2_1 = outlines_2.next(); !outlines_2_1.done; outlines_2_1 = outlines_2.next()) {
                                points = outlines_2_1.value;
                                header[offset++] = points.length - 2;
                                header[offset++] = points[0];
                                header[offset++] = points[1];
                            }
                        }
                        catch (e_195_1) { e_195 = { error: e_195_1 }; }
                        finally {
                            try {
                                if (outlines_2_1 && !outlines_2_1.done && (_0 = outlines_2.return)) _0.call(outlines_2);
                            }
                            finally { if (e_195) throw e_195.error; }
                        }
                        cs = new CompressionStream("deflate-raw");
                        writer = cs.writable.getWriter();
                        return [4 /*yield*/, writer.ready];
                    case 1:
                        _2.sent();
                        writer.write(header);
                        BufferCtor = bufferType.prototype.constructor;
                        try {
                            for (outlines_3 = __values(outlines), outlines_3_1 = outlines_3.next(); !outlines_3_1.done; outlines_3_1 = outlines_3.next()) {
                                points = outlines_3_1.value;
                                diffs = new BufferCtor(points.length - 2);
                                for (i = 2, ii = points.length; i < ii; i++) {
                                    diffs[i - 2] = points[i] - points[i - 2];
                                }
                                writer.write(diffs);
                            }
                        }
                        catch (e_196_1) { e_196 = { error: e_196_1 }; }
                        finally {
                            try {
                                if (outlines_3_1 && !outlines_3_1.done && (_1 = outlines_3.return)) _1.call(outlines_3);
                            }
                            finally { if (e_196) throw e_196.error; }
                        }
                        writer.close();
                        return [4 /*yield*/, new Response(cs.readable).arrayBuffer()];
                    case 2:
                        buf = _2.sent();
                        bytes = new Uint8Array(buf);
                        return [2 /*return*/, toBase64Util(bytes)];
                }
            });
        });
    };
    SignatureExtractor.decompressSignature = function (signatureData) {
        return __awaiter(this, void 0, void 0, function () {
            var bytes, _v, readable, writable, writer_1, data, offset, _w, readable_1, readable_1_1, chunk, e_197_1, header, version_1, width, height, areContours, thickness, numberOfDrawings, bufferType, outlines, diffsOffset, diffs, i, len, points, j, j, e_198;
            var _this = this;
            var _z, e_197, _0, _1;
            return __generator(this, function (_2) {
                switch (_2.label) {
                    case 0:
                        _2.trys.push([0, 14, , 15]);
                        bytes = fromBase64Util(signatureData);
                        _v = new DecompressionStream("deflate-raw"), readable = _v.readable, writable = _v.writable;
                        writer_1 = writable.getWriter();
                        return [4 /*yield*/, writer_1.ready];
                    case 1:
                        _2.sent();
                        writer_1.write(bytes).then(function () { return __awaiter(_this, void 0, void 0, function () {
                            return __generator(this, function (_v) {
                                switch (_v.label) {
                                    case 0: return [4 /*yield*/, writer_1.ready];
                                    case 1:
                                        _v.sent();
                                        return [4 /*yield*/, writer_1.close()];
                                    case 2:
                                        _v.sent();
                                        return [2 /*return*/];
                                }
                            });
                        }); }).catch(function () { });
                        data = null;
                        offset = 0;
                        _2.label = 2;
                    case 2:
                        _2.trys.push([2, 7, 8, 13]);
                        _w = true, readable_1 = __asyncValues(readable);
                        _2.label = 3;
                    case 3: return [4 /*yield*/, readable_1.next()];
                    case 4:
                        if (!(readable_1_1 = _2.sent(), _z = readable_1_1.done, !_z)) return [3 /*break*/, 6];
                        _1 = readable_1_1.value;
                        _w = false;
                        chunk = _1;
                        data || (data = new Uint8Array(new Uint32Array(chunk.buffer, 0, 4)[0]));
                        data.set(chunk, offset);
                        offset += chunk.length;
                        _2.label = 5;
                    case 5:
                        _w = true;
                        return [3 /*break*/, 3];
                    case 6: return [3 /*break*/, 13];
                    case 7:
                        e_197_1 = _2.sent();
                        e_197 = { error: e_197_1 };
                        return [3 /*break*/, 13];
                    case 8:
                        _2.trys.push([8, , 11, 12]);
                        if (!(!_w && !_z && (_0 = readable_1.return))) return [3 /*break*/, 10];
                        return [4 /*yield*/, _0.call(readable_1)];
                    case 9:
                        _2.sent();
                        _2.label = 10;
                    case 10: return [3 /*break*/, 12];
                    case 11:
                        if (e_197) throw e_197.error;
                        return [7 /*endfinally*/];
                    case 12: return [7 /*endfinally*/];
                    case 13:
                        header = new Uint32Array(data.buffer, 0, data.length >> 2);
                        version_1 = header[1];
                        if (version_1 !== 0) {
                            throw new Error("Invalid version: ".concat(version_1));
                        }
                        width = header[2];
                        height = header[3];
                        areContours = header[4] === 0;
                        thickness = header[5];
                        numberOfDrawings = header[6];
                        bufferType = header[7];
                        outlines = [];
                        diffsOffset = (BASE_HEADER_LENGTH + POINTS_PROPERTIES_NUMBER * numberOfDrawings) * Uint32Array.BYTES_PER_ELEMENT;
                        diffs = void 0;
                        switch (bufferType) {
                            case Int8Array.BYTES_PER_ELEMENT:
                                diffs = new Int8Array(data.buffer, diffsOffset);
                                break;
                            case Int16Array.BYTES_PER_ELEMENT:
                                diffs = new Int16Array(data.buffer, diffsOffset);
                                break;
                            case Int32Array.BYTES_PER_ELEMENT:
                                diffs = new Int32Array(data.buffer, diffsOffset);
                                break;
                        }
                        offset = 0;
                        for (i = 0; i < numberOfDrawings; i++) {
                            len = header[POINTS_PROPERTIES_NUMBER * i + BASE_HEADER_LENGTH];
                            points = new Float32Array(len + 2);
                            outlines.push(points);
                            for (j = 0; j < POINTS_PROPERTIES_NUMBER - 1; j++) {
                                points[j] = header[POINTS_PROPERTIES_NUMBER * i + BASE_HEADER_LENGTH + j + 1];
                            }
                            for (j = 0; j < len; j++) {
                                points[j + 2] = points[j] + diffs[offset++];
                            }
                        }
                        return [2 /*return*/, {
                                areContours: areContours,
                                thickness: thickness,
                                outlines: outlines,
                                width: width,
                                height: height
                            }];
                    case 14:
                        e_198 = _2.sent();
                        warn("decompressSignature: ".concat(e_198));
                        return [2 /*return*/, null];
                    case 15: return [2 /*return*/];
                }
            });
        });
    };
    var _u, _SignatureExtractor_PARAMETERS, _SignatureExtractor_neighborIndexToId, _SignatureExtractor_neighborIdToIndex, _SignatureExtractor_clockwiseNonZero, _SignatureExtractor_counterClockwiseNonZero, _SignatureExtractor_findContours, _SignatureExtractor_douglasPeuckerHelper, _SignatureExtractor_douglasPeucker, _SignatureExtractor_bilateralFilter, _SignatureExtractor_getHistogram, _SignatureExtractor_toUint8, _SignatureExtractor_guessThreshold, _SignatureExtractor_getGrayPixels;
    _u = SignatureExtractor, _SignatureExtractor_neighborIndexToId = function _SignatureExtractor_neighborIndexToId(i0, j0, i, j) {
        i -= i0;
        j -= j0;
        if (i === 0) {
            return j > 0 ? 0 : 4;
        }
        if (i === 1) {
            return j + 6;
        }
        return 2 - j;
    }, _SignatureExtractor_clockwiseNonZero = function _SignatureExtractor_clockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        var id = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_neighborIndexToId).call(this, i0, j0, i, j);
        for (var k = 0; k < 8; k++) {
            var kk = (-k + id - offset + 16) % 8;
            var shiftI = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * kk];
            var shiftJ = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) {
                return kk;
            }
        }
        return -1;
    }, _SignatureExtractor_counterClockwiseNonZero = function _SignatureExtractor_counterClockwiseNonZero(buf, width, i0, j0, i, j, offset) {
        var id = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_neighborIndexToId).call(this, i0, j0, i, j);
        for (var k = 0; k < 8; k++) {
            var kk = (k + id + offset + 16) % 8;
            var shiftI = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * kk];
            var shiftJ = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * kk + 1];
            if (buf[(i0 + shiftI) * width + (j0 + shiftJ)] !== 0) {
                return kk;
            }
        }
        return -1;
    }, _SignatureExtractor_findContours = function _SignatureExtractor_findContours(buf, width, height, threshold) {
        var e_199, _v;
        var N = buf.length;
        var types = new Int32Array(N);
        for (var i = 0; i < N; i++) {
            types[i] = buf[i] <= threshold ? 1 : 0;
        }
        for (var i = 1; i < height - 1; i++) {
            types[i * width] = types[i * width + width - 1] = 0;
        }
        for (var i = 0; i < width; i++) {
            types[i] = types[width * height - 1 - i] = 0;
        }
        var nbd = 1;
        var lnbd;
        var contours = [];
        for (var i = 1; i < height - 1; i++) {
            lnbd = 1;
            for (var j = 1; j < width - 1; j++) {
                var ij = i * width + j;
                var pix = types[ij];
                if (pix === 0) {
                    continue;
                }
                var i2 = i;
                var j2 = j;
                if (pix === 1 && types[ij - 1] === 0) {
                    nbd += 1;
                    j2 -= 1;
                }
                else if (pix >= 1 && types[ij + 1] === 0) {
                    nbd += 1;
                    j2 += 1;
                    if (pix > 1) {
                        lnbd = pix;
                    }
                }
                else {
                    if (pix !== 1) {
                        lnbd = Math.abs(pix);
                    }
                    continue;
                }
                var points = [j, i];
                var isHole = j2 === j + 1;
                var contour = {
                    isHole: isHole,
                    points: points,
                    id: nbd,
                    parent: 0
                };
                contours.push(contour);
                var contour0 = void 0;
                try {
                    for (var contours_1 = (e_199 = void 0, __values(contours)), contours_1_1 = contours_1.next(); !contours_1_1.done; contours_1_1 = contours_1.next()) {
                        var c = contours_1_1.value;
                        if (c.id === lnbd) {
                            contour0 = c;
                            break;
                        }
                    }
                }
                catch (e_199_1) { e_199 = { error: e_199_1 }; }
                finally {
                    try {
                        if (contours_1_1 && !contours_1_1.done && (_v = contours_1.return)) _v.call(contours_1);
                    }
                    finally { if (e_199) throw e_199.error; }
                }
                if (!contour0) {
                    contour.parent = isHole ? lnbd : 0;
                }
                else if (contour0.isHole) {
                    contour.parent = isHole ? contour0.parent : lnbd;
                }
                else {
                    contour.parent = isHole ? lnbd : contour0.parent;
                }
                var k = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_clockwiseNonZero).call(this, types, width, i, j, i2, j2, 0);
                if (k === -1) {
                    types[ij] = -nbd;
                    if (types[ij] !== 1) {
                        lnbd = Math.abs(types[ij]);
                    }
                    continue;
                }
                var shiftI = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * k];
                var shiftJ = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * k + 1];
                var i1 = i + shiftI;
                var j1 = j + shiftJ;
                i2 = i1;
                j2 = j1;
                var i3 = i;
                var j3 = j;
                while (true) {
                    var kk = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_counterClockwiseNonZero).call(this, types, width, i3, j3, i2, j2, 1);
                    shiftI = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * kk];
                    shiftJ = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_neighborIdToIndex)[2 * kk + 1];
                    var i4 = i3 + shiftI;
                    var j4 = j3 + shiftJ;
                    points.push(j4, i4);
                    var ij3 = i3 * width + j3;
                    if (types[ij3 + 1] === 0) {
                        types[ij3] = -nbd;
                    }
                    else if (types[ij3] === 1) {
                        types[ij3] = nbd;
                    }
                    if (i4 === i && j4 === j && i3 === i1 && j3 === j1) {
                        if (types[ij] !== 1) {
                            lnbd = Math.abs(types[ij]);
                        }
                        break;
                    }
                    else {
                        i2 = i3;
                        j2 = j3;
                        i3 = i4;
                        j3 = j4;
                    }
                }
            }
        }
        return contours;
    }, _SignatureExtractor_douglasPeuckerHelper = function _SignatureExtractor_douglasPeuckerHelper(points, start, end, output) {
        if (end - start <= 4) {
            for (var i = start; i < end - 2; i += 2) {
                output.push(points[i], points[i + 1]);
            }
            return;
        }
        var ax = points[start];
        var ay = points[start + 1];
        var abx = points[end - 4] - ax;
        var aby = points[end - 3] - ay;
        var dist = Math.hypot(abx, aby);
        var nabx = abx / dist;
        var naby = aby / dist;
        var aa = nabx * ay - naby * ax;
        var m = aby / abx;
        var invS = 1 / dist;
        var phi = Math.atan(m);
        var cosPhi = Math.cos(phi);
        var sinPhi = Math.sin(phi);
        var tmax = invS * (Math.abs(cosPhi) + Math.abs(sinPhi));
        var poly = invS * (1 - tmax + Math.pow(tmax, 2));
        var partialPhi = Math.max(Math.atan(Math.abs(sinPhi + cosPhi) * poly), Math.atan(Math.abs(sinPhi - cosPhi) * poly));
        var dmax = 0;
        var index = start;
        for (var i = start + 2; i < end - 2; i += 2) {
            var d = Math.abs(aa - nabx * points[i + 1] + naby * points[i]);
            if (d > dmax) {
                index = i;
                dmax = d;
            }
        }
        if (dmax > Math.pow((dist * partialPhi), 2)) {
            __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_douglasPeuckerHelper).call(this, points, start, index + 2, output);
            __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_douglasPeuckerHelper).call(this, points, index, end, output);
        }
        else {
            output.push(ax, ay);
        }
    }, _SignatureExtractor_douglasPeucker = function _SignatureExtractor_douglasPeucker(points) {
        var output = [];
        var len = points.length;
        __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_douglasPeuckerHelper).call(this, points, 0, len, output);
        output.push(points[len - 2], points[len - 1]);
        return output.length <= 4 ? null : output;
    }, _SignatureExtractor_bilateralFilter = function _SignatureExtractor_bilateralFilter(buf, width, height, sigmaS, sigmaR, kernelSize) {
        var kernel = new Float32Array(Math.pow(kernelSize, 2));
        var sigmaS2 = -2 * Math.pow(sigmaS, 2);
        var halfSize = kernelSize >> 1;
        for (var i = 0; i < kernelSize; i++) {
            var x = Math.pow((i - halfSize), 2);
            for (var j = 0; j < kernelSize; j++) {
                kernel[i * kernelSize + j] = Math.exp((x + Math.pow((j - halfSize), 2)) / sigmaS2);
            }
        }
        var rangeValues = new Float32Array(256);
        var sigmaR2 = -2 * Math.pow(sigmaR, 2);
        for (var i = 0; i < 256; i++) {
            rangeValues[i] = Math.exp(Math.pow(i, 2) / sigmaR2);
        }
        var N = buf.length;
        var out = new Uint8Array(N);
        var histogram = new Uint32Array(256);
        for (var i = 0; i < height; i++) {
            for (var j = 0; j < width; j++) {
                var ij = i * width + j;
                var center = buf[ij];
                var sum = 0;
                var norm = 0;
                for (var k = 0; k < kernelSize; k++) {
                    var y = i + k - halfSize;
                    if (y < 0 || y >= height) {
                        continue;
                    }
                    for (var l = 0; l < kernelSize; l++) {
                        var x = j + l - halfSize;
                        if (x < 0 || x >= width) {
                            continue;
                        }
                        var neighbour = buf[y * width + x];
                        var w = kernel[k * kernelSize + l] * rangeValues[Math.abs(neighbour - center)];
                        sum += neighbour * w;
                        norm += w;
                    }
                }
                var pix = out[ij] = Math.round(sum / norm);
                histogram[pix]++;
            }
        }
        return [out, histogram];
    }, _SignatureExtractor_getHistogram = function _SignatureExtractor_getHistogram(buf) {
        var e_200, _v;
        var histogram = new Uint32Array(256);
        try {
            for (var buf_1 = __values(buf), buf_1_1 = buf_1.next(); !buf_1_1.done; buf_1_1 = buf_1.next()) {
                var g = buf_1_1.value;
                histogram[g]++;
            }
        }
        catch (e_200_1) { e_200 = { error: e_200_1 }; }
        finally {
            try {
                if (buf_1_1 && !buf_1_1.done && (_v = buf_1.return)) _v.call(buf_1);
            }
            finally { if (e_200) throw e_200.error; }
        }
        return histogram;
    }, _SignatureExtractor_toUint8 = function _SignatureExtractor_toUint8(buf) {
        var N = buf.length;
        var out = new Uint8ClampedArray(N >> 2);
        var max = -Infinity;
        var min = Infinity;
        for (var i = 0, ii = out.length; i < ii; i++) {
            var A = buf[(i << 2) + 3];
            if (A === 0) {
                max = out[i] = 0xff;
                continue;
            }
            var pix = out[i] = buf[i << 2];
            if (pix > max) {
                max = pix;
            }
            if (pix < min) {
                min = pix;
            }
        }
        var ratio = 255 / (max - min);
        for (var i = 0; i < N; i++) {
            out[i] = (out[i] - min) * ratio;
        }
        return out;
    }, _SignatureExtractor_guessThreshold = function _SignatureExtractor_guessThreshold(histogram) {
        var i;
        var M = -Infinity;
        var L = -Infinity;
        var min = histogram.findIndex(function (v) { return v !== 0; });
        var pos = min;
        var spos = min;
        for (i = min; i < 256; i++) {
            var v = histogram[i];
            if (v > M) {
                if (i - pos > L) {
                    L = i - pos;
                    spos = i - 1;
                }
                M = v;
                pos = i;
            }
        }
        for (i = spos - 1; i >= 0; i--) {
            if (histogram[i] > histogram[i + 1]) {
                break;
            }
        }
        return i;
    }, _SignatureExtractor_getGrayPixels = function _SignatureExtractor_getGrayPixels(bitmap) {
        var originalBitmap = bitmap;
        var width = bitmap.width, height = bitmap.height;
        var maxDim = __classPrivateFieldGet(this, _u, "f", _SignatureExtractor_PARAMETERS).maxDim;
        var newWidth = width;
        var newHeight = height;
        if (width > maxDim || height > maxDim) {
            var prevWidth = width;
            var prevHeight = height;
            var steps = Math.log2(Math.max(width, height) / maxDim);
            var isteps = Math.floor(steps);
            steps = steps === isteps ? isteps - 1 : isteps;
            for (var i = 0; i < steps; i++) {
                newWidth = prevWidth;
                newHeight = prevHeight;
                if (newWidth > maxDim) {
                    newWidth = Math.ceil(newWidth / 2);
                }
                if (newHeight > maxDim) {
                    newHeight = Math.ceil(newHeight / 2);
                }
                var offscreen_1 = new OffscreenCanvas(newWidth, newHeight);
                var ctx_1 = offscreen_1.getContext("2d");
                ctx_1.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
                prevWidth = newWidth;
                prevHeight = newHeight;
                if (bitmap !== originalBitmap) {
                    bitmap.close();
                }
                bitmap = offscreen_1.transferToImageBitmap();
            }
            var ratio = Math.min(maxDim / newWidth, maxDim / newHeight);
            newWidth = Math.round(newWidth * ratio);
            newHeight = Math.round(newHeight * ratio);
        }
        var offscreen = new OffscreenCanvas(newWidth, newHeight);
        var ctx = offscreen.getContext("2d", {
            willReadFrequently: true
        });
        ctx.filter = "grayscale(1)";
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, newWidth, newHeight);
        var grayImage = ctx.getImageData(0, 0, newWidth, newHeight).data;
        var uint8Buf = __classPrivateFieldGet(this, _u, "m", _SignatureExtractor_toUint8).call(this, grayImage);
        return [uint8Buf, newWidth, newHeight];
    };
    _SignatureExtractor_PARAMETERS = { value: {
            maxDim: 512,
            sigmaSFactor: 0.02,
            sigmaR: 25,
            kernelSize: 16
        } };
    _SignatureExtractor_neighborIdToIndex = { value: new Int32Array([0, 1, -1, 1, -1, 0, -1, -1, 0, -1, 1, -1, 1, 0, 1, 1]) };
    return SignatureExtractor;
}());
; // ./src/display/editor/signature.js
var SignatureOptions = /** @class */ (function (_super) {
    __extends(SignatureOptions, _super);
    function SignatureOptions() {
        var _this = _super.call(this) || this;
        _super.prototype.updateProperties.call(_this, {
            fill: AnnotationEditor._defaultLineColor,
            "stroke-width": 0
        });
        return _this;
    }
    SignatureOptions.prototype.clone = function () {
        var clone = new SignatureOptions();
        clone.updateAll(this);
        return clone;
    };
    return SignatureOptions;
}(DrawingOptions));
var DrawnSignatureOptions = /** @class */ (function (_super) {
    __extends(DrawnSignatureOptions, _super);
    function DrawnSignatureOptions(viewerParameters) {
        var _this = _super.call(this, viewerParameters) || this;
        _super.prototype.updateProperties.call(_this, {
            stroke: AnnotationEditor._defaultLineColor,
            "stroke-width": 1
        });
        return _this;
    }
    DrawnSignatureOptions.prototype.clone = function () {
        var clone = new DrawnSignatureOptions(this._viewParameters);
        clone.updateAll(this);
        return clone;
    };
    return DrawnSignatureOptions;
}(InkDrawingOptions));
var SignatureEditor = /** @class */ (function (_super) {
    __extends(SignatureEditor, _super);
    function SignatureEditor(params) {
        var _this = _super.call(this, __assign(__assign({}, params), { mustBeCommitted: true, name: "signatureEditor" })) || this;
        _SignatureEditor_isExtracted.set(_this, false);
        _SignatureEditor_description.set(_this, null);
        _SignatureEditor_signatureData.set(_this, null);
        _SignatureEditor_signatureUUID.set(_this, null);
        _this._willKeepAspectRatio = true;
        __classPrivateFieldSet(_this, _SignatureEditor_signatureData, params.signatureData || null, "f");
        __classPrivateFieldSet(_this, _SignatureEditor_description, null, "f");
        _this.defaultL10nId = "pdfjs-editor-signature-editor1";
        return _this;
    }
    SignatureEditor.initialize = function (l10n, uiManager) {
        AnnotationEditor.initialize(l10n, uiManager);
        this._defaultDrawingOptions = new SignatureOptions();
        this._defaultDrawnSignatureOptions = new DrawnSignatureOptions(uiManager.viewParameters);
    };
    SignatureEditor.getDefaultDrawingOptions = function (options) {
        var clone = this._defaultDrawingOptions.clone();
        clone.updateProperties(options);
        return clone;
    };
    Object.defineProperty(SignatureEditor, "supportMultipleDrawings", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignatureEditor, "typesMap", {
        get: function () {
            return shadow(this, "typesMap", new Map());
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignatureEditor, "isDrawer", {
        get: function () {
            return false;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(SignatureEditor.prototype, "telemetryFinalData", {
        get: function () {
            return {
                type: "signature",
                hasDescription: !!__classPrivateFieldGet(this, _SignatureEditor_description, "f")
            };
        },
        enumerable: false,
        configurable: true
    });
    SignatureEditor.computeTelemetryFinalData = function (data) {
        var _v, _w;
        var hasDescriptionStats = data.get("hasDescription");
        return {
            hasAltText: (_v = hasDescriptionStats.get(true)) !== null && _v !== void 0 ? _v : 0,
            hasNoAltText: (_w = hasDescriptionStats.get(false)) !== null && _w !== void 0 ? _w : 0
        };
    };
    Object.defineProperty(SignatureEditor.prototype, "isResizable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    SignatureEditor.prototype.onScaleChanging = function () {
        if (this._drawId === null) {
            return;
        }
        _super.prototype.onScaleChanging.call(this);
    };
    SignatureEditor.prototype.render = function () {
        if (this.div) {
            return this.div;
        }
        var baseX, baseY;
        var _isCopy = this._isCopy;
        if (_isCopy) {
            this._isCopy = false;
            baseX = this.x;
            baseY = this.y;
        }
        _super.prototype.render.call(this);
        if (this._drawId === null) {
            if (__classPrivateFieldGet(this, _SignatureEditor_signatureData, "f")) {
                var _v = __classPrivateFieldGet(this, _SignatureEditor_signatureData, "f"), lines = _v.lines, mustSmooth = _v.mustSmooth, areContours = _v.areContours, description = _v.description, uuid = _v.uuid, heightInPage = _v.heightInPage;
                var _w = this.parent.viewport, _z = _w.rawDims, pageWidth = _z.pageWidth, pageHeight = _z.pageHeight, rotation = _w.rotation;
                var outline = SignatureExtractor.processDrawnLines({
                    lines: lines,
                    pageWidth: pageWidth,
                    pageHeight: pageHeight,
                    rotation: rotation,
                    innerMargin: SignatureEditor._INNER_MARGIN,
                    mustSmooth: mustSmooth,
                    areContours: areContours
                });
                this.addSignature(outline, heightInPage, description, uuid);
            }
            else {
                this.div.setAttribute("data-l10n-args", JSON.stringify({
                    description: ""
                }));
                this.div.hidden = true;
                this._uiManager.getSignature(this);
            }
        }
        if (_isCopy) {
            this._isCopy = true;
            this._moveAfterPaste(baseX, baseY);
        }
        return this.div;
    };
    SignatureEditor.prototype.setUuid = function (uuid) {
        __classPrivateFieldSet(this, _SignatureEditor_signatureUUID, uuid, "f");
        this.addEditToolbar();
    };
    SignatureEditor.prototype.getUuid = function () {
        return __classPrivateFieldGet(this, _SignatureEditor_signatureUUID, "f");
    };
    Object.defineProperty(SignatureEditor.prototype, "description", {
        get: function () {
            return __classPrivateFieldGet(this, _SignatureEditor_description, "f");
        },
        set: function (description) {
            __classPrivateFieldSet(this, _SignatureEditor_description, description, "f");
            _super.prototype.addEditToolbar.call(this).then(function (toolbar) {
                toolbar === null || toolbar === void 0 ? void 0 : toolbar.updateEditSignatureButton(description);
            });
        },
        enumerable: false,
        configurable: true
    });
    SignatureEditor.prototype.getSignaturePreview = function () {
        var _v = __classPrivateFieldGet(this, _SignatureEditor_signatureData, "f"), newCurves = _v.newCurves, areContours = _v.areContours, thickness = _v.thickness, width = _v.width, height = _v.height;
        var maxDim = Math.max(width, height);
        var outlineData = SignatureExtractor.processDrawnLines({
            lines: {
                curves: newCurves.map(function (points) { return ({
                    points: points
                }); }),
                thickness: thickness,
                width: width,
                height: height
            },
            pageWidth: maxDim,
            pageHeight: maxDim,
            rotation: 0,
            innerMargin: 0,
            mustSmooth: false,
            areContours: areContours
        });
        return {
            areContours: areContours,
            outline: outlineData.outline
        };
    };
    SignatureEditor.prototype.addEditToolbar = function () {
        return __awaiter(this, void 0, void 0, function () {
            var toolbar;
            return __generator(this, function (_v) {
                switch (_v.label) {
                    case 0: return [4 /*yield*/, _super.prototype.addEditToolbar.call(this)];
                    case 1:
                        toolbar = _v.sent();
                        if (!toolbar) {
                            return [2 /*return*/, null];
                        }
                        if (!(this._uiManager.signatureManager && __classPrivateFieldGet(this, _SignatureEditor_description, "f") !== null)) return [3 /*break*/, 3];
                        return [4 /*yield*/, toolbar.addEditSignatureButton(this._uiManager.signatureManager, __classPrivateFieldGet(this, _SignatureEditor_signatureUUID, "f"), __classPrivateFieldGet(this, _SignatureEditor_description, "f"))];
                    case 2:
                        _v.sent();
                        toolbar.show();
                        _v.label = 3;
                    case 3: return [2 /*return*/, toolbar];
                }
            });
        });
    };
    SignatureEditor.prototype.addSignature = function (data, heightInPage, description, uuid) {
        var _v = this, savedX = _v.x, savedY = _v.y;
        var outline = __classPrivateFieldSet(this, _SignatureEditor_signatureData, data, "f").outline;
        __classPrivateFieldSet(this, _SignatureEditor_isExtracted, outline instanceof ContourDrawOutline, "f");
        __classPrivateFieldSet(this, _SignatureEditor_description, description, "f");
        this.div.setAttribute("data-l10n-args", JSON.stringify({
            description: description
        }));
        var drawingOptions;
        if (__classPrivateFieldGet(this, _SignatureEditor_isExtracted, "f")) {
            drawingOptions = SignatureEditor.getDefaultDrawingOptions();
        }
        else {
            drawingOptions = SignatureEditor._defaultDrawnSignatureOptions.clone();
            drawingOptions.updateProperties({
                "stroke-width": outline.thickness
            });
        }
        this._addOutlines({
            drawOutlines: outline,
            drawingOptions: drawingOptions
        });
        var _w = __read(this.parentDimensions, 2), parentWidth = _w[0], parentHeight = _w[1];
        var _z = __read(this.pageDimensions, 2), pageHeight = _z[1];
        var newHeight = heightInPage / pageHeight;
        newHeight = newHeight >= 1 ? 0.5 : newHeight;
        this.width *= newHeight / this.height;
        if (this.width >= 1) {
            newHeight *= 0.9 / this.width;
            this.width = 0.9;
        }
        this.height = newHeight;
        this.setDims(parentWidth * this.width, parentHeight * this.height);
        this.x = savedX;
        this.y = savedY;
        this.center();
        this._onResized();
        this.onScaleChanging();
        this.rotate();
        this._uiManager.addToAnnotationStorage(this);
        this.setUuid(uuid);
        this._reportTelemetry({
            action: "pdfjs.signature.inserted",
            data: {
                hasBeenSaved: !!uuid,
                hasDescription: !!description
            }
        });
        this.div.hidden = false;
    };
    SignatureEditor.prototype.getFromImage = function (bitmap) {
        var _v = this.parent.viewport, _w = _v.rawDims, pageWidth = _w.pageWidth, pageHeight = _w.pageHeight, rotation = _v.rotation;
        return SignatureExtractor.process(bitmap, pageWidth, pageHeight, rotation, SignatureEditor._INNER_MARGIN);
    };
    SignatureEditor.prototype.getFromText = function (text, fontInfo) {
        var _v = this.parent.viewport, _w = _v.rawDims, pageWidth = _w.pageWidth, pageHeight = _w.pageHeight, rotation = _v.rotation;
        return SignatureExtractor.extractContoursFromText(text, fontInfo, pageWidth, pageHeight, rotation, SignatureEditor._INNER_MARGIN);
    };
    SignatureEditor.prototype.getDrawnSignature = function (curves) {
        var _v = this.parent.viewport, _w = _v.rawDims, pageWidth = _w.pageWidth, pageHeight = _w.pageHeight, rotation = _v.rotation;
        return SignatureExtractor.processDrawnLines({
            lines: curves,
            pageWidth: pageWidth,
            pageHeight: pageHeight,
            rotation: rotation,
            innerMargin: SignatureEditor._INNER_MARGIN,
            mustSmooth: false,
            areContours: false
        });
    };
    SignatureEditor.prototype.createDrawingOptions = function (_v) {
        var areContours = _v.areContours, thickness = _v.thickness;
        if (areContours) {
            this._drawingOptions = SignatureEditor.getDefaultDrawingOptions();
        }
        else {
            this._drawingOptions = SignatureEditor._defaultDrawnSignatureOptions.clone();
            this._drawingOptions.updateProperties({
                "stroke-width": thickness
            });
        }
    };
    SignatureEditor.prototype.serialize = function (isForCopying) {
        if (isForCopying === void 0) { isForCopying = false; }
        if (this.isEmpty()) {
            return null;
        }
        var _v = this.serializeDraw(isForCopying), lines = _v.lines, points = _v.points, rect = _v.rect;
        var thickness = this._drawingOptions["stroke-width"];
        var serialized = {
            annotationType: AnnotationEditorType.SIGNATURE,
            isSignature: true,
            areContours: __classPrivateFieldGet(this, _SignatureEditor_isExtracted, "f"),
            color: [0, 0, 0],
            thickness: __classPrivateFieldGet(this, _SignatureEditor_isExtracted, "f") ? 0 : thickness,
            pageIndex: this.pageIndex,
            rect: rect,
            rotation: this.rotation,
            structTreeParentId: this._structTreeParentId
        };
        if (isForCopying) {
            serialized.paths = {
                lines: lines,
                points: points
            };
            serialized.uuid = __classPrivateFieldGet(this, _SignatureEditor_signatureUUID, "f");
            serialized.isCopy = true;
        }
        else {
            serialized.lines = lines;
        }
        if (__classPrivateFieldGet(this, _SignatureEditor_description, "f")) {
            serialized.accessibilityData = {
                type: "Figure",
                alt: __classPrivateFieldGet(this, _SignatureEditor_description, "f")
            };
        }
        return serialized;
    };
    SignatureEditor.deserializeDraw = function (pageX, pageY, pageWidth, pageHeight, innerMargin, data) {
        if (data.areContours) {
            return ContourDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
        }
        return InkDrawOutline.deserialize(pageX, pageY, pageWidth, pageHeight, innerMargin, data);
    };
    SignatureEditor.deserialize = function (data, parent, uiManager) {
        return __awaiter(this, void 0, void 0, function () {
            var editor;
            var _v;
            return __generator(this, function (_w) {
                switch (_w.label) {
                    case 0: return [4 /*yield*/, _super.deserialize.call(this, data, parent, uiManager)];
                    case 1:
                        editor = _w.sent();
                        __classPrivateFieldSet(editor, _SignatureEditor_isExtracted, data.areContours, "f");
                        __classPrivateFieldSet(editor, _SignatureEditor_description, ((_v = data.accessibilityData) === null || _v === void 0 ? void 0 : _v.alt) || "", "f");
                        __classPrivateFieldSet(editor, _SignatureEditor_signatureUUID, data.uuid, "f");
                        return [2 /*return*/, editor];
                }
            });
        });
    };
    var _SignatureEditor_isExtracted, _SignatureEditor_description, _SignatureEditor_signatureData, _SignatureEditor_signatureUUID;
    _SignatureEditor_isExtracted = new WeakMap(), _SignatureEditor_description = new WeakMap(), _SignatureEditor_signatureData = new WeakMap(), _SignatureEditor_signatureUUID = new WeakMap();
    SignatureEditor._type = "signature";
    SignatureEditor._editorType = AnnotationEditorType.SIGNATURE;
    SignatureEditor._defaultDrawingOptions = null;
    return SignatureEditor;
}(DrawingEditor));
; // ./src/display/editor/stamp.js
var StampEditor = /** @class */ (function (_super) {
    __extends(StampEditor, _super);
    function StampEditor(params) {
        var _this = _super.call(this, __assign(__assign({}, params), { name: "stampEditor" })) || this;
        _StampEditor_instances.add(_this);
        _StampEditor_bitmap.set(_this, null);
        _StampEditor_bitmapId.set(_this, null);
        _StampEditor_bitmapPromise.set(_this, null);
        _StampEditor_bitmapUrl.set(_this, null);
        _StampEditor_bitmapFile.set(_this, null);
        _StampEditor_bitmapFileName.set(_this, "");
        _StampEditor_canvas.set(_this, null);
        _StampEditor_missingCanvas.set(_this, false);
        _StampEditor_resizeTimeoutId.set(_this, null);
        _StampEditor_isSvg.set(_this, false);
        _StampEditor_hasBeenAddedInUndoStack.set(_this, false);
        __classPrivateFieldSet(_this, _StampEditor_bitmapUrl, params.bitmapUrl, "f");
        __classPrivateFieldSet(_this, _StampEditor_bitmapFile, params.bitmapFile, "f");
        _this.defaultL10nId = "pdfjs-editor-stamp-editor";
        return _this;
    }
    StampEditor.initialize = function (l10n, uiManager) {
        AnnotationEditor.initialize(l10n, uiManager);
    };
    StampEditor.isHandlingMimeForPasting = function (mime) {
        return SupportedImageMimeTypes.includes(mime);
    };
    StampEditor.paste = function (item, parent) {
        parent.pasteEditor(AnnotationEditorType.STAMP, {
            bitmapFile: item.getAsFile()
        });
    };
    StampEditor.prototype.altTextFinish = function () {
        if (this._uiManager.useNewAltTextFlow) {
            this.div.hidden = false;
        }
        _super.prototype.altTextFinish.call(this);
    };
    Object.defineProperty(StampEditor.prototype, "telemetryFinalData", {
        get: function () {
            var _v;
            return {
                type: "stamp",
                hasAltText: !!((_v = this.altTextData) === null || _v === void 0 ? void 0 : _v.altText)
            };
        },
        enumerable: false,
        configurable: true
    });
    StampEditor.computeTelemetryFinalData = function (data) {
        var _v, _w;
        var hasAltTextStats = data.get("hasAltText");
        return {
            hasAltText: (_v = hasAltTextStats.get(true)) !== null && _v !== void 0 ? _v : 0,
            hasNoAltText: (_w = hasAltTextStats.get(false)) !== null && _w !== void 0 ? _w : 0
        };
    };
    StampEditor.prototype.mlGuessAltText = function () {
        return __awaiter(this, arguments, void 0, function (imageData, updateAltTextData) {
            var mlManager, _v, data, width, height, response, altText;
            if (imageData === void 0) { imageData = null; }
            if (updateAltTextData === void 0) { updateAltTextData = true; }
            return __generator(this, function (_w) {
                switch (_w.label) {
                    case 0:
                        if (this.hasAltTextData()) {
                            return [2 /*return*/, null];
                        }
                        mlManager = this._uiManager.mlManager;
                        if (!mlManager) {
                            throw new Error("No ML.");
                        }
                        return [4 /*yield*/, mlManager.isEnabledFor("altText")];
                    case 1:
                        if (!(_w.sent())) {
                            throw new Error("ML isn't enabled for alt text.");
                        }
                        _v = imageData || this.copyCanvas(null, null, true).imageData, data = _v.data, width = _v.width, height = _v.height;
                        return [4 /*yield*/, mlManager.guess({
                                name: "altText",
                                request: {
                                    data: data,
                                    width: width,
                                    height: height,
                                    channels: data.length / (width * height)
                                }
                            })];
                    case 2:
                        response = _w.sent();
                        if (!response) {
                            throw new Error("No response from the AI service.");
                        }
                        if (response.error) {
                            throw new Error("Error from the AI service.");
                        }
                        if (response.cancel) {
                            return [2 /*return*/, null];
                        }
                        if (!response.output) {
                            throw new Error("No valid response from the AI service.");
                        }
                        altText = response.output;
                        return [4 /*yield*/, this.setGuessedAltText(altText)];
                    case 3:
                        _w.sent();
                        if (updateAltTextData && !this.hasAltTextData()) {
                            this.altTextData = {
                                alt: altText,
                                decorative: false
                            };
                        }
                        return [2 /*return*/, altText];
                }
            });
        });
    };
    StampEditor.prototype.remove = function () {
        var _v;
        if (__classPrivateFieldGet(this, _StampEditor_bitmapId, "f")) {
            __classPrivateFieldSet(this, _StampEditor_bitmap, null, "f");
            this._uiManager.imageManager.deleteId(__classPrivateFieldGet(this, _StampEditor_bitmapId, "f"));
            (_v = __classPrivateFieldGet(this, _StampEditor_canvas, "f")) === null || _v === void 0 ? void 0 : _v.remove();
            __classPrivateFieldSet(this, _StampEditor_canvas, null, "f");
            if (__classPrivateFieldGet(this, _StampEditor_resizeTimeoutId, "f")) {
                clearTimeout(__classPrivateFieldGet(this, _StampEditor_resizeTimeoutId, "f"));
                __classPrivateFieldSet(this, _StampEditor_resizeTimeoutId, null, "f");
            }
        }
        _super.prototype.remove.call(this);
    };
    StampEditor.prototype.rebuild = function () {
        if (!this.parent) {
            if (__classPrivateFieldGet(this, _StampEditor_bitmapId, "f")) {
                __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_getBitmap).call(this);
            }
            return;
        }
        _super.prototype.rebuild.call(this);
        if (this.div === null) {
            return;
        }
        if (__classPrivateFieldGet(this, _StampEditor_bitmapId, "f") && __classPrivateFieldGet(this, _StampEditor_canvas, "f") === null) {
            __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_getBitmap).call(this);
        }
        if (!this.isAttachedToDOM) {
            this.parent.add(this);
        }
    };
    StampEditor.prototype.onceAdded = function (focus) {
        this._isDraggable = true;
        if (focus) {
            this.div.focus();
        }
    };
    StampEditor.prototype.isEmpty = function () {
        return !(__classPrivateFieldGet(this, _StampEditor_bitmapPromise, "f") || __classPrivateFieldGet(this, _StampEditor_bitmap, "f") || __classPrivateFieldGet(this, _StampEditor_bitmapUrl, "f") || __classPrivateFieldGet(this, _StampEditor_bitmapFile, "f") || __classPrivateFieldGet(this, _StampEditor_bitmapId, "f") || __classPrivateFieldGet(this, _StampEditor_missingCanvas, "f"));
    };
    Object.defineProperty(StampEditor.prototype, "isResizable", {
        get: function () {
            return true;
        },
        enumerable: false,
        configurable: true
    });
    StampEditor.prototype.render = function () {
        if (this.div) {
            return this.div;
        }
        var baseX, baseY;
        if (this._isCopy) {
            baseX = this.x;
            baseY = this.y;
        }
        _super.prototype.render.call(this);
        this.div.hidden = true;
        this.addAltTextButton();
        if (!__classPrivateFieldGet(this, _StampEditor_missingCanvas, "f")) {
            if (__classPrivateFieldGet(this, _StampEditor_bitmap, "f")) {
                __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_createCanvas).call(this);
            }
            else {
                __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_getBitmap).call(this);
            }
        }
        if (this._isCopy) {
            this._moveAfterPaste(baseX, baseY);
        }
        this._uiManager.addShouldRescale(this);
        return this.div;
    };
    StampEditor.prototype.setCanvas = function (annotationElementId, canvas) {
        var _v = this._uiManager.imageManager.getFromCanvas(annotationElementId, canvas), bitmapId = _v.id, bitmap = _v.bitmap;
        canvas.remove();
        if (bitmapId && this._uiManager.imageManager.isValidId(bitmapId)) {
            __classPrivateFieldSet(this, _StampEditor_bitmapId, bitmapId, "f");
            if (bitmap) {
                __classPrivateFieldSet(this, _StampEditor_bitmap, bitmap, "f");
            }
            __classPrivateFieldSet(this, _StampEditor_missingCanvas, false, "f");
            __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_createCanvas).call(this);
        }
    };
    StampEditor.prototype._onResized = function () {
        this.onScaleChanging();
    };
    StampEditor.prototype.onScaleChanging = function () {
        var _this = this;
        if (!this.parent) {
            return;
        }
        if (__classPrivateFieldGet(this, _StampEditor_resizeTimeoutId, "f") !== null) {
            clearTimeout(__classPrivateFieldGet(this, _StampEditor_resizeTimeoutId, "f"));
        }
        var TIME_TO_WAIT = 200;
        __classPrivateFieldSet(this, _StampEditor_resizeTimeoutId, setTimeout(function () {
            __classPrivateFieldSet(_this, _StampEditor_resizeTimeoutId, null, "f");
            __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_drawBitmap).call(_this);
        }, TIME_TO_WAIT), "f");
    };
    StampEditor.prototype.copyCanvas = function (maxDataDimension, maxPreviewDimension, createImageData) {
        var _v;
        if (createImageData === void 0) { createImageData = false; }
        if (!maxDataDimension) {
            maxDataDimension = 224;
        }
        var _w = __classPrivateFieldGet(this, _StampEditor_bitmap, "f"), bitmapWidth = _w.width, bitmapHeight = _w.height;
        var outputScale = new OutputScale();
        var bitmap = __classPrivateFieldGet(this, _StampEditor_bitmap, "f");
        var width = bitmapWidth, height = bitmapHeight;
        var canvas = null;
        if (maxPreviewDimension) {
            if (bitmapWidth > maxPreviewDimension || bitmapHeight > maxPreviewDimension) {
                var ratio = Math.min(maxPreviewDimension / bitmapWidth, maxPreviewDimension / bitmapHeight);
                width = Math.floor(bitmapWidth * ratio);
                height = Math.floor(bitmapHeight * ratio);
            }
            canvas = document.createElement("canvas");
            var scaledWidth = canvas.width = Math.ceil(width * outputScale.sx);
            var scaledHeight = canvas.height = Math.ceil(height * outputScale.sy);
            if (!__classPrivateFieldGet(this, _StampEditor_isSvg, "f")) {
                bitmap = __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_scaleBitmap).call(this, scaledWidth, scaledHeight);
            }
            var ctx = canvas.getContext("2d");
            ctx.filter = this._uiManager.hcmFilter;
            var white = "white", black = "#cfcfd8";
            if (this._uiManager.hcmFilter !== "none") {
                black = "black";
            }
            else if ((_v = window.matchMedia) === null || _v === void 0 ? void 0 : _v.call(window, "(prefers-color-scheme: dark)").matches) {
                white = "#8f8f9d";
                black = "#42414d";
            }
            var boxDim = 15;
            var boxDimWidth = boxDim * outputScale.sx;
            var boxDimHeight = boxDim * outputScale.sy;
            var pattern = new OffscreenCanvas(boxDimWidth * 2, boxDimHeight * 2);
            var patternCtx = pattern.getContext("2d");
            patternCtx.fillStyle = white;
            patternCtx.fillRect(0, 0, boxDimWidth * 2, boxDimHeight * 2);
            patternCtx.fillStyle = black;
            patternCtx.fillRect(0, 0, boxDimWidth, boxDimHeight);
            patternCtx.fillRect(boxDimWidth, boxDimHeight, boxDimWidth, boxDimHeight);
            ctx.fillStyle = ctx.createPattern(pattern, "repeat");
            ctx.fillRect(0, 0, scaledWidth, scaledHeight);
            ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
        }
        var imageData = null;
        if (createImageData) {
            var dataWidth = void 0, dataHeight = void 0;
            if (outputScale.symmetric && bitmap.width < maxDataDimension && bitmap.height < maxDataDimension) {
                dataWidth = bitmap.width;
                dataHeight = bitmap.height;
            }
            else {
                bitmap = __classPrivateFieldGet(this, _StampEditor_bitmap, "f");
                if (bitmapWidth > maxDataDimension || bitmapHeight > maxDataDimension) {
                    var ratio = Math.min(maxDataDimension / bitmapWidth, maxDataDimension / bitmapHeight);
                    dataWidth = Math.floor(bitmapWidth * ratio);
                    dataHeight = Math.floor(bitmapHeight * ratio);
                    if (!__classPrivateFieldGet(this, _StampEditor_isSvg, "f")) {
                        bitmap = __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_scaleBitmap).call(this, dataWidth, dataHeight);
                    }
                }
            }
            var offscreen = new OffscreenCanvas(dataWidth, dataHeight);
            var offscreenCtx = offscreen.getContext("2d", {
                willReadFrequently: true
            });
            offscreenCtx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, dataWidth, dataHeight);
            imageData = {
                width: dataWidth,
                height: dataHeight,
                data: offscreenCtx.getImageData(0, 0, dataWidth, dataHeight).data
            };
        }
        return {
            canvas: canvas,
            width: width,
            height: height,
            imageData: imageData
        };
    };
    StampEditor.deserialize = function (data, parent, uiManager) {
        return __awaiter(this, void 0, void 0, function () {
            var initialData, missingCanvas, _v, rect_1, rotation, id, structParent, popupRef, container, pageNumber, canvas, bitmapId_1, bitmap_1, altText, editor, rect, bitmap, bitmapUrl, bitmapId, isSvg, accessibilityData, _w, parentWidth, parentHeight;
            var _z;
            var _0;
            return __generator(this, function (_1) {
                switch (_1.label) {
                    case 0:
                        initialData = null;
                        missingCanvas = false;
                        if (!(data instanceof StampAnnotationElement)) return [3 /*break*/, 2];
                        _v = data.data, rect_1 = _v.rect, rotation = _v.rotation, id = _v.id, structParent = _v.structParent, popupRef = _v.popupRef, container = data.container, pageNumber = data.parent.page.pageNumber, canvas = data.canvas;
                        if (canvas) {
                            delete data.canvas;
                            (_z = uiManager.imageManager.getFromCanvas(container.id, canvas), bitmapId_1 = _z.id, bitmap_1 = _z.bitmap);
                            canvas.remove();
                        }
                        else {
                            missingCanvas = true;
                            data._hasNoCanvas = true;
                        }
                        return [4 /*yield*/, parent._structTree.getAriaAttributes("".concat(AnnotationPrefix).concat(id))];
                    case 1:
                        altText = ((_0 = (_1.sent())) === null || _0 === void 0 ? void 0 : _0.get("aria-label")) || "";
                        initialData = data = {
                            annotationType: AnnotationEditorType.STAMP,
                            bitmapId: bitmapId_1,
                            bitmap: bitmap_1,
                            pageIndex: pageNumber - 1,
                            rect: rect_1.slice(0),
                            rotation: rotation,
                            id: id,
                            deleted: false,
                            accessibilityData: {
                                decorative: false,
                                altText: altText
                            },
                            isSvg: false,
                            structParent: structParent,
                            popupRef: popupRef
                        };
                        _1.label = 2;
                    case 2: return [4 /*yield*/, _super.deserialize.call(this, data, parent, uiManager)];
                    case 3:
                        editor = _1.sent();
                        rect = data.rect, bitmap = data.bitmap, bitmapUrl = data.bitmapUrl, bitmapId = data.bitmapId, isSvg = data.isSvg, accessibilityData = data.accessibilityData;
                        if (missingCanvas) {
                            uiManager.addMissingCanvas(data.id, editor);
                            __classPrivateFieldSet(editor, _StampEditor_missingCanvas, true, "f");
                        }
                        else if (bitmapId && uiManager.imageManager.isValidId(bitmapId)) {
                            __classPrivateFieldSet(editor, _StampEditor_bitmapId, bitmapId, "f");
                            if (bitmap) {
                                __classPrivateFieldSet(editor, _StampEditor_bitmap, bitmap, "f");
                            }
                        }
                        else {
                            __classPrivateFieldSet(editor, _StampEditor_bitmapUrl, bitmapUrl, "f");
                        }
                        __classPrivateFieldSet(editor, _StampEditor_isSvg, isSvg, "f");
                        _w = __read(editor.pageDimensions, 2), parentWidth = _w[0], parentHeight = _w[1];
                        editor.width = (rect[2] - rect[0]) / parentWidth;
                        editor.height = (rect[3] - rect[1]) / parentHeight;
                        editor.annotationElementId = data.id || null;
                        if (accessibilityData) {
                            editor.altTextData = accessibilityData;
                        }
                        editor._initialData = initialData;
                        __classPrivateFieldSet(editor, _StampEditor_hasBeenAddedInUndoStack, !!initialData, "f");
                        return [2 /*return*/, editor];
                }
            });
        });
    };
    StampEditor.prototype.serialize = function (isForCopying, context) {
        var _v;
        if (isForCopying === void 0) { isForCopying = false; }
        if (context === void 0) { context = null; }
        if (this.isEmpty()) {
            return null;
        }
        if (this.deleted) {
            return this.serializeDeleted();
        }
        var serialized = {
            annotationType: AnnotationEditorType.STAMP,
            bitmapId: __classPrivateFieldGet(this, _StampEditor_bitmapId, "f"),
            pageIndex: this.pageIndex,
            rect: this.getRect(0, 0),
            rotation: this.rotation,
            isSvg: __classPrivateFieldGet(this, _StampEditor_isSvg, "f"),
            structTreeParentId: this._structTreeParentId
        };
        if (isForCopying) {
            serialized.bitmapUrl = __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_serializeBitmap).call(this, true);
            serialized.accessibilityData = this.serializeAltText(true);
            serialized.isCopy = true;
            return serialized;
        }
        var _w = this.serializeAltText(false), decorative = _w.decorative, altText = _w.altText;
        if (!decorative && altText) {
            serialized.accessibilityData = {
                type: "Figure",
                alt: altText
            };
        }
        if (this.annotationElementId) {
            var changes = __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_hasElementChanged).call(this, serialized);
            if (changes.isSame) {
                return null;
            }
            if (changes.isSameAltText) {
                delete serialized.accessibilityData;
            }
            else {
                serialized.accessibilityData.structParent = (_v = this._initialData.structParent) !== null && _v !== void 0 ? _v : -1;
            }
        }
        serialized.id = this.annotationElementId;
        if (context === null) {
            return serialized;
        }
        context.stamps || (context.stamps = new Map());
        var area = __classPrivateFieldGet(this, _StampEditor_isSvg, "f") ? (serialized.rect[2] - serialized.rect[0]) * (serialized.rect[3] - serialized.rect[1]) : null;
        if (!context.stamps.has(__classPrivateFieldGet(this, _StampEditor_bitmapId, "f"))) {
            context.stamps.set(__classPrivateFieldGet(this, _StampEditor_bitmapId, "f"), {
                area: area,
                serialized: serialized
            });
            serialized.bitmap = __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_serializeBitmap).call(this, false);
        }
        else if (__classPrivateFieldGet(this, _StampEditor_isSvg, "f")) {
            var prevData = context.stamps.get(__classPrivateFieldGet(this, _StampEditor_bitmapId, "f"));
            if (area > prevData.area) {
                prevData.area = area;
                prevData.serialized.bitmap.close();
                prevData.serialized.bitmap = __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_serializeBitmap).call(this, false);
            }
        }
        return serialized;
    };
    StampEditor.prototype.renderAnnotationElement = function (annotation) {
        annotation.updateEdited({
            rect: this.getRect(0, 0)
        });
        return null;
    };
    var _StampEditor_instances, _StampEditor_bitmap, _StampEditor_bitmapId, _StampEditor_bitmapPromise, _StampEditor_bitmapUrl, _StampEditor_bitmapFile, _StampEditor_bitmapFileName, _StampEditor_canvas, _StampEditor_missingCanvas, _StampEditor_resizeTimeoutId, _StampEditor_isSvg, _StampEditor_hasBeenAddedInUndoStack, _StampEditor_getBitmapFetched, _StampEditor_getBitmapDone, _StampEditor_getBitmap, _StampEditor_createCanvas, _StampEditor_scaleBitmap, _StampEditor_drawBitmap, _StampEditor_serializeBitmap, _StampEditor_hasElementChanged;
    _StampEditor_bitmap = new WeakMap(), _StampEditor_bitmapId = new WeakMap(), _StampEditor_bitmapPromise = new WeakMap(), _StampEditor_bitmapUrl = new WeakMap(), _StampEditor_bitmapFile = new WeakMap(), _StampEditor_bitmapFileName = new WeakMap(), _StampEditor_canvas = new WeakMap(), _StampEditor_missingCanvas = new WeakMap(), _StampEditor_resizeTimeoutId = new WeakMap(), _StampEditor_isSvg = new WeakMap(), _StampEditor_hasBeenAddedInUndoStack = new WeakMap(), _StampEditor_instances = new WeakSet(), _StampEditor_getBitmapFetched = function _StampEditor_getBitmapFetched(data, fromId) {
        if (fromId === void 0) { fromId = false; }
        if (!data) {
            this.remove();
            return;
        }
        __classPrivateFieldSet(this, _StampEditor_bitmap, data.bitmap, "f");
        if (!fromId) {
            __classPrivateFieldSet(this, _StampEditor_bitmapId, data.id, "f");
            __classPrivateFieldSet(this, _StampEditor_isSvg, data.isSvg, "f");
        }
        if (data.file) {
            __classPrivateFieldSet(this, _StampEditor_bitmapFileName, data.file.name, "f");
        }
        __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_createCanvas).call(this);
    }, _StampEditor_getBitmapDone = function _StampEditor_getBitmapDone() {
        __classPrivateFieldSet(this, _StampEditor_bitmapPromise, null, "f");
        this._uiManager.enableWaiting(false);
        if (!__classPrivateFieldGet(this, _StampEditor_canvas, "f")) {
            return;
        }
        if (this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && __classPrivateFieldGet(this, _StampEditor_bitmap, "f")) {
            this._editToolbar.hide();
            this._uiManager.editAltText(this, true);
            return;
        }
        if (!this._uiManager.useNewAltTextWhenAddingImage && this._uiManager.useNewAltTextFlow && __classPrivateFieldGet(this, _StampEditor_bitmap, "f")) {
            this._reportTelemetry({
                action: "pdfjs.image.image_added",
                data: {
                    alt_text_modal: false,
                    alt_text_type: "empty"
                }
            });
            try {
                this.mlGuessAltText();
            }
            catch (_v) { }
        }
        this.div.focus();
    }, _StampEditor_getBitmap = function _StampEditor_getBitmap() {
        var _this = this;
        if (__classPrivateFieldGet(this, _StampEditor_bitmapId, "f")) {
            this._uiManager.enableWaiting(true);
            this._uiManager.imageManager.getFromId(__classPrivateFieldGet(this, _StampEditor_bitmapId, "f")).then(function (data) { return __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_getBitmapFetched).call(_this, data, true); }).finally(function () { return __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_getBitmapDone).call(_this); });
            return;
        }
        if (__classPrivateFieldGet(this, _StampEditor_bitmapUrl, "f")) {
            var url = __classPrivateFieldGet(this, _StampEditor_bitmapUrl, "f");
            __classPrivateFieldSet(this, _StampEditor_bitmapUrl, null, "f");
            this._uiManager.enableWaiting(true);
            __classPrivateFieldSet(this, _StampEditor_bitmapPromise, this._uiManager.imageManager.getFromUrl(url).then(function (data) { return __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_getBitmapFetched).call(_this, data); }).finally(function () { return __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_getBitmapDone).call(_this); }), "f");
            return;
        }
        if (__classPrivateFieldGet(this, _StampEditor_bitmapFile, "f")) {
            var file = __classPrivateFieldGet(this, _StampEditor_bitmapFile, "f");
            __classPrivateFieldSet(this, _StampEditor_bitmapFile, null, "f");
            this._uiManager.enableWaiting(true);
            __classPrivateFieldSet(this, _StampEditor_bitmapPromise, this._uiManager.imageManager.getFromFile(file).then(function (data) { return __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_getBitmapFetched).call(_this, data); }).finally(function () { return __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_getBitmapDone).call(_this); }), "f");
            return;
        }
        var input = document.createElement("input");
        input.type = "file";
        input.accept = SupportedImageMimeTypes.join(",");
        var signal = this._uiManager._signal;
        __classPrivateFieldSet(this, _StampEditor_bitmapPromise, new Promise(function (resolve) {
            input.addEventListener("change", function () { return __awaiter(_this, void 0, void 0, function () {
                var data;
                return __generator(this, function (_v) {
                    switch (_v.label) {
                        case 0:
                            if (!(!input.files || input.files.length === 0)) return [3 /*break*/, 1];
                            this.remove();
                            return [3 /*break*/, 3];
                        case 1:
                            this._uiManager.enableWaiting(true);
                            return [4 /*yield*/, this._uiManager.imageManager.getFromFile(input.files[0])];
                        case 2:
                            data = _v.sent();
                            this._reportTelemetry({
                                action: "pdfjs.image.image_selected",
                                data: {
                                    alt_text_modal: this._uiManager.useNewAltTextFlow
                                }
                            });
                            __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_getBitmapFetched).call(this, data);
                            _v.label = 3;
                        case 3:
                            resolve();
                            return [2 /*return*/];
                    }
                });
            }); }, {
                signal: signal
            });
            input.addEventListener("cancel", function () {
                _this.remove();
                resolve();
            }, {
                signal: signal
            });
        }).finally(function () { return __classPrivateFieldGet(_this, _StampEditor_instances, "m", _StampEditor_getBitmapDone).call(_this); }), "f");
        input.click();
    }, _StampEditor_createCanvas = function _StampEditor_createCanvas() {
        var _v;
        var div = this.div;
        var _w = __classPrivateFieldGet(this, _StampEditor_bitmap, "f"), width = _w.width, height = _w.height;
        var _z = __read(this.pageDimensions, 2), pageWidth = _z[0], pageHeight = _z[1];
        var MAX_RATIO = 0.75;
        if (this.width) {
            width = this.width * pageWidth;
            height = this.height * pageHeight;
        }
        else if (width > MAX_RATIO * pageWidth || height > MAX_RATIO * pageHeight) {
            var factor = Math.min(MAX_RATIO * pageWidth / width, MAX_RATIO * pageHeight / height);
            width *= factor;
            height *= factor;
        }
        var _0 = __read(this.parentDimensions, 2), parentWidth = _0[0], parentHeight = _0[1];
        this.setDims(width * parentWidth / pageWidth, height * parentHeight / pageHeight);
        this._uiManager.enableWaiting(false);
        var canvas = __classPrivateFieldSet(this, _StampEditor_canvas, document.createElement("canvas"), "f");
        canvas.setAttribute("role", "img");
        this.addContainer(canvas);
        this.width = width / pageWidth;
        this.height = height / pageHeight;
        if ((_v = this._initialOptions) === null || _v === void 0 ? void 0 : _v.isCentered) {
            this.center();
        }
        else {
            this.fixAndSetPosition();
        }
        this._initialOptions = null;
        if (!this._uiManager.useNewAltTextWhenAddingImage || !this._uiManager.useNewAltTextFlow || this.annotationElementId) {
            div.hidden = false;
        }
        __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_drawBitmap).call(this);
        if (!__classPrivateFieldGet(this, _StampEditor_hasBeenAddedInUndoStack, "f")) {
            this.parent.addUndoableEditor(this);
            __classPrivateFieldSet(this, _StampEditor_hasBeenAddedInUndoStack, true, "f");
        }
        this._reportTelemetry({
            action: "inserted_image"
        });
        if (__classPrivateFieldGet(this, _StampEditor_bitmapFileName, "f")) {
            this.div.setAttribute("aria-description", __classPrivateFieldGet(this, _StampEditor_bitmapFileName, "f"));
        }
    }, _StampEditor_scaleBitmap = function _StampEditor_scaleBitmap(width, height) {
        var _v = __classPrivateFieldGet(this, _StampEditor_bitmap, "f"), bitmapWidth = _v.width, bitmapHeight = _v.height;
        var newWidth = bitmapWidth;
        var newHeight = bitmapHeight;
        var bitmap = __classPrivateFieldGet(this, _StampEditor_bitmap, "f");
        while (newWidth > 2 * width || newHeight > 2 * height) {
            var prevWidth = newWidth;
            var prevHeight = newHeight;
            if (newWidth > 2 * width) {
                newWidth = newWidth >= 16384 ? Math.floor(newWidth / 2) - 1 : Math.ceil(newWidth / 2);
            }
            if (newHeight > 2 * height) {
                newHeight = newHeight >= 16384 ? Math.floor(newHeight / 2) - 1 : Math.ceil(newHeight / 2);
            }
            var offscreen = new OffscreenCanvas(newWidth, newHeight);
            var ctx = offscreen.getContext("2d");
            ctx.drawImage(bitmap, 0, 0, prevWidth, prevHeight, 0, 0, newWidth, newHeight);
            bitmap = offscreen.transferToImageBitmap();
        }
        return bitmap;
    }, _StampEditor_drawBitmap = function _StampEditor_drawBitmap() {
        var _v = __read(this.parentDimensions, 2), parentWidth = _v[0], parentHeight = _v[1];
        var _w = this, width = _w.width, height = _w.height;
        var outputScale = new OutputScale();
        var scaledWidth = Math.ceil(width * parentWidth * outputScale.sx);
        var scaledHeight = Math.ceil(height * parentHeight * outputScale.sy);
        var canvas = __classPrivateFieldGet(this, _StampEditor_canvas, "f");
        if (!canvas || canvas.width === scaledWidth && canvas.height === scaledHeight) {
            return;
        }
        canvas.width = scaledWidth;
        canvas.height = scaledHeight;
        var bitmap = __classPrivateFieldGet(this, _StampEditor_isSvg, "f") ? __classPrivateFieldGet(this, _StampEditor_bitmap, "f") : __classPrivateFieldGet(this, _StampEditor_instances, "m", _StampEditor_scaleBitmap).call(this, scaledWidth, scaledHeight);
        var ctx = canvas.getContext("2d");
        ctx.filter = this._uiManager.hcmFilter;
        ctx.drawImage(bitmap, 0, 0, bitmap.width, bitmap.height, 0, 0, scaledWidth, scaledHeight);
    }, _StampEditor_serializeBitmap = function _StampEditor_serializeBitmap(toUrl) {
        var _v;
        if (toUrl) {
            if (__classPrivateFieldGet(this, _StampEditor_isSvg, "f")) {
                var url = this._uiManager.imageManager.getSvgUrl(__classPrivateFieldGet(this, _StampEditor_bitmapId, "f"));
                if (url) {
                    return url;
                }
            }
            var canvas = document.createElement("canvas");
            (_v = __classPrivateFieldGet(this, _StampEditor_bitmap, "f"), canvas.width = _v.width, canvas.height = _v.height);
            var ctx = canvas.getContext("2d");
            ctx.drawImage(__classPrivateFieldGet(this, _StampEditor_bitmap, "f"), 0, 0);
            return canvas.toDataURL();
        }
        if (__classPrivateFieldGet(this, _StampEditor_isSvg, "f")) {
            var _w = __read(this.pageDimensions, 2), pageWidth = _w[0], pageHeight = _w[1];
            var width = Math.round(this.width * pageWidth * PixelsPerInch.PDF_TO_CSS_UNITS);
            var height = Math.round(this.height * pageHeight * PixelsPerInch.PDF_TO_CSS_UNITS);
            var offscreen = new OffscreenCanvas(width, height);
            var ctx = offscreen.getContext("2d");
            ctx.drawImage(__classPrivateFieldGet(this, _StampEditor_bitmap, "f"), 0, 0, __classPrivateFieldGet(this, _StampEditor_bitmap, "f").width, __classPrivateFieldGet(this, _StampEditor_bitmap, "f").height, 0, 0, width, height);
            return offscreen.transferToImageBitmap();
        }
        return structuredClone(__classPrivateFieldGet(this, _StampEditor_bitmap, "f"));
    }, _StampEditor_hasElementChanged = function _StampEditor_hasElementChanged(serialized) {
        var _v;
        var _w = this._initialData, pageIndex = _w.pageIndex, altText = _w.accessibilityData.altText;
        var isSamePageIndex = serialized.pageIndex === pageIndex;
        var isSameAltText = (((_v = serialized.accessibilityData) === null || _v === void 0 ? void 0 : _v.alt) || "") === altText;
        return {
            isSame: !this._hasBeenMoved && !this._hasBeenResized && isSamePageIndex && isSameAltText,
            isSameAltText: isSameAltText
        };
    };
    StampEditor._type = "stamp";
    StampEditor._editorType = AnnotationEditorType.STAMP;
    return StampEditor;
}(AnnotationEditor));
; // ./src/display/editor/annotation_editor_layer.js
var AnnotationEditorLayer = /** @class */ (function () {
    function AnnotationEditorLayer(_w) {
        var e_201, _z;
        var uiManager = _w.uiManager, pageIndex = _w.pageIndex, div = _w.div, structTreeLayer = _w.structTreeLayer, accessibilityManager = _w.accessibilityManager, annotationLayer = _w.annotationLayer, drawLayer = _w.drawLayer, textLayer = _w.textLayer, viewport = _w.viewport, l10n = _w.l10n;
        _AnnotationEditorLayer_instances.add(this);
        _AnnotationEditorLayer_accessibilityManager.set(this, void 0);
        _AnnotationEditorLayer_allowClick.set(this, false);
        _AnnotationEditorLayer_annotationLayer.set(this, null);
        _AnnotationEditorLayer_clickAC.set(this, null);
        _AnnotationEditorLayer_editorFocusTimeoutId.set(this, null);
        _AnnotationEditorLayer_editors.set(this, new Map());
        _AnnotationEditorLayer_hadPointerDown.set(this, false);
        _AnnotationEditorLayer_isDisabling.set(this, false);
        _AnnotationEditorLayer_isEnabling.set(this, false);
        _AnnotationEditorLayer_drawingAC.set(this, null);
        _AnnotationEditorLayer_focusedElement.set(this, null);
        _AnnotationEditorLayer_textLayer.set(this, null);
        _AnnotationEditorLayer_textSelectionAC.set(this, null);
        _AnnotationEditorLayer_uiManager.set(this, void 0);
        var editorTypes = __spreadArray([], __read(__classPrivateFieldGet(_v, _v, "f", _AnnotationEditorLayer_editorTypes).values()), false);
        if (!_v._initialized) {
            _v._initialized = true;
            try {
                for (var editorTypes_1 = __values(editorTypes), editorTypes_1_1 = editorTypes_1.next(); !editorTypes_1_1.done; editorTypes_1_1 = editorTypes_1.next()) {
                    var editorType = editorTypes_1_1.value;
                    editorType.initialize(l10n, uiManager);
                }
            }
            catch (e_201_1) { e_201 = { error: e_201_1 }; }
            finally {
                try {
                    if (editorTypes_1_1 && !editorTypes_1_1.done && (_z = editorTypes_1.return)) _z.call(editorTypes_1);
                }
                finally { if (e_201) throw e_201.error; }
            }
        }
        uiManager.registerEditorTypes(editorTypes);
        __classPrivateFieldSet(this, _AnnotationEditorLayer_uiManager, uiManager, "f");
        this.pageIndex = pageIndex;
        this.div = div;
        __classPrivateFieldSet(this, _AnnotationEditorLayer_accessibilityManager, accessibilityManager, "f");
        __classPrivateFieldSet(this, _AnnotationEditorLayer_annotationLayer, annotationLayer, "f");
        this.viewport = viewport;
        __classPrivateFieldSet(this, _AnnotationEditorLayer_textLayer, textLayer, "f");
        this.drawLayer = drawLayer;
        this._structTree = structTreeLayer;
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addLayer(this);
    }
    Object.defineProperty(AnnotationEditorLayer.prototype, "isEmpty", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").size === 0;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorLayer.prototype, "isInvisible", {
        get: function () {
            return this.isEmpty && __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode() === AnnotationEditorType.NONE;
        },
        enumerable: false,
        configurable: true
    });
    AnnotationEditorLayer.prototype.updateToolbar = function (mode) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").updateToolbar(mode);
    };
    AnnotationEditorLayer.prototype.updateMode = function (mode) {
        var e_202, _w;
        if (mode === void 0) { mode = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode(); }
        __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_cleanup).call(this);
        switch (mode) {
            case AnnotationEditorType.NONE:
                this.disableTextSelection();
                this.togglePointerEvents(false);
                this.toggleAnnotationLayerPointerEvents(true);
                this.disableClick();
                return;
            case AnnotationEditorType.INK:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
                break;
            case AnnotationEditorType.HIGHLIGHT:
                this.enableTextSelection();
                this.togglePointerEvents(false);
                this.disableClick();
                break;
            default:
                this.disableTextSelection();
                this.togglePointerEvents(true);
                this.enableClick();
        }
        this.toggleAnnotationLayerPointerEvents(false);
        var classList = this.div.classList;
        try {
            for (var _z = __values(__classPrivateFieldGet(_v, _v, "f", _AnnotationEditorLayer_editorTypes).values()), _0 = _z.next(); !_0.done; _0 = _z.next()) {
                var editorType = _0.value;
                classList.toggle("".concat(editorType._type, "Editing"), mode === editorType._editorType);
            }
        }
        catch (e_202_1) { e_202 = { error: e_202_1 }; }
        finally {
            try {
                if (_0 && !_0.done && (_w = _z.return)) _w.call(_z);
            }
            finally { if (e_202) throw e_202.error; }
        }
        this.div.hidden = false;
    };
    AnnotationEditorLayer.prototype.hasTextLayer = function (textLayer) {
        var _w;
        return textLayer === ((_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f")) === null || _w === void 0 ? void 0 : _w.div);
    };
    AnnotationEditorLayer.prototype.setEditingState = function (isEditing) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setEditingState(isEditing);
    };
    AnnotationEditorLayer.prototype.addCommands = function (params) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addCommands(params);
    };
    AnnotationEditorLayer.prototype.cleanUndoStack = function (type) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").cleanUndoStack(type);
    };
    AnnotationEditorLayer.prototype.toggleDrawing = function (enabled) {
        if (enabled === void 0) { enabled = false; }
        this.div.classList.toggle("drawing", !enabled);
    };
    AnnotationEditorLayer.prototype.togglePointerEvents = function (enabled) {
        if (enabled === void 0) { enabled = false; }
        this.div.classList.toggle("disabled", !enabled);
    };
    AnnotationEditorLayer.prototype.toggleAnnotationLayerPointerEvents = function (enabled) {
        var _w;
        if (enabled === void 0) { enabled = false; }
        (_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) === null || _w === void 0 ? void 0 : _w.div.classList.toggle("disabled", !enabled);
    };
    AnnotationEditorLayer.prototype.enable = function () {
        return __awaiter(this, void 0, void 0, function () {
            var annotationElementIds, _w, _z, editor, editables, editables_1, editables_1_1, editable, editor, e_203_1;
            var e_204, _0, e_203, _1;
            return __generator(this, function (_2) {
                switch (_2.label) {
                    case 0:
                        __classPrivateFieldSet(this, _AnnotationEditorLayer_isEnabling, true, "f");
                        this.div.tabIndex = 0;
                        this.togglePointerEvents(true);
                        annotationElementIds = new Set();
                        try {
                            for (_w = __values(__classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()), _z = _w.next(); !_z.done; _z = _w.next()) {
                                editor = _z.value;
                                editor.enableEditing();
                                editor.show(true);
                                if (editor.annotationElementId) {
                                    __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeChangedExistingAnnotation(editor);
                                    annotationElementIds.add(editor.annotationElementId);
                                }
                            }
                        }
                        catch (e_204_1) { e_204 = { error: e_204_1 }; }
                        finally {
                            try {
                                if (_z && !_z.done && (_0 = _w.return)) _0.call(_w);
                            }
                            finally { if (e_204) throw e_204.error; }
                        }
                        if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) {
                            __classPrivateFieldSet(this, _AnnotationEditorLayer_isEnabling, false, "f");
                            return [2 /*return*/];
                        }
                        editables = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f").getEditableAnnotations();
                        _2.label = 1;
                    case 1:
                        _2.trys.push([1, 6, 7, 8]);
                        editables_1 = __values(editables), editables_1_1 = editables_1.next();
                        _2.label = 2;
                    case 2:
                        if (!!editables_1_1.done) return [3 /*break*/, 5];
                        editable = editables_1_1.value;
                        editable.hide();
                        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").isDeletedAnnotationElement(editable.data.id)) {
                            return [3 /*break*/, 4];
                        }
                        if (annotationElementIds.has(editable.data.id)) {
                            return [3 /*break*/, 4];
                        }
                        return [4 /*yield*/, this.deserialize(editable)];
                    case 3:
                        editor = _2.sent();
                        if (!editor) {
                            return [3 /*break*/, 4];
                        }
                        this.addOrRebuild(editor);
                        editor.enableEditing();
                        _2.label = 4;
                    case 4:
                        editables_1_1 = editables_1.next();
                        return [3 /*break*/, 2];
                    case 5: return [3 /*break*/, 8];
                    case 6:
                        e_203_1 = _2.sent();
                        e_203 = { error: e_203_1 };
                        return [3 /*break*/, 8];
                    case 7:
                        try {
                            if (editables_1_1 && !editables_1_1.done && (_1 = editables_1.return)) _1.call(editables_1);
                        }
                        finally { if (e_203) throw e_203.error; }
                        return [7 /*endfinally*/];
                    case 8:
                        __classPrivateFieldSet(this, _AnnotationEditorLayer_isEnabling, false, "f");
                        return [2 /*return*/];
                }
            });
        });
    };
    AnnotationEditorLayer.prototype.disable = function () {
        var e_205, _w, e_206, _z, e_207, _0;
        var _1;
        __classPrivateFieldSet(this, _AnnotationEditorLayer_isDisabling, true, "f");
        this.div.tabIndex = -1;
        this.togglePointerEvents(false);
        var changedAnnotations = new Map();
        var resetAnnotations = new Map();
        try {
            for (var _2 = __values(__classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()), _3 = _2.next(); !_3.done; _3 = _2.next()) {
                var editor = _3.value;
                editor.disableEditing();
                if (!editor.annotationElementId) {
                    continue;
                }
                if (editor.serialize() !== null) {
                    changedAnnotations.set(editor.annotationElementId, editor);
                    continue;
                }
                else {
                    resetAnnotations.set(editor.annotationElementId, editor);
                }
                (_1 = this.getEditableAnnotation(editor.annotationElementId)) === null || _1 === void 0 ? void 0 : _1.show();
                editor.remove();
            }
        }
        catch (e_205_1) { e_205 = { error: e_205_1 }; }
        finally {
            try {
                if (_3 && !_3.done && (_w = _2.return)) _w.call(_2);
            }
            finally { if (e_205) throw e_205.error; }
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) {
            var editables = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f").getEditableAnnotations();
            try {
                for (var editables_2 = __values(editables), editables_2_1 = editables_2.next(); !editables_2_1.done; editables_2_1 = editables_2.next()) {
                    var editable = editables_2_1.value;
                    var id = editable.data.id;
                    if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").isDeletedAnnotationElement(id)) {
                        continue;
                    }
                    var editor = resetAnnotations.get(id);
                    if (editor) {
                        editor.resetAnnotationElement(editable);
                        editor.show(false);
                        editable.show();
                        continue;
                    }
                    editor = changedAnnotations.get(id);
                    if (editor) {
                        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addChangedExistingAnnotation(editor);
                        if (editor.renderAnnotationElement(editable)) {
                            editor.show(false);
                        }
                    }
                    editable.show();
                }
            }
            catch (e_206_1) { e_206 = { error: e_206_1 }; }
            finally {
                try {
                    if (editables_2_1 && !editables_2_1.done && (_z = editables_2.return)) _z.call(editables_2);
                }
                finally { if (e_206) throw e_206.error; }
            }
        }
        __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_cleanup).call(this);
        if (this.isEmpty) {
            this.div.hidden = true;
        }
        var classList = this.div.classList;
        try {
            for (var _4 = __values(__classPrivateFieldGet(_v, _v, "f", _AnnotationEditorLayer_editorTypes).values()), _5 = _4.next(); !_5.done; _5 = _4.next()) {
                var editorType = _5.value;
                classList.remove("".concat(editorType._type, "Editing"));
            }
        }
        catch (e_207_1) { e_207 = { error: e_207_1 }; }
        finally {
            try {
                if (_5 && !_5.done && (_0 = _4.return)) _0.call(_4);
            }
            finally { if (e_207) throw e_207.error; }
        }
        this.disableTextSelection();
        this.toggleAnnotationLayerPointerEvents(true);
        __classPrivateFieldSet(this, _AnnotationEditorLayer_isDisabling, false, "f");
    };
    AnnotationEditorLayer.prototype.getEditableAnnotation = function (id) {
        var _w;
        return ((_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_annotationLayer, "f")) === null || _w === void 0 ? void 0 : _w.getEditableAnnotation(id)) || null;
    };
    AnnotationEditorLayer.prototype.setActiveEditor = function (editor) {
        var currentActive = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getActive();
        if (currentActive === editor) {
            return;
        }
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setActiveEditor(editor);
    };
    AnnotationEditorLayer.prototype.enableTextSelection = function () {
        var _w;
        this.div.tabIndex = -1;
        if (((_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f")) === null || _w === void 0 ? void 0 : _w.div) && !__classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f")) {
            __classPrivateFieldSet(this, _AnnotationEditorLayer_textSelectionAC, new AbortController(), "f");
            var signal = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f"));
            __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.addEventListener("pointerdown", __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_textLayerPointerDown).bind(this), {
                signal: signal
            });
            __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.classList.add("highlighting");
        }
    };
    AnnotationEditorLayer.prototype.disableTextSelection = function () {
        var _w;
        this.div.tabIndex = 0;
        if (((_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f")) === null || _w === void 0 ? void 0 : _w.div) && __classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f")) {
            __classPrivateFieldGet(this, _AnnotationEditorLayer_textSelectionAC, "f").abort();
            __classPrivateFieldSet(this, _AnnotationEditorLayer_textSelectionAC, null, "f");
            __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.classList.remove("highlighting");
        }
    };
    AnnotationEditorLayer.prototype.enableClick = function () {
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_clickAC, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorLayer_clickAC, new AbortController(), "f");
        var signal = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorLayer_clickAC, "f"));
        this.div.addEventListener("pointerdown", this.pointerdown.bind(this), {
            signal: signal
        });
        var pointerup = this.pointerup.bind(this);
        this.div.addEventListener("pointerup", pointerup, {
            signal: signal
        });
        this.div.addEventListener("pointercancel", pointerup, {
            signal: signal
        });
    };
    AnnotationEditorLayer.prototype.disableClick = function () {
        var _w;
        (_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_clickAC, "f")) === null || _w === void 0 ? void 0 : _w.abort();
        __classPrivateFieldSet(this, _AnnotationEditorLayer_clickAC, null, "f");
    };
    AnnotationEditorLayer.prototype.attach = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").set(editor.id, editor);
        var annotationElementId = editor.annotationElementId;
        if (annotationElementId && __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").isDeletedAnnotationElement(annotationElementId)) {
            __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeDeletedAnnotationElement(editor);
        }
    };
    AnnotationEditorLayer.prototype.detach = function (editor) {
        var _w;
        __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").delete(editor.id);
        (_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_accessibilityManager, "f")) === null || _w === void 0 ? void 0 : _w.removePointerInTextLayer(editor.contentDiv);
        if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_isDisabling, "f") && editor.annotationElementId) {
            __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addDeletedAnnotationElement(editor);
        }
    };
    AnnotationEditorLayer.prototype.remove = function (editor) {
        this.detach(editor);
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeEditor(editor);
        editor.div.remove();
        editor.isAttachedToDOM = false;
    };
    AnnotationEditorLayer.prototype.changeParent = function (editor) {
        var _w;
        if (editor.parent === this) {
            return;
        }
        if (editor.parent && editor.annotationElementId) {
            __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addDeletedAnnotationElement(editor.annotationElementId);
            AnnotationEditor.deleteAnnotationElement(editor);
            editor.annotationElementId = null;
        }
        this.attach(editor);
        (_w = editor.parent) === null || _w === void 0 ? void 0 : _w.detach(editor);
        editor.setParent(this);
        if (editor.div && editor.isAttachedToDOM) {
            editor.div.remove();
            this.div.append(editor.div);
        }
    };
    AnnotationEditorLayer.prototype.add = function (editor) {
        if (editor.parent === this && editor.isAttachedToDOM) {
            return;
        }
        this.changeParent(editor);
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addEditor(editor);
        this.attach(editor);
        if (!editor.isAttachedToDOM) {
            var div = editor.render();
            this.div.append(div);
            editor.isAttachedToDOM = true;
        }
        editor.fixAndSetPosition();
        editor.onceAdded(!__classPrivateFieldGet(this, _AnnotationEditorLayer_isEnabling, "f"));
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").addToAnnotationStorage(editor);
        editor._reportTelemetry(editor.telemetryInitialData);
    };
    AnnotationEditorLayer.prototype.moveEditorInDOM = function (editor) {
        var _this = this;
        var _w;
        if (!editor.isAttachedToDOM) {
            return;
        }
        var activeElement = document.activeElement;
        if (editor.div.contains(activeElement) && !__classPrivateFieldGet(this, _AnnotationEditorLayer_editorFocusTimeoutId, "f")) {
            editor._focusEventsAllowed = false;
            __classPrivateFieldSet(this, _AnnotationEditorLayer_editorFocusTimeoutId, setTimeout(function () {
                __classPrivateFieldSet(_this, _AnnotationEditorLayer_editorFocusTimeoutId, null, "f");
                if (!editor.div.contains(document.activeElement)) {
                    editor.div.addEventListener("focusin", function () {
                        editor._focusEventsAllowed = true;
                    }, {
                        once: true,
                        signal: __classPrivateFieldGet(_this, _AnnotationEditorLayer_uiManager, "f")._signal
                    });
                    activeElement.focus();
                }
                else {
                    editor._focusEventsAllowed = true;
                }
            }, 0), "f");
        }
        editor._structTreeParentId = (_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_accessibilityManager, "f")) === null || _w === void 0 ? void 0 : _w.moveElementInDOM(this.div, editor.div, editor.contentDiv, true);
    };
    AnnotationEditorLayer.prototype.addOrRebuild = function (editor) {
        if (editor.needsToBeRebuilt()) {
            editor.parent || (editor.parent = this);
            editor.rebuild();
            editor.show();
        }
        else {
            this.add(editor);
        }
    };
    AnnotationEditorLayer.prototype.addUndoableEditor = function (editor) {
        var cmd = function () { return editor._uiManager.rebuild(editor); };
        var undo = function () {
            editor.remove();
        };
        this.addCommands({
            cmd: cmd,
            undo: undo,
            mustExec: false
        });
    };
    AnnotationEditorLayer.prototype.getNextId = function () {
        return __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getId();
    };
    AnnotationEditorLayer.prototype.combinedSignal = function (ac) {
        return __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").combinedSignal(ac);
    };
    AnnotationEditorLayer.prototype.canCreateNewEmptyEditor = function () {
        var _w;
        return (_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get)) === null || _w === void 0 ? void 0 : _w.canCreateNewEmptyEditor();
    };
    AnnotationEditorLayer.prototype.pasteEditor = function (mode, params) {
        return __awaiter(this, void 0, void 0, function () {
            var _w, offsetX, offsetY, id, editor;
            return __generator(this, function (_z) {
                switch (_z.label) {
                    case 0:
                        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").updateToolbar(mode);
                        return [4 /*yield*/, __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").updateMode(mode)];
                    case 1:
                        _z.sent();
                        _w = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_getCenterPoint).call(this), offsetX = _w.offsetX, offsetY = _w.offsetY;
                        id = this.getNextId();
                        editor = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_createNewEditor).call(this, __assign({ parent: this, id: id, x: offsetX, y: offsetY, uiManager: __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f"), isCentered: true }, params));
                        if (editor) {
                            this.add(editor);
                        }
                        return [2 /*return*/];
                }
            });
        });
    };
    AnnotationEditorLayer.prototype.deserialize = function (data) {
        return __awaiter(this, void 0, void 0, function () {
            var _w, _z;
            return __generator(this, function (_0) {
                switch (_0.label) {
                    case 0: return [4 /*yield*/, ((_z = __classPrivateFieldGet(_v, _v, "f", _AnnotationEditorLayer_editorTypes).get((_w = data.annotationType) !== null && _w !== void 0 ? _w : data.annotationEditorType)) === null || _z === void 0 ? void 0 : _z.deserialize(data, this, __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f")))];
                    case 1: return [2 /*return*/, (_0.sent()) || null];
                }
            });
        });
    };
    AnnotationEditorLayer.prototype.createAndAddNewEditor = function (event, isCentered, data) {
        if (data === void 0) { data = {}; }
        var id = this.getNextId();
        var editor = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_createNewEditor).call(this, __assign({ parent: this, id: id, x: event.offsetX, y: event.offsetY, uiManager: __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f"), isCentered: isCentered }, data));
        if (editor) {
            this.add(editor);
        }
        return editor;
    };
    AnnotationEditorLayer.prototype.addNewEditor = function (data) {
        if (data === void 0) { data = {}; }
        this.createAndAddNewEditor(__classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_getCenterPoint).call(this), true, data);
    };
    AnnotationEditorLayer.prototype.setSelected = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setSelected(editor);
    };
    AnnotationEditorLayer.prototype.toggleSelected = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").toggleSelected(editor);
    };
    AnnotationEditorLayer.prototype.unselect = function (editor) {
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").unselect(editor);
    };
    AnnotationEditorLayer.prototype.pointerup = function (event) {
        var _w;
        var isMac = util_FeatureTest.platform.isMac;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            return;
        }
        if (event.target !== this.div) {
            return;
        }
        if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_hadPointerDown, "f")) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorLayer_hadPointerDown, false, "f");
        if (((_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get)) === null || _w === void 0 ? void 0 : _w.isDrawer) && __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get).supportMultipleDrawings) {
            return;
        }
        if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_allowClick, "f")) {
            __classPrivateFieldSet(this, _AnnotationEditorLayer_allowClick, true, "f");
            return;
        }
        var currentMode = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode();
        if (currentMode === AnnotationEditorType.STAMP || currentMode === AnnotationEditorType.SIGNATURE) {
            __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").unselectAll();
            return;
        }
        this.createAndAddNewEditor(event, false);
    };
    AnnotationEditorLayer.prototype.pointerdown = function (event) {
        var _w;
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode() === AnnotationEditorType.HIGHLIGHT) {
            this.enableTextSelection();
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_hadPointerDown, "f")) {
            __classPrivateFieldSet(this, _AnnotationEditorLayer_hadPointerDown, false, "f");
            return;
        }
        var isMac = util_FeatureTest.platform.isMac;
        if (event.button !== 0 || event.ctrlKey && isMac) {
            return;
        }
        if (event.target !== this.div) {
            return;
        }
        __classPrivateFieldSet(this, _AnnotationEditorLayer_hadPointerDown, true, "f");
        if ((_w = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get)) === null || _w === void 0 ? void 0 : _w.isDrawer) {
            this.startDrawingSession(event);
            return;
        }
        var editor = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getActive();
        __classPrivateFieldSet(this, _AnnotationEditorLayer_allowClick, !editor || editor.isEmpty(), "f");
    };
    AnnotationEditorLayer.prototype.startDrawingSession = function (event) {
        var _this = this;
        this.div.focus({
            preventScroll: true
        });
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_drawingAC, "f")) {
            __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get).startDrawing(this, __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f"), false, event);
            return;
        }
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setCurrentDrawingSession(this);
        __classPrivateFieldSet(this, _AnnotationEditorLayer_drawingAC, new AbortController(), "f");
        var signal = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").combinedSignal(__classPrivateFieldGet(this, _AnnotationEditorLayer_drawingAC, "f"));
        this.div.addEventListener("blur", function (_w) {
            var relatedTarget = _w.relatedTarget;
            if (relatedTarget && !_this.div.contains(relatedTarget)) {
                __classPrivateFieldSet(_this, _AnnotationEditorLayer_focusedElement, null, "f");
                _this.commitOrRemove();
            }
        }, {
            signal: signal
        });
        __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get).startDrawing(this, __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f"), false, event);
    };
    AnnotationEditorLayer.prototype.pause = function (on) {
        var _this = this;
        if (on) {
            var activeElement = document.activeElement;
            if (this.div.contains(activeElement)) {
                __classPrivateFieldSet(this, _AnnotationEditorLayer_focusedElement, activeElement, "f");
            }
            return;
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_focusedElement, "f")) {
            setTimeout(function () {
                var _w;
                (_w = __classPrivateFieldGet(_this, _AnnotationEditorLayer_focusedElement, "f")) === null || _w === void 0 ? void 0 : _w.focus();
                __classPrivateFieldSet(_this, _AnnotationEditorLayer_focusedElement, null, "f");
            }, 0);
        }
    };
    AnnotationEditorLayer.prototype.endDrawingSession = function (isAborted) {
        if (isAborted === void 0) { isAborted = false; }
        if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_drawingAC, "f")) {
            return null;
        }
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setCurrentDrawingSession(null);
        __classPrivateFieldGet(this, _AnnotationEditorLayer_drawingAC, "f").abort();
        __classPrivateFieldSet(this, _AnnotationEditorLayer_drawingAC, null, "f");
        __classPrivateFieldSet(this, _AnnotationEditorLayer_focusedElement, null, "f");
        return __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get).endDrawing(isAborted);
    };
    AnnotationEditorLayer.prototype.findNewParent = function (editor, x, y) {
        var layer = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").findParent(x, y);
        if (layer === null || layer === this) {
            return false;
        }
        layer.changeParent(editor);
        return true;
    };
    AnnotationEditorLayer.prototype.commitOrRemove = function () {
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_drawingAC, "f")) {
            this.endDrawingSession();
            return true;
        }
        return false;
    };
    AnnotationEditorLayer.prototype.onScaleChanging = function () {
        if (!__classPrivateFieldGet(this, _AnnotationEditorLayer_drawingAC, "f")) {
            return;
        }
        __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get).onScaleChangingWhenDrawing(this);
    };
    AnnotationEditorLayer.prototype.destroy = function () {
        var e_208, _w;
        var _z, _0;
        this.commitOrRemove();
        if (((_z = __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getActive()) === null || _z === void 0 ? void 0 : _z.parent) === this) {
            __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").commitOrRemove();
            __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").setActiveEditor(null);
        }
        if (__classPrivateFieldGet(this, _AnnotationEditorLayer_editorFocusTimeoutId, "f")) {
            clearTimeout(__classPrivateFieldGet(this, _AnnotationEditorLayer_editorFocusTimeoutId, "f"));
            __classPrivateFieldSet(this, _AnnotationEditorLayer_editorFocusTimeoutId, null, "f");
        }
        try {
            for (var _1 = __values(__classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()), _2 = _1.next(); !_2.done; _2 = _1.next()) {
                var editor = _2.value;
                (_0 = __classPrivateFieldGet(this, _AnnotationEditorLayer_accessibilityManager, "f")) === null || _0 === void 0 ? void 0 : _0.removePointerInTextLayer(editor.contentDiv);
                editor.setParent(null);
                editor.isAttachedToDOM = false;
                editor.div.remove();
            }
        }
        catch (e_208_1) { e_208 = { error: e_208_1 }; }
        finally {
            try {
                if (_2 && !_2.done && (_w = _1.return)) _w.call(_1);
            }
            finally { if (e_208) throw e_208.error; }
        }
        this.div = null;
        __classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").clear();
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").removeLayer(this);
    };
    AnnotationEditorLayer.prototype.render = function (_w) {
        var e_209, _z;
        var viewport = _w.viewport;
        this.viewport = viewport;
        setLayerDimensions(this.div, viewport);
        try {
            for (var _0 = __values(__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getEditors(this.pageIndex)), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                var editor = _1.value;
                this.add(editor);
                editor.rebuild();
            }
        }
        catch (e_209_1) { e_209 = { error: e_209_1 }; }
        finally {
            try {
                if (_1 && !_1.done && (_z = _0.return)) _z.call(_0);
            }
            finally { if (e_209) throw e_209.error; }
        }
        this.updateMode();
    };
    AnnotationEditorLayer.prototype.update = function (_w) {
        var e_210, _z;
        var viewport = _w.viewport;
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").commitOrRemove();
        __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "m", _AnnotationEditorLayer_cleanup).call(this);
        var oldRotation = this.viewport.rotation;
        var rotation = viewport.rotation;
        this.viewport = viewport;
        setLayerDimensions(this.div, {
            rotation: rotation
        });
        if (oldRotation !== rotation) {
            try {
                for (var _0 = __values(__classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                    var editor = _1.value;
                    editor.rotate(rotation);
                }
            }
            catch (e_210_1) { e_210 = { error: e_210_1 }; }
            finally {
                try {
                    if (_1 && !_1.done && (_z = _0.return)) _z.call(_0);
                }
                finally { if (e_210) throw e_210.error; }
            }
        }
    };
    Object.defineProperty(AnnotationEditorLayer.prototype, "pageDimensions", {
        get: function () {
            var _w = this.viewport.rawDims, pageWidth = _w.pageWidth, pageHeight = _w.pageHeight;
            return [pageWidth, pageHeight];
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(AnnotationEditorLayer.prototype, "scale", {
        get: function () {
            return __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").viewParameters.realScale;
        },
        enumerable: false,
        configurable: true
    });
    var _AnnotationEditorLayer_instances, _v, _AnnotationEditorLayer_accessibilityManager, _AnnotationEditorLayer_allowClick, _AnnotationEditorLayer_annotationLayer, _AnnotationEditorLayer_clickAC, _AnnotationEditorLayer_editorFocusTimeoutId, _AnnotationEditorLayer_editors, _AnnotationEditorLayer_hadPointerDown, _AnnotationEditorLayer_isDisabling, _AnnotationEditorLayer_isEnabling, _AnnotationEditorLayer_drawingAC, _AnnotationEditorLayer_focusedElement, _AnnotationEditorLayer_textLayer, _AnnotationEditorLayer_textSelectionAC, _AnnotationEditorLayer_uiManager, _AnnotationEditorLayer_editorTypes, _AnnotationEditorLayer_textLayerPointerDown, _AnnotationEditorLayer_currentEditorType_get, _AnnotationEditorLayer_createNewEditor, _AnnotationEditorLayer_getCenterPoint, _AnnotationEditorLayer_cleanup;
    _v = AnnotationEditorLayer, _AnnotationEditorLayer_accessibilityManager = new WeakMap(), _AnnotationEditorLayer_allowClick = new WeakMap(), _AnnotationEditorLayer_annotationLayer = new WeakMap(), _AnnotationEditorLayer_clickAC = new WeakMap(), _AnnotationEditorLayer_editorFocusTimeoutId = new WeakMap(), _AnnotationEditorLayer_editors = new WeakMap(), _AnnotationEditorLayer_hadPointerDown = new WeakMap(), _AnnotationEditorLayer_isDisabling = new WeakMap(), _AnnotationEditorLayer_isEnabling = new WeakMap(), _AnnotationEditorLayer_drawingAC = new WeakMap(), _AnnotationEditorLayer_focusedElement = new WeakMap(), _AnnotationEditorLayer_textLayer = new WeakMap(), _AnnotationEditorLayer_textSelectionAC = new WeakMap(), _AnnotationEditorLayer_uiManager = new WeakMap(), _AnnotationEditorLayer_instances = new WeakSet(), _AnnotationEditorLayer_textLayerPointerDown = function _AnnotationEditorLayer_textLayerPointerDown(event) {
        var _this = this;
        __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").unselectAll();
        var target = event.target;
        if (target === __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div || (target.getAttribute("role") === "img" || target.classList.contains("endOfContent")) && __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.contains(target)) {
            var isMac = util_FeatureTest.platform.isMac;
            if (event.button !== 0 || event.ctrlKey && isMac) {
                return;
            }
            __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").showAllEditors("highlight", true, true);
            __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.classList.add("free");
            this.toggleDrawing();
            HighlightEditor.startHighlighting(this, __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").direction === "ltr", {
                target: __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div,
                x: event.x,
                y: event.y
            });
            __classPrivateFieldGet(this, _AnnotationEditorLayer_textLayer, "f").div.addEventListener("pointerup", function () {
                __classPrivateFieldGet(_this, _AnnotationEditorLayer_textLayer, "f").div.classList.remove("free");
                _this.toggleDrawing(true);
            }, {
                once: true,
                signal: __classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f")._signal
            });
            event.preventDefault();
        }
    }, _AnnotationEditorLayer_currentEditorType_get = function _AnnotationEditorLayer_currentEditorType_get() {
        return __classPrivateFieldGet(_v, _v, "f", _AnnotationEditorLayer_editorTypes).get(__classPrivateFieldGet(this, _AnnotationEditorLayer_uiManager, "f").getMode());
    }, _AnnotationEditorLayer_createNewEditor = function _AnnotationEditorLayer_createNewEditor(params) {
        var editorType = __classPrivateFieldGet(this, _AnnotationEditorLayer_instances, "a", _AnnotationEditorLayer_currentEditorType_get);
        return editorType ? new editorType.prototype.constructor(params) : null;
    }, _AnnotationEditorLayer_getCenterPoint = function _AnnotationEditorLayer_getCenterPoint() {
        var _w = this.div.getBoundingClientRect(), x = _w.x, y = _w.y, width = _w.width, height = _w.height;
        var tlX = Math.max(0, x);
        var tlY = Math.max(0, y);
        var brX = Math.min(window.innerWidth, x + width);
        var brY = Math.min(window.innerHeight, y + height);
        var centerX = (tlX + brX) / 2 - x;
        var centerY = (tlY + brY) / 2 - y;
        var _z = __read(this.viewport.rotation % 180 === 0 ? [centerX, centerY] : [centerY, centerX], 2), offsetX = _z[0], offsetY = _z[1];
        return {
            offsetX: offsetX,
            offsetY: offsetY
        };
    }, _AnnotationEditorLayer_cleanup = function _AnnotationEditorLayer_cleanup() {
        var e_211, _w;
        try {
            for (var _z = __values(__classPrivateFieldGet(this, _AnnotationEditorLayer_editors, "f").values()), _0 = _z.next(); !_0.done; _0 = _z.next()) {
                var editor = _0.value;
                if (editor.isEmpty()) {
                    editor.remove();
                }
            }
        }
        catch (e_211_1) { e_211 = { error: e_211_1 }; }
        finally {
            try {
                if (_0 && !_0.done && (_w = _z.return)) _w.call(_z);
            }
            finally { if (e_211) throw e_211.error; }
        }
    };
    AnnotationEditorLayer._initialized = false;
    _AnnotationEditorLayer_editorTypes = { value: new Map([FreeTextEditor, InkEditor, StampEditor, HighlightEditor, SignatureEditor].map(function (type) { return [type._editorType, type]; })) };
    return AnnotationEditorLayer;
}());
; // ./src/display/draw_layer.js
var DrawLayer = /** @class */ (function () {
    function DrawLayer(_z) {
        var pageIndex = _z.pageIndex;
        _DrawLayer_instances.add(this);
        _DrawLayer_parent.set(this, null);
        _DrawLayer_mapping.set(this, new Map());
        _DrawLayer_toUpdate.set(this, new Map());
        this.pageIndex = pageIndex;
    }
    DrawLayer.prototype.setParent = function (parent) {
        var e_212, _z;
        if (!__classPrivateFieldGet(this, _DrawLayer_parent, "f")) {
            __classPrivateFieldSet(this, _DrawLayer_parent, parent, "f");
            return;
        }
        if (__classPrivateFieldGet(this, _DrawLayer_parent, "f") !== parent) {
            if (__classPrivateFieldGet(this, _DrawLayer_mapping, "f").size > 0) {
                try {
                    for (var _0 = __values(__classPrivateFieldGet(this, _DrawLayer_mapping, "f").values()), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                        var root = _1.value;
                        root.remove();
                        parent.append(root);
                    }
                }
                catch (e_212_1) { e_212 = { error: e_212_1 }; }
                finally {
                    try {
                        if (_1 && !_1.done && (_z = _0.return)) _z.call(_0);
                    }
                    finally { if (e_212) throw e_212.error; }
                }
            }
            __classPrivateFieldSet(this, _DrawLayer_parent, parent, "f");
        }
    };
    Object.defineProperty(DrawLayer, "_svgFactory", {
        get: function () {
            return shadow(this, "_svgFactory", new DOMSVGFactory());
        },
        enumerable: false,
        configurable: true
    });
    DrawLayer.prototype.draw = function (properties, isPathUpdatable, hasClip) {
        var _z, _0, _1;
        if (isPathUpdatable === void 0) { isPathUpdatable = false; }
        if (hasClip === void 0) { hasClip = false; }
        var id = (__classPrivateFieldSet(_z = _w, _w, (_1 = __classPrivateFieldGet(_z, _w, "f", _DrawLayer_id), _0 = _1++, _1), "f", _DrawLayer_id), _0);
        var root = __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_createSVG).call(this);
        var defs = _w._svgFactory.createElement("defs");
        root.append(defs);
        var path = _w._svgFactory.createElement("path");
        defs.append(path);
        var pathId = "path_p".concat(this.pageIndex, "_").concat(id);
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        if (isPathUpdatable) {
            __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").set(id, path);
        }
        var clipPathId = hasClip ? __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_createClipPath).call(this, defs, pathId) : null;
        var use = _w._svgFactory.createElement("use");
        root.append(use);
        use.setAttribute("href", "#".concat(pathId));
        this.updateProperties(root, properties);
        __classPrivateFieldGet(this, _DrawLayer_mapping, "f").set(id, root);
        return {
            id: id,
            clipPathId: "url(#".concat(clipPathId, ")")
        };
    };
    DrawLayer.prototype.drawOutline = function (properties, mustRemoveSelfIntersections) {
        var _z, _0, _1;
        var id = (__classPrivateFieldSet(_z = _w, _w, (_1 = __classPrivateFieldGet(_z, _w, "f", _DrawLayer_id), _0 = _1++, _1), "f", _DrawLayer_id), _0);
        var root = __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_createSVG).call(this);
        var defs = _w._svgFactory.createElement("defs");
        root.append(defs);
        var path = _w._svgFactory.createElement("path");
        defs.append(path);
        var pathId = "path_p".concat(this.pageIndex, "_").concat(id);
        path.setAttribute("id", pathId);
        path.setAttribute("vector-effect", "non-scaling-stroke");
        var maskId;
        if (mustRemoveSelfIntersections) {
            var mask = _w._svgFactory.createElement("mask");
            defs.append(mask);
            maskId = "mask_p".concat(this.pageIndex, "_").concat(id);
            mask.setAttribute("id", maskId);
            mask.setAttribute("maskUnits", "objectBoundingBox");
            var rect = _w._svgFactory.createElement("rect");
            mask.append(rect);
            rect.setAttribute("width", "1");
            rect.setAttribute("height", "1");
            rect.setAttribute("fill", "white");
            var use = _w._svgFactory.createElement("use");
            mask.append(use);
            use.setAttribute("href", "#".concat(pathId));
            use.setAttribute("stroke", "none");
            use.setAttribute("fill", "black");
            use.setAttribute("fill-rule", "nonzero");
            use.classList.add("mask");
        }
        var use1 = _w._svgFactory.createElement("use");
        root.append(use1);
        use1.setAttribute("href", "#".concat(pathId));
        if (maskId) {
            use1.setAttribute("mask", "url(#".concat(maskId, ")"));
        }
        var use2 = use1.cloneNode();
        root.append(use2);
        use1.classList.add("mainOutline");
        use2.classList.add("secondaryOutline");
        this.updateProperties(root, properties);
        __classPrivateFieldGet(this, _DrawLayer_mapping, "f").set(id, root);
        return id;
    };
    DrawLayer.prototype.finalizeDraw = function (id, properties) {
        __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").delete(id);
        this.updateProperties(id, properties);
    };
    DrawLayer.prototype.updateProperties = function (elementOrId, properties) {
        var e_213, _z;
        if (!properties) {
            return;
        }
        var root = properties.root, bbox = properties.bbox, rootClass = properties.rootClass, path = properties.path;
        var element = typeof elementOrId === "number" ? __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(elementOrId) : elementOrId;
        if (!element) {
            return;
        }
        if (root) {
            __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_updateProperties).call(this, element, root);
        }
        if (bbox) {
            __classPrivateFieldGet(_w, _w, "m", _DrawLayer_setBox).call(_w, element, bbox);
        }
        if (rootClass) {
            var classList = element.classList;
            try {
                for (var _0 = __values(Object.entries(rootClass)), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                    var _2 = __read(_1.value, 2), className = _2[0], value = _2[1];
                    classList.toggle(className, value);
                }
            }
            catch (e_213_1) { e_213 = { error: e_213_1 }; }
            finally {
                try {
                    if (_1 && !_1.done && (_z = _0.return)) _z.call(_0);
                }
                finally { if (e_213) throw e_213.error; }
            }
        }
        if (path) {
            var defs = element.firstChild;
            var pathElement = defs.firstChild;
            __classPrivateFieldGet(this, _DrawLayer_instances, "m", _DrawLayer_updateProperties).call(this, pathElement, path);
        }
    };
    DrawLayer.prototype.updateParent = function (id, layer) {
        if (layer === this) {
            return;
        }
        var root = __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id);
        if (!root) {
            return;
        }
        __classPrivateFieldGet(layer, _DrawLayer_parent, "f").append(root);
        __classPrivateFieldGet(this, _DrawLayer_mapping, "f").delete(id);
        __classPrivateFieldGet(layer, _DrawLayer_mapping, "f").set(id, root);
    };
    DrawLayer.prototype.remove = function (id) {
        __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").delete(id);
        if (__classPrivateFieldGet(this, _DrawLayer_parent, "f") === null) {
            return;
        }
        __classPrivateFieldGet(this, _DrawLayer_mapping, "f").get(id).remove();
        __classPrivateFieldGet(this, _DrawLayer_mapping, "f").delete(id);
    };
    DrawLayer.prototype.destroy = function () {
        var e_214, _z;
        __classPrivateFieldSet(this, _DrawLayer_parent, null, "f");
        try {
            for (var _0 = __values(__classPrivateFieldGet(this, _DrawLayer_mapping, "f").values()), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                var root = _1.value;
                root.remove();
            }
        }
        catch (e_214_1) { e_214 = { error: e_214_1 }; }
        finally {
            try {
                if (_1 && !_1.done && (_z = _0.return)) _z.call(_0);
            }
            finally { if (e_214) throw e_214.error; }
        }
        __classPrivateFieldGet(this, _DrawLayer_mapping, "f").clear();
        __classPrivateFieldGet(this, _DrawLayer_toUpdate, "f").clear();
    };
    var _DrawLayer_instances, _w, _DrawLayer_parent, _DrawLayer_mapping, _DrawLayer_toUpdate, _DrawLayer_id, _DrawLayer_setBox, _DrawLayer_createSVG, _DrawLayer_createClipPath, _DrawLayer_updateProperties;
    _w = DrawLayer, _DrawLayer_parent = new WeakMap(), _DrawLayer_mapping = new WeakMap(), _DrawLayer_toUpdate = new WeakMap(), _DrawLayer_instances = new WeakSet(), _DrawLayer_setBox = function _DrawLayer_setBox(element, _z) {
        var _0 = __read(_z, 4), x = _0[0], y = _0[1], width = _0[2], height = _0[3];
        var style = element.style;
        style.top = "".concat(100 * y, "%");
        style.left = "".concat(100 * x, "%");
        style.width = "".concat(100 * width, "%");
        style.height = "".concat(100 * height, "%");
    }, _DrawLayer_createSVG = function _DrawLayer_createSVG() {
        var svg = _w._svgFactory.create(1, 1, true);
        __classPrivateFieldGet(this, _DrawLayer_parent, "f").append(svg);
        svg.setAttribute("aria-hidden", true);
        return svg;
    }, _DrawLayer_createClipPath = function _DrawLayer_createClipPath(defs, pathId) {
        var clipPath = _w._svgFactory.createElement("clipPath");
        defs.append(clipPath);
        var clipPathId = "clip_".concat(pathId);
        clipPath.setAttribute("id", clipPathId);
        clipPath.setAttribute("clipPathUnits", "objectBoundingBox");
        var clipPathUse = _w._svgFactory.createElement("use");
        clipPath.append(clipPathUse);
        clipPathUse.setAttribute("href", "#".concat(pathId));
        clipPathUse.classList.add("clip");
        return clipPathId;
    }, _DrawLayer_updateProperties = function _DrawLayer_updateProperties(element, properties) {
        var e_215, _z;
        try {
            for (var _0 = __values(Object.entries(properties)), _1 = _0.next(); !_1.done; _1 = _0.next()) {
                var _2 = __read(_1.value, 2), key = _2[0], value = _2[1];
                if (value === null) {
                    element.removeAttribute(key);
                }
                else {
                    element.setAttribute(key, value);
                }
            }
        }
        catch (e_215_1) { e_215 = { error: e_215_1 }; }
        finally {
            try {
                if (_1 && !_1.done && (_z = _0.return)) _z.call(_0);
            }
            finally { if (e_215) throw e_215.error; }
        }
    };
    _DrawLayer_id = { value: 0 };
    return DrawLayer;
}());
; // ./src/pdf.js
var pdfjsVersion = "5.2.133";
var pdfjsBuild = "4f7761353";
{
    globalThis.pdfjsTestingUtils = {
        HighlightOutliner: HighlightOutliner
    };
}
globalThis.pdfjsLib = {
    AbortException: AbortException,
    AnnotationEditorLayer: AnnotationEditorLayer,
    AnnotationEditorParamsType: AnnotationEditorParamsType,
    AnnotationEditorType: AnnotationEditorType,
    AnnotationEditorUIManager: AnnotationEditorUIManager,
    AnnotationLayer: AnnotationLayer,
    AnnotationMode: AnnotationMode,
    AnnotationType: AnnotationType,
    build: build,
    ColorPicker: ColorPicker,
    createValidAbsoluteUrl: createValidAbsoluteUrl,
    DOMSVGFactory: DOMSVGFactory,
    DrawLayer: DrawLayer,
    FeatureTest: util_FeatureTest,
    fetchData: fetchData,
    getDocument: getDocument,
    getFilenameFromUrl: getFilenameFromUrl,
    getPdfFilenameFromUrl: getPdfFilenameFromUrl,
    getUuid: getUuid,
    getXfaPageViewport: getXfaPageViewport,
    GlobalWorkerOptions: GlobalWorkerOptions,
    ImageKind: util_ImageKind,
    InvalidPDFException: InvalidPDFException,
    isDataScheme: isDataScheme,
    isPdfFile: isPdfFile,
    isValidExplicitDest: isValidExplicitDest,
    MathClamp: MathClamp,
    noContextMenu: noContextMenu,
    normalizeUnicode: normalizeUnicode,
    OPS: OPS,
    OutputScale: OutputScale,
    PasswordResponses: PasswordResponses,
    PDFDataRangeTransport: PDFDataRangeTransport,
    PDFDateString: PDFDateString,
    PDFWorker: PDFWorker,
    PermissionFlag: PermissionFlag,
    PixelsPerInch: PixelsPerInch,
    RenderingCancelledException: RenderingCancelledException,
    ResponseException: ResponseException,
    setLayerDimensions: setLayerDimensions,
    shadow: shadow,
    SignatureExtractor: SignatureExtractor,
    stopEvent: stopEvent,
    SupportedImageMimeTypes: SupportedImageMimeTypes,
    TextLayer: TextLayer,
    TouchManager: TouchManager,
    updateUrlHash: updateUrlHash,
    Util: Util,
    VerbosityLevel: VerbosityLevel,
    version: version,
    XfaLayer: XfaLayer
};
export { AbortException, AnnotationEditorLayer, AnnotationEditorParamsType, AnnotationEditorType, AnnotationEditorUIManager, AnnotationLayer, AnnotationMode, AnnotationType, ColorPicker, DOMSVGFactory, DrawLayer, util_FeatureTest as FeatureTest, GlobalWorkerOptions, util_ImageKind as ImageKind, InvalidPDFException, MathClamp, OPS, OutputScale, PDFDataRangeTransport, PDFDateString, PDFWorker, PasswordResponses, PermissionFlag, PixelsPerInch, RenderingCancelledException, ResponseException, SignatureExtractor, SupportedImageMimeTypes, TextLayer, TouchManager, Util, VerbosityLevel, XfaLayer, build, createValidAbsoluteUrl, fetchData, getDocument, getFilenameFromUrl, getPdfFilenameFromUrl, getUuid, getXfaPageViewport, isDataScheme, isPdfFile, isValidExplicitDest, noContextMenu, normalizeUnicode, setLayerDimensions, shadow, stopEvent, updateUrlHash, version };
//# sourceMappingURL=pdf.mjs.map
